webpackJsonp([0,3],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(0);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(760)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966)(module)))

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(186));
__export(__webpack_require__(200));
__export(__webpack_require__(73));
__export(__webpack_require__(72));
__export(__webpack_require__(98));
__export(__webpack_require__(100));
__export(__webpack_require__(74));
__export(__webpack_require__(193));
__export(__webpack_require__(202));
__export(__webpack_require__(198));
__export(__webpack_require__(87));
__export(__webpack_require__(514));
__export(__webpack_require__(53));
__export(__webpack_require__(524));
__export(__webpack_require__(523));
__export(__webpack_require__(103));
__export(__webpack_require__(205));
__export(__webpack_require__(530));
__export(__webpack_require__(529));
__export(__webpack_require__(69));
__export(__webpack_require__(101));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(11);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(198);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(13);

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(206);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// DO NOT EDIT THIS FILE, EDIT THE WEBPACK COMMON CONFIG INSTEAD, WHICH WILL MODIFY THIS FILE
var _VERSION = '0.0.0'; // This value will be overwritten by webpack
var _DEBUG_INFO_ENABLED = true; // This value will be overwritten by webpack
_VERSION = "0.0.0";
_DEBUG_INFO_ENABLED = false;
exports.VERSION = _VERSION;
exports.DEBUG_INFO_ENABLED = _DEBUG_INFO_ENABLED;
exports.SERVER_FILE_API_URL = 'http://192.168.4.90:8080/api/files-no-authenticate/';
exports.PAGE_TITLE_SUFFIX = ' | Télérecours Citoyens | Conseil d\'État';


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(12);

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(4);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var operators_1 = __webpack_require__(7);
var ng_jhipster_1 = __webpack_require__(30);
var ng2_file_upload_1 = __webpack_require__(129);
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var ng_bootstrap_1 = __webpack_require__(19);
var draft_requete_model_1 = __webpack_require__(91);
var piece_jointe_1 = __webpack_require__(38);
var requete_1 = __webpack_require__(17);
var shared_1 = __webpack_require__(4);
var draft_modal_component_1 = __webpack_require__(96);
var file_uploader_model_1 = __webpack_require__(187);
var application_constants_1 = __webpack_require__(191);
var error_constants_1 = __webpack_require__(60);
var http_code_constants_1 = __webpack_require__(71);
var tracking_enum_1 = __webpack_require__(31);
var tracking_model_1 = __webpack_require__(195);
var draft_requete_service_1 = __webpack_require__(201);
var parameters_service_1 = __webpack_require__(25);
var tracking_service_1 = __webpack_require__(32);
var depot_requete_state_model_1 = __webpack_require__(89);
var common_1 = __webpack_require__(15);
var DraftDepotRequeteService = /** @class */ (function () {
    function DraftDepotRequeteService(draftRequeteService, router, alertService, trackingService, parametersService, modalService, datePipe) {
        this.draftRequeteService = draftRequeteService;
        this.router = router;
        this.alertService = alertService;
        this.trackingService = trackingService;
        this.parametersService = parametersService;
        this.modalService = modalService;
        this.datePipe = datePipe;
        this._eventDraftDeleted = new core_1.EventEmitter();
        this.dataSource = new rxjs_1.Subject();
        this.data$ = this.dataSource.asObservable();
    }
    Object.defineProperty(DraftDepotRequeteService.prototype, "eventDraftDeleted", {
        get: function () {
            return this._eventDraftDeleted;
        },
        enumerable: true,
        configurable: true
    });
    DraftDepotRequeteService.prototype.sendData = function (data) {
        this.dataSource.next(data);
    };
    DraftDepotRequeteService.prototype.getAutoSaveTime = function () {
        var autoSaveTime = this.datePipe.transform(new Date(), 'H:mm');
        autoSaveTime = autoSaveTime.replace(':', 'h');
        return autoSaveTime;
    };
    // convert creation date from format 'yyyy-MM-DDTHH:mm:ss' to ['DD/MM/yyyy', 'HHhmm']
    DraftDepotRequeteService.prototype.convertCreationDateToDateAndHour = function (creationDate) {
        var dateAndHour = [];
        var date = creationDate.substring(0, creationDate.indexOf('T'));
        date = date.split('-').reverse().join('/');
        dateAndHour.push(date);
        var hour = creationDate.substring(creationDate.indexOf('T') + 1, creationDate.lastIndexOf(':'));
        hour = hour.split(':').join('h');
        dateAndHour.push(hour);
        return dateAndHour;
    };
    DraftDepotRequeteService.prototype.getDepotRequeteStateVersion = function () {
        if (this.depotRequeteState && this.depotRequeteState.version !== undefined) {
            return this.depotRequeteState.version;
        }
    };
    DraftDepotRequeteService.prototype.addRequestHeaderToUploader = function (options) {
        if (this.depotRequeteState && this.depotRequeteState.version !== undefined) {
            options.headers = [{ name: application_constants_1.HEADER_DRAFT_VERSION, value: "" + this.depotRequeteState.version }];
        }
        return options;
    };
    DraftDepotRequeteService.prototype.updateVersionWithResponseHeader = function (headers) {
        if (headers && headers.get(application_constants_1.HEADER_DRAFT_VERSION) && this.depotRequeteState) {
            /* this.depotRequeteState.version = parseInt(headers.get(HEADER_DRAFT_VERSION), 10) + 1; */
            this.depotRequeteState.version = parseInt(headers.get(application_constants_1.HEADER_DRAFT_VERSION), 10);
        }
        return this.depotRequeteState ? this.depotRequeteState.version : null;
    };
    DraftDepotRequeteService.prototype.updateVersionWithResponseHeaderFromUploader = function (headers) {
        if (headers && headers[application_constants_1.HEADER_DRAFT_VERSION] !== undefined && this.depotRequeteState) {
            /* this.depotRequeteState.version = parseInt(headers[HEADER_DRAFT_VERSION], 10) + 1; */
            this.depotRequeteState.version = parseInt(headers[application_constants_1.HEADER_DRAFT_VERSION], 10);
        }
    };
    DraftDepotRequeteService.prototype.cleanDepotRequeteState = function () {
        this.depotRequeteState = null;
    };
    DraftDepotRequeteService.prototype.acceptCgu = function () {
        var _this = this;
        if (!this.depotRequeteState) {
            return this.draftRequeteService
                .initMyDraftRequete()
                .pipe(operators_1.switchMap(function (draft) { return _this.draftRequeteToDepotRequeteState(draft); }));
        }
        return rxjs_1.of(this.depotRequeteState);
    };
    DraftDepotRequeteService.prototype.saveParties = function (requeteCategory, requerants) {
        if (requeteCategory === requete_1.RequeteCategory.REQUERANT_SEUL) {
            return this.draftRequeteService.addOneRequerant();
        }
        else if (requeteCategory === requete_1.RequeteCategory.COLLECTIVE) {
            return this.draftRequeteService.addRequerants(requerants);
        }
        else if (requeteCategory === requete_1.RequeteCategory.AVEC_MANDATAIRE) {
            return this.draftRequeteService.addMandants(requerants);
        }
    };
    DraftDepotRequeteService.prototype.saveJuridiction = function () {
        var juridiction = new draft_requete_model_1.Juridiction();
        /*  if (this.depotRequeteState.urgenceRequete !== undefined && this.depotRequeteState.urgenceRequete !== null) {
             juridiction.typeRequeteId = this.depotRequeteState.urgenceRequete.id;
         } */
        if (this.depotRequeteState.typeJuridiction !== undefined && this.depotRequeteState.typeJuridiction !== null) {
            juridiction.typeJuridictionId = this.depotRequeteState.typeJuridiction.id;
        }
        if (this.depotRequeteState.siteJuridiction !== undefined && this.depotRequeteState.siteJuridiction !== null) {
            juridiction.siteJuridictionId = this.depotRequeteState.siteJuridiction.id;
        }
        if (this.depotRequeteState.typeActeAttaque !== undefined && this.depotRequeteState.typeActeAttaque !== null) {
            juridiction.typeActeAttaque = this.depotRequeteState.typeActeAttaque;
        }
        return this.draftRequeteService.addJuridiction(juridiction);
    };
    DraftDepotRequeteService.prototype.saveRequeteByEmergencyType = function (urgenceRequete) {
        console.log('saveRequete | urgenceRequete : ', urgenceRequete);
        if (urgenceRequete && urgenceRequete.codeUrgence === 0) {
            return this.saveNormalProceedingRequest(urgenceRequete);
        }
        else {
            return this.saveInterimProceedingRequest(urgenceRequete);
        }
    };
    DraftDepotRequeteService.prototype.saveNormalProceedingRequest = function (urgenceRequete) {
        var requeteContentieuxSocial = new draft_requete_model_1.RequeteContentieuxSocial();
        if (urgenceRequete !== undefined && urgenceRequete !== null) {
            requeteContentieuxSocial.typeRequeteId = urgenceRequete.id;
        }
        if (this.depotRequeteState.concernContentieuxSocial !== undefined && this.depotRequeteState.concernContentieuxSocial !== null) {
            requeteContentieuxSocial.contentieuxSocial = this.depotRequeteState.concernContentieuxSocial;
        }
        if (this.depotRequeteState.requeteCS !== undefined && this.depotRequeteState.requeteCS !== null) {
            // if the config is ON
            if (this.depotRequeteState.formActivated) {
                if (requeteContentieuxSocial.contentieuxSocial) {
                    // Sociaux DALO
                    this.buildDALORequete(requeteContentieuxSocial);
                }
                else {
                    requeteContentieuxSocial.souhait = this.depotRequeteState.requeteCS.souhait;
                    switch (requeteContentieuxSocial.souhait) {
                        case 'Remplir le formulaire : litige lié à une décision de l\'administration':
                            this.buildLitigeLieDecisionAdminRequete(requeteContentieuxSocial);
                            break;
                        case 'Remplir le formulaire : litige lié à une somme d\'argent':
                            requeteContentieuxSocial.typeLitige = this.depotRequeteState.requeteCS.typeLitige;
                            switch (requeteContentieuxSocial.typeLitige) {
                                case 'Vous réclamez une somme d\'argent à l\'administration':
                                    this.buildReclamerUneSommeRequete(requeteContentieuxSocial);
                                    break;
                                case 'Vous contestez une somme d\'argent réclamée par l\'administration':
                                    this.buildContesterUneSommeRequete(requeteContentieuxSocial);
                                    break;
                                case 'Vous réclamez une indemnisation pour une faute commise par l\'administration ou '
                                    + 'une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)':
                                    this.buildIndemnisationRequete(requeteContentieuxSocial);
                                    break;
                                default:
                                    this.buildReclamerUneSommeRequete(requeteContentieuxSocial);
                            }
                            break;
                        case 'Déposer une requête que vous avez rédigée':
                            this.buildRequeteDejaRedigee(requeteContentieuxSocial);
                            break;
                        default:
                            this.buildLitigeLieDecisionAdminRequete(requeteContentieuxSocial);
                    }
                }
            }
            else {
                if (requeteContentieuxSocial.contentieuxSocial) {
                    // Sociaux DALO
                    this.buildDALORequete(requeteContentieuxSocial);
                }
            }
        }
        return this.draftRequeteService.addNormalProceedingRequest(requeteContentieuxSocial);
    };
    DraftDepotRequeteService.prototype.buildDALORequete = function (requeteContentieuxSocial) {
        requeteContentieuxSocial.hasDocument = this.depotRequeteState.requeteCS.hasDocument;
        requeteContentieuxSocial.raisonSansDocument = this.depotRequeteState.requeteCS.raisonSansDocument;
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.motifs = this.depotRequeteState.requeteCS.motifs;
        requeteContentieuxSocial.conclusionDALO = this.depotRequeteState.requeteCS.conclusionDALO;
        var jointPieces = [];
        var pieceRAPO = this.depotRequeteState.piecesComplementaires.find(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.RAPO;
        });
        if (pieceRAPO !== undefined && pieceRAPO !== null) {
            pieceRAPO.libelle = 'RAPO';
            jointPieces.push(pieceRAPO);
        }
        if (this.depotRequeteState.acteAttaquesAFusioner !== undefined &&
            this.depotRequeteState.acteAttaquesAFusioner !== null) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.acteAttaquesAFusioner));
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(function (piece) { return piece.toDTO(); });
    };
    DraftDepotRequeteService.prototype.buildLitigeLieDecisionAdminRequete = function (requeteContentieuxSocial) {
        requeteContentieuxSocial.hasDocument = this.depotRequeteState.requeteCS.hasDocument;
        requeteContentieuxSocial.raisonSansDocument = this.depotRequeteState.requeteCS.raisonSansDocument;
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.contexteInterventionDecision = this.depotRequeteState.requeteCS.contexteInterventionDecision;
        requeteContentieuxSocial.raisonContestations = this.depotRequeteState.requeteCS.raisonContestations;
        requeteContentieuxSocial.conclusionLitigeAdminCheckbox = this.depotRequeteState.requeteCS.conclusionLitigeAdminCheckbox;
        requeteContentieuxSocial.conclusionLitigeAdmin = this.depotRequeteState.requeteCS.conclusionLitigeAdmin;
        var jointPieces = [];
        if (this.depotRequeteState.acteAttaquesAFusioner !== undefined &&
            this.depotRequeteState.acteAttaquesAFusioner !== null) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.acteAttaquesAFusioner));
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_INTERPRETE;
        }).length > 0) {
            if (requeteContentieuxSocial.raisonContestations.some(function (rc) { return rc.typeRaisonContestationId === 6; })) {
                jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                    return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_INTERPRETE;
                })));
            }
            else {
                this.depotRequeteState.piecesComplementaires =
                    this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                        return pc.complementaryFileOriginType !== piece_jointe_1.PieceComplementaireOrigineType.MAL_INTERPRETE;
                    });
            }
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_APPRECIE;
        }).length > 0) {
            if (requeteContentieuxSocial.raisonContestations.some(function (rc) { return rc.typeRaisonContestationId === 7; })) {
                jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                    return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_APPRECIE;
                })));
            }
            else {
                this.depotRequeteState.piecesComplementaires =
                    this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                        return pc.complementaryFileOriginType !== piece_jointe_1.PieceComplementaireOrigineType.MAL_APPRECIE;
                    });
            }
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(function (piece) { return piece.toDTO(); });
    };
    DraftDepotRequeteService.prototype.buildReclamerUneSommeRequete = function (requeteContentieuxSocial) {
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.contexteInterventionDecision = this.depotRequeteState.requeteCS.contexteInterventionDecision;
        requeteContentieuxSocial.pourquoiSommeDue = this.depotRequeteState.requeteCS.pourquoiSommeDue;
        requeteContentieuxSocial.montantDuMontant = this.depotRequeteState.requeteCS.montantDuMontant;
        requeteContentieuxSocial.conclusionReclamerSommeCondamnerAdmin =
            this.depotRequeteState.requeteCS.conclusionReclamerSommeCondamnerAdmin;
        requeteContentieuxSocial.conclusionReclamerSommeMajoree = this.depotRequeteState.requeteCS.conclusionReclamerSommeMajoree;
        var jointPieces = [];
        if (this.depotRequeteState.reclamationPrealablesAFusioner.length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.reclamationPrealablesAFusioner));
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.SOMME_DUE;
        }).length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.SOMME_DUE;
            })));
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MONTANT_DU;
        }).length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MONTANT_DU;
            })));
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(function (piece) { return piece.toDTO(); });
    };
    DraftDepotRequeteService.prototype.buildContesterUneSommeRequete = function (requeteContentieuxSocial) {
        var jointPieces = [];
        if (this.depotRequeteState.reclamationPrealablesAFusioner.length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.reclamationPrealablesAFusioner));
        }
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.faitConduitAuLitige = this.depotRequeteState.requeteCS.faitConduitAuLitige;
        requeteContentieuxSocial.typeActe = this.depotRequeteState.requeteCS.typeActe;
        if (this.depotRequeteState.acteAttaquesAFusioner.length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.acteAttaquesAFusioner));
        }
        if (!requeteContentieuxSocial.typeActe ||
            requeteContentieuxSocial.typeActe === 'Un avis d\'imposition') {
            requeteContentieuxSocial.raisonAvisDimpositionIrreguliers = this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers;
            requeteContentieuxSocial.raisonPasPayerImpot = this.depotRequeteState.requeteCS.raisonPasPayerImpot;
            if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE;
            }).length > 0) {
                jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                    return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE;
                })));
            }
            requeteContentieuxSocial.conclusionAvisImpositionImpot = this.depotRequeteState.requeteCS.conclusionAvisImpositionImpot;
        }
        else {
            requeteContentieuxSocial.raisonInvalidationTitres = this.depotRequeteState.requeteCS.raisonInvalidationTitres;
            requeteContentieuxSocial.conclusionContesterSommeTitreEmisIrregulierDes =
                this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierDes;
            requeteContentieuxSocial.conclusionContesterSommeTitreEmisIrregulierMontant =
                this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierMontant;
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(function (piece) { return piece.toDTO(); });
    };
    DraftDepotRequeteService.prototype.buildIndemnisationRequete = function (requeteContentieuxSocial) {
        console.log('buildIndemnisationRequete');
        requeteContentieuxSocial.nomsAdministrations = this.depotRequeteState.requeteCS.nomsAdministrations;
        requeteContentieuxSocial.objetDemande = this.depotRequeteState.requeteCS.objetDemande;
        requeteContentieuxSocial.faitConduitSituationReparation = this.depotRequeteState.requeteCS.faitConduitSituationReparation;
        requeteContentieuxSocial.prejudiceEvaluableEnArgents = this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents;
        requeteContentieuxSocial.precisionPrejudice = this.depotRequeteState.requeteCS.precisionPrejudice;
        requeteContentieuxSocial.originePrejudice = this.depotRequeteState.requeteCS.originePrejudice;
        requeteContentieuxSocial.conclusionIndemnisationCondamnerAdmin =
            this.depotRequeteState.requeteCS.conclusionIndemnisationCondamnerAdmin;
        requeteContentieuxSocial.conclusionIndemnisationMontant =
            this.depotRequeteState.requeteCS.conclusionIndemnisationMontant;
        requeteContentieuxSocial.conclusionIndemnisationMajoree =
            this.depotRequeteState.requeteCS.conclusionIndemnisationMajoree;
        var jointPieces = [];
        if (this.depotRequeteState.reclamationPrealablesAFusioner.length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.reclamationPrealablesAFusioner));
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.PRECISION_PREJUDICE;
        }).length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.PRECISION_PREJUDICE;
            })));
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(function (piece) { return piece.toDTO(); });
    };
    DraftDepotRequeteService.prototype.buildRequeteDejaRedigee = function (requeteContentieuxSocial) {
        var jointPieces = [];
        if (this.depotRequeteState.acteAttaquesAFusioner !== undefined &&
            this.depotRequeteState.acteAttaquesAFusioner !== null) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.acteAttaquesAFusioner));
        }
        if (this.depotRequeteState.reclamationPrealablesAFusioner.length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.reclamationPrealablesAFusioner));
        }
        if (this.depotRequeteState.requete !== undefined && this.depotRequeteState.requete !== null) {
            jointPieces.push(this.depotRequeteState.requete);
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF;
        }).length > 0) {
            jointPieces.push.apply(jointPieces, __spread(this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF;
            })));
        }
        requeteContentieuxSocial.piecesAttachees = jointPieces.map(function (piece) { return piece.toDTO(); });
    };
    // Référé, à modifier quand le formulaire Référé prend sa forme it_13, it_14
    DraftDepotRequeteService.prototype.saveInterimProceedingRequest = function (urgenceRequete) {
        var typeRequeteId = 3; // valeur temporaire
        if (urgenceRequete !== undefined && urgenceRequete !== null) {
            typeRequeteId = urgenceRequete.id;
        }
        return this.draftRequeteService.addInterimProceedingRequest(typeRequeteId);
    };
    DraftDepotRequeteService.prototype.refreshRequete = function () {
        return this.draftRequeteService.getMyDraftRequeteDetail();
    };
    DraftDepotRequeteService.prototype.getContentieuxSocial = function (contentieuxSocialId) {
        return this.draftRequeteService.getContentieuxSocial(contentieuxSocialId);
    };
    DraftDepotRequeteService.prototype.saveJustificatifsAndMergeActeAttaquesIfNeeded = function () {
        var justificatifs = new draft_requete_model_1.Justificatifs();
        this.addPieceJustificatifs(justificatifs);
        return this.draftRequeteService
            .addJustificatifs(justificatifs).pipe(operators_1.map(function (justifcatifs) {
            if (justifcatifs) {
                var acteAttaqueOrReclamationPrealable = [];
                if (Array.isArray(justifcatifs) && justifcatifs.some(function (j) { return j.fileType === piece_jointe_1.PieceJointType.ACTE_ATTAQUE; })) {
                    var acteAttaque = justifcatifs.find(function (j) { return j.fileType === piece_jointe_1.PieceJointType.ACTE_ATTAQUE; });
                    var fileItem = new ng2_file_upload_1.FileLikeObject({
                        name: 'Acte attaqué',
                        type: 'application/pdf'
                    });
                    acteAttaqueOrReclamationPrealable.push(new file_uploader_model_1.FileUploaderModel(fileItem, acteAttaque['fileApiId'], acteAttaque['fileSize']));
                }
                if (Array.isArray(justifcatifs) && justifcatifs.some(function (j) { return j.fileType === piece_jointe_1.PieceJointType.RECLAMATION_PREALABLE; })) {
                    var reclamationPrealable = justifcatifs.find(function (j) { return j.fileType === piece_jointe_1.PieceJointType.RECLAMATION_PREALABLE; });
                    var fileItemRP = new ng2_file_upload_1.FileLikeObject({
                        name: 'Réclamation préalable',
                        type: 'application/pdf'
                    });
                    acteAttaqueOrReclamationPrealable.push(new file_uploader_model_1.FileUploaderModel(fileItemRP, reclamationPrealable['fileApiId'], reclamationPrealable['fileSize']));
                }
                return acteAttaqueOrReclamationPrealable;
            }
            else {
                return null;
            }
        }));
    };
    DraftDepotRequeteService.prototype.updateStatusToRecapitulatif = function () {
        return this.draftRequeteService.addRecapitulatif();
    };
    DraftDepotRequeteService.prototype.depotRequete = function () {
        var _this = this;
        return this.draftRequeteService.depotRequete().pipe(operators_1.tap(function (_res) {
            _this.alertService.success('home.transfered', null, null);
            _this.trackRequete(tracking_enum_1.TrackingAction.SUCCESS);
            _this.router.navigate(['/accueil']);
        }, function (_res) {
            _this.trackRequete(tracking_enum_1.TrackingAction.FAILED);
        }));
    };
    DraftDepotRequeteService.prototype.addPieceJustificatifs = function (justificatifs) {
        justificatifs.piecesNotPostales = __spread([
            this.depotRequeteState.requete
        ], this.depotRequeteState.piecesComplementaires, this.depotRequeteState.acteAttaquesAFusioner, this.depotRequeteState.reclamationPrealablesAFusioner).filter(function (piece) { return piece !== null; })
            .filter(function (piece) { return piece.fileModel; }) // initialized but not yet uploaded
            .map(function (piece) { return piece.toDTO(); });
        justificatifs.piecesPostales = this.depotRequeteState.piecesPostales.map(function (piece) { return piece.toDTO(); });
    };
    DraftDepotRequeteService.prototype.buildUploadUrl = function () {
        // TODO remove
        return "/api/my-draft-requete/pieces/upload";
    };
    DraftDepotRequeteService.prototype.generateInventairePreview = function () {
        return this.draftRequeteService.generateInventairePreview();
    };
    DraftDepotRequeteService.prototype.downloadJustificatif = function (fileApiId) {
        return this.draftRequeteService.downloadJustificatif(fileApiId);
    };
    DraftDepotRequeteService.prototype.getMyDraftRequeteDetail = function () {
        var _this = this;
        return this.draftRequeteService.getMyDraftRequeteDetail().pipe(operators_1.tap(function (draft) {
            if (draft) {
                _this.draftRequeteToDepotRequeteState(draft);
            }
            else {
                _this.cleanDepotRequeteState();
            }
        }));
    };
    DraftDepotRequeteService.prototype.deleteMyDraftRequete = function () {
        var _this = this;
        return this.draftRequeteService.deleteMyDraftRequete().pipe(operators_1.tap(function () { return _this.cleanDepotRequeteState(); }));
    };
    DraftDepotRequeteService.prototype.getMyDraftRequeteSummary = function () {
        var _this = this;
        return this.draftRequeteService.getMyDraftRequeteSummary().pipe(operators_1.tap(function (draftSummary) {
            if (draftSummary) {
                _this.draftSummaryToDepotRequeteState(draftSummary);
            }
            else {
                _this.cleanDepotRequeteState();
            }
        }));
    };
    DraftDepotRequeteService.prototype.displayDraftModal = function () {
        this.modalService.open(draft_modal_component_1.DraftModalComponent, { size: 'lg' });
    };
    DraftDepotRequeteService.prototype.displayOrNotErrorAlertDraft = function (error, showErrorAlertDraft) {
        if (!this.isDraftConflictError(error)) {
            showErrorAlertDraft.emit();
        }
    };
    DraftDepotRequeteService.prototype.isDraftConflictError = function (error) {
        if (error) {
            var errorBody = error;
            if (error.status === http_code_constants_1.HttpCodeEnum.CONFLICT &&
                errorBody && errorBody.code === error_constants_1.ErrorEnum.INVALID_DRAFT_VERSION) {
                return true;
            }
        }
        return false;
    };
    DraftDepotRequeteService.prototype.draftSummaryToDepotRequeteState = function (draftSummary) {
        if (!this.depotRequeteState) {
            this.depotRequeteState = new depot_requete_state_model_1.DepotRequeteState();
            this.depotRequeteState.id = draftSummary.id;
            this.depotRequeteState.dateCreation = draftSummary.dateCreation;
        }
    };
    /**
     * Return a DepotRequeteState object creating from a DraftRequete object
     * @param draftRequete
     */
    DraftDepotRequeteService.prototype.draftRequeteToDepotRequeteState = function (draftRequete) {
        var _this = this;
        this.depotRequeteState = new depot_requete_state_model_1.DepotRequeteState();
        this.depotRequeteState.id = draftRequete.id;
        this.depotRequeteState.dateCreation = draftRequete.dateCreation;
        this.depotRequeteState.statut = draftRequete.statut;
        this.depotRequeteState.version = draftRequete.version;
        this.addRequerantFromDrafToDepotRequestState(draftRequete, this.depotRequeteState);
        this.depotRequeteState.concernContentieuxSocial = draftRequete.concernContentieuxSocial;
        this.depotRequeteState.formActivated = draftRequete.formActivated;
        this.parametersService.getParameters().subscribe(function (parameters) {
            _this.juridictions = parameters.juridictions;
            _this.typeActeAttaques = parameters.typeActeAttaques;
            _this.addJuridictionFromDraft(draftRequete, _this.depotRequeteState);
            _this.addContentieuxSocialFromDraft(draftRequete, _this.depotRequeteState);
            _this.addPiecesFromDraft(draftRequete, _this.depotRequeteState);
        });
        return rxjs_1.of(this.depotRequeteState);
    };
    /**
     * Use to fill the object depotRequeteState from a draftRequete for the Requerant Section
     * @param draftRequete
     * @param depotRequeteState
     */
    DraftDepotRequeteService.prototype.addRequerantFromDrafToDepotRequestState = function (draftRequete, depotRequeteState) {
        depotRequeteState.requeteCategory = draftRequete.category;
        switch (draftRequete.category) {
            case requete_1.RequeteCategory.AVEC_MANDATAIRE:
                depotRequeteState.requeteCategory = requete_1.RequeteCategory.AVEC_MANDATAIRE;
                draftRequete.parties
                    .filter(function (partie) { return partie.userId; })
                    .forEach(function (partie) {
                    if (partie.qualite === requete_1.QualityType.Mandataire) {
                        depotRequeteState.currentActeur = partie;
                    }
                    else if (partie.qualite === requete_1.QualityType.Requerant) {
                        depotRequeteState.requerants.push(partie);
                    }
                });
                break;
            case requete_1.RequeteCategory.COLLECTIVE:
                depotRequeteState.requeteCategory = requete_1.RequeteCategory.COLLECTIVE;
                draftRequete.parties.forEach(function (partie) {
                    if (partie.userId !== null) {
                        depotRequeteState.currentActeur = partie;
                    }
                    else {
                        depotRequeteState.requerants.push(partie);
                    }
                });
                break;
            case requete_1.RequeteCategory.REQUERANT_SEUL:
                depotRequeteState.requeteCategory = requete_1.RequeteCategory.REQUERANT_SEUL;
                if (draftRequete.parties.length === 1) {
                    if (draftRequete.parties[0].qualite === requete_1.QualityType.Requerant) {
                        depotRequeteState.currentActeur = draftRequete.parties[0];
                    }
                }
                break;
        }
    };
    /**
     * Use to fill the object depotRequeteState from a draftRequete for the Juridiction Section
     * @param draftRequete
     * @param depotRequeteState
     */
    DraftDepotRequeteService.prototype.addJuridictionFromDraft = function (draftRequete, depotRequeteState) {
        depotRequeteState.typeJuridiction =
            draftRequete.typeJuridictionId != null
                ? this.juridictions.find(function (juridiction) { return juridiction.id === draftRequete.typeJuridictionId; })
                : null;
        depotRequeteState.siteJuridiction =
            depotRequeteState.typeJuridiction != null && draftRequete.siteJuridictionId != null
                ? depotRequeteState.typeJuridiction.siteJuridictions.find(function (sj) { return sj.id === draftRequete.siteJuridictionId; })
                : null;
        depotRequeteState.urgenceRequete =
            draftRequete.typeRequeteId != null && depotRequeteState.typeJuridiction != null
                ? depotRequeteState.typeJuridiction.urgencesRequete.find(function (urgenceRequete) { return urgenceRequete.id === draftRequete.typeRequeteId; })
                : null;
        depotRequeteState.typeActeAttaque =
            draftRequete.typeActeAttaque != null && depotRequeteState.siteJuridiction != null
                ? draftRequete.typeActeAttaque.code
                : null;
    };
    DraftDepotRequeteService.prototype.addContentieuxSocialFromDraft = function (draftRequete, depotRequeteState) {
        depotRequeteState.requeteCS = null;
        if (draftRequete.contentieuxSocialId != null) {
            this.getContentieuxSocial(draftRequete.contentieuxSocialId).subscribe(function (cs) { return depotRequeteState.requeteCS = cs; });
        }
        if (draftRequete.pieces.length > 0) {
            draftRequete.pieces.forEach(function (piece) {
                var file = { name: piece.fileName, type: piece.fileType, size: piece.fileSize };
                var fileLikeObject = new ng2_file_upload_1.FileLikeObject(file);
                var fileModel = new file_uploader_model_1.FileUploaderModel(fileLikeObject, piece.fileApiId, piece.fileSize);
                if (piece.fileType === piece_jointe_1.PieceJointType.REQUETE) {
                    var pieceRequete = new piece_jointe_1.PieceRequete(fileModel);
                    depotRequeteState.requete = pieceRequete;
                }
            });
        }
    };
    /**
     * Use to fill the object depotRequeteState from a draftRequete for the PieceJointe Section
     * @param draftRequete
     * @param depotRequeteState
     */
    DraftDepotRequeteService.prototype.addPiecesFromDraft = function (draftRequete, depotRequeteState) {
        draftRequete.pieces.forEach(function (piece) {
            var file = { name: piece.fileName, type: piece.fileType, size: piece.fileSize };
            var fileLikeObject = new ng2_file_upload_1.FileLikeObject(file);
            var fileModel = new file_uploader_model_1.FileUploaderModel(fileLikeObject, piece.fileApiId, piece.fileSize);
            switch (piece.fileType) {
                case piece_jointe_1.PieceJointType.REQUETE:
                    var pieceRequete = new piece_jointe_1.PieceRequete(fileModel);
                    depotRequeteState.requete = pieceRequete;
                    break;
                case piece_jointe_1.PieceJointType.ACTE_ATTAQUE:
                    var pieceActeAttaque = new piece_jointe_1.PieceActeAttaque(fileModel);
                    if (piece.createdFromHash) {
                        depotRequeteState.acteAttaque = pieceActeAttaque;
                    }
                    else {
                        if (depotRequeteState.acteAttaque.fileModel == null) {
                            depotRequeteState.acteAttaque = pieceActeAttaque;
                        }
                        depotRequeteState.acteAttaquesAFusioner.push(pieceActeAttaque);
                    }
                    break;
                case piece_jointe_1.PieceJointType.RECLAMATION_PREALABLE:
                    var pieceReclamationPrealable = new piece_jointe_1.PieceReclamationPrealable(fileModel);
                    if (piece.createdFromHash) {
                        depotRequeteState.reclamationPrealable = pieceReclamationPrealable;
                    }
                    else {
                        if (depotRequeteState.reclamationPrealable.fileModel == null) {
                            depotRequeteState.reclamationPrealable = pieceReclamationPrealable;
                        }
                        depotRequeteState.reclamationPrealablesAFusioner.push(pieceReclamationPrealable);
                    }
                    break;
                case piece_jointe_1.PieceJointType.PIECE_JOINTE_REQUETE:
                    var pieceComplementaire = new piece_jointe_1.PieceComplementaire(fileModel, piece_jointe_1.PieceJointType.PIECE_JOINTE_REQUETE, piece_jointe_1.PieceComplementaireOrigineType.DEFAULT);
                    // update piece complementaire origin type
                    pieceComplementaire.complementaryFileOriginType = piece.complementaryFileOriginType;
                    pieceComplementaire.libelle = piece.libelle;
                    depotRequeteState.piecesComplementaires.push(pieceComplementaire);
                    break;
                case piece_jointe_1.PieceJointType.PIECE_POSTALE:
                    if (!depotRequeteState.piecesPostales.some(function (pp) { return pp.libelle === piece.libelle; })) {
                        var piecePostale = new piece_jointe_1.PiecePostale(piece.libelle);
                        depotRequeteState.piecesPostales.push(piecePostale);
                    }
                    break;
            }
        });
    };
    DraftDepotRequeteService.prototype.refreshPiecesFromDraft = function (draftRequete, depotRequeteState) {
        // remove all piece from depotRequeteState
        depotRequeteState.requete = null;
        depotRequeteState.acteAttaque = null;
        depotRequeteState.acteAttaquesAFusioner.length = 0;
        depotRequeteState.reclamationPrealable = null;
        depotRequeteState.reclamationPrealablesAFusioner.length = 0;
        depotRequeteState.piecesComplementaires.length = 0;
        draftRequete.pieces.forEach(function (piece) {
            var file = { name: piece.fileName, type: piece.fileType, size: piece.fileSize };
            var fileLikeObject = new ng2_file_upload_1.FileLikeObject(file);
            var fileModel = new file_uploader_model_1.FileUploaderModel(fileLikeObject, piece.fileApiId, piece.fileSize);
            switch (piece.fileType) {
                case piece_jointe_1.PieceJointType.REQUETE:
                    var pieceRequete = new piece_jointe_1.PieceRequete(fileModel);
                    depotRequeteState.requete = pieceRequete;
                    break;
                case piece_jointe_1.PieceJointType.ACTE_ATTAQUE:
                    var pieceActeAttaque = new piece_jointe_1.PieceActeAttaque(fileModel);
                    if (piece.createdFromHash) {
                        depotRequeteState.acteAttaque = pieceActeAttaque;
                    }
                    else {
                        if (depotRequeteState.acteAttaque && depotRequeteState.acteAttaque.fileModel == null) {
                            depotRequeteState.acteAttaque = pieceActeAttaque;
                        }
                        depotRequeteState.acteAttaquesAFusioner.push(pieceActeAttaque);
                    }
                    break;
                case piece_jointe_1.PieceJointType.RECLAMATION_PREALABLE:
                    var pieceReclamationPrealable = new piece_jointe_1.PieceReclamationPrealable(fileModel);
                    if (piece.createdFromHash) {
                        depotRequeteState.reclamationPrealable = pieceReclamationPrealable;
                    }
                    else {
                        if (depotRequeteState.reclamationPrealable && depotRequeteState.reclamationPrealable.fileModel == null) {
                            depotRequeteState.reclamationPrealable = pieceReclamationPrealable;
                        }
                        depotRequeteState.reclamationPrealablesAFusioner.push(pieceReclamationPrealable);
                    }
                    break;
                case piece_jointe_1.PieceJointType.PIECE_JOINTE_REQUETE:
                    var pieceComplementaire = new piece_jointe_1.PieceComplementaire(fileModel, piece_jointe_1.PieceJointType.PIECE_JOINTE_REQUETE, piece_jointe_1.PieceComplementaireOrigineType.DEFAULT);
                    // update piece complementaire origin type
                    pieceComplementaire.complementaryFileOriginType = piece.complementaryFileOriginType;
                    pieceComplementaire.libelle = piece.libelle;
                    depotRequeteState.piecesComplementaires.push(pieceComplementaire);
                    break;
                case piece_jointe_1.PieceJointType.PIECE_POSTALE:
                    if (!depotRequeteState.piecesPostales.some(function (pp) { return pp.libelle === piece.libelle; })) {
                        var piecePostale = new piece_jointe_1.PiecePostale(piece.libelle);
                        depotRequeteState.piecesPostales.push(piecePostale);
                    }
                    break;
            }
        });
    };
    DraftDepotRequeteService.prototype.trackInventairePreviewDownload = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.DOWNLOAD,
            properties: {
                category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE,
                name: tracking_model_1.TrackingName.PREVIEW_INVENTORY
            }
        });
    };
    DraftDepotRequeteService.prototype.trackInventairePreviewFail = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.DOWNLOAD_FAILED,
            properties: {
                category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE,
                name: tracking_model_1.TrackingName.PREVIEW_INVENTORY
            }
        });
    };
    DraftDepotRequeteService.prototype.trackRequete = function (action) {
        var requete = this.depotRequeteState;
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE,
                name: tracking_model_1.TrackingName.GENERAL
            }
        });
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE_COMPTE,
                name: requete.currentActeur.type === shared_1.AccountType.PHYSIQUE ? 'Personne physique' : 'Personne morale'
            }
        });
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE_TYPE,
                name: requete.requeteCategory
            }
        });
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE_TYPE_JURIDICTION,
                name: requete.typeJuridiction.code
            }
        });
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE_SITE_JURIDICTION,
                name: requete.siteJuridiction.code
            }
        });
        /*  this.trackingService.trackEvent({
             action,
             properties: {
                 category: TrackingCategory.DEPOT_REQUETE_URGENCE,
                 name: requete.urgenceRequete.libelle
             }
         }); */
        if (requete.piecesComplementaires.length) {
            this.trackingService.trackEvent({
                action: action,
                properties: {
                    category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE,
                    name: tracking_model_1.TrackingName.NOMBRE_PIECES_COMPLEMENTAIRES,
                    value: requete.piecesComplementaires.length
                }
            });
        }
        if (requete.piecesPostales.length) {
            this.trackingService.trackEvent({
                action: action,
                properties: {
                    category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE,
                    name: tracking_model_1.TrackingName.NOMBRE_PIECES_POSTALES,
                    value: requete.piecesPostales.length
                }
            });
        }
        if (requete.requeteCategory === requete_1.RequeteCategory.AVEC_MANDATAIRE) {
            this.trackingService.trackEvent({
                action: action,
                properties: {
                    category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE,
                    name: tracking_model_1.TrackingName.NOMBRE_MANDANTS,
                    value: requete.requerants.length
                }
            });
        }
        if (requete.requeteCategory === requete_1.RequeteCategory.COLLECTIVE) {
            this.trackingService.trackEvent({
                action: action,
                properties: {
                    category: tracking_enum_1.TrackingCategory.DEPOT_REQUETE,
                    name: tracking_model_1.TrackingName.NOMBRE_REQUERANTS_REQUETE_COLLECTIVE,
                    value: requete.requerants.length
                }
            });
        }
    };
    DraftDepotRequeteService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [draft_requete_service_1.DraftRequeteService,
            router_1.Router,
            ng_jhipster_1.JhiAlertService,
            tracking_service_1.TrackingService,
            parameters_service_1.ParametersService,
            ng_bootstrap_1.NgbModal,
            common_1.DatePipe])
    ], DraftDepotRequeteService);
    return DraftDepotRequeteService;
}());
exports.DraftDepotRequeteService = DraftDepotRequeteService;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(68));
__export(__webpack_require__(203));


/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(199);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = __webpack_require__(5);
var core_1 = __webpack_require__(0);
var util_1 = __webpack_require__(28);
var BaseControlValueAccessor = /** @class */ (function () {
    function BaseControlValueAccessor(injector) {
        this.injector = injector;
    }
    BaseControlValueAccessor.prototype.writeValue = function (_value) {
    };
    BaseControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (value) {
            _this.modelValue = value;
            _this.modelValueChanged(value);
            fn(value);
        };
        if (typeof this.model !== 'undefined') {
            this.model.valueAccessor.registerOnChange(this.onChange);
        }
    };
    BaseControlValueAccessor.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
        if (typeof this.model !== 'undefined') {
            this.model.valueAccessor.registerOnTouched(fn);
        }
    };
    BaseControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this.model.valueAccessor.setDisabledState(isDisabled);
    };
    BaseControlValueAccessor.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._control = this.injector.get(forms_1.NgControl); // NOSONAR
        this.sub = this._control.valueChanges.subscribe(function (value) {
            _this.modelValue = value;
            _this.modelValueChanged(value);
        });
    };
    BaseControlValueAccessor.prototype.ngAfterContentChecked = function () {
        this.isInvalid = this._control.invalid && (this._control.touched || this._control.dirty);
        this.isValid = this._control.valid;
        var validators = this.injector.get(forms_1.NG_VALIDATORS, null) || [];
        this.isRequired = validators.some(function (validator) { return validator.required; });
        if (typeof this.model !== 'undefined') {
            if (this._control.touched && !this.model.touched) {
                this.model.control.markAsTouched();
            }
        }
    };
    BaseControlValueAccessor.prototype.ngOnDestroy = function () {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    };
    BaseControlValueAccessor.prototype.getModelValue = function () {
        return this.modelValue;
    };
    BaseControlValueAccessor.prototype.hasValue = function () {
        return this.modelValue !== '' && this.modelValue !== undefined && this.modelValue !== null;
    };
    BaseControlValueAccessor.prototype.isEquals = function (x, y) {
        return util_1.isEquals(x, y);
    };
    __decorate([
        core_1.ViewChild(forms_1.NgModel),
        __metadata("design:type", forms_1.NgModel)
    ], BaseControlValueAccessor.prototype, "model", void 0);
    return BaseControlValueAccessor;
}());
exports.BaseControlValueAccessor = BaseControlValueAccessor;


/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ErrorService = /** @class */ (function () {
    function ErrorService() {
    }
    ErrorService.prototype.markAllControlsAsTouched = function (form) {
        Object.keys(form.controls).map(function (key) { return form.controls[key]; })
            .forEach(function (control) { return control.markAsTouched(); });
    };
    ErrorService = __decorate([
        core_1.Injectable()
    ], ErrorService);
    return ErrorService;
}());
exports.ErrorService = ErrorService;


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var rxjs_1 = __webpack_require__(12);
var operators_1 = __webpack_require__(7);
var parameters_model_1 = __webpack_require__(522);
var ParametersService = /** @class */ (function () {
    function ParametersService(http) {
        this.http = http;
        this.parameters = new rxjs_1.BehaviorSubject(parameters_model_1.DEFAULT_PARAMETERS);
    }
    ParametersService.prototype.loadParameters = function () {
        var _this = this;
        if (this.parameters.getValue().countries.length === 0) {
            this.http
                .get('/api/parameters')
                .pipe(operators_1.map(function (response) {
                var rawParameters = response;
                // Correct parameters name before the back update
                rawParameters.juridictions.map(function (typeJuridiction) {
                    typeJuridiction.urgencesRequete = typeJuridiction.typeRequetes.map(function (typeRequete) {
                        typeRequete.codeUrgence = typeRequete.typeUrgence;
                        return typeRequete;
                    });
                    return typeJuridiction;
                });
                return rawParameters;
            }))
                .subscribe(function (parameters) { return _this.parameters.next(parameters); });
        }
        /*if (this.parameters.getValue().countries.length === 0) {
            this.http
                .get('/api/parameters')
                .pipe(
                    map((rawParameters: any) =>
                        rawParameters['juridictions']
                            .map(typeJuridiction => typeJuridiction.urgencesRequete = typeJuridiction.typeRequetes
                                .map(typeRequete => typeRequete.codeUrgence = typeRequete.typeUrgence))
                    )
                )
                .subscribe(parameters => this.parameters.next(parameters));
        }*/
    };
    ParametersService.prototype.getParameters = function () {
        return this.parameters.asObservable();
    };
    ParametersService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], ParametersService);
    return ParametersService;
}());
exports.ParametersService = ParametersService;


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var isDeepEquals = function (x, y) {
    for (var p in x) {
        if (!x.hasOwnProperty(p)) {
            continue; // other properties were tested using x.constructor === y.constructor
        }
        if (!y.hasOwnProperty(p)) {
            return false; // allows to compare x[ p ] and y[ p ] when set to undefined
        }
        if (x[p] === y[p]) {
            continue; // if they have the same strict value or identity then they are equal
        }
        if (typeof (x[p]) !== 'object') {
            return false; // Numbers, Strings, Functions, Booleans must be strictly equal
        }
        if (!exports.isEquals(x[p], y[p])) {
            return false;
        }
    }
    for (var p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
            return false;
        }
    }
    return true;
};
exports.isEquals = function (x, y) {
    if (x === y) {
        return true; // if both x and y are null or undefined and exactly the same
    }
    else if (!(x instanceof Object) || !(y instanceof Object)) {
        return false; // if they are not strictly equal, they both need to be Objects
    }
    else if (x.constructor !== y.constructor) {
        // they must have the exact same prototype chain, the closest we can do is
        // test their constructor.
        return false;
    }
    else {
        return isDeepEquals(x, y);
    }
};
exports.isEmpty = function (value) { return !value || value.replace(/\s/g, '').length === 0; };
exports.normalizeLibelle = function (value) { return value.replace(/[^a-zA-Z\u00C0-\u017F0-9]\./g, '_'); };
/**
 * @TODO: deepCasAs
 */
exports.castAs = function (value, TCreator) {
    // if we already have the correct class skip the cast
    if (!value || value instanceof TCreator) {
        return value;
    }
    // create a new object (create), and copy over all properties (assign)
    var target = new TCreator();
    Object.assign(target, value);
    return target;
};
exports.saveOrOpenRawFile = function (rawFile, fileName) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(rawFile, exports.normalizeLibelle(fileName));
    }
    else {
        var url = URL.createObjectURL(rawFile);
        var downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.target = '_blank';
        downloadLink.download = exports.normalizeLibelle(fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }
};


/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(201);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TrackingCategory;
(function (TrackingCategory) {
    TrackingCategory["DEPOT_REQUETE"] = "D\u00E9pot de requ\u00EAte";
    TrackingCategory["DEPOT_REQUETE_COMPTE"] = "D\u00E9pot de requ\u00EAte par type de compte";
    TrackingCategory["DEPOT_REQUETE_TYPE"] = "D\u00E9pot de requ\u00EAte par type";
    TrackingCategory["DEPOT_REQUETE_TYPE_JURIDICTION"] = "D\u00E9pot de requ\u00EAte par type de juridiction";
    TrackingCategory["DEPOT_REQUETE_SITE_JURIDICTION"] = "D\u00E9pot de requ\u00EAte par site juridiction";
    TrackingCategory["DEPOT_REQUETE_URGENCE"] = "D\u00E9pot de requ\u00EAte par urgence";
    TrackingCategory["RATACHEMENT"] = "Rattachement";
    TrackingCategory["AJOUT_DOCUMENTS"] = "Ajout de documents";
    TrackingCategory["CONSULTATION_DOSSIER"] = "Consultation de dossier";
    TrackingCategory["AUTHENTICATION"] = "Authentication";
    TrackingCategory["FOOTER"] = "Footer";
    TrackingCategory["HEADER"] = "Header";
    TrackingCategory["MES_DOSSIER"] = "Mes dossiers";
})(TrackingCategory = exports.TrackingCategory || (exports.TrackingCategory = {}));
var TrackingAction;
(function (TrackingAction) {
    TrackingAction["SUCCESS"] = "R\u00E9ussi";
    TrackingAction["FAILED"] = "\u00C9chou\u00E9";
    TrackingAction["DOWNLOAD"] = "T\u00E9l\u00E9chargement";
    TrackingAction["DOWNLOAD_FAILED"] = "T\u00E9l\u00E9chargement - \u00C9chou\u00E9";
    TrackingAction["OPTION_ACTIVATED"] = "Option activ\u00E9e";
    TrackingAction["OPTION_NOT_ACTIVATED"] = "Option non activ\u00E9e";
    TrackingAction["CLIQUER"] = "Cliquer";
})(TrackingAction = exports.TrackingAction || (exports.TrackingAction = {}));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var angulartics2_1 = __webpack_require__(104);
var TrackingService = /** @class */ (function () {
    function TrackingService(angulartics) {
        this.angulartics = angulartics;
    }
    TrackingService.prototype.trackEvent = function (event) {
        this.angulartics.eventTrack.next(event);
    };
    TrackingService.prototype.trackStep = function (path) {
        this.angulartics.pageTrack.next({ path: path });
    };
    TrackingService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [angulartics2_1.Angulartics2])
    ], TrackingService);
    return TrackingService;
}());
exports.TrackingService = TrackingService;


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(443));


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(41);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tslib__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_cdk_coercion__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_cdk_observers__ = __webpack_require__(404);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MESSAGES_CONTAINER_ID", function() { return MESSAGES_CONTAINER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_DESCRIBEDBY_ID_PREFIX", function() { return CDK_DESCRIBEDBY_ID_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_DESCRIBEDBY_HOST_ATTRIBUTE", function() { return CDK_DESCRIBEDBY_HOST_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AriaDescriber", function() { return AriaDescriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARIA_DESCRIBER_PROVIDER_FACTORY", function() { return ARIA_DESCRIBER_PROVIDER_FACTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARIA_DESCRIBER_PROVIDER", function() { return ARIA_DESCRIBER_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActiveDescendantKeyManager", function() { return ActiveDescendantKeyManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusKeyManager", function() { return FocusKeyManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListKeyManager", function() { return ListKeyManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusTrap", function() { return FocusTrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusTrapFactory", function() { return FocusTrapFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTrapFocus", function() { return CdkTrapFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InteractivityChecker", function() { return InteractivityChecker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LiveAnnouncer", function() { return LiveAnnouncer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkAriaLive", function() { return CdkAriaLive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_PROVIDER_FACTORY", function() { return LIVE_ANNOUNCER_PROVIDER_FACTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_PROVIDER", function() { return LIVE_ANNOUNCER_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_ELEMENT_TOKEN", function() { return LIVE_ANNOUNCER_ELEMENT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY", function() { return LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH_BUFFER_MS", function() { return TOUCH_BUFFER_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FocusMonitor", function() { return FocusMonitor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkMonitorFocus", function() { return CdkMonitorFocus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_MONITOR_PROVIDER_FACTORY", function() { return FOCUS_MONITOR_PROVIDER_FACTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_MONITOR_PROVIDER", function() { return FOCUS_MONITOR_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFakeMousedownFromScreenReader", function() { return isFakeMousedownFromScreenReader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A11yModule", function() { return A11yModule; });
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */










/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * IDs are deliminated by an empty space, as per the spec.
 */
var /** @type {?} */ ID_DELIMINATOR = ' ';
/**
 * Adds the given ID to the specified ARIA attribute on an element.
 * Used for attributes such as aria-labelledby, aria-owns, etc.
 * @param {?} el
 * @param {?} attr
 * @param {?} id
 * @return {?}
 */
function addAriaReferencedId(el, attr, id) {
    var /** @type {?} */ ids = getAriaReferenceIds(el, attr);
    if (ids.some(function (existingId) { return existingId.trim() == id.trim(); })) {
        return;
    }
    ids.push(id.trim());
    el.setAttribute(attr, ids.join(ID_DELIMINATOR));
}
/**
 * Removes the given ID from the specified ARIA attribute on an element.
 * Used for attributes such as aria-labelledby, aria-owns, etc.
 * @param {?} el
 * @param {?} attr
 * @param {?} id
 * @return {?}
 */
function removeAriaReferencedId(el, attr, id) {
    var /** @type {?} */ ids = getAriaReferenceIds(el, attr);
    var /** @type {?} */ filteredIds = ids.filter(function (val) { return val != id.trim(); });
    el.setAttribute(attr, filteredIds.join(ID_DELIMINATOR));
}
/**
 * Gets the list of IDs referenced by the given ARIA attribute on an element.
 * Used for attributes such as aria-labelledby, aria-owns, etc.
 * @param {?} el
 * @param {?} attr
 * @return {?}
 */
function getAriaReferenceIds(el, attr) {
    // Get string array of all individual ids (whitespace deliminated) in the attribute value
    return (el.getAttribute(attr) || '').match(/\S+/g) || [];
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * ID used for the body container where all messages are appended.
 */
var /** @type {?} */ MESSAGES_CONTAINER_ID = 'cdk-describedby-message-container';
/**
 * ID prefix used for each created message element.
 */
var /** @type {?} */ CDK_DESCRIBEDBY_ID_PREFIX = 'cdk-describedby-message';
/**
 * Attribute given to each host element that is described by a message element.
 */
var /** @type {?} */ CDK_DESCRIBEDBY_HOST_ATTRIBUTE = 'cdk-describedby-host';
/**
 * Global incremental identifier for each registered message element.
 */
var /** @type {?} */ nextId = 0;
/**
 * Global map of all registered message elements that have been placed into the document.
 */
var /** @type {?} */ messageRegistry = new Map();
/**
 * Container for all registered messages.
 */
var /** @type {?} */ messagesContainer = null;
/**
 * Utility that creates visually hidden elements with a message content. Useful for elements that
 * want to use aria-describedby to further describe themselves without adding additional visual
 * content.
 * \@docs-private
 */
var AriaDescriber = /** @class */ (function () {
    function AriaDescriber(_document) {
        this._document = _document;
    }
    /**
     * Adds to the host element an aria-describedby reference to a hidden element that contains
     * the message. If the same message has already been registered, then it will reuse the created
     * message element.
     */
    /**
     * Adds to the host element an aria-describedby reference to a hidden element that contains
     * the message. If the same message has already been registered, then it will reuse the created
     * message element.
     * @param {?} hostElement
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype.describe = /**
     * Adds to the host element an aria-describedby reference to a hidden element that contains
     * the message. If the same message has already been registered, then it will reuse the created
     * message element.
     * @param {?} hostElement
     * @param {?} message
     * @return {?}
     */
    function (hostElement, message) {
        if (!this._canBeDescribed(hostElement, message)) {
            return;
        }
        if (!messageRegistry.has(message)) {
            this._createMessageElement(message);
        }
        if (!this._isElementDescribedByMessage(hostElement, message)) {
            this._addMessageReference(hostElement, message);
        }
    };
    /** Removes the host element's aria-describedby reference to the message element. */
    /**
     * Removes the host element's aria-describedby reference to the message element.
     * @param {?} hostElement
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype.removeDescription = /**
     * Removes the host element's aria-describedby reference to the message element.
     * @param {?} hostElement
     * @param {?} message
     * @return {?}
     */
    function (hostElement, message) {
        if (!this._canBeDescribed(hostElement, message)) {
            return;
        }
        if (this._isElementDescribedByMessage(hostElement, message)) {
            this._removeMessageReference(hostElement, message);
        }
        var /** @type {?} */ registeredMessage = messageRegistry.get(message);
        if (registeredMessage && registeredMessage.referenceCount === 0) {
            this._deleteMessageElement(message);
        }
        if (messagesContainer && messagesContainer.childNodes.length === 0) {
            this._deleteMessagesContainer();
        }
    };
    /** Unregisters all created message elements and removes the message container. */
    /**
     * Unregisters all created message elements and removes the message container.
     * @return {?}
     */
    AriaDescriber.prototype.ngOnDestroy = /**
     * Unregisters all created message elements and removes the message container.
     * @return {?}
     */
    function () {
        var /** @type {?} */ describedElements = this._document.querySelectorAll("[" + CDK_DESCRIBEDBY_HOST_ATTRIBUTE + "]");
        for (var /** @type {?} */ i = 0; i < describedElements.length; i++) {
            this._removeCdkDescribedByReferenceIds(describedElements[i]);
            describedElements[i].removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
        }
        if (messagesContainer) {
            this._deleteMessagesContainer();
        }
        messageRegistry.clear();
    };
    /**
     * Creates a new element in the visually hidden message container element with the message
     * as its content and adds it to the message registry.
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype._createMessageElement = /**
     * Creates a new element in the visually hidden message container element with the message
     * as its content and adds it to the message registry.
     * @param {?} message
     * @return {?}
     */
    function (message) {
        var /** @type {?} */ messageElement = this._document.createElement('div');
        messageElement.setAttribute('id', CDK_DESCRIBEDBY_ID_PREFIX + "-" + nextId++);
        messageElement.appendChild(/** @type {?} */ ((this._document.createTextNode(message))));
        this._createMessagesContainer(); /** @type {?} */
        ((messagesContainer)).appendChild(messageElement);
        messageRegistry.set(message, { messageElement: messageElement, referenceCount: 0 });
    };
    /**
     * Deletes the message element from the global messages container.
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype._deleteMessageElement = /**
     * Deletes the message element from the global messages container.
     * @param {?} message
     * @return {?}
     */
    function (message) {
        var /** @type {?} */ registeredMessage = messageRegistry.get(message);
        var /** @type {?} */ messageElement = registeredMessage && registeredMessage.messageElement;
        if (messagesContainer && messageElement) {
            messagesContainer.removeChild(messageElement);
        }
        messageRegistry.delete(message);
    };
    /**
     * Creates the global container for all aria-describedby messages.
     * @return {?}
     */
    AriaDescriber.prototype._createMessagesContainer = /**
     * Creates the global container for all aria-describedby messages.
     * @return {?}
     */
    function () {
        if (!messagesContainer) {
            var /** @type {?} */ preExistingContainer = this._document.getElementById(MESSAGES_CONTAINER_ID);
            // When going from the server to the client, we may end up in a situation where there's
            // already a container on the page, but we don't have a reference to it. Clear the
            // old container so we don't get duplicates. Doing this, instead of emptying the previous
            // container, should be slightly faster.
            if (preExistingContainer) {
                /** @type {?} */ ((preExistingContainer.parentNode)).removeChild(preExistingContainer);
            }
            messagesContainer = this._document.createElement('div');
            messagesContainer.id = MESSAGES_CONTAINER_ID;
            messagesContainer.setAttribute('aria-hidden', 'true');
            messagesContainer.style.display = 'none';
            this._document.body.appendChild(messagesContainer);
        }
    };
    /**
     * Deletes the global messages container.
     * @return {?}
     */
    AriaDescriber.prototype._deleteMessagesContainer = /**
     * Deletes the global messages container.
     * @return {?}
     */
    function () {
        if (messagesContainer && messagesContainer.parentNode) {
            messagesContainer.parentNode.removeChild(messagesContainer);
            messagesContainer = null;
        }
    };
    /**
     * Removes all cdk-describedby messages that are hosted through the element.
     * @param {?} element
     * @return {?}
     */
    AriaDescriber.prototype._removeCdkDescribedByReferenceIds = /**
     * Removes all cdk-describedby messages that are hosted through the element.
     * @param {?} element
     * @return {?}
     */
    function (element) {
        // Remove all aria-describedby reference IDs that are prefixed by CDK_DESCRIBEDBY_ID_PREFIX
        var /** @type {?} */ originalReferenceIds = getAriaReferenceIds(element, 'aria-describedby')
            .filter(function (id) { return id.indexOf(CDK_DESCRIBEDBY_ID_PREFIX) != 0; });
        element.setAttribute('aria-describedby', originalReferenceIds.join(' '));
    };
    /**
     * Adds a message reference to the element using aria-describedby and increments the registered
     * message's reference count.
     * @param {?} element
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype._addMessageReference = /**
     * Adds a message reference to the element using aria-describedby and increments the registered
     * message's reference count.
     * @param {?} element
     * @param {?} message
     * @return {?}
     */
    function (element, message) {
        var /** @type {?} */ registeredMessage = /** @type {?} */ ((messageRegistry.get(message)));
        // Add the aria-describedby reference and set the
        // describedby_host attribute to mark the element.
        addAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
        element.setAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE, '');
        registeredMessage.referenceCount++;
    };
    /**
     * Removes a message reference from the element using aria-describedby
     * and decrements the registered message's reference count.
     * @param {?} element
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype._removeMessageReference = /**
     * Removes a message reference from the element using aria-describedby
     * and decrements the registered message's reference count.
     * @param {?} element
     * @param {?} message
     * @return {?}
     */
    function (element, message) {
        var /** @type {?} */ registeredMessage = /** @type {?} */ ((messageRegistry.get(message)));
        registeredMessage.referenceCount--;
        removeAriaReferencedId(element, 'aria-describedby', registeredMessage.messageElement.id);
        element.removeAttribute(CDK_DESCRIBEDBY_HOST_ATTRIBUTE);
    };
    /**
     * Returns true if the element has been described by the provided message ID.
     * @param {?} element
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype._isElementDescribedByMessage = /**
     * Returns true if the element has been described by the provided message ID.
     * @param {?} element
     * @param {?} message
     * @return {?}
     */
    function (element, message) {
        var /** @type {?} */ referenceIds = getAriaReferenceIds(element, 'aria-describedby');
        var /** @type {?} */ registeredMessage = messageRegistry.get(message);
        var /** @type {?} */ messageId = registeredMessage && registeredMessage.messageElement.id;
        return !!messageId && referenceIds.indexOf(messageId) != -1;
    };
    /**
     * Determines whether a message can be described on a particular element.
     * @param {?} element
     * @param {?} message
     * @return {?}
     */
    AriaDescriber.prototype._canBeDescribed = /**
     * Determines whether a message can be described on a particular element.
     * @param {?} element
     * @param {?} message
     * @return {?}
     */
    function (element, message) {
        return element.nodeType === this._document.ELEMENT_NODE && message != null &&
            !!("" + message).trim();
    };
    AriaDescriber.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */
    AriaDescriber.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"],] },] },
    ]; };
    /** @nocollapse */ AriaDescriber.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function AriaDescriber_Factory() { return new AriaDescriber(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"])); }, token: AriaDescriber, providedIn: "root" });
    return AriaDescriber;
}());
/**
 * \@docs-private \@deprecated \@breaking-change 7.0.0
 * @param {?} parentDispatcher
 * @param {?} _document
 * @return {?}
 */
function ARIA_DESCRIBER_PROVIDER_FACTORY(parentDispatcher, _document) {
    return parentDispatcher || new AriaDescriber(_document);
}
/**
 * \@docs-private \@deprecated \@breaking-change 7.0.0
 */
var /** @type {?} */ ARIA_DESCRIBER_PROVIDER = {
    // If there is already an AriaDescriber available, use that. Otherwise, provide a new one.
    provide: AriaDescriber,
    deps: [
        [new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"](), AriaDescriber],
        /** @type {?} */ (__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"])
    ],
    useFactory: ARIA_DESCRIBER_PROVIDER_FACTORY
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
// unsupported: template constraints.
/**
 * This class manages keyboard events for selectable lists. If you pass it a query list
 * of items, it will set the active item correctly when arrow events occur.
 * @template T
 */
var  
// unsupported: template constraints.
/**
 * This class manages keyboard events for selectable lists. If you pass it a query list
 * of items, it will set the active item correctly when arrow events occur.
 * @template T
 */
ListKeyManager = /** @class */ (function () {
    function ListKeyManager(_items) {
        var _this = this;
        this._items = _items;
        this._activeItemIndex = -1;
        this._wrap = false;
        this._letterKeyStream = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["Subject"]();
        this._typeaheadSubscription = __WEBPACK_IMPORTED_MODULE_2_rxjs__["Subscription"].EMPTY;
        this._vertical = true;
        /**
         * Predicate function that can be used to check whether an item should be skipped
         * by the key manager. By default, disabled items are skipped.
         */
        this._skipPredicateFn = function (item) { return item.disabled; };
        this._pressedLetters = [];
        /**
         * Stream that emits any time the TAB key is pressed, so components can react
         * when focus is shifted off of the list.
         */
        this.tabOut = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["Subject"]();
        /**
         * Stream that emits whenever the active item of the list manager changes.
         */
        this.change = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["Subject"]();
        // We allow for the items to be an array because, in some cases, the consumer may
        // not have access to a QueryList of the items they want to manage (e.g. when the
        // items aren't being collected via `ViewChildren` or `ContentChildren`).
        if (_items instanceof __WEBPACK_IMPORTED_MODULE_1__angular_core__["QueryList"]) {
            _items.changes.subscribe(function (newItems) {
                if (_this._activeItem) {
                    var /** @type {?} */ itemArray = newItems.toArray();
                    var /** @type {?} */ newIndex = itemArray.indexOf(_this._activeItem);
                    if (newIndex > -1 && newIndex !== _this._activeItemIndex) {
                        _this._activeItemIndex = newIndex;
                    }
                }
            });
        }
    }
    /**
     * Sets the predicate function that determines which items should be skipped by the
     * list key manager.
     * @param predicate Function that determines whether the given item should be skipped.
     */
    /**
     * Sets the predicate function that determines which items should be skipped by the
     * list key manager.
     * @param {?} predicate Function that determines whether the given item should be skipped.
     * @return {?}
     */
    ListKeyManager.prototype.skipPredicate = /**
     * Sets the predicate function that determines which items should be skipped by the
     * list key manager.
     * @param {?} predicate Function that determines whether the given item should be skipped.
     * @return {?}
     */
    function (predicate) {
        this._skipPredicateFn = predicate;
        return this;
    };
    /**
     * Configures wrapping mode, which determines whether the active item will wrap to
     * the other end of list when there are no more items in the given direction.
     * @param shouldWrap Whether the list should wrap when reaching the end.
     */
    /**
     * Configures wrapping mode, which determines whether the active item will wrap to
     * the other end of list when there are no more items in the given direction.
     * @param {?=} shouldWrap Whether the list should wrap when reaching the end.
     * @return {?}
     */
    ListKeyManager.prototype.withWrap = /**
     * Configures wrapping mode, which determines whether the active item will wrap to
     * the other end of list when there are no more items in the given direction.
     * @param {?=} shouldWrap Whether the list should wrap when reaching the end.
     * @return {?}
     */
    function (shouldWrap) {
        if (shouldWrap === void 0) { shouldWrap = true; }
        this._wrap = shouldWrap;
        return this;
    };
    /**
     * Configures whether the key manager should be able to move the selection vertically.
     * @param enabled Whether vertical selection should be enabled.
     */
    /**
     * Configures whether the key manager should be able to move the selection vertically.
     * @param {?=} enabled Whether vertical selection should be enabled.
     * @return {?}
     */
    ListKeyManager.prototype.withVerticalOrientation = /**
     * Configures whether the key manager should be able to move the selection vertically.
     * @param {?=} enabled Whether vertical selection should be enabled.
     * @return {?}
     */
    function (enabled) {
        if (enabled === void 0) { enabled = true; }
        this._vertical = enabled;
        return this;
    };
    /**
     * Configures the key manager to move the selection horizontally.
     * Passing in `null` will disable horizontal movement.
     * @param direction Direction in which the selection can be moved.
     */
    /**
     * Configures the key manager to move the selection horizontally.
     * Passing in `null` will disable horizontal movement.
     * @param {?} direction Direction in which the selection can be moved.
     * @return {?}
     */
    ListKeyManager.prototype.withHorizontalOrientation = /**
     * Configures the key manager to move the selection horizontally.
     * Passing in `null` will disable horizontal movement.
     * @param {?} direction Direction in which the selection can be moved.
     * @return {?}
     */
    function (direction) {
        this._horizontal = direction;
        return this;
    };
    /**
     * Turns on typeahead mode which allows users to set the active item by typing.
     * @param debounceInterval Time to wait after the last keystroke before setting the active item.
     */
    /**
     * Turns on typeahead mode which allows users to set the active item by typing.
     * @param {?=} debounceInterval Time to wait after the last keystroke before setting the active item.
     * @return {?}
     */
    ListKeyManager.prototype.withTypeAhead = /**
     * Turns on typeahead mode which allows users to set the active item by typing.
     * @param {?=} debounceInterval Time to wait after the last keystroke before setting the active item.
     * @return {?}
     */
    function (debounceInterval) {
        var _this = this;
        if (debounceInterval === void 0) { debounceInterval = 200; }
        if (this._items.length && this._items.some(function (item) { return typeof item.getLabel !== 'function'; })) {
            throw Error('ListKeyManager items in typeahead mode must implement the `getLabel` method.');
        }
        this._typeaheadSubscription.unsubscribe();
        // Debounce the presses of non-navigational keys, collect the ones that correspond to letters
        // and convert those letters back into a string. Afterwards find the first item that starts
        // with that string and select it.
        this._typeaheadSubscription = this._letterKeyStream.pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["tap"])(function (keyCode) { return _this._pressedLetters.push(keyCode); }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["debounceTime"])(debounceInterval), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["filter"])(function () { return _this._pressedLetters.length > 0; }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["map"])(function () { return _this._pressedLetters.join(''); })).subscribe(function (inputString) {
            var /** @type {?} */ items = _this._getItemsArray();
            // Start at 1 because we want to start searching at the item immediately
            // following the current active item.
            for (var /** @type {?} */ i = 1; i < items.length + 1; i++) {
                var /** @type {?} */ index = (_this._activeItemIndex + i) % items.length;
                var /** @type {?} */ item = items[index];
                if (!_this._skipPredicateFn(item) && /** @type {?} */ ((item.getLabel))().toUpperCase().trim().indexOf(inputString) === 0) {
                    _this.setActiveItem(index);
                    break;
                }
            }
            _this._pressedLetters = [];
        });
        return this;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ListKeyManager.prototype.setActiveItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var /** @type {?} */ previousIndex = this._activeItemIndex;
        this.updateActiveItem(item);
        if (this._activeItemIndex !== previousIndex) {
            this.change.next(this._activeItemIndex);
        }
    };
    /**
     * Sets the active item depending on the key event passed in.
     * @param event Keyboard event to be used for determining which element should be active.
     */
    /**
     * Sets the active item depending on the key event passed in.
     * @param {?} event Keyboard event to be used for determining which element should be active.
     * @return {?}
     */
    ListKeyManager.prototype.onKeydown = /**
     * Sets the active item depending on the key event passed in.
     * @param {?} event Keyboard event to be used for determining which element should be active.
     * @return {?}
     */
    function (event) {
        var /** @type {?} */ keyCode = event.keyCode;
        switch (keyCode) {
            case __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["a" /* TAB */]:
                this.tabOut.next();
                return;
            case __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["b" /* DOWN_ARROW */]:
                if (this._vertical) {
                    this.setNextItemActive();
                    break;
                }
                else {
                    return;
                }
            case __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["c" /* UP_ARROW */]:
                if (this._vertical) {
                    this.setPreviousItemActive();
                    break;
                }
                else {
                    return;
                }
            case __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["d" /* RIGHT_ARROW */]:
                if (this._horizontal === 'ltr') {
                    this.setNextItemActive();
                    break;
                }
                else if (this._horizontal === 'rtl') {
                    this.setPreviousItemActive();
                    break;
                }
                else {
                    return;
                }
            case __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["e" /* LEFT_ARROW */]:
                if (this._horizontal === 'ltr') {
                    this.setPreviousItemActive();
                    break;
                }
                else if (this._horizontal === 'rtl') {
                    this.setNextItemActive();
                    break;
                }
                else {
                    return;
                }
            default:
                // Attempt to use the `event.key` which also maps it to the user's keyboard language,
                // otherwise fall back to resolving alphanumeric characters via the keyCode.
                if (event.key && event.key.length === 1) {
                    this._letterKeyStream.next(event.key.toLocaleUpperCase());
                }
                else if ((keyCode >= __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["f" /* A */] && keyCode <= __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["g" /* Z */]) || (keyCode >= __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["h" /* ZERO */] && keyCode <= __WEBPACK_IMPORTED_MODULE_3__angular_cdk_keycodes__["i" /* NINE */])) {
                    this._letterKeyStream.next(String.fromCharCode(keyCode));
                }
                // Note that we return here, in order to avoid preventing
                // the default action of non-navigational keys.
                return;
        }
        this._pressedLetters = [];
        event.preventDefault();
    };
    Object.defineProperty(ListKeyManager.prototype, "activeItemIndex", {
        /** Index of the currently active item. */
        get: /**
         * Index of the currently active item.
         * @return {?}
         */
        function () {
            return this._activeItemIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListKeyManager.prototype, "activeItem", {
        /** The active item. */
        get: /**
         * The active item.
         * @return {?}
         */
        function () {
            return this._activeItem;
        },
        enumerable: true,
        configurable: true
    });
    /** Sets the active item to the first enabled item in the list. */
    /**
     * Sets the active item to the first enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setFirstItemActive = /**
     * Sets the active item to the first enabled item in the list.
     * @return {?}
     */
    function () {
        this._setActiveItemByIndex(0, 1);
    };
    /** Sets the active item to the last enabled item in the list. */
    /**
     * Sets the active item to the last enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setLastItemActive = /**
     * Sets the active item to the last enabled item in the list.
     * @return {?}
     */
    function () {
        this._setActiveItemByIndex(this._items.length - 1, -1);
    };
    /** Sets the active item to the next enabled item in the list. */
    /**
     * Sets the active item to the next enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setNextItemActive = /**
     * Sets the active item to the next enabled item in the list.
     * @return {?}
     */
    function () {
        this._activeItemIndex < 0 ? this.setFirstItemActive() : this._setActiveItemByDelta(1);
    };
    /** Sets the active item to a previous enabled item in the list. */
    /**
     * Sets the active item to a previous enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setPreviousItemActive = /**
     * Sets the active item to a previous enabled item in the list.
     * @return {?}
     */
    function () {
        this._activeItemIndex < 0 && this._wrap ? this.setLastItemActive()
            : this._setActiveItemByDelta(-1);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ListKeyManager.prototype.updateActiveItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var /** @type {?} */ itemArray = this._getItemsArray();
        var /** @type {?} */ index = typeof item === 'number' ? item : itemArray.indexOf(item);
        this._activeItemIndex = index;
        this._activeItem = itemArray[index];
    };
    /**
     * Allows setting of the activeItemIndex without any other effects.
     * @param index The new activeItemIndex.
     * @deprecated Use `updateActiveItem` instead.
     * @breaking-change 7.0.0
     */
    /**
     * Allows setting of the activeItemIndex without any other effects.
     * @deprecated Use `updateActiveItem` instead.
     * \@breaking-change 7.0.0
     * @param {?} index The new activeItemIndex.
     * @return {?}
     */
    ListKeyManager.prototype.updateActiveItemIndex = /**
     * Allows setting of the activeItemIndex without any other effects.
     * @deprecated Use `updateActiveItem` instead.
     * \@breaking-change 7.0.0
     * @param {?} index The new activeItemIndex.
     * @return {?}
     */
    function (index) {
        this.updateActiveItem(index);
    };
    /**
     * This method sets the active item, given a list of items and the delta between the
     * currently active item and the new active item. It will calculate differently
     * depending on whether wrap mode is turned on.
     * @param {?} delta
     * @return {?}
     */
    ListKeyManager.prototype._setActiveItemByDelta = /**
     * This method sets the active item, given a list of items and the delta between the
     * currently active item and the new active item. It will calculate differently
     * depending on whether wrap mode is turned on.
     * @param {?} delta
     * @return {?}
     */
    function (delta) {
        this._wrap ? this._setActiveInWrapMode(delta) : this._setActiveInDefaultMode(delta);
    };
    /**
     * Sets the active item properly given "wrap" mode. In other words, it will continue to move
     * down the list until it finds an item that is not disabled, and it will wrap if it
     * encounters either end of the list.
     * @param {?} delta
     * @return {?}
     */
    ListKeyManager.prototype._setActiveInWrapMode = /**
     * Sets the active item properly given "wrap" mode. In other words, it will continue to move
     * down the list until it finds an item that is not disabled, and it will wrap if it
     * encounters either end of the list.
     * @param {?} delta
     * @return {?}
     */
    function (delta) {
        var /** @type {?} */ items = this._getItemsArray();
        for (var /** @type {?} */ i = 1; i <= items.length; i++) {
            var /** @type {?} */ index = (this._activeItemIndex + (delta * i) + items.length) % items.length;
            var /** @type {?} */ item = items[index];
            if (!this._skipPredicateFn(item)) {
                this.setActiveItem(index);
                return;
            }
        }
    };
    /**
     * Sets the active item properly given the default mode. In other words, it will
     * continue to move down the list until it finds an item that is not disabled. If
     * it encounters either end of the list, it will stop and not wrap.
     * @param {?} delta
     * @return {?}
     */
    ListKeyManager.prototype._setActiveInDefaultMode = /**
     * Sets the active item properly given the default mode. In other words, it will
     * continue to move down the list until it finds an item that is not disabled. If
     * it encounters either end of the list, it will stop and not wrap.
     * @param {?} delta
     * @return {?}
     */
    function (delta) {
        this._setActiveItemByIndex(this._activeItemIndex + delta, delta);
    };
    /**
     * Sets the active item to the first enabled item starting at the index specified. If the
     * item is disabled, it will move in the fallbackDelta direction until it either
     * finds an enabled item or encounters the end of the list.
     * @param {?} index
     * @param {?} fallbackDelta
     * @return {?}
     */
    ListKeyManager.prototype._setActiveItemByIndex = /**
     * Sets the active item to the first enabled item starting at the index specified. If the
     * item is disabled, it will move in the fallbackDelta direction until it either
     * finds an enabled item or encounters the end of the list.
     * @param {?} index
     * @param {?} fallbackDelta
     * @return {?}
     */
    function (index, fallbackDelta) {
        var /** @type {?} */ items = this._getItemsArray();
        if (!items[index]) {
            return;
        }
        while (this._skipPredicateFn(items[index])) {
            index += fallbackDelta;
            if (!items[index]) {
                return;
            }
        }
        this.setActiveItem(index);
    };
    /**
     * Returns the items as an array.
     * @return {?}
     */
    ListKeyManager.prototype._getItemsArray = /**
     * Returns the items as an array.
     * @return {?}
     */
    function () {
        return this._items instanceof __WEBPACK_IMPORTED_MODULE_1__angular_core__["QueryList"] ? this._items.toArray() : this._items;
    };
    return ListKeyManager;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
ActiveDescendantKeyManager = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_tslib__["__extends"])(ActiveDescendantKeyManager, _super);
    function ActiveDescendantKeyManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    ActiveDescendantKeyManager.prototype.setActiveItem = /**
     * @param {?} index
     * @return {?}
     */
    function (index) {
        if (this.activeItem) {
            this.activeItem.setInactiveStyles();
        }
        _super.prototype.setActiveItem.call(this, index);
        if (this.activeItem) {
            this.activeItem.setActiveStyles();
        }
    };
    return ActiveDescendantKeyManager;
}(ListKeyManager));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @template T
 */
var  /**
 * @template T
 */
FocusKeyManager = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_tslib__["__extends"])(FocusKeyManager, _super);
    function FocusKeyManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._origin = 'program';
        return _this;
    }
    /**
     * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
     * @param origin Focus origin to be used when focusing items.
     */
    /**
     * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
     * @param {?} origin Focus origin to be used when focusing items.
     * @return {?}
     */
    FocusKeyManager.prototype.setFocusOrigin = /**
     * Sets the focus origin that will be passed in to the items for any subsequent `focus` calls.
     * @param {?} origin Focus origin to be used when focusing items.
     * @return {?}
     */
    function (origin) {
        this._origin = origin;
        return this;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FocusKeyManager.prototype.setActiveItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        _super.prototype.setActiveItem.call(this, item);
        if (this.activeItem) {
            this.activeItem.focus(this._origin);
        }
    };
    return FocusKeyManager;
}(ListKeyManager));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Utility for checking the interactivity of an element, such as whether is is focusable or
 * tabbable.
 */
var InteractivityChecker = /** @class */ (function () {
    function InteractivityChecker(_platform) {
        this._platform = _platform;
    }
    /**
     * Gets whether an element is disabled.
     *
     * @param element Element to be checked.
     * @returns Whether the element is disabled.
     */
    /**
     * Gets whether an element is disabled.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is disabled.
     */
    InteractivityChecker.prototype.isDisabled = /**
     * Gets whether an element is disabled.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is disabled.
     */
    function (element) {
        // This does not capture some cases, such as a non-form control with a disabled attribute or
        // a form control inside of a disabled form, but should capture the most common cases.
        return element.hasAttribute('disabled');
    };
    /**
     * Gets whether an element is visible for the purposes of interactivity.
     *
     * This will capture states like `display: none` and `visibility: hidden`, but not things like
     * being clipped by an `overflow: hidden` parent or being outside the viewport.
     *
     * @returns Whether the element is visible.
     */
    /**
     * Gets whether an element is visible for the purposes of interactivity.
     *
     * This will capture states like `display: none` and `visibility: hidden`, but not things like
     * being clipped by an `overflow: hidden` parent or being outside the viewport.
     *
     * @param {?} element
     * @return {?} Whether the element is visible.
     */
    InteractivityChecker.prototype.isVisible = /**
     * Gets whether an element is visible for the purposes of interactivity.
     *
     * This will capture states like `display: none` and `visibility: hidden`, but not things like
     * being clipped by an `overflow: hidden` parent or being outside the viewport.
     *
     * @param {?} element
     * @return {?} Whether the element is visible.
     */
    function (element) {
        return hasGeometry(element) && getComputedStyle(element).visibility === 'visible';
    };
    /**
     * Gets whether an element can be reached via Tab key.
     * Assumes that the element has already been checked with isFocusable.
     *
     * @param element Element to be checked.
     * @returns Whether the element is tabbable.
     */
    /**
     * Gets whether an element can be reached via Tab key.
     * Assumes that the element has already been checked with isFocusable.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is tabbable.
     */
    InteractivityChecker.prototype.isTabbable = /**
     * Gets whether an element can be reached via Tab key.
     * Assumes that the element has already been checked with isFocusable.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is tabbable.
     */
    function (element) {
        // Nothing is tabbable on the the server 😎
        if (!this._platform.isBrowser) {
            return false;
        }
        var /** @type {?} */ frameElement = getFrameElement(getWindow(element));
        if (frameElement) {
            var /** @type {?} */ frameType = frameElement && frameElement.nodeName.toLowerCase();
            // Frame elements inherit their tabindex onto all child elements.
            if (getTabIndexValue(frameElement) === -1) {
                return false;
            }
            // Webkit and Blink consider anything inside of an <object> element as non-tabbable.
            if ((this._platform.BLINK || this._platform.WEBKIT) && frameType === 'object') {
                return false;
            }
            // Webkit and Blink disable tabbing to an element inside of an invisible frame.
            if ((this._platform.BLINK || this._platform.WEBKIT) && !this.isVisible(frameElement)) {
                return false;
            }
        }
        var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
        var /** @type {?} */ tabIndexValue = getTabIndexValue(element);
        if (element.hasAttribute('contenteditable')) {
            return tabIndexValue !== -1;
        }
        if (nodeName === 'iframe') {
            // The frames may be tabbable depending on content, but it's not possibly to reliably
            // investigate the content of the frames.
            return false;
        }
        if (nodeName === 'audio') {
            if (!element.hasAttribute('controls')) {
                // By default an <audio> element without the controls enabled is not tabbable.
                return false;
            }
            else if (this._platform.BLINK) {
                // In Blink <audio controls> elements are always tabbable.
                return true;
            }
        }
        if (nodeName === 'video') {
            if (!element.hasAttribute('controls') && this._platform.TRIDENT) {
                // In Trident a <video> element without the controls enabled is not tabbable.
                return false;
            }
            else if (this._platform.BLINK || this._platform.FIREFOX) {
                // In Chrome and Firefox <video controls> elements are always tabbable.
                return true;
            }
        }
        if (nodeName === 'object' && (this._platform.BLINK || this._platform.WEBKIT)) {
            // In all Blink and WebKit based browsers <object> elements are never tabbable.
            return false;
        }
        // In iOS the browser only considers some specific elements as tabbable.
        if (this._platform.WEBKIT && this._platform.IOS && !isPotentiallyTabbableIOS(element)) {
            return false;
        }
        return element.tabIndex >= 0;
    };
    /**
     * Gets whether an element can be focused by the user.
     *
     * @param element Element to be checked.
     * @returns Whether the element is focusable.
     */
    /**
     * Gets whether an element can be focused by the user.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is focusable.
     */
    InteractivityChecker.prototype.isFocusable = /**
     * Gets whether an element can be focused by the user.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is focusable.
     */
    function (element) {
        // Perform checks in order of left to most expensive.
        // Again, naive approach that does not capture many edge cases and browser quirks.
        return isPotentiallyFocusable(element) && !this.isDisabled(element) && this.isVisible(element);
    };
    InteractivityChecker.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */
    InteractivityChecker.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__["a" /* Platform */], },
    ]; };
    /** @nocollapse */ InteractivityChecker.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function InteractivityChecker_Factory() { return new InteractivityChecker(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__["a" /* Platform */])); }, token: InteractivityChecker, providedIn: "root" });
    return InteractivityChecker;
}());
/**
 * Returns the frame element from a window object. Since browsers like MS Edge throw errors if
 * the frameElement property is being accessed from a different host address, this property
 * should be accessed carefully.
 * @param {?} window
 * @return {?}
 */
function getFrameElement(window) {
    try {
        return /** @type {?} */ (window.frameElement);
    }
    catch (/** @type {?} */ e) {
        return null;
    }
}
/**
 * Checks whether the specified element has any geometry / rectangles.
 * @param {?} element
 * @return {?}
 */
function hasGeometry(element) {
    // Use logic from jQuery to check for an invisible element.
    // See https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js#L12
    return !!(element.offsetWidth || element.offsetHeight ||
        (typeof element.getClientRects === 'function' && element.getClientRects().length));
}
/**
 * Gets whether an element's
 * @param {?} element
 * @return {?}
 */
function isNativeFormElement(element) {
    var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
    return nodeName === 'input' ||
        nodeName === 'select' ||
        nodeName === 'button' ||
        nodeName === 'textarea';
}
/**
 * Gets whether an element is an `<input type="hidden">`.
 * @param {?} element
 * @return {?}
 */
function isHiddenInput(element) {
    return isInputElement(element) && element.type == 'hidden';
}
/**
 * Gets whether an element is an anchor that has an href attribute.
 * @param {?} element
 * @return {?}
 */
function isAnchorWithHref(element) {
    return isAnchorElement(element) && element.hasAttribute('href');
}
/**
 * Gets whether an element is an input element.
 * @param {?} element
 * @return {?}
 */
function isInputElement(element) {
    return element.nodeName.toLowerCase() == 'input';
}
/**
 * Gets whether an element is an anchor element.
 * @param {?} element
 * @return {?}
 */
function isAnchorElement(element) {
    return element.nodeName.toLowerCase() == 'a';
}
/**
 * Gets whether an element has a valid tabindex.
 * @param {?} element
 * @return {?}
 */
function hasValidTabIndex(element) {
    if (!element.hasAttribute('tabindex') || element.tabIndex === undefined) {
        return false;
    }
    var /** @type {?} */ tabIndex = element.getAttribute('tabindex');
    // IE11 parses tabindex="" as the value "-32768"
    if (tabIndex == '-32768') {
        return false;
    }
    return !!(tabIndex && !isNaN(parseInt(tabIndex, 10)));
}
/**
 * Returns the parsed tabindex from the element attributes instead of returning the
 * evaluated tabindex from the browsers defaults.
 * @param {?} element
 * @return {?}
 */
function getTabIndexValue(element) {
    if (!hasValidTabIndex(element)) {
        return null;
    }
    // See browser issue in Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
    var /** @type {?} */ tabIndex = parseInt(element.getAttribute('tabindex') || '', 10);
    return isNaN(tabIndex) ? -1 : tabIndex;
}
/**
 * Checks whether the specified element is potentially tabbable on iOS
 * @param {?} element
 * @return {?}
 */
function isPotentiallyTabbableIOS(element) {
    var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
    var /** @type {?} */ inputType = nodeName === 'input' && (/** @type {?} */ (element)).type;
    return inputType === 'text'
        || inputType === 'password'
        || nodeName === 'select'
        || nodeName === 'textarea';
}
/**
 * Gets whether an element is potentially focusable without taking current visible/disabled state
 * into account.
 * @param {?} element
 * @return {?}
 */
function isPotentiallyFocusable(element) {
    // Inputs are potentially focusable *unless* they're type="hidden".
    if (isHiddenInput(element)) {
        return false;
    }
    return isNativeFormElement(element) ||
        isAnchorWithHref(element) ||
        element.hasAttribute('contenteditable') ||
        hasValidTabIndex(element);
}
/**
 * Gets the parent window of a DOM node with regards of being inside of an iframe.
 * @param {?} node
 * @return {?}
 */
function getWindow(node) {
    return node.ownerDocument.defaultView || window;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Class that allows for trapping focus within a DOM element.
 *
 * This class currently uses a relatively simple approach to focus trapping.
 * It assumes that the tab order is the same as DOM order, which is not necessarily true.
 * Things like `tabIndex > 0`, flex `order`, and shadow roots can cause to two to misalign.
 */
var  /**
 * Class that allows for trapping focus within a DOM element.
 *
 * This class currently uses a relatively simple approach to focus trapping.
 * It assumes that the tab order is the same as DOM order, which is not necessarily true.
 * Things like `tabIndex > 0`, flex `order`, and shadow roots can cause to two to misalign.
 */
FocusTrap = /** @class */ (function () {
    function FocusTrap(_element, _checker, _ngZone, _document, deferAnchors) {
        if (deferAnchors === void 0) { deferAnchors = false; }
        this._element = _element;
        this._checker = _checker;
        this._ngZone = _ngZone;
        this._document = _document;
        this._hasAttached = false;
        this._enabled = true;
        if (!deferAnchors) {
            this.attachAnchors();
        }
    }
    Object.defineProperty(FocusTrap.prototype, "enabled", {
        /** Whether the focus trap is active. */
        get: /**
         * Whether the focus trap is active.
         * @return {?}
         */
        function () { return this._enabled; },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            this._enabled = val;
            if (this._startAnchor && this._endAnchor) {
                this._startAnchor.tabIndex = this._endAnchor.tabIndex = this._enabled ? 0 : -1;
            }
        },
        enumerable: true,
        configurable: true
    });
    /** Destroys the focus trap by cleaning up the anchors. */
    /**
     * Destroys the focus trap by cleaning up the anchors.
     * @return {?}
     */
    FocusTrap.prototype.destroy = /**
     * Destroys the focus trap by cleaning up the anchors.
     * @return {?}
     */
    function () {
        if (this._startAnchor && this._startAnchor.parentNode) {
            this._startAnchor.parentNode.removeChild(this._startAnchor);
        }
        if (this._endAnchor && this._endAnchor.parentNode) {
            this._endAnchor.parentNode.removeChild(this._endAnchor);
        }
        this._startAnchor = this._endAnchor = null;
    };
    /**
     * Inserts the anchors into the DOM. This is usually done automatically
     * in the constructor, but can be deferred for cases like directives with `*ngIf`.
     * @returns Whether the focus trap managed to attach successfuly. This may not be the case
     * if the target element isn't currently in the DOM.
     */
    /**
     * Inserts the anchors into the DOM. This is usually done automatically
     * in the constructor, but can be deferred for cases like directives with `*ngIf`.
     * @return {?} Whether the focus trap managed to attach successfuly. This may not be the case
     * if the target element isn't currently in the DOM.
     */
    FocusTrap.prototype.attachAnchors = /**
     * Inserts the anchors into the DOM. This is usually done automatically
     * in the constructor, but can be deferred for cases like directives with `*ngIf`.
     * @return {?} Whether the focus trap managed to attach successfuly. This may not be the case
     * if the target element isn't currently in the DOM.
     */
    function () {
        var _this = this;
        // If we're not on the browser, there can be no focus to trap.
        if (this._hasAttached) {
            return true;
        }
        this._ngZone.runOutsideAngular(function () {
            if (!_this._startAnchor) {
                _this._startAnchor = _this._createAnchor(); /** @type {?} */
                ((_this._startAnchor)).addEventListener('focus', function () { return _this.focusLastTabbableElement(); });
            }
            if (!_this._endAnchor) {
                _this._endAnchor = _this._createAnchor(); /** @type {?} */
                ((_this._endAnchor)).addEventListener('focus', function () { return _this.focusFirstTabbableElement(); });
            }
        });
        if (this._element.parentNode) {
            this._element.parentNode.insertBefore(/** @type {?} */ ((this._startAnchor)), this._element);
            this._element.parentNode.insertBefore(/** @type {?} */ ((this._endAnchor)), this._element.nextSibling);
            this._hasAttached = true;
        }
        return this._hasAttached;
    };
    /**
     * Waits for the zone to stabilize, then either focuses the first element that the
     * user specified, or the first tabbable element.
     * @returns Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    /**
     * Waits for the zone to stabilize, then either focuses the first element that the
     * user specified, or the first tabbable element.
     * @return {?} Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    FocusTrap.prototype.focusInitialElementWhenReady = /**
     * Waits for the zone to stabilize, then either focuses the first element that the
     * user specified, or the first tabbable element.
     * @return {?} Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this._executeOnStable(function () { return resolve(_this.focusInitialElement()); });
        });
    };
    /**
     * Waits for the zone to stabilize, then focuses
     * the first tabbable element within the focus trap region.
     * @returns Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    /**
     * Waits for the zone to stabilize, then focuses
     * the first tabbable element within the focus trap region.
     * @return {?} Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    FocusTrap.prototype.focusFirstTabbableElementWhenReady = /**
     * Waits for the zone to stabilize, then focuses
     * the first tabbable element within the focus trap region.
     * @return {?} Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this._executeOnStable(function () { return resolve(_this.focusFirstTabbableElement()); });
        });
    };
    /**
     * Waits for the zone to stabilize, then focuses
     * the last tabbable element within the focus trap region.
     * @returns Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    /**
     * Waits for the zone to stabilize, then focuses
     * the last tabbable element within the focus trap region.
     * @return {?} Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    FocusTrap.prototype.focusLastTabbableElementWhenReady = /**
     * Waits for the zone to stabilize, then focuses
     * the last tabbable element within the focus trap region.
     * @return {?} Returns a promise that resolves with a boolean, depending
     * on whether focus was moved successfuly.
     */
    function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this._executeOnStable(function () { return resolve(_this.focusLastTabbableElement()); });
        });
    };
    /**
     * Get the specified boundary element of the trapped region.
     * @param {?} bound The boundary to get (start or end of trapped region).
     * @return {?} The boundary element.
     */
    FocusTrap.prototype._getRegionBoundary = /**
     * Get the specified boundary element of the trapped region.
     * @param {?} bound The boundary to get (start or end of trapped region).
     * @return {?} The boundary element.
     */
    function (bound) {
        // Contains the deprecated version of selector, for temporary backwards comparability.
        var /** @type {?} */ markers = /** @type {?} */ (this._element.querySelectorAll("[cdk-focus-region-" + bound + "], " +
            ("[cdkFocusRegion" + bound + "], ") +
            ("[cdk-focus-" + bound + "]")));
        for (var /** @type {?} */ i = 0; i < markers.length; i++) {
            // @breaking-change 7.0.0
            if (markers[i].hasAttribute("cdk-focus-" + bound)) {
                console.warn("Found use of deprecated attribute 'cdk-focus-" + bound + "', " +
                    ("use 'cdkFocusRegion" + bound + "' instead. The deprecated ") +
                    "attribute will be removed in 7.0.0.", markers[i]);
            }
            else if (markers[i].hasAttribute("cdk-focus-region-" + bound)) {
                console.warn("Found use of deprecated attribute 'cdk-focus-region-" + bound + "', " +
                    ("use 'cdkFocusRegion" + bound + "' instead. The deprecated attribute ") +
                    "will be removed in 7.0.0.", markers[i]);
            }
        }
        if (bound == 'start') {
            return markers.length ? markers[0] : this._getFirstTabbableElement(this._element);
        }
        return markers.length ?
            markers[markers.length - 1] : this._getLastTabbableElement(this._element);
    };
    /**
     * Focuses the element that should be focused when the focus trap is initialized.
     * @returns Whether focus was moved successfuly.
     */
    /**
     * Focuses the element that should be focused when the focus trap is initialized.
     * @return {?} Whether focus was moved successfuly.
     */
    FocusTrap.prototype.focusInitialElement = /**
     * Focuses the element that should be focused when the focus trap is initialized.
     * @return {?} Whether focus was moved successfuly.
     */
    function () {
        // Contains the deprecated version of selector, for temporary backwards comparability.
        var /** @type {?} */ redirectToElement = /** @type {?} */ (this._element.querySelector("[cdk-focus-initial], " +
            "[cdkFocusInitial]"));
        if (redirectToElement) {
            // @breaking-change 7.0.0
            if (redirectToElement.hasAttribute("cdk-focus-initial")) {
                console.warn("Found use of deprecated attribute 'cdk-focus-initial', " +
                    "use 'cdkFocusInitial' instead. The deprecated attribute " +
                    "will be removed in 7.0.0", redirectToElement);
            }
            redirectToElement.focus();
            return true;
        }
        return this.focusFirstTabbableElement();
    };
    /**
     * Focuses the first tabbable element within the focus trap region.
     * @returns Whether focus was moved successfuly.
     */
    /**
     * Focuses the first tabbable element within the focus trap region.
     * @return {?} Whether focus was moved successfuly.
     */
    FocusTrap.prototype.focusFirstTabbableElement = /**
     * Focuses the first tabbable element within the focus trap region.
     * @return {?} Whether focus was moved successfuly.
     */
    function () {
        var /** @type {?} */ redirectToElement = this._getRegionBoundary('start');
        if (redirectToElement) {
            redirectToElement.focus();
        }
        return !!redirectToElement;
    };
    /**
     * Focuses the last tabbable element within the focus trap region.
     * @returns Whether focus was moved successfuly.
     */
    /**
     * Focuses the last tabbable element within the focus trap region.
     * @return {?} Whether focus was moved successfuly.
     */
    FocusTrap.prototype.focusLastTabbableElement = /**
     * Focuses the last tabbable element within the focus trap region.
     * @return {?} Whether focus was moved successfuly.
     */
    function () {
        var /** @type {?} */ redirectToElement = this._getRegionBoundary('end');
        if (redirectToElement) {
            redirectToElement.focus();
        }
        return !!redirectToElement;
    };
    /**
     * Checks whether the focus trap has successfuly been attached.
     */
    /**
     * Checks whether the focus trap has successfuly been attached.
     * @return {?}
     */
    FocusTrap.prototype.hasAttached = /**
     * Checks whether the focus trap has successfuly been attached.
     * @return {?}
     */
    function () {
        return this._hasAttached;
    };
    /**
     * Get the first tabbable element from a DOM subtree (inclusive).
     * @param {?} root
     * @return {?}
     */
    FocusTrap.prototype._getFirstTabbableElement = /**
     * Get the first tabbable element from a DOM subtree (inclusive).
     * @param {?} root
     * @return {?}
     */
    function (root) {
        if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
            return root;
        }
        // Iterate in DOM order. Note that IE doesn't have `children` for SVG so we fall
        // back to `childNodes` which includes text nodes, comments etc.
        var /** @type {?} */ children = root.children || root.childNodes;
        for (var /** @type {?} */ i = 0; i < children.length; i++) {
            var /** @type {?} */ tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ?
                this._getFirstTabbableElement(/** @type {?} */ (children[i])) :
                null;
            if (tabbableChild) {
                return tabbableChild;
            }
        }
        return null;
    };
    /**
     * Get the last tabbable element from a DOM subtree (inclusive).
     * @param {?} root
     * @return {?}
     */
    FocusTrap.prototype._getLastTabbableElement = /**
     * Get the last tabbable element from a DOM subtree (inclusive).
     * @param {?} root
     * @return {?}
     */
    function (root) {
        if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
            return root;
        }
        // Iterate in reverse DOM order.
        var /** @type {?} */ children = root.children || root.childNodes;
        for (var /** @type {?} */ i = children.length - 1; i >= 0; i--) {
            var /** @type {?} */ tabbableChild = children[i].nodeType === this._document.ELEMENT_NODE ?
                this._getLastTabbableElement(/** @type {?} */ (children[i])) :
                null;
            if (tabbableChild) {
                return tabbableChild;
            }
        }
        return null;
    };
    /**
     * Creates an anchor element.
     * @return {?}
     */
    FocusTrap.prototype._createAnchor = /**
     * Creates an anchor element.
     * @return {?}
     */
    function () {
        var /** @type {?} */ anchor = this._document.createElement('div');
        anchor.tabIndex = this._enabled ? 0 : -1;
        anchor.classList.add('cdk-visually-hidden');
        anchor.classList.add('cdk-focus-trap-anchor');
        return anchor;
    };
    /**
     * Executes a function when the zone is stable.
     * @param {?} fn
     * @return {?}
     */
    FocusTrap.prototype._executeOnStable = /**
     * Executes a function when the zone is stable.
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        if (this._ngZone.isStable) {
            fn();
        }
        else {
            this._ngZone.onStable.asObservable().pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["take"])(1)).subscribe(fn);
        }
    };
    return FocusTrap;
}());
/**
 * Factory that allows easy instantiation of focus traps.
 */
var FocusTrapFactory = /** @class */ (function () {
    function FocusTrapFactory(_checker, _ngZone, _document) {
        this._checker = _checker;
        this._ngZone = _ngZone;
        this._document = _document;
    }
    /**
     * Creates a focus-trapped region around the given element.
     * @param element The element around which focus will be trapped.
     * @param deferCaptureElements Defers the creation of focus-capturing elements to be done
     *     manually by the user.
     * @returns The created focus trap instance.
     */
    /**
     * Creates a focus-trapped region around the given element.
     * @param {?} element The element around which focus will be trapped.
     * @param {?=} deferCaptureElements Defers the creation of focus-capturing elements to be done
     *     manually by the user.
     * @return {?} The created focus trap instance.
     */
    FocusTrapFactory.prototype.create = /**
     * Creates a focus-trapped region around the given element.
     * @param {?} element The element around which focus will be trapped.
     * @param {?=} deferCaptureElements Defers the creation of focus-capturing elements to be done
     *     manually by the user.
     * @return {?} The created focus trap instance.
     */
    function (element, deferCaptureElements) {
        if (deferCaptureElements === void 0) { deferCaptureElements = false; }
        return new FocusTrap(element, this._checker, this._ngZone, this._document, deferCaptureElements);
    };
    FocusTrapFactory.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */
    FocusTrapFactory.ctorParameters = function () { return [
        { type: InteractivityChecker, },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"],] },] },
    ]; };
    /** @nocollapse */ FocusTrapFactory.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function FocusTrapFactory_Factory() { return new FocusTrapFactory(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(InteractivityChecker), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"])); }, token: FocusTrapFactory, providedIn: "root" });
    return FocusTrapFactory;
}());
/**
 * Directive for trapping focus within a region.
 */
var CdkTrapFocus = /** @class */ (function () {
    function CdkTrapFocus(_elementRef, _focusTrapFactory, _document) {
        this._elementRef = _elementRef;
        this._focusTrapFactory = _focusTrapFactory;
        /**
         * Previously focused element to restore focus to upon destroy when using autoCapture.
         */
        this._previouslyFocusedElement = null;
        this._document = _document;
        this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
    }
    Object.defineProperty(CdkTrapFocus.prototype, "enabled", {
        get: /**
         * Whether the focus trap is active.
         * @return {?}
         */
        function () { return this.focusTrap.enabled; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) { this.focusTrap.enabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__angular_cdk_coercion__["a" /* coerceBooleanProperty */])(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkTrapFocus.prototype, "autoCapture", {
        get: /**
         * Whether the directive should automatially move focus into the trapped region upon
         * initialization and return focus to the previous activeElement upon destruction.
         * @return {?}
         */
        function () { return this._autoCapture; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) { this._autoCapture = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__angular_cdk_coercion__["a" /* coerceBooleanProperty */])(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkTrapFocus.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.focusTrap.destroy();
        // If we stored a previously focused element when using autoCapture, return focus to that
        // element now that the trapped region is being destroyed.
        if (this._previouslyFocusedElement) {
            this._previouslyFocusedElement.focus();
            this._previouslyFocusedElement = null;
        }
    };
    /**
     * @return {?}
     */
    CdkTrapFocus.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this.focusTrap.attachAnchors();
        if (this.autoCapture) {
            this._previouslyFocusedElement = /** @type {?} */ (this._document.activeElement);
            this.focusTrap.focusInitialElementWhenReady();
        }
    };
    /**
     * @return {?}
     */
    CdkTrapFocus.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        if (!this.focusTrap.hasAttached()) {
            this.focusTrap.attachAnchors();
        }
    };
    CdkTrapFocus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[cdkTrapFocus]',
                    exportAs: 'cdkTrapFocus',
                },] },
    ];
    /** @nocollapse */
    CdkTrapFocus.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: FocusTrapFactory, },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"],] },] },
    ]; };
    CdkTrapFocus.propDecorators = {
        "enabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['cdkTrapFocus',] },],
        "autoCapture": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['cdkTrapFocusAutoCapture',] },],
    };
    return CdkTrapFocus;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
// The token for the live announcer element is defined in a separate file from LiveAnnouncer
// as a workaround for https://github.com/angular/angular/issues/22559
var /** @type {?} */ LIVE_ANNOUNCER_ELEMENT_TOKEN = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('liveAnnouncerElement', {
    providedIn: 'root',
    factory: LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY,
});
/**
 * \@docs-private
 * @return {?}
 */
function LIVE_ANNOUNCER_ELEMENT_TOKEN_FACTORY() {
    return null;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var LiveAnnouncer = /** @class */ (function () {
    function LiveAnnouncer(elementToken, _document) {
        // We inject the live element and document as `any` because the constructor signature cannot
        // reference browser globals (HTMLElement, Document) on non-browser environments, since having
        // a class decorator causes TypeScript to preserve the constructor signature types.
        this._document = _document;
        this._liveElement = elementToken || this._createLiveElement();
    }
    /**
     * Announces a message to screenreaders.
     * @param message Message to be announced to the screenreader
     * @param politeness The politeness of the announcer element
     * @returns Promise that will be resolved when the message is added to the DOM.
     */
    /**
     * Announces a message to screenreaders.
     * @param {?} message Message to be announced to the screenreader
     * @param {?=} politeness The politeness of the announcer element
     * @return {?} Promise that will be resolved when the message is added to the DOM.
     */
    LiveAnnouncer.prototype.announce = /**
     * Announces a message to screenreaders.
     * @param {?} message Message to be announced to the screenreader
     * @param {?=} politeness The politeness of the announcer element
     * @return {?} Promise that will be resolved when the message is added to the DOM.
     */
    function (message, politeness) {
        var _this = this;
        if (politeness === void 0) { politeness = 'polite'; }
        this._liveElement.textContent = '';
        // TODO: ensure changing the politeness works on all environments we support.
        this._liveElement.setAttribute('aria-live', politeness);
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        return new Promise(function (resolve) {
            setTimeout(function () {
                _this._liveElement.textContent = message;
                resolve();
            }, 100);
        });
    };
    /**
     * @return {?}
     */
    LiveAnnouncer.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._liveElement && this._liveElement.parentNode) {
            this._liveElement.parentNode.removeChild(this._liveElement);
        }
    };
    /**
     * @return {?}
     */
    LiveAnnouncer.prototype._createLiveElement = /**
     * @return {?}
     */
    function () {
        var /** @type {?} */ elementClass = 'cdk-live-announcer-element';
        var /** @type {?} */ previousElements = this._document.getElementsByClassName(elementClass);
        // Remove any old containers. This can happen when coming in from a server-side-rendered page.
        for (var /** @type {?} */ i = 0; i < previousElements.length; i++) {
            /** @type {?} */ ((previousElements[i].parentNode)).removeChild(previousElements[i]);
        }
        var /** @type {?} */ liveEl = this._document.createElement('div');
        liveEl.classList.add(elementClass);
        liveEl.classList.add('cdk-visually-hidden');
        liveEl.setAttribute('aria-atomic', 'true');
        liveEl.setAttribute('aria-live', 'polite');
        this._document.body.appendChild(liveEl);
        return liveEl;
    };
    LiveAnnouncer.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */
    LiveAnnouncer.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [LIVE_ANNOUNCER_ELEMENT_TOKEN,] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"],] },] },
    ]; };
    /** @nocollapse */ LiveAnnouncer.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function LiveAnnouncer_Factory() { return new LiveAnnouncer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(LIVE_ANNOUNCER_ELEMENT_TOKEN, 8), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"])); }, token: LiveAnnouncer, providedIn: "root" });
    return LiveAnnouncer;
}());
/**
 * A directive that works similarly to aria-live, but uses the LiveAnnouncer to ensure compatibility
 * with a wider range of browsers and screen readers.
 */
var CdkAriaLive = /** @class */ (function () {
    function CdkAriaLive(_elementRef, _liveAnnouncer, _contentObserver, _ngZone) {
        this._elementRef = _elementRef;
        this._liveAnnouncer = _liveAnnouncer;
        this._contentObserver = _contentObserver;
        this._ngZone = _ngZone;
        this._politeness = 'off';
    }
    Object.defineProperty(CdkAriaLive.prototype, "politeness", {
        get: /**
         * The aria-live politeness level to use when announcing messages.
         * @return {?}
         */
        function () { return this._politeness; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var _this = this;
            this._politeness = value === 'polite' || value === 'assertive' ? value : 'off';
            if (this._politeness === 'off') {
                if (this._subscription) {
                    this._subscription.unsubscribe();
                    this._subscription = null;
                }
            }
            else if (!this._subscription) {
                this._subscription = this._ngZone.runOutsideAngular(function () {
                    return _this._contentObserver
                        .observe(_this._elementRef)
                        .subscribe(function () {
                        // Note that we use textContent here, rather than innerText, in order to avoid a reflow.
                        var /** @type {?} */ element = _this._elementRef.nativeElement;
                        _this._liveAnnouncer.announce(element.textContent, _this._politeness);
                    });
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkAriaLive.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
    };
    CdkAriaLive.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[cdkAriaLive]',
                    exportAs: 'cdkAriaLive',
                },] },
    ];
    /** @nocollapse */
    CdkAriaLive.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: LiveAnnouncer, },
        { type: __WEBPACK_IMPORTED_MODULE_8__angular_cdk_observers__["a" /* ContentObserver */], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
    ]; };
    CdkAriaLive.propDecorators = {
        "politeness": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['cdkAriaLive',] },],
    };
    return CdkAriaLive;
}());
/**
 * \@docs-private \@deprecated \@breaking-change 7.0.0
 * @param {?} parentDispatcher
 * @param {?} liveElement
 * @param {?} _document
 * @return {?}
 */
function LIVE_ANNOUNCER_PROVIDER_FACTORY(parentDispatcher, liveElement, _document) {
    return parentDispatcher || new LiveAnnouncer(liveElement, _document);
}
/**
 * \@docs-private \@deprecated \@breaking-change 7.0.0
 */
var /** @type {?} */ LIVE_ANNOUNCER_PROVIDER = {
    // If there is already a LiveAnnouncer available, use that. Otherwise, provide a new one.
    provide: LiveAnnouncer,
    deps: [
        [new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"](), LiveAnnouncer],
        [new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"](LIVE_ANNOUNCER_ELEMENT_TOKEN)],
        __WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"],
    ],
    useFactory: LIVE_ANNOUNCER_PROVIDER_FACTORY
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
// This is the value used by AngularJS Material. Through trial and error (on iPhone 6S) they found
// that a value of around 650ms seems appropriate.
var /** @type {?} */ TOUCH_BUFFER_MS = 650;
/**
 * Monitors mouse and keyboard events to determine the cause of focus events.
 */
var FocusMonitor = /** @class */ (function () {
    function FocusMonitor(_ngZone, _platform) {
        this._ngZone = _ngZone;
        this._platform = _platform;
        /**
         * The focus origin that the next focus event is a result of.
         */
        this._origin = null;
        /**
         * Whether the window has just been focused.
         */
        this._windowFocused = false;
        /**
         * Map of elements being monitored to their info.
         */
        this._elementInfo = new Map();
        /**
         * A map of global objects to lists of current listeners.
         */
        this._unregisterGlobalListeners = function () { };
        /**
         * The number of elements currently being monitored.
         */
        this._monitoredElementCount = 0;
    }
    /**
     * Monitors focus on an element and applies appropriate CSS classes.
     * @param element The element to monitor
     * @param checkChildren Whether to count the element as focused when its children are focused.
     * @returns An observable that emits when the focus state of the element changes.
     *     When the element is blurred, null will be emitted.
     */
    /**
     * Monitors focus on an element and applies appropriate CSS classes.
     * @param {?} element The element to monitor
     * @param {?=} checkChildren Whether to count the element as focused when its children are focused.
     * @return {?} An observable that emits when the focus state of the element changes.
     *     When the element is blurred, null will be emitted.
     */
    FocusMonitor.prototype.monitor = /**
     * Monitors focus on an element and applies appropriate CSS classes.
     * @param {?} element The element to monitor
     * @param {?=} checkChildren Whether to count the element as focused when its children are focused.
     * @return {?} An observable that emits when the focus state of the element changes.
     *     When the element is blurred, null will be emitted.
     */
    function (element, checkChildren) {
        var _this = this;
        if (checkChildren === void 0) { checkChildren = false; }
        // Do nothing if we're not on the browser platform.
        if (!this._platform.isBrowser) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs__["of"])(null);
        }
        // Check if we're already monitoring this element.
        if (this._elementInfo.has(element)) {
            var /** @type {?} */ cachedInfo = this._elementInfo.get(element); /** @type {?} */
            ((cachedInfo)).checkChildren = checkChildren;
            return /** @type {?} */ ((cachedInfo)).subject.asObservable();
        }
        // Create monitored element info.
        var /** @type {?} */ info = {
            unlisten: function () { },
            checkChildren: checkChildren,
            subject: new __WEBPACK_IMPORTED_MODULE_2_rxjs__["Subject"]()
        };
        this._elementInfo.set(element, info);
        this._incrementMonitoredElementCount();
        // Start listening. We need to listen in capture phase since focus events don't bubble.
        var /** @type {?} */ focusListener = function (event) { return _this._onFocus(event, element); };
        var /** @type {?} */ blurListener = function (event) { return _this._onBlur(event, element); };
        this._ngZone.runOutsideAngular(function () {
            element.addEventListener('focus', focusListener, true);
            element.addEventListener('blur', blurListener, true);
        });
        // Create an unlisten function for later.
        info.unlisten = function () {
            element.removeEventListener('focus', focusListener, true);
            element.removeEventListener('blur', blurListener, true);
        };
        return info.subject.asObservable();
    };
    /**
     * Stops monitoring an element and removes all focus classes.
     * @param element The element to stop monitoring.
     */
    /**
     * Stops monitoring an element and removes all focus classes.
     * @param {?} element The element to stop monitoring.
     * @return {?}
     */
    FocusMonitor.prototype.stopMonitoring = /**
     * Stops monitoring an element and removes all focus classes.
     * @param {?} element The element to stop monitoring.
     * @return {?}
     */
    function (element) {
        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
        if (elementInfo) {
            elementInfo.unlisten();
            elementInfo.subject.complete();
            this._setClasses(element);
            this._elementInfo.delete(element);
            this._decrementMonitoredElementCount();
        }
    };
    /**
     * Focuses the element via the specified focus origin.
     * @param element Element to focus.
     * @param origin Focus origin.
     * @param options Options that can be used to configure the focus behavior.
     */
    /**
     * Focuses the element via the specified focus origin.
     * @param {?} element Element to focus.
     * @param {?} origin Focus origin.
     * @param {?=} options Options that can be used to configure the focus behavior.
     * @return {?}
     */
    FocusMonitor.prototype.focusVia = /**
     * Focuses the element via the specified focus origin.
     * @param {?} element Element to focus.
     * @param {?} origin Focus origin.
     * @param {?=} options Options that can be used to configure the focus behavior.
     * @return {?}
     */
    function (element, origin, options) {
        this._setOriginForCurrentEventQueue(origin);
        // `focus` isn't available on the server
        if (typeof element.focus === 'function') {
            // Cast the element to `any`, because the TS typings don't have the `options` parameter yet.
            (/** @type {?} */ (element)).focus(options);
        }
    };
    /**
     * @return {?}
     */
    FocusMonitor.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this._elementInfo.forEach(function (_info, element) { return _this.stopMonitoring(element); });
    };
    /**
     * Register necessary event listeners on the document and window.
     * @return {?}
     */
    FocusMonitor.prototype._registerGlobalListeners = /**
     * Register necessary event listeners on the document and window.
     * @return {?}
     */
    function () {
        var _this = this;
        // Do nothing if we're not on the browser platform.
        if (!this._platform.isBrowser) {
            return;
        }
        // On keydown record the origin and clear any touch event that may be in progress.
        var /** @type {?} */ documentKeydownListener = function () {
            _this._lastTouchTarget = null;
            _this._setOriginForCurrentEventQueue('keyboard');
        };
        // On mousedown record the origin only if there is not touch target, since a mousedown can
        // happen as a result of a touch event.
        var /** @type {?} */ documentMousedownListener = function () {
            if (!_this._lastTouchTarget) {
                _this._setOriginForCurrentEventQueue('mouse');
            }
        };
        // When the touchstart event fires the focus event is not yet in the event queue. This means
        // we can't rely on the trick used above (setting timeout of 1ms). Instead we wait 650ms to
        // see if a focus happens.
        var /** @type {?} */ documentTouchstartListener = function (event) {
            if (_this._touchTimeoutId != null) {
                clearTimeout(_this._touchTimeoutId);
            }
            _this._lastTouchTarget = event.target;
            _this._touchTimeoutId = setTimeout(function () { return _this._lastTouchTarget = null; }, TOUCH_BUFFER_MS);
        };
        // Make a note of when the window regains focus, so we can restore the origin info for the
        // focused element.
        var /** @type {?} */ windowFocusListener = function () {
            _this._windowFocused = true;
            _this._windowFocusTimeoutId = setTimeout(function () { return _this._windowFocused = false; });
        };
        // Note: we listen to events in the capture phase so we can detect them even if the user stops
        // propagation.
        this._ngZone.runOutsideAngular(function () {
            document.addEventListener('keydown', documentKeydownListener, true);
            document.addEventListener('mousedown', documentMousedownListener, true);
            document.addEventListener('touchstart', documentTouchstartListener, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__["b" /* supportsPassiveEventListeners */])() ? (/** @type {?} */ ({ passive: true, capture: true })) : true);
            window.addEventListener('focus', windowFocusListener);
        });
        this._unregisterGlobalListeners = function () {
            document.removeEventListener('keydown', documentKeydownListener, true);
            document.removeEventListener('mousedown', documentMousedownListener, true);
            document.removeEventListener('touchstart', documentTouchstartListener, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__["b" /* supportsPassiveEventListeners */])() ? (/** @type {?} */ ({ passive: true, capture: true })) : true);
            window.removeEventListener('focus', windowFocusListener);
            // Clear timeouts for all potentially pending timeouts to prevent the leaks.
            clearTimeout(_this._windowFocusTimeoutId);
            clearTimeout(_this._touchTimeoutId);
            clearTimeout(_this._originTimeoutId);
        };
    };
    /**
     * @param {?} element
     * @param {?} className
     * @param {?} shouldSet
     * @return {?}
     */
    FocusMonitor.prototype._toggleClass = /**
     * @param {?} element
     * @param {?} className
     * @param {?} shouldSet
     * @return {?}
     */
    function (element, className, shouldSet) {
        if (shouldSet) {
            element.classList.add(className);
        }
        else {
            element.classList.remove(className);
        }
    };
    /**
     * Sets the focus classes on the element based on the given focus origin.
     * @param {?} element The element to update the classes on.
     * @param {?=} origin The focus origin.
     * @return {?}
     */
    FocusMonitor.prototype._setClasses = /**
     * Sets the focus classes on the element based on the given focus origin.
     * @param {?} element The element to update the classes on.
     * @param {?=} origin The focus origin.
     * @return {?}
     */
    function (element, origin) {
        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
        if (elementInfo) {
            this._toggleClass(element, 'cdk-focused', !!origin);
            this._toggleClass(element, 'cdk-touch-focused', origin === 'touch');
            this._toggleClass(element, 'cdk-keyboard-focused', origin === 'keyboard');
            this._toggleClass(element, 'cdk-mouse-focused', origin === 'mouse');
            this._toggleClass(element, 'cdk-program-focused', origin === 'program');
        }
    };
    /**
     * Sets the origin and schedules an async function to clear it at the end of the event queue.
     * @param {?} origin The origin to set.
     * @return {?}
     */
    FocusMonitor.prototype._setOriginForCurrentEventQueue = /**
     * Sets the origin and schedules an async function to clear it at the end of the event queue.
     * @param {?} origin The origin to set.
     * @return {?}
     */
    function (origin) {
        var _this = this;
        this._ngZone.runOutsideAngular(function () {
            _this._origin = origin;
            // Sometimes the focus origin won't be valid in Firefox because Firefox seems to focus *one*
            // tick after the interaction event fired. To ensure the focus origin is always correct,
            // the focus origin will be determined at the beginning of the next tick.
            // Sometimes the focus origin won't be valid in Firefox because Firefox seems to focus *one*
            // tick after the interaction event fired. To ensure the focus origin is always correct,
            // the focus origin will be determined at the beginning of the next tick.
            _this._originTimeoutId = setTimeout(function () { return _this._origin = null; }, 1);
        });
    };
    /**
     * Checks whether the given focus event was caused by a touchstart event.
     * @param {?} event The focus event to check.
     * @return {?} Whether the event was caused by a touch.
     */
    FocusMonitor.prototype._wasCausedByTouch = /**
     * Checks whether the given focus event was caused by a touchstart event.
     * @param {?} event The focus event to check.
     * @return {?} Whether the event was caused by a touch.
     */
    function (event) {
        // Note(mmalerba): This implementation is not quite perfect, there is a small edge case.
        // Consider the following dom structure:
        //
        // <div #parent tabindex="0" cdkFocusClasses>
        //   <div #child (click)="#parent.focus()"></div>
        // </div>
        //
        // If the user touches the #child element and the #parent is programmatically focused as a
        // result, this code will still consider it to have been caused by the touch event and will
        // apply the cdk-touch-focused class rather than the cdk-program-focused class. This is a
        // relatively small edge-case that can be worked around by using
        // focusVia(parentEl, 'program') to focus the parent element.
        //
        // If we decide that we absolutely must handle this case correctly, we can do so by listening
        // for the first focus event after the touchstart, and then the first blur event after that
        // focus event. When that blur event fires we know that whatever follows is not a result of the
        // touchstart.
        var /** @type {?} */ focusTarget = event.target;
        return this._lastTouchTarget instanceof Node && focusTarget instanceof Node &&
            (focusTarget === this._lastTouchTarget || focusTarget.contains(this._lastTouchTarget));
    };
    /**
     * Handles focus events on a registered element.
     * @param {?} event The focus event.
     * @param {?} element The monitored element.
     * @return {?}
     */
    FocusMonitor.prototype._onFocus = /**
     * Handles focus events on a registered element.
     * @param {?} event The focus event.
     * @param {?} element The monitored element.
     * @return {?}
     */
    function (event, element) {
        // NOTE(mmalerba): We currently set the classes based on the focus origin of the most recent
        // focus event affecting the monitored element. If we want to use the origin of the first event
        // instead we should check for the cdk-focused class here and return if the element already has
        // it. (This only matters for elements that have includesChildren = true).
        // If we are not counting child-element-focus as focused, make sure that the event target is the
        // monitored element itself.
        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
        if (!elementInfo || (!elementInfo.checkChildren && element !== event.target)) {
            return;
        }
        // If we couldn't detect a cause for the focus event, it's due to one of three reasons:
        // 1) The window has just regained focus, in which case we want to restore the focused state of
        //    the element from before the window blurred.
        // 2) It was caused by a touch event, in which case we mark the origin as 'touch'.
        // 3) The element was programmatically focused, in which case we should mark the origin as
        //    'program'.
        var /** @type {?} */ origin = this._origin;
        if (!origin) {
            if (this._windowFocused && this._lastFocusOrigin) {
                origin = this._lastFocusOrigin;
            }
            else if (this._wasCausedByTouch(event)) {
                origin = 'touch';
            }
            else {
                origin = 'program';
            }
        }
        this._setClasses(element, origin);
        this._emitOrigin(elementInfo.subject, origin);
        this._lastFocusOrigin = origin;
    };
    /**
     * Handles blur events on a registered element.
     * @param event The blur event.
     * @param element The monitored element.
     */
    /**
     * Handles blur events on a registered element.
     * @param {?} event The blur event.
     * @param {?} element The monitored element.
     * @return {?}
     */
    FocusMonitor.prototype._onBlur = /**
     * Handles blur events on a registered element.
     * @param {?} event The blur event.
     * @param {?} element The monitored element.
     * @return {?}
     */
    function (event, element) {
        // If we are counting child-element-focus as focused, make sure that we aren't just blurring in
        // order to focus another child of the monitored element.
        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
        if (!elementInfo || (elementInfo.checkChildren && event.relatedTarget instanceof Node &&
            element.contains(event.relatedTarget))) {
            return;
        }
        this._setClasses(element);
        this._emitOrigin(elementInfo.subject, null);
    };
    /**
     * @param {?} subject
     * @param {?} origin
     * @return {?}
     */
    FocusMonitor.prototype._emitOrigin = /**
     * @param {?} subject
     * @param {?} origin
     * @return {?}
     */
    function (subject, origin) {
        this._ngZone.run(function () { return subject.next(origin); });
    };
    /**
     * @return {?}
     */
    FocusMonitor.prototype._incrementMonitoredElementCount = /**
     * @return {?}
     */
    function () {
        // Register global listeners when first element is monitored.
        if (++this._monitoredElementCount == 1) {
            this._registerGlobalListeners();
        }
    };
    /**
     * @return {?}
     */
    FocusMonitor.prototype._decrementMonitoredElementCount = /**
     * @return {?}
     */
    function () {
        // Unregister global listeners when last element is unmonitored.
        if (!--this._monitoredElementCount) {
            this._unregisterGlobalListeners();
            this._unregisterGlobalListeners = function () { };
        }
    };
    FocusMonitor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */
    FocusMonitor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
        { type: __WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__["a" /* Platform */], },
    ]; };
    /** @nocollapse */ FocusMonitor.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function FocusMonitor_Factory() { return new FocusMonitor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__["a" /* Platform */])); }, token: FocusMonitor, providedIn: "root" });
    return FocusMonitor;
}());
/**
 * Directive that determines how a particular element was focused (via keyboard, mouse, touch, or
 * programmatically) and adds corresponding classes to the element.
 *
 * There are two variants of this directive:
 * 1) cdkMonitorElementFocus: does not consider an element to be focused if one of its children is
 *    focused.
 * 2) cdkMonitorSubtreeFocus: considers an element focused if it or any of its children are focused.
 */
var CdkMonitorFocus = /** @class */ (function () {
    function CdkMonitorFocus(_elementRef, _focusMonitor) {
        var _this = this;
        this._elementRef = _elementRef;
        this._focusMonitor = _focusMonitor;
        this.cdkFocusChange = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this._monitorSubscription = this._focusMonitor.monitor(this._elementRef.nativeElement, this._elementRef.nativeElement.hasAttribute('cdkMonitorSubtreeFocus'))
            .subscribe(function (origin) { return _this.cdkFocusChange.emit(origin); });
    }
    /**
     * @return {?}
     */
    CdkMonitorFocus.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._focusMonitor.stopMonitoring(this._elementRef.nativeElement);
        this._monitorSubscription.unsubscribe();
    };
    CdkMonitorFocus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]',
                },] },
    ];
    /** @nocollapse */
    CdkMonitorFocus.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: FocusMonitor, },
    ]; };
    CdkMonitorFocus.propDecorators = {
        "cdkFocusChange": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"] },],
    };
    return CdkMonitorFocus;
}());
/**
 * \@docs-private \@deprecated \@breaking-change 7.0.0
 * @param {?} parentDispatcher
 * @param {?} ngZone
 * @param {?} platform
 * @return {?}
 */
function FOCUS_MONITOR_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
    return parentDispatcher || new FocusMonitor(ngZone, platform);
}
/**
 * \@docs-private \@deprecated \@breaking-change 7.0.0
 */
var /** @type {?} */ FOCUS_MONITOR_PROVIDER = {
    // If there is already a FocusMonitor available, use that. Otherwise, provide a new one.
    provide: FocusMonitor,
    deps: [[new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"](), FocusMonitor], __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], __WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__["a" /* Platform */]],
    useFactory: FOCUS_MONITOR_PROVIDER_FACTORY
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * Screenreaders will often fire fake mousedown events when a focusable element
 * is activated using the keyboard. We can typically distinguish between these faked
 * mousedown events and real mousedown events using the "buttons" property. While
 * real mousedowns will indicate the mouse button that was pressed (e.g. "1" for
 * the left mouse button), faked mousedowns will usually set the property value to 0.
 * @param {?} event
 * @return {?}
 */
function isFakeMousedownFromScreenReader(event) {
    return event.buttons === 0;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var A11yModule = /** @class */ (function () {
    function A11yModule() {
    }
    A11yModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_6__angular_cdk_platform__["c" /* PlatformModule */], __WEBPACK_IMPORTED_MODULE_8__angular_cdk_observers__["b" /* ObserversModule */]],
                    declarations: [CdkAriaLive, CdkTrapFocus, CdkMonitorFocus],
                    exports: [CdkAriaLive, CdkTrapFocus, CdkMonitorFocus],
                },] },
    ];
    return A11yModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


//# sourceMappingURL=a11y.es5.js.map


/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dragula_class_1 = __webpack_require__(127);
exports.dragula = dragula_class_1.dragula;
var dragula_directive_1 = __webpack_require__(376);
exports.DragulaDirective = dragula_directive_1.DragulaDirective;
var dragula_provider_1 = __webpack_require__(128);
exports.DragulaService = dragula_provider_1.DragulaService;
var dragular_module_1 = __webpack_require__(761);
exports.DragulaModule = dragular_module_1.DragulaModule;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(965);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(964);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)))

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(1);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var account_service_1 = __webpack_require__(72);
var moment = __webpack_require__(1);
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var http_1 = __webpack_require__(10);
var rxjs_1 = __webpack_require__(12);
var shared_1 = __webpack_require__(4);
var account_model_1 = __webpack_require__(53);
var Register = /** @class */ (function () {
    function Register(http, router, loginService, accountService) {
        this.http = http;
        this.router = router;
        this.loginService = loginService;
        this.accountService = accountService;
        this.newAccountSource = new rxjs_1.BehaviorSubject(new account_model_1.EditableAccount());
    }
    Register.prototype.reset = function () {
        this.newAccountSource.next(new account_model_1.EditableAccount());
    };
    Register.prototype.save = function (account) {
        account.birthDate = this.formatDate(account.birthDate);
        account.notification = account_model_1.NotificationType.EMAIL;
        return this.http.post('/api/register', account);
    };
    Register.prototype.cancel = function () {
        var isFranceConnectUser = this.newAccountSource.getValue().credentials.franceConnectSubscription
            && !this.newAccountSource.getValue().id;
        this.reset();
        if (isFranceConnectUser) {
            this.loginService.fcLogout();
        }
        else {
            this.router.navigate(['/']);
        }
    };
    Register.prototype.injectFCUser = function (account) {
        this.newAccountSource.next(this.accountService.mapAccoutToEditableAccount(account));
    };
    Register.prototype.formatDate = function (date) {
        return date ? moment(date).format('YYYY-MM-DD') : date;
    };
    Register.prototype.newAccountAsObservable = function () {
        return this.newAccountSource.asObservable();
    };
    Register = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            router_1.Router,
            shared_1.LoginService,
            account_service_1.AccountService])
    ], Register);
    return Register;
}());
exports.Register = Register;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng2_file_upload_1 = __webpack_require__(129);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var draft_depot_requete_service_1 = __webpack_require__(16);
var filesConstraints_constants_1 = __webpack_require__(192);
var util_1 = __webpack_require__(28);
var parameters_service_1 = __webpack_require__(25);
var file_uploader_model_1 = __webpack_require__(187);
var error_constants_1 = __webpack_require__(60);
var FileUploaderComponent = /** @class */ (function () {
    function FileUploaderComponent(injector, parametersService) {
        this.injector = injector;
        this.parametersService = parametersService;
        this.file = null;
        this.fileChange = new core_1.EventEmitter();
        this.hasFileOver = false;
        this.acceptMimeType = filesConstraints_constants_1.ALLOWED_MIME_TYPES.join(',');
        this.isUploading = false;
        this.tailleError = false;
        this.formatError = false;
        this.nomFichierError = false;
        this.techniqueError = false;
        this.draftDepotRequeteService = this.injector
            .get(draft_depot_requete_service_1.DraftDepotRequeteService);
    }
    FileUploaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.uploader = new ng2_file_upload_1.FileUploader({ url: this.url, itemAlias: 'file', removeAfterUpload: true });
        this.uploader.onAfterAddingFile = this.onAfterAddingFile.bind(this);
        this.uploader.onBeforeUploadItem = this.onBeforeUploadItem.bind(this);
        this.uploader.onCompleteItem = this.onCompleteItem.bind(this);
        this.uploader.onSuccessItem = this.onSuccessItem.bind(this);
        this.uploader.onErrorItem = this.onErrorItem.bind(this);
        this.parametersService.getParameters().subscribe(function (parameters) { return (_this.maxFileSize = parameters.maxFileSize); });
    };
    FileUploaderComponent.prototype.onSuccessItem = function (item, jsonResponse) {
        var response = JSON.parse(jsonResponse);
        this.isUploading = false;
        this.validationInput.control.setErrors(null);
        this.file = new file_uploader_model_1.FileUploaderModel(item.file, response.fileApiId, response.fileSize);
        this.fileChange.emit(this.file);
    };
    FileUploaderComponent.prototype.onErrorItem = function (_item, response, status) {
        console.log('onErrorItem | response', response);
        this.isUploading = false;
        if (status === 400 && JSON.parse(response).code === filesConstraints_constants_1.MAX_FILE_EXCEEDED_ERROR_CODE) {
            this.validationInput.control.setErrors({ invalid: true, taille: true });
            this.tailleError = true;
        }
        else if (status === 400 && JSON.parse(response).code === filesConstraints_constants_1.FILE_NAME_INVALID_ERROR_CODE) {
            this.validationInput.control.setErrors({ invalid: true, nomFichier: true });
            this.nomFichierError = true;
        }
        else {
            this.validationInput.control.setErrors({ invalid: true, technique: true });
            this.techniqueError = true;
        }
        this.validationInput.control.markAsTouched();
    };
    FileUploaderComponent.prototype.onBeforeUploadItem = function (_fileItem) {
        if (this.url.includes('/api/my-draft-requete')) {
            var newOptions = this.draftDepotRequeteService.addRequestHeaderToUploader(this.uploader.options);
            this.uploader.setOptions(newOptions);
        }
    };
    FileUploaderComponent.prototype.onCompleteItem = function (item, _jsonResponse, _status, headers) {
        if (item.url.includes('/api/my-draft-requete')) {
            this.injector
                .get(draft_depot_requete_service_1.DraftDepotRequeteService)
                .updateVersionWithResponseHeaderFromUploader(headers);
        }
    };
    FileUploaderComponent.prototype.onAfterAddingFile = function (item) {
        var errors = this.validateFile(item);
        this.validationInput.control.markAsUntouched();
        if (Object.keys(errors).length !== 0) {
            this.fileName = item.file.name;
            this.validationInput.control.setErrors(errors);
            this.validationInput.control.markAsTouched();
            this.uploader.removeFromQueue(item);
        }
        else if (!this.isUploading) {
            // Check for isUploading == false to prevent upload of multiple files
            this.validationInput.control.setErrors({ inprogress: true });
            this.uploader.uploadItem(item);
            this.isUploading = true;
        }
    };
    FileUploaderComponent.prototype.validateFile = function (item) {
        var errors = {};
        if (item.file.size > this.maxFileSize) {
            errors['taille'] = true;
            this.tailleError = true;
        }
        if (!item.file.type || filesConstraints_constants_1.ALLOWED_MIME_TYPES.indexOf(item.file.type) === -1) {
            errors['format'] = true;
            this.formatError = true;
        }
        if ((item.file.name.length !== this.countCodePoints(item.file.name))) {
            errors['nomFichier'] = true;
            this.nomFichierError = true;
        }
        return errors;
    };
    // get the code point length to see whether a string contains a non BMP (Basic Multilingual Plane) character.
    FileUploaderComponent.prototype.countCodePoints = function (str) {
        var i = str[Symbol.iterator]();
        var count = 0;
        while (!i.next().done) {
            ++count;
        }
        return count;
    };
    FileUploaderComponent.prototype.isInvalid = function () {
        return !!this.validationInput && this.validationInput.invalid && this.validationInput.touched;
    };
    FileUploaderComponent.prototype.markAsUntouched = function () {
        this.validationInput.control.markAsUntouched();
    };
    FileUploaderComponent.prototype.fileOver = function (event) {
        this.hasFileOver = event;
    };
    FileUploaderComponent.prototype.viewFile = function () {
        var _this = this;
        // If the file is loaded we just open the file but in case the file is not loaded (if it's a draft version) we call FileApi
        if (File.prototype.isPrototypeOf(this.file.fileItem.rawFile)) {
            util_1.saveOrOpenRawFile(this.file.fileItem.rawFile, this.file.fileItem.name);
        }
        else {
            this.draftDepotRequeteService.downloadJustificatif(this.file.fileApiId)
                .subscribe(function (blob) { return util_1.saveOrOpenRawFile(blob, _this.file.fileItem.name); }, function (error) {
                if (error.errorType === error_constants_1.ErrorEnum.TR_FUNCTIONAL_ERROR) {
                    _this.errorTrFonctionnel = true;
                }
            });
        }
    };
    FileUploaderComponent.prototype.deleteFile = function () {
        this.file = undefined;
        this.fileChange.emit(this.file);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], FileUploaderComponent.prototype, "inputName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], FileUploaderComponent.prototype, "label", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], FileUploaderComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FileUploaderComponent.prototype, "required", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FileUploaderComponent.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", file_uploader_model_1.FileUploaderModel)
    ], FileUploaderComponent.prototype, "file", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], FileUploaderComponent.prototype, "url", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], FileUploaderComponent.prototype, "fileChange", void 0);
    __decorate([
        core_1.ViewChild('validationInput'),
        __metadata("design:type", forms_1.NgModel)
    ], FileUploaderComponent.prototype, "validationInput", void 0);
    FileUploaderComponent = __decorate([
        core_1.Component({
            selector: 'jhi-file-uploader',
            template: __webpack_require__(840),
            styles: [__webpack_require__(940)],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        }),
        __metadata("design:paramtypes", [core_1.Injector, parameters_service_1.ParametersService])
    ], FileUploaderComponent);
    return FileUploaderComponent;
}());
exports.FileUploaderComponent = FileUploaderComponent;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NotificationType;
(function (NotificationType) {
    NotificationType["AUCUNE"] = "AUCUNE";
    NotificationType["EMAIL"] = "EMAIL";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
/** IHM - register + update */
var EditableAccount = /** @class */ (function () {
    function EditableAccount() {
        this.credentials = {};
        this.address = {};
        this.contact = {};
        this.notification = NotificationType.EMAIL;
    }
    EditableAccount.prototype.toAccountDTO = function () {
        return Object.assign({}, {
            id: this.id,
            type: this.type,
            civilite: this.civilite,
            firstName: this.firstName,
            lastName: this.lastName,
            birthDate: this.birthDate,
            fonctionEntreprise: this.fonctionEntreprise,
            nomEntreprise: this.nomEntreprise,
            sigleEntreprise: this.sigleEntreprise,
            notification: this.notification,
            captcha: this.captcha,
            address: this.address,
            contact: this.contact
        }, this.credentials);
    };
    return EditableAccount;
}());
exports.EditableAccount = EditableAccount;
var MyInformation = /** @class */ (function () {
    function MyInformation() {
    }
    return MyInformation;
}());
exports.MyInformation = MyInformation;
var UpdateAccountErrorType;
(function (UpdateAccountErrorType) {
    UpdateAccountErrorType["EMAIL_ALREADY_IN_USE"] = "1031";
    UpdateAccountErrorType["WRONG_OLD_PASSWORD"] = "1033";
})(UpdateAccountErrorType = exports.UpdateAccountErrorType || (exports.UpdateAccountErrorType = {}));
var CreateAccountErrorType;
(function (CreateAccountErrorType) {
    CreateAccountErrorType["EMAIL_ALREADY_IN_USE"] = "1031";
    CreateAccountErrorType["INVALID_PASSWORD"] = "1034";
    CreateAccountErrorType["INVALID_NEW_PASSWORD"] = "1035";
})(CreateAccountErrorType = exports.CreateAccountErrorType || (exports.CreateAccountErrorType = {}));
var AccountType;
(function (AccountType) {
    AccountType["PHYSIQUE"] = "PHYSIQUE";
    AccountType["MORALE"] = "MORALE";
})(AccountType = exports.AccountType || (exports.AccountType = {}));


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var depot_requete_model_1 = __webpack_require__(416);
exports.depotRequeteBasePath = 'depot-requete';
exports.PAGE_TITLE_PREFIX = ' | Dépôt d\'une requête';
exports.depotRequeteSteps = [
    new depot_requete_model_1.StepDetail({
        route: 'avertissement',
        breadTitle: 'Avertissement',
        pageTitle: "Avertissement (\u00C9tape 1)" + exports.PAGE_TITLE_PREFIX + app_constants_1.PAGE_TITLE_SUFFIX
    }),
    new depot_requete_model_1.StepDetail({
        route: 'requerants',
        breadTitle: 'Requérant',
        pageTitle: "Requ\u00E9rant (\u00C9tape 2)" + exports.PAGE_TITLE_PREFIX + app_constants_1.PAGE_TITLE_SUFFIX
    }),
    new depot_requete_model_1.StepDetail({
        route: 'juridiction',
        breadTitle: 'Juridiction',
        pageTitle: "Choix de la juridiction (\u00C9tape 3)" + exports.PAGE_TITLE_PREFIX + app_constants_1.PAGE_TITLE_SUFFIX
    }),
    new depot_requete_model_1.StepDetail({
        route: 'requete',
        breadTitle: 'Requête',
        pageTitle: "Requ\u00EAte (\u00C9tape 4)" + exports.PAGE_TITLE_PREFIX + app_constants_1.PAGE_TITLE_SUFFIX
    }),
    new depot_requete_model_1.StepDetail({
        route: 'justificatifs',
        breadTitle: 'Justificatifs',
        pageTitle: "Ajout des justificatifs (\u00C9tape 5)" + exports.PAGE_TITLE_PREFIX + app_constants_1.PAGE_TITLE_SUFFIX
    }),
    new depot_requete_model_1.StepDetail({
        route: 'recapitulatif',
        breadTitle: 'Récapitulatif',
        pageTitle: "R\u00E9capitulatif (\u00C9tape 6)" + exports.PAGE_TITLE_PREFIX + app_constants_1.PAGE_TITLE_SUFFIX
    })
];


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ErrorEnum;
(function (ErrorEnum) {
    ErrorEnum["TR_FUNCTIONAL_ERROR"] = "-1";
    ErrorEnum["TR_TECHNICAL_ERROR"] = "-2";
    ErrorEnum["SECRET_CODE_SYNTAX_ERROR"] = "1001";
    ErrorEnum["SECRET_CODE_SEMANTIC_ERROR"] = "1002";
    ErrorEnum["SECRET_CODE_ALREADY_ATTACHED"] = "1003";
    ErrorEnum["SECRET_CODE_EXPIRED"] = "1004";
    ErrorEnum["INVALID_DRAFT_VERSION"] = "1057";
})(ErrorEnum = exports.ErrorEnum || (exports.ErrorEnum = {}));


/***/ }),
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(47);
var shared_1 = __webpack_require__(4);
var RequeteStatut;
(function (RequeteStatut) {
    RequeteStatut["ENVOYE"] = "Envoy\u00E9";
    RequeteStatut["REFUSE"] = "Refus\u00E9";
    RequeteStatut["RATTACHE"] = "Rattach\u00E9";
    RequeteStatut["EN_ATTENTE_DE_RATTACHEMENT"] = "En attente de rattachement";
    RequeteStatut["DOSSIER_NON_ACCESSIBLE"] = "Dossier non accessible";
    RequeteStatut["AUTRES"] = "-";
})(RequeteStatut = exports.RequeteStatut || (exports.RequeteStatut = {}));
var RequeteCategory;
(function (RequeteCategory) {
    RequeteCategory["REQUERANT_SEUL"] = "REQUERANT_SEUL";
    RequeteCategory["COLLECTIVE"] = "COLLECTIVE";
    RequeteCategory["AVEC_MANDATAIRE"] = "AVEC_MANDATAIRE";
})(RequeteCategory = exports.RequeteCategory || (exports.RequeteCategory = {}));
var PartieDepot = /** @class */ (function () {
    function PartieDepot() {
        this.contact = {};
        this.address = {};
    }
    PartieDepot.prototype.clone = function () {
        var clone = new PartieDepot();
        clone.type = this.type;
        clone.userId = this.userId;
        clone.email = this.email;
        clone.qualite = this.qualite;
        clone.civilite = this.civilite;
        clone.firstName = this.firstName;
        clone.lastName = this.lastName;
        clone.nomEntreprise = this.nomEntreprise;
        clone.sigleEntreprise = this.sigleEntreprise;
        clone.address = Object.assign({}, this.address);
        clone.contact = Object.assign({}, this.contact);
        return clone;
    };
    Object.defineProperty(PartieDepot.prototype, "isAnonymous", {
        get: function () {
            return util_1.isNullOrUndefined(this.userId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PartieDepot.prototype, "isMorale", {
        get: function () {
            return shared_1.AccountType.MORALE === this.type;
        },
        enumerable: true,
        configurable: true
    });
    return PartieDepot;
}());
exports.PartieDepot = PartieDepot;
var SyntheseDossier = /** @class */ (function () {
    function SyntheseDossier() {
    }
    return SyntheseDossier;
}());
exports.SyntheseDossier = SyntheseDossier;
var SensConclusion = /** @class */ (function () {
    function SensConclusion() {
    }
    return SensConclusion;
}());
exports.SensConclusion = SensConclusion;
var RequeteDetail = /** @class */ (function () {
    function RequeteDetail() {
    }
    return RequeteDetail;
}());
exports.RequeteDetail = RequeteDetail;
var RequeteSummary = /** @class */ (function () {
    function RequeteSummary() {
    }
    return RequeteSummary;
}());
exports.RequeteSummary = RequeteSummary;
var QualityType;
(function (QualityType) {
    QualityType["Requerant"] = "R";
    QualityType["IntervenantEnRequete"] = "IR";
    QualityType["Defendeur"] = "D";
    QualityType["IntervenantEnDefense"] = "ID";
    QualityType["Observateur"] = "O";
    QualityType["ExpertMediateur"] = "E";
    QualityType["Sapiteur"] = "S";
    QualityType["Interprete"] = "I";
    QualityType["Temoin"] = "T";
    QualityType["Avocat"] = "A";
    QualityType["Avoue"] = "AE";
    QualityType["Mandataire"] = "M";
    QualityType["Pseudoacteur"] = "P";
})(QualityType = exports.QualityType || (exports.QualityType = {}));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var rxjs_1 = __webpack_require__(12);
var CaptchaService = /** @class */ (function () {
    function CaptchaService(http) {
        this.http = http;
        this.reloadEvents = new rxjs_1.Subject();
    }
    CaptchaService.prototype.getCaptcha = function (isAudioCaptcha) {
        var url = '/api/captcha/';
        var params = {
            'isAudioCaptcha': isAudioCaptcha ? 'true' : 'false'
        };
        return this.http.get(url, {
            params: params,
            responseType: 'blob'
        });
    };
    CaptchaService.prototype.isValid = function (captcha, email) {
        return this.http.post("/api/captcha/valide/" + captcha + "?email=" + email, '', {
            responseType: 'text'
        });
    };
    CaptchaService.prototype.getImageCaptcha = function () {
        var url = '/api/captcha/image/';
        /* let options: BaseRequestOptions = new BaseRequestOptions();
        options.responseType = ResponseContentType.Blob; */
        return this.http.get(url, {
            responseType: 'blob'
        });
    };
    CaptchaService.prototype.reloadCaptcha = function () {
        this.reloadEvents.next();
    };
    CaptchaService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], CaptchaService);
    return CaptchaService;
}());
exports.CaptchaService = CaptchaService;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var AccountData = /** @class */ (function () {
    function AccountData() {
    }
    AccountData.prototype.ngOnInit = function () {
    };
    AccountData = __decorate([
        core_1.Injectable()
    ], AccountData);
    return AccountData;
}());
exports.AccountData = AccountData;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HttpCodeEnum;
(function (HttpCodeEnum) {
    HttpCodeEnum[HttpCodeEnum["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpCodeEnum[HttpCodeEnum["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpCodeEnum[HttpCodeEnum["CONFLICT"] = 409] = "CONFLICT";
})(HttpCodeEnum = exports.HttpCodeEnum || (exports.HttpCodeEnum = {}));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(1);
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var account_model_1 = __webpack_require__(53);
var requete_1 = __webpack_require__(17);
var operators_1 = __webpack_require__(7);
var AccountService = /** @class */ (function () {
    function AccountService(http) {
        this.http = http;
    }
    AccountService.prototype.get = function () {
        var _this = this;
        return this.http.get('/api/account').pipe(operators_1.map(function (account) {
            account.birthDate = _this.formatDate(account.birthDate);
            return account;
        }));
    };
    AccountService.prototype.getRequerant = function (email, firstName, lastName) {
        var _this = this;
        var params = new http_1.HttpParams({
            fromObject: {
                'email': email,
                'firstName': firstName,
                'lastName': lastName
            }
        });
        return this.http.get('/api/account', {
            params: params,
            responseType: 'json'
        }).pipe(operators_1.map(function (account) {
            account.birthDate = _this.formatDate(account.birthDate);
            return account;
        }));
    };
    AccountService.prototype.save = function (account) {
        account.birthDate = this.formatDate(account.birthDate);
        return this.http.put('/api/account', account);
    };
    AccountService.prototype.mapAccountToPartieDepot = function (account) {
        var partieDepot = new requete_1.PartieDepot();
        partieDepot.userId = account.id;
        partieDepot.email = account.email;
        partieDepot.type = account.type;
        partieDepot.firstName = account.firstName;
        partieDepot.lastName = account.lastName;
        partieDepot.civilite = account.civilite;
        partieDepot.nomEntreprise = account.nomEntreprise;
        partieDepot.sigleEntreprise = account.sigleEntreprise;
        partieDepot.contact = Object.assign({}, account.contact);
        partieDepot.address = Object.assign({}, account.address);
        return partieDepot;
    };
    AccountService.prototype.mapAccoutToEditableAccount = function (account) {
        var editableAccount = new account_model_1.EditableAccount();
        editableAccount.id = account.id;
        editableAccount.civilite = account.civilite;
        editableAccount.firstName = account.firstName;
        editableAccount.lastName = account.lastName;
        editableAccount.birthDate = account.birthDate;
        editableAccount.fonctionEntreprise = account.fonctionEntreprise;
        editableAccount.nomEntreprise = account.nomEntreprise;
        editableAccount.sigleEntreprise = account.sigleEntreprise;
        editableAccount.contact = Object.assign({}, account.contact);
        editableAccount.address = Object.assign({}, account.address);
        editableAccount.notification = account.notification;
        editableAccount.credentials.email = account.email;
        editableAccount.credentials.franceConnectSubscription = account.franceConnectSubscription;
        return editableAccount;
    };
    AccountService.prototype.formatDate = function (date) {
        return date ? moment(date).format('YYYY-MM-DD') : date;
    };
    AccountService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], AccountService);
    return AccountService;
}());
exports.AccountService = AccountService;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ngx_webstorage_1 = __webpack_require__(379);
var StateStorageService = /** @class */ (function () {
    function StateStorageService($sessionStorage) {
        this.$sessionStorage = $sessionStorage;
    }
    StateStorageService.prototype.getPreviousState = function () {
        return this.$sessionStorage.retrieve('previousState');
    };
    StateStorageService.prototype.resetPreviousState = function () {
        this.$sessionStorage.clear('previousState');
    };
    StateStorageService.prototype.storePreviousState = function (previousState) {
        if (previousState) {
            this.$sessionStorage.store('previousState', previousState);
        }
    };
    StateStorageService.prototype.getDestinationState = function () {
        return this.$sessionStorage.retrieve('destinationState');
    };
    StateStorageService.prototype.storeDestinationState = function (destinationState) {
        if (destinationState) {
            this.$sessionStorage.store('destinationState', destinationState);
        }
    };
    StateStorageService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [ngx_webstorage_1.SessionStorageService])
    ], StateStorageService);
    return StateStorageService;
}());
exports.StateStorageService = StateStorageService;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var account_service_1 = __webpack_require__(72);
var rxjs_1 = __webpack_require__(12);
var operators_1 = __webpack_require__(7);
var UserService = /** @class */ (function () {
    function UserService(accountService, http) {
        this.accountService = accountService;
        this.http = http;
        this.authenticated = false;
        this.auth2 = new rxjs_1.Subject();
        this.auth2Observable = this.auth2.asObservable();
    }
    UserService.prototype.getAccount = function (force) {
        var _this = this;
        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving unless we want to force the refresh
        if (this.account && !force) {
            return Promise.resolve(this.account);
        }
        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.accountService.get().toPromise().then(function (account) {
            _this.account = account;
            return _this.account;
        }).catch(function (_err) {
            _this.account = null;
            return _this.account;
        });
    };
    UserService.prototype.getIsAuthenticated = function (force) {
        if (this.authenticated !== null && !force) {
            return rxjs_1.of(this.authenticated);
        }
        return this._isAuthenticated();
    };
    UserService.prototype.clearUserState = function () {
        this.account = null;
        this.authenticated = false;
        this.auth2.next(this.authenticated);
    };
    UserService.prototype._isAuthenticated = function () {
        var _this = this;
        return this.http.get('/api/authenticate', { responseType: 'text' }).pipe(operators_1.map(function (response) {
            _this.authenticated = !!response;
            _this.auth2.next(_this.authenticated);
            return _this.authenticated;
        }), operators_1.catchError(function (error) {
            console.error('_isAuthenticated: ', error);
            _this.clearUserState();
            return rxjs_1.of(false);
        }));
    };
    UserService.prototype.subscribeUserClub = function () {
        return this.http.patch("/api/account/user-club/subscribe", null).toPromise();
    };
    UserService.prototype.unsubscribeUserClub = function () {
        return this.http.patch("/api/account/user-club/unsubscribe", null).toPromise();
    };
    UserService.prototype.getIsUserClubMember = function () {
        return this.http.get("/api/account/user-club").toPromise();
    };
    UserService.prototype.isRememberMe = function () {
        return this.http.get('/api/remember-me').toPromise();
    };
    UserService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [account_service_1.AccountService,
            http_1.HttpClient])
    ], UserService);
    return UserService;
}());
exports.UserService = UserService;


/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationBuilder", function() { return AnimationBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationFactory", function() { return AnimationFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTO_STYLE", function() { return AUTO_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animate", function() { return animate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animateChild", function() { return animateChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animation", function() { return animation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "group", function() { return group; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "query", function() { return query; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sequence", function() { return sequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stagger", function() { return stagger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return style; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trigger", function() { return trigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useAnimation", function() { return useAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoopAnimationPlayer", function() { return NoopAnimationPlayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPRE_STYLE", function() { return ɵPRE_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationGroupPlayer", function() { return AnimationGroupPlayer; });
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */

/**
 * An injectable service that produces an animation sequence programmatically within an
 * Angular component or directive.
 * Provided by the `BrowserAnimationsModule` or `NoopAnimationsModule`.
 *
 * @usageNotes
 *
 * To use this service, add it to your component or directive as a dependency.
 * The service is instantiated along with your component.
 *
 * Apps do not typically need to create their own animation players, but if you
 * do need to, follow these steps:
 *
 * 1. Use the `build()` method to create a programmatic animation using the
 * `animate()` function. The method returns an `AnimationFactory` instance.
 *
 * 2. Use the factory object to create an `AnimationPlayer` and attach it to a DOM element.
 *
 * 3. Use the player object to control the animation programmatically.
 *
 * For example:
 *
 * ```ts
 * // import the service from BrowserAnimationsModule
 * import {AnimationBuilder} from '@angular/animations';
 * // require the service as a dependency
 * class MyCmp {
 *   constructor(private _builder: AnimationBuilder) {}
 *
 *   makeAnimation(element: any) {
 *     // first define a reusable animation
 *     const myAnimation = this._builder.build([
 *       style({ width: 0 }),
 *       animate(1000, style({ width: '100px' }))
 *     ]);
 *
 *     // use the returned factory object to create a player
 *     const player = myAnimation.create(element);
 *
 *     player.play();
 *   }
 * }
 * ```
 *
 */
var AnimationBuilder = /** @class */ (function () {
    function AnimationBuilder() {
    }
    return AnimationBuilder;
}());
/**
 * A factory object returned from the `AnimationBuilder`.`build()` method.
 *
 */
var AnimationFactory = /** @class */ (function () {
    function AnimationFactory() {
    }
    return AnimationFactory;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Specifies automatic styling.
 */
var AUTO_STYLE = '*';
/**
 * Creates a named animation trigger, containing a  list of `state()`
 * and `transition()` entries to be evaluated when the expression
 * bound to the trigger changes.
 *
 * @param name An identifying string.
 * @param definitions  An animation definition object, containing an array of `state()`
 * and `transition()` declarations.
 *
 * @return An object that encapsulates the trigger data.
 *
 * @usageNotes
 * Define an animation trigger in the `animations` section of `@Component` metadata.
 * In the template, reference the trigger by name and bind it to a trigger expression that
 * evaluates to a defined animation state, using the following format:
 *
 * `[@triggerName]="expression"`
 *
 * Animation trigger bindings convert all values to strings, and then match the
 * previous and current values against any linked transitions.
 * Booleans can be specified as `1` or `true` and `0` or `false`.
 *
 * ### Usage Example
 *
 * The following example creates an animation trigger reference based on the provided
 * name value.
 * The provided animation value is expected to be an array consisting of state and
 * transition declarations.
 *
 * ```typescript
 * @Component({
 *   selector: "my-component",
 *   templateUrl: "my-component-tpl.html",
 *   animations: [
 *     trigger("myAnimationTrigger", [
 *       state(...),
 *       state(...),
 *       transition(...),
 *       transition(...)
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   myStatusExp = "something";
 * }
 * ```
 *
 * The template associated with this component makes use of the defined trigger
 * by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * ### Using an inline function
 * The `transition` animation method also supports reading an inline function which can decide
 * if its associated animation should be run.
 *
 * ```typescript
 * // this method is run each time the `myAnimationTrigger` trigger value changes.
 * function myInlineMatcherFn(fromState: string, toState: string, element: any, params: {[key:
 string]: any}): boolean {
 *   // notice that `element` and `params` are also available here
 *   return toState == 'yes-please-animate';
 * }
 *
 * @Component({
 *   selector: 'my-component',
 *   templateUrl: 'my-component-tpl.html',
 *   animations: [
 *     trigger('myAnimationTrigger', [
 *       transition(myInlineMatcherFn, [
 *         // the animation sequence code
 *       ]),
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   myStatusExp = "yes-please-animate";
 * }
 * ```
 *
 * ### Disabling Animations
 * When true, the special animation control binding `@.disabled` binding prevents
 * all animations from rendering.
 * Place the  `@.disabled` binding on an element to disable
 * animations on the element itself, as well as any inner animation triggers
 * within the element.
 *
 * The following example shows how to use this feature:
 *
 * ```typescript
 * @Component({
 *   selector: 'my-component',
 *   template: `
 *     <div [@.disabled]="isDisabled">
 *       <div [@childAnimation]="exp"></div>
 *     </div>
 *   `,
 *   animations: [
 *     trigger("childAnimation", [
 *       // ...
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   isDisabled = true;
 *   exp = '...';
 * }
 * ```
 *
 * When `@.disabled` is true, it prevents the `@childAnimation` trigger from animating,
 * along with any inner animations.
 *
 * ### Disable animations application-wide
 * When an area of the template is set to have animations disabled,
 * **all** inner components have their animations disabled as well.
 * This means that you can disable all animations for an app
 * by placing a host binding set on `@.disabled` on the topmost Angular component.
 *
 * ```typescript
 * import {Component, HostBinding} from '@angular/core';
 *
 * @Component({
 *   selector: 'app-component',
 *   templateUrl: 'app.component.html',
 * })
 * class AppComponent {
 *   @HostBinding('@.disabled')
 *   public animationsDisabled = true;
 * }
 * ```
 *
 * ### Overriding disablement of inner animations
 * Despite inner animations being disabled, a parent animation can `query()`
 * for inner elements located in disabled areas of the template and still animate
 * them if needed. This is also the case for when a sub animation is
 * queried by a parent and then later animated using `animateChild()`.
 *
 * ### Detecting when an animation is disabled
 * If a region of the DOM (or the entire application) has its animations disabled, the animation
 * trigger callbacks still fire, but for zero seconds. When the callback fires, it provides
 * an instance of an `AnimationEvent`. If animations are disabled,
 * the `.disabled` flag on the event is true.
 *
 * @experimental Animation support is experimental.
 */
function trigger(name, definitions) {
    return { type: 7 /* Trigger */, name: name, definitions: definitions, options: {} };
}
/**
 * Defines an animation step that combines styling information with timing information.
 *
 * @param timings Sets `AnimateTimings` for the parent animation.
 * A string in the format "duration [delay] [easing]".
 *  - Duration and delay are expressed as a number and optional time unit,
 * such as "1s" or "10ms" for one second and 10 milliseconds, respectively.
 * The default unit is milliseconds.
 *  - The easing value controls how the animation accelerates and decelerates
 * during its runtime. Value is one of  `ease`, `ease-in`, `ease-out`,
 * `ease-in-out`, or a `cubic-bezier()` function call.
 * If not supplied, no easing is applied.
 *
 * For example, the string "1s 100ms ease-out" specifies a duration of
 * 1000 milliseconds, and delay of 100 ms, and the "ease-out" easing style,
 * which decelerates near the end of the duration.
 * @param styles Sets AnimationStyles for the parent animation.
 * A function call to either `style()` or `keyframes()`
 * that returns a collection of CSS style entries to be applied to the parent animation.
 * When null, uses the styles from the destination state.
 * This is useful when describing an animation step that will complete an animation;
 * see "Animating to the final state" in `transitions()`.
 * @returns An object that encapsulates the animation step.
 *
 * @usageNotes
 * Call within an animation `sequence()`, `{@link animations/group group()}`, or
 * `transition()` call to specify an animation step
 * that applies given style data to the parent animation for a given amount of time.
 *
 * ### Syntax Examples
 * **Timing examples**
 *
 * The following examples show various `timings` specifications.
 * - `animate(500)` : Duration is 500 milliseconds.
 * - `animate("1s")` : Duration is 1000 milliseconds.
 * - `animate("100ms 0.5s")` : Duration is 100 milliseconds, delay is 500 milliseconds.
 * - `animate("5s ease-in")` : Duration is 5000 milliseconds, easing in.
 * - `animate("5s 10ms cubic-bezier(.17,.67,.88,.1)")` : Duration is 5000 milliseconds, delay is 10
 * milliseconds, easing according to a bezier curve.
 *
 * **Style examples**
 *
 * The following example calls `style()` to set a single CSS style.
 * ```typescript
 * animate(500, style({ background: "red" }))
 * ```
 * The following example calls `keyframes()` to set a CSS style
 * to different values for successive keyframes.
 * ```typescript
 * animate(500, keyframes(
 *  [
 *   style({ background: "blue" })),
 *   style({ background: "red" }))
 *  ])
 * ```
 */
function animate(timings, styles) {
    if (styles === void 0) { styles = null; }
    return { type: 4 /* Animate */, styles: styles, timings: timings };
}
/**
 * @description Defines a list of animation steps to be run in parallel.
 *
 * @param steps An array of animation step objects.
 * - When steps are defined by `style()` or `animate()`
 * function calls, each call within the group is executed instantly.
 * - To specify offset styles to be applied at a later time, define steps with
 * `keyframes()`, or use `animate()` calls with a delay value.
 * For example:
 *
 * ```typescript
 * group([
 *   animate("1s", { background: "black" }))
 *   animate("2s", { color: "white" }))
 * ])
 * ```
 *
 * @param options An options object containing a delay and
 * developer-defined parameters that provide styling defaults and
 * can be overridden on invocation.
 *
 * @return An object that encapsulates the group data.
 *
 * @usageNotes
 * Grouped animations are useful when a series of styles must be
 * animated at different starting times and closed off at different ending times.
 *
 * When called within a `sequence()` or a
 * `transition()` call, does not continue to the next
 * instruction until all of the inner animation steps have completed.
 */
function group(steps, options) {
    if (options === void 0) { options = null; }
    return { type: 3 /* Group */, steps: steps, options: options };
}
/**
 * Defines a list of animation steps to be run sequentially, one by one.
 *
 * @param steps An array of animation step objects.
 * - Steps defined by `style()` calls apply the styling data immediately.
 * - Steps defined by `animate()` calls apply the styling data over time
 *   as specified by the timing data.
 *
 * ```typescript
 * sequence([
 *   style({ opacity: 0 })),
 *   animate("1s", { opacity: 1 }))
 * ])
 * ```
 *
 * @param options An options object containing a delay and
 * developer-defined parameters that provide styling defaults and
 * can be overridden on invocation.
 *
 * @return An object that encapsulates the sequence data.
 *
 * @usageNotes
 * When you pass an array of steps to a
 * `transition()` call, the steps run sequentially by default.
 * Compare this to the `{@link animations/group group()}` call, which runs animation steps in parallel.
 *
 * When a sequence is used within a `{@link animations/group group()}` or a `transition()` call,
 * execution continues to the next instruction only after each of the inner animation
 * steps have completed.
 *
 **/
function sequence(steps, options) {
    if (options === void 0) { options = null; }
    return { type: 2 /* Sequence */, steps: steps, options: options };
}
/**
 * Declares a key/value object containing CSS properties/styles that
 * can then be used for an animation `state`, within an animation `sequence`,
 * or as styling data for calls to `animate()` and `keyframes()`.
 *
 * @param tokens A set of CSS styles or HTML styles associated with an animation state.
 * The value can be any of the following:
 * - A key-value style pair associating a CSS property with a value.
 * - An array of key-value style pairs.
 * - An asterisk (*), to use auto-styling, where styles are derived from the element
 * being animated and applied to the animation when it starts.
 *
 * Auto-styling can be used to define a state that depends on layout or other
 * environmental factors.
 *
 * @return An object that encapsulates the style data.
 *
 * @usageNotes
 * The following examples create animation styles that collect a set of
 * CSS property values:
 *
 * ```typescript
 * // string values for CSS properties
 * style({ background: "red", color: "blue" })
 *
 * // numerical pixel values
 * style({ width: 100, height: 0 })
 * ```
 *
 * The following example uses auto-styling to allow a component to animate from
 * a height of 0 up to the height of the parent element:
 *
 * ```
 * style({ height: 0 }),
 * animate("1s", style({ height: "*" }))
 * ```
 *
 **/
function style(tokens) {
    return { type: 6 /* Style */, styles: tokens, offset: null };
}
/**
 * Declares an animation state within a trigger attached to an element.
 *
 * @param name One or more names for the defined state in a comma-separated string.
 * The following reserved state names can be supplied to define a style for specific use
 * cases:
 *
 * - `void` You can associate styles with this name to be used when
 * the element is detached from the application. For example, when an `ngIf` evaluates
 * to false, the state of the associated element is void.
 *  - `*` (asterisk) Indicates the default state. You can associate styles with this name
 * to be used as the fallback when the state that is being animated is not declared
 * within the trigger.
 *
 * @param styles A set of CSS styles associated with this state, created using the
 * `style()` function.
 * This set of styles persists on the element once the state has been reached.
 * @param options Parameters that can be passed to the state when it is invoked.
 * 0 or more key-value pairs.
 * @return An object that encapsulates the new state data.
 *
 * @usageNotes
 * Use the `trigger()` function to register states to an animation trigger.
 * Use the `transition()` function to animate between states.
 * When a state is active within a component, its associated styles persist on the element,
 * even when the animation ends.
 **/
function state(name, styles, options) {
    return { type: 0 /* State */, name: name, styles: styles, options: options };
}
/**
 * Defines a set of animation styles, associating each style with an optional `offset` value.
 *
 * @param steps A set of animation styles with optional offset data.
 * The optional `offset` value for a style specifies a percentage of the total animation
 * time at which that style is applied.
 * @returns An object that encapsulates the keyframes data.
 *
 * @usageNotes
 * Use with the `animate()` call. Instead of applying animations
 * from the current state
 * to the destination state, keyframes describe how each style entry is applied and at what point
 * within the animation arc.
 * Compare [CSS Keyframe Animations](https://www.w3schools.com/css/css3_animations.asp).
 *
 * ### Usage
 *
 * In the following example, the offset values describe
 * when each `backgroundColor` value is applied. The color is red at the start, and changes to
 * blue when 20% of the total time has elapsed.
 *
 * ```typescript
 * // the provided offset values
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red", offset: 0 }),
 *   style({ backgroundColor: "blue", offset: 0.2 }),
 *   style({ backgroundColor: "orange", offset: 0.3 }),
 *   style({ backgroundColor: "black", offset: 1 })
 * ]))
 * ```
 *
 * If there are no `offset` values specified in the style entries, the offsets
 * are calculated automatically.
 *
 * ```typescript
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red" }) // offset = 0
 *   style({ backgroundColor: "blue" }) // offset = 0.33
 *   style({ backgroundColor: "orange" }) // offset = 0.66
 *   style({ backgroundColor: "black" }) // offset = 1
 * ]))
 *```
 */
function keyframes(steps) {
    return { type: 5 /* Keyframes */, steps: steps };
}
/**
 * Declares an animation transition as a sequence of animation steps to run when a given
 * condition is satisfied. The condition is a Boolean expression or function that compares
 * the previous and current animation states, and returns true if this transition should occur.
 * When the state criteria of a defined transition are met, the associated animation is
 * triggered.
 *
 * @param stateChangeExpr A Boolean expression or function that compares the previous and current
 * animation states, and returns true if this transition should occur. Note that  "true" and "false"
 * match 1 and 0, respectively. An expression is evaluated each time a state change occurs in the
 * animation trigger element.
 * The animation steps run when the expression evaluates to true.
 *
 * - A state-change string takes the form "state1 => state2", where each side is a defined animation
 * state, or an asterix (*) to refer to a dynamic start or end state.
 *   - The expression string can contain multiple comma-separated statements;
 * for example "state1 => state2, state3 => state4".
 *   - Special values `:enter` and `:leave` initiate a transition on the entry and exit states,
 * equivalent to  "void => *"  and "* => void".
 *   - Special values `:increment` and `:decrement` initiate a transition when a numeric value has
 * increased or decreased in value.
 * - A function is executed each time a state change occurs in the animation trigger element.
 * The animation steps run when the function returns true.
 *
 * @param steps One or more animation objects, as returned by the `animate()` or
 * `sequence()` function, that form a transformation from one state to another.
 * A sequence is used by default when you pass an array.
 * @param options An options object that can contain a delay value for the start of the animation,
 * and additional developer-defined parameters. Provided values for additional parameters are used
 * as defaults, and override values can be passed to the caller on invocation.
 * @returns An object that encapsulates the transition data.
 *
 * @usageNotes
 * The template associated with a component binds an animation trigger to an element.
 *
 * ```HTML
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * All transitions are defined within an animation trigger,
 * along with named states that the transitions change to and from.
 *
 * ```typescript
 * trigger("myAnimationTrigger", [
 *  // define states
 *  state("on", style({ background: "green" })),
 *  state("off", style({ background: "grey" })),
 *  ...]
 * ```
 *
 * Note that when you call the `sequence()` function within a `{@link animations/group group()}`
 * or a `transition()` call, execution does not continue to the next instruction
 * until each of the inner animation steps have completed.
 *
 * ### Syntax examples
 *
 * The following examples define transitions between the two defined states (and default states),
 * using various options:
 *
 * ```typescript
 * // Transition occurs when the state value
 * // bound to "myAnimationTrigger" changes from "on" to "off"
 * transition("on => off", animate(500))
 * // Run the same animation for both directions
 * transition("on <=> off", animate(500))
 * // Define multiple state-change pairs separated by commas
 * transition("on => off, off => void", animate(500))
 * ```
 *
 * ### Special values for state-change expressions
 *
 * - Catch-all state change for when an element is inserted into the page and the
 * destination state is unknown:
 *
 * ```typescript
 * transition("void => *", [
 *  style({ opacity: 0 }),
 *  animate(500)
 *  ])
 * ```
 *
 * - Capture a state change between any states:
 *
 *  `transition("* => *", animate("1s 0s"))`
 *
 * - Entry and exit transitions:
 *
 * ```typescript
 * transition(":enter", [
 *   style({ opacity: 0 }),
 *   animate(500, style({ opacity: 1 }))
 *   ]),
 * transition(":leave", [
 *   animate(500, style({ opacity: 0 }))
 *   ])
 * ```
 *
 * - Use `:increment` and `:decrement` to initiate transitions:
 *
 * ```typescript
 * transition(":increment", group([
 *  query(':enter', [
 *     style({ left: '100%' }),
 *     animate('0.5s ease-out', style('*'))
 *   ]),
 *  query(':leave', [
 *     animate('0.5s ease-out', style({ left: '-100%' }))
 *  ])
 * ]))
 *
 * transition(":decrement", group([
 *  query(':enter', [
 *     style({ left: '100%' }),
 *     animate('0.5s ease-out', style('*'))
 *   ]),
 *  query(':leave', [
 *     animate('0.5s ease-out', style({ left: '-100%' }))
 *  ])
 * ]))
 * ```
 *
 * ### State-change functions
 *
 * Here is an example of a `fromState` specified as a state-change function that invokes an
 * animation when true:
 *
 * ```typescript
 * transition((fromState, toState) =>
 *  {
 *   return fromState == "off" && toState == "on";
 *  },
 *  animate("1s 0s"))
 * ```
 *
 * ### Animating to the final state
 *
 * If the final step in a transition is a call to `animate()` that uses a timing value
 * with no style data, that step is automatically considered the final animation arc,
 * for the element to reach the final state. Angular automatically adds or removes
 * CSS styles to ensure that the element is in the correct final state.
 *
 * The following example defines a transition that starts by hiding the element,
 * then makes sure that it animates properly to whatever state is currently active for trigger:
 *
 * ```typescript
 * transition("void => *", [
 *   style({ opacity: 0 }),
 *   animate(500)
 *  ])
 * ```
 * ### Boolean value matching
 * If a trigger binding value is a Boolean, it can be matched using a transition expression
 * that compares true and false or 1 and 0. For example:
 *
 * ```
 * // in the template
 * <div [@openClose]="open ? true : false">...</div>
 * // in the component metadata
 * trigger('openClose', [
 *   state('true', style({ height: '*' })),
 *   state('false', style({ height: '0px' })),
 *   transition('false <=> true', animate(500))
 * ])
 * ```
 **/
function transition(stateChangeExpr, steps, options) {
    if (options === void 0) { options = null; }
    return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps, options: options };
}
/**
 * Produces a reusable animation that can be invoked in another animation or sequence,
 * by calling the `useAnimation()` function.
 *
 * @param steps One or more animation objects, as returned by the `animate()`
 * or `sequence()` function, that form a transformation from one state to another.
 * A sequence is used by default when you pass an array.
 * @param options An options object that can contain a delay value for the start of the
 * animation, and additional developer-defined parameters.
 * Provided values for additional parameters are used as defaults,
 * and override values can be passed to the caller on invocation.
 * @returns An object that encapsulates the animation data.
 *
 * @usageNotes
 * The following example defines a reusable animation, providing some default parameter
 * values.
 *
 * ```typescript
 * var fadeAnimation = animation([
 *   style({ opacity: '{{ start }}' }),
 *   animate('{{ time }}',
 *   style({ opacity: '{{ end }}'}))
 *   ],
 *   { params: { time: '1000ms', start: 0, end: 1 }});
 * ```
 *
 * The following invokes the defined animation with a call to `useAnimation()`,
 * passing in override parameter values.
 *
 * ```js
 * useAnimation(fadeAnimation, {
 *   params: {
 *     time: '2s',
 *     start: 1,
 *     end: 0
 *   }
 * })
 * ```
 *
 * If any of the passed-in parameter values are missing from this call,
 * the default values are used. If one or more parameter values are missing before a step is
 * animated, `useAnimation()` throws an error.
 */
function animation(steps, options) {
    if (options === void 0) { options = null; }
    return { type: 8 /* Reference */, animation: steps, options: options };
}
/**
 * Executes a queried inner animation element within an animation sequence.
 *
 * @param options An options object that can contain a delay value for the start of the
 * animation, and additional override values for developer-defined parameters.
 * @return An object that encapsulates the child animation data.
 *
 * @usageNotes
 * Each time an animation is triggered in Angular, the parent animation
 * has priority and any child animations are blocked. In order
 * for a child animation to run, the parent animation must query each of the elements
 * containing child animations, and run them using this function.
 *
 * Note that this feature designed to be used with `query()` and it will only work
 * with animations that are assigned using the Angular animation library. CSS keyframes
 * and transitions are not handled by this API.
 */
function animateChild(options) {
    if (options === void 0) { options = null; }
    return { type: 9 /* AnimateChild */, options: options };
}
/**
 * Starts a reusable animation that is created using the `animation()` function.
 *
 * @param animation The reusable animation to start.
 * @param options An options object that can contain a delay value for the start of
 * the animation, and additional override values for developer-defined parameters.
 * @return An object that contains the animation parameters.
 */
function useAnimation(animation, options) {
    if (options === void 0) { options = null; }
    return { type: 10 /* AnimateRef */, animation: animation, options: options };
}
/**
 * Finds one or more inner elements within the current element that is
 * being animated within a sequence. Use with `animateChild()`.
 *
 * @param selector The element to query, or a set of elements that contain Angular-specific
 * characteristics, specified with one or more of the following tokens.
 *  - `query(":enter")` or `query(":leave")` : Query for newly inserted/removed elements.
 *  - `query(":animating")` : Query all currently animating elements.
 *  - `query("@triggerName")` : Query elements that contain an animation trigger.
 *  - `query("@*")` : Query all elements that contain an animation triggers.
 *  - `query(":self")` : Include the current element into the animation sequence.
 *
 * @param animation One or more animation steps to apply to the queried element or elements.
 * An array is treated as an animation sequence.
 * @param options An options object. Use the 'limit' field to limit the total number of
 * items to collect.
 * @return An object that encapsulates the query data.
 *
 * @usageNotes
 * Tokens can be merged into a combined query selector string. For example:
 *
 * ```typescript
 *  query(':self, .record:enter, .record:leave, @subTrigger', [...])
 * ```
 *
 * The `query()` function collects multiple elements and works internally by using
 * `element.querySelectorAll`. Use the `limit` field of an options object to limit
 * the total number of items to be collected. For example:
 *
 * ```js
 * query('div', [
 *   animate(...),
 *   animate(...)
 * ], { limit: 1 })
 * ```
 *
 * By default, throws an error when zero items are found. Set the
 * `optional` flag to ignore this error. For example:
 *
 * ```js
 * query('.some-element-that-may-not-be-there', [
 *   animate(...),
 *   animate(...)
 * ], { optional: true })
 * ```
 *
 * ### Usage Example
 *
 * The following example queries for inner elements and animates them
 * individually using `animateChild()`.
 *
 * ```typescript
 * @Component({
 *   selector: 'inner',
 *   template: `
 *     <div [@queryAnimation]="exp">
 *       <h1>Title</h1>
 *       <div class="content">
 *         Blah blah blah
 *       </div>
 *     </div>
 *   `,
 *   animations: [
 *    trigger('queryAnimation', [
 *      transition('* => goAnimate', [
 *        // hide the inner elements
 *        query('h1', style({ opacity: 0 })),
 *        query('.content', style({ opacity: 0 })),
 *
 *        // animate the inner elements in, one by one
 *        query('h1', animate(1000, style({ opacity: 1 })),
 *        query('.content', animate(1000, style({ opacity: 1 })),
 *      ])
 *    ])
 *  ]
 * })
 * class Cmp {
 *   exp = '';
 *
 *   goAnimate() {
 *     this.exp = 'goAnimate';
 *   }
 * }
 * ```
 */
function query(selector, animation, options) {
    if (options === void 0) { options = null; }
    return { type: 11 /* Query */, selector: selector, animation: animation, options: options };
}
/**
 * Use within an animation `query()` call to issue a timing gap after
 * each queried item is animated.
 *
 * @param timings A delay value.
 * @param animation One ore more animation steps.
 * @returns An object that encapsulates the stagger data.
 *
 * @usageNotes
 * In the following example, a container element wraps a list of items stamped out
 * by an `ngFor`. The container element contains an animation trigger that will later be set
 * to query for each of the inner items.
 *
 * Each time items are added, the opacity fade-in animation runs,
 * and each removed item is faded out.
 * When either of these animations occur, the stagger effect is
 * applied after each item's animation is started.
 *
 * ```html
 * <!-- list.component.html -->
 * <button (click)="toggle()">Show / Hide Items</button>
 * <hr />
 * <div [@listAnimation]="items.length">
 *   <div *ngFor="let item of items">
 *     {{ item }}
 *   </div>
 * </div>
 * ```
 *
 * Here is the component code:
 *
 * ```typescript
 * import {trigger, transition, style, animate, query, stagger} from '@angular/animations';
 * @Component({
 *   templateUrl: 'list.component.html',
 *   animations: [
 *     trigger('listAnimation', [
 *     ...
 *     ])
 *   ]
 * })
 * class ListComponent {
 *   items = [];
 *
 *   showItems() {
 *     this.items = [0,1,2,3,4];
 *   }
 *
 *   hideItems() {
 *     this.items = [];
 *   }
 *
 *   toggle() {
 *     this.items.length ? this.hideItems() : this.showItems();
 *    }
 *  }
 * ```
 *
 * Here is the animation trigger code:
 *
 * ```typescript
 * trigger('listAnimation', [
 *   transition('* => *', [ // each time the binding value changes
 *     query(':leave', [
 *       stagger(100, [
 *         animate('0.5s', style({ opacity: 0 }))
 *       ])
 *     ]),
 *     query(':enter', [
 *       style({ opacity: 0 }),
 *       stagger(100, [
 *         animate('0.5s', style({ opacity: 1 }))
 *       ])
 *     ])
 *   ])
 * ])
 * ```
 */
function stagger(timings, animation) {
    return { type: 12 /* Stagger */, timings: timings, animation: animation };
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function scheduleMicroTask(cb) {
    Promise.resolve(null).then(cb);
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An empty programmatic controller for reusable animations.
 * Used internally when animations are disabled, to avoid
 * checking for the null case when an animation player is expected.
 *
 * @see `animate()`
 * @see `AnimationPlayer`
 * @see `GroupPlayer`
 *
 */
var NoopAnimationPlayer = /** @class */ (function () {
    function NoopAnimationPlayer(duration, delay) {
        if (duration === void 0) { duration = 0; }
        if (delay === void 0) { delay = 0; }
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._started = false;
        this._destroyed = false;
        this._finished = false;
        this.parentPlayer = null;
        this.totalTime = duration + delay;
    }
    NoopAnimationPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    NoopAnimationPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    NoopAnimationPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    NoopAnimationPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    NoopAnimationPlayer.prototype.hasStarted = function () { return this._started; };
    NoopAnimationPlayer.prototype.init = function () { };
    NoopAnimationPlayer.prototype.play = function () {
        if (!this.hasStarted()) {
            this._onStart();
            this.triggerMicrotask();
        }
        this._started = true;
    };
    /** @internal */
    NoopAnimationPlayer.prototype.triggerMicrotask = function () {
        var _this = this;
        scheduleMicroTask(function () { return _this._onFinish(); });
    };
    NoopAnimationPlayer.prototype._onStart = function () {
        this._onStartFns.forEach(function (fn) { return fn(); });
        this._onStartFns = [];
    };
    NoopAnimationPlayer.prototype.pause = function () { };
    NoopAnimationPlayer.prototype.restart = function () { };
    NoopAnimationPlayer.prototype.finish = function () { this._onFinish(); };
    NoopAnimationPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            if (!this.hasStarted()) {
                this._onStart();
            }
            this.finish();
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    NoopAnimationPlayer.prototype.reset = function () { };
    NoopAnimationPlayer.prototype.setPosition = function (position) { };
    NoopAnimationPlayer.prototype.getPosition = function () { return 0; };
    /** @internal */
    NoopAnimationPlayer.prototype.triggerCallback = function (phaseName) {
        var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
        methods.forEach(function (fn) { return fn(); });
        methods.length = 0;
    };
    return NoopAnimationPlayer;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A programmatic controller for a group of reusable animations.
 * Used internally to control animations.
 *
 * @see `AnimationPlayer`
 * @see `{@link animations/group group()}`
 *
 */
var AnimationGroupPlayer = /** @class */ (function () {
    function AnimationGroupPlayer(_players) {
        var _this = this;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._finished = false;
        this._started = false;
        this._destroyed = false;
        this._onDestroyFns = [];
        this.parentPlayer = null;
        this.totalTime = 0;
        this.players = _players;
        var doneCount = 0;
        var destroyCount = 0;
        var startCount = 0;
        var total = this.players.length;
        if (total == 0) {
            scheduleMicroTask(function () { return _this._onFinish(); });
        }
        else {
            this.players.forEach(function (player) {
                player.onDone(function () {
                    if (++doneCount == total) {
                        _this._onFinish();
                    }
                });
                player.onDestroy(function () {
                    if (++destroyCount == total) {
                        _this._onDestroy();
                    }
                });
                player.onStart(function () {
                    if (++startCount == total) {
                        _this._onStart();
                    }
                });
            });
        }
        this.totalTime = this.players.reduce(function (time, player) { return Math.max(time, player.totalTime); }, 0);
    }
    AnimationGroupPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    AnimationGroupPlayer.prototype.init = function () { this.players.forEach(function (player) { return player.init(); }); };
    AnimationGroupPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    AnimationGroupPlayer.prototype._onStart = function () {
        if (!this.hasStarted()) {
            this._started = true;
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
        }
    };
    AnimationGroupPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    AnimationGroupPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    AnimationGroupPlayer.prototype.hasStarted = function () { return this._started; };
    AnimationGroupPlayer.prototype.play = function () {
        if (!this.parentPlayer) {
            this.init();
        }
        this._onStart();
        this.players.forEach(function (player) { return player.play(); });
    };
    AnimationGroupPlayer.prototype.pause = function () { this.players.forEach(function (player) { return player.pause(); }); };
    AnimationGroupPlayer.prototype.restart = function () { this.players.forEach(function (player) { return player.restart(); }); };
    AnimationGroupPlayer.prototype.finish = function () {
        this._onFinish();
        this.players.forEach(function (player) { return player.finish(); });
    };
    AnimationGroupPlayer.prototype.destroy = function () { this._onDestroy(); };
    AnimationGroupPlayer.prototype._onDestroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            this._onFinish();
            this.players.forEach(function (player) { return player.destroy(); });
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    AnimationGroupPlayer.prototype.reset = function () {
        this.players.forEach(function (player) { return player.reset(); });
        this._destroyed = false;
        this._finished = false;
        this._started = false;
    };
    AnimationGroupPlayer.prototype.setPosition = function (p) {
        var timeAtPosition = p * this.totalTime;
        this.players.forEach(function (player) {
            var position = player.totalTime ? Math.min(1, timeAtPosition / player.totalTime) : 1;
            player.setPosition(position);
        });
    };
    AnimationGroupPlayer.prototype.getPosition = function () {
        var min = 0;
        this.players.forEach(function (player) {
            var p = player.getPosition();
            min = Math.min(p, min);
        });
        return min;
    };
    AnimationGroupPlayer.prototype.beforeDestroy = function () {
        this.players.forEach(function (player) {
            if (player.beforeDestroy) {
                player.beforeDestroy();
            }
        });
    };
    /** @internal */
    AnimationGroupPlayer.prototype.triggerCallback = function (phaseName) {
        var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
        methods.forEach(function (fn) { return fn(); });
        methods.length = 0;
    };
    return AnimationGroupPlayer;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ɵPRE_STYLE = '!';

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=animations.js.map


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return coerceBooleanProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return coerceNumberProperty; });
/* unused harmony export _isNumberValue */
/* unused harmony export coerceArray */
/* unused harmony export coerceCssPixelValue */
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @param {?} value
 * @param {?=} fallbackValue
 * @return {?}
 */
function coerceNumberProperty(value, fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = 0; }
    return _isNumberValue(value) ? Number(value) : fallbackValue;
}
/**
 * Whether the provided value is considered a number.
 * \@docs-private
 * @param {?} value
 * @return {?}
 */
function _isNumberValue(value) {
    // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
    // and other non-number values as NaN, where Number just uses 0) but it considers the string
    // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
    return !isNaN(parseFloat(/** @type {?} */ (value))) && !isNaN(Number(value));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * Wraps the provided value in an array, unless the provided value is an array.
 * @template T
 * @param {?} value
 * @return {?}
 */
function coerceArray(value) {
    return Array.isArray(value) ? value : [value];
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * Coerces a value to a CSS pixel value.
 * @param {?} value
 * @return {?}
 */
function coerceCssPixelValue(value) {
    if (value == null) {
        return '';
    }
    return typeof value === 'string' ? value : value + "px";
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


//# sourceMappingURL=coercion.es5.js.map


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var Activate = /** @class */ (function () {
    function Activate(http) {
        this.http = http;
    }
    Activate.prototype.activateEmail = function (key) {
        var params = new http_1.HttpParams().set('key', key);
        return this.http.get('/api/activate-email', {
            params: params
        });
    };
    Activate.prototype.activateAccount = function (key) {
        var params = new http_1.HttpParams().set('key', key);
        return this.http.get('/api/activate-account', {
            params: params
        });
    };
    Activate = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], Activate);
    return Activate;
}());
exports.Activate = Activate;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var user_service_1 = __webpack_require__(74);
var auth_session_service_1 = __webpack_require__(98);
var LoginService = /** @class */ (function () {
    function LoginService(userService, authServerProvider, router) {
        this.userService = userService;
        this.authServerProvider = authServerProvider;
        this.router = router;
    }
    LoginService.prototype.login = function (credentials) {
        return this.authServerProvider.login(credentials).toPromise();
    };
    LoginService.prototype.logout = function () {
        var _this = this;
        this.userService.getAccount(false).then(function (account) {
            if (account && account.franceConnectSubscription) {
                _this.fcLogout();
            }
            else {
                _this.authServerProvider.logout().subscribe(function () {
                    _this.userService.clearUserState();
                    _this.router.navigate(['authentication']);
                });
            }
        });
    };
    LoginService.prototype.fcLogout = function () {
        this.authServerProvider.fcLogout()
            .subscribe(function (fcLogOutUrl) { return window.location.href = fcLogOutUrl; });
    };
    LoginService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [user_service_1.UserService,
            auth_session_service_1.AuthServerProvider,
            router_1.Router])
    ], LoginService);
    return LoginService;
}());
exports.LoginService = LoginService;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var maj_site_component_1 = __webpack_require__(170);
var mention_legale_component_1 = __webpack_require__(171);
var condition_generale_component_1 = __webpack_require__(169);
var navbar_component_1 = __webpack_require__(174);
var accessibilite_component_1 = __webpack_require__(168);
var shared_1 = __webpack_require__(4);
var app_constants_1 = __webpack_require__(11);
var personal_data_component_1 = __webpack_require__(172);
exports.navbarRoute = {
    path: '',
    component: navbar_component_1.NavbarComponent,
    outlet: 'navbar'
};
exports.mentionLegaleRoute = {
    path: 'mentions-legales',
    component: mention_legale_component_1.MentionLegaleComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Mentions l\u00E9gales" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};
exports.conditionGeneraleRoute = {
    path: 'conditions-generales',
    component: condition_generale_component_1.ConditionGeneraleComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Conditions g\u00E9n\u00E9rales d'utilisation" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};
exports.accessibiliteRoute = {
    path: 'accessibilite',
    component: accessibilite_component_1.AccessibiliteComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Accessibilit\u00E9 : partiellement conforme" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};
exports.personalDataRoute = {
    path: 'donnees-personelles',
    component: personal_data_component_1.PersonalDataComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Donn\u00E9es personnelles" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};
exports.changelogRoute = {
    path: 'changelog',
    component: maj_site_component_1.MajSiteComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Mises \u00E0 jour du site" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var piece_jointe_1 = __webpack_require__(38);
var DepotRequeteState = /** @class */ (function () {
    function DepotRequeteState() {
        this.requerants = [];
        this.requete = new piece_jointe_1.PieceRequete(null);
        this.acteAttaque = new piece_jointe_1.PieceActeAttaque(null);
        this.reclamationPrealable = new piece_jointe_1.PieceReclamationPrealable(null);
        this.acteAttaquesAFusioner = [];
        this.reclamationPrealablesAFusioner = [];
        this.piecesComplementaires = [];
        this.piecesPostales = [];
        // flags to show auto save time
        this.isStepRequerantAutoSaveSucceed = false;
        this.isStepJuridictionAutoSaveSucceed = false;
        this.isStepRequeteAutoSaveSucceed = false;
        this.isStepJustificatifsAutoSaveSucceed = false;
    }
    return DepotRequeteState;
}());
exports.DepotRequeteState = DepotRequeteState;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(442));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(28);
var requete_model_1 = __webpack_require__(68);
var Statut;
(function (Statut) {
    Statut["AVERTISSEMENT"] = "AVERTISSEMENT";
    Statut["REQUERANT"] = "REQUERANT";
    Statut["JURIDICTION"] = "JURIDICTION";
    Statut["REQUETE"] = "REQUETE";
    Statut["JUSTIFICATIF"] = "JUSTIFICATIF";
    Statut["RECAPITULATIF"] = "RECAPITULATIF";
})(Statut = exports.Statut || (exports.Statut = {}));
var DraftRequete = /** @class */ (function () {
    function DraftRequete() {
    }
    DraftRequete.castAs = function (draft) {
        var draftRequete = util_1.castAs(draft, DraftRequete);
        draftRequete.parties = (draftRequete.parties || []).map(function (partie) {
            return util_1.castAs(partie, requete_model_1.PartieDepot);
        });
        draftRequete.pieces = draftRequete.pieces || [];
        return draftRequete;
    };
    DraftRequete.prototype.getIndexStateFromDraft = function () {
        switch (this.statut) {
            case Statut.AVERTISSEMENT:
                return 0;
            case Statut.REQUERANT:
                return 1;
            case Statut.JURIDICTION:
                return 2;
            case Statut.REQUETE:
                return 3;
            case Statut.JUSTIFICATIF:
                return 4;
            case Statut.RECAPITULATIF:
                return 5;
            default:
                return 0;
        }
    };
    return DraftRequete;
}());
exports.DraftRequete = DraftRequete;
var DraftRequeteSummary = /** @class */ (function () {
    function DraftRequeteSummary() {
    }
    return DraftRequeteSummary;
}());
exports.DraftRequeteSummary = DraftRequeteSummary;
var Requerant = /** @class */ (function () {
    function Requerant() {
        this.address = {};
        this.contact = {};
    }
    return Requerant;
}());
exports.Requerant = Requerant;
var Juridiction = /** @class */ (function () {
    function Juridiction() {
    }
    return Juridiction;
}());
exports.Juridiction = Juridiction;
var RequeteContentieuxSocial = /** @class */ (function () {
    function RequeteContentieuxSocial() {
    }
    return RequeteContentieuxSocial;
}());
exports.RequeteContentieuxSocial = RequeteContentieuxSocial;
var Justificatifs = /** @class */ (function () {
    function Justificatifs() {
    }
    return Justificatifs;
}());
exports.Justificatifs = Justificatifs;
var DraftPieceJointe = /** @class */ (function () {
    function DraftPieceJointe() {
    }
    return DraftPieceJointe;
}());
exports.DraftPieceJointe = DraftPieceJointe;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
/**
 * NOTE:
 * This application uses the default JHipster automatic inactivity logout, which is triggered
 * after 30 minutes of server inactivity.
 */
var TIMEOUT_IN_MS = 1000 * 60 * 29;
var InactivityService = /** @class */ (function () {
    function InactivityService() {
        this.openModal = new core_1.EventEmitter();
    }
    InactivityService.prototype.registerUserActivity = function () {
        if (this.currentCountdown) {
            this._clearCountdown();
        }
        this._startNewCountdown();
    };
    InactivityService.prototype._clearCountdown = function () {
        clearTimeout(this.currentCountdown);
    };
    InactivityService.prototype._startNewCountdown = function () {
        var _this = this;
        this.currentCountdown = setTimeout(function () {
            _this.openModal.emit();
        }, TIMEOUT_IN_MS);
    };
    InactivityService = __decorate([
        core_1.Injectable()
    ], InactivityService);
    return InactivityService;
}());
exports.InactivityService = InactivityService;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ROUTES_NAMES;
(function (ROUTES_NAMES) {
    ROUTES_NAMES["AVERTISSEMENTS"] = "avertissement";
    ROUTES_NAMES["REJOINDRE_DOSSIER"] = "rejoindre-dossier";
    ROUTES_NAMES["CONFIRMATION"] = "confirmation";
})(ROUTES_NAMES = exports.ROUTES_NAMES || (exports.ROUTES_NAMES = {}));
var BREAD_STEPS;
(function (BREAD_STEPS) {
    BREAD_STEPS["AVERTISSEMENTS"] = "Avertissement";
    BREAD_STEPS["REJOINDRE_DOSSIER"] = "Saisie du code";
    // PAGE_TITLE_SUFFIX unusable in enum
    BREAD_STEPS["CONFIRMATION"] = "Confirmation de rattachement";
})(BREAD_STEPS = exports.BREAD_STEPS || (exports.BREAD_STEPS = {}));
var PAGES_TITLES;
(function (PAGES_TITLES) {
    PAGES_TITLES["AVERTISSEMENTS"] = "Avertissement (\u00C9tape 1) | Rattacher un dossier \u00E0 mon compte | T\u00E9l\u00E9recours citoyens | Conseil d'\u00C9tat";
    PAGES_TITLES["REJOINDRE_DOSSIER"] = "Saisie du code (\u00C9tape 2) | Rattacher un dossier \u00E0 mon compte | T\u00E9l\u00E9recours citoyens | Conseil d'\u00C9tat";
    PAGES_TITLES["CONFIRMATION"] = "Confirmation de rattachement (\u00C9tape 3) | Rattacher un dossier \u00E0 mon compte | T\u00E9l\u00E9recours citoyens | Conseil d'\u00C9tat";
})(PAGES_TITLES = exports.PAGES_TITLES || (exports.PAGES_TITLES = {}));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var tracking_service_1 = __webpack_require__(32);
var http_1 = __webpack_require__(10);
var tracking_enum_1 = __webpack_require__(31);
var RattachementService = /** @class */ (function () {
    function RattachementService(trackingService, http) {
        this.trackingService = trackingService;
        this.http = http;
    }
    RattachementService.prototype.applyRattachement = function (secretCode) {
        return this.http.post('/api/requetes/rejoindre-dossier/', secretCode);
    };
    RattachementService.prototype.trackCguEvent = function (action) {
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.RATACHEMENT,
                name: 'Acceptation CGU'
            }
        });
    };
    RattachementService.prototype.trackRattachementSucceedEvent = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.SUCCESS,
            properties: {
                category: tracking_enum_1.TrackingCategory.RATACHEMENT,
                name: 'Rattachement effectué'
            }
        });
    };
    RattachementService.prototype.trackRattachementFailedTrTechnicalEvent = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.FAILED,
            properties: {
                category: tracking_enum_1.TrackingCategory.RATACHEMENT,
                name: 'Erreur technique (origine TR)'
            }
        });
    };
    RattachementService.prototype.trackRattachementFailedTechnicalEvent = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.FAILED,
            properties: {
                category: tracking_enum_1.TrackingCategory.RATACHEMENT,
                name: 'Erreur technique'
            }
        });
    };
    RattachementService.prototype.trackRattachementFailedSyntaxEvent = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.FAILED,
            properties: {
                category: tracking_enum_1.TrackingCategory.RATACHEMENT,
                name: 'Code invalide syntaxiquement (interne TRC)'
            }
        });
    };
    RattachementService.prototype.trackRattachementFailedSemanticEvent = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.FAILED,
            properties: {
                category: tracking_enum_1.TrackingCategory.RATACHEMENT,
                name: 'Code invalide semantiquement (validation par TR)'
            }
        });
    };
    RattachementService.prototype.trackRattachementFailedAlreadyAttachedEvent = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.FAILED,
            properties: {
                category: tracking_enum_1.TrackingCategory.RATACHEMENT,
                name: 'Code déja utilisé'
            }
        });
    };
    RattachementService.prototype.trackRattachementFailedExpiredEvent = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.FAILED,
            properties: {
                category: tracking_enum_1.TrackingCategory.RATACHEMENT,
                name: 'Code expiré'
            }
        });
    };
    RattachementService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [tracking_service_1.TrackingService, http_1.HttpClient])
    ], RattachementService);
    return RattachementService;
}());
exports.RattachementService = RattachementService;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(7);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(43);
var captcha_service_1 = __webpack_require__(69);
var base_control_value_accessor_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(5);
var CaptchaComponent = /** @class */ (function (_super) {
    __extends(CaptchaComponent, _super);
    function CaptchaComponent(injector, sanitizer, captchaService) {
        var _this = _super.call(this, injector) || this;
        _this.sanitizer = sanitizer;
        _this.captchaService = captchaService;
        _this.wasCaptchaReloaded = false;
        _this.captchaTexte = {
            texte: ''
        };
        _this.isAudioCaptcha = true;
        return _this;
    }
    CaptchaComponent_1 = CaptchaComponent;
    CaptchaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.audio = new Audio();
        this.reload(true);
        this.subscription = this.captchaService.reloadEvents.subscribe(function () { return _this.reload(); });
    };
    CaptchaComponent.prototype.ngOnDestroy = function () {
        // destroy audio here
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
        this.subscription.unsubscribe();
        _super.prototype.ngOnDestroy.call(this);
    };
    CaptchaComponent.prototype.onAudioPlay = function () {
        this.audio.play();
    };
    CaptchaComponent.prototype.reload = function (isOninit) {
        var _this = this;
        this.getCaptcha(this.isAudioCaptcha);
        this.resetCaptcha();
        // this allows for captcha accesibility reload message to appear
        if (!isOninit) {
            this.wasCaptchaReloaded = true;
            setTimeout(function () { _this.wasCaptchaReloaded = false; }, 1000);
        }
    };
    CaptchaComponent.prototype.getCaptcha = function (isAudioCaptcha) {
        var _this = this;
        this.isAudioCaptcha = isAudioCaptcha;
        this.captchaService.getCaptcha(isAudioCaptcha).pipe(operators_1.first()).subscribe(function (blob) {
            _this.audio.src = URL.createObjectURL(blob);
            _this.imageCaptchaUrl = null;
            if (isAudioCaptcha) {
                _this.captchaService.getImageCaptcha().subscribe(function (imageBlob) {
                    _this.imageCaptchaUrl = _this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(imageBlob));
                });
            }
        });
    };
    CaptchaComponent.prototype.modelValueChanged = function (value) {
        this.captchaTexte.texte = value;
    };
    CaptchaComponent.prototype.resetCaptcha = function () {
        this.captchaTexte.texte = '';
        if (this.onChange) {
            this.onChange(this.captchaTexte.texte);
        }
    };
    CaptchaComponent = CaptchaComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-captcha',
            template: __webpack_require__(834),
            styles: [__webpack_require__(934)],
            providers: [{
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: CaptchaComponent_1,
                    multi: true
                }]
        }),
        __metadata("design:paramtypes", [core_1.Injector, platform_browser_1.DomSanitizer, captcha_service_1.CaptchaService])
    ], CaptchaComponent);
    return CaptchaComponent;
    var CaptchaComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.CaptchaComponent = CaptchaComponent;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(19);
var draft_depot_requete_service_1 = __webpack_require__(16);
var draft_requete_model_1 = __webpack_require__(91);
var DraftModalComponent = /** @class */ (function () {
    function DraftModalComponent(activeModal, draftDepotRequeteService) {
        this.activeModal = activeModal;
        this.draftDepotRequeteService = draftDepotRequeteService;
    }
    DraftModalComponent.prototype.ngOnInit = function () {
        // RGAA workaround
        var modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', 'Suppression de votre brouillon en cours');
    };
    DraftModalComponent.prototype.deleteMyDraftRequete = function () {
        var _this = this;
        this.draftDepotRequeteService.deleteMyDraftRequete().subscribe(function () {
            _this.draftDepotRequeteService.eventDraftDeleted.emit();
            _this.activeModal.close();
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", draft_requete_model_1.DraftRequete)
    ], DraftModalComponent.prototype, "requete", void 0);
    DraftModalComponent = __decorate([
        core_1.Component({
            selector: 'jhi-draft-modal',
            template: __webpack_require__(838),
            styles: [__webpack_require__(938)]
        })
        /**
         * Modal to take back a draft or create a new requete
         */
        ,
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
            draft_depot_requete_service_1.DraftDepotRequeteService])
    ], DraftModalComponent);
    return DraftModalComponent;
}());
exports.DraftModalComponent = DraftModalComponent;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var OptionComponent = /** @class */ (function () {
    function OptionComponent(elRef) {
        this.elRef = elRef;
    }
    Object.defineProperty(OptionComponent.prototype, "label", {
        get: function () {
            return this.elRef.nativeElement.innerHTML;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], OptionComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], OptionComponent.prototype, "disabled", void 0);
    OptionComponent = __decorate([
        core_1.Component({
            selector: 'jhi-option',
            template: '<ng-content></ng-content>',
            styles: [__webpack_require__(948)]
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], OptionComponent);
    return OptionComponent;
}());
exports.OptionComponent = OptionComponent;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var AuthServerProvider = /** @class */ (function () {
    function AuthServerProvider(http) {
        this.http = http;
    }
    AuthServerProvider.prototype.login = function (credentials) {
        var data = [
            "j_username=" + encodeURIComponent(credentials.username),
            "j_password=" + encodeURIComponent(credentials.password),
            "remember-me=" + credentials.rememberMe + "&submit=Login"
        ].join('&');
        var headers = new http_1.HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        return this.http.post('/api/authentication', data, {
            headers: headers
        });
    };
    AuthServerProvider.prototype.logout = function () {
        // logout from the server
        return this.http.post('/api/logout', {});
    };
    AuthServerProvider.prototype.fcLogout = function () {
        // logout from the server
        return this.http.get('/franceconnect/logout', { responseType: 'text' });
    };
    AuthServerProvider.prototype.fcUserInfo = function () {
        return this.http
            .get("/franceconnect/userinfo", {
            responseType: 'json'
        });
    };
    AuthServerProvider = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], AuthServerProvider);
    return AuthServerProvider;
}());
exports.AuthServerProvider = AuthServerProvider;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var operators_1 = __webpack_require__(7);
var NavigationService = /** @class */ (function () {
    function NavigationService(router) {
        var _this = this;
        this._isGoingBack = false;
        router.events.pipe(operators_1.filter(function (e) { return e instanceof router_1.NavigationEnd; })).subscribe(function (_e) {
            _this._isGoingBack = false;
        });
    }
    NavigationService.prototype.isGoingBack = function () {
        console.log('isGoingBack', this._isGoingBack);
        var isGoingBack = this._isGoingBack;
        this._isGoingBack = false; // reset
        return isGoingBack;
    };
    NavigationService.prototype.markAsGoingBack = function () {
        this._isGoingBack = true;
    };
    NavigationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [router_1.Router])
    ], NavigationService);
    return NavigationService;
}());
exports.NavigationService = NavigationService;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var user_service_1 = __webpack_require__(74);
var state_storage_service_1 = __webpack_require__(73);
var router_1 = __webpack_require__(6);
var RouterAuthService = /** @class */ (function () {
    function RouterAuthService(stateStorageService, router, userService) {
        this.stateStorageService = stateStorageService;
        this.router = router;
        this.userService = userService;
    }
    RouterAuthService.prototype.authorize = function (route) {
        var _this = this;
        return this.userService.getIsAuthenticated(true).toPromise().then(function (isAuthenticated) {
            var url = route.pathFromRoot.map(function (r) { return r.url.join('/'); }).join('/');
            var data = Object.assign.apply(Object, __spread([{}], route.pathFromRoot.map(function (r) { return r.data; })));
            if (!isAuthenticated && data.needAuthentication) {
                // user is not authenticated. Save the state they wanted before you
                // send them to the login service, so you can return them when you're done
                _this.stateStorageService.storePreviousState(url);
                // now, send them to the signin state so they can log in
                _this.router.navigate(['/authentication']);
                return false;
            }
            // an authenticated user can't access to login and register pages
            if (isAuthenticated &&
                (url.indexOf('/register') === 0 || url.indexOf('/authentication') === 0)) {
                _this.router.navigate(['accueil']);
                return false;
            }
            return true;
        });
    };
    RouterAuthService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [state_storage_service_1.StateStorageService,
            router_1.Router,
            user_service_1.UserService])
    ], RouterAuthService);
    return RouterAuthService;
}());
exports.RouterAuthService = RouterAuthService;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ScrollToService = /** @class */ (function () {
    function ScrollToService() {
    }
    ScrollToService.prototype.scrollTo = function (target) {
        if (target) {
            var element = $(target).offset();
            if (element) {
                $('html,body').animate({ scrollTop: element.top }, 'fast', function () {
                    target.focus();
                });
            }
        }
    };
    ScrollToService.prototype.scrollToFirstError = function () {
        var target = $('.invalid:first');
        if (!target.length) {
            target = $('.ng-invalid:not(form):first');
        }
        this.scrollTo(target);
    };
    ScrollToService.prototype.scrollToFirstErrorForStepRequeteInDepotRequete = function () {
        var target = $('.ng-invalid:not(form):first');
        this.scrollTo(target);
    };
    ScrollToService.prototype.scrollToNearestTitleOfFirstError = function () {
        var target = $('.invalid:first');
        var closesth5 = target.closest('jhi-section').find('h5');
        var closesth2 = target.closest('jhi-section').find('h2');
        var finalTarget = closesth5.length ? closesth5 : closesth2;
        if (!target.length) {
            target = $('.ng-invalid:not(form):first');
            closesth5 = target.closest('jhi-section').find('h5');
            closesth2 = target.closest('jhi-section').find('h2');
            finalTarget = closesth5.length ? closesth5 : closesth2;
        }
        this.scrollTo(finalTarget);
    };
    ScrollToService.prototype.scrollBySelector = function (selector) {
        var target = $(selector);
        this.scrollTo(target);
    };
    ScrollToService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [])
    ], ScrollToService);
    return ScrollToService;
}());
exports.ScrollToService = ScrollToService;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(377)))

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var rxjs_1 = __webpack_require__(12);
var http_1 = __webpack_require__(10);
var operators_1 = __webpack_require__(7);
var StaticContentService = /** @class */ (function () {
    function StaticContentService(http) {
        this.http = http;
        this.faqCategories = new rxjs_1.BehaviorSubject([]);
    }
    StaticContentService.prototype.getFaqCategories = function () {
        var _this = this;
        if (this.faqCategories.getValue().length === 0) {
            return this.http.get('/api/static/faq.json').pipe(operators_1.map(function (res) { return _this.mapResposeBodyToFaqCategories(res).sort(_this.sortFaqCategoriesByRank.bind(_this)); }), operators_1.tap(function (res) { return _this.faqCategories.next(res); }));
        }
        return this.faqCategories.asObservable();
    };
    StaticContentService.prototype.mapResposeBodyToFaqCategories = function (body) {
        return Object.keys(body).map(function (key) { return body[key]; });
    };
    StaticContentService.prototype.sortFaqCategoriesByRank = function (category1, category2) {
        return category1.rank > category2.rank ? 1 : -1;
    };
    StaticContentService.prototype.getChangeLog = function (changelog) {
        console.log('changelog', changelog);
        return this.http.get('/api/static/changelog.xml', {
            responseType: 'text'
        }).pipe(operators_1.map(function (res) { return changelog = res; }));
    };
    StaticContentService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], StaticContentService);
    return StaticContentService;
}());
exports.StaticContentService = StaticContentService;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var http_1 = __webpack_require__(10);
var common_1 = __webpack_require__(15);
var ng_bootstrap_1 = __webpack_require__(19);
var ng_jhipster_1 = __webpack_require__(30);
var ngx_infinite_scroll_1 = __webpack_require__(967);
var ngx_cookie_1 = __webpack_require__(378);
var ng2_file_upload_1 = __webpack_require__(129);
var angulartics2_1 = __webpack_require__(104);
var TelerecourspnrSharedLibsModule = /** @class */ (function () {
    function TelerecourspnrSharedLibsModule() {
    }
    TelerecourspnrSharedLibsModule = __decorate([
        core_1.NgModule({
            imports: [
                ng_bootstrap_1.NgbModule.forRoot(),
                ng_jhipster_1.NgJhipsterModule.forRoot({
                    alertAsToast: false,
                    i18nEnabled: true,
                    defaultI18nLang: 'fr'
                }),
                ngx_infinite_scroll_1.InfiniteScrollModule,
                ng2_file_upload_1.FileUploadModule,
                angulartics2_1.Angulartics2Module.forRoot(),
                ngx_cookie_1.CookieModule.forRoot()
            ],
            exports: [
                forms_1.FormsModule,
                http_1.HttpClientModule,
                common_1.CommonModule,
                ng_bootstrap_1.NgbModule,
                ng_jhipster_1.NgJhipsterModule,
                ngx_infinite_scroll_1.InfiniteScrollModule,
                ng2_file_upload_1.FileUploadModule
            ]
        })
    ], TelerecourspnrSharedLibsModule);
    return TelerecourspnrSharedLibsModule;
}());
exports.TelerecourspnrSharedLibsModule = TelerecourspnrSharedLibsModule;


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(6);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANGULARTICS2_TOKEN", function() { return ANGULARTICS2_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AngularRouterTracking", function() { return AngularRouterTracking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Angulartics2", function() { return Angulartics2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Angulartics2Module", function() { return Angulartics2Module; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Angulartics2On", function() { return Angulartics2On; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Angulartics2OnModule", function() { return Angulartics2OnModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultConfig", function() { return DefaultConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RouterlessTracking", function() { return RouterlessTracking; });







var DefaultConfig = /** @class */ (function () {
    function DefaultConfig() {
        this.pageTracking = {
            autoTrackVirtualPages: true,
            basePath: '',
            excludedRoutes: [],
            clearIds: false,
            clearHash: false,
            clearQueryParams: false,
            idsRegExp: /^\d+$|^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
        };
        this.developerMode = false;
        this.ga = {};
        this.appInsights = {};
        this.gtm = {};
        this.gst = {};
    }
    return DefaultConfig;
}());

var ANGULARTICS2_TOKEN = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('ANGULARTICS2');

var RouterlessTracking = /** @class */ (function () {
    function RouterlessTracking() {
    }
    RouterlessTracking.prototype.trackLocation = function (settings) {
        return new __WEBPACK_IMPORTED_MODULE_2_rxjs__["BehaviorSubject"]({ url: '/' });
    };
    RouterlessTracking.prototype.prepareExternalUrl = function (url) {
        return url;
    };
    return RouterlessTracking;
}());

var Angulartics2 = /** @class */ (function () {
    function Angulartics2(tracker, setup) {
        var _this = this;
        this.tracker = tracker;
        this.pageTrack = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.eventTrack = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.exceptionTrack = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.setAlias = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.setUsername = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.setUserProperties = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.setUserPropertiesOnce = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.setSuperProperties = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.setSuperPropertiesOnce = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        this.userTimings = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["ReplaySubject"](10);
        var defaultConfig = new DefaultConfig();
        this.settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, defaultConfig, setup.settings);
        this.settings.pageTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, defaultConfig.pageTracking, setup.settings.pageTracking);
        this.tracker
            .trackLocation(this.settings)
            .subscribe(function (event) {
            return _this.trackUrlChange(event.url);
        });
    }
    /** filters all events when developer mode is true */
    Angulartics2.prototype.filterDeveloperMode = function () {
        var _this = this;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["filter"])(function (value, index) { return !_this.settings.developerMode; });
    };
    Angulartics2.prototype.trackUrlChange = function (url) {
        if (this.settings.pageTracking.autoTrackVirtualPages && !this.matchesExcludedRoute(url)) {
            var clearedUrl = this.clearUrl(url);
            var path = void 0;
            if (this.settings.pageTracking.basePath.length) {
                path = this.settings.pageTracking.basePath + clearedUrl;
            }
            else {
                path = this.tracker.prepareExternalUrl(clearedUrl);
            }
            this.pageTrack.next({ path: path });
        }
    };
    /**
     * Use string literals or regular expressions to exclude routes
     * from automatic pageview tracking.
     *
     * @param url location
     */
    Angulartics2.prototype.matchesExcludedRoute = function (url) {
        var e_1, _a;
        try {
            for (var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(this.settings.pageTracking.excludedRoutes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var excludedRoute = _c.value;
                var matchesRegex = excludedRoute instanceof RegExp && excludedRoute.test(url);
                if (matchesRegex || url.indexOf(excludedRoute) !== -1) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    /**
     * Removes id's from tracked route.
     *  EX: `/project/12981/feature` becomes `/project/feature`
     *
     * @param url current page path
     */
    Angulartics2.prototype.clearUrl = function (url) {
        var _this = this;
        if (this.settings.pageTracking.clearIds || this.settings.pageTracking.clearQueryParams ||
            this.settings.pageTracking.clearHash) {
            return url
                .split('/')
                .map(function (part) { return _this.settings.pageTracking.clearQueryParams ? part.split('?')[0] : part; })
                .map(function (part) { return _this.settings.pageTracking.clearHash ? part.split('#')[0] : part; })
                .filter(function (part) { return !_this.settings.pageTracking.clearIds || !part.match(_this.settings.pageTracking.idsRegExp); })
                .join('/');
        }
        return url;
    };
    Angulartics2.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function Angulartics2_Factory() { return new Angulartics2(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(RouterlessTracking), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(ANGULARTICS2_TOKEN)); }, token: Angulartics2, providedIn: "root" });
    Angulartics2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])({ providedIn: 'root' }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(ANGULARTICS2_TOKEN)),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [RouterlessTracking, Object])
    ], Angulartics2);
    return Angulartics2;
}());

/**
 * Track Route changes for applications using Angular's
 * default router
 *
 * @link https://angular.io/api/router/Router
 */
var AngularRouterTracking = /** @class */ (function () {
    function AngularRouterTracking(router, location) {
        this.router = router;
        this.location = location;
    }
    AngularRouterTracking.prototype.trackLocation = function (settings) {
        return this.router.events.pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["filter"])(function (e) { return e instanceof __WEBPACK_IMPORTED_MODULE_5__angular_router__["NavigationEnd"]; }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["filter"])(function () { return !settings.developerMode; }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (e) {
            return { url: e.urlAfterRedirects };
        }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["delay"])(0));
    };
    AngularRouterTracking.prototype.prepareExternalUrl = function (url) {
        return this.location.prepareExternalUrl(url);
    };
    AngularRouterTracking.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function AngularRouterTracking_Factory() { return new AngularRouterTracking(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_5__angular_router__["Router"]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_4__angular_common__["Location"])); }, token: AngularRouterTracking, providedIn: "root" });
    AngularRouterTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])({ providedIn: 'root' }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_5__angular_router__["Router"],
            __WEBPACK_IMPORTED_MODULE_4__angular_common__["Location"]])
    ], AngularRouterTracking);
    return AngularRouterTracking;
}());

var Angulartics2On = /** @class */ (function () {
    function Angulartics2On(elRef, angulartics2, renderer) {
        this.elRef = elRef;
        this.angulartics2 = angulartics2;
        this.renderer = renderer;
        this.angularticsProperties = {};
    }
    Angulartics2On.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.renderer.listen(this.elRef.nativeElement, this.angulartics2On || 'click', function (event) { return _this.eventTrack(event); });
    };
    Angulartics2On.prototype.eventTrack = function (event) {
        var action = this.angularticsAction; // || this.inferEventName();
        var properties = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.angularticsProperties, { eventType: event.type });
        if (this.angularticsCategory) {
            properties.category = this.angularticsCategory;
        }
        if (this.angularticsLabel) {
            properties.label = this.angularticsLabel;
        }
        if (this.angularticsValue) {
            properties.value = this.angularticsValue;
        }
        this.angulartics2.eventTrack.next({
            action: action,
            properties: properties,
        });
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])('angulartics2On'),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:type", String)
    ], Angulartics2On.prototype, "angulartics2On", void 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:type", String)
    ], Angulartics2On.prototype, "angularticsAction", void 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:type", String)
    ], Angulartics2On.prototype, "angularticsCategory", void 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:type", String)
    ], Angulartics2On.prototype, "angularticsLabel", void 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:type", String)
    ], Angulartics2On.prototype, "angularticsValue", void 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:type", Object)
    ], Angulartics2On.prototype, "angularticsProperties", void 0);
    Angulartics2On = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"])({ selector: '[angulartics2On]' }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"],
            Angulartics2,
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer2"]])
    ], Angulartics2On);
    return Angulartics2On;
}());
var Angulartics2OnModule = /** @class */ (function () {
    function Angulartics2OnModule() {
    }
    Angulartics2OnModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            declarations: [Angulartics2On],
            exports: [Angulartics2On],
        })
    ], Angulartics2OnModule);
    return Angulartics2OnModule;
}());

var Angulartics2Module = /** @class */ (function () {
    function Angulartics2Module() {
    }
    Angulartics2Module_1 = Angulartics2Module;
    Angulartics2Module.forRoot = function (settings) {
        if (settings === void 0) { settings = {}; }
        return {
            ngModule: Angulartics2Module_1,
            providers: [
                { provide: ANGULARTICS2_TOKEN, useValue: { settings: settings } },
                { provide: RouterlessTracking, useClass: AngularRouterTracking },
                Angulartics2,
            ],
        };
    };
    var Angulartics2Module_1;
    Angulartics2Module = Angulartics2Module_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [Angulartics2OnModule],
            exports: [Angulartics2On],
        })
    ], Angulartics2Module);
    return Angulartics2Module;
}());

/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=angulartics2.js.map


/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dragulaExpt = __webpack_require__(756);
exports.dragula = dragulaExpt.default || dragulaExpt;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var dragula_class_1 = __webpack_require__(127);
var core_1 = __webpack_require__(0);
var DragulaService = (function () {
    function DragulaService() {
        this.cancel = new core_1.EventEmitter();
        this.cloned = new core_1.EventEmitter();
        this.drag = new core_1.EventEmitter();
        this.dragend = new core_1.EventEmitter();
        this.drop = new core_1.EventEmitter();
        this.out = new core_1.EventEmitter();
        this.over = new core_1.EventEmitter();
        this.remove = new core_1.EventEmitter();
        this.shadow = new core_1.EventEmitter();
        this.dropModel = new core_1.EventEmitter();
        this.removeModel = new core_1.EventEmitter();
        this.events = [
            'cancel', 'cloned', 'drag', 'dragend', 'drop', 'out', 'over',
            'remove', 'shadow', 'dropModel', 'removeModel'
        ];
        this.bags = [];
    }
    DragulaService.prototype.add = function (name, drake) {
        var bag = this.find(name);
        if (bag) {
            throw new Error('Bag named: "' + name + '" already exists.');
        }
        bag = { name: name, drake: drake };
        this.bags.push(bag);
        if (drake.models) {
            this.handleModels(name, drake);
        }
        if (!bag.initEvents) {
            this.setupEvents(bag);
        }
        return bag;
    };
    DragulaService.prototype.find = function (name) {
        for (var _i = 0, _a = this.bags; _i < _a.length; _i++) {
            var bag = _a[_i];
            if (bag.name === name) {
                return bag;
            }
        }
    };
    DragulaService.prototype.destroy = function (name) {
        var bag = this.find(name);
        var i = this.bags.indexOf(bag);
        this.bags.splice(i, 1);
        bag.drake.destroy();
    };
    DragulaService.prototype.setOptions = function (name, options) {
        var bag = this.add(name, dragula_class_1.dragula(options));
        this.handleModels(name, bag.drake);
    };
    DragulaService.prototype.handleModels = function (name, drake) {
        var _this = this;
        var dragElm;
        var dragIndex;
        var dropIndex;
        var sourceModel;
        drake.on('remove', function (el, source) {
            if (!drake.models) {
                return;
            }
            sourceModel = drake.models[drake.containers.indexOf(source)];
            sourceModel.splice(dragIndex, 1);
            // console.log('REMOVE');
            // console.log(sourceModel);
            _this.removeModel.emit([name, el, source]);
        });
        drake.on('drag', function (el, source) {
            dragElm = el;
            dragIndex = _this.domIndexOf(el, source);
        });
        drake.on('drop', function (dropElm, target, source) {
            if (!drake.models || !target) {
                return;
            }
            dropIndex = _this.domIndexOf(dropElm, target);
            sourceModel = drake.models[drake.containers.indexOf(source)];
            // console.log('DROP');
            // console.log(sourceModel);
            if (target === source) {
                sourceModel.splice(dropIndex, 0, sourceModel.splice(dragIndex, 1)[0]);
            }
            else {
                var notCopy = dragElm === dropElm;
                var targetModel = drake.models[drake.containers.indexOf(target)];
                var dropElmModel = notCopy ? sourceModel[dragIndex] : JSON.parse(JSON.stringify(sourceModel[dragIndex]));
                if (notCopy) {
                    sourceModel.splice(dragIndex, 1);
                }
                targetModel.splice(dropIndex, 0, dropElmModel);
                target.removeChild(dropElm); // element must be removed for ngFor to apply correctly
            }
            _this.dropModel.emit([name, dropElm, target, source]);
        });
    };
    DragulaService.prototype.setupEvents = function (bag) {
        bag.initEvents = true;
        var that = this;
        var emitter = function (type) {
            function replicate() {
                var args = Array.prototype.slice.call(arguments);
                that[type].emit([bag.name].concat(args));
            }
            bag.drake.on(type, replicate);
        };
        this.events.forEach(emitter);
    };
    DragulaService.prototype.domIndexOf = function (child, parent) {
        return Array.prototype.indexOf.call(parent.children, child);
    };
    return DragulaService;
}());
DragulaService = __decorate([
    core_1.Injectable()
], DragulaService);
exports.DragulaService = DragulaService;


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(15);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileDropDirective", function() { return FileDropDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileItem", function() { return FileItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileLikeObject", function() { return FileLikeObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileSelectDirective", function() { return FileSelectDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileUploadModule", function() { return FileUploadModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileUploader", function() { return FileUploader; });



/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} node
 * @return {?}
 */
function isElement(node) {
    return !!(node && (node.nodeName || node.prop && node.attr && node.find));
}
var FileLikeObject = /** @class */ (function () {
    function FileLikeObject(fileOrInput) {
        this.rawFile = fileOrInput;
        /** @type {?} */
        var isInput = isElement(fileOrInput);
        /** @type {?} */
        var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
        /** @type {?} */
        var postfix = typeof fakePathOrObject === 'string' ? 'FakePath' : 'Object';
        /** @type {?} */
        var method = '_createFrom' + postfix;
        ((/** @type {?} */ (this)))[method](fakePathOrObject);
    }
    /**
     * @param {?} path
     * @return {?}
     */
    FileLikeObject.prototype._createFromFakePath = /**
     * @param {?} path
     * @return {?}
     */
    function (path) {
        this.lastModifiedDate = void 0;
        this.size = void 0;
        this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
        this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
    };
    /**
     * @param {?} object
     * @return {?}
     */
    FileLikeObject.prototype._createFromObject = /**
     * @param {?} object
     * @return {?}
     */
    function (object) {
        this.size = object.size;
        this.type = object.type;
        this.name = object.name;
    };
    return FileLikeObject;
}());
if (false) {
    /** @type {?} */
    FileLikeObject.prototype.lastModifiedDate;
    /** @type {?} */
    FileLikeObject.prototype.size;
    /** @type {?} */
    FileLikeObject.prototype.type;
    /** @type {?} */
    FileLikeObject.prototype.name;
    /** @type {?} */
    FileLikeObject.prototype.rawFile;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileItem = /** @class */ (function () {
    function FileItem(uploader, some, options) {
        this.url = '/';
        this.headers = [];
        this.withCredentials = true;
        this.formData = [];
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.index = void 0;
        this.uploader = uploader;
        this.some = some;
        this.options = options;
        this.file = new FileLikeObject(some);
        this._file = some;
        if (uploader.options) {
            this.method = uploader.options.method || 'POST';
            this.alias = uploader.options.itemAlias || 'file';
        }
        this.url = uploader.options.url;
    }
    /**
     * @return {?}
     */
    FileItem.prototype.upload = /**
     * @return {?}
     */
    function () {
        try {
            this.uploader.uploadItem(this);
        }
        catch (e) {
            this.uploader._onCompleteItem(this, '', 0, {});
            this.uploader._onErrorItem(this, '', 0, {});
        }
    };
    /**
     * @return {?}
     */
    FileItem.prototype.cancel = /**
     * @return {?}
     */
    function () {
        this.uploader.cancelItem(this);
    };
    /**
     * @return {?}
     */
    FileItem.prototype.remove = /**
     * @return {?}
     */
    function () {
        this.uploader.removeFromQueue(this);
    };
    /**
     * @return {?}
     */
    FileItem.prototype.onBeforeUpload = /**
     * @return {?}
     */
    function () {
        return void 0;
    };
    /**
     * @param {?} form
     * @return {?}
     */
    FileItem.prototype.onBuildForm = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        return { form: form };
    };
    /**
     * @param {?} progress
     * @return {?}
     */
    FileItem.prototype.onProgress = /**
     * @param {?} progress
     * @return {?}
     */
    function (progress) {
        return { progress: progress };
    };
    /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileItem.prototype.onSuccess = /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (response, status, headers) {
        return { response: response, status: status, headers: headers };
    };
    /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileItem.prototype.onError = /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (response, status, headers) {
        return { response: response, status: status, headers: headers };
    };
    /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileItem.prototype.onCancel = /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (response, status, headers) {
        return { response: response, status: status, headers: headers };
    };
    /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileItem.prototype.onComplete = /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (response, status, headers) {
        return { response: response, status: status, headers: headers };
    };
    /**
     * @return {?}
     */
    FileItem.prototype._onBeforeUpload = /**
     * @return {?}
     */
    function () {
        this.isReady = true;
        this.isUploading = true;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = false;
        this.progress = 0;
        this.onBeforeUpload();
    };
    /**
     * @param {?} form
     * @return {?}
     */
    FileItem.prototype._onBuildForm = /**
     * @param {?} form
     * @return {?}
     */
    function (form) {
        this.onBuildForm(form);
    };
    /**
     * @param {?} progress
     * @return {?}
     */
    FileItem.prototype._onProgress = /**
     * @param {?} progress
     * @return {?}
     */
    function (progress) {
        this.progress = progress;
        this.onProgress(progress);
    };
    /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileItem.prototype._onSuccess = /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = true;
        this.isCancel = false;
        this.isError = false;
        this.progress = 100;
        this.index = void 0;
        this.onSuccess(response, status, headers);
    };
    /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileItem.prototype._onError = /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = true;
        this.isSuccess = false;
        this.isCancel = false;
        this.isError = true;
        this.progress = 0;
        this.index = void 0;
        this.onError(response, status, headers);
    };
    /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileItem.prototype._onCancel = /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (response, status, headers) {
        this.isReady = false;
        this.isUploading = false;
        this.isUploaded = false;
        this.isSuccess = false;
        this.isCancel = true;
        this.isError = false;
        this.progress = 0;
        this.index = void 0;
        this.onCancel(response, status, headers);
    };
    /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileItem.prototype._onComplete = /**
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (response, status, headers) {
        this.onComplete(response, status, headers);
        if (this.uploader.options.removeAfterUpload) {
            this.remove();
        }
    };
    /**
     * @return {?}
     */
    FileItem.prototype._prepareToUploading = /**
     * @return {?}
     */
    function () {
        this.index = this.index || ++this.uploader._nextIndex;
        this.isReady = true;
    };
    return FileItem;
}());
if (false) {
    /** @type {?} */
    FileItem.prototype.file;
    /** @type {?} */
    FileItem.prototype._file;
    /** @type {?} */
    FileItem.prototype.alias;
    /** @type {?} */
    FileItem.prototype.url;
    /** @type {?} */
    FileItem.prototype.method;
    /** @type {?} */
    FileItem.prototype.headers;
    /** @type {?} */
    FileItem.prototype.withCredentials;
    /** @type {?} */
    FileItem.prototype.formData;
    /** @type {?} */
    FileItem.prototype.isReady;
    /** @type {?} */
    FileItem.prototype.isUploading;
    /** @type {?} */
    FileItem.prototype.isUploaded;
    /** @type {?} */
    FileItem.prototype.isSuccess;
    /** @type {?} */
    FileItem.prototype.isCancel;
    /** @type {?} */
    FileItem.prototype.isError;
    /** @type {?} */
    FileItem.prototype.progress;
    /** @type {?} */
    FileItem.prototype.index;
    /** @type {?} */
    FileItem.prototype._xhr;
    /** @type {?} */
    FileItem.prototype._form;
    /**
     * @type {?}
     * @protected
     */
    FileItem.prototype.uploader;
    /**
     * @type {?}
     * @protected
     */
    FileItem.prototype.some;
    /**
     * @type {?}
     * @protected
     */
    FileItem.prototype.options;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileType = /** @class */ (function () {
    function FileType() {
    }
    /**
     * @param {?} file
     * @return {?}
     */
    FileType.getMimeClass = /**
     * @param {?} file
     * @return {?}
     */
    function (file) {
        /** @type {?} */
        var mimeClass = 'application';
        if (this.mime_psd.indexOf(file.type) !== -1) {
            mimeClass = 'image';
        }
        else if (file.type.match('image.*')) {
            mimeClass = 'image';
        }
        else if (file.type.match('video.*')) {
            mimeClass = 'video';
        }
        else if (file.type.match('audio.*')) {
            mimeClass = 'audio';
        }
        else if (file.type === 'application/pdf') {
            mimeClass = 'pdf';
        }
        else if (this.mime_compress.indexOf(file.type) !== -1) {
            mimeClass = 'compress';
        }
        else if (this.mime_doc.indexOf(file.type) !== -1) {
            mimeClass = 'doc';
        }
        else if (this.mime_xsl.indexOf(file.type) !== -1) {
            mimeClass = 'xls';
        }
        else if (this.mime_ppt.indexOf(file.type) !== -1) {
            mimeClass = 'ppt';
        }
        if (mimeClass === 'application') {
            mimeClass = this.fileTypeDetection(file.name);
        }
        return mimeClass;
    };
    /**
     * @param {?} inputFilename
     * @return {?}
     */
    FileType.fileTypeDetection = /**
     * @param {?} inputFilename
     * @return {?}
     */
    function (inputFilename) {
        /** @type {?} */
        var types = {
            'jpg': 'image',
            'jpeg': 'image',
            'tif': 'image',
            'psd': 'image',
            'bmp': 'image',
            'png': 'image',
            'nef': 'image',
            'tiff': 'image',
            'cr2': 'image',
            'dwg': 'image',
            'cdr': 'image',
            'ai': 'image',
            'indd': 'image',
            'pin': 'image',
            'cdp': 'image',
            'skp': 'image',
            'stp': 'image',
            '3dm': 'image',
            'mp3': 'audio',
            'wav': 'audio',
            'wma': 'audio',
            'mod': 'audio',
            'm4a': 'audio',
            'compress': 'compress',
            'zip': 'compress',
            'rar': 'compress',
            '7z': 'compress',
            'lz': 'compress',
            'z01': 'compress',
            'bz2': 'compress',
            'gz': 'compress',
            'pdf': 'pdf',
            'xls': 'xls',
            'xlsx': 'xls',
            'ods': 'xls',
            'mp4': 'video',
            'avi': 'video',
            'wmv': 'video',
            'mpg': 'video',
            'mts': 'video',
            'flv': 'video',
            '3gp': 'video',
            'vob': 'video',
            'm4v': 'video',
            'mpeg': 'video',
            'm2ts': 'video',
            'mov': 'video',
            'doc': 'doc',
            'docx': 'doc',
            'eps': 'doc',
            'txt': 'doc',
            'odt': 'doc',
            'rtf': 'doc',
            'ppt': 'ppt',
            'pptx': 'ppt',
            'pps': 'ppt',
            'ppsx': 'ppt',
            'odp': 'ppt'
        };
        /** @type {?} */
        var chunks = inputFilename.split('.');
        if (chunks.length < 2) {
            return 'application';
        }
        /** @type {?} */
        var extension = chunks[chunks.length - 1].toLowerCase();
        if (types[extension] === undefined) {
            return 'application';
        }
        else {
            return types[extension];
        }
    };
    /*  MS office  */
    FileType.mime_doc = [
        'application/msword',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroEnabled.12',
        'application/vnd.ms-word.template.macroEnabled.12'
    ];
    FileType.mime_xsl = [
        'application/vnd.ms-excel',
        'application/vnd.ms-excel',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroEnabled.12',
        'application/vnd.ms-excel.template.macroEnabled.12',
        'application/vnd.ms-excel.addin.macroEnabled.12',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ];
    FileType.mime_ppt = [
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ];
    /* PSD */
    FileType.mime_psd = [
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd'
    ];
    /* Compressed files */
    FileType.mime_compress = [
        'application/x-gtar',
        'application/x-gcompress',
        'application/compress',
        'application/x-tar',
        'application/x-rar-compressed',
        'application/octet-stream',
        'application/x-zip-compressed',
        'application/zip-compressed',
        'application/x-7z-compressed',
        'application/gzip',
        'application/x-bzip2'
    ];
    return FileType;
}());
if (false) {
    /** @type {?} */
    FileType.mime_doc;
    /** @type {?} */
    FileType.mime_xsl;
    /** @type {?} */
    FileType.mime_ppt;
    /** @type {?} */
    FileType.mime_psd;
    /** @type {?} */
    FileType.mime_compress;
}

var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
/**
 * @param {?} value
 * @return {?}
 */
function isFile(value) {
    return (File && value instanceof File);
}
/**
 * @record
 */
function Headers() { }
if (false) {
    /** @type {?} */
    Headers.prototype.name;
    /** @type {?} */
    Headers.prototype.value;
}
/**
 * @record
 */
function FileUploaderOptions() { }
if (false) {
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.allowedMimeType;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.allowedFileType;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.autoUpload;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.isHTML5;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.filters;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.headers;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.method;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.authToken;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.maxFileSize;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.queueLimit;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.removeAfterUpload;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.url;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.disableMultipart;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.itemAlias;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.authTokenHeader;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.additionalParameter;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.parametersBeforeFiles;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.formatDataFunction;
    /** @type {?|undefined} */
    FileUploaderOptions.prototype.formatDataFunctionIsAsync;
}
var FileUploader = /** @class */ (function () {
    function FileUploader(options) {
        this.isUploading = false;
        this.queue = [];
        this.progress = 0;
        this._nextIndex = 0;
        this.options = {
            autoUpload: false,
            isHTML5: true,
            filters: [],
            removeAfterUpload: false,
            disableMultipart: false,
            formatDataFunction: (/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return item._file; }),
            formatDataFunctionIsAsync: false
        };
        this.setOptions(options);
        this.response = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    /**
     * @param {?} options
     * @return {?}
     */
    FileUploader.prototype.setOptions = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        this.options = Object.assign(this.options, options);
        this.authToken = this.options.authToken;
        this.authTokenHeader = this.options.authTokenHeader || 'Authorization';
        this.autoUpload = this.options.autoUpload;
        this.options.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
        if (this.options.maxFileSize) {
            this.options.filters.unshift({ name: 'fileSize', fn: this._fileSizeFilter });
        }
        if (this.options.allowedFileType) {
            this.options.filters.unshift({ name: 'fileType', fn: this._fileTypeFilter });
        }
        if (this.options.allowedMimeType) {
            this.options.filters.unshift({ name: 'mimeType', fn: this._mimeTypeFilter });
        }
        for (var i = 0; i < this.queue.length; i++) {
            this.queue[i].url = this.options.url;
        }
    };
    /**
     * @param {?} files
     * @param {?=} options
     * @param {?=} filters
     * @return {?}
     */
    FileUploader.prototype.addToQueue = /**
     * @param {?} files
     * @param {?=} options
     * @param {?=} filters
     * @return {?}
     */
    function (files, options, filters) {
        var e_1, _a;
        var _this = this;
        /** @type {?} */
        var list = [];
        try {
            for (var files_1 = __values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
                var file = files_1_1.value;
                list.push(file);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        /** @type {?} */
        var arrayOfFilters = this._getFilters(filters);
        /** @type {?} */
        var count = this.queue.length;
        /** @type {?} */
        var addedFileItems = [];
        list.map((/**
         * @param {?} some
         * @return {?}
         */
        function (some) {
            if (!options) {
                options = _this.options;
            }
            /** @type {?} */
            var temp = new FileLikeObject(some);
            if (_this._isValidFile(temp, arrayOfFilters, options)) {
                /** @type {?} */
                var fileItem = new FileItem(_this, some, options);
                addedFileItems.push(fileItem);
                _this.queue.push(fileItem);
                _this._onAfterAddingFile(fileItem);
            }
            else {
                /** @type {?} */
                var filter = arrayOfFilters[_this._failFilterIndex];
                _this._onWhenAddingFileFailed(temp, filter, options);
            }
        }));
        if (this.queue.length !== count) {
            this._onAfterAddingAll(addedFileItems);
            this.progress = this._getTotalProgress();
        }
        this._render();
        if (this.options.autoUpload) {
            this.uploadAll();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FileUploader.prototype.removeFromQueue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var index = this.getIndexOfItem(value);
        /** @type {?} */
        var item = this.queue[index];
        if (item.isUploading) {
            item.cancel();
        }
        this.queue.splice(index, 1);
        this.progress = this._getTotalProgress();
    };
    /**
     * @return {?}
     */
    FileUploader.prototype.clearQueue = /**
     * @return {?}
     */
    function () {
        while (this.queue.length) {
            this.queue[0].remove();
        }
        this.progress = 0;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FileUploader.prototype.uploadItem = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var index = this.getIndexOfItem(value);
        /** @type {?} */
        var item = this.queue[index];
        /** @type {?} */
        var transport = this.options.isHTML5 ? '_xhrTransport' : '_iframeTransport';
        item._prepareToUploading();
        if (this.isUploading) {
            return;
        }
        this.isUploading = true;
        ((/** @type {?} */ (this)))[transport](item);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FileUploader.prototype.cancelItem = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var index = this.getIndexOfItem(value);
        /** @type {?} */
        var item = this.queue[index];
        /** @type {?} */
        var prop = this.options.isHTML5 ? item._xhr : item._form;
        if (item && item.isUploading) {
            prop.abort();
        }
    };
    /**
     * @return {?}
     */
    FileUploader.prototype.uploadAll = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var items = this.getNotUploadedItems().filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return !item.isUploading; }));
        if (!items.length) {
            return;
        }
        items.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item._prepareToUploading(); }));
        items[0].upload();
    };
    /**
     * @return {?}
     */
    FileUploader.prototype.cancelAll = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var items = this.getNotUploadedItems();
        items.map((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return item.cancel(); }));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FileUploader.prototype.isFile = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return isFile(value);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FileUploader.prototype.isFileLikeObject = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return value instanceof FileLikeObject;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FileUploader.prototype.getIndexOfItem = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return typeof value === 'number' ? value : this.queue.indexOf(value);
    };
    /**
     * @return {?}
     */
    FileUploader.prototype.getNotUploadedItems = /**
     * @return {?}
     */
    function () {
        return this.queue.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return !item.isUploaded; }));
    };
    /**
     * @return {?}
     */
    FileUploader.prototype.getReadyItems = /**
     * @return {?}
     */
    function () {
        return this.queue
            .filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return (item.isReady && !item.isUploading); }))
            .sort((/**
         * @param {?} item1
         * @param {?} item2
         * @return {?}
         */
        function (item1, item2) { return item1.index - item2.index; }));
    };
    /**
     * @return {?}
     */
    FileUploader.prototype.destroy = /**
     * @return {?}
     */
    function () {
        return void 0;
    };
    /**
     * @param {?} fileItems
     * @return {?}
     */
    FileUploader.prototype.onAfterAddingAll = /**
     * @param {?} fileItems
     * @return {?}
     */
    function (fileItems) {
        return { fileItems: fileItems };
    };
    /**
     * @param {?} fileItem
     * @param {?} form
     * @return {?}
     */
    FileUploader.prototype.onBuildItemForm = /**
     * @param {?} fileItem
     * @param {?} form
     * @return {?}
     */
    function (fileItem, form) {
        return { fileItem: fileItem, form: form };
    };
    /**
     * @param {?} fileItem
     * @return {?}
     */
    FileUploader.prototype.onAfterAddingFile = /**
     * @param {?} fileItem
     * @return {?}
     */
    function (fileItem) {
        return { fileItem: fileItem };
    };
    /**
     * @param {?} item
     * @param {?} filter
     * @param {?} options
     * @return {?}
     */
    FileUploader.prototype.onWhenAddingFileFailed = /**
     * @param {?} item
     * @param {?} filter
     * @param {?} options
     * @return {?}
     */
    function (item, filter, options) {
        return { item: item, filter: filter, options: options };
    };
    /**
     * @param {?} fileItem
     * @return {?}
     */
    FileUploader.prototype.onBeforeUploadItem = /**
     * @param {?} fileItem
     * @return {?}
     */
    function (fileItem) {
        return { fileItem: fileItem };
    };
    /**
     * @param {?} fileItem
     * @param {?} progress
     * @return {?}
     */
    FileUploader.prototype.onProgressItem = /**
     * @param {?} fileItem
     * @param {?} progress
     * @return {?}
     */
    function (fileItem, progress) {
        return { fileItem: fileItem, progress: progress };
    };
    /**
     * @param {?} progress
     * @return {?}
     */
    FileUploader.prototype.onProgressAll = /**
     * @param {?} progress
     * @return {?}
     */
    function (progress) {
        return { progress: progress };
    };
    /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype.onSuccessItem = /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (item, response, status, headers) {
        return { item: item, response: response, status: status, headers: headers };
    };
    /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype.onErrorItem = /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (item, response, status, headers) {
        return { item: item, response: response, status: status, headers: headers };
    };
    /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype.onCancelItem = /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (item, response, status, headers) {
        return { item: item, response: response, status: status, headers: headers };
    };
    /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype.onCompleteItem = /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (item, response, status, headers) {
        return { item: item, response: response, status: status, headers: headers };
    };
    /**
     * @return {?}
     */
    FileUploader.prototype.onCompleteAll = /**
     * @return {?}
     */
    function () {
        return void 0;
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FileUploader.prototype._mimeTypeFilter = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return !(this.options.allowedMimeType && this.options.allowedMimeType.indexOf(item.type) === -1);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FileUploader.prototype._fileSizeFilter = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return !(this.options.maxFileSize && item.size > this.options.maxFileSize);
    };
    /**
     * @param {?} item
     * @return {?}
     */
    FileUploader.prototype._fileTypeFilter = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        return !(this.options.allowedFileType &&
            this.options.allowedFileType.indexOf(FileType.getMimeClass(item)) === -1);
    };
    /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype._onErrorItem = /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (item, response, status, headers) {
        item._onError(response, status, headers);
        this.onErrorItem(item, response, status, headers);
    };
    /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype._onCompleteItem = /**
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (item, response, status, headers) {
        item._onComplete(response, status, headers);
        this.onCompleteItem(item, response, status, headers);
        /** @type {?} */
        var nextItem = this.getReadyItems()[0];
        this.isUploading = false;
        if (nextItem) {
            nextItem.upload();
            return;
        }
        this.onCompleteAll();
        this.progress = this._getTotalProgress();
        this._render();
    };
    /**
     * @protected
     * @param {?} parsedHeaders
     * @return {?}
     */
    FileUploader.prototype._headersGetter = /**
     * @protected
     * @param {?} parsedHeaders
     * @return {?}
     */
    function (parsedHeaders) {
        return (/**
         * @param {?} name
         * @return {?}
         */
        function (name) {
            if (name) {
                return parsedHeaders[name.toLowerCase()] || void 0;
            }
            return parsedHeaders;
        });
    };
    /**
     * @protected
     * @param {?} item
     * @return {?}
     */
    FileUploader.prototype._xhrTransport = /**
     * @protected
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var e_2, _a, e_3, _b;
        var _this = this;
        /** @type {?} */
        var that = this;
        /** @type {?} */
        var xhr = item._xhr = new XMLHttpRequest();
        /** @type {?} */
        var sendable;
        this._onBeforeUploadItem(item);
        if (typeof item._file.size !== 'number') {
            throw new TypeError('The file specified is no longer valid');
        }
        if (!this.options.disableMultipart) {
            sendable = new FormData();
            this._onBuildItemForm(item, sendable);
            /** @type {?} */
            var appendFile = (/**
             * @return {?}
             */
            function () { return sendable.append(item.alias, item._file, item.file.name); });
            if (!this.options.parametersBeforeFiles) {
                appendFile();
            }
            // For AWS, Additional Parameters must come BEFORE Files
            if (this.options.additionalParameter !== undefined) {
                Object.keys(this.options.additionalParameter).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                function (key) {
                    /** @type {?} */
                    var paramVal = _this.options.additionalParameter[key];
                    // Allow an additional parameter to include the filename
                    if (typeof paramVal === 'string' && paramVal.indexOf('{{file_name}}') >= 0) {
                        paramVal = paramVal.replace('{{file_name}}', item.file.name);
                    }
                    sendable.append(key, paramVal);
                }));
            }
            if (this.options.parametersBeforeFiles) {
                appendFile();
            }
        }
        else {
            sendable = this.options.formatDataFunction(item);
        }
        xhr.upload.onprogress = (/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            /** @type {?} */
            var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
            _this._onProgressItem(item, progress);
        });
        xhr.onload = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
            /** @type {?} */
            var response = _this._transformResponse(xhr.response, headers);
            /** @type {?} */
            var gist = _this._isSuccessCode(xhr.status) ? 'Success' : 'Error';
            /** @type {?} */
            var method = '_on' + gist + 'Item';
            ((/** @type {?} */ (_this)))[method](item, response, xhr.status, headers);
            _this._onCompleteItem(item, response, xhr.status, headers);
        });
        xhr.onerror = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
            /** @type {?} */
            var response = _this._transformResponse(xhr.response, headers);
            _this._onErrorItem(item, response, xhr.status, headers);
            _this._onCompleteItem(item, response, xhr.status, headers);
        });
        xhr.onabort = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
            /** @type {?} */
            var response = _this._transformResponse(xhr.response, headers);
            _this._onCancelItem(item, response, xhr.status, headers);
            _this._onCompleteItem(item, response, xhr.status, headers);
        });
        xhr.open(item.method, item.url, true);
        xhr.withCredentials = item.withCredentials;
        if (this.options.headers) {
            try {
                for (var _c = __values(this.options.headers), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var header = _d.value;
                    xhr.setRequestHeader(header.name, header.value);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        if (item.headers.length) {
            try {
                for (var _e = __values(item.headers), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var header = _f.value;
                    xhr.setRequestHeader(header.name, header.value);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        if (this.authToken) {
            xhr.setRequestHeader(this.authTokenHeader, this.authToken);
        }
        xhr.onreadystatechange = (/**
         * @return {?}
         */
        function () {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                that.response.emit(xhr.responseText);
            }
        });
        if (this.options.formatDataFunctionIsAsync) {
            sendable.then((/**
             * @param {?} result
             * @return {?}
             */
            function (result) { return xhr.send(JSON.stringify(result)); }));
        }
        else {
            xhr.send(sendable);
        }
        this._render();
    };
    /**
     * @protected
     * @param {?=} value
     * @return {?}
     */
    FileUploader.prototype._getTotalProgress = /**
     * @protected
     * @param {?=} value
     * @return {?}
     */
    function (value) {
        if (value === void 0) { value = 0; }
        if (this.options.removeAfterUpload) {
            return value;
        }
        /** @type {?} */
        var notUploaded = this.getNotUploadedItems().length;
        /** @type {?} */
        var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
        /** @type {?} */
        var ratio = 100 / this.queue.length;
        /** @type {?} */
        var current = value * ratio / 100;
        return Math.round(uploaded * ratio + current);
    };
    /**
     * @protected
     * @param {?} filters
     * @return {?}
     */
    FileUploader.prototype._getFilters = /**
     * @protected
     * @param {?} filters
     * @return {?}
     */
    function (filters) {
        if (!filters) {
            return this.options.filters;
        }
        if (Array.isArray(filters)) {
            return filters;
        }
        if (typeof filters === 'string') {
            /** @type {?} */
            var names_1 = filters.match(/[^\s,]+/g);
            return this.options.filters
                .filter((/**
             * @param {?} filter
             * @return {?}
             */
            function (filter) { return names_1.indexOf(filter.name) !== -1; }));
        }
        return this.options.filters;
    };
    /**
     * @protected
     * @return {?}
     */
    FileUploader.prototype._render = /**
     * @protected
     * @return {?}
     */
    function () {
        return void 0;
    };
    /**
     * @protected
     * @return {?}
     */
    FileUploader.prototype._queueLimitFilter = /**
     * @protected
     * @return {?}
     */
    function () {
        return this.options.queueLimit === undefined || this.queue.length < this.options.queueLimit;
    };
    /**
     * @protected
     * @param {?} file
     * @param {?} filters
     * @param {?} options
     * @return {?}
     */
    FileUploader.prototype._isValidFile = /**
     * @protected
     * @param {?} file
     * @param {?} filters
     * @param {?} options
     * @return {?}
     */
    function (file, filters, options) {
        var _this = this;
        this._failFilterIndex = -1;
        return !filters.length ? true : filters.every((/**
         * @param {?} filter
         * @return {?}
         */
        function (filter) {
            _this._failFilterIndex++;
            return filter.fn.call(_this, file, options);
        }));
    };
    /**
     * @protected
     * @param {?} status
     * @return {?}
     */
    FileUploader.prototype._isSuccessCode = /**
     * @protected
     * @param {?} status
     * @return {?}
     */
    function (status) {
        return (status >= 200 && status < 300) || status === 304;
    };
    /**
     * @protected
     * @param {?} response
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype._transformResponse = /**
     * @protected
     * @param {?} response
     * @param {?} headers
     * @return {?}
     */
    function (response, headers) {
        return response;
    };
    /**
     * @protected
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype._parseHeaders = /**
     * @protected
     * @param {?} headers
     * @return {?}
     */
    function (headers) {
        /** @type {?} */
        var parsed = {};
        /** @type {?} */
        var key;
        /** @type {?} */
        var val;
        /** @type {?} */
        var i;
        if (!headers) {
            return parsed;
        }
        headers.split('\n').map((/**
         * @param {?} line
         * @return {?}
         */
        function (line) {
            i = line.indexOf(':');
            key = line.slice(0, i).trim().toLowerCase();
            val = line.slice(i + 1).trim();
            if (key) {
                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
        }));
        return parsed;
    };
    /**
     * @protected
     * @param {?} item
     * @param {?} filter
     * @param {?} options
     * @return {?}
     */
    FileUploader.prototype._onWhenAddingFileFailed = /**
     * @protected
     * @param {?} item
     * @param {?} filter
     * @param {?} options
     * @return {?}
     */
    function (item, filter, options) {
        this.onWhenAddingFileFailed(item, filter, options);
    };
    /**
     * @protected
     * @param {?} item
     * @return {?}
     */
    FileUploader.prototype._onAfterAddingFile = /**
     * @protected
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.onAfterAddingFile(item);
    };
    /**
     * @protected
     * @param {?} items
     * @return {?}
     */
    FileUploader.prototype._onAfterAddingAll = /**
     * @protected
     * @param {?} items
     * @return {?}
     */
    function (items) {
        this.onAfterAddingAll(items);
    };
    /**
     * @protected
     * @param {?} item
     * @return {?}
     */
    FileUploader.prototype._onBeforeUploadItem = /**
     * @protected
     * @param {?} item
     * @return {?}
     */
    function (item) {
        item._onBeforeUpload();
        this.onBeforeUploadItem(item);
    };
    /**
     * @protected
     * @param {?} item
     * @param {?} form
     * @return {?}
     */
    FileUploader.prototype._onBuildItemForm = /**
     * @protected
     * @param {?} item
     * @param {?} form
     * @return {?}
     */
    function (item, form) {
        item._onBuildForm(form);
        this.onBuildItemForm(item, form);
    };
    /**
     * @protected
     * @param {?} item
     * @param {?} progress
     * @return {?}
     */
    FileUploader.prototype._onProgressItem = /**
     * @protected
     * @param {?} item
     * @param {?} progress
     * @return {?}
     */
    function (item, progress) {
        /** @type {?} */
        var total = this._getTotalProgress(progress);
        this.progress = total;
        item._onProgress(progress);
        this.onProgressItem(item, progress);
        this.onProgressAll(total);
        this._render();
    };
    /**
     * @protected
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype._onSuccessItem = /**
     * @protected
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (item, response, status, headers) {
        item._onSuccess(response, status, headers);
        this.onSuccessItem(item, response, status, headers);
    };
    /**
     * @protected
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    FileUploader.prototype._onCancelItem = /**
     * @protected
     * @param {?} item
     * @param {?} response
     * @param {?} status
     * @param {?} headers
     * @return {?}
     */
    function (item, response, status, headers) {
        item._onCancel(response, status, headers);
        this.onCancelItem(item, response, status, headers);
    };
    return FileUploader;
}());
if (false) {
    /** @type {?} */
    FileUploader.prototype.authToken;
    /** @type {?} */
    FileUploader.prototype.isUploading;
    /** @type {?} */
    FileUploader.prototype.queue;
    /** @type {?} */
    FileUploader.prototype.progress;
    /** @type {?} */
    FileUploader.prototype._nextIndex;
    /** @type {?} */
    FileUploader.prototype.autoUpload;
    /** @type {?} */
    FileUploader.prototype.authTokenHeader;
    /** @type {?} */
    FileUploader.prototype.response;
    /** @type {?} */
    FileUploader.prototype.options;
    /**
     * @type {?}
     * @protected
     */
    FileUploader.prototype._failFilterIndex;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileSelectDirective = /** @class */ (function () {
    function FileSelectDirective(element) {
        this.onFileSelected = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.element = element;
    }
    /**
     * @return {?}
     */
    FileSelectDirective.prototype.getOptions = /**
     * @return {?}
     */
    function () {
        return this.uploader.options;
    };
    /**
     * @return {?}
     */
    FileSelectDirective.prototype.getFilters = /**
     * @return {?}
     */
    function () {
        return {};
    };
    /**
     * @return {?}
     */
    FileSelectDirective.prototype.isEmptyAfterSelection = /**
     * @return {?}
     */
    function () {
        return !!this.element.nativeElement.attributes.multiple;
    };
    /**
     * @return {?}
     */
    FileSelectDirective.prototype.onChange = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var files = this.element.nativeElement.files;
        /** @type {?} */
        var options = this.getOptions();
        /** @type {?} */
        var filters = this.getFilters();
        this.uploader.addToQueue(files, options, filters);
        this.onFileSelected.emit(files);
        if (this.isEmptyAfterSelection()) {
            this.element.nativeElement.value = '';
        }
    };
    FileSelectDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ng2FileSelect]' },] }
    ];
    /** @nocollapse */
    FileSelectDirective.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] }
    ]; };
    FileSelectDirective.propDecorators = {
        uploader: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }],
        onFileSelected: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] }],
        onChange: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['change',] }]
    };
    return FileSelectDirective;
}());
if (false) {
    /** @type {?} */
    FileSelectDirective.prototype.uploader;
    /** @type {?} */
    FileSelectDirective.prototype.onFileSelected;
    /**
     * @type {?}
     * @protected
     */
    FileSelectDirective.prototype.element;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileDropDirective = /** @class */ (function () {
    function FileDropDirective(element) {
        this.fileOver = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.onFileDrop = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.element = element;
    }
    /**
     * @return {?}
     */
    FileDropDirective.prototype.getOptions = /**
     * @return {?}
     */
    function () {
        return this.uploader.options;
    };
    /**
     * @return {?}
     */
    FileDropDirective.prototype.getFilters = /**
     * @return {?}
     */
    function () {
        return {};
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FileDropDirective.prototype.onDrop = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var transfer = this._getTransfer(event);
        if (!transfer) {
            return;
        }
        /** @type {?} */
        var options = this.getOptions();
        /** @type {?} */
        var filters = this.getFilters();
        this._preventAndStop(event);
        this.uploader.addToQueue(transfer.files, options, filters);
        this.fileOver.emit(false);
        this.onFileDrop.emit(transfer.files);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FileDropDirective.prototype.onDragOver = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var transfer = this._getTransfer(event);
        if (!this._haveFiles(transfer.types)) {
            return;
        }
        transfer.dropEffect = 'copy';
        this._preventAndStop(event);
        this.fileOver.emit(true);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FileDropDirective.prototype.onDragLeave = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (((/** @type {?} */ (this))).element) {
            if (event.currentTarget === ((/** @type {?} */ (this))).element[0]) {
                return;
            }
        }
        this._preventAndStop(event);
        this.fileOver.emit(false);
    };
    /**
     * @protected
     * @param {?} event
     * @return {?}
     */
    FileDropDirective.prototype._getTransfer = /**
     * @protected
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    };
    /**
     * @protected
     * @param {?} event
     * @return {?}
     */
    FileDropDirective.prototype._preventAndStop = /**
     * @protected
     * @param {?} event
     * @return {?}
     */
    function (event) {
        event.preventDefault();
        event.stopPropagation();
    };
    /**
     * @protected
     * @param {?} types
     * @return {?}
     */
    FileDropDirective.prototype._haveFiles = /**
     * @protected
     * @param {?} types
     * @return {?}
     */
    function (types) {
        if (!types) {
            return false;
        }
        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        }
        else if (types.contains) {
            return types.contains('Files');
        }
        else {
            return false;
        }
    };
    FileDropDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ng2FileDrop]' },] }
    ];
    /** @nocollapse */
    FileDropDirective.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] }
    ]; };
    FileDropDirective.propDecorators = {
        uploader: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }],
        fileOver: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] }],
        onFileDrop: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] }],
        onDrop: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['drop', ['$event'],] }],
        onDragOver: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['dragover', ['$event'],] }],
        onDragLeave: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['dragleave', ['$event'],] }]
    };
    return FileDropDirective;
}());
if (false) {
    /** @type {?} */
    FileDropDirective.prototype.uploader;
    /** @type {?} */
    FileDropDirective.prototype.fileOver;
    /** @type {?} */
    FileDropDirective.prototype.onFileDrop;
    /**
     * @type {?}
     * @protected
     */
    FileDropDirective.prototype.element;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FileUploadModule = /** @class */ (function () {
    function FileUploadModule() {
    }
    FileUploadModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]],
                    declarations: [FileDropDirective, FileSelectDirective],
                    exports: [FileDropDirective, FileSelectDirective]
                },] }
    ];
    return FileUploadModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */


//# sourceMappingURL=ng2-file-upload.js.map


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(0);
/* unused harmony export UniqueSelectionDispatcher */
/* unused harmony export ArrayDataSource */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataSource; });
/* unused harmony export SelectionModel */
/* unused harmony export getMultipleValuesInSingleSelectionError */
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @abstract
 * @template T
 */
var  /**
 * @abstract
 * @template T
 */
DataSource = /** @class */ (function () {
    function DataSource() {
    }
    return DataSource;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * DataSource wrapper for a native array.
 * @template T
 */
var  /**
 * DataSource wrapper for a native array.
 * @template T
 */
ArrayDataSource = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ArrayDataSource, _super);
    function ArrayDataSource(_data) {
        var _this = _super.call(this) || this;
        _this._data = _data;
        return _this;
    }
    /**
     * @return {?}
     */
    ArrayDataSource.prototype.connect = /**
     * @return {?}
     */
    function () {
        return this._data instanceof __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"] ? this._data : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs__["of"])(this._data);
    };
    /**
     * @return {?}
     */
    ArrayDataSource.prototype.disconnect = /**
     * @return {?}
     */
    function () { };
    return ArrayDataSource;
}(DataSource));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Class to be used to power selecting one or more options from a list.
 * @template T
 */
var  /**
 * Class to be used to power selecting one or more options from a list.
 * @template T
 */
SelectionModel = /** @class */ (function () {
    function SelectionModel(_multiple, initiallySelectedValues, _emitChanges) {
        if (_multiple === void 0) { _multiple = false; }
        if (_emitChanges === void 0) { _emitChanges = true; }
        var _this = this;
        this._multiple = _multiple;
        this._emitChanges = _emitChanges;
        /**
         * Currently-selected values.
         */
        this._selection = new Set();
        /**
         * Keeps track of the deselected options that haven't been emitted by the change event.
         */
        this._deselectedToEmit = [];
        /**
         * Keeps track of the selected options that haven't been emitted by the change event.
         */
        this._selectedToEmit = [];
        /**
         * Event emitted when the value has changed.
         */
        this.changed = this._emitChanges ? new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Subject"]() : null;
        /**
         * Event emitted when the value has changed.
         * @deprecated Use `changed` instead.
         * \@breaking-change 8.0.0 To be changed to `changed`
         */
        this.onChange = this.changed;
        if (initiallySelectedValues && initiallySelectedValues.length) {
            if (_multiple) {
                initiallySelectedValues.forEach(function (value) { return _this._markSelected(value); });
            }
            else {
                this._markSelected(initiallySelectedValues[0]);
            }
            // Clear the array in order to avoid firing the change event for preselected values.
            this._selectedToEmit.length = 0;
        }
    }
    Object.defineProperty(SelectionModel.prototype, "selected", {
        /** Selected values. */
        get: /**
         * Selected values.
         * @return {?}
         */
        function () {
            if (!this._selected) {
                this._selected = Array.from(this._selection.values());
            }
            return this._selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects a value or an array of values.
     */
    /**
     * Selects a value or an array of values.
     * @param {...?} values
     * @return {?}
     */
    SelectionModel.prototype.select = /**
     * Selects a value or an array of values.
     * @param {...?} values
     * @return {?}
     */
    function () {
        var _this = this;
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        this._verifyValueAssignment(values);
        values.forEach(function (value) { return _this._markSelected(value); });
        this._emitChangeEvent();
    };
    /**
     * Deselects a value or an array of values.
     */
    /**
     * Deselects a value or an array of values.
     * @param {...?} values
     * @return {?}
     */
    SelectionModel.prototype.deselect = /**
     * Deselects a value or an array of values.
     * @param {...?} values
     * @return {?}
     */
    function () {
        var _this = this;
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        this._verifyValueAssignment(values);
        values.forEach(function (value) { return _this._unmarkSelected(value); });
        this._emitChangeEvent();
    };
    /**
     * Toggles a value between selected and deselected.
     */
    /**
     * Toggles a value between selected and deselected.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.toggle = /**
     * Toggles a value between selected and deselected.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.isSelected(value) ? this.deselect(value) : this.select(value);
    };
    /**
     * Clears all of the selected values.
     */
    /**
     * Clears all of the selected values.
     * @return {?}
     */
    SelectionModel.prototype.clear = /**
     * Clears all of the selected values.
     * @return {?}
     */
    function () {
        this._unmarkAll();
        this._emitChangeEvent();
    };
    /**
     * Determines whether a value is selected.
     */
    /**
     * Determines whether a value is selected.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.isSelected = /**
     * Determines whether a value is selected.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return this._selection.has(value);
    };
    /**
     * Determines whether the model does not have a value.
     */
    /**
     * Determines whether the model does not have a value.
     * @return {?}
     */
    SelectionModel.prototype.isEmpty = /**
     * Determines whether the model does not have a value.
     * @return {?}
     */
    function () {
        return this._selection.size === 0;
    };
    /**
     * Determines whether the model has a value.
     */
    /**
     * Determines whether the model has a value.
     * @return {?}
     */
    SelectionModel.prototype.hasValue = /**
     * Determines whether the model has a value.
     * @return {?}
     */
    function () {
        return !this.isEmpty();
    };
    /**
     * Sorts the selected values based on a predicate function.
     */
    /**
     * Sorts the selected values based on a predicate function.
     * @param {?=} predicate
     * @return {?}
     */
    SelectionModel.prototype.sort = /**
     * Sorts the selected values based on a predicate function.
     * @param {?=} predicate
     * @return {?}
     */
    function (predicate) {
        if (this._multiple && this.selected) {
            /** @type {?} */ ((this._selected)).sort(predicate);
        }
    };
    /**
     * Gets whether multiple values can be selected.
     */
    /**
     * Gets whether multiple values can be selected.
     * @return {?}
     */
    SelectionModel.prototype.isMultipleSelection = /**
     * Gets whether multiple values can be selected.
     * @return {?}
     */
    function () {
        return this._multiple;
    };
    /**
     * Emits a change event and clears the records of selected and deselected values.
     * @return {?}
     */
    SelectionModel.prototype._emitChangeEvent = /**
     * Emits a change event and clears the records of selected and deselected values.
     * @return {?}
     */
    function () {
        // Clear the selected values so they can be re-cached.
        this._selected = null;
        if (this._selectedToEmit.length || this._deselectedToEmit.length) {
            if (this.changed) {
                this.changed.next({
                    source: this,
                    added: this._selectedToEmit,
                    removed: this._deselectedToEmit
                });
            }
            this._deselectedToEmit = [];
            this._selectedToEmit = [];
        }
    };
    /**
     * Selects a value.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype._markSelected = /**
     * Selects a value.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (!this.isSelected(value)) {
            if (!this._multiple) {
                this._unmarkAll();
            }
            this._selection.add(value);
            if (this._emitChanges) {
                this._selectedToEmit.push(value);
            }
        }
    };
    /**
     * Deselects a value.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype._unmarkSelected = /**
     * Deselects a value.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (this.isSelected(value)) {
            this._selection.delete(value);
            if (this._emitChanges) {
                this._deselectedToEmit.push(value);
            }
        }
    };
    /**
     * Clears out the selected values.
     * @return {?}
     */
    SelectionModel.prototype._unmarkAll = /**
     * Clears out the selected values.
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.isEmpty()) {
            this._selection.forEach(function (value) { return _this._unmarkSelected(value); });
        }
    };
    /**
     * Verifies the value assignment and throws an error if the specified value array is
     * including multiple values while the selection model is not supporting multiple values.
     * @param {?} values
     * @return {?}
     */
    SelectionModel.prototype._verifyValueAssignment = /**
     * Verifies the value assignment and throws an error if the specified value array is
     * including multiple values while the selection model is not supporting multiple values.
     * @param {?} values
     * @return {?}
     */
    function (values) {
        if (values.length > 1 && !this._multiple) {
            throw getMultipleValuesInSingleSelectionError();
        }
    };
    return SelectionModel;
}());
/**
 * Returns an error that reports that multiple values are passed into a selection model
 * with a single value.
 * @return {?}
 */
function getMultipleValuesInSingleSelectionError() {
    return Error('Cannot pass multiple values into SelectionModel with single-value mode.');
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Class to coordinate unique selection based on name.
 * Intended to be consumed as an Angular service.
 * This service is needed because native radio change events are only fired on the item currently
 * being selected, and we still need to uncheck the previous selection.
 *
 * This service does not *store* any IDs and names because they may change at any time, so it is
 * less error-prone if they are simply passed through when the events occur.
 */
var UniqueSelectionDispatcher = /** @class */ (function () {
    function UniqueSelectionDispatcher() {
        this._listeners = [];
    }
    /**
     * Notify other items that selection for the given name has been set.
     * @param id ID of the item.
     * @param name Name of the item.
     */
    /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.notify = /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
    function (id, name) {
        for (var _i = 0, _a = this._listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(id, name);
        }
    };
    /**
     * Listen for future changes to item selection.
     * @return Function used to deregister listener
     */
    /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?} Function used to deregister listener
     */
    UniqueSelectionDispatcher.prototype.listen = /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?} Function used to deregister listener
     */
    function (listener) {
        var _this = this;
        this._listeners.push(listener);
        return function () {
            _this._listeners = _this._listeners.filter(function (registered) {
                return listener !== registered;
            });
        };
    };
    /**
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._listeners = [];
    };
    UniqueSelectionDispatcher.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */ UniqueSelectionDispatcher.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["defineInjectable"])({ factory: function UniqueSelectionDispatcher_Factory() { return new UniqueSelectionDispatcher(); }, token: UniqueSelectionDispatcher, providedIn: "root" });
    return UniqueSelectionDispatcher;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


//# sourceMappingURL=collections.es5.js.map


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(15);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Platform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportsPassiveEventListeners; });
/* unused harmony export supportsScrollBehavior */
/* unused harmony export getSupportedInputTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PlatformModule; });
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
// Whether the current platform supports the V8 Break Iterator. The V8 check
// is necessary to detect all Blink based browsers.
var /** @type {?} */ hasV8BreakIterator = (typeof Intl !== 'undefined' && (/** @type {?} */ (Intl)).v8BreakIterator);
/**
 * Service to detect the current platform by comparing the userAgent strings and
 * checking browser-specific global properties.
 */
var Platform = /** @class */ (function () {
    /**
     * @breaking-change v7.0.0 remove optional decorator
     */
    function Platform(_platformId) {
        this._platformId = _platformId;
        /**
         * Whether the Angular application is being rendered in the browser.
         * We want to use the Angular platform check because if the Document is shimmed
         * without the navigator, the following checks will fail. This is preferred because
         * sometimes the Document may be shimmed without the user's knowledge or intention
         */
        this.isBrowser = this._platformId ?
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_common__["isPlatformBrowser"])(this._platformId) : typeof document === 'object' && !!document;
        /**
         * Whether the current browser is Microsoft Edge.
         */
        this.EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent);
        /**
         * Whether the current rendering engine is Microsoft Trident.
         */
        this.TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent);
        /**
         * Whether the current rendering engine is Blink.
         */
        this.BLINK = this.isBrowser && (!!((/** @type {?} */ (window)).chrome || hasV8BreakIterator) &&
            typeof CSS !== 'undefined' && !this.EDGE && !this.TRIDENT);
        /**
         * Whether the current rendering engine is WebKit.
         */
        this.WEBKIT = this.isBrowser &&
            /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
        /**
         * Whether the current platform is Apple iOS.
         */
        this.IOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) &&
            !(/** @type {?} */ (window)).MSStream;
        /**
         * Whether the current browser is Firefox.
         */
        this.FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent);
        /**
         * Whether the current platform is Android.
         */
        this.ANDROID = this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT;
        /**
         * Whether the current browser is Safari.
         */
        this.SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;
    }
    Platform.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */
    Platform.ctorParameters = function () { return [
        { type: Object, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["PLATFORM_ID"],] },] },
    ]; };
    /** @nocollapse */ Platform.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["defineInjectable"])({ factory: function Platform_Factory() { return new Platform(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["PLATFORM_ID"], 8)); }, token: Platform, providedIn: "root" });
    return Platform;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * Cached result of whether the user's browser supports passive event listeners.
 */
var /** @type {?} */ supportsPassiveEvents;
/**
 * Checks whether the user's browser supports passive event listeners.
 * See: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 * @return {?}
 */
function supportsPassiveEventListeners() {
    if (supportsPassiveEvents == null && typeof window !== 'undefined') {
        try {
            window.addEventListener('test', /** @type {?} */ ((null)), Object.defineProperty({}, 'passive', {
                get: function () { return supportsPassiveEvents = true; }
            }));
        }
        finally {
            supportsPassiveEvents = supportsPassiveEvents || false;
        }
    }
    return supportsPassiveEvents;
}
/**
 * Check whether the browser supports scroll behaviors.
 * @return {?}
 */
function supportsScrollBehavior() {
    return !!(document && document.documentElement && document.documentElement.style &&
        'scrollBehavior' in document.documentElement.style);
}
/**
 * Cached result Set of input types support by the current browser.
 */
var /** @type {?} */ supportedInputTypes;
/**
 * Types of `<input>` that *might* be supported.
 */
var /** @type {?} */ candidateInputTypes = [
    'color',
    'button',
    'checkbox',
    'date',
    'datetime-local',
    'email',
    'file',
    'hidden',
    'image',
    'month',
    'number',
    'password',
    'radio',
    'range',
    'reset',
    'search',
    'submit',
    'tel',
    'text',
    'time',
    'url',
    'week',
];
/**
 * @return {?} The input types supported by this browser.
 */
function getSupportedInputTypes() {
    // Result is cached.
    if (supportedInputTypes) {
        return supportedInputTypes;
    }
    // We can't check if an input type is not supported until we're on the browser, so say that
    // everything is supported when not on the browser. We don't use `Platform` here since it's
    // just a helper function and can't inject it.
    if (typeof document !== 'object' || !document) {
        supportedInputTypes = new Set(candidateInputTypes);
        return supportedInputTypes;
    }
    var /** @type {?} */ featureTestInput = document.createElement('input');
    supportedInputTypes = new Set(candidateInputTypes.filter(function (value) {
        featureTestInput.setAttribute('type', value);
        return featureTestInput.type === value;
    }));
    return supportedInputTypes;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PlatformModule = /** @class */ (function () {
    function PlatformModule() {
    }
    PlatformModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"] },
    ];
    return PlatformModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


//# sourceMappingURL=platform.es5.js.map


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_cdk_coercion__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_cdk_collections__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DataSource", function() { return __WEBPACK_IMPORTED_MODULE_3__angular_cdk_collections__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_cdk_bidi__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_cdk_platform__ = __webpack_require__(131);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataRowOutlet", function() { return DataRowOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderRowOutlet", function() { return HeaderRowOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FooterRowOutlet", function() { return FooterRowOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_TABLE_TEMPLATE", function() { return CDK_TABLE_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTable", function() { return CdkTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkCellDef", function() { return CdkCellDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderCellDef", function() { return CdkHeaderCellDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterCellDef", function() { return CdkFooterCellDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkColumnDefBase", function() { return CdkColumnDefBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_CdkColumnDefBase", function() { return _CdkColumnDefBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkColumnDef", function() { return CdkColumnDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseCdkCell", function() { return BaseCdkCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderCell", function() { return CdkHeaderCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterCell", function() { return CdkFooterCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkCell", function() { return CdkCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CDK_ROW_TEMPLATE", function() { return CDK_ROW_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseRowDef", function() { return BaseRowDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderRowDefBase", function() { return CdkHeaderRowDefBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_CdkHeaderRowDefBase", function() { return _CdkHeaderRowDefBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderRowDef", function() { return CdkHeaderRowDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterRowDefBase", function() { return CdkFooterRowDefBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_CdkFooterRowDefBase", function() { return _CdkFooterRowDefBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterRowDef", function() { return CdkFooterRowDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkRowDef", function() { return CdkRowDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkCellOutlet", function() { return CdkCellOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkHeaderRow", function() { return CdkHeaderRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkFooterRow", function() { return CdkFooterRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkRow", function() { return CdkRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CdkTableModule", function() { return CdkTableModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STICKY_DIRECTIONS", function() { return STICKY_DIRECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StickyStyler", function() { return StickyStyler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mixinHasStickyInput", function() { return mixinHasStickyInput; });
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */











/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Mixin to provide a directive with a function that checks if the sticky input has been
 * changed since the last time the function was called. Essentially adds a dirty-check to the
 * sticky value.
 * @template T
 * @param {?} base
 * @return {?}
 */
function mixinHasStickyInput(base) {
    return /** @class */ (function (_super) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(class_1, _super);
        function class_1() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, args) || this;
            _this._sticky = false;
            /**
             * Whether the sticky input has changed since it was last checked.
             */
            _this._hasStickyChanged = false;
            return _this;
        }
        Object.defineProperty(class_1.prototype, "sticky", {
            /** Whether sticky positioning should be applied. */
            get: /**
             * Whether sticky positioning should be applied.
             * @return {?}
             */
            function () { return this._sticky; },
            set: /**
             * @param {?} v
             * @return {?}
             */
            function (v) {
                var /** @type {?} */ prevValue = this._sticky;
                this._sticky = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_cdk_coercion__["a" /* coerceBooleanProperty */])(v);
                this._hasStickyChanged = prevValue !== this._sticky;
            },
            enumerable: true,
            configurable: true
        });
        /** Whether the sticky value has changed since this was last called. */
        /**
         * Whether the sticky value has changed since this was last called.
         * @return {?}
         */
        class_1.prototype.hasStickyChanged = /**
         * Whether the sticky value has changed since this was last called.
         * @return {?}
         */
        function () {
            var /** @type {?} */ hasStickyChanged = this._hasStickyChanged;
            this._hasStickyChanged = false;
            return hasStickyChanged;
        };
        /** Resets the dirty check for cases where the sticky state has been used without checking. */
        /**
         * Resets the dirty check for cases where the sticky state has been used without checking.
         * @return {?}
         */
        class_1.prototype.resetStickyChanged = /**
         * Resets the dirty check for cases where the sticky state has been used without checking.
         * @return {?}
         */
        function () {
            this._hasStickyChanged = false;
        };
        return class_1;
    }(base));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Cell definition for a CDK table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 */
var CdkCellDef = /** @class */ (function () {
    function CdkCellDef(template) {
        this.template = template;
    }
    CdkCellDef.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{ selector: '[cdkCellDef]' },] },
    ];
    /** @nocollapse */
    CdkCellDef.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"], },
    ]; };
    return CdkCellDef;
}());
/**
 * Header cell definition for a CDK table.
 * Captures the template of a column's header cell and as well as cell-specific properties.
 */
var CdkHeaderCellDef = /** @class */ (function () {
    function CdkHeaderCellDef(template) {
        this.template = template;
    }
    CdkHeaderCellDef.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{ selector: '[cdkHeaderCellDef]' },] },
    ];
    /** @nocollapse */
    CdkHeaderCellDef.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"], },
    ]; };
    return CdkHeaderCellDef;
}());
/**
 * Footer cell definition for a CDK table.
 * Captures the template of a column's footer cell and as well as cell-specific properties.
 */
var CdkFooterCellDef = /** @class */ (function () {
    function CdkFooterCellDef(template) {
        this.template = template;
    }
    CdkFooterCellDef.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{ selector: '[cdkFooterCellDef]' },] },
    ];
    /** @nocollapse */
    CdkFooterCellDef.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"], },
    ]; };
    return CdkFooterCellDef;
}());
/**
 * \@docs-private
 */
var  /**
 * \@docs-private
 */
CdkColumnDefBase = /** @class */ (function () {
    function CdkColumnDefBase() {
    }
    return CdkColumnDefBase;
}());
var /** @type {?} */ _CdkColumnDefBase = mixinHasStickyInput(CdkColumnDefBase);
/**
 * Column definition for the CDK table.
 * Defines a set of cells available for a table column.
 */
var CdkColumnDef = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkColumnDef, _super);
    function CdkColumnDef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._stickyEnd = false;
        return _this;
    }
    Object.defineProperty(CdkColumnDef.prototype, "name", {
        get: /**
         * Unique name for this column.
         * @return {?}
         */
        function () { return this._name; },
        set: /**
         * @param {?} name
         * @return {?}
         */
        function (name) {
            // If the directive is set without a name (updated programatically), then this setter will
            // trigger with an empty string and should not overwrite the programatically set value.
            if (!name) {
                return;
            }
            this._name = name;
            this.cssClassFriendlyName = name.replace(/[^a-z0-9_-]/ig, '-');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkColumnDef.prototype, "stickyEnd", {
        get: /**
         * Whether this column should be sticky positioned on the end of the row. Should make sure
         * that it mimics the `CanStick` mixin such that `_hasStickyChanged` is set to true if the value
         * has been changed.
         * @return {?}
         */
        function () { return this._stickyEnd; },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            var /** @type {?} */ prevValue = this._stickyEnd;
            this._stickyEnd = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_cdk_coercion__["a" /* coerceBooleanProperty */])(v);
            this._hasStickyChanged = prevValue !== this._stickyEnd;
        },
        enumerable: true,
        configurable: true
    });
    CdkColumnDef.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{
                    selector: '[cdkColumnDef]',
                    inputs: ['sticky']
                },] },
    ];
    /** @nocollapse */
    CdkColumnDef.propDecorators = {
        "name": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"], args: ['cdkColumnDef',] },],
        "stickyEnd": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"], args: ['stickyEnd',] },],
        "cell": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ContentChild"], args: [CdkCellDef,] },],
        "headerCell": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ContentChild"], args: [CdkHeaderCellDef,] },],
        "footerCell": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ContentChild"], args: [CdkFooterCellDef,] },],
    };
    return CdkColumnDef;
}(_CdkColumnDefBase));
/**
 * Base class for the cells. Adds a CSS classname that identifies the column it renders in.
 */
var  /**
 * Base class for the cells. Adds a CSS classname that identifies the column it renders in.
 */
BaseCdkCell = /** @class */ (function () {
    function BaseCdkCell(columnDef, elementRef) {
        var /** @type {?} */ columnClassName = "cdk-column-" + columnDef.cssClassFriendlyName;
        elementRef.nativeElement.classList.add(columnClassName);
    }
    return BaseCdkCell;
}());
/**
 * Header cell template container that adds the right classes and role.
 */
var CdkHeaderCell = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkHeaderCell, _super);
    function CdkHeaderCell(columnDef, elementRef) {
        return _super.call(this, columnDef, elementRef) || this;
    }
    CdkHeaderCell.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{
                    selector: 'cdk-header-cell, th[cdk-header-cell]',
                    host: {
                        'class': 'cdk-header-cell',
                        'role': 'columnheader',
                    },
                },] },
    ];
    /** @nocollapse */
    CdkHeaderCell.ctorParameters = function () { return [
        { type: CdkColumnDef, },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], },
    ]; };
    return CdkHeaderCell;
}(BaseCdkCell));
/**
 * Footer cell template container that adds the right classes and role.
 */
var CdkFooterCell = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkFooterCell, _super);
    function CdkFooterCell(columnDef, elementRef) {
        return _super.call(this, columnDef, elementRef) || this;
    }
    CdkFooterCell.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{
                    selector: 'cdk-footer-cell, td[cdk-footer-cell]',
                    host: {
                        'class': 'cdk-footer-cell',
                        'role': 'gridcell',
                    },
                },] },
    ];
    /** @nocollapse */
    CdkFooterCell.ctorParameters = function () { return [
        { type: CdkColumnDef, },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], },
    ]; };
    return CdkFooterCell;
}(BaseCdkCell));
/**
 * Cell template container that adds the right classes and role.
 */
var CdkCell = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkCell, _super);
    function CdkCell(columnDef, elementRef) {
        return _super.call(this, columnDef, elementRef) || this;
    }
    CdkCell.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{
                    selector: 'cdk-cell, td[cdk-cell]',
                    host: {
                        'class': 'cdk-cell',
                        'role': 'gridcell',
                    },
                },] },
    ];
    /** @nocollapse */
    CdkCell.ctorParameters = function () { return [
        { type: CdkColumnDef, },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], },
    ]; };
    return CdkCell;
}(BaseCdkCell));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * The row template that can be used by the mat-table. Should not be used outside of the
 * material library.
 */
var /** @type {?} */ CDK_ROW_TEMPLATE = "<ng-container cdkCellOutlet></ng-container>";
/**
 * Base class for the CdkHeaderRowDef and CdkRowDef that handles checking their columns inputs
 * for changes and notifying the table.
 * @abstract
 */
var  /**
 * Base class for the CdkHeaderRowDef and CdkRowDef that handles checking their columns inputs
 * for changes and notifying the table.
 * @abstract
 */
BaseRowDef = /** @class */ (function () {
    function BaseRowDef(template, _differs) {
        this.template = template;
        this._differs = _differs;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    BaseRowDef.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        // Create a new columns differ if one does not yet exist. Initialize it based on initial value
        // of the columns property or an empty array if none is provided.
        if (!this._columnsDiffer) {
            var /** @type {?} */ columns = (changes['columns'] && changes['columns'].currentValue) || [];
            this._columnsDiffer = this._differs.find(columns).create();
            this._columnsDiffer.diff(columns);
        }
    };
    /**
     * Returns the difference between the current columns and the columns from the last diff, or null
     * if there is no difference.
     */
    /**
     * Returns the difference between the current columns and the columns from the last diff, or null
     * if there is no difference.
     * @return {?}
     */
    BaseRowDef.prototype.getColumnsDiff = /**
     * Returns the difference between the current columns and the columns from the last diff, or null
     * if there is no difference.
     * @return {?}
     */
    function () {
        return this._columnsDiffer.diff(this.columns);
    };
    /** Gets this row def's relevant cell template from the provided column def. */
    /**
     * Gets this row def's relevant cell template from the provided column def.
     * @param {?} column
     * @return {?}
     */
    BaseRowDef.prototype.extractCellTemplate = /**
     * Gets this row def's relevant cell template from the provided column def.
     * @param {?} column
     * @return {?}
     */
    function (column) {
        if (this instanceof CdkHeaderRowDef) {
            return column.headerCell.template;
        }
        if (this instanceof CdkFooterRowDef) {
            return column.footerCell.template;
        }
        else {
            return column.cell.template;
        }
    };
    return BaseRowDef;
}());
/**
 * \@docs-private
 */
var  /**
 * \@docs-private
 */
CdkHeaderRowDefBase = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkHeaderRowDefBase, _super);
    function CdkHeaderRowDefBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CdkHeaderRowDefBase;
}(BaseRowDef));
var /** @type {?} */ _CdkHeaderRowDefBase = mixinHasStickyInput(CdkHeaderRowDefBase);
/**
 * Header row definition for the CDK table.
 * Captures the header row's template and other header properties such as the columns to display.
 */
var CdkHeaderRowDef = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkHeaderRowDef, _super);
    function CdkHeaderRowDef(template, _differs) {
        return _super.call(this, template, _differs) || this;
    }
    // Prerender fails to recognize that ngOnChanges in a part of this class through inheritance.
    // Explicitly define it so that the method is called as part of the Angular lifecycle.
    /**
     * @param {?} changes
     * @return {?}
     */
    CdkHeaderRowDef.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
    };
    CdkHeaderRowDef.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{
                    selector: '[cdkHeaderRowDef]',
                    inputs: ['columns: cdkHeaderRowDef', 'sticky: cdkHeaderRowDefSticky'],
                },] },
    ];
    /** @nocollapse */
    CdkHeaderRowDef.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], },
    ]; };
    return CdkHeaderRowDef;
}(_CdkHeaderRowDefBase));
/**
 * \@docs-private
 */
var  /**
 * \@docs-private
 */
CdkFooterRowDefBase = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkFooterRowDefBase, _super);
    function CdkFooterRowDefBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CdkFooterRowDefBase;
}(BaseRowDef));
var /** @type {?} */ _CdkFooterRowDefBase = mixinHasStickyInput(CdkFooterRowDefBase);
/**
 * Footer row definition for the CDK table.
 * Captures the footer row's template and other footer properties such as the columns to display.
 */
var CdkFooterRowDef = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkFooterRowDef, _super);
    function CdkFooterRowDef(template, _differs) {
        return _super.call(this, template, _differs) || this;
    }
    // Prerender fails to recognize that ngOnChanges in a part of this class through inheritance.
    // Explicitly define it so that the method is called as part of the Angular lifecycle.
    /**
     * @param {?} changes
     * @return {?}
     */
    CdkFooterRowDef.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
    };
    CdkFooterRowDef.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{
                    selector: '[cdkFooterRowDef]',
                    inputs: ['columns: cdkFooterRowDef', 'sticky: cdkFooterRowDefSticky'],
                },] },
    ];
    /** @nocollapse */
    CdkFooterRowDef.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], },
    ]; };
    return CdkFooterRowDef;
}(_CdkFooterRowDefBase));
/**
 * Data row definition for the CDK table.
 * Captures the header row's template and other row properties such as the columns to display and
 * a when predicate that describes when this row should be used.
 * @template T
 */
var CdkRowDef = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CdkRowDef, _super);
    // TODO(andrewseguin): Add an input for providing a switch function to determine
    //   if this template should be used.
    function CdkRowDef(template, _differs) {
        return _super.call(this, template, _differs) || this;
    }
    CdkRowDef.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{
                    selector: '[cdkRowDef]',
                    inputs: ['columns: cdkRowDefColumns', 'when: cdkRowDefWhen'],
                },] },
    ];
    /** @nocollapse */
    CdkRowDef.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["TemplateRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], },
    ]; };
    return CdkRowDef;
}(BaseRowDef));
/**
 * Outlet for rendering cells inside of a row or header row.
 * \@docs-private
 */
var CdkCellOutlet = /** @class */ (function () {
    function CdkCellOutlet(_viewContainer) {
        this._viewContainer = _viewContainer;
        CdkCellOutlet.mostRecentCellOutlet = this;
    }
    /**
     * @return {?}
     */
    CdkCellOutlet.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        // If this was the last outlet being rendered in the view, remove the reference
        // from the static property after it has been destroyed to avoid leaking memory.
        if (CdkCellOutlet.mostRecentCellOutlet === this) {
            CdkCellOutlet.mostRecentCellOutlet = null;
        }
    };
    /**
     * Static property containing the latest constructed instance of this class.
     * Used by the CDK table when each CdkHeaderRow and CdkRow component is created using
     * createEmbeddedView. After one of these components are created, this property will provide
     * a handle to provide that component's cells and context. After init, the CdkCellOutlet will
     * construct the cells with the provided context.
     */
    CdkCellOutlet.mostRecentCellOutlet = null;
    CdkCellOutlet.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{ selector: '[cdkCellOutlet]' },] },
    ];
    /** @nocollapse */
    CdkCellOutlet.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], },
    ]; };
    return CdkCellOutlet;
}());
/**
 * Header template container that contains the cell outlet. Adds the right class and role.
 */
var CdkHeaderRow = /** @class */ (function () {
    function CdkHeaderRow() {
    }
    CdkHeaderRow.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Component"], args: [{selector: 'cdk-header-row, tr[cdk-header-row]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        'class': 'cdk-header-row',
                        'role': 'row',
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    return CdkHeaderRow;
}());
/**
 * Footer template container that contains the cell outlet. Adds the right class and role.
 */
var CdkFooterRow = /** @class */ (function () {
    function CdkFooterRow() {
    }
    CdkFooterRow.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Component"], args: [{selector: 'cdk-footer-row, tr[cdk-footer-row]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        'class': 'cdk-footer-row',
                        'role': 'row',
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    return CdkFooterRow;
}());
/**
 * Data row template container that contains the cell outlet. Adds the right class and role.
 */
var CdkRow = /** @class */ (function () {
    function CdkRow() {
    }
    CdkRow.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Component"], args: [{selector: 'cdk-row, tr[cdk-row]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        'class': 'cdk-row',
                        'role': 'row',
                    },
                    changeDetection: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ChangeDetectionStrategy"].OnPush,
                    encapsulation: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].None,
                },] },
    ];
    return CdkRow;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * Returns an error to be thrown when attempting to find an unexisting column.
 * \@docs-private
 * @param {?} id Id whose lookup failed.
 * @return {?}
 */
function getTableUnknownColumnError(id) {
    return Error("Could not find column with id \"" + id + "\".");
}
/**
 * Returns an error to be thrown when two column definitions have the same name.
 * \@docs-private
 * @param {?} name
 * @return {?}
 */
function getTableDuplicateColumnNameError(name) {
    return Error("Duplicate column definition name provided: \"" + name + "\".");
}
/**
 * Returns an error to be thrown when there are multiple rows that are missing a when function.
 * \@docs-private
 * @return {?}
 */
function getTableMultipleDefaultRowDefsError() {
    return Error("There can only be one default row without a when predicate function.");
}
/**
 * Returns an error to be thrown when there are no matching row defs for a particular set of data.
 * \@docs-private
 * @param {?} data
 * @return {?}
 */
function getTableMissingMatchingRowDefError(data) {
    return Error("Could not find a matching row definition for the" +
        ("provided row data: " + JSON.stringify(data)));
}
/**
 * Returns an error to be thrown when there is no row definitions present in the content.
 * \@docs-private
 * @return {?}
 */
function getTableMissingRowDefsError() {
    return Error('Missing definitions for header, footer, and row; ' +
        'cannot determine which columns should be rendered.');
}
/**
 * Returns an error to be thrown when the data source does not match the compatible types.
 * \@docs-private
 * @return {?}
 */
function getTableUnknownDataSourceError() {
    return Error("Provided data source did not match an array, Observable, or DataSource");
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * List of all possible directions that can be used for sticky positioning.
 * \@docs-private
 */
var /** @type {?} */ STICKY_DIRECTIONS = ['top', 'bottom', 'left', 'right'];
/**
 * Applies and removes sticky positioning styles to the `CdkTable` rows and columns cells.
 * \@docs-private
 */
var  /**
 * Applies and removes sticky positioning styles to the `CdkTable` rows and columns cells.
 * \@docs-private
 */
StickyStyler = /** @class */ (function () {
    /**
     * @param isNativeHtmlTable Whether the sticky logic should be based on a table
     *     that uses the native `<table>` element.
     * @param stickCellCss The CSS class that will be applied to every row/cell that has
     *     sticky positioning applied.
     * @param direction The directionality context of the table (ltr/rtl); affects column positioning
     *     by reversing left/right positions.
     * @param _isBrowser Whether the table is currently being rendered on the server or the client.
     */
    function StickyStyler(isNativeHtmlTable, stickCellCss, direction, _isBrowser) {
        if (_isBrowser === void 0) { _isBrowser = true; }
        this.isNativeHtmlTable = isNativeHtmlTable;
        this.stickCellCss = stickCellCss;
        this.direction = direction;
        this._isBrowser = _isBrowser;
    }
    /**
     * Clears the sticky positioning styles from the row and its cells by resetting the `position`
     * style, setting the zIndex to 0, and unsetting each provided sticky direction.
     * @param rows The list of rows that should be cleared from sticking in the provided directions
     * @param stickyDirections The directions that should no longer be set as sticky on the rows.
     */
    /**
     * Clears the sticky positioning styles from the row and its cells by resetting the `position`
     * style, setting the zIndex to 0, and unsetting each provided sticky direction.
     * @param {?} rows The list of rows that should be cleared from sticking in the provided directions
     * @param {?} stickyDirections The directions that should no longer be set as sticky on the rows.
     * @return {?}
     */
    StickyStyler.prototype.clearStickyPositioning = /**
     * Clears the sticky positioning styles from the row and its cells by resetting the `position`
     * style, setting the zIndex to 0, and unsetting each provided sticky direction.
     * @param {?} rows The list of rows that should be cleared from sticking in the provided directions
     * @param {?} stickyDirections The directions that should no longer be set as sticky on the rows.
     * @return {?}
     */
    function (rows, stickyDirections) {
        for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
            var row = rows_1[_i];
            // If the row isn't an element (e.g. if it's an `ng-container`),
            // it won't have inline styles or `children` so we skip it.
            if (row.nodeType !== row.ELEMENT_NODE) {
                continue;
            }
            this._removeStickyStyle(row, stickyDirections);
            for (var /** @type {?} */ i = 0; i < row.children.length; i++) {
                var /** @type {?} */ cell = /** @type {?} */ (row.children[i]);
                this._removeStickyStyle(cell, stickyDirections);
            }
        }
    };
    /**
     * Applies sticky left and right positions to the cells of each row according to the sticky
     * states of the rendered column definitions.
     * @param rows The rows that should have its set of cells stuck according to the sticky states.
     * @param stickyStartStates A list of boolean states where each state represents whether the cell
     *     in this index position should be stuck to the start of the row.
     * @param stickyEndStates A list of boolean states where each state represents whether the cell
     *     in this index position should be stuck to the end of the row.
     */
    /**
     * Applies sticky left and right positions to the cells of each row according to the sticky
     * states of the rendered column definitions.
     * @param {?} rows The rows that should have its set of cells stuck according to the sticky states.
     * @param {?} stickyStartStates A list of boolean states where each state represents whether the cell
     *     in this index position should be stuck to the start of the row.
     * @param {?} stickyEndStates A list of boolean states where each state represents whether the cell
     *     in this index position should be stuck to the end of the row.
     * @return {?}
     */
    StickyStyler.prototype.updateStickyColumns = /**
     * Applies sticky left and right positions to the cells of each row according to the sticky
     * states of the rendered column definitions.
     * @param {?} rows The rows that should have its set of cells stuck according to the sticky states.
     * @param {?} stickyStartStates A list of boolean states where each state represents whether the cell
     *     in this index position should be stuck to the start of the row.
     * @param {?} stickyEndStates A list of boolean states where each state represents whether the cell
     *     in this index position should be stuck to the end of the row.
     * @return {?}
     */
    function (rows, stickyStartStates, stickyEndStates) {
        var /** @type {?} */ hasStickyColumns = stickyStartStates.some(function (state) { return state; }) || stickyEndStates.some(function (state) { return state; });
        if (!rows.length || !hasStickyColumns || !this._isBrowser) {
            return;
        }
        var /** @type {?} */ firstRow = rows[0];
        var /** @type {?} */ numCells = firstRow.children.length;
        var /** @type {?} */ cellWidths = this._getCellWidths(firstRow);
        var /** @type {?} */ startPositions = this._getStickyStartColumnPositions(cellWidths, stickyStartStates);
        var /** @type {?} */ endPositions = this._getStickyEndColumnPositions(cellWidths, stickyEndStates);
        var /** @type {?} */ isRtl = this.direction === 'rtl';
        for (var _i = 0, rows_2 = rows; _i < rows_2.length; _i++) {
            var row = rows_2[_i];
            for (var /** @type {?} */ i = 0; i < numCells; i++) {
                var /** @type {?} */ cell = /** @type {?} */ (row.children[i]);
                if (stickyStartStates[i]) {
                    this._addStickyStyle(cell, isRtl ? 'right' : 'left', startPositions[i]);
                }
                if (stickyEndStates[i]) {
                    this._addStickyStyle(cell, isRtl ? 'left' : 'right', endPositions[i]);
                }
            }
        }
    };
    /**
     * Applies sticky positioning to the row's cells if using the native table layout, and to the
     * row itself otherwise.
     * @param rowsToStick The list of rows that should be stuck according to their corresponding
     *     sticky state and to the provided top or bottom position.
     * @param stickyStates A list of boolean states where each state represents whether the row
     *     should be stuck in the particular top or bottom position.
     * @param position The position direction in which the row should be stuck if that row should be
     *     sticky.
     *
     */
    /**
     * Applies sticky positioning to the row's cells if using the native table layout, and to the
     * row itself otherwise.
     * @param {?} rowsToStick The list of rows that should be stuck according to their corresponding
     *     sticky state and to the provided top or bottom position.
     * @param {?} stickyStates A list of boolean states where each state represents whether the row
     *     should be stuck in the particular top or bottom position.
     * @param {?} position The position direction in which the row should be stuck if that row should be
     *     sticky.
     *
     * @return {?}
     */
    StickyStyler.prototype.stickRows = /**
     * Applies sticky positioning to the row's cells if using the native table layout, and to the
     * row itself otherwise.
     * @param {?} rowsToStick The list of rows that should be stuck according to their corresponding
     *     sticky state and to the provided top or bottom position.
     * @param {?} stickyStates A list of boolean states where each state represents whether the row
     *     should be stuck in the particular top or bottom position.
     * @param {?} position The position direction in which the row should be stuck if that row should be
     *     sticky.
     *
     * @return {?}
     */
    function (rowsToStick, stickyStates, position) {
        // Since we can't measure the rows on the server, we can't stick the rows properly.
        if (!this._isBrowser) {
            return;
        }
        // If positioning the rows to the bottom, reverse their order when evaluating the sticky
        // position such that the last row stuck will be "bottom: 0px" and so on.
        var /** @type {?} */ rows = position === 'bottom' ? rowsToStick.reverse() : rowsToStick;
        var /** @type {?} */ stickyHeight = 0;
        for (var /** @type {?} */ rowIndex = 0; rowIndex < rows.length; rowIndex++) {
            if (!stickyStates[rowIndex]) {
                continue;
            }
            var /** @type {?} */ row = rows[rowIndex];
            if (this.isNativeHtmlTable) {
                for (var /** @type {?} */ j = 0; j < row.children.length; j++) {
                    var /** @type {?} */ cell = /** @type {?} */ (row.children[j]);
                    this._addStickyStyle(cell, position, stickyHeight);
                }
            }
            else {
                // Flex does not respect the stick positioning on the cells, needs to be applied to the row.
                // If this is applied on a native table, Safari causes the header to fly in wrong direction.
                this._addStickyStyle(row, position, stickyHeight);
            }
            stickyHeight += row.getBoundingClientRect().height;
        }
    };
    /**
     * When using the native table in Safari, sticky footer cells do not stick. The only way to stick
     * footer rows is to apply sticky styling to the tfoot container. This should only be done if
     * all footer rows are sticky. If not all footer rows are sticky, remove sticky positioning from
     * the tfoot element.
     */
    /**
     * When using the native table in Safari, sticky footer cells do not stick. The only way to stick
     * footer rows is to apply sticky styling to the tfoot container. This should only be done if
     * all footer rows are sticky. If not all footer rows are sticky, remove sticky positioning from
     * the tfoot element.
     * @param {?} tableElement
     * @param {?} stickyStates
     * @return {?}
     */
    StickyStyler.prototype.updateStickyFooterContainer = /**
     * When using the native table in Safari, sticky footer cells do not stick. The only way to stick
     * footer rows is to apply sticky styling to the tfoot container. This should only be done if
     * all footer rows are sticky. If not all footer rows are sticky, remove sticky positioning from
     * the tfoot element.
     * @param {?} tableElement
     * @param {?} stickyStates
     * @return {?}
     */
    function (tableElement, stickyStates) {
        if (!this.isNativeHtmlTable) {
            return;
        }
        var /** @type {?} */ tfoot = /** @type {?} */ ((tableElement.querySelector('tfoot')));
        if (stickyStates.some(function (state) { return !state; })) {
            this._removeStickyStyle(tfoot, ['bottom']);
        }
        else {
            this._addStickyStyle(tfoot, 'bottom', 0);
        }
    };
    /**
     * Removes the sticky style on the element by removing the sticky cell CSS class, re-evaluating
     * the zIndex, removing each of the provided sticky directions, and removing the
     * sticky position if there are no more directions.
     */
    /**
     * Removes the sticky style on the element by removing the sticky cell CSS class, re-evaluating
     * the zIndex, removing each of the provided sticky directions, and removing the
     * sticky position if there are no more directions.
     * @param {?} element
     * @param {?} stickyDirections
     * @return {?}
     */
    StickyStyler.prototype._removeStickyStyle = /**
     * Removes the sticky style on the element by removing the sticky cell CSS class, re-evaluating
     * the zIndex, removing each of the provided sticky directions, and removing the
     * sticky position if there are no more directions.
     * @param {?} element
     * @param {?} stickyDirections
     * @return {?}
     */
    function (element, stickyDirections) {
        for (var _i = 0, stickyDirections_1 = stickyDirections; _i < stickyDirections_1.length; _i++) {
            var dir = stickyDirections_1[_i];
            element.style[dir] = '';
        }
        element.style.zIndex = this._getCalculatedZIndex(element);
        // If the element no longer has any more sticky directions, remove sticky positioning and
        // the sticky CSS class.
        var /** @type {?} */ hasDirection = STICKY_DIRECTIONS.some(function (dir) { return !!element.style[dir]; });
        if (!hasDirection) {
            element.style.position = '';
            element.classList.remove(this.stickCellCss);
        }
    };
    /**
     * Adds the sticky styling to the element by adding the sticky style class, changing position
     * to be sticky (and -webkit-sticky), setting the appropriate zIndex, and adding a sticky
     * direction and value.
     */
    /**
     * Adds the sticky styling to the element by adding the sticky style class, changing position
     * to be sticky (and -webkit-sticky), setting the appropriate zIndex, and adding a sticky
     * direction and value.
     * @param {?} element
     * @param {?} dir
     * @param {?} dirValue
     * @return {?}
     */
    StickyStyler.prototype._addStickyStyle = /**
     * Adds the sticky styling to the element by adding the sticky style class, changing position
     * to be sticky (and -webkit-sticky), setting the appropriate zIndex, and adding a sticky
     * direction and value.
     * @param {?} element
     * @param {?} dir
     * @param {?} dirValue
     * @return {?}
     */
    function (element, dir, dirValue) {
        element.classList.add(this.stickCellCss);
        element.style[dir] = dirValue + "px";
        element.style.cssText += 'position: -webkit-sticky; position: sticky; ';
        element.style.zIndex = this._getCalculatedZIndex(element);
    };
    /**
     * Calculate what the z-index should be for the element, depending on what directions (top,
     * bottom, left, right) have been set. It should be true that elements with a top direction
     * should have the highest index since these are elements like a table header. If any of those
     * elements are also sticky in another direction, then they should appear above other elements
     * that are only sticky top (e.g. a sticky column on a sticky header). Bottom-sticky elements
     * (e.g. footer rows) should then be next in the ordering such that they are below the header
     * but above any non-sticky elements. Finally, left/right sticky elements (e.g. sticky columns)
     * should minimally increment so that they are above non-sticky elements but below top and bottom
     * elements.
     */
    /**
     * Calculate what the z-index should be for the element, depending on what directions (top,
     * bottom, left, right) have been set. It should be true that elements with a top direction
     * should have the highest index since these are elements like a table header. If any of those
     * elements are also sticky in another direction, then they should appear above other elements
     * that are only sticky top (e.g. a sticky column on a sticky header). Bottom-sticky elements
     * (e.g. footer rows) should then be next in the ordering such that they are below the header
     * but above any non-sticky elements. Finally, left/right sticky elements (e.g. sticky columns)
     * should minimally increment so that they are above non-sticky elements but below top and bottom
     * elements.
     * @param {?} element
     * @return {?}
     */
    StickyStyler.prototype._getCalculatedZIndex = /**
     * Calculate what the z-index should be for the element, depending on what directions (top,
     * bottom, left, right) have been set. It should be true that elements with a top direction
     * should have the highest index since these are elements like a table header. If any of those
     * elements are also sticky in another direction, then they should appear above other elements
     * that are only sticky top (e.g. a sticky column on a sticky header). Bottom-sticky elements
     * (e.g. footer rows) should then be next in the ordering such that they are below the header
     * but above any non-sticky elements. Finally, left/right sticky elements (e.g. sticky columns)
     * should minimally increment so that they are above non-sticky elements but below top and bottom
     * elements.
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var /** @type {?} */ zIndexIncrements = {
            top: 100,
            bottom: 10,
            left: 1,
            right: 1,
        };
        var /** @type {?} */ zIndex = 0;
        for (var _i = 0, STICKY_DIRECTIONS_1 = STICKY_DIRECTIONS; _i < STICKY_DIRECTIONS_1.length; _i++) {
            var dir = STICKY_DIRECTIONS_1[_i];
            if (element.style[dir]) {
                zIndex += zIndexIncrements[dir];
            }
        }
        return zIndex ? "" + zIndex : '';
    };
    /** Gets the widths for each cell in the provided row. */
    /**
     * Gets the widths for each cell in the provided row.
     * @param {?} row
     * @return {?}
     */
    StickyStyler.prototype._getCellWidths = /**
     * Gets the widths for each cell in the provided row.
     * @param {?} row
     * @return {?}
     */
    function (row) {
        var /** @type {?} */ cellWidths = [];
        var /** @type {?} */ firstRowCells = row.children;
        for (var /** @type {?} */ i = 0; i < firstRowCells.length; i++) {
            var /** @type {?} */ cell = /** @type {?} */ (firstRowCells[i]);
            cellWidths.push(cell.getBoundingClientRect().width);
        }
        return cellWidths;
    };
    /**
     * Determines the left and right positions of each sticky column cell, which will be the
     * accumulation of all sticky column cell widths to the left and right, respectively.
     * Non-sticky cells do not need to have a value set since their positions will not be applied.
     */
    /**
     * Determines the left and right positions of each sticky column cell, which will be the
     * accumulation of all sticky column cell widths to the left and right, respectively.
     * Non-sticky cells do not need to have a value set since their positions will not be applied.
     * @param {?} widths
     * @param {?} stickyStates
     * @return {?}
     */
    StickyStyler.prototype._getStickyStartColumnPositions = /**
     * Determines the left and right positions of each sticky column cell, which will be the
     * accumulation of all sticky column cell widths to the left and right, respectively.
     * Non-sticky cells do not need to have a value set since their positions will not be applied.
     * @param {?} widths
     * @param {?} stickyStates
     * @return {?}
     */
    function (widths, stickyStates) {
        var /** @type {?} */ positions = [];
        var /** @type {?} */ nextPosition = 0;
        for (var /** @type {?} */ i = 0; i < widths.length; i++) {
            if (stickyStates[i]) {
                positions[i] = nextPosition;
                nextPosition += widths[i];
            }
        }
        return positions;
    };
    /**
     * Determines the left and right positions of each sticky column cell, which will be the
     * accumulation of all sticky column cell widths to the left and right, respectively.
     * Non-sticky cells do not need to have a value set since their positions will not be applied.
     */
    /**
     * Determines the left and right positions of each sticky column cell, which will be the
     * accumulation of all sticky column cell widths to the left and right, respectively.
     * Non-sticky cells do not need to have a value set since their positions will not be applied.
     * @param {?} widths
     * @param {?} stickyStates
     * @return {?}
     */
    StickyStyler.prototype._getStickyEndColumnPositions = /**
     * Determines the left and right positions of each sticky column cell, which will be the
     * accumulation of all sticky column cell widths to the left and right, respectively.
     * Non-sticky cells do not need to have a value set since their positions will not be applied.
     * @param {?} widths
     * @param {?} stickyStates
     * @return {?}
     */
    function (widths, stickyStates) {
        var /** @type {?} */ positions = [];
        var /** @type {?} */ nextPosition = 0;
        for (var /** @type {?} */ i = widths.length; i > 0; i--) {
            if (stickyStates[i]) {
                positions[i] = nextPosition;
                nextPosition += widths[i];
            }
        }
        return positions;
    };
    return StickyStyler;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Provides a handle for the table to grab the view container's ng-container to insert data rows.
 * \@docs-private
 */
var DataRowOutlet = /** @class */ (function () {
    function DataRowOutlet(viewContainer, elementRef) {
        this.viewContainer = viewContainer;
        this.elementRef = elementRef;
    }
    DataRowOutlet.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{ selector: '[rowOutlet]' },] },
    ];
    /** @nocollapse */
    DataRowOutlet.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], },
    ]; };
    return DataRowOutlet;
}());
/**
 * Provides a handle for the table to grab the view container's ng-container to insert the header.
 * \@docs-private
 */
var HeaderRowOutlet = /** @class */ (function () {
    function HeaderRowOutlet(viewContainer, elementRef) {
        this.viewContainer = viewContainer;
        this.elementRef = elementRef;
    }
    HeaderRowOutlet.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{ selector: '[headerRowOutlet]' },] },
    ];
    /** @nocollapse */
    HeaderRowOutlet.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], },
    ]; };
    return HeaderRowOutlet;
}());
/**
 * Provides a handle for the table to grab the view container's ng-container to insert the footer.
 * \@docs-private
 */
var FooterRowOutlet = /** @class */ (function () {
    function FooterRowOutlet(viewContainer, elementRef) {
        this.viewContainer = viewContainer;
        this.elementRef = elementRef;
    }
    FooterRowOutlet.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Directive"], args: [{ selector: '[footerRowOutlet]' },] },
    ];
    /** @nocollapse */
    FooterRowOutlet.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewContainerRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], },
    ]; };
    return FooterRowOutlet;
}());
/**
 * The table template that can be used by the mat-table. Should not be used outside of the
 * material library.
 * \@docs-private
 */
var /** @type {?} */ CDK_TABLE_TEMPLATE = "\n  <ng-container headerRowOutlet></ng-container>\n  <ng-container rowOutlet></ng-container>\n  <ng-container footerRowOutlet></ng-container>";
/**
 * Class used to conveniently type the embedded view ref for rows with a context.
 * \@docs-private
 * @abstract
 * @template T
 */
var /**
 * Class used to conveniently type the embedded view ref for rows with a context.
 * \@docs-private
 * @abstract
 * @template T
 */
RowViewRef = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(RowViewRef, _super);
    function RowViewRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RowViewRef;
}(__WEBPACK_IMPORTED_MODULE_2__angular_core__["EmbeddedViewRef"]));
/**
 * A data table that can render a header row, data rows, and a footer row.
 * Uses the dataSource input to determine the data to be rendered. The data can be provided either
 * as a data array, an Observable stream that emits the data array to render, or a DataSource with a
 * connect function that will return an Observable stream that emits the data array to render.
 * @template T
 */
var CdkTable = /** @class */ (function () {
    function CdkTable(_differs, _changeDetectorRef, _elementRef, role, _dir, /**
                   * @deprecated
                   * @breaking-change 8.0.0 `_document` and `_platform` to
                   *    be made into a required parameters.
                   */
    _document, _platform) {
        this._differs = _differs;
        this._changeDetectorRef = _changeDetectorRef;
        this._elementRef = _elementRef;
        this._dir = _dir;
        this._platform = _platform;
        /**
         * Subject that emits when the component has been destroyed.
         */
        this._onDestroy = new __WEBPACK_IMPORTED_MODULE_5_rxjs__["Subject"]();
        /**
         * Map of all the user's defined columns (header, data, and footer cell template) identified by
         * name. Collection populated by the column definitions gathered by `ContentChildren` as well as
         * any custom column definitions added to `_customColumnDefs`.
         */
        this._columnDefsByName = new Map();
        /**
         * Column definitions that were defined outside of the direct content children of the table.
         * These will be defined when, e.g., creating a wrapper around the cdkTable that has
         * column definitions as *it's* content child.
         */
        this._customColumnDefs = new Set();
        /**
         * Data row definitions that were defined outside of the direct content children of the table.
         * These will be defined when, e.g., creating a wrapper around the cdkTable that has
         * built-in data rows as *it's* content child.
         */
        this._customRowDefs = new Set();
        /**
         * Header row definitions that were defined outside of the direct content children of the table.
         * These will be defined when, e.g., creating a wrapper around the cdkTable that has
         * built-in header rows as *it's* content child.
         */
        this._customHeaderRowDefs = new Set();
        /**
         * Footer row definitions that were defined outside of the direct content children of the table.
         * These will be defined when, e.g., creating a wrapper around the cdkTable that has a
         * built-in footer row as *it's* content child.
         */
        this._customFooterRowDefs = new Set();
        /**
         * Whether the header row definition has been changed. Triggers an update to the header row after
         * content is checked. Initialized as true so that the table renders the initial set of rows.
         */
        this._headerRowDefChanged = true;
        /**
         * Whether the footer row definition has been changed. Triggers an update to the footer row after
         * content is checked. Initialized as true so that the table renders the initial set of rows.
         */
        this._footerRowDefChanged = true;
        /**
         * Cache of the latest rendered `RenderRow` objects as a map for easy retrieval when constructing
         * a new list of `RenderRow` objects for rendering rows. Since the new list is constructed with
         * the cached `RenderRow` objects when possible, the row identity is preserved when the data
         * and row template matches, which allows the `IterableDiffer` to check rows by reference
         * and understand which rows are added/moved/removed.
         *
         * Implemented as a map of maps where the first key is the `data: T` object and the second is the
         * `CdkRowDef<T>` object. With the two keys, the cache points to a `RenderRow<T>` object that
         * contains an array of created pairs. The array is necessary to handle cases where the data
         * array contains multiple duplicate data objects and each instantiated `RenderRow` must be
         * stored.
         */
        this._cachedRenderRowsMap = new Map();
        /**
         * CSS class added to any row or cell that has sticky positioning applied. May be overriden by
         * table subclasses.
         */
        this.stickyCssClass = 'cdk-table-sticky';
        this._multiTemplateDataRows = false;
        /**
         * Stream containing the latest information on what rows are being displayed on screen.
         * Can be used by the data source to as a heuristic of what data should be provided.
         */
        this.viewChange = new __WEBPACK_IMPORTED_MODULE_5_rxjs__["BehaviorSubject"]({ start: 0, end: Number.MAX_VALUE });
        if (!role) {
            this._elementRef.nativeElement.setAttribute('role', 'grid');
        }
        this._document = _document;
        this._isNativeHtmlTable = this._elementRef.nativeElement.nodeName === 'TABLE';
    }
    Object.defineProperty(CdkTable.prototype, "trackBy", {
        get: /**
         * Tracking function that will be used to check the differences in data changes. Used similarly
         * to `ngFor` `trackBy` function. Optimize row operations by identifying a row based on its data
         * relative to the function to know if a row should be added/removed/moved.
         * Accepts a function that takes two parameters, `index` and `item`.
         * @return {?}
         */
        function () { return this._trackByFn; },
        set: /**
         * @param {?} fn
         * @return {?}
         */
        function (fn) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["isDevMode"])() &&
                fn != null && typeof fn !== 'function' && /** @type {?} */ (console) && /** @type {?} */ (console.warn)) {
                console.warn("trackBy must be a function, but received " + JSON.stringify(fn) + ".");
            }
            this._trackByFn = fn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkTable.prototype, "dataSource", {
        get: /**
         * The table's source of data, which can be provided in three ways (in order of complexity):
         *   - Simple data array (each object represents one table row)
         *   - Stream that emits a data array each time the array changes
         *   - `DataSource` object that implements the connect/disconnect interface.
         *
         * If a data array is provided, the table must be notified when the array's objects are
         * added, removed, or moved. This can be done by calling the `renderRows()` function which will
         * render the diff since the last table render. If the data array reference is changed, the table
         * will automatically trigger an update to the rows.
         *
         * When providing an Observable stream, the table will trigger an update automatically when the
         * stream emits a new array of data.
         *
         * Finally, when providing a `DataSource` object, the table will use the Observable stream
         * provided by the connect function and trigger updates when that stream emits new data array
         * values. During the table's ngOnDestroy or when the data source is removed from the table, the
         * table will call the DataSource's `disconnect` function (may be useful for cleaning up any
         * subscriptions registered during the connect process).
         * @return {?}
         */
        function () { return this._dataSource; },
        set: /**
         * @param {?} dataSource
         * @return {?}
         */
        function (dataSource) {
            if (this._dataSource !== dataSource) {
                this._switchDataSource(dataSource);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkTable.prototype, "multiTemplateDataRows", {
        get: /**
         * Whether to allow multiple rows per data object by evaluating which rows evaluate their 'when'
         * predicate to true. If `multiTemplateDataRows` is false, which is the default value, then each
         * dataobject will render the first row that evaluates its when predicate to true, in the order
         * defined in the table, or otherwise the default row which does not have a when predicate.
         * @return {?}
         */
        function () { return this._multiTemplateDataRows; },
        set: /**
         * @param {?} v
         * @return {?}
         */
        function (v) {
            this._multiTemplateDataRows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_cdk_coercion__["a" /* coerceBooleanProperty */])(v);
            if (this._rowOutlet.viewContainer.length) {
                this._forceRenderDataRows();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkTable.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this._setupStickyStyler();
        if (this._isNativeHtmlTable) {
            this._applyNativeTableSections();
        }
        // Set up the trackBy function so that it uses the `RenderRow` as its identity by default. If
        // the user has provided a custom trackBy, return the result of that function as evaluated
        // with the values of the `RenderRow`'s data and index.
        this._dataDiffer = this._differs.find([]).create(function (_i, dataRow) {
            return _this.trackBy ? _this.trackBy(dataRow.dataIndex, dataRow.data) : dataRow;
        });
    };
    /**
     * @return {?}
     */
    CdkTable.prototype.ngAfterContentChecked = /**
     * @return {?}
     */
    function () {
        // Cache the row and column definitions gathered by ContentChildren and programmatic injection.
        this._cacheRowDefs();
        this._cacheColumnDefs();
        // Make sure that the user has at least added header, footer, or data row def.
        if (!this._headerRowDefs.length && !this._footerRowDefs.length && !this._rowDefs.length) {
            throw getTableMissingRowDefsError();
        }
        // Render updates if the list of columns have been changed for the header, row, or footer defs.
        this._renderUpdatedColumns();
        // If the header row definition has been changed, trigger a render to the header row.
        if (this._headerRowDefChanged) {
            this._forceRenderHeaderRows();
            this._headerRowDefChanged = false;
        }
        // If the footer row definition has been changed, trigger a render to the footer row.
        if (this._footerRowDefChanged) {
            this._forceRenderFooterRows();
            this._footerRowDefChanged = false;
        }
        // If there is a data source and row definitions, connect to the data source unless a
        // connection has already been made.
        if (this.dataSource && this._rowDefs.length > 0 && !this._renderChangeSubscription) {
            this._observeRenderChanges();
        }
        this._checkStickyStates();
    };
    /**
     * @return {?}
     */
    CdkTable.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._rowOutlet.viewContainer.clear();
        this._headerRowOutlet.viewContainer.clear();
        this._footerRowOutlet.viewContainer.clear();
        this._cachedRenderRowsMap.clear();
        this._onDestroy.next();
        this._onDestroy.complete();
        if (this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_3__angular_cdk_collections__["a" /* DataSource */]) {
            this.dataSource.disconnect(this);
        }
    };
    /**
     * Renders rows based on the table's latest set of data, which was either provided directly as an
     * input or retrieved through an Observable stream (directly or from a DataSource).
     * Checks for differences in the data since the last diff to perform only the necessary
     * changes (add/remove/move rows).
     *
     * If the table's data source is a DataSource or Observable, this will be invoked automatically
     * each time the provided Observable stream emits a new data array. Otherwise if your data is
     * an array, this function will need to be called to render any changes.
     */
    /**
     * Renders rows based on the table's latest set of data, which was either provided directly as an
     * input or retrieved through an Observable stream (directly or from a DataSource).
     * Checks for differences in the data since the last diff to perform only the necessary
     * changes (add/remove/move rows).
     *
     * If the table's data source is a DataSource or Observable, this will be invoked automatically
     * each time the provided Observable stream emits a new data array. Otherwise if your data is
     * an array, this function will need to be called to render any changes.
     * @return {?}
     */
    CdkTable.prototype.renderRows = /**
     * Renders rows based on the table's latest set of data, which was either provided directly as an
     * input or retrieved through an Observable stream (directly or from a DataSource).
     * Checks for differences in the data since the last diff to perform only the necessary
     * changes (add/remove/move rows).
     *
     * If the table's data source is a DataSource or Observable, this will be invoked automatically
     * each time the provided Observable stream emits a new data array. Otherwise if your data is
     * an array, this function will need to be called to render any changes.
     * @return {?}
     */
    function () {
        var _this = this;
        this._renderRows = this._getAllRenderRows();
        var /** @type {?} */ changes = this._dataDiffer.diff(this._renderRows);
        if (!changes) {
            return;
        }
        var /** @type {?} */ viewContainer = this._rowOutlet.viewContainer;
        changes.forEachOperation(function (record, prevIndex, currentIndex) {
            if (record.previousIndex == null) {
                _this._insertRow(record.item, currentIndex);
            }
            else if (currentIndex == null) {
                viewContainer.remove(prevIndex);
            }
            else {
                var /** @type {?} */ view = /** @type {?} */ (viewContainer.get(prevIndex));
                viewContainer.move(/** @type {?} */ ((view)), currentIndex);
            }
        });
        // Update the meta context of a row's context data (index, count, first, last, ...)
        this._updateRowIndexContext();
        // Update rows that did not get added/removed/moved but may have had their identity changed,
        // e.g. if trackBy matched data on some property but the actual data reference changed.
        changes.forEachIdentityChange(function (record) {
            var /** @type {?} */ rowView = /** @type {?} */ (viewContainer.get(/** @type {?} */ ((record.currentIndex))));
            rowView.context.$implicit = record.item.data;
        });
        this.updateStickyColumnStyles();
    };
    /**
     * Sets the header row definition to be used. Overrides the header row definition gathered by
     * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
     * table's content is checked.
     * @docs-private
     * @deprecated Use `addHeaderRowDef` and `removeHeaderRowDef` instead
     * @breaking-change 8.0.0
     */
    /**
     * Sets the header row definition to be used. Overrides the header row definition gathered by
     * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
     * table's content is checked.
     * \@docs-private
     * @deprecated Use `addHeaderRowDef` and `removeHeaderRowDef` instead
     * \@breaking-change 8.0.0
     * @param {?} headerRowDef
     * @return {?}
     */
    CdkTable.prototype.setHeaderRowDef = /**
     * Sets the header row definition to be used. Overrides the header row definition gathered by
     * using `ContentChild`, if one exists. Sets a flag that will re-render the header row after the
     * table's content is checked.
     * \@docs-private
     * @deprecated Use `addHeaderRowDef` and `removeHeaderRowDef` instead
     * \@breaking-change 8.0.0
     * @param {?} headerRowDef
     * @return {?}
     */
    function (headerRowDef) {
        this._customHeaderRowDefs = new Set([headerRowDef]);
        this._headerRowDefChanged = true;
    };
    /**
     * Sets the footer row definition to be used. Overrides the footer row definition gathered by
     * using `ContentChild`, if one exists. Sets a flag that will re-render the footer row after the
     * table's content is checked.
     * @docs-private
     * @deprecated Use `addFooterRowDef` and `removeFooterRowDef` instead
     * @breaking-change 8.0.0
     */
    /**
     * Sets the footer row definition to be used. Overrides the footer row definition gathered by
     * using `ContentChild`, if one exists. Sets a flag that will re-render the footer row after the
     * table's content is checked.
     * \@docs-private
     * @deprecated Use `addFooterRowDef` and `removeFooterRowDef` instead
     * \@breaking-change 8.0.0
     * @param {?} footerRowDef
     * @return {?}
     */
    CdkTable.prototype.setFooterRowDef = /**
     * Sets the footer row definition to be used. Overrides the footer row definition gathered by
     * using `ContentChild`, if one exists. Sets a flag that will re-render the footer row after the
     * table's content is checked.
     * \@docs-private
     * @deprecated Use `addFooterRowDef` and `removeFooterRowDef` instead
     * \@breaking-change 8.0.0
     * @param {?} footerRowDef
     * @return {?}
     */
    function (footerRowDef) {
        this._customFooterRowDefs = new Set([footerRowDef]);
        this._footerRowDefChanged = true;
    };
    /** Adds a column definition that was not included as part of the content children. */
    /**
     * Adds a column definition that was not included as part of the content children.
     * @param {?} columnDef
     * @return {?}
     */
    CdkTable.prototype.addColumnDef = /**
     * Adds a column definition that was not included as part of the content children.
     * @param {?} columnDef
     * @return {?}
     */
    function (columnDef) {
        this._customColumnDefs.add(columnDef);
    };
    /** Removes a column definition that was not included as part of the content children. */
    /**
     * Removes a column definition that was not included as part of the content children.
     * @param {?} columnDef
     * @return {?}
     */
    CdkTable.prototype.removeColumnDef = /**
     * Removes a column definition that was not included as part of the content children.
     * @param {?} columnDef
     * @return {?}
     */
    function (columnDef) {
        this._customColumnDefs.delete(columnDef);
    };
    /** Adds a row definition that was not included as part of the content children. */
    /**
     * Adds a row definition that was not included as part of the content children.
     * @param {?} rowDef
     * @return {?}
     */
    CdkTable.prototype.addRowDef = /**
     * Adds a row definition that was not included as part of the content children.
     * @param {?} rowDef
     * @return {?}
     */
    function (rowDef) {
        this._customRowDefs.add(rowDef);
    };
    /** Removes a row definition that was not included as part of the content children. */
    /**
     * Removes a row definition that was not included as part of the content children.
     * @param {?} rowDef
     * @return {?}
     */
    CdkTable.prototype.removeRowDef = /**
     * Removes a row definition that was not included as part of the content children.
     * @param {?} rowDef
     * @return {?}
     */
    function (rowDef) {
        this._customRowDefs.delete(rowDef);
    };
    /** Adds a header row definition that was not included as part of the content children. */
    /**
     * Adds a header row definition that was not included as part of the content children.
     * @param {?} headerRowDef
     * @return {?}
     */
    CdkTable.prototype.addHeaderRowDef = /**
     * Adds a header row definition that was not included as part of the content children.
     * @param {?} headerRowDef
     * @return {?}
     */
    function (headerRowDef) {
        this._customHeaderRowDefs.add(headerRowDef);
        this._headerRowDefChanged = true;
    };
    /** Removes a header row definition that was not included as part of the content children. */
    /**
     * Removes a header row definition that was not included as part of the content children.
     * @param {?} headerRowDef
     * @return {?}
     */
    CdkTable.prototype.removeHeaderRowDef = /**
     * Removes a header row definition that was not included as part of the content children.
     * @param {?} headerRowDef
     * @return {?}
     */
    function (headerRowDef) {
        this._customHeaderRowDefs.delete(headerRowDef);
        this._headerRowDefChanged = true;
    };
    /** Adds a footer row definition that was not included as part of the content children. */
    /**
     * Adds a footer row definition that was not included as part of the content children.
     * @param {?} footerRowDef
     * @return {?}
     */
    CdkTable.prototype.addFooterRowDef = /**
     * Adds a footer row definition that was not included as part of the content children.
     * @param {?} footerRowDef
     * @return {?}
     */
    function (footerRowDef) {
        this._customFooterRowDefs.add(footerRowDef);
        this._footerRowDefChanged = true;
    };
    /** Removes a footer row definition that was not included as part of the content children. */
    /**
     * Removes a footer row definition that was not included as part of the content children.
     * @param {?} footerRowDef
     * @return {?}
     */
    CdkTable.prototype.removeFooterRowDef = /**
     * Removes a footer row definition that was not included as part of the content children.
     * @param {?} footerRowDef
     * @return {?}
     */
    function (footerRowDef) {
        this._customFooterRowDefs.delete(footerRowDef);
        this._footerRowDefChanged = true;
    };
    /**
     * Updates the header sticky styles. First resets all applied styles with respect to the cells
     * sticking to the top. Then, evaluating which cells need to be stuck to the top. This is
     * automatically called when the header row changes its displayed set of columns, or if its
     * sticky input changes. May be called manually for cases where the cell content changes outside
     * of these events.
     */
    /**
     * Updates the header sticky styles. First resets all applied styles with respect to the cells
     * sticking to the top. Then, evaluating which cells need to be stuck to the top. This is
     * automatically called when the header row changes its displayed set of columns, or if its
     * sticky input changes. May be called manually for cases where the cell content changes outside
     * of these events.
     * @return {?}
     */
    CdkTable.prototype.updateStickyHeaderRowStyles = /**
     * Updates the header sticky styles. First resets all applied styles with respect to the cells
     * sticking to the top. Then, evaluating which cells need to be stuck to the top. This is
     * automatically called when the header row changes its displayed set of columns, or if its
     * sticky input changes. May be called manually for cases where the cell content changes outside
     * of these events.
     * @return {?}
     */
    function () {
        var /** @type {?} */ headerRows = this._getRenderedRows(this._headerRowOutlet);
        this._stickyStyler.clearStickyPositioning(headerRows, ['top']);
        var /** @type {?} */ stickyStates = this._headerRowDefs.map(function (def) { return def.sticky; });
        this._stickyStyler.stickRows(headerRows, stickyStates, 'top');
        // Reset the dirty state of the sticky input change since it has been used.
        this._headerRowDefs.forEach(function (def) { return def.resetStickyChanged(); });
    };
    /**
     * Updates the footer sticky styles. First resets all applied styles with respect to the cells
     * sticking to the bottom. Then, evaluating which cells need to be stuck to the bottom. This is
     * automatically called when the footer row changes its displayed set of columns, or if its
     * sticky input changes. May be called manually for cases where the cell content changes outside
     * of these events.
     */
    /**
     * Updates the footer sticky styles. First resets all applied styles with respect to the cells
     * sticking to the bottom. Then, evaluating which cells need to be stuck to the bottom. This is
     * automatically called when the footer row changes its displayed set of columns, or if its
     * sticky input changes. May be called manually for cases where the cell content changes outside
     * of these events.
     * @return {?}
     */
    CdkTable.prototype.updateStickyFooterRowStyles = /**
     * Updates the footer sticky styles. First resets all applied styles with respect to the cells
     * sticking to the bottom. Then, evaluating which cells need to be stuck to the bottom. This is
     * automatically called when the footer row changes its displayed set of columns, or if its
     * sticky input changes. May be called manually for cases where the cell content changes outside
     * of these events.
     * @return {?}
     */
    function () {
        var /** @type {?} */ footerRows = this._getRenderedRows(this._footerRowOutlet);
        this._stickyStyler.clearStickyPositioning(footerRows, ['bottom']);
        var /** @type {?} */ stickyStates = this._footerRowDefs.map(function (def) { return def.sticky; });
        this._stickyStyler.stickRows(footerRows, stickyStates, 'bottom');
        this._stickyStyler.updateStickyFooterContainer(this._elementRef.nativeElement, stickyStates);
        // Reset the dirty state of the sticky input change since it has been used.
        this._footerRowDefs.forEach(function (def) { return def.resetStickyChanged(); });
    };
    /**
     * Updates the column sticky styles. First resets all applied styles with respect to the cells
     * sticking to the left and right. Then sticky styles are added for the left and right according
     * to the column definitions for each cell in each row. This is automatically called when
     * the data source provides a new set of data or when a column definition changes its sticky
     * input. May be called manually for cases where the cell content changes outside of these events.
     */
    /**
     * Updates the column sticky styles. First resets all applied styles with respect to the cells
     * sticking to the left and right. Then sticky styles are added for the left and right according
     * to the column definitions for each cell in each row. This is automatically called when
     * the data source provides a new set of data or when a column definition changes its sticky
     * input. May be called manually for cases where the cell content changes outside of these events.
     * @return {?}
     */
    CdkTable.prototype.updateStickyColumnStyles = /**
     * Updates the column sticky styles. First resets all applied styles with respect to the cells
     * sticking to the left and right. Then sticky styles are added for the left and right according
     * to the column definitions for each cell in each row. This is automatically called when
     * the data source provides a new set of data or when a column definition changes its sticky
     * input. May be called manually for cases where the cell content changes outside of these events.
     * @return {?}
     */
    function () {
        var _this = this;
        var /** @type {?} */ headerRows = this._getRenderedRows(this._headerRowOutlet);
        var /** @type {?} */ dataRows = this._getRenderedRows(this._rowOutlet);
        var /** @type {?} */ footerRows = this._getRenderedRows(this._footerRowOutlet);
        // Clear the left and right positioning from all columns in the table across all rows since
        // sticky columns span across all table sections (header, data, footer)
        this._stickyStyler.clearStickyPositioning(headerRows.concat(dataRows, footerRows), ['left', 'right']);
        // Update the sticky styles for each header row depending on the def's sticky state
        headerRows.forEach(function (headerRow, i) {
            _this._addStickyColumnStyles([headerRow], _this._headerRowDefs[i]);
        });
        // Update the sticky styles for each data row depending on its def's sticky state
        this._rowDefs.forEach(function (rowDef) {
            // Collect all the rows rendered with this row definition.
            var /** @type {?} */ rows = [];
            for (var /** @type {?} */ i = 0; i < dataRows.length; i++) {
                if (_this._renderRows[i].rowDef === rowDef) {
                    rows.push(dataRows[i]);
                }
            }
            _this._addStickyColumnStyles(rows, rowDef);
        });
        // Update the sticky styles for each footer row depending on the def's sticky state
        footerRows.forEach(function (footerRow, i) {
            _this._addStickyColumnStyles([footerRow], _this._footerRowDefs[i]);
        });
        // Reset the dirty state of the sticky input change since it has been used.
        Array.from(this._columnDefsByName.values()).forEach(function (def) { return def.resetStickyChanged(); });
    };
    /**
     * Get the list of RenderRow objects to render according to the current list of data and defined
     * row definitions. If the previous list already contained a particular pair, it should be reused
     * so that the differ equates their references.
     * @return {?}
     */
    CdkTable.prototype._getAllRenderRows = /**
     * Get the list of RenderRow objects to render according to the current list of data and defined
     * row definitions. If the previous list already contained a particular pair, it should be reused
     * so that the differ equates their references.
     * @return {?}
     */
    function () {
        var /** @type {?} */ renderRows = [];
        // Store the cache and create a new one. Any re-used RenderRow objects will be moved into the
        // new cache while unused ones can be picked up by garbage collection.
        var /** @type {?} */ prevCachedRenderRows = this._cachedRenderRowsMap;
        this._cachedRenderRowsMap = new Map();
        // For each data object, get the list of rows that should be rendered, represented by the
        // respective `RenderRow` object which is the pair of `data` and `CdkRowDef`.
        for (var /** @type {?} */ i = 0; i < this._data.length; i++) {
            var /** @type {?} */ data = this._data[i];
            var /** @type {?} */ renderRowsForData = this._getRenderRowsForData(data, i, prevCachedRenderRows.get(data));
            if (!this._cachedRenderRowsMap.has(data)) {
                this._cachedRenderRowsMap.set(data, new WeakMap());
            }
            for (var /** @type {?} */ j = 0; j < renderRowsForData.length; j++) {
                var /** @type {?} */ renderRow = renderRowsForData[j];
                var /** @type {?} */ cache = /** @type {?} */ ((this._cachedRenderRowsMap.get(renderRow.data)));
                if (cache.has(renderRow.rowDef)) {
                    /** @type {?} */ ((cache.get(renderRow.rowDef))).push(renderRow);
                }
                else {
                    cache.set(renderRow.rowDef, [renderRow]);
                }
                renderRows.push(renderRow);
            }
        }
        return renderRows;
    };
    /**
     * Gets a list of `RenderRow<T>` for the provided data object and any `CdkRowDef` objects that
     * should be rendered for this data. Reuses the cached RenderRow objects if they match the same
     * `(T, CdkRowDef)` pair.
     * @param {?} data
     * @param {?} dataIndex
     * @param {?=} cache
     * @return {?}
     */
    CdkTable.prototype._getRenderRowsForData = /**
     * Gets a list of `RenderRow<T>` for the provided data object and any `CdkRowDef` objects that
     * should be rendered for this data. Reuses the cached RenderRow objects if they match the same
     * `(T, CdkRowDef)` pair.
     * @param {?} data
     * @param {?} dataIndex
     * @param {?=} cache
     * @return {?}
     */
    function (data, dataIndex, cache) {
        var /** @type {?} */ rowDefs = this._getRowDefs(data, dataIndex);
        return rowDefs.map(function (rowDef) {
            var /** @type {?} */ cachedRenderRows = (cache && cache.has(rowDef)) ? /** @type {?} */ ((cache.get(rowDef))) : [];
            if (cachedRenderRows.length) {
                var /** @type {?} */ dataRow = /** @type {?} */ ((cachedRenderRows.shift()));
                dataRow.dataIndex = dataIndex;
                return dataRow;
            }
            else {
                return { data: data, rowDef: rowDef, dataIndex: dataIndex };
            }
        });
    };
    /**
     * Update the map containing the content's column definitions.
     * @return {?}
     */
    CdkTable.prototype._cacheColumnDefs = /**
     * Update the map containing the content's column definitions.
     * @return {?}
     */
    function () {
        var _this = this;
        this._columnDefsByName.clear();
        var /** @type {?} */ columnDefs = mergeQueryListAndSet(this._contentColumnDefs, this._customColumnDefs);
        columnDefs.forEach(function (columnDef) {
            if (_this._columnDefsByName.has(columnDef.name)) {
                throw getTableDuplicateColumnNameError(columnDef.name);
            }
            _this._columnDefsByName.set(columnDef.name, columnDef);
        });
    };
    /**
     * Update the list of all available row definitions that can be used.
     * @return {?}
     */
    CdkTable.prototype._cacheRowDefs = /**
     * Update the list of all available row definitions that can be used.
     * @return {?}
     */
    function () {
        this._headerRowDefs =
            mergeQueryListAndSet(this._contentHeaderRowDefs, this._customHeaderRowDefs);
        this._footerRowDefs =
            mergeQueryListAndSet(this._contentFooterRowDefs, this._customFooterRowDefs);
        this._rowDefs =
            mergeQueryListAndSet(this._contentRowDefs, this._customRowDefs);
        // After all row definitions are determined, find the row definition to be considered default.
        var /** @type {?} */ defaultRowDefs = this._rowDefs.filter(function (def) { return !def.when; });
        if (!this.multiTemplateDataRows && defaultRowDefs.length > 1) {
            throw getTableMultipleDefaultRowDefsError();
        }
        this._defaultRowDef = defaultRowDefs[0];
    };
    /**
     * Check if the header, data, or footer rows have changed what columns they want to display or
     * whether the sticky states have changed for the header or footer. If there is a diff, then
     * re-render that section.
     * @return {?}
     */
    CdkTable.prototype._renderUpdatedColumns = /**
     * Check if the header, data, or footer rows have changed what columns they want to display or
     * whether the sticky states have changed for the header or footer. If there is a diff, then
     * re-render that section.
     * @return {?}
     */
    function () {
        var /** @type {?} */ columnsDiffReducer = function (acc, def) { return acc || !!def.getColumnsDiff(); };
        // Force re-render data rows if the list of column definitions have changed.
        if (this._rowDefs.reduce(columnsDiffReducer, false)) {
            this._forceRenderDataRows();
        }
        // Force re-render header/footer rows if the list of column definitions have changed..
        if (this._headerRowDefs.reduce(columnsDiffReducer, false)) {
            this._forceRenderHeaderRows();
        }
        if (this._footerRowDefs.reduce(columnsDiffReducer, false)) {
            this._forceRenderFooterRows();
        }
    };
    /**
     * Switch to the provided data source by resetting the data and unsubscribing from the current
     * render change subscription if one exists. If the data source is null, interpret this by
     * clearing the row outlet. Otherwise start listening for new data.
     * @param {?} dataSource
     * @return {?}
     */
    CdkTable.prototype._switchDataSource = /**
     * Switch to the provided data source by resetting the data and unsubscribing from the current
     * render change subscription if one exists. If the data source is null, interpret this by
     * clearing the row outlet. Otherwise start listening for new data.
     * @param {?} dataSource
     * @return {?}
     */
    function (dataSource) {
        this._data = [];
        if (this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_3__angular_cdk_collections__["a" /* DataSource */]) {
            this.dataSource.disconnect(this);
        }
        // Stop listening for data from the previous data source.
        if (this._renderChangeSubscription) {
            this._renderChangeSubscription.unsubscribe();
            this._renderChangeSubscription = null;
        }
        if (!dataSource) {
            if (this._dataDiffer) {
                this._dataDiffer.diff([]);
            }
            this._rowOutlet.viewContainer.clear();
        }
        this._dataSource = dataSource;
    };
    /**
     * Set up a subscription for the data provided by the data source.
     * @return {?}
     */
    CdkTable.prototype._observeRenderChanges = /**
     * Set up a subscription for the data provided by the data source.
     * @return {?}
     */
    function () {
        var _this = this;
        // If no data source has been set, there is nothing to observe for changes.
        if (!this.dataSource) {
            return;
        }
        var /** @type {?} */ dataStream;
        // Check if the datasource is a DataSource object by observing if it has a connect function.
        // Cannot check this.dataSource['connect'] due to potential property renaming, nor can it
        // checked as an instanceof DataSource<T> since the table should allow for data sources
        // that did not explicitly extend DataSource<T>.
        if ((/** @type {?} */ (this.dataSource)).connect instanceof Function) {
            dataStream = (/** @type {?} */ (this.dataSource)).connect(this);
        }
        else if (this.dataSource instanceof __WEBPACK_IMPORTED_MODULE_5_rxjs__["Observable"]) {
            dataStream = this.dataSource;
        }
        else if (Array.isArray(this.dataSource)) {
            dataStream = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs__["of"])(this.dataSource);
        }
        if (dataStream === undefined) {
            throw getTableUnknownDataSourceError();
        }
        this._renderChangeSubscription = dataStream
            .pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["takeUntil"])(this._onDestroy))
            .subscribe(function (data) {
            _this._data = data || [];
            _this.renderRows();
        });
    };
    /**
     * Clears any existing content in the header row outlet and creates a new embedded view
     * in the outlet using the header row definition.
     * @return {?}
     */
    CdkTable.prototype._forceRenderHeaderRows = /**
     * Clears any existing content in the header row outlet and creates a new embedded view
     * in the outlet using the header row definition.
     * @return {?}
     */
    function () {
        var _this = this;
        // Clear the header row outlet if any content exists.
        if (this._headerRowOutlet.viewContainer.length > 0) {
            this._headerRowOutlet.viewContainer.clear();
        }
        this._headerRowDefs.forEach(function (def, i) { return _this._renderRow(_this._headerRowOutlet, def, i); });
        this.updateStickyHeaderRowStyles();
        this.updateStickyColumnStyles();
    };
    /**
     * Clears any existing content in the footer row outlet and creates a new embedded view
     * in the outlet using the footer row definition.
     * @return {?}
     */
    CdkTable.prototype._forceRenderFooterRows = /**
     * Clears any existing content in the footer row outlet and creates a new embedded view
     * in the outlet using the footer row definition.
     * @return {?}
     */
    function () {
        var _this = this;
        // Clear the footer row outlet if any content exists.
        if (this._footerRowOutlet.viewContainer.length > 0) {
            this._footerRowOutlet.viewContainer.clear();
        }
        this._footerRowDefs.forEach(function (def, i) { return _this._renderRow(_this._footerRowOutlet, def, i); });
        this.updateStickyFooterRowStyles();
        this.updateStickyColumnStyles();
    };
    /**
     * Adds the sticky column styles for the rows according to the columns' stick states.
     * @param {?} rows
     * @param {?} rowDef
     * @return {?}
     */
    CdkTable.prototype._addStickyColumnStyles = /**
     * Adds the sticky column styles for the rows according to the columns' stick states.
     * @param {?} rows
     * @param {?} rowDef
     * @return {?}
     */
    function (rows, rowDef) {
        var _this = this;
        var /** @type {?} */ columnDefs = Array.from(rowDef.columns || []).map(function (c) { return ((_this._columnDefsByName.get(c))); });
        var /** @type {?} */ stickyStartStates = columnDefs.map(function (columnDef) { return columnDef.sticky; });
        var /** @type {?} */ stickyEndStates = columnDefs.map(function (columnDef) { return columnDef.stickyEnd; });
        this._stickyStyler.updateStickyColumns(rows, stickyStartStates, stickyEndStates);
    };
    /** Gets the list of rows that have been rendered in the row outlet. */
    /**
     * Gets the list of rows that have been rendered in the row outlet.
     * @param {?} rowOutlet
     * @return {?}
     */
    CdkTable.prototype._getRenderedRows = /**
     * Gets the list of rows that have been rendered in the row outlet.
     * @param {?} rowOutlet
     * @return {?}
     */
    function (rowOutlet) {
        var /** @type {?} */ renderedRows = [];
        for (var /** @type {?} */ i = 0; i < rowOutlet.viewContainer.length; i++) {
            var /** @type {?} */ viewRef = (/** @type {?} */ (((rowOutlet.viewContainer.get(i)))));
            renderedRows.push(viewRef.rootNodes[0]);
        }
        return renderedRows;
    };
    /**
     * Get the matching row definitions that should be used for this row data. If there is only
     * one row definition, it is returned. Otherwise, find the row definitions that has a when
     * predicate that returns true with the data. If none return true, return the default row
     * definition.
     */
    /**
     * Get the matching row definitions that should be used for this row data. If there is only
     * one row definition, it is returned. Otherwise, find the row definitions that has a when
     * predicate that returns true with the data. If none return true, return the default row
     * definition.
     * @param {?} data
     * @param {?} dataIndex
     * @return {?}
     */
    CdkTable.prototype._getRowDefs = /**
     * Get the matching row definitions that should be used for this row data. If there is only
     * one row definition, it is returned. Otherwise, find the row definitions that has a when
     * predicate that returns true with the data. If none return true, return the default row
     * definition.
     * @param {?} data
     * @param {?} dataIndex
     * @return {?}
     */
    function (data, dataIndex) {
        if (this._rowDefs.length == 1) {
            return [this._rowDefs[0]];
        }
        var /** @type {?} */ rowDefs = [];
        if (this.multiTemplateDataRows) {
            rowDefs = this._rowDefs.filter(function (def) { return !def.when || def.when(dataIndex, data); });
        }
        else {
            var /** @type {?} */ rowDef = this._rowDefs.find(function (def) { return def.when && def.when(dataIndex, data); }) || this._defaultRowDef;
            if (rowDef) {
                rowDefs.push(rowDef);
            }
        }
        if (!rowDefs.length) {
            throw getTableMissingMatchingRowDefError(data);
        }
        return rowDefs;
    };
    /**
     * Create the embedded view for the data row template and place it in the correct index location
     * within the data row view container.
     * @param {?} renderRow
     * @param {?} renderIndex
     * @return {?}
     */
    CdkTable.prototype._insertRow = /**
     * Create the embedded view for the data row template and place it in the correct index location
     * within the data row view container.
     * @param {?} renderRow
     * @param {?} renderIndex
     * @return {?}
     */
    function (renderRow, renderIndex) {
        var /** @type {?} */ rowDef = renderRow.rowDef;
        var /** @type {?} */ context = { $implicit: renderRow.data };
        this._renderRow(this._rowOutlet, rowDef, renderIndex, context);
    };
    /**
     * Creates a new row template in the outlet and fills it with the set of cell templates.
     * Optionally takes a context to provide to the row and cells, as well as an optional index
     * of where to place the new row template in the outlet.
     * @param {?} outlet
     * @param {?} rowDef
     * @param {?} index
     * @param {?=} context
     * @return {?}
     */
    CdkTable.prototype._renderRow = /**
     * Creates a new row template in the outlet and fills it with the set of cell templates.
     * Optionally takes a context to provide to the row and cells, as well as an optional index
     * of where to place the new row template in the outlet.
     * @param {?} outlet
     * @param {?} rowDef
     * @param {?} index
     * @param {?=} context
     * @return {?}
     */
    function (outlet, rowDef, index, context) {
        if (context === void 0) { context = {}; }
        // TODO(andrewseguin): enforce that one outlet was instantiated from createEmbeddedView
        outlet.viewContainer.createEmbeddedView(rowDef.template, context, index);
        for (var _a = 0, _b = this._getCellTemplates(rowDef); _a < _b.length; _a++) {
            var cellTemplate = _b[_a];
            if (CdkCellOutlet.mostRecentCellOutlet) {
                CdkCellOutlet.mostRecentCellOutlet._viewContainer.createEmbeddedView(cellTemplate, context);
            }
        }
        this._changeDetectorRef.markForCheck();
    };
    /**
     * Updates the index-related context for each row to reflect any changes in the index of the rows,
     * e.g. first/last/even/odd.
     * @return {?}
     */
    CdkTable.prototype._updateRowIndexContext = /**
     * Updates the index-related context for each row to reflect any changes in the index of the rows,
     * e.g. first/last/even/odd.
     * @return {?}
     */
    function () {
        var /** @type {?} */ viewContainer = this._rowOutlet.viewContainer;
        for (var /** @type {?} */ renderIndex = 0, /** @type {?} */ count = viewContainer.length; renderIndex < count; renderIndex++) {
            var /** @type {?} */ viewRef = /** @type {?} */ (viewContainer.get(renderIndex));
            var /** @type {?} */ context = /** @type {?} */ (viewRef.context);
            context.count = count;
            context.first = renderIndex === 0;
            context.last = renderIndex === count - 1;
            context.even = renderIndex % 2 === 0;
            context.odd = !context.even;
            if (this.multiTemplateDataRows) {
                context.dataIndex = this._renderRows[renderIndex].dataIndex;
                context.renderIndex = renderIndex;
            }
            else {
                context.index = this._renderRows[renderIndex].dataIndex;
            }
        }
    };
    /**
     * Gets the column definitions for the provided row def.
     * @param {?} rowDef
     * @return {?}
     */
    CdkTable.prototype._getCellTemplates = /**
     * Gets the column definitions for the provided row def.
     * @param {?} rowDef
     * @return {?}
     */
    function (rowDef) {
        var _this = this;
        if (!rowDef || !rowDef.columns) {
            return [];
        }
        return Array.from(rowDef.columns, function (columnId) {
            var /** @type {?} */ column = _this._columnDefsByName.get(columnId);
            if (!column) {
                throw getTableUnknownColumnError(columnId);
            }
            return rowDef.extractCellTemplate(column);
        });
    };
    /**
     * Adds native table sections (e.g. tbody) and moves the row outlets into them.
     * @return {?}
     */
    CdkTable.prototype._applyNativeTableSections = /**
     * Adds native table sections (e.g. tbody) and moves the row outlets into them.
     * @return {?}
     */
    function () {
        var /** @type {?} */ sections = [
            { tag: 'thead', outlet: this._headerRowOutlet },
            { tag: 'tbody', outlet: this._rowOutlet },
            { tag: 'tfoot', outlet: this._footerRowOutlet },
        ];
        for (var _a = 0, sections_1 = sections; _a < sections_1.length; _a++) {
            var section = sections_1[_a];
            // @breaking-change 8.0.0 remove the `|| document` once the `_document` is a required param.
            var /** @type {?} */ documentRef = this._document || document;
            var /** @type {?} */ element = documentRef.createElement(section.tag);
            element.appendChild(section.outlet.elementRef.nativeElement);
            this._elementRef.nativeElement.appendChild(element);
        }
    };
    /**
     * Forces a re-render of the data rows. Should be called in cases where there has been an input
     * change that affects the evaluation of which rows should be rendered, e.g. toggling
     * `multiTemplateDataRows` or adding/removing row definitions.
     * @return {?}
     */
    CdkTable.prototype._forceRenderDataRows = /**
     * Forces a re-render of the data rows. Should be called in cases where there has been an input
     * change that affects the evaluation of which rows should be rendered, e.g. toggling
     * `multiTemplateDataRows` or adding/removing row definitions.
     * @return {?}
     */
    function () {
        this._dataDiffer.diff([]);
        this._rowOutlet.viewContainer.clear();
        this.renderRows();
        this.updateStickyColumnStyles();
    };
    /**
     * Checks if there has been a change in sticky states since last check and applies the correct
     * sticky styles. Since checking resets the "dirty" state, this should only be performed once
     * during a change detection and after the inputs are settled (after content check).
     * @return {?}
     */
    CdkTable.prototype._checkStickyStates = /**
     * Checks if there has been a change in sticky states since last check and applies the correct
     * sticky styles. Since checking resets the "dirty" state, this should only be performed once
     * during a change detection and after the inputs are settled (after content check).
     * @return {?}
     */
    function () {
        var /** @type {?} */ stickyCheckReducer = function (acc, d) {
            return acc || d.hasStickyChanged();
        };
        // Note that the check needs to occur for every definition since it notifies the definition
        // that it can reset its dirty state. Using another operator like `some` may short-circuit
        // remaining definitions and leave them in an unchecked state.
        if (this._headerRowDefs.reduce(stickyCheckReducer, false)) {
            this.updateStickyHeaderRowStyles();
        }
        if (this._footerRowDefs.reduce(stickyCheckReducer, false)) {
            this.updateStickyFooterRowStyles();
        }
        if (Array.from(this._columnDefsByName.values()).reduce(stickyCheckReducer, false)) {
            this.updateStickyColumnStyles();
        }
    };
    /**
     * Creates the sticky styler that will be used for sticky rows and columns. Listens
     * for directionality changes and provides the latest direction to the styler. Re-applies column
     * stickiness when directionality changes.
     * @return {?}
     */
    CdkTable.prototype._setupStickyStyler = /**
     * Creates the sticky styler that will be used for sticky rows and columns. Listens
     * for directionality changes and provides the latest direction to the styler. Re-applies column
     * stickiness when directionality changes.
     * @return {?}
     */
    function () {
        var _this = this;
        var /** @type {?} */ direction = this._dir ? this._dir.value : 'ltr';
        this._stickyStyler = new StickyStyler(this._isNativeHtmlTable, 
        // @breaking-change 8.0.0 remove the null check for `this._platform`.
        this.stickyCssClass, direction, this._platform ? this._platform.isBrowser : true);
        (this._dir ? this._dir.change : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs__["of"])())
            .pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators__["takeUntil"])(this._onDestroy))
            .subscribe(function (value) {
            _this._stickyStyler.direction = value;
            _this.updateStickyColumnStyles();
        });
    };
    CdkTable.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Component"], args: [{selector: 'cdk-table, table[cdk-table]',
                    exportAs: 'cdkTable',
                    template: CDK_TABLE_TEMPLATE,
                    host: {
                        'class': 'cdk-table',
                    },
                    encapsulation: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].None,
                    changeDetection: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ChangeDetectionStrategy"].OnPush,
                },] },
    ];
    /** @nocollapse */
    CdkTable.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["IterableDiffers"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ChangeDetectorRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ElementRef"], },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Attribute"], args: ['role',] },] },
        { type: __WEBPACK_IMPORTED_MODULE_7__angular_cdk_bidi__["a" /* Directionality */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Optional"] },] },
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_4__angular_common__["DOCUMENT"],] },] },
        { type: __WEBPACK_IMPORTED_MODULE_8__angular_cdk_platform__["a" /* Platform */], },
    ]; };
    CdkTable.propDecorators = {
        "trackBy": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"] },],
        "dataSource": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"] },],
        "multiTemplateDataRows": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Input"] },],
        "_rowOutlet": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewChild"], args: [DataRowOutlet,] },],
        "_headerRowOutlet": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewChild"], args: [HeaderRowOutlet,] },],
        "_footerRowOutlet": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewChild"], args: [FooterRowOutlet,] },],
        "_contentColumnDefs": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ContentChildren"], args: [CdkColumnDef,] },],
        "_contentRowDefs": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ContentChildren"], args: [CdkRowDef,] },],
        "_contentHeaderRowDefs": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ContentChildren"], args: [CdkHeaderRowDef,] },],
        "_contentFooterRowDefs": [{ type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ContentChildren"], args: [CdkFooterRowDef,] },],
    };
    return CdkTable;
}());
/**
 * Utility function that gets a merged list of the entries in a QueryList and values of a Set.
 * @template T
 * @param {?} queryList
 * @param {?} set
 * @return {?}
 */
function mergeQueryListAndSet(queryList, set) {
    return queryList.toArray().concat(Array.from(set));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ EXPORTED_DECLARATIONS = [
    CdkTable,
    CdkRowDef,
    CdkCellDef,
    CdkCellOutlet,
    CdkHeaderCellDef,
    CdkFooterCellDef,
    CdkColumnDef,
    CdkCell,
    CdkRow,
    CdkHeaderCell,
    CdkFooterCell,
    CdkHeaderRow,
    CdkHeaderRowDef,
    CdkFooterRow,
    CdkFooterRowDef,
    DataRowOutlet,
    HeaderRowOutlet,
    FooterRowOutlet,
];
var CdkTableModule = /** @class */ (function () {
    function CdkTableModule() {
    }
    CdkTableModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_4__angular_common__["CommonModule"]],
                    exports: EXPORTED_DECLARATIONS,
                    declarations: EXPORTED_DECLARATIONS
                },] },
    ];
    return CdkTableModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


//# sourceMappingURL=table.es5.js.map


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var activate_email_component_1 = __webpack_require__(136);
var activate_account_component_1 = __webpack_require__(135);
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var ng_bootstrap_1 = __webpack_require__(19);
var ng2_dragula_1 = __webpack_require__(46);
var forms_1 = __webpack_require__(5);
var shared_1 = __webpack_require__(4);
var account_route_1 = __webpack_require__(134);
var fc_auth_redirect_component_1 = __webpack_require__(139);
var authentication_component_1 = __webpack_require__(137);
var register_component_1 = __webpack_require__(149);
var password_strength_bar_component_1 = __webpack_require__(412);
var password_reset_init_component_1 = __webpack_require__(142);
var password_reset_finish_component_1 = __webpack_require__(140);
var credentials_component_1 = __webpack_require__(408);
var settings_component_1 = __webpack_require__(151);
var personne_morale_component_1 = __webpack_require__(147);
var personne_physique_component_1 = __webpack_require__(148);
var inscription_reussie_component_1 = __webpack_require__(146);
var register_service_1 = __webpack_require__(51);
var activate_service_1 = __webpack_require__(86);
var password_reset_init_service_1 = __webpack_require__(144);
var password_reset_finish_service_1 = __webpack_require__(141);
var TelerecourspnrAccountModule = /** @class */ (function () {
    function TelerecourspnrAccountModule() {
    }
    TelerecourspnrAccountModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_1.TelerecourspnrSharedModule,
                ng2_dragula_1.DragulaModule,
                router_1.RouterModule.forRoot(account_route_1.accountState, { useHash: true }),
                forms_1.ReactiveFormsModule
            ],
            declarations: [
                activate_account_component_1.ActivateAccountComponent,
                activate_email_component_1.ActivateEmailComponent,
                authentication_component_1.AuthenticationComponent,
                register_component_1.RegisterComponent,
                password_strength_bar_component_1.PasswordStrengthBarComponent,
                password_reset_init_component_1.PasswordResetInitComponent,
                password_reset_finish_component_1.PasswordResetFinishComponent,
                credentials_component_1.CredentialsComponent,
                settings_component_1.SettingsComponent,
                personne_morale_component_1.PersonneMoraleComponent,
                personne_physique_component_1.PersonnePhysiqueComponent,
                inscription_reussie_component_1.InscriptionReussieComponent,
                fc_auth_redirect_component_1.FcAuthRedirectComponent
            ],
            providers: [
                register_service_1.Register,
                activate_service_1.Activate,
                ng_bootstrap_1.NgbActiveModal,
                password_reset_init_service_1.PasswordResetInit,
                password_reset_finish_service_1.PasswordResetFinish
            ],
            entryComponents: [],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
        })
    ], TelerecourspnrAccountModule);
    return TelerecourspnrAccountModule;
}());
exports.TelerecourspnrAccountModule = TelerecourspnrAccountModule;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var register_route_1 = __webpack_require__(150);
var fc_auth_redirect_route_1 = __webpack_require__(409);
var activate_route_1 = __webpack_require__(407);
var settings_route_1 = __webpack_require__(152);
var password_reset_finish_route_1 = __webpack_require__(411);
var password_reset_init_route_1 = __webpack_require__(143);
var authentication_route_1 = __webpack_require__(138);
var ACCOUNT_ROUTES = [
    activate_route_1.activateEmailRoute,
    settings_route_1.monCompteRoute,
    password_reset_finish_route_1.passwordResetFinishRoute,
    password_reset_init_route_1.passwordResetInitRoute,
    register_route_1.registerRoute,
    register_route_1.registerSuccessRoute,
    settings_route_1.settingsRoute,
    authentication_route_1.authenticationRoute,
    fc_auth_redirect_route_1.fcAuthRedirectRoute
];
exports.accountState = ACCOUNT_ROUTES.concat(activate_route_1.activateAccountRoute);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var activate_service_1 = __webpack_require__(86);
var ActivateAccountComponent = /** @class */ (function () {
    function ActivateAccountComponent(activate, router, route) {
        this.activate = activate;
        this.router = router;
        this.route = route;
    }
    ActivateAccountComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.activate.activateAccount(params['key']).subscribe(function () {
                _this.success = true;
            }, function () {
                _this.success = false;
            });
        });
    };
    ActivateAccountComponent.prototype.login = function () {
        this.router.navigate(['authentication']);
    };
    ActivateAccountComponent = __decorate([
        core_1.Component({
            selector: 'jhi-activate-account',
            template: __webpack_require__(762)
        }),
        __metadata("design:paramtypes", [activate_service_1.Activate,
            router_1.Router,
            router_1.ActivatedRoute])
    ], ActivateAccountComponent);
    return ActivateAccountComponent;
}());
exports.ActivateAccountComponent = ActivateAccountComponent;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var activate_service_1 = __webpack_require__(86);
var ActivateEmailComponent = /** @class */ (function () {
    function ActivateEmailComponent(activate, router, route) {
        this.activate = activate;
        this.router = router;
        this.route = route;
    }
    ActivateEmailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.activate.activateEmail(params['key']).subscribe(function () {
                _this.success = true;
            }, function () {
                _this.success = false;
            });
        });
    };
    ActivateEmailComponent.prototype.login = function () {
        this.router.navigate(['authentication']);
    };
    ActivateEmailComponent = __decorate([
        core_1.Component({
            selector: 'jhi-activate-email',
            template: __webpack_require__(763)
        }),
        __metadata("design:paramtypes", [activate_service_1.Activate,
            router_1.Router,
            router_1.ActivatedRoute])
    ], ActivateEmailComponent);
    return ActivateEmailComponent;
}());
exports.ActivateEmailComponent = ActivateEmailComponent;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(30);
var login_service_1 = __webpack_require__(87);
var state_storage_service_1 = __webpack_require__(73);
var router_1 = __webpack_require__(6);
var tracking_service_1 = __webpack_require__(32);
var tracking_enum_1 = __webpack_require__(31);
var AuthenticationComponent = /** @class */ (function () {
    function AuthenticationComponent(eventManager, loginService, stateStorageService, router, trackingService) {
        this.eventManager = eventManager;
        this.loginService = loginService;
        this.stateStorageService = stateStorageService;
        this.router = router;
        this.trackingService = trackingService;
        this.showPassword = false;
        this.credentials = {};
    }
    AuthenticationComponent.prototype.ngAfterViewInit = function () {
        /* this.emailInputElement.nativeElement.focus(); */
    };
    AuthenticationComponent.prototype.login = function () {
        var _this = this;
        this.isSigning = true;
        this.trackRememberMe(this.rememberMe ? tracking_enum_1.TrackingAction.OPTION_ACTIVATED : tracking_enum_1.TrackingAction.OPTION_NOT_ACTIVATED);
        this.loginService.login({
            username: this.username,
            password: this.password,
            rememberMe: this.rememberMe
        }).then(function () {
            _this.successLogin();
            _this.trackLogin(tracking_enum_1.TrackingAction.SUCCESS);
        }).catch(function () {
            _this.isSigning = false;
            _this.authenticationError = true;
            _this.trackLogin(tracking_enum_1.TrackingAction.FAILED);
        });
    };
    AuthenticationComponent.prototype.resetAuthErrors = function () {
        this.authenticationError = false;
    };
    AuthenticationComponent.prototype.successLogin = function () {
        this.authenticationError = false;
        this.eventManager.broadcast({
            name: 'authenticationSuccess',
            content: 'Sending Authentication Success'
        });
        var previousState = this.stateStorageService.getPreviousState();
        if (previousState && typeof previousState === 'string') {
            this.stateStorageService.resetPreviousState();
            this.router.navigate([previousState]);
        }
        else {
            this.router.navigate(['accueil']);
        }
    };
    AuthenticationComponent.prototype.trackLogin = function (action) {
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.AUTHENTICATION,
                name: 'Connexion'
            }
        });
    };
    AuthenticationComponent.prototype.trackRememberMe = function (action) {
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.AUTHENTICATION,
                name: 'Rester connecté'
            }
        });
    };
    AuthenticationComponent.prototype.togglePassword = function ($event) {
        this.showPassword = !this.showPassword;
        $event.preventDefault();
    };
    __decorate([
        core_1.ViewChild('email'),
        __metadata("design:type", core_1.ElementRef)
    ], AuthenticationComponent.prototype, "emailInputElement", void 0);
    AuthenticationComponent = __decorate([
        core_1.Component({
            selector: 'jhi-authentication',
            template: __webpack_require__(764),
            styles: [
                __webpack_require__(865)
            ]
        }),
        __metadata("design:paramtypes", [ng_jhipster_1.JhiEventManager,
            login_service_1.LoginService,
            state_storage_service_1.StateStorageService,
            router_1.Router,
            tracking_service_1.TrackingService])
    ], AuthenticationComponent);
    return AuthenticationComponent;
}());
exports.AuthenticationComponent = AuthenticationComponent;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var authentication_component_1 = __webpack_require__(137);
exports.authenticationRoute = {
    path: 'authentication',
    component: authentication_component_1.AuthenticationComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Connexion" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var shared_1 = __webpack_require__(4);
var register_service_1 = __webpack_require__(51);
var FcAuthRedirectComponent = /** @class */ (function () {
    function FcAuthRedirectComponent(router, register, fcAuthServerProvider) {
        this.router = router;
        this.register = register;
        this.fcAuthServerProvider = fcAuthServerProvider;
    }
    FcAuthRedirectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fcUserInfo().subscribe(function (user) {
            if (user.id) {
                _this.router.navigate(['/']);
            }
            else {
                _this.register.injectFCUser(user);
                _this.router.navigate(['/register/particulier']);
            }
        }, function (_) { return _this.router.navigate(['/authentication']); });
    };
    FcAuthRedirectComponent.prototype.fcUserInfo = function () {
        return this.fcAuthServerProvider.fcUserInfo();
    };
    FcAuthRedirectComponent = __decorate([
        core_1.Component({
            selector: 'jhi-fc-auth-redirect',
            template: __webpack_require__(766),
            styles: [__webpack_require__(867)]
        }),
        __metadata("design:paramtypes", [router_1.Router,
            register_service_1.Register,
            shared_1.AuthServerProvider])
    ], FcAuthRedirectComponent);
    return FcAuthRedirectComponent;
}());
exports.FcAuthRedirectComponent = FcAuthRedirectComponent;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var forms_1 = __webpack_require__(5);
var password_reset_finish_service_1 = __webpack_require__(141);
var error_service_1 = __webpack_require__(22);
var ResetResult;
(function (ResetResult) {
    ResetResult["SUCCESS"] = "SUCCESS";
    ResetResult["ERROR"] = "ERROR";
})(ResetResult = exports.ResetResult || (exports.ResetResult = {}));
var PasswordResetFinishComponent = /** @class */ (function () {
    function PasswordResetFinishComponent(passwordResetFinish, route, router, errorService) {
        this.passwordResetFinish = passwordResetFinish;
        this.route = route;
        this.router = router;
        this.errorService = errorService;
        this.ResetResultEnum = ResetResult;
    }
    PasswordResetFinishComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.key = params['key'];
        });
        this.resetAccount = {};
        this.keyMissing = !this.key;
    };
    PasswordResetFinishComponent.prototype.ngAfterViewInit = function () {
        if (this.passwordInputElement != null) {
            this.passwordInputElement.nativeElement.focus();
        }
    };
    PasswordResetFinishComponent.prototype.finishReset = function () {
        var _this = this;
        this.resetResult = null;
        if (this.form.valid) {
            this.passwordResetFinish
                .save({ key: this.key, newPassword: this.resetAccount.password })
                .subscribe(function () { return _this.resetResult = ResetResult.SUCCESS; }, function () { return _this.resetResult = ResetResult.ERROR; });
        }
        else {
            this.errorService.markAllControlsAsTouched(this.form);
        }
    };
    PasswordResetFinishComponent.prototype.login = function () {
        this.router.navigate(['authentication']);
    };
    PasswordResetFinishComponent.prototype.updateValueAndValidity = function (controlNames) {
        var _this = this;
        (controlNames || [])
            .map(function (controlName) { return _this.form.controls[controlName]; })
            .filter(function (control) { return control && control.touched; })
            .forEach(function (control) { return control.updateValueAndValidity(); });
    };
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], PasswordResetFinishComponent.prototype, "form", void 0);
    __decorate([
        core_1.ViewChild('password', { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], PasswordResetFinishComponent.prototype, "passwordInputElement", void 0);
    PasswordResetFinishComponent = __decorate([
        core_1.Component({
            selector: 'jhi-password-reset-finish',
            template: __webpack_require__(767),
            styles: [__webpack_require__(868)]
        }),
        __metadata("design:paramtypes", [password_reset_finish_service_1.PasswordResetFinish,
            router_1.ActivatedRoute,
            router_1.Router,
            error_service_1.ErrorService])
    ], PasswordResetFinishComponent);
    return PasswordResetFinishComponent;
}());
exports.PasswordResetFinishComponent = PasswordResetFinishComponent;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var PasswordResetFinish = /** @class */ (function () {
    function PasswordResetFinish(http) {
        this.http = http;
    }
    PasswordResetFinish.prototype.save = function (keyAndPassword) {
        return this.http.post('/api/account/reset-password/finish', keyAndPassword);
    };
    PasswordResetFinish = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], PasswordResetFinish);
    return PasswordResetFinish;
}());
exports.PasswordResetFinish = PasswordResetFinish;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var error_service_1 = __webpack_require__(22);
var password_reset_init_service_1 = __webpack_require__(144);
var PasswordResetInitComponent = /** @class */ (function () {
    function PasswordResetInitComponent(passwordResetInit, errorService) {
        this.passwordResetInit = passwordResetInit;
        this.errorService = errorService;
        this.success = false;
    }
    PasswordResetInitComponent.prototype.ngOnInit = function () {
        this.resetAccount = {};
    };
    PasswordResetInitComponent.prototype.ngAfterViewInit = function () {
        if (this.emailInputElement != null) {
            this.emailInputElement.nativeElement.focus();
        }
    };
    PasswordResetInitComponent.prototype.requestReset = function () {
        var _this = this;
        if (!this.resetRequestForm.valid) {
            this.errorService.markAllControlsAsTouched(this.resetRequestForm);
        }
        else {
            this.passwordResetInit.save(this.resetAccount.email).subscribe(function () {
                _this.success = true;
            }, function (_response) {
                _this.success = false;
            });
        }
    };
    __decorate([
        core_1.ViewChild('resetRequestForm'),
        __metadata("design:type", forms_1.NgForm)
    ], PasswordResetInitComponent.prototype, "resetRequestForm", void 0);
    __decorate([
        core_1.ViewChild('emailInput', { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], PasswordResetInitComponent.prototype, "emailInputElement", void 0);
    PasswordResetInitComponent = __decorate([
        core_1.Component({
            selector: 'jhi-password-reset-init',
            template: __webpack_require__(768)
        }),
        __metadata("design:paramtypes", [password_reset_init_service_1.PasswordResetInit,
            error_service_1.ErrorService])
    ], PasswordResetInitComponent);
    return PasswordResetInitComponent;
}());
exports.PasswordResetInitComponent = PasswordResetInitComponent;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var password_reset_init_component_1 = __webpack_require__(142);
exports.passwordResetInitRoute = {
    path: 'reset/request',
    component: password_reset_init_component_1.PasswordResetInitComponent,
    data: {
        needAuthentication: false,
        pageTitle: "R\u00E9initialisation du mot de passe" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var PasswordResetInit = /** @class */ (function () {
    function PasswordResetInit(http) {
        this.http = http;
    }
    PasswordResetInit.prototype.save = function (mail) {
        return this.http.post('/api/account/reset-password/init', mail);
    };
    PasswordResetInit = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], PasswordResetInit);
    return PasswordResetInit;
}());
exports.PasswordResetInit = PasswordResetInit;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ValidationErrorType;
(function (ValidationErrorType) {
    ValidationErrorType["MIN_LENGTH"] = "min-length";
    ValidationErrorType["LOWERCASE"] = "require-lowercase";
    ValidationErrorType["UPPERCASE"] = "require-upercase";
    ValidationErrorType["NUMBER"] = "require-number";
    ValidationErrorType["SPECIAL"] = "require-special";
})(ValidationErrorType = exports.ValidationErrorType || (exports.ValidationErrorType = {}));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var account_data_1 = __webpack_require__(70);
var InscriptionReussieComponent = /** @class */ (function () {
    function InscriptionReussieComponent(router, accountData) {
        this.router = router;
        this.accountData = accountData;
    }
    InscriptionReussieComponent.prototype.ngOnInit = function () {
        this.email = this.accountData.email;
        this.accountData = new account_data_1.AccountData();
    };
    InscriptionReussieComponent.prototype.goToAcceuil = function () {
        this.router.navigate(['/']);
    };
    InscriptionReussieComponent = __decorate([
        core_1.Component({
            selector: 'jhi-inscription-reussie',
            template: __webpack_require__(769),
            styles: [__webpack_require__(870)]
        }),
        __metadata("design:paramtypes", [router_1.Router,
            account_data_1.AccountData])
    ], InscriptionReussieComponent);
    return InscriptionReussieComponent;
}());
exports.InscriptionReussieComponent = InscriptionReussieComponent;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var forms_1 = __webpack_require__(5);
var register_service_1 = __webpack_require__(51);
var ng_jhipster_1 = __webpack_require__(30);
var index_1 = __webpack_require__(4);
var captcha_component_1 = __webpack_require__(95);
var error_service_1 = __webpack_require__(22);
var parameters_service_1 = __webpack_require__(25);
var account_data_1 = __webpack_require__(70);
var PersonneMoraleComponent = /** @class */ (function () {
    function PersonneMoraleComponent(registerService, eventManager, router, scrollToService, captchaService, errorService, parametersService, accountData) {
        this.registerService = registerService;
        this.eventManager = eventManager;
        this.router = router;
        this.scrollToService = scrollToService;
        this.captchaService = captchaService;
        this.errorService = errorService;
        this.parametersService = parametersService;
        this.accountData = accountData;
        this.isCreateAccountBtnClicked = false;
    }
    PersonneMoraleComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = rxjs_1.combineLatest(this.registerService.newAccountAsObservable(), this.parametersService.getParameters()).subscribe(function (_a) {
            var _b = __read(_a, 2), newAccount = _b[0], parameters = _b[1];
            _this.countries = parameters.countries;
            _this.civilites = parameters.civilities;
            _this.newAccount = newAccount;
            _this.newAccount.type = index_1.AccountType.MORALE;
            _this.newAccount.address.pays = _this.newAccount.address.pays || 'France';
        });
    };
    PersonneMoraleComponent.prototype.ngAfterViewChecked = function () {
        if (this.registerForm.submitted && !this.registerForm.valid && this.enableScroll) {
            this.scrollToService.scrollToFirstError();
            this.enableScroll = false;
        }
    };
    PersonneMoraleComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    PersonneMoraleComponent.prototype.register = function () {
        var _this = this;
        if (!this.registerForm.valid) {
            this.errorService.markAllControlsAsTouched(this.registerForm);
            this.captchaService.reloadCaptcha();
        }
        else {
            this.isTechnicalError = false;
            this.registerService.save(this.newAccount.toAccountDTO())
                .subscribe(function (_) { return _this.registerSucceeded(); }, function (error) { return _this.processError(error); });
        }
        this.enableScroll = true;
    };
    PersonneMoraleComponent.prototype.registerSucceeded = function () {
        this.eventManager.broadcast({
            name: 'authenticationSuccess',
            content: 'Sending Authentication Success'
        });
        this.accountData.email = this.newAccount.credentials.email;
        this.router.navigate(['/inscription-reussie']);
    };
    PersonneMoraleComponent.prototype.processError = function (error) {
        this.captchaService.reloadCaptcha();
        if (error.error.code === index_1.CreateAccountErrorType.EMAIL_ALREADY_IN_USE) {
            this.registerForm.controls['email'].setErrors({ 'invalid': true, 'emailexists': true });
        }
        else if (error.error.code === index_1.CreateAccountErrorType.INVALID_PASSWORD) {
            this.registerForm.controls['password'].setErrors({ 'invalid': true, 'invalidPassword': true });
            this.errorService.markAllControlsAsTouched(this.registerForm);
        }
        else {
            this.isTechnicalError = true;
        }
    };
    PersonneMoraleComponent.prototype.cancel = function () {
        this.registerService.cancel();
    };
    PersonneMoraleComponent.prototype.captchaChange = function (captcha) {
        this.newAccount.captcha = captcha;
    };
    PersonneMoraleComponent.prototype.clickCheck = function () {
        this.isCreateAccountBtnClicked = true;
    };
    __decorate([
        core_1.ViewChild('registerForm'),
        __metadata("design:type", forms_1.NgForm)
    ], PersonneMoraleComponent.prototype, "registerForm", void 0);
    __decorate([
        core_1.ViewChild(captcha_component_1.CaptchaComponent),
        __metadata("design:type", captcha_component_1.CaptchaComponent)
    ], PersonneMoraleComponent.prototype, "captcha", void 0);
    PersonneMoraleComponent = __decorate([
        core_1.Component({
            selector: 'jhi-personne-morale',
            template: __webpack_require__(770),
            styles: [__webpack_require__(871)]
        }),
        __metadata("design:paramtypes", [register_service_1.Register,
            ng_jhipster_1.JhiEventManager,
            router_1.Router,
            index_1.ScrollToService,
            index_1.CaptchaService,
            error_service_1.ErrorService,
            parameters_service_1.ParametersService,
            account_data_1.AccountData])
    ], PersonneMoraleComponent);
    return PersonneMoraleComponent;
}());
exports.PersonneMoraleComponent = PersonneMoraleComponent;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var util_1 = __webpack_require__(47);
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(30);
var register_service_1 = __webpack_require__(51);
var forms_1 = __webpack_require__(5);
var index_1 = __webpack_require__(4);
var error_service_1 = __webpack_require__(22);
var parameters_service_1 = __webpack_require__(25);
var router_1 = __webpack_require__(6);
var captcha_component_1 = __webpack_require__(95);
var account_data_1 = __webpack_require__(70);
var PersonnePhysiqueComponent = /** @class */ (function () {
    function PersonnePhysiqueComponent(router, eventManager, registerService, scrollToService, captchaService, errorService, parametersService, accountData) {
        this.router = router;
        this.eventManager = eventManager;
        this.registerService = registerService;
        this.scrollToService = scrollToService;
        this.captchaService = captchaService;
        this.errorService = errorService;
        this.parametersService = parametersService;
        this.accountData = accountData;
        this.isCreateAccountBtnClicked = false;
        this.isFCUser = false;
    }
    PersonnePhysiqueComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = rxjs_1.combineLatest(this.registerService.newAccountAsObservable(), this.parametersService.getParameters())
            .subscribe(function (_a) {
            var _b = __read(_a, 2), newAccount = _b[0], parameters = _b[1];
            _this.countries = parameters.countries;
            _this.newAccount = newAccount;
            _this.newAccount.type = index_1.AccountType.PHYSIQUE;
            _this.newAccount.address.pays = _this.newAccount.address.pays || 'France';
            _this.isFCUser = !util_1.isNullOrUndefined(_this.newAccount.credentials.franceConnectSubscription);
        });
    };
    PersonnePhysiqueComponent.prototype.ngAfterViewChecked = function () {
        if (this.registerForm.submitted &&
            !this.registerForm.valid &&
            this.enableScroll) {
            this.scrollToService.scrollToFirstError();
            this.enableScroll = false;
        }
    };
    PersonnePhysiqueComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    PersonnePhysiqueComponent.prototype.register = function () {
        var _this = this;
        if (!this.registerForm.valid) {
            this.errorService.markAllControlsAsTouched(this.registerForm);
            this.captchaService.reloadCaptcha();
            this.enableScroll = true;
        }
        else {
            this.isTechnicalError = false;
            this.registerService.save(this.newAccount.toAccountDTO())
                .subscribe(function (_) { return _this.registerSucceeded(); }, function (error) { return _this.processError(error); });
        }
    };
    PersonnePhysiqueComponent.prototype.cancel = function () {
        this.registerService.cancel();
    };
    PersonnePhysiqueComponent.prototype.processError = function (error) {
        this.captchaService.reloadCaptcha();
        if (error.error.code === index_1.CreateAccountErrorType.EMAIL_ALREADY_IN_USE) {
            this.registerForm.controls['email'].setErrors({ invalid: true, emailexists: true });
            this.errorService.markAllControlsAsTouched(this.registerForm);
        }
        else if (error.error.code === index_1.CreateAccountErrorType.INVALID_PASSWORD) {
            this.registerForm.controls['password'].setErrors({ invalid: true, invalidPassword: true });
            this.errorService.markAllControlsAsTouched(this.registerForm);
        }
        else {
            this.isTechnicalError = true;
        }
        this.enableScroll = true;
    };
    PersonnePhysiqueComponent.prototype.registerSucceeded = function () {
        this.eventManager.broadcast({
            name: 'authenticationSuccess',
            content: 'Sending Authentication Success'
        });
        if (!this.newAccount.credentials.franceConnectSubscription) {
            this.accountData.email = this.newAccount.credentials.email;
            this.router.navigate(['/inscription-reussie']);
        }
        else {
            this.router.navigate(['/accueil']);
        }
    };
    PersonnePhysiqueComponent.prototype.clickCheck = function () {
        this.isCreateAccountBtnClicked = true;
    };
    __decorate([
        core_1.ViewChild('registerForm'),
        __metadata("design:type", forms_1.NgForm)
    ], PersonnePhysiqueComponent.prototype, "registerForm", void 0);
    __decorate([
        core_1.ViewChild(captcha_component_1.CaptchaComponent),
        __metadata("design:type", captcha_component_1.CaptchaComponent)
    ], PersonnePhysiqueComponent.prototype, "captcha", void 0);
    PersonnePhysiqueComponent = __decorate([
        core_1.Component({
            selector: 'jhi-personne-physique',
            template: __webpack_require__(771),
            styles: [__webpack_require__(872)]
        }),
        __metadata("design:paramtypes", [router_1.Router,
            ng_jhipster_1.JhiEventManager,
            register_service_1.Register,
            index_1.ScrollToService,
            index_1.CaptchaService,
            error_service_1.ErrorService,
            parameters_service_1.ParametersService,
            account_data_1.AccountData])
    ], PersonnePhysiqueComponent);
    return PersonnePhysiqueComponent;
}());
exports.PersonnePhysiqueComponent = PersonnePhysiqueComponent;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var register_service_1 = __webpack_require__(51);
var RegisterComponent = /** @class */ (function () {
    function RegisterComponent(registerService) {
        this.registerService = registerService;
    }
    RegisterComponent.prototype.ngOnDestroy = function () {
        this.registerService.reset();
    };
    RegisterComponent = __decorate([
        core_1.Component({
            selector: 'jhi-register',
            template: __webpack_require__(772)
        }),
        __metadata("design:paramtypes", [register_service_1.Register])
    ], RegisterComponent);
    return RegisterComponent;
}());
exports.RegisterComponent = RegisterComponent;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(4);
var register_component_1 = __webpack_require__(149);
var inscription_reussie_component_1 = __webpack_require__(146);
var personne_physique_component_1 = __webpack_require__(148);
var personne_morale_component_1 = __webpack_require__(147);
var app_constants_1 = __webpack_require__(11);
exports.registerRoute = {
    path: 'register',
    component: register_component_1.RegisterComponent,
    children: [
        {
            path: 'particulier',
            component: personne_physique_component_1.PersonnePhysiqueComponent,
            data: {
                needAuthentication: false,
                pageTitle: "Cr\u00E9ation de compte particulier" + app_constants_1.PAGE_TITLE_SUFFIX
            },
            canActivate: [shared_1.UserRouteAccessService]
        },
        {
            path: 'morale',
            component: personne_morale_component_1.PersonneMoraleComponent,
            data: {
                needAuthentication: false,
                pageTitle: "Cr\u00E9ation de compte de personne morale" + app_constants_1.PAGE_TITLE_SUFFIX
            },
            canActivate: [shared_1.UserRouteAccessService]
        }
    ]
};
exports.registerSuccessRoute = {
    path: 'inscription-reussie',
    component: inscription_reussie_component_1.InscriptionReussieComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Inscription r\u00E9ussie" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(15);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var ng_bootstrap_1 = __webpack_require__(19);
var ng_jhipster_1 = __webpack_require__(30);
var shared_1 = __webpack_require__(4);
var error_service_1 = __webpack_require__(22);
var account_model_1 = __webpack_require__(53);
var util_1 = __webpack_require__(47);
var util_2 = __webpack_require__(28);
var SettingsComponent = /** @class */ (function () {
    function SettingsComponent(accountService, userService, loginService, modalService, scrollToService, errorService, alertService, location) {
        this.accountService = accountService;
        this.userService = userService;
        this.loginService = loginService;
        this.modalService = modalService;
        this.scrollToService = scrollToService;
        this.errorService = errorService;
        this.alertService = alertService;
        this.location = location;
        this.retrivedInfo = new account_model_1.MyInformation();
        this.confirmEmail = {
            confirmEmail: ''
        };
        this.enableScroll = false;
        this.isFCUser = false;
        this.isMorale = false;
        this.showUpgradeWarning = true;
        this.showSaveMsg = false;
        this.disableAnnulerBtn = false;
        this.isCreateAccountBtnClicked = false;
    }
    SettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.getAccount().then(function (account) {
            _this.account = _this.accountService.mapAccoutToEditableAccount(account);
            _this.account.credentials.oldEmail = _this.account.credentials.email;
            _this.initRetrivedInfo();
            _this.isFCUser = !util_1.isNullOrUndefined(_this.account.credentials.franceConnectSubscription);
            _this.isMorale = account_model_1.AccountType.MORALE === account.type;
            _this.oldNotificationType = account.notification;
        });
    };
    SettingsComponent.prototype.initRetrivedInfo = function () {
        this.retrivedInfo.firstName = this.account.firstName;
        this.retrivedInfo.lastName = this.account.lastName;
        this.retrivedInfo.adresse1 = this.account.address.adresse1;
        this.retrivedInfo.adresse2 = this.account.address.adresse2;
        this.retrivedInfo.adresse3 = this.account.address.adresse3;
        this.retrivedInfo.codePostal = this.account.address.codePostal;
        this.retrivedInfo.ville = this.account.address.ville;
        this.retrivedInfo.pays = this.account.address.pays;
        this.retrivedInfo.email = this.account.credentials.email;
    };
    SettingsComponent.prototype.ngAfterContentChecked = function () {
        this.showUpgradeWarningIfNeeded();
    };
    SettingsComponent.prototype.ngAfterViewChecked = function () {
        this.scrollToFirstErrorIfNeeded();
    };
    SettingsComponent.prototype.save = function () {
        if (this.compteForm.valid) {
            this.enableScroll = false;
            this.compteForm.form.markAsPristine();
            if (this.isOnlyCredentialsChanged()) {
                this.openChangeCredentialModal(this.credentialsChangeModal, 'Modifier vos identifiants');
            }
            else if (this.isMyInfoChanged()) {
                this.openChangeMyInfoModal(this.myInfoChangeModal, 'Modifer vos informations');
            }
            else {
                this.saveAccount();
            }
        }
        else {
            this.errorService.markAllControlsAsTouched(this.compteForm);
            this.enableScroll = true;
        }
    };
    SettingsComponent.prototype.saveAccount = function () {
        var _this = this;
        this.accountService.save(this.account.toAccountDTO()).subscribe(function () {
            _this.isLoading = false;
            _this.disableAnnulerBtn = false;
            _this.showSaveMsg = true;
            _this.alertService.addAlert({ type: 'success', msg: 'settings.messages.success', timeout: 10000 }, []);
            _this.isTechnicalError = false;
            if (_this.isCredentialsChanged()) {
                _this.loginService.logout();
                return;
            }
            _this.userService.getAccount(true);
            _this.location.back();
        }, function (error) {
            _this.isLoading = false;
            _this.disableAnnulerBtn = false;
            _this.errorService.markAllControlsAsTouched(_this.compteForm);
            _this.processError(error ? error : {});
        });
    };
    SettingsComponent.prototype.processError = function (error) {
        this.enableScroll = true;
        if (error.error.code === account_model_1.UpdateAccountErrorType.WRONG_OLD_PASSWORD) {
            this.compteForm.controls['oldPassword'].setErrors({ invalid: true, wrongpassword: true });
            this.errorService.markAllControlsAsTouched(this.compteForm);
        }
        else if (error.error.code === account_model_1.UpdateAccountErrorType.EMAIL_ALREADY_IN_USE) {
            this.compteForm.controls['email'].setErrors({ invalid: true, emailexists: true });
        }
        else if (error.error.code === shared_1.CreateAccountErrorType.INVALID_NEW_PASSWORD) {
            this.compteForm.controls['password'].setErrors({ invalid: true, invalidNewPassword: true });
            this.errorService.markAllControlsAsTouched(this.compteForm);
        }
        else {
            this.isTechnicalError = true;
        }
    };
    SettingsComponent.prototype.onNotificationValueChange = function (modal) {
        var _this = this;
        if (this.account.notification === account_model_1.NotificationType.AUCUNE) {
            // Hack for https://github.com/ng-bootstrap/ng-bootstrap/issues/1604
            this.compteFormElRef.nativeElement.ownerDocument.activeElement.blur();
            this.modalService.open(modal, { size: 'lg' }).result.then(function (result) {
                if (result !== 'Confirmer') {
                    _this.isLoading = false;
                    _this.disableAnnulerBtn = false;
                    _this.account.notification = _this.oldNotificationType;
                }
            }, function (_) { return (_this.account.notification = _this.oldNotificationType); });
            // RGAA workaround
            var modalEl = document.querySelector('ngb-modal-window');
            modalEl.setAttribute('aria-label', 'Avertissement');
        }
        else {
            this.oldNotificationType = this.account.notification;
        }
    };
    SettingsComponent.prototype.openChangeCredentialModal = function (modal, message) {
        var _this = this;
        this.modalService.open(modal, { size: 'lg' }).result.then(function (result) {
            if (result === 'Confirmer') {
                _this.saveAccount();
            }
            else {
                _this.account.credentials.email = _this.retrivedInfo.email;
                _this.confirmEmail.confirmEmail = _this.retrivedInfo.email;
                _this.isLoading = false;
                _this.disableAnnulerBtn = false;
                if (_this.isMyInfoChanged()) {
                    _this.compteForm.form.markAsDirty();
                }
            }
        }).catch(function (e) {
            console.log('error :', e);
            _this.isLoading = false;
            _this.disableAnnulerBtn = false;
        });
        // RGAA workaround
        var modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', message);
    };
    SettingsComponent.prototype.openChangeMyInfoModal = function (modal, message) {
        var _this = this;
        this.modalReference = this.modalService.open(modal, { size: 'lg' });
        this.modalReference.result.then(function (result) {
            if (result === 'Confirmer') {
                if (_this.retrivedInfo.email !==
                    _this.account.credentials.email) {
                    _this.openChangeCredentialModal(_this.credentialsChangeModal, 'Modifier vos identifiants');
                }
                else {
                    _this.saveAccount();
                }
                _this.modalReference.close();
            }
            else {
                _this.setBackMyInfo();
                _this.isLoading = false;
                _this.disableAnnulerBtn = false;
                _this.modalReference.close();
            }
        }).catch(function (e) {
            console.log('error :', e);
            _this.isLoading = false;
            _this.disableAnnulerBtn = false;
        });
        // RGAA workaround
        var modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', message);
    };
    SettingsComponent.prototype.setBackMyInfo = function () {
        this.account.firstName = this.retrivedInfo.firstName;
        this.account.lastName = this.retrivedInfo.lastName;
        this.account.address.adresse1 = this.retrivedInfo.adresse1;
        this.account.address.adresse2 = this.retrivedInfo.adresse2;
        this.account.address.adresse3 = this.retrivedInfo.adresse3;
        this.account.address.codePostal = this.retrivedInfo.codePostal;
        this.account.address.ville = this.retrivedInfo.ville;
        this.account.address.pays = this.retrivedInfo.pays;
    };
    SettingsComponent.prototype.clickCheckAndSave = function () {
        this.clickCheck();
        this.save();
    };
    SettingsComponent.prototype.cancel = function () {
        this.location.back();
    };
    SettingsComponent.prototype.isCredentialsChanged = function () {
        return !util_2.isEmpty(this.account.credentials.password) ||
            this.account.credentials.oldEmail !==
                this.account.credentials.email;
    };
    SettingsComponent.prototype.isOnlyCredentialsChanged = function () {
        return !util_2.isEmpty(this.account.credentials.password) ||
            (this.account.credentials.oldEmail !==
                this.account.credentials.email &&
                !this.isMyInfoChanged());
    };
    SettingsComponent.prototype.isMyInfoChanged = function () {
        return this.retrivedInfo.firstName !== this.account.firstName ||
            this.retrivedInfo.lastName !== this.account.lastName ||
            this.retrivedInfo.adresse1 !== this.account.address.adresse1 ||
            this.retrivedInfo.adresse2 !== this.account.address.adresse2 ||
            this.retrivedInfo.adresse3 !== this.account.address.adresse3 ||
            this.retrivedInfo.codePostal !== this.account.address.codePostal ||
            this.retrivedInfo.ville !== this.account.address.ville ||
            this.retrivedInfo.pays !== this.account.address.pays;
    };
    SettingsComponent.prototype.showUpgradeWarningIfNeeded = function () {
        if (this.compteForm) {
            if (this.showUpgradeWarning && this.compteForm && this.compteForm.invalid) {
                this.alertService.addAlert({
                    type: 'danger',
                    msg: 'settings.messages.error.upgradeWarning',
                    timeout: 10000,
                    position: 'fixed'
                }, []);
                this.errorService.markAllControlsAsTouched(this.compteForm);
                this.enableScroll = true;
            }
            this.showUpgradeWarning = false;
        }
    };
    SettingsComponent.prototype.scrollToFirstErrorIfNeeded = function () {
        if (this.compteForm && !this.compteForm.valid && this.enableScroll) {
            this.scrollToService.scrollToFirstError();
            this.enableScroll = false;
        }
    };
    SettingsComponent.prototype.clickCheck = function () {
        if (this.compteForm && !this.compteForm.valid) {
            this.isLoading = false;
            this.disableAnnulerBtn = false;
        }
        else {
            this.isLoading = true;
            this.disableAnnulerBtn = true;
        }
        this.isCreateAccountBtnClicked = true;
    };
    __decorate([
        core_1.ViewChild('compteForm'),
        __metadata("design:type", forms_1.NgForm)
    ], SettingsComponent.prototype, "compteForm", void 0);
    __decorate([
        core_1.ViewChild('compteForm', { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], SettingsComponent.prototype, "compteFormElRef", void 0);
    __decorate([
        core_1.ViewChild('credentialsChangeModal'),
        __metadata("design:type", Object)
    ], SettingsComponent.prototype, "credentialsChangeModal", void 0);
    __decorate([
        core_1.ViewChild('myInfoChangeModal'),
        __metadata("design:type", Object)
    ], SettingsComponent.prototype, "myInfoChangeModal", void 0);
    __decorate([
        core_1.ViewChild('notificationModal'),
        __metadata("design:type", Object)
    ], SettingsComponent.prototype, "notificationModal", void 0);
    SettingsComponent = __decorate([
        core_1.Component({
            selector: 'jhi-settings',
            template: __webpack_require__(773),
            styles: [__webpack_require__(873)]
        }),
        __metadata("design:paramtypes", [shared_1.AccountService,
            shared_1.UserService,
            shared_1.LoginService,
            ng_bootstrap_1.NgbModal,
            shared_1.ScrollToService,
            error_service_1.ErrorService,
            ng_jhipster_1.JhiAlertService,
            common_1.Location])
    ], SettingsComponent);
    return SettingsComponent;
}());
exports.SettingsComponent = SettingsComponent;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var settings_component_1 = __webpack_require__(151);
exports.monCompteRoute = {
    path: 'mon-compte',
    component: settings_component_1.SettingsComponent,
    data: {
        needAuthentication: true,
        pageTitle: "Mon compte" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};
exports.settingsRoute = {
    path: 'mon-profil',
    component: settings_component_1.SettingsComponent,
    data: {
        needAuthentication: true,
        pageTitle: "Mon compte" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var alert_service_1 = __webpack_require__(969);
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var depot_requete_data_1 = __webpack_require__(59);
var draft_depot_requete_service_1 = __webpack_require__(16);
var DepotRequeteComponent = /** @class */ (function () {
    function DepotRequeteComponent(router, alertService, draftDepotRequeteService) {
        var _this = this;
        this.router = router;
        this.alertService = alertService;
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.steps = depot_requete_data_1.depotRequeteSteps.map(function (step, index) { return ({
            label: step.breadTitle,
            route: "/" + step.fullRoute,
            isActive: index === _this.getActiveStepIndex()
        }); });
        this.isRetakenDraft = false;
        this.hideAlertDraft();
        this.draftDepotRequeteService.getMyDraftRequeteSummary().subscribe(function (draftSummary) {
            if (draftSummary) {
                // cacher temporairement suite au commentaire fait le 30/10/2023 dans TRC-629, à rétablir plus tard
                _this.isRetakenDraft = false;
                _this.draftCreationDate = _this.draftDepotRequeteService.depotRequeteState.dateCreation.toString();
                _this.dateAndHour = _this.draftDepotRequeteService.convertCreationDateToDateAndHour(_this.draftCreationDate);
                setTimeout(function () {
                    _this.isRetakenDraft = false;
                }, 15000);
            }
        });
        this.draftDepotRequeteService.data$.subscribe(function (data) {
            _this.autoSaveTime = data;
        });
    }
    // When a component is loaded, onActivate will be triggered
    // and we will get the component reference
    // and can access all functions using that
    DepotRequeteComponent.prototype.onActivate = function (childComponent) {
        var _this = this;
        var methodNames = [
            'previousStep',
            'nextStep',
            'hideAlertDraft',
            'showErrorAlertDraft',
            'showSuccessAlertDraft',
            'showAutoSaveSuccessAlertDraft'
        ];
        // Define which method is called when the child emits one of its EventEmitter
        var methods = methodNames.reduce(function (map, currentMethodName) {
            map.set(currentMethodName, _this[currentMethodName].bind(_this));
            return map;
        }, new Map());
        methods.forEach(function (method, methodName) {
            // If the component has a property corresponding to one of the known event-emitter,
            // subscribe the corresponding handler to the property.
            if (methodName in childComponent) {
                childComponent[methodName].subscribe(method);
            }
        });
    };
    DepotRequeteComponent.prototype.hideAlertDraft = function () {
        this.alertService.clear();
    };
    // @ts-ignore method is used as subscriber in onActivate
    DepotRequeteComponent.prototype.showErrorAlertDraft = function () {
        this.alertService.addAlert({ type: 'danger', msg: 'draft.error' }, []);
    };
    // @ts-ignore method is used as subscriber in onActivate
    DepotRequeteComponent.prototype.showSuccessAlertDraft = function () {
        this.alertService.addAlert({ type: 'success', msg: 'draft.success', timeout: 300000 }, []);
    };
    // @ts-ignore method is used as subscriber in onActivate
    DepotRequeteComponent.prototype.showAutoSaveSuccessAlertDraft = function () {
        this.alertService.addAlert({ type: 'success', msg: 'draft.autoSaveSuccess',
            params: { param: this.autoSaveTime }, timeout: 30000 }, []);
    };
    // @ts-ignore method is used as subscriber in onActivate
    DepotRequeteComponent.prototype.nextStep = function () {
        var activeStepIndex = this.getActiveStepIndex();
        this.navigateToStepByIndex(activeStepIndex + 1);
    };
    // @ts-ignore method is used as subscriber in onActivate
    DepotRequeteComponent.prototype.previousStep = function () {
        var activeStepIndex = this.getActiveStepIndex();
        this.navigateToStepByIndex(activeStepIndex - 1);
    };
    // @ts-ignore method is used as subscriber in onActivate
    DepotRequeteComponent.prototype.getActiveStepIndex = function () {
        var _this = this;
        return depot_requete_data_1.depotRequeteSteps.findIndex(function (stepDetail) { return _this.router.isActive("" + stepDetail.fullRoute, true); });
    };
    DepotRequeteComponent.prototype.navigateToStepByIndex = function (index) {
        if (depot_requete_data_1.depotRequeteSteps[index]) {
            this.router.navigate([depot_requete_data_1.depotRequeteSteps[index].fullRoute]);
        }
        else if (index < 0) {
            this.router.navigate(['/accueil']);
        }
    };
    DepotRequeteComponent.prototype.close = function () {
        this.isRetakenDraft = false;
    };
    DepotRequeteComponent = __decorate([
        core_1.Component({
            selector: 'jhi-depot-requete',
            template: __webpack_require__(774),
            styles: [__webpack_require__(874)]
        }),
        __metadata("design:paramtypes", [router_1.Router,
            alert_service_1.JhiAlertService,
            draft_depot_requete_service_1.DraftDepotRequeteService])
    ], DepotRequeteComponent);
    return DepotRequeteComponent;
}());
exports.DepotRequeteComponent = DepotRequeteComponent;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(4);
var depot_requete_component_1 = __webpack_require__(153);
var depot_requete_data_1 = __webpack_require__(59);
var draft_requete_resolver_1 = __webpack_require__(155);
var load_draft_component_1 = __webpack_require__(156);
var steps_1 = __webpack_require__(157);
exports.DEPOT_REQUETE_ROUTE = {
    path: depot_requete_data_1.depotRequeteBasePath,
    component: depot_requete_component_1.DepotRequeteComponent,
    resolve: {
        draftRequete: draft_requete_resolver_1.DraftRequeteResolver
    },
    children: [
        {
            path: '',
            component: load_draft_component_1.LoadDraftComponent,
            pathMatch: 'full',
            data: {
                needAuthentication: true
            },
            canActivate: [shared_1.UserRouteAccessService]
        },
        {
            path: depot_requete_data_1.depotRequeteSteps[0].route,
            component: steps_1.AvertissementComponent,
            data: {
                needAuthentication: true,
                pageTitle: depot_requete_data_1.depotRequeteSteps[0].pageTitle
            },
            canActivate: [shared_1.UserRouteAccessService]
        },
        {
            path: depot_requete_data_1.depotRequeteSteps[1].route,
            component: steps_1.RequerantsComponent,
            data: {
                needAuthentication: true,
                pageTitle: depot_requete_data_1.depotRequeteSteps[1].pageTitle
            },
            canActivate: [shared_1.UserRouteAccessService]
        },
        {
            path: depot_requete_data_1.depotRequeteSteps[2].route,
            component: steps_1.JuridictionComponent,
            data: {
                needAuthentication: true,
                pageTitle: depot_requete_data_1.depotRequeteSteps[2].pageTitle
            },
            canActivate: [shared_1.UserRouteAccessService]
        },
        {
            path: depot_requete_data_1.depotRequeteSteps[3].route,
            component: steps_1.RequeteComponent,
            data: {
                needAuthentication: true,
                pageTitle: depot_requete_data_1.depotRequeteSteps[3].pageTitle
            },
            canActivate: [shared_1.UserRouteAccessService]
        },
        {
            path: depot_requete_data_1.depotRequeteSteps[4].route,
            component: steps_1.JustificatifsComponent,
            data: {
                needAuthentication: true,
                pageTitle: depot_requete_data_1.depotRequeteSteps[4].pageTitle
            },
            canActivate: [shared_1.UserRouteAccessService]
        },
        {
            path: depot_requete_data_1.depotRequeteSteps[5].route,
            component: steps_1.RecapitulatifComponent,
            data: {
                needAuthentication: true,
                pageTitle: depot_requete_data_1.depotRequeteSteps[5].pageTitle
            },
            canActivate: [shared_1.UserRouteAccessService]
        }
    ]
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var draft_depot_requete_service_1 = __webpack_require__(16);
var DraftRequeteResolver = /** @class */ (function () {
    function DraftRequeteResolver(draftDepotRequeteService) {
        this.draftDepotRequeteService = draftDepotRequeteService;
    }
    DraftRequeteResolver.prototype.resolve = function () {
        return this.draftDepotRequeteService.getMyDraftRequeteDetail();
    };
    DraftRequeteResolver = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [draft_depot_requete_service_1.DraftDepotRequeteService])
    ], DraftRequeteResolver);
    return DraftRequeteResolver;
}());
exports.DraftRequeteResolver = DraftRequeteResolver;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var depot_requete_data_1 = __webpack_require__(59);
var draft_depot_requete_service_1 = __webpack_require__(16);
// This is a 'false' component, use to refresh and go to the correct draft page
// This component is used when we call router.navigate(['/depot-requete']) from the draft modal for example
var LoadDraftComponent = /** @class */ (function () {
    function LoadDraftComponent(router, draftDepotRequeteService) {
        this.router = router;
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.steps = depot_requete_data_1.depotRequeteSteps.map(function (step, index) { return ({
            label: step.breadTitle,
            route: "/" + step.fullRoute,
            isActive: index === 0
        }); });
        this.goToDraftAndRefreshVersion();
    }
    LoadDraftComponent.prototype.goToDraftAndRefreshVersion = function () {
        var _this = this;
        this.draftDepotRequeteService
            .getMyDraftRequeteDetail()
            .subscribe(function (newDraft) {
            _this.navigateToStepByIndex(newDraft);
        });
    };
    LoadDraftComponent.prototype.navigateToStepByIndex = function (draft) {
        if (draft !== undefined) {
            var index = draft.getIndexStateFromDraft();
            if (depot_requete_data_1.depotRequeteSteps[index]) {
                this.router.navigate([depot_requete_data_1.depotRequeteSteps[index].fullRoute]);
                return;
            }
        }
        this.router.navigate([depot_requete_data_1.depotRequeteSteps[0].fullRoute]);
    };
    LoadDraftComponent = __decorate([
        core_1.Component({
            selector: 'jhi-load-draft',
            template: ''
        }),
        __metadata("design:paramtypes", [router_1.Router,
            draft_depot_requete_service_1.DraftDepotRequeteService])
    ], LoadDraftComponent);
    return LoadDraftComponent;
}());
exports.LoadDraftComponent = LoadDraftComponent;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(418));
__export(__webpack_require__(435));
__export(__webpack_require__(419));
__export(__webpack_require__(439));
__export(__webpack_require__(427));
__export(__webpack_require__(426));
__export(__webpack_require__(159));
__export(__webpack_require__(428));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(7);
var shared_1 = __webpack_require__(4);
var forms_1 = __webpack_require__(5);
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var requete_1 = __webpack_require__(17);
var shared_2 = __webpack_require__(4);
var util_1 = __webpack_require__(28);
var RequerantsHandlingError;
(function (RequerantsHandlingError) {
    RequerantsHandlingError[RequerantsHandlingError["NotFound"] = 0] = "NotFound";
    RequerantsHandlingError[RequerantsHandlingError["AlreadyAdded"] = 1] = "AlreadyAdded";
    RequerantsHandlingError[RequerantsHandlingError["Mandataire"] = 2] = "Mandataire";
})(RequerantsHandlingError = exports.RequerantsHandlingError || (exports.RequerantsHandlingError = {}));
var ScrollSelector;
(function (ScrollSelector) {
    ScrollSelector["ERROR"] = ".error";
    ScrollSelector["ADDED_REQUERANTS"] = "jhi-added-requerant";
})(ScrollSelector = exports.ScrollSelector || (exports.ScrollSelector = {}));
var AddRequerantSectionComponent = /** @class */ (function (_super) {
    __extends(AddRequerantSectionComponent, _super);
    function AddRequerantSectionComponent(injector, accountService, scrollService, userService) {
        var _this = _super.call(this, injector) || this;
        _this.accountService = accountService;
        _this.scrollService = scrollService;
        _this.userService = userService;
        _this.RequeteCategoryEnum = requete_1.RequeteCategory;
        _this.RequerantsHandlingErrorEnum = RequerantsHandlingError;
        _this.addedRequerants = [];
        return _this;
    }
    AddRequerantSectionComponent_1 = AddRequerantSectionComponent;
    AddRequerantSectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.getAccount(false)
            .then(function (account) { return _this.mandataire = account; });
    };
    AddRequerantSectionComponent.prototype.ngAfterViewChecked = function () {
        if (this.scrollSelector) {
            this.scrollService.scrollBySelector(this.scrollSelector);
            this.scrollSelector = null;
        }
    };
    AddRequerantSectionComponent.prototype.modelValueChanged = function (value) {
        this.addedRequerants = value;
        this.errorType = null;
    };
    AddRequerantSectionComponent.prototype.setRequerants = function (value) {
        this.onChange(value);
    };
    AddRequerantSectionComponent.prototype.search = function (searchForm) {
        var _this = this;
        this.errorType = null;
        if (searchForm != null) {
            this.accountService.getRequerant(searchForm.email, searchForm.firstName, searchForm.lastName).pipe(operators_1.first())
                .subscribe(function (account) {
                if (_this.isAccountAlreadyAdded(account)) {
                    _this.errorType = RequerantsHandlingError.AlreadyAdded;
                }
                else if (_this.isMandataire(account)) {
                    _this.errorType = RequerantsHandlingError.Mandataire;
                }
                else {
                    _this.requerant = _this.setRequerantFromAccount(account);
                }
            }, function () {
                _this.errorType = RequerantsHandlingError.NotFound;
            });
        }
    };
    AddRequerantSectionComponent.prototype.isMandataire = function (account) {
        return this.mandataire.id === account.id;
    };
    AddRequerantSectionComponent.prototype.isAccountAlreadyAdded = function (account) {
        return this.addedRequerants.some(function (item) { return item.userId === account.id; });
    };
    AddRequerantSectionComponent.prototype.setRequerantFromAccount = function (account) {
        var requerant = this.accountService.mapAccountToPartieDepot(account);
        requerant.qualite = requete_1.QualityType.Requerant;
        return requerant;
    };
    AddRequerantSectionComponent.prototype.addQualifiedRequerant = function () {
        this.addedRequerants.push(this.requerant);
        this.requerant = null;
        this.setRequerants(this.addedRequerants);
    };
    AddRequerantSectionComponent.prototype.addAnonymousRequerant = function (requerant) {
        this.errorType = null;
        if (!this.isRequerantAlreadyAdded(requerant)) {
            this.addedRequerants.push(requerant);
            this.setRequerants(this.addedRequerants);
            this.scrollSelector = ScrollSelector.ADDED_REQUERANTS;
        }
        else {
            this.errorType = RequerantsHandlingError.AlreadyAdded;
            this.scrollSelector = ScrollSelector.ERROR;
        }
    };
    AddRequerantSectionComponent.prototype.isRequerantAlreadyAdded = function (partie) {
        return this.addedRequerants.some(function (item) { return util_1.isEquals(item, partie); });
    };
    AddRequerantSectionComponent.prototype.removeRequerant = function (index) {
        this.addedRequerants.splice(index, 1);
        this.setRequerants(this.addedRequerants);
        this.errorType = null;
    };
    AddRequerantSectionComponent.prototype.moveToRequerantPrincipal = function (index) {
        this.swap(0, index);
        this.setRequerants(this.addedRequerants);
    };
    AddRequerantSectionComponent.prototype.swap = function (x, y) {
        var tmp = this.addedRequerants[x];
        this.addedRequerants[x] = this.addedRequerants[y];
        this.addedRequerants[y] = tmp;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AddRequerantSectionComponent.prototype, "requeteCategory", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AddRequerantSectionComponent.prototype, "state", void 0);
    AddRequerantSectionComponent = AddRequerantSectionComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-add-requerant-section',
            template: __webpack_require__(786),
            styles: [__webpack_require__(886)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: AddRequerantSectionComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector,
            shared_1.AccountService,
            shared_2.ScrollToService,
            shared_2.UserService])
    ], AddRequerantSectionComponent);
    return AddRequerantSectionComponent;
    var AddRequerantSectionComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.AddRequerantSectionComponent = AddRequerantSectionComponent;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = __webpack_require__(5);
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var piece_jointe_1 = __webpack_require__(38);
var file_uploader_component_1 = __webpack_require__(52);
var draft_depot_requete_service_1 = __webpack_require__(16);
var a11y_1 = __webpack_require__(44);
var ng2_dragula_1 = __webpack_require__(46);
var ReclamationPrealableComponent = /** @class */ (function (_super) {
    __extends(ReclamationPrealableComponent, _super);
    function ReclamationPrealableComponent(injector, draftDepotRequeteService, liveAnnouncer, dragulaService) {
        var _this = _super.call(this, injector) || this;
        _this.draftDepotRequeteService = draftDepotRequeteService;
        _this.liveAnnouncer = liveAnnouncer;
        _this.dragulaService = dragulaService;
        _this.reclamationPrealables = [];
        // --- drag n drop keyboard accessible
        _this.selectedItem = null;
        _this.dragulaService.drop.subscribe(function () {
            _this.liveAnnouncer.announce('élément relaché');
        });
        _this.dragulaService.drag.subscribe(function () {
            _this.liveAnnouncer.announce('élément selectionné ');
        });
        return _this;
    }
    ReclamationPrealableComponent_1 = ReclamationPrealableComponent;
    ReclamationPrealableComponent.prototype.modelValueChanged = function (value) {
        this.reclamationPrealables = value;
    };
    ReclamationPrealableComponent.prototype.markAsUntouched = function () {
        if (this.pieceAdder) {
            this.pieceAdder.markAsUntouched();
        }
    };
    ReclamationPrealableComponent.prototype.onReclamationPrealableAdd = function (file) {
        if (file) {
            this.reclamationPrealables.push(new piece_jointe_1.PieceReclamationPrealable(file));
            this.pieceAdder.deleteFile();
        }
        this.onChange(this.reclamationPrealables);
    };
    ReclamationPrealableComponent.prototype.onReclamationPrealableDelete = function (index, file) {
        if (!file) {
            this.reclamationPrealables.splice(index, 1);
        }
        this.onChange(this.reclamationPrealables);
    };
    ReclamationPrealableComponent.prototype.moveUp = function (index) {
        if (index > 0) {
            this.swapReclamationPrealables(index - 1, index);
        }
    };
    ReclamationPrealableComponent.prototype.moveDown = function (index) {
        if (index < this.reclamationPrealables.length - 1) {
            this.swapReclamationPrealables(index + 1, index);
        }
    };
    ReclamationPrealableComponent.prototype.trackByFileApiId = function (_index, item) {
        return item.fileModel.fileApiId;
    };
    ReclamationPrealableComponent.prototype.swapReclamationPrealables = function (piece1Index, piece2Index) {
        var piece1 = this.reclamationPrealables[piece1Index];
        var piece2 = this.reclamationPrealables[piece2Index];
        this.reclamationPrealables[piece2Index] = piece1;
        this.reclamationPrealables[piece1Index] = piece2;
    };
    Object.defineProperty(ReclamationPrealableComponent.prototype, "uploadUrl", {
        get: function () {
            return this.draftDepotRequeteService.buildUploadUrl();
        },
        enumerable: true,
        configurable: true
    });
    // --- drag n drop keyboard accessible
    ReclamationPrealableComponent.prototype.onMoveup = function (data) {
        console.log('onMoveup', data);
        this.moveUp(data.i);
    };
    ReclamationPrealableComponent.prototype.onMovedown = function (data) {
        console.log('onMovedown', data);
        this.moveDown(data.i);
    };
    ReclamationPrealableComponent.prototype.onSelect = function (data) {
        console.log('onSelect', data);
        this.selectedItem = data.piece.fileModel.fileApiId;
    };
    ReclamationPrealableComponent.prototype.onEscape = function (data) {
        console.log('onEscape', data);
        this.selectedItem = null;
    };
    __decorate([
        core_1.ViewChild('reclamationPrealablesAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ReclamationPrealableComponent.prototype, "pieceAdder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ReclamationPrealableComponent.prototype, "maxReclamationPrealablesForMerge", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ReclamationPrealableComponent.prototype, "draftRequeteId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ReclamationPrealableComponent.prototype, "required", void 0);
    ReclamationPrealableComponent = ReclamationPrealableComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-reclamation-prealable',
            template: __webpack_require__(794),
            styles: [__webpack_require__(894)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: ReclamationPrealableComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector, draft_depot_requete_service_1.DraftDepotRequeteService,
            a11y_1.LiveAnnouncer,
            ng2_dragula_1.DragulaService])
    ], ReclamationPrealableComponent);
    return ReclamationPrealableComponent;
    var ReclamationPrealableComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.ReclamationPrealableComponent = ReclamationPrealableComponent;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(444));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var HighlightSearchPipe = /** @class */ (function () {
    function HighlightSearchPipe() {
    }
    HighlightSearchPipe.prototype.transform = function (items, searchText) {
        var _this = this;
        var result = [];
        if (!searchText) {
            return result;
        }
        // strimming whitespace
        searchText = searchText.replace(/\s{2}/g, ' ');
        items.forEach(function (item) {
            // escape html tag
            item.question = _this.escapeHtml(item.question);
            item.answer = _this.escapeHtml(item.answer);
            // contains searchText or not ?
            if (_this.containSearchText(item, searchText)) {
                result.push(_this.highlightItem(item, searchText));
            }
        });
        return result;
    };
    HighlightSearchPipe.prototype.highlightItem = function (item, searchText) {
        var question = this.highlightText(item.question, searchText);
        var answer = this.highlightText(this.truncateAnswer(item.answer, searchText), searchText);
        var matchedItem = {
            'id': item.id,
            'question': question,
            'answer': answer
        };
        return matchedItem;
    };
    HighlightSearchPipe.prototype.highlightText = function (text, searchText) {
        var highlightedText = text;
        searchText.split(' ').filter(function (word) { return word.trim().length > 0; }).forEach(function (word) {
            // Match in a case insensitive maneer
            var re = new RegExp(word, 'gi');
            var match = highlightedText.match(re);
            // If there's no match, just return the original value.
            if (match) {
                highlightedText = highlightedText.replace(re, "<mark>" + match[0] + "</mark>");
            }
        });
        return highlightedText;
    };
    HighlightSearchPipe.prototype.truncateAnswer = function (answer, searchText) {
        var truncatedText = null;
        searchText.split(' ').filter(function (word) { return word.trim().length > 0; }).forEach(function (word) {
            var pattern = "([a-zA-Z0-9\u00C0-\u00FF\\.,;:-]+\\s+){0,4}" + word + "\\S*(\\s+[a-zA-Z0-9\u00C0-\u00FF\\.,;:-]+){0,4}";
            // Match in a case insensitive maneer
            var re = new RegExp(pattern, 'gi');
            var match = answer.match(re);
            // If there's no match, just return the original value.
            if (match) {
                truncatedText = match[0];
            }
        });
        if (truncatedText == null) {
            truncatedText = answer.length < 100 ? answer : answer.substr(0, 100);
        }
        return "$[...] " + truncatedText + " [...]";
    };
    HighlightSearchPipe.prototype.containSearchText = function (item, searchText) {
        var _this = this;
        return searchText.split(' ').filter(function (word) { return word.trim().length > 0; }).some(function (word) { return _this.containWord(word, item); });
    };
    HighlightSearchPipe.prototype.containWord = function (word, item) {
        var re = new RegExp(word, 'gi');
        var matchQuestion = item.question.match(re);
        var matchAnswer = item.answer.match(re);
        if (matchQuestion || matchAnswer) {
            return true;
        }
        return false;
    };
    HighlightSearchPipe.prototype.escapeHtml = function (text) {
        var escapedText = '';
        if (text) {
            // remove html tags
            escapedText = text.replace(/<[^>]*>/g, '');
        }
        return escapedText;
    };
    HighlightSearchPipe = __decorate([
        core_1.Pipe({
            name: 'highlightSearch'
        }),
        __metadata("design:paramtypes", [])
    ], HighlightSearchPipe);
    return HighlightSearchPipe;
}());
exports.HighlightSearchPipe = HighlightSearchPipe;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var static_content_service_1 = __webpack_require__(102);
var router_1 = __webpack_require__(6);
var shared_1 = __webpack_require__(4);
var FaqComponent = /** @class */ (function () {
    function FaqComponent(route, staticContentService, scrollToService) {
        this.route = route;
        this.staticContentService = staticContentService;
        this.scrollToService = scrollToService;
        this.faqCategories = [];
    }
    FaqComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.faqCategoryId = this.route.snapshot.queryParams['category'];
        this.faqCategoryItemId = this.route.snapshot.queryParams['item'];
        this.faqCategoryItemRank = this.route.snapshot.queryParams['rank'];
        this.subscription = this.staticContentService
            .getFaqCategories()
            .subscribe(function (faqCategories) {
            _this.faqCategories = faqCategories;
        });
    };
    FaqComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    FaqComponent.prototype.ngAfterViewChecked = function () {
        if (this.faqCategories.length > 0) {
            if (this.faqCategoryItemId) {
                this.scrollToService.scrollBySelector(".faq-category-item-" + this.faqCategoryItemId);
            }
            else if (this.faqCategoryItemRank) {
                this.scrollToService.scrollBySelector(".faq-category-item-rank" + this.faqCategoryItemRank);
            }
            else if (this.faqCategoryId) {
                this.scrollToService.scrollBySelector(".faq-category-" + this.faqCategoryId);
            }
            this.faqCategoryId = null;
            this.faqCategoryItemRank = null;
            this.faqCategoryItemId = null;
        }
    };
    FaqComponent = __decorate([
        core_1.Component({
            selector: 'jhi-faq',
            template: __webpack_require__(801),
            styles: [__webpack_require__(901)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            static_content_service_1.StaticContentService,
            shared_1.ScrollToService])
    ], FaqComponent);
    return FaqComponent;
}());
exports.FaqComponent = FaqComponent;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var faq_component_1 = __webpack_require__(162);
exports.faqRoute = {
    path: 'faq',
    component: faq_component_1.FaqComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Aide" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var depot_requete_data_1 = __webpack_require__(59);
var draft_depot_requete_service_1 = __webpack_require__(16);
var HomeComponent = /** @class */ (function () {
    function HomeComponent(draftDepotRequeteService, router) {
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.router = router;
    }
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.draftDepotRequeteService.getMyDraftRequeteSummary().subscribe(function (draftSummary) {
            if (draftSummary) {
                _this.requete = _this.draftDepotRequeteService.depotRequeteState;
            }
        });
        this.draftDepotRequeteService.eventDraftDeleted.subscribe(function () {
            _this.requete = _this.draftDepotRequeteService.depotRequeteState;
            _this.isErrorDraftMessage = false;
            _this.isDeletedDraftMessage = true;
        });
    };
    /**
     * Display a popup to take back a draft if there is one, otherwise go to new requete page
     */
    HomeComponent.prototype.newRequete = function () {
        var _this = this;
        this.draftDepotRequeteService.getMyDraftRequeteSummary().subscribe(function (draftSummary) {
            if (draftSummary) {
                _this.isErrorDraftMessage = true;
            }
            else {
                _this.router.navigate([depot_requete_data_1.depotRequeteSteps[0].fullRoute]);
            }
        });
    };
    HomeComponent.prototype.goToDraftRequete = function () {
        this.router.navigate(['/depot-requete'], { skipLocationChange: true });
    };
    HomeComponent.prototype.deleteDraftRequete = function () {
        this.draftDepotRequeteService.displayDraftModal();
    };
    HomeComponent.prototype.scroll = function (id) {
        var el = document.getElementById(id);
        el.scrollIntoView();
    };
    HomeComponent = __decorate([
        core_1.Component({
            selector: 'jhi-home',
            template: __webpack_require__(802),
            styles: [__webpack_require__(902)]
        }),
        __metadata("design:paramtypes", [draft_depot_requete_service_1.DraftDepotRequeteService,
            router_1.Router])
    ], HomeComponent);
    return HomeComponent;
}());
exports.HomeComponent = HomeComponent;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var requete_1 = __webpack_require__(17);
var ng_bootstrap_1 = __webpack_require__(19);
var DossierModalComponent = /** @class */ (function () {
    function DossierModalComponent(activeModal) {
        this.activeModal = activeModal;
    }
    DossierModalComponent.prototype.ngOnInit = function () {
        // RGAA workaround
        var modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', 'Ce dossier est en cours de rattachement');
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", requete_1.RequeteDetail)
    ], DossierModalComponent.prototype, "requete", void 0);
    DossierModalComponent = __decorate([
        core_1.Component({
            selector: 'jhi-dossier-modal',
            template: "\n          <ng-container [ngSwitch]=\"requete?.statut.toString()\">\n            <div aria-modal=\"true\"\n                 role=\"alertdialog\"\n                 aria-labelledby=\"alert_dialog_attach_doc_label\"\n                 aria-describedby=\"alert_dialog_attach_doc_desc\"\n                 jhiTrapFocus>\n              <div class=\"modal-header m-4\">\n                <h4 class=\"modal-title\" *ngSwitchCase=\"'En attente de rattachement'\" id=\"alert_dialog_attach_doc_label\">\n                  Ce dossier est en cours de rattachement\n                </h4>\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\n                  <span aria-hidden=\"true\" title=\"Fermer la fen\u00EAtre\">&times;</span>\n                  <span class=\"sr-only\">Fermer la fen\u00EAtre</span>\n                </button>\n              </div>\n\n              <div class=\"modal-body m-4\" *ngSwitchCase=\"'En attente de rattachement'\">\n                <p>Vous avez fait les d\u00E9marches n\u00E9cessaires pour avoir acc\u00E8s \u00E0 ce dossier.</p>\n                <p id=\"alert_dialog_attach_doc_desc\">La proc\u00E9dure de rattachement sera finalis\u00E9e d'ici 24 heures au plus tard.\n                Vous recevrez un courriel d'avertissement d\u00E8s l'op\u00E9ration finalis\u00E9e,\n                et vous pourrez acc\u00E9der \u00E0 ce dossier depuis cette page d'accueil.\n                </p>\n              </div>\n\n              <div class=\"modal-footer\">\n                  <button class=\"btn btn-outline-primary m-auto\" (click)=\"activeModal.dismiss('Cross click')\">Fermer</button>\n              </div>\n            </div>\n          </ng-container>\n      "
        }),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])
    ], DossierModalComponent);
    return DossierModalComponent;
}());
exports.DossierModalComponent = DossierModalComponent;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var table_1 = __webpack_require__(132);
var DisplayedColumn;
(function (DisplayedColumn) {
    DisplayedColumn["DOSSIER"] = "description";
    DisplayedColumn["JURIDICTION"] = "juridiction";
    DisplayedColumn["STATUT"] = "statut";
    DisplayedColumn["DATE_MAJ"] = "dateModification";
    DisplayedColumn["ACTIONS"] = "actions";
})(DisplayedColumn = exports.DisplayedColumn || (exports.DisplayedColumn = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var RequeteStatutFilter;
(function (RequeteStatutFilter) {
    RequeteStatutFilter["ALL"] = "All";
    RequeteStatutFilter["EN_COURS"] = "En cours";
    RequeteStatutFilter["REFUSE"] = "Refus\u00E9";
    RequeteStatutFilter["TERMINE"] = "Termin\u00E9";
})(RequeteStatutFilter = exports.RequeteStatutFilter || (exports.RequeteStatutFilter = {}));
var RequetesDataSource = /** @class */ (function (_super) {
    __extends(RequetesDataSource, _super);
    function RequetesDataSource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sortKey$ = new rxjs_1.BehaviorSubject(DisplayedColumn.DATE_MAJ);
        _this.sortDirection$ = new rxjs_1.BehaviorSubject(SortDirection.DESC);
        _this.statutFilter$ = new rxjs_1.BehaviorSubject(RequeteStatutFilter.ALL);
        _this.requetes = [];
        _this.displayedRequetes$ = new rxjs_1.BehaviorSubject([]);
        return _this;
    }
    RequetesDataSource.prototype.connect = function () {
        return this.displayedRequetes$;
    };
    RequetesDataSource.prototype.disconnect = function () { };
    RequetesDataSource.prototype.init = function (requetes) {
        var _this = this;
        this.requetes = requetes;
        this.displayedRequetes$.next(this.sortAndMapRequetes(requetes, this.sortKey$.getValue(), this.sortDirection$.getValue()));
        rxjs_1.combineLatest([
            this.sortKey$,
            this.sortDirection$,
            this.statutFilter$
        ]).subscribe(function (_a) {
            var _b = __read(_a, 3), sortKey = _b[0], sortDirection = _b[1], filter = _b[2];
            var dataToSort = filter === RequeteStatutFilter.ALL ?
                _this.requetes : _this.requetes.filter(function (requete) { return _this.hasStatus(requete, filter); });
            _this.displayedRequetes$.next(_this.sortAndMapRequetes(dataToSort, sortKey, sortDirection));
        });
    };
    RequetesDataSource.prototype.applyFilter = function (key) {
        this.statutFilter$.next(key);
    };
    RequetesDataSource.prototype.adjustSort = function (key) {
        if (this.sortKey$.value === key) {
            if (this.sortDirection$.value === SortDirection.ASC) {
                this.sortDirection$.next(SortDirection.DESC);
            }
            else {
                this.sortDirection$.next(SortDirection.ASC);
            }
            return;
        }
        this.sortKey$.next(key);
        this.sortDirection$.next(SortDirection.DESC);
    };
    RequetesDataSource.prototype.hasRequete = function () {
        return this.requetes.length > 0;
    };
    RequetesDataSource.prototype.hasStatus = function (requete, status) {
        if (status === RequeteStatutFilter.EN_COURS) {
            return requete.statut !== RequeteStatutFilter.TERMINE && requete.statut !== RequeteStatutFilter.REFUSE;
        }
        return requete.statut === RequeteStatutFilter.TERMINE || requete.statut === RequeteStatutFilter.REFUSE;
    };
    RequetesDataSource.prototype.sortAndMapRequetes = function (requetes, sortKey, sortDirection) {
        return this.sortRequetes(requetes, sortKey, sortDirection)
            .map(function (requete) { return __spread([requete], requete.dossierCorreles.map(function (req) { req.isLinked = true; return req; })); })
            .reduce(function (acc, correles) { return acc.concat(correles); }, []);
    };
    RequetesDataSource.prototype.sortRequetes = function (requetes, sortKey, sortDirection) {
        var _this = this;
        return requetes.sort(function (r1, r2) { return _this.compare(r1[sortKey], r2[sortKey], sortDirection); });
    };
    RequetesDataSource.prototype.compare = function (value1, value2, sortDirection) {
        if (value1 > value2) {
            return sortDirection === SortDirection.ASC ? 1 : -1;
        }
        if (value1 < value2) {
            return sortDirection === SortDirection.ASC ? -1 : 1;
        }
        return 0;
    };
    return RequetesDataSource;
}(table_1.DataSource));
exports.RequetesDataSource = RequetesDataSource;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ErrorComponent = /** @class */ (function () {
    function ErrorComponent() {
    }
    ErrorComponent = __decorate([
        core_1.Component({
            selector: 'jhi-error',
            template: __webpack_require__(807),
            styles: [__webpack_require__(908)]
        })
    ], ErrorComponent);
    return ErrorComponent;
}());
exports.ErrorComponent = ErrorComponent;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var AccessibiliteComponent = /** @class */ (function () {
    function AccessibiliteComponent() {
    }
    AccessibiliteComponent = __decorate([
        core_1.Component({
            selector: 'jhi-accessibilite',
            template: __webpack_require__(808),
            styles: [__webpack_require__(909)]
        })
    ], AccessibiliteComponent);
    return AccessibiliteComponent;
}());
exports.AccessibiliteComponent = AccessibiliteComponent;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ConditionGeneraleComponent = /** @class */ (function () {
    function ConditionGeneraleComponent() {
        this.cguTypeEnum = "cgu" /* CGU */;
    }
    ConditionGeneraleComponent = __decorate([
        core_1.Component({
            selector: 'jhi-condition-generale',
            template: __webpack_require__(809)
        })
    ], ConditionGeneraleComponent);
    return ConditionGeneraleComponent;
}());
exports.ConditionGeneraleComponent = ConditionGeneraleComponent;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var MajSiteComponent = /** @class */ (function () {
    function MajSiteComponent() {
    }
    MajSiteComponent = __decorate([
        core_1.Component({
            selector: 'jhi-maj-site',
            template: __webpack_require__(811)
        })
    ], MajSiteComponent);
    return MajSiteComponent;
}());
exports.MajSiteComponent = MajSiteComponent;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var MentionLegaleComponent = /** @class */ (function () {
    function MentionLegaleComponent() {
    }
    MentionLegaleComponent = __decorate([
        core_1.Component({
            selector: 'jhi-mention-legale',
            template: __webpack_require__(812),
            styles: [__webpack_require__(911)]
        })
    ], MentionLegaleComponent);
    return MentionLegaleComponent;
}());
exports.MentionLegaleComponent = MentionLegaleComponent;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var PersonalDataComponent = /** @class */ (function () {
    function PersonalDataComponent() {
    }
    PersonalDataComponent.prototype.scroll = function (id) {
        var el = document.getElementById(id);
        el.scrollIntoView();
    };
    PersonalDataComponent = __decorate([
        core_1.Component({
            selector: 'jhi-personal-data',
            template: __webpack_require__(813),
            styles: [__webpack_require__(912)]
        }),
        __metadata("design:paramtypes", [])
    ], PersonalDataComponent);
    return PersonalDataComponent;
}());
exports.PersonalDataComponent = PersonalDataComponent;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_route_1 = __webpack_require__(88);
var core_1 = __webpack_require__(0);
var account_1 = __webpack_require__(410);
var faq_route_1 = __webpack_require__(163);
var app_route_2 = __webpack_require__(88);
var depot_requete_route_1 = __webpack_require__(154);
var rattachement_1 = __webpack_require__(469);
var shared_1 = __webpack_require__(4);
var app_constants_1 = __webpack_require__(11);
var PlanSiteComponent = /** @class */ (function () {
    function PlanSiteComponent(userService) {
        this.userService = userService;
        this.routes = [
            Object.assign({}, account_1.authenticationRoute, { data: { needAuthentication: false, pageTitle: 'Connexion' } }),
            Object.assign({}, account_1.registerRoute, { data: { needAuthentication: false, pageTitle: 'Inscription' } }),
            account_1.passwordResetInitRoute,
            {
                path: '/',
                data: {
                    needAuthentication: true,
                    pageTitle: "Accueil" + app_constants_1.PAGE_TITLE_SUFFIX
                },
                children: [
                    Object.assign({}, depot_requete_route_1.DEPOT_REQUETE_ROUTE, {
                        data: {
                            pageTitle: "D\u00E9poser une requ\u00EAte" + app_constants_1.PAGE_TITLE_SUFFIX
                        }
                    }),
                    Object.assign({}, rattachement_1.RATTACHEMENT_ROUTE, {
                        data: {
                            pageTitle: "Entrer un code re\u00E7u par courrier" + app_constants_1.PAGE_TITLE_SUFFIX
                        }
                    })
                ]
            },
            Object.assign({}, account_1.settingsRoute),
            Object.assign({}, faq_route_1.faqRoute),
            Object.assign({}, app_route_2.conditionGeneraleRoute),
            Object.assign({}, app_route_2.mentionLegaleRoute),
            Object.assign({}, app_route_1.changelogRoute),
        ];
        this.authRoutes = [account_1.registerRoute, account_1.passwordResetInitRoute, account_1.authenticationRoute];
    }
    PlanSiteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.getIsAuthenticated().subscribe(function (isAuthenticated) {
            _this.routes.forEach(function (route) {
                _this.handleRouteDisplay(route, isAuthenticated);
                if (_this.hasChildren(route)) {
                    route.children.forEach(function (childRoute) { return _this.handleRouteDisplay(childRoute, isAuthenticated); });
                }
            });
        });
    };
    PlanSiteComponent.prototype.hasChildren = function (route) {
        return route.children && route.children.length > 0;
    };
    PlanSiteComponent.prototype.handleRouteDisplay = function (route, isAuthenticated) {
        route.data.hide = isAuthenticated ? this.authRoutes.some(function (r) { return r.path === route.path; }) : route.data.needAuthentication;
    };
    PlanSiteComponent = __decorate([
        core_1.Component({
            selector: 'jhi-plan-site',
            template: __webpack_require__(815),
            styles: [__webpack_require__(914)]
        }),
        __metadata("design:paramtypes", [shared_1.UserService])
    ], PlanSiteComponent);
    return PlanSiteComponent;
}());
exports.PlanSiteComponent = PlanSiteComponent;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(4);
var tracking_enum_1 = __webpack_require__(31);
var tracking_service_1 = __webpack_require__(32);
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent(loginService, userService, trackingService) {
        this.loginService = loginService;
        this.userService = userService;
        this.trackingService = trackingService;
        this.collapseNavbar();
    }
    NavbarComponent.prototype.collapseNavbar = function () {
        this.isNavbarCollapsed = true;
    };
    NavbarComponent.prototype.logout = function () {
        this.collapseNavbar();
        this.loginService.logout();
    };
    NavbarComponent.prototype.isAuthenticated = function () {
        return this.userService.authenticated;
    };
    NavbarComponent.prototype.toggleNavbar = function () {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    };
    NavbarComponent.prototype.trackCliquer = function () {
        this._track(tracking_enum_1.TrackingAction.CLIQUER);
    };
    NavbarComponent.prototype._track = function (action) {
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.HEADER,
                name: 'Aide'
            }
        });
    };
    NavbarComponent = __decorate([
        core_1.Component({
            selector: 'jhi-navbar',
            template: __webpack_require__(817),
            styles: [
                __webpack_require__(916)
            ]
        }),
        __metadata("design:paramtypes", [shared_1.LoginService,
            shared_1.UserService,
            tracking_service_1.TrackingService])
    ], NavbarComponent);
    return NavbarComponent;
}());
exports.NavbarComponent = NavbarComponent;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var operators_1 = __webpack_require__(7);
var ProfileService = /** @class */ (function () {
    function ProfileService(http) {
        this.http = http;
        this.profileInfoUrl = '/api/profile-info';
    }
    ProfileService.prototype.getProfileInfo = function () {
        return this.http.get(this.profileInfoUrl).pipe(operators_1.map(function (data) {
            return {
                activeProfiles: data.activeProfiles,
                ribbonEnv: data.ribbonEnv,
                inProduction: data.activeProfiles.indexOf('prod') !== -1,
                swaggerEnabled: data.activeProfiles.indexOf('swagger') !== -1
            };
        }));
    };
    ProfileService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], ProfileService);
    return ProfileService;
}());
exports.ProfileService = ProfileService;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var rattachement_model_1 = __webpack_require__(93);
var RattachementComponent = /** @class */ (function () {
    function RattachementComponent(router) {
        this.router = router;
        this.steps = [
            {
                label: rattachement_model_1.BREAD_STEPS.AVERTISSEMENTS,
                route: "/rattachement/" + rattachement_model_1.ROUTES_NAMES.AVERTISSEMENTS,
                isActive: true
            },
            {
                label: rattachement_model_1.BREAD_STEPS.REJOINDRE_DOSSIER,
                route: "/rattachement/" + rattachement_model_1.ROUTES_NAMES.REJOINDRE_DOSSIER,
                isActive: false
            },
            {
                label: rattachement_model_1.BREAD_STEPS.CONFIRMATION,
                route: "/rattachement/" + rattachement_model_1.ROUTES_NAMES.CONFIRMATION,
                isActive: false
            }
        ];
    }
    RattachementComponent.prototype.ngOnInit = function () {
        this.router.navigate(["/rattachement/" + rattachement_model_1.ROUTES_NAMES.AVERTISSEMENTS]);
    };
    RattachementComponent = __decorate([
        core_1.Component({
            selector: 'jhi-rattachement',
            template: __webpack_require__(819),
            styles: [__webpack_require__(919)]
        }),
        __metadata("design:paramtypes", [router_1.Router])
    ], RattachementComponent);
    return RattachementComponent;
}());
exports.RattachementComponent = RattachementComponent;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var shared_1 = __webpack_require__(4);
var rattachement_service_1 = __webpack_require__(94);
var rattachement_route_1 = __webpack_require__(178);
var rejoindre_dossier_component_1 = __webpack_require__(181);
var rattachement_component_1 = __webpack_require__(176);
var avertissements_component_1 = __webpack_require__(179);
var confirmation_component_1 = __webpack_require__(180);
var TelerecourspnrRattachementModule = /** @class */ (function () {
    function TelerecourspnrRattachementModule() {
    }
    TelerecourspnrRattachementModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_1.TelerecourspnrSharedModule,
                router_1.RouterModule.forRoot([rattachement_route_1.RATTACHEMENT_ROUTE], { useHash: true })
            ],
            declarations: [
                avertissements_component_1.AvertissementsComponent,
                rejoindre_dossier_component_1.RejoindreDossierComponent,
                confirmation_component_1.ConfirmationComponent,
                rattachement_component_1.RattachementComponent
            ],
            providers: [
                rattachement_service_1.RattachementService
            ],
        })
    ], TelerecourspnrRattachementModule);
    return TelerecourspnrRattachementModule;
}());
exports.TelerecourspnrRattachementModule = TelerecourspnrRattachementModule;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __webpack_require__(4);
var rejoindre_dossier_component_1 = __webpack_require__(181);
var rattachement_component_1 = __webpack_require__(176);
var avertissements_component_1 = __webpack_require__(179);
var confirmation_component_1 = __webpack_require__(180);
var nav_back_guard_1 = __webpack_require__(194);
var rattachement_model_1 = __webpack_require__(93);
exports.RATTACHEMENT_ROUTE = {
    path: 'rattachement',
    component: rattachement_component_1.RattachementComponent,
    children: [
        {
            path: '',
            redirectTo: rattachement_model_1.ROUTES_NAMES.AVERTISSEMENTS,
            pathMatch: 'full'
        },
        {
            path: rattachement_model_1.ROUTES_NAMES.AVERTISSEMENTS,
            component: avertissements_component_1.AvertissementsComponent,
            data: {
                needAuthentication: true,
                pageTitle: rattachement_model_1.PAGES_TITLES.AVERTISSEMENTS
            },
            canActivate: [index_1.UserRouteAccessService]
        },
        {
            path: rattachement_model_1.ROUTES_NAMES.REJOINDRE_DOSSIER,
            component: rejoindre_dossier_component_1.RejoindreDossierComponent,
            data: {
                needAuthentication: true,
                pageTitle: rattachement_model_1.PAGES_TITLES.REJOINDRE_DOSSIER
            },
            canActivate: [index_1.UserRouteAccessService]
        },
        {
            path: rattachement_model_1.ROUTES_NAMES.CONFIRMATION,
            component: confirmation_component_1.ConfirmationComponent,
            data: {
                needAuthentication: true,
                pageTitle: rattachement_model_1.PAGES_TITLES.CONFIRMATION
            },
            canActivate: [index_1.UserRouteAccessService],
            canDeactivate: [nav_back_guard_1.NavBackGuard]
        }
    ]
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var router_1 = __webpack_require__(6);
var tracking_enum_1 = __webpack_require__(31);
var rattachement_service_1 = __webpack_require__(94);
var AvertissementsComponent = /** @class */ (function () {
    function AvertissementsComponent(router, rattachementService) {
        this.router = router;
        this.rattachementService = rattachementService;
        // For validation only
        this._cgu = false;
        this._teleprocedures = false;
        this.cguTypeEnum = "cgu-rattachement" /* CGU_RATTACHEMENT */;
    }
    AvertissementsComponent.prototype.previous = function () {
        this.router.navigate(['/']);
    };
    AvertissementsComponent.prototype.next = function () {
        this.isSubmitted = true;
        if (this.form.valid) {
            this.rattachementService.trackCguEvent(tracking_enum_1.TrackingAction.SUCCESS);
            this.router.navigate(['rattachement/rejoindre-dossier']);
        }
        else {
            this.rattachementService.trackCguEvent(tracking_enum_1.TrackingAction.FAILED);
        }
    };
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], AvertissementsComponent.prototype, "form", void 0);
    AvertissementsComponent = __decorate([
        core_1.Component({
            selector: 'jhi-avertissements',
            template: __webpack_require__(820),
            styles: [__webpack_require__(920)]
        }),
        __metadata("design:paramtypes", [router_1.Router, rattachement_service_1.RattachementService])
    ], AvertissementsComponent);
    return AvertissementsComponent;
}());
exports.AvertissementsComponent = AvertissementsComponent;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var ConfirmationComponent = /** @class */ (function () {
    function ConfirmationComponent(router) {
        this.router = router;
    }
    ConfirmationComponent.prototype.goToHome = function () {
        this.router.navigate(['/']);
    };
    ConfirmationComponent = __decorate([
        core_1.Component({
            selector: 'jhi-confirmation',
            template: __webpack_require__(821),
            styles: [__webpack_require__(921)]
        }),
        __metadata("design:paramtypes", [router_1.Router])
    ], ConfirmationComponent);
    return ConfirmationComponent;
}());
exports.ConfirmationComponent = ConfirmationComponent;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var router_1 = __webpack_require__(6);
var requete_1 = __webpack_require__(17);
var error_constants_1 = __webpack_require__(60);
var error_service_1 = __webpack_require__(22);
var rattachement_model_1 = __webpack_require__(93);
var rattachement_service_1 = __webpack_require__(94);
var RejoindreDossierComponent = /** @class */ (function () {
    function RejoindreDossierComponent(rattachementService, errorService, router) {
        this.rattachementService = rattachementService;
        this.errorService = errorService;
        this.router = router;
    }
    RejoindreDossierComponent.prototype.valider = function () {
        var _this = this;
        if (this.form.valid) {
            this.error = null;
            this.isLoading = true;
            this.rattachementService.applyRattachement(this.secretCode)
                .toPromise()
                .then(function (_res) {
                _this.rattachementService.trackRattachementSucceedEvent();
                _this.router.navigate(["/rattachement/" + rattachement_model_1.ROUTES_NAMES.CONFIRMATION]);
            }).catch(function (err) {
                _this.isLoading = false;
                _this.processError(err);
            });
        }
        else {
            this.errorService.markAllControlsAsTouched(this.form);
        }
    };
    RejoindreDossierComponent.prototype.processTechnicalError = function () {
        this.form.controls['secretCode'].setErrors({ invalid: true, 'technical': true });
        if (this.error.code === error_constants_1.ErrorEnum.TR_TECHNICAL_ERROR) {
            this.rattachementService.trackRattachementFailedTrTechnicalEvent();
        }
        else {
            this.rattachementService.trackRattachementFailedTechnicalEvent();
        }
        this.isDisabled = true;
    };
    RejoindreDossierComponent.prototype.processError = function (err) {
        this.error = err.error;
        if (err.status === 400 && this.error.code === error_constants_1.ErrorEnum.SECRET_CODE_SYNTAX_ERROR) {
            this.form.controls['secretCode'].setErrors({ invalid: true, syntax: true });
            this.rattachementService.trackRattachementFailedSyntaxEvent();
        }
        else if (err.status === 400 && this.error.code === error_constants_1.ErrorEnum.SECRET_CODE_SEMANTIC_ERROR) {
            this.form.controls['secretCode'].setErrors({ invalid: true, semantic: true });
            this.rattachementService.trackRattachementFailedSemanticEvent();
        }
        else if (err.status === 400 && this.error.code === error_constants_1.ErrorEnum.SECRET_CODE_ALREADY_ATTACHED) {
            this.processAlreadyAttachedError(this.error);
            this.rattachementService.trackRattachementFailedAlreadyAttachedEvent();
        }
        else if (err.status === 400 && this.error.code === error_constants_1.ErrorEnum.SECRET_CODE_EXPIRED) {
            this.form.controls['secretCode'].setErrors({ invalid: true, expired: true });
            this.rattachementService.trackRattachementFailedExpiredEvent();
        }
        else {
            this.processTechnicalError();
        }
    };
    RejoindreDossierComponent.prototype.processAlreadyAttachedError = function (error) {
        if (error.requeteId && error.requeteStatus !== requete_1.RequeteStatut.EN_ATTENTE_DE_RATTACHEMENT) {
            this.form.controls['secretCode'].setErrors({ invalid: true, 'already-attached-fetchable': true });
        }
        else if (error.requeteId && error.requeteStatus === requete_1.RequeteStatut.EN_ATTENTE_DE_RATTACHEMENT) {
            this.form.controls['secretCode'].setErrors({ invalid: true, 'already-attached-listable': true });
        }
        else {
            this.form.controls['secretCode'].setErrors({ invalid: true, 'already-attached-unknown': true });
        }
    };
    RejoindreDossierComponent.prototype.previous = function () {
        this.router.navigate(["/rattachement/" + rattachement_model_1.ROUTES_NAMES.AVERTISSEMENTS]);
    };
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], RejoindreDossierComponent.prototype, "form", void 0);
    RejoindreDossierComponent = __decorate([
        core_1.Component({
            selector: 'jhi-rejoindre-dossier',
            template: __webpack_require__(822),
            styles: [__webpack_require__(922)]
        }),
        __metadata("design:paramtypes", [rattachement_service_1.RattachementService,
            error_service_1.ErrorService,
            router_1.Router])
    ], RejoindreDossierComponent);
    return RejoindreDossierComponent;
}());
exports.RejoindreDossierComponent = RejoindreDossierComponent;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var piece_jointe_1 = __webpack_require__(38);
var router_1 = __webpack_require__(6);
var common_1 = __webpack_require__(15);
var forms_1 = __webpack_require__(5);
var error_service_1 = __webpack_require__(22);
var shared_1 = __webpack_require__(4);
var file_uploader_component_1 = __webpack_require__(52);
var tracking_service_1 = __webpack_require__(32);
var tracking_enum_1 = __webpack_require__(31);
var tracking_model_1 = __webpack_require__(195);
var requete_1 = __webpack_require__(17);
var parameters_service_1 = __webpack_require__(25);
var app_constants_1 = __webpack_require__(11);
var platform_browser_1 = __webpack_require__(43);
var a11y_1 = __webpack_require__(44);
var ng2_dragula_1 = __webpack_require__(46);
var Document = /** @class */ (function () {
    function Document(memoire, complementaires, postales) {
        this.isTrc = true;
        this.dateEvt = new Date();
        this.pieces = [];
        var complementairesDTO = complementaires.map(function (piece) { return piece.toDTO(); });
        (_a = this.pieces).push.apply(_a, __spread(complementairesDTO));
        var postalesDTO = postales.map(function (piece) { return piece.toDTO(); });
        (_b = this.pieces).push.apply(_b, __spread(postalesDTO));
        if (memoire) {
            this.type = 'MEMOIRE_ENVOYE';
            this.pieces.push(memoire.toDTO());
            complementairesDTO.forEach(function (piece) { return piece.fileType = piece_jointe_1.PieceJointType.PIECE_JOINTE_DOCUMENT; });
        }
        else if (complementaires.length || postales.length) {
            this.type = 'PJ_ENVOYE';
        }
        var _a, _b;
    }
    return Document;
}());
var DocumentComponent = /** @class */ (function () {
    function DocumentComponent(route, location, scrollService, errorService, requeteService, trackingService, parametersService, router, titleService, liveAnnouncer, dragulaService) {
        var _this = this;
        this.route = route;
        this.location = location;
        this.scrollService = scrollService;
        this.errorService = errorService;
        this.requeteService = requeteService;
        this.trackingService = trackingService;
        this.parametersService = parametersService;
        this.router = router;
        this.titleService = titleService;
        this.liveAnnouncer = liveAnnouncer;
        this.dragulaService = dragulaService;
        this.pieceComplementaireArray = [];
        this.piecePostaleArray = [];
        this.uploadUrl = '';
        this.conditionRenommage = false;
        this.isLoading = false;
        this.isEmptyError = false;
        this.isError = false;
        this.isDeactivedPopup = false;
        this.showLengthWarningForFileName = false;
        this.actualFileNameLength = 0;
        // --- drag n drop keyboard accessible
        this.selectedItem = null;
        this.dragulaService.drop.subscribe(function () {
            _this.liveAnnouncer.announce('élément relaché');
        });
        this.dragulaService.drag.subscribe(function () {
            _this.liveAnnouncer.announce('élément selectionné ');
        });
    }
    DocumentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.requeteSubscription = this.route.params.subscribe(function (params) {
            _this.requeteService.getRequeteSummary(params.id).subscribe(function (requeteSummary) {
                _this.requeteSummary = requeteSummary;
                _this.titleService.setTitle("Ajout des documents compl\u00E9mentaires au dossier\n                (N\u00B0" + requeteSummary.numeroRequete + ")" + app_constants_1.PAGE_TITLE_SUFFIX);
                _this.uploadUrl = "/api/requetes/" + _this.requeteSummary.id + "/documents/upload";
            });
        });
        this.parameterSubscription = this.parametersService
            .getParameters()
            .subscribe(function (parameters) { return (_this.maxFileNameWithoutExtensionLength = parameters.maxFileNameWithoutExtensionLength); });
        this.maxNumberJointsPieces = 99;
    };
    /* Memoire/Courrier */
    DocumentComponent.prototype.onMemoireChange = function (file) {
        if (file) {
            this.memoire = new piece_jointe_1.Memoire(file);
            this.maxNumberJointsPieces = 98;
            // si on uploade d'abords les pièces complémentaires et qu'elles ont atteint le nombre max,
            // on enlève la dernière pièce uploadée
            if (this.pieceComplementaireArray.length === this.maxNumberJointsPieces + 1) {
                this.pieceComplementaireArray.pop();
            }
        }
        else {
            this.memoire = null;
            this.maxNumberJointsPieces = 99;
        }
    };
    /* Pieces Complementaires */
    DocumentComponent.prototype.onPieceAdd = function (file) {
        if (file) {
            this.pieceComplementaireArray
                .push(new piece_jointe_1.PieceComplementaire(file, piece_jointe_1.PieceJointType.PIECES, piece_jointe_1.PieceComplementaireOrigineType.DEFAULT));
            this.pieceAdder.deleteFile();
        }
    };
    DocumentComponent.prototype.onRenamePiece = function (piece, name) {
        piece.libelle = name;
    };
    DocumentComponent.prototype.onPieceDelete = function (index, file) {
        if (!file) {
            this.pieceComplementaireArray.splice(index, 1);
        }
    };
    DocumentComponent.prototype.trackByFileApiId = function (_index, item) {
        return item.fileModel.fileApiId;
    };
    DocumentComponent.prototype.moveUp = function (index) {
        if (index > 0) {
            this.swapPiecesComplementaire(index - 1, index);
        }
    };
    DocumentComponent.prototype.moveDown = function (index) {
        if (index < this.pieceComplementaireArray.length - 1) {
            this.swapPiecesComplementaire(index + 1, index);
        }
    };
    DocumentComponent.prototype.swapPiecesComplementaire = function (piece1Index, piece2Index) {
        var piece1 = this.pieceComplementaireArray[piece1Index];
        var piece2 = this.pieceComplementaireArray[piece2Index];
        this.pieceComplementaireArray[piece2Index] = piece1;
        this.pieceComplementaireArray[piece1Index] = piece2;
    };
    /* Envoi des pieces */
    DocumentComponent.prototype.submitForm = function () {
        var _this = this;
        if (this.validateForm()) {
            var doc = new Document(this.memoire, this.pieceComplementaireArray, this.piecePostaleArray);
            this.isLoading = true;
            this.isError = false;
            this.requeteService.addDocument(this.requeteSummary.id, doc)
                .subscribe(function (res) {
                _this.trackAddDocument(tracking_enum_1.TrackingAction.SUCCESS);
                _this.isLoading = false;
                _this.requeteService.addEvent(_this.requeteSummary.id, res);
                _this.router.navigate(["/historique/" + _this.requeteSummary.id]);
            }, function (_res) {
                _this.trackAddDocument(tracking_enum_1.TrackingAction.FAILED);
                _this.isLoading = false;
                _this.isError = true;
            });
        }
        else {
            this.scrollService.scrollToFirstError();
        }
    };
    DocumentComponent.prototype.validateForm = function () {
        this.isEmptyError = this.isFormEmpty();
        this.errorService.markAllControlsAsTouched(this.form);
        return this.form.valid && !this.isFormEmpty();
    };
    DocumentComponent.prototype.isFormEmpty = function () {
        return !this.memoire && this.isPieceEmpty();
    };
    DocumentComponent.prototype.isPieceEmpty = function () {
        return this.pieceComplementaireArray.length === 0 && this.piecePostaleArray.length === 0;
    };
    DocumentComponent.prototype.ngOnDestroy = function () {
        this.requeteSubscription.unsubscribe();
        this.parameterSubscription.unsubscribe();
    };
    DocumentComponent.prototype.openInventaire = function () {
        var isIE = (window.navigator && window.navigator.msSaveOrOpenBlob);
        var popup;
        if (!isIE) {
            try {
                popup = window.open('', '_blank');
                popup.document.write('<html><body><head></head><p>Chargement en cours...</p> </body></html>');
                popup.focus();
            }
            catch (e) {
                this.isDeactivedPopup = true;
            }
        }
        this.getInventaire().subscribe(function (blob) {
            if (isIE) {
                window.navigator.msSaveOrOpenBlob(blob);
            }
            else {
                popup.location.href = URL.createObjectURL(blob);
            }
        });
    };
    DocumentComponent.prototype.previous = function () {
        this.location.back();
    };
    DocumentComponent.prototype.getInventaire = function () {
        this.trackInventairePreviewDownload();
        return this.requeteService.generateInventairePreview(this.pieceComplementaireArray, this.piecePostaleArray, this.requeteSummary.id);
    };
    DocumentComponent.prototype.trackInventairePreviewDownload = function () {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.DOWNLOAD,
            properties: {
                category: tracking_enum_1.TrackingCategory.AJOUT_DOCUMENTS,
                name: tracking_model_1.TrackingName.PREVIEW_INVENTORY
            }
        });
    };
    DocumentComponent.prototype.checkLengthForFileName = function (value) {
        if (value) {
            this.actualFileNameLength = value.length;
            this.showLengthWarningForFileName = value.length > this.maxFileNameWithoutExtensionLength;
        }
    };
    DocumentComponent.prototype.trackAddDocument = function (action) {
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.AJOUT_DOCUMENTS,
                name: tracking_model_1.TrackingName.GENERAL
            }
        });
        if (this.memoire) {
            this.trackingService.trackEvent({
                action: action,
                properties: {
                    category: tracking_enum_1.TrackingCategory.AJOUT_DOCUMENTS,
                    name: 'Ajout d\'un mémoire'
                }
            });
        }
        if (this.pieceComplementaireArray.length) {
            this.trackingService.trackEvent({
                action: action,
                properties: {
                    category: tracking_enum_1.TrackingCategory.AJOUT_DOCUMENTS,
                    name: tracking_model_1.TrackingName.NOMBRE_PIECES_COMPLEMENTAIRES,
                    value: this.pieceComplementaireArray.length
                }
            });
        }
        if (this.piecePostaleArray.length) {
            this.trackingService.trackEvent({
                action: action,
                properties: {
                    category: tracking_enum_1.TrackingCategory.AJOUT_DOCUMENTS,
                    name: tracking_model_1.TrackingName.NOMBRE_PIECES_POSTALES,
                    value: this.piecePostaleArray.length
                }
            });
        }
    };
    // --- drag n drop keyboard accessible
    DocumentComponent.prototype.onMoveup = function (data) {
        console.log('onMoveup', data);
        this.moveUp(data.i);
    };
    DocumentComponent.prototype.onMovedown = function (data) {
        console.log('onMovedown', data);
        this.moveDown(data.i);
    };
    DocumentComponent.prototype.onSelect = function (data) {
        console.log('onSelect', data);
        this.selectedItem = data.piece.fileModel.fileApiId;
    };
    DocumentComponent.prototype.onEscape = function (data) {
        console.log('onEscape', data);
        this.selectedItem = null;
    };
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], DocumentComponent.prototype, "form", void 0);
    __decorate([
        core_1.ViewChild('pieceAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], DocumentComponent.prototype, "pieceAdder", void 0);
    DocumentComponent = __decorate([
        core_1.Component({
            selector: 'jhi-document',
            template: __webpack_require__(823),
            styles: [__webpack_require__(923)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute,
            common_1.Location,
            shared_1.ScrollToService,
            error_service_1.ErrorService,
            requete_1.RequeteService,
            tracking_service_1.TrackingService,
            parameters_service_1.ParametersService,
            router_1.Router,
            platform_browser_1.Title,
            a11y_1.LiveAnnouncer,
            ng2_dragula_1.DragulaService])
    ], DocumentComponent);
    return DocumentComponent;
}());
exports.DocumentComponent = DocumentComponent;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_jhipster_1 = __webpack_require__(30);
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var requete_1 = __webpack_require__(17);
var http_code_constants_1 = __webpack_require__(71);
var tracking_enum_1 = __webpack_require__(31);
var tracking_service_1 = __webpack_require__(32);
var platform_browser_1 = __webpack_require__(43);
var app_constants_1 = __webpack_require__(11);
var HistoriqueComponent = /** @class */ (function () {
    function HistoriqueComponent(requeteService, trackingService, route, alertService, titleService) {
        this.requeteService = requeteService;
        this.trackingService = trackingService;
        this.route = route;
        this.alertService = alertService;
        this.titleService = titleService;
        this.hasError = false;
        this.showDossierNonAccessible = false;
    }
    HistoriqueComponent.prototype.ngOnInit = function () {
        var _this = this;
        var dossierId;
        this.isLoading = true;
        this.alertService.clear();
        this.subscription = this.route.params.subscribe(function (params) {
            dossierId = Number(params.id);
            _this.requeteService.getRequeteDetail(dossierId).subscribe(function (data) {
                _this.dossier = data;
                if (_this.dossier.statut === requete_1.RequeteStatut.DOSSIER_NON_ACCESSIBLE) {
                    _this.showDossierNonAccessible = true;
                    _this.showWarning(_this.dossier);
                }
                _this.titleService.setTitle("Consultation du dossier (N\u00B0" + data.numeroRequete + ")" + app_constants_1.PAGE_TITLE_SUFFIX);
                _this.trackDossier(data.id, tracking_enum_1.TrackingAction.SUCCESS);
            }, function (error) {
                _this.processError(dossierId, error);
                _this.hasError = true;
            })
                .add(function () {
                _this.isLoading = false;
            });
        });
    };
    HistoriqueComponent.prototype.displayLoading = function () {
        return !this.dossier && this.isLoading;
    };
    HistoriqueComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    HistoriqueComponent.prototype.showWarning = function (dossier) {
        this.dateAndHour = this.convertModificationDateToDateAndHour(this.dossier.dateModification.toString());
        if (dossier.siteJuridictionLabel.startsWith('Cour')) {
            this.siteJuridictionLabelMsg = 'de la ' + dossier.siteJuridictionLabel;
        }
        else {
            this.siteJuridictionLabelMsg = 'du ' + dossier.siteJuridictionLabel;
        }
        if (dossier.motif) {
            this.alertService.addAlert({ type: 'warning', msg: 'historique.messages.attachement-remove-motif',
                params: { date: this.dateAndHour[0], hour: this.dateAndHour[1], motif: this.dossier.motif } }, []);
        }
        else {
            this.alertService.addAlert({ type: 'warning', msg: 'historique.messages.attachement-remove',
                params: { date: this.dateAndHour[0], hour: this.dateAndHour[1] } }, []);
        }
    };
    HistoriqueComponent.prototype.convertModificationDateToDateAndHour = function (dateModification) {
        var dateAndHour = [];
        var date = dateModification.substring(0, dateModification.indexOf('T'));
        date = date.split('-').reverse().join('/');
        dateAndHour.push(date);
        var hour = dateModification.substring(dateModification.indexOf('T') + 1, dateModification.lastIndexOf(':'));
        dateAndHour.push(hour);
        return dateAndHour;
    };
    HistoriqueComponent.prototype.processError = function (dossierId, error) {
        if (error.status === http_code_constants_1.HttpCodeEnum.FORBIDDEN) {
            console.log('error | ', error);
            // Forbidden
            this.alertService.addAlert({ type: 'danger', msg: 'historique.error.access-rights' }, []);
        }
        else {
            this.alertService.addAlert({ type: 'danger', msg: 'historique.error.technical' }, []);
        }
        this.trackDossier(dossierId, tracking_enum_1.TrackingAction.FAILED, error.status);
    };
    HistoriqueComponent.prototype.trackDossier = function (id, action, errorStatus) {
        if (errorStatus === void 0) { errorStatus = null; }
        var name = errorStatus === http_code_constants_1.HttpCodeEnum.FORBIDDEN ? "Acc\u00E8s refus\u00E9, id du dossier : " + id : "Id du dossier : " + id;
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.CONSULTATION_DOSSIER,
                name: name
            }
        });
    };
    HistoriqueComponent = __decorate([
        core_1.Component({
            selector: 'jhi-historique',
            template: __webpack_require__(825),
            styles: [__webpack_require__(925)]
        }),
        __metadata("design:paramtypes", [requete_1.RequeteService,
            tracking_service_1.TrackingService,
            router_1.ActivatedRoute,
            ng_jhipster_1.JhiAlertService,
            platform_browser_1.Title])
    ], HistoriqueComponent);
    return HistoriqueComponent;
}());
exports.HistoriqueComponent = HistoriqueComponent;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__(10);
var core_1 = __webpack_require__(0);
var util_1 = __webpack_require__(28);
var EventPieceService = /** @class */ (function () {
    function EventPieceService(http) {
        this.http = http;
    }
    EventPieceService.prototype.downloadEventPieceFile = function (requeteId, eventId, eventType, fileApiId, fileName, origin, options) {
        var url = "/api/requetes/" + requeteId + "/events/" + eventId + "/pieces/" + fileApiId + "/download";
        var fileN = !/(.+)(\.pdf)+$/.test(fileName) ? util_1.normalizeLibelle(fileName) + ".pdf" : util_1.normalizeLibelle(fileName);
        /* return this.http.post(url, { */
        /*     origin, */
        /*     typeEvent: eventType, */
        /*     fileName: `${normalizeLibelle(fileName)}.pdf` */
        /* }, options).map(res =>  new Blob([res.blob()], {type: 'application/pdf'})); */
        return this.http.post(url, {
            origin: origin,
            typeEvent: eventType,
            fileName: fileN
        }, __assign({}, options));
    };
    EventPieceService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], EventPieceService);
    return EventPieceService;
}());
exports.EventPieceService = EventPieceService;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(19);
var requete_1 = __webpack_require__(17);
var MAX_TITLE_LENGTH = 150;
var RenameDossierComponent = /** @class */ (function () {
    function RenameDossierComponent(activeModal, requeteService) {
        this.activeModal = activeModal;
        this.requeteService = requeteService;
        this.maxTitleLength = MAX_TITLE_LENGTH;
        this.titleLengthExceeded = false;
    }
    RenameDossierComponent.prototype.onSave = function () {
        var _this = this;
        this.newTitle = this.newTitle.substr(0, MAX_TITLE_LENGTH);
        this.requeteService.getById(this.dossier.id).subscribe(function (req) {
            _this.requeteService.changerTitre(_this.dossier.id, _this.newTitle);
            _this.dossier.titre = _this.newTitle;
            if (req.titre !== _this.dossier.titre) {
                _this.dossier.renamed = true;
            }
            else {
                _this.dossier.renamed = false;
            }
            return req;
        }, function (error) {
            console.error('Ooops, could not retrieve Dossier with id: ' + _this.dossier.id, error);
        }, function () {
            _this.activeModal.dismiss('Nom du dossier enregistré');
        });
    };
    RenameDossierComponent.prototype.ngOnInit = function () {
        this.newTitle = this.dossier.titre;
        // RGAA workaround
        var modalEl = document.querySelector('ngb-modal-window'); // Sélectionnez l'élément modal ng-bootstrap
        modalEl.setAttribute('aria-label', 'Renommer votre dossier'); // Ajoutez l'attribut aria-label
    };
    RenameDossierComponent.prototype.onTitleChange = function () {
        if (this.newTitle.length > MAX_TITLE_LENGTH) {
            this.titleLengthExceeded = true;
        }
        else {
            this.titleLengthExceeded = false;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", requete_1.RequeteDetail)
    ], RenameDossierComponent.prototype, "dossier", void 0);
    RenameDossierComponent = __decorate([
        core_1.Component({
            selector: 'jhi-modal-rename-dossier',
            template: __webpack_require__(829),
            styles: [__webpack_require__(929)]
        }),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
            requete_1.RequeteService])
    ], RenameDossierComponent);
    return RenameDossierComponent;
}());
exports.RenameDossierComponent = RenameDossierComponent;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(30);
var JhiAlertComponent = /** @class */ (function () {
    function JhiAlertComponent(alertService) {
        this.alertService = alertService;
    }
    JhiAlertComponent.prototype.ngOnInit = function () {
        this.alerts = this.alertService.get();
    };
    JhiAlertComponent.prototype.ngOnDestroy = function () {
        this.alerts = [];
    };
    JhiAlertComponent = __decorate([
        core_1.Component({
            selector: 'jhi-alert',
            template: "\n        <ng-container *ngFor=\"let alert of alerts\">\n            <div class=\"alert alert-{{alert.type}} alert-dismissible\"\n            [ngClass]=\"{'fixed-position fixed-bottom pb-3': alert.position === 'fixed'}\" role=\"status\">\n                <button type=\"button\" class=\"close\" aria-label=\"Fermer\" (click)=\"alert.close(alerts)\">\n                    <span aria-hidden=\"true\">&times;</span>\n                </button>\n                <span [innerHTML]=\"alert.msg\"></span>\n            </div>\n        </ng-container>\n    "
        }),
        __metadata("design:paramtypes", [ng_jhipster_1.JhiAlertService])
    ], JhiAlertComponent);
    return JhiAlertComponent;
}());
exports.JhiAlertComponent = JhiAlertComponent;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FileUploaderModel = /** @class */ (function () {
    function FileUploaderModel(fileItem, fileApiId, fileSize) {
        this.fileItem = fileItem;
        this.fileApiId = fileApiId;
        this.fileSize = fileSize;
    }
    return FileUploaderModel;
}());
exports.FileUploaderModel = FileUploaderModel;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var base_control_value_accessor_1 = __webpack_require__(20);
var util_1 = __webpack_require__(47);
var InputComponent = /** @class */ (function (_super) {
    __extends(InputComponent, _super);
    function InputComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.placeholder = '';
        return _this;
    }
    InputComponent_1 = InputComponent;
    InputComponent.prototype.ngOnInit = function () {
        this.hidden = util_1.isNullOrUndefined(this.hidden) ? false : this.hidden;
        this.isPassword = this.type === 'password';
    };
    Object.defineProperty(InputComponent.prototype, "inputType", {
        set: function (type) {
            this.type = type;
        },
        enumerable: true,
        configurable: true
    });
    InputComponent.prototype.modelValueChanged = function (value) {
        this.value = value;
    };
    InputComponent.prototype.toggle = function ($event) {
        this.type = this.type === 'password' ? 'text' : 'password';
        $event.preventDefault();
    };
    InputComponent.prototype.hasValue = function () {
        return _super.prototype.hasValue.call(this) || this.placeholder !== '';
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "label", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "hintLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "readonly", void 0);
    __decorate([
        core_1.HostBinding('class.hidden'),
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "hidden", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "placeholder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "autocomplete", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "ariaDescribedBy", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input('type'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], InputComponent.prototype, "inputType", null);
    InputComponent = InputComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-input',
            template: __webpack_require__(846),
            styles: [__webpack_require__(945)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: InputComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector])
    ], InputComponent);
    return InputComponent;
    var InputComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.InputComponent = InputComponent;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var MessageComponent = /** @class */ (function () {
    function MessageComponent() {
        this.isInvalid = false;
    }
    MessageComponent.prototype.ngOnInit = function () {
    };
    __decorate([
        core_1.HostBinding('class.display-message'),
        __metadata("design:type", Object)
    ], MessageComponent.prototype, "isInvalid", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MessageComponent.prototype, "error", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MessageComponent.prototype, "controlKey", void 0);
    MessageComponent = __decorate([
        core_1.Component({
            selector: 'jhi-message',
            template: '<div role="alert"><ng-content></ng-content></div>',
            styles: [__webpack_require__(946)]
        }),
        __metadata("design:paramtypes", [])
    ], MessageComponent);
    return MessageComponent;
}());
exports.MessageComponent = MessageComponent;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var MessagesComponent = /** @class */ (function () {
    function MessagesComponent() {
        this.isInvalid = false;
    }
    __decorate([
        core_1.HostBinding('class.show-messages'),
        __metadata("design:type", Object)
    ], MessagesComponent.prototype, "isInvalid", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MessagesComponent.prototype, "id", void 0);
    MessagesComponent = __decorate([
        core_1.Component({
            selector: 'jhi-messages',
            template: '<div [id]="id"  class="alert alert-danger alert-secondary" [attr.aria-hidden]="!isInvalid"><ng-content></ng-content></div>',
            styles: [__webpack_require__(947)]
        })
    ], MessagesComponent);
    return MessagesComponent;
}());
exports.MessagesComponent = MessagesComponent;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION_CGU = '07/03/2018';
exports.TIMEOUT_DEFAULT = 600000; // 10 minutes
exports.HEADER_DRAFT_VERSION = 'x-draft-version';


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'application/pdf',
    'application/rtf',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword'
];
exports.MAX_FILE_EXCEEDED_ERROR_CODE = '1080';
exports.FILE_NAME_INVALID_ERROR_CODE = '1061';


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/*
    Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
    They are written in English to avoid character encoding issues (not a perfect solution)
*/
exports.LANGUAGES = [
    'fr'
    // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
];


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var navigation_service_1 = __webpack_require__(99);
var NavBackGuard = /** @class */ (function () {
    function NavBackGuard(navigationService) {
        this.navigationService = navigationService;
    }
    NavBackGuard.prototype.canDeactivate = function (_component, _route, _state) {
        return !this.navigationService.isGoingBack();
    };
    NavBackGuard = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [navigation_service_1.NavigationService])
    ], NavBackGuard);
    return NavBackGuard;
}());
exports.NavBackGuard = NavBackGuard;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TrackingEvent = /** @class */ (function () {
    function TrackingEvent() {
    }
    return TrackingEvent;
}());
exports.TrackingEvent = TrackingEvent;
var TrackingProperties = /** @class */ (function () {
    function TrackingProperties() {
    }
    return TrackingProperties;
}());
exports.TrackingProperties = TrackingProperties;
exports.TrackingName = {
    NOMBRE_PIECES_COMPLEMENTAIRES: 'Nombre de pièces complémentaires',
    NOMBRE_PIECES_POSTALES: 'Nombre de pièces postales',
    NOMBRE_REQUERANTS_REQUETE_COLLECTIVE: 'Nombre de requérants secondaires',
    NOMBRE_MANDANTS: 'Nombre de mandants',
    PREVIEW_INVENTORY: 'Apercu de l\'inventaire',
    GENERAL: 'Général'
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var TrcAlphaStringPipe = /** @class */ (function () {
    function TrcAlphaStringPipe() {
    }
    TrcAlphaStringPipe.prototype.transform = function (input) {
        if (input.match(/^[.]/g)) {
            input = '';
        }
        return input.replace(/\s+/g, ' ')
            .replace(/[\d]/g, '')
            .replace(/-+/g, '-')
            .replace(/"+/g, '"')
            .replace(/'+/g, '\'')
            .replace(/\.+/g, '.')
            .replace(/[,\?!@#\$%\°&\*\(\)\²\§\¤_=\+;:<>\/\\\|\}\{\[\]`~]*/g, '');
    };
    TrcAlphaStringPipe = __decorate([
        core_1.Pipe({ name: 'jhiAlphaString' }),
        __metadata("design:paramtypes", [])
    ], TrcAlphaStringPipe);
    return TrcAlphaStringPipe;
}());
exports.TrcAlphaStringPipe = TrcAlphaStringPipe;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(30);
var CustomCapitalizePipe = /** @class */ (function () {
    function CustomCapitalizePipe(capitalizePipe) {
        this.capitalizePipe = capitalizePipe;
    }
    CustomCapitalizePipe.prototype.transform = function (input) {
        var _this = this;
        return input.replace(/[^ -]+/g, function (match) { return _this.capitalizePipe.transform(match); });
    };
    CustomCapitalizePipe = __decorate([
        core_1.Pipe({ name: 'jhiCapitalize' }),
        __metadata("design:paramtypes", [ng_jhipster_1.JhiCapitalizePipe])
    ], CustomCapitalizePipe);
    return CustomCapitalizePipe;
}());
exports.CustomCapitalizePipe = CustomCapitalizePipe;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var FindLanguageFromKeyPipe = /** @class */ (function () {
    function FindLanguageFromKeyPipe() {
        this.languages = {
            'ca': 'Català',
            'cs': 'Český',
            'da': 'Dansk',
            'de': 'Deutsch',
            'el': 'Ελληνικά',
            'en': 'English',
            'es': 'Español',
            'et': 'Eesti',
            'fr': 'Français',
            'gl': 'Galego',
            'hu': 'Magyar',
            'hi': 'हिंदी',
            'it': 'Italiano',
            'ja': '日本語',
            'ko': '한국어',
            'mr': 'मराठी',
            'nl': 'Nederlands',
            'pl': 'Polski',
            'pt-br': 'Português (Brasil)',
            'pt-pt': 'Português',
            'ro': 'Română',
            'ru': 'Русский',
            'sk': 'Slovenský',
            'sr': 'Srpski',
            'sv': 'Svenska',
            'ta': 'தமிழ்',
            'tr': 'Türkçe',
            'vi': 'Tiếng Việt',
            'zh-cn': '中文（简体）',
            'zh-tw': '繁體中文'
        };
    }
    FindLanguageFromKeyPipe.prototype.transform = function (lang) {
        return this.languages[lang];
    };
    FindLanguageFromKeyPipe = __decorate([
        core_1.Pipe({ name: 'findLanguageFromKey' })
    ], FindLanguageFromKeyPipe);
    return FindLanguageFromKeyPipe;
}());
exports.FindLanguageFromKeyPipe = FindLanguageFromKeyPipe;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var operators_1 = __webpack_require__(7);
var CguService = /** @class */ (function () {
    function CguService(httpClient) {
        this.httpClient = httpClient;
        this.COMMON_URL_CGU = '/api/static';
    }
    CguService.prototype.getCgu = function (cguTypeEnum) {
        var _this = this;
        if (this.cguText && this.cguTypeEnum === cguTypeEnum) {
            return rxjs_1.of(this.cguText);
        }
        var cguUrl = this.COMMON_URL_CGU + "/" + cguTypeEnum + ".xml";
        /* return this.httpClient.get(cguUrl)
            .map(res => {
                this.cguText = res.text();
                this.cguTypeEnum = cguTypeEnum;
                return this.cguText;
            }); */
        return this.httpClient.get(cguUrl, {
            responseType: 'text'
        }).pipe(operators_1.tap(function () { return _this.cguTypeEnum = cguTypeEnum; }), operators_1.map(function (data) { return _this.cguText = data; }));
    };
    CguService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], CguService);
    return CguService;
}());
exports.CguService = CguService;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ngx_cookie_1 = __webpack_require__(378);
var CSRFService = /** @class */ (function () {
    function CSRFService(cookieService) {
        this.cookieService = cookieService;
    }
    CSRFService.prototype.getCSRF = function (name) {
        name = "" + (name ? name : 'XSRF-TOKEN');
        return this.cookieService.get(name);
    };
    CSRFService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [ngx_cookie_1.CookieService])
    ], CSRFService);
    return CSRFService;
}());
exports.CSRFService = CSRFService;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var util_1 = __webpack_require__(47);
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var operators_1 = __webpack_require__(7);
var draft_requete_model_1 = __webpack_require__(91);
var http_code_constants_1 = __webpack_require__(71);
var DraftRequeteService = /** @class */ (function () {
    function DraftRequeteService(http) {
        this.http = http;
        this.resourceUrl = '/api/my-draft-requete';
    }
    DraftRequeteService.prototype.initMyDraftRequete = function () {
        return this.http
            .post(this.resourceUrl, null).pipe(operators_1.map(function (draft) { return draft_requete_model_1.DraftRequete.castAs(draft); }));
    };
    DraftRequeteService.prototype.getMyDraftRequeteDetail = function () {
        return this.http.get(this.resourceUrl).pipe(operators_1.filter(function (draft) { return !util_1.isNullOrUndefined(draft); }), operators_1.map(function (draft) { return draft_requete_model_1.DraftRequete.castAs(draft); }), operators_1.catchError(function (err) {
            if (err.status === http_code_constants_1.HttpCodeEnum.NOT_FOUND) {
                return null;
            }
            rxjs_1.throwError(err);
        }));
    };
    DraftRequeteService.prototype.getMyDraftRequeteSummary = function () {
        return this.http
            .get(this.resourceUrl + "/summary")
            .pipe(operators_1.catchError(function (err) {
            if (err.status === http_code_constants_1.HttpCodeEnum.NOT_FOUND) {
                return null;
            }
            throw err;
        }));
    };
    DraftRequeteService.prototype.deleteMyDraftRequete = function () {
        return this.http.delete(this.resourceUrl);
    };
    DraftRequeteService.prototype.addOneRequerant = function () {
        return this.http.patch(this.resourceUrl + "/requerants/add-one-requerant", null);
    };
    DraftRequeteService.prototype.addRequerants = function (requerants) {
        return this.http.patch(this.resourceUrl + "/requerants/add-many-requerants", requerants);
    };
    DraftRequeteService.prototype.addMandants = function (requerants) {
        return this.http.patch(this.resourceUrl + "/requerants/add-mandants", requerants);
    };
    DraftRequeteService.prototype.addJuridiction = function (juridiction) {
        return this.http.patch(this.resourceUrl + "/juridictions/add-juridiction", juridiction);
    };
    DraftRequeteService.prototype.addNormalProceedingRequest = function (requeteContentieuxSocial) {
        console.log('addRequete requeteContentieuxSocial :', requeteContentieuxSocial);
        return this.http.patch(this.resourceUrl + "/requete/add-normal-proceeding-request", requeteContentieuxSocial);
    };
    DraftRequeteService.prototype.addInterimProceedingRequest = function (typeRequeteId) {
        console.log('addInterimProceedingRequest typeRequeteId :', typeRequeteId);
        return this.http.patch(this.resourceUrl + "/requete/add-interim-proceeding-request", typeRequeteId);
    };
    DraftRequeteService.prototype.addJustificatifs = function (justification) {
        return this.http.patch(this.resourceUrl + "/justificatifs/add-justificatifs", justification);
    };
    DraftRequeteService.prototype.addRecapitulatif = function () {
        return this.http.patch(this.resourceUrl + "/recapitulatifs/add-recapitulatif", null);
    };
    DraftRequeteService.prototype.depotRequete = function () {
        return this.http.post(this.resourceUrl + "/depot", null);
    };
    DraftRequeteService.prototype.getContentieuxSocial = function (contentieuxSocialId) {
        return this.http.get(this.resourceUrl + "/requete/get-contentieux-social-by-id/" + contentieuxSocialId, {
            responseType: 'json'
        }).pipe(operators_1.catchError(function (err) {
            if (err.status === http_code_constants_1.HttpCodeEnum.NOT_FOUND) {
                return null;
            }
            throw err;
        }));
    };
    DraftRequeteService.prototype.generateInventairePreview = function () {
        return this.http
            .get(this.resourceUrl + "/inventaires/preview", {
            responseType: 'blob'
        });
    };
    DraftRequeteService.prototype.downloadJustificatif = function (fileApiId) {
        return this.http
            .get(this.resourceUrl + "/pieces/" + fileApiId + "/download", {
            responseType: 'blob'
        });
    };
    DraftRequeteService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], DraftRequeteService);
    return DraftRequeteService;
}());
exports.DraftRequeteService = DraftRequeteService;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(43);
var router_1 = __webpack_require__(6);
var language_constants_1 = __webpack_require__(193);
var core_2 = __webpack_require__(970);
var JhiLanguageHelper = /** @class */ (function () {
    function JhiLanguageHelper(translateService, titleService, router) {
        this.translateService = translateService;
        this.titleService = titleService;
        this.router = router;
        this.init();
    }
    JhiLanguageHelper.prototype.getAll = function () {
        return Promise.resolve(language_constants_1.LANGUAGES);
    };
    /**
     * Update the window title using params in the following
     * order:
     * 1. titleKey parameter
     * 2. $state.$current.data.pageTitle (current state page title)
     * 3. 'global.title'
     */
    JhiLanguageHelper.prototype.updateTitle = function (titleKey) {
        if (!titleKey) {
            titleKey = this.getPageTitle(this.router.routerState.snapshot.root);
        }
        this.titleService.setTitle(titleKey);
    };
    JhiLanguageHelper.prototype.init = function () {
        var _this = this;
        this.translateService.onTranslationChange.subscribe(function (_event) {
            _this.updateTitle();
        });
        this.translateService.onLangChange.subscribe(function (_event) {
            _this.updateTitle();
        });
    };
    JhiLanguageHelper.prototype.getPageTitle = function (routeSnapshot) {
        var title = (routeSnapshot.data && routeSnapshot.data['pageTitle']) || 'Télérecours citoyens';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    };
    JhiLanguageHelper = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [core_2.TranslateService, platform_browser_1.Title, router_1.Router])
    ], JhiLanguageHelper);
    return JhiLanguageHelper;
}());
exports.JhiLanguageHelper = JhiLanguageHelper;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var operators_1 = __webpack_require__(7);
var RequeteService = /** @class */ (function () {
    function RequeteService(http) {
        this.http = http;
        this._requeteMap = new Map();
        this.resourceUrl = '/api/requetes';
    }
    RequeteService.prototype.getAll = function () {
        return this.http.get(this.resourceUrl);
    };
    RequeteService.prototype.getById = function (id) {
        return this.http.get(this.resourceUrl + "/" + id);
    };
    RequeteService.prototype.changerTitre = function (id, nouveauTitre) {
        this.http.patch(this.resourceUrl + "/" + id, nouveauTitre).subscribe();
    };
    RequeteService.prototype.getRequeteSummary = function (id) {
        return this.http.get(this.resourceUrl + "/" + id + "/summary");
    };
    RequeteService.prototype.getRequeteDetail = function (id) {
        /* if (!this._requeteMap.has(id)) {
            return this.getById(id).map(requete => {
                this._requeteMap.set(requete.id, requete);
                return requete;
            });
        } */
        var _this = this;
        if (!this._requeteMap.has(id)) {
            return this.getById(id).pipe(operators_1.tap(function (requete) { return _this._requeteMap.set(requete['id'], requete); }));
        }
        return rxjs_1.of(this._requeteMap.get(id));
    };
    RequeteService.prototype.canAddPieces = function (requete) {
        // Abstract the rule to allow adding pieces even if it is currently very simple.
        return requete.isSync;
    };
    RequeteService.prototype.addEvent = function (dossierId, event) {
        var dossier = this._requeteMap.get(dossierId);
        if (dossier) {
            dossier.events = __spread([event], dossier.events);
        }
    };
    RequeteService.prototype.clear = function () {
        this._requeteMap.clear();
    };
    RequeteService.prototype.addDocument = function (requeteId, doc) {
        return this.http.post(this.resourceUrl + "/" + requeteId + "/documents/add-documents", doc);
    };
    RequeteService.prototype.readRequeteNumberToday = function () {
        return this.http.get(this.resourceUrl + '?count&today');
    };
    RequeteService.prototype.notifyAccuseCourrier = function (dossierId, eventId, body) {
        return this.http.patch(this.resourceUrl + "/" + dossierId + "/events/" + eventId + "/notification-accuse-courrier", body);
    };
    RequeteService.prototype.generateInventairePreview = function (piecesComplementaires, piecesPostales, dossierId) {
        var event = {
            piecesComplementaires: piecesComplementaires.map(function (pc) { return pc.toDTO(); }),
            piecesPostales: piecesPostales.map(function (pp) { return pp.toDTO(); }),
        };
        return this.http
            .post("/api/requetes/" + dossierId + "/inventaires/preview", event, { responseType: 'blob' });
    };
    RequeteService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], RequeteService);
    return RequeteService;
}());
exports.RequeteService = RequeteService;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__(10);
var core_1 = __webpack_require__(0);
var TRCAdminConfigService = /** @class */ (function () {
    function TRCAdminConfigService(http) {
        this.http = http;
        this.resourceUrl = '/api/trc-admin-config';
    }
    TRCAdminConfigService.prototype.getConfigByCode = function (code) {
        return this.http.get(this.resourceUrl + "/" + code);
    };
    TRCAdminConfigService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient])
    ], TRCAdminConfigService);
    return TRCAdminConfigService;
}());
exports.TRCAdminConfigService = TRCAdminConfigService;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_jhipster_1 = __webpack_require__(30);
var common_1 = __webpack_require__(15);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(43);
var address_component_1 = __webpack_require__(479);
var alert_component_1 = __webpack_require__(186);
var breadcrumb_component_1 = __webpack_require__(480);
var captcha_validator_1 = __webpack_require__(481);
var captcha_component_1 = __webpack_require__(95);
var changelog_component_1 = __webpack_require__(482);
var cgu_component_1 = __webpack_require__(483);
var contact_component_1 = __webpack_require__(484);
var draft_modal_component_1 = __webpack_require__(96);
var fiche_acteur_component_1 = __webpack_require__(485);
var file_uploader_component_1 = __webpack_require__(52);
var form_module_1 = __webpack_require__(493);
var franceConnect_button_component_1 = __webpack_require__(501);
var identite_organisme_component_1 = __webpack_require__(502);
var nom_entreprise_component_1 = __webpack_require__(503);
var civilite_component_1 = __webpack_require__(504);
var identite_personne_component_1 = __webpack_require__(505);
var jumbotron_component_1 = __webpack_require__(506);
var piece_postales_component_1 = __webpack_require__(507);
var preview_piece_component_1 = __webpack_require__(508);
var progress_spinner_component_1 = __webpack_require__(509);
var section_module_1 = __webpack_require__(512);
var alpha_string_directive_1 = __webpack_require__(516);
var capitalize_directive_1 = __webpack_require__(517);
var ignore_dirty_directive_1 = __webpack_require__(518);
var only_numbers_directive_1 = __webpack_require__(519);
var alpha_string_pipe_1 = __webpack_require__(196);
var capitalize_pipe_1 = __webpack_require__(197);
var format_file_size_pipe_1 = __webpack_require__(526);
var language_pipe_1 = __webpack_require__(198);
var local_date_pipe_1 = __webpack_require__(527);
var safe_html_pipe_1 = __webpack_require__(528);
var language_helper_1 = __webpack_require__(202);
var shared_libs_module_1 = __webpack_require__(103);
var trap_focus_directive_1 = __webpack_require__(521);
var a11y_drag_n_drop_directive_1 = __webpack_require__(515);
var adblocker_detector_component_1 = __webpack_require__(478);
var trc_admin_config_component_1 = __webpack_require__(513);
var TelerecourspnrSharedCommonModule = /** @class */ (function () {
    function TelerecourspnrSharedCommonModule() {
    }
    TelerecourspnrSharedCommonModule = __decorate([
        core_1.NgModule({
            imports: [shared_libs_module_1.TelerecourspnrSharedLibsModule, form_module_1.TelerecoursFormModule, section_module_1.SectionModule],
            declarations: [
                only_numbers_directive_1.OnlyNumbersDirective,
                capitalize_pipe_1.CustomCapitalizePipe,
                safe_html_pipe_1.SafeHtmlPipe,
                local_date_pipe_1.LocalDatePipe,
                format_file_size_pipe_1.FormatFileSizePipe,
                capitalize_directive_1.CustomCapitalizeDirective,
                language_pipe_1.FindLanguageFromKeyPipe,
                alert_component_1.JhiAlertComponent,
                piece_postales_component_1.PiecePostalesComponent,
                preview_piece_component_1.PreviewPieceComponent,
                file_uploader_component_1.FileUploaderComponent,
                fiche_acteur_component_1.FicheActeurComponent,
                franceConnect_button_component_1.FranceConnectButtonComponent,
                jumbotron_component_1.JumbotronComponent,
                cgu_component_1.CguComponent,
                captcha_component_1.CaptchaComponent,
                captcha_validator_1.CaptchaValidatorDirective,
                breadcrumb_component_1.BreadcrumbComponent,
                progress_spinner_component_1.ProgressSpinnerComponent,
                address_component_1.AddressComponent,
                identite_personne_component_1.IdentitePersonneComponent,
                identite_organisme_component_1.IdentiteOrganismeComponent,
                contact_component_1.ContactComponent,
                draft_modal_component_1.DraftModalComponent,
                civilite_component_1.CiviliteComponent,
                nom_entreprise_component_1.NomEntrepriseComponent,
                changelog_component_1.ChangelogComponent,
                alpha_string_pipe_1.TrcAlphaStringPipe,
                alpha_string_directive_1.CustomAlphaStringDirective,
                ignore_dirty_directive_1.IgnoreDirtyDirective,
                trap_focus_directive_1.TrapFocusDirective,
                a11y_drag_n_drop_directive_1.A11yDragNDropDirective,
                adblocker_detector_component_1.AdBlockDetectorComponent,
                trc_admin_config_component_1.TRCAdminConfigComponent
            ],
            providers: [
                language_helper_1.JhiLanguageHelper,
                platform_browser_1.Title,
                {
                    provide: core_1.LOCALE_ID,
                    useValue: 'fr'
                },
                common_1.DatePipe,
                local_date_pipe_1.LocalDatePipe,
                format_file_size_pipe_1.FormatFileSizePipe,
                ng_jhipster_1.JhiCapitalizePipe,
                capitalize_pipe_1.CustomCapitalizePipe,
                safe_html_pipe_1.SafeHtmlPipe,
                alpha_string_pipe_1.TrcAlphaStringPipe
            ],
            exports: [
                shared_libs_module_1.TelerecourspnrSharedLibsModule,
                form_module_1.TelerecoursFormModule,
                section_module_1.SectionModule,
                language_pipe_1.FindLanguageFromKeyPipe,
                alert_component_1.JhiAlertComponent,
                piece_postales_component_1.PiecePostalesComponent,
                preview_piece_component_1.PreviewPieceComponent,
                file_uploader_component_1.FileUploaderComponent,
                fiche_acteur_component_1.FicheActeurComponent,
                franceConnect_button_component_1.FranceConnectButtonComponent,
                jumbotron_component_1.JumbotronComponent,
                cgu_component_1.CguComponent,
                captcha_component_1.CaptchaComponent,
                captcha_validator_1.CaptchaValidatorDirective,
                breadcrumb_component_1.BreadcrumbComponent,
                progress_spinner_component_1.ProgressSpinnerComponent,
                address_component_1.AddressComponent,
                identite_personne_component_1.IdentitePersonneComponent,
                identite_organisme_component_1.IdentiteOrganismeComponent,
                contact_component_1.ContactComponent,
                draft_modal_component_1.DraftModalComponent,
                civilite_component_1.CiviliteComponent,
                nom_entreprise_component_1.NomEntrepriseComponent,
                common_1.DatePipe,
                local_date_pipe_1.LocalDatePipe,
                format_file_size_pipe_1.FormatFileSizePipe,
                only_numbers_directive_1.OnlyNumbersDirective,
                capitalize_directive_1.CustomCapitalizeDirective,
                safe_html_pipe_1.SafeHtmlPipe,
                changelog_component_1.ChangelogComponent,
                alpha_string_directive_1.CustomAlphaStringDirective,
                ignore_dirty_directive_1.IgnoreDirtyDirective,
                trap_focus_directive_1.TrapFocusDirective,
                a11y_drag_n_drop_directive_1.A11yDragNDropDirective,
                adblocker_detector_component_1.AdBlockDetectorComponent,
                trc_admin_config_component_1.TRCAdminConfigComponent
            ]
        })
    ], TelerecourspnrSharedCommonModule);
    return TelerecourspnrSharedCommonModule;
}());
exports.TelerecourspnrSharedCommonModule = TelerecourspnrSharedCommonModule;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(19);
var shared_1 = __webpack_require__(4);
var UserClubModalComponent = /** @class */ (function () {
    function UserClubModalComponent(activeModal, userService) {
        var _this = this;
        this.activeModal = activeModal;
        this.userService = userService;
        this.isSuccessMessageActive = false;
        this.isErrorMessageActive = false;
        this.isLoadingMessageActive = false;
        this.isTermsChecked = false;
        this.isSubmitted = false;
        this.showSuccessMessage = function () {
            _this.isLoadingMessageActive = false;
            _this.isSuccessMessageActive = true;
            _this.isSubmitted = false;
        };
        this.showErrorMessage = function () {
            _this.isLoadingMessageActive = false;
            _this.isErrorMessageActive = true;
        };
        this.showLoadingMessage = function () {
            _this.isSuccessMessageActive = false;
            _this.isErrorMessageActive = false;
            _this.isLoadingMessageActive = true;
        };
        this.onJoinUserClub = function () {
            _this.isSubmitted = true;
            if (_this.isTermsChecked) {
                _this.showLoadingMessage();
                _this.userService.subscribeUserClub().then(function () {
                    _this.showSuccessMessage();
                    _this.userService.auth2.next(false);
                }).catch(function () {
                    _this.showErrorMessage();
                });
            }
        };
    }
    UserClubModalComponent.prototype.ngOnInit = function () {
        // RGAA workaround
        var modalEl = document.querySelector('ngb-modal-window'); // Sélectionnez l'élément modal ng-bootstrap
        modalEl.setAttribute('aria-label', 'S’inscrire au club utilisateur de Télérecours citoyens'); // Ajoutez l'attribut aria-label
    };
    UserClubModalComponent = __decorate([
        core_1.Component({
            selector: 'jhi-user-club-modal',
            template: __webpack_require__(859),
            styles: [__webpack_require__(961)],
        }),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
            shared_1.UserService])
    ], UserClubModalComponent);
    return UserClubModalComponent;
}());
exports.UserClubModalComponent = UserClubModalComponent;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(4);
var UserClubUnsubscribeComponent = /** @class */ (function () {
    function UserClubUnsubscribeComponent(userService) {
        this.userService = userService;
        this.isSuccessMessage = false;
        this.isUserAlreadyJoined = false;
        this.isErrorMessage = false;
    }
    UserClubUnsubscribeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.getAccount().then(function (account) {
            _this.email = account.email;
            _this.joinedUserClub = account.userClubMember;
            _this.isUserAlreadyJoined = account.userClubMember === false;
        });
    };
    UserClubUnsubscribeComponent.prototype.unsubscribeUser = function () {
        var _this = this;
        this.userService.unsubscribeUserClub().then(function () {
            _this.joinedUserClub = false;
            _this.isSuccessMessage = true;
        }).catch(function () {
            _this.isErrorMessage = true;
        });
    };
    UserClubUnsubscribeComponent = __decorate([
        core_1.Component({
            selector: 'jhi-user-club',
            template: __webpack_require__(860),
            styles: [__webpack_require__(962)],
        }),
        __metadata("design:paramtypes", [shared_1.UserService])
    ], UserClubUnsubscribeComponent);
    return UserClubUnsubscribeComponent;
}());
exports.UserClubUnsubscribeComponent = UserClubUnsubscribeComponent;


/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var dragula_provider_1 = __webpack_require__(128);
var dragula_class_1 = __webpack_require__(127);
var DragulaDirective = (function () {
    function DragulaDirective(el, dragulaService) {
        this.el = el;
        this.dragulaService = dragulaService;
        this.container = el.nativeElement;
    }
    DragulaDirective.prototype.ngOnInit = function () {
        var _this = this;
        // console.log(this.bag);
        var bag = this.dragulaService.find(this.dragula);
        var checkModel = function () {
            if (_this.dragulaModel) {
                if (_this.drake.models) {
                    _this.drake.models.push(_this.dragulaModel);
                }
                else {
                    _this.drake.models = [_this.dragulaModel];
                }
            }
        };
        if (bag) {
            this.drake = bag.drake;
            checkModel();
            this.drake.containers.push(this.container);
        }
        else {
            this.drake = dragula_class_1.dragula([this.container], Object.assign({}, this.dragulaOptions));
            checkModel();
            this.dragulaService.add(this.dragula, this.drake);
        }
    };
    DragulaDirective.prototype.ngOnChanges = function (changes) {
        // console.log('dragula.directive: ngOnChanges');
        // console.log(changes);
        if (changes && changes.dragulaModel) {
            if (this.drake) {
                if (this.drake.models) {
                    var modelIndex = this.drake.models.indexOf(changes.dragulaModel.previousValue);
                    this.drake.models.splice(modelIndex, 1, changes.dragulaModel.currentValue);
                }
                else {
                    this.drake.models = [changes.dragulaModel.currentValue];
                }
            }
        }
    };
    return DragulaDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DragulaDirective.prototype, "dragula", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DragulaDirective.prototype, "dragulaModel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DragulaDirective.prototype, "dragulaOptions", void 0);
DragulaDirective = __decorate([
    core_1.Directive({ selector: '[dragula]' }),
    __metadata("design:paramtypes", [core_1.ElementRef, dragula_provider_1.DragulaService])
], DragulaDirective);
exports.DragulaDirective = DragulaDirective;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(200);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(202);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(204);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(968);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(43);
var ng_bootstrap_1 = __webpack_require__(19);
var account_module_1 = __webpack_require__(133);
var uib_pagination_config_1 = __webpack_require__(413);
var depot_requete_module_1 = __webpack_require__(417);
var faq_module_1 = __webpack_require__(451);
var home_module_1 = __webpack_require__(452);
var layouts_1 = __webpack_require__(464);
var maj_site_component_1 = __webpack_require__(170);
var plan_site_item_component_1 = __webpack_require__(462);
var plan_site_component_1 = __webpack_require__(173);
var rattachement_module_1 = __webpack_require__(177);
var requete_module_1 = __webpack_require__(477);
var shared_1 = __webpack_require__(4);
var account_data_1 = __webpack_require__(70);
var accessibilite_component_1 = __webpack_require__(168);
var user_club_module_1 = __webpack_require__(532);
var personal_data_component_1 = __webpack_require__(172);
var inactivity_service_1 = __webpack_require__(92);
var inactivity_modal_component_1 = __webpack_require__(468);
var common_1 = __webpack_require__(15);
var http_1 = __webpack_require__(10);
var auth_expired_interceptor_1 = __webpack_require__(414);
var draft_header_interceptor_1 = __webpack_require__(415);
var ngx_webstorage_1 = __webpack_require__(379);
var fr_1 = __webpack_require__(405);
var common_2 = __webpack_require__(15);
common_2.registerLocaleData(fr_1.default, 'fr');
var TelerecourspnrAppModule = /** @class */ (function () {
    function TelerecourspnrAppModule() {
    }
    TelerecourspnrAppModule = __decorate([
        core_1.NgModule({
            imports: [
                platform_browser_1.BrowserModule,
                layouts_1.LayoutRoutingModule,
                ngx_webstorage_1.Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-' }),
                shared_1.TelerecourspnrSharedModule,
                home_module_1.TelerecourspnrHomeModule,
                account_module_1.TelerecourspnrAccountModule,
                requete_module_1.TelerecourspnrRequeteModule,
                faq_module_1.TelerecourspnrFaqModule,
                rattachement_module_1.TelerecourspnrRattachementModule,
                depot_requete_module_1.TelerecourspnrDepotRequeteModule,
                user_club_module_1.TelerecourspnrUserClubModule
            ],
            declarations: [
                layouts_1.JhiMainComponent,
                layouts_1.NavbarComponent,
                layouts_1.ErrorComponent,
                layouts_1.PageRibbonComponent,
                layouts_1.FooterComponent,
                layouts_1.MentionLegaleComponent,
                layouts_1.ConditionGeneraleComponent,
                plan_site_component_1.PlanSiteComponent,
                plan_site_item_component_1.PlanSiteItemComponent,
                maj_site_component_1.MajSiteComponent,
                accessibilite_component_1.AccessibiliteComponent,
                personal_data_component_1.PersonalDataComponent,
                inactivity_modal_component_1.InactivityModalComponent
            ],
            providers: [
                layouts_1.ProfileService,
                { provide: core_1.LOCALE_ID, useValue: 'fr' },
                { provide: http_1.HTTP_INTERCEPTORS, useClass: auth_expired_interceptor_1.AuthExpiredInterceptor, multi: true },
                { provide: http_1.HTTP_INTERCEPTORS, useClass: draft_header_interceptor_1.DraftHeaderInterceptor, multi: true },
                uib_pagination_config_1.PaginationConfig,
                shared_1.UserRouteAccessService,
                account_data_1.AccountData,
                ng_bootstrap_1.NgbActiveModal,
                inactivity_service_1.InactivityService,
                common_1.DatePipe
            ],
            bootstrap: [layouts_1.JhiMainComponent],
        })
    ], TelerecourspnrAppModule);
    return TelerecourspnrAppModule;
}());
exports.TelerecourspnrAppModule = TelerecourspnrAppModule;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var app_constants_1 = __webpack_require__(11);
function ProdConfig() {
    // disable debug data on prod profile to improve performance
    if (!app_constants_1.DEBUG_INFO_ENABLED) {
        core_1.enableProdMode();
    }
}
exports.ProdConfig = ProdConfig;


/***/ }),
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(197);

/***/ }),
/* 400 */,
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_animations__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnimationDriver; });
/* unused harmony export ɵAnimation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnimationStyleNormalizer; });
/* unused harmony export ɵNoopAnimationStyleNormalizer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WebAnimationsStyleNormalizer; });
/* unused harmony export ɵAnimationDriver */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NoopAnimationDriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CssKeyframesDriver; });
/* unused harmony export ɵCssKeyframesPlayer */
/* unused harmony export ɵcontainsElement */
/* unused harmony export ɵinvokeQuery */
/* unused harmony export ɵmatchesElement */
/* unused harmony export ɵvalidateStyleProperty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WebAnimationsDriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return supportsWebAnimations; });
/* unused harmony export ɵWebAnimationsPlayer */
/* unused harmony export ɵallowPreviousPlayerStylesMerge */
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */





function isBrowser() {
    return (typeof window !== 'undefined' && typeof window.document !== 'undefined');
}
function isNode() {
    return (typeof process !== 'undefined');
}
function optimizeGroupPlayer(players) {
    switch (players.length) {
        case 0:
            return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["NoopAnimationPlayer"]();
        case 1:
            return players[0];
        default:
            return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["ɵAnimationGroupPlayer"](players);
    }
}
function normalizeKeyframes(driver, normalizer, element, keyframes, preStyles, postStyles) {
    if (preStyles === void 0) { preStyles = {}; }
    if (postStyles === void 0) { postStyles = {}; }
    var errors = [];
    var normalizedKeyframes = [];
    var previousOffset = -1;
    var previousKeyframe = null;
    keyframes.forEach(function (kf) {
        var offset = kf['offset'];
        var isSameOffset = offset == previousOffset;
        var normalizedKeyframe = (isSameOffset && previousKeyframe) || {};
        Object.keys(kf).forEach(function (prop) {
            var normalizedProp = prop;
            var normalizedValue = kf[prop];
            if (prop !== 'offset') {
                normalizedProp = normalizer.normalizePropertyName(normalizedProp, errors);
                switch (normalizedValue) {
                    case __WEBPACK_IMPORTED_MODULE_1__angular_animations__["ɵPRE_STYLE"]:
                        normalizedValue = preStyles[prop];
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"]:
                        normalizedValue = postStyles[prop];
                        break;
                    default:
                        normalizedValue =
                            normalizer.normalizeStyleValue(prop, normalizedProp, normalizedValue, errors);
                        break;
                }
            }
            normalizedKeyframe[normalizedProp] = normalizedValue;
        });
        if (!isSameOffset) {
            normalizedKeyframes.push(normalizedKeyframe);
        }
        previousKeyframe = normalizedKeyframe;
        previousOffset = offset;
    });
    if (errors.length) {
        var LINE_START = '\n - ';
        throw new Error("Unable to animate due to the following errors:" + LINE_START + errors.join(LINE_START));
    }
    return normalizedKeyframes;
}
function listenOnPlayer(player, eventName, event, callback) {
    switch (eventName) {
        case 'start':
            player.onStart(function () { return callback(event && copyAnimationEvent(event, 'start', player)); });
            break;
        case 'done':
            player.onDone(function () { return callback(event && copyAnimationEvent(event, 'done', player)); });
            break;
        case 'destroy':
            player.onDestroy(function () { return callback(event && copyAnimationEvent(event, 'destroy', player)); });
            break;
    }
}
function copyAnimationEvent(e, phaseName, player) {
    var totalTime = player.totalTime;
    var disabled = player.disabled ? true : false;
    var event = makeAnimationEvent(e.element, e.triggerName, e.fromState, e.toState, phaseName || e.phaseName, totalTime == undefined ? e.totalTime : totalTime, disabled);
    var data = e['_data'];
    if (data != null) {
        event['_data'] = data;
    }
    return event;
}
function makeAnimationEvent(element, triggerName, fromState, toState, phaseName, totalTime, disabled) {
    if (phaseName === void 0) { phaseName = ''; }
    if (totalTime === void 0) { totalTime = 0; }
    return { element: element, triggerName: triggerName, fromState: fromState, toState: toState, phaseName: phaseName, totalTime: totalTime, disabled: !!disabled };
}
function getOrSetAsInMap(map, key, defaultValue) {
    var value;
    if (map instanceof Map) {
        value = map.get(key);
        if (!value) {
            map.set(key, value = defaultValue);
        }
    }
    else {
        value = map[key];
        if (!value) {
            value = map[key] = defaultValue;
        }
    }
    return value;
}
function parseTimelineCommand(command) {
    var separatorPos = command.indexOf(':');
    var id = command.substring(1, separatorPos);
    var action = command.substr(separatorPos + 1);
    return [id, action];
}
var _contains = function (elm1, elm2) { return false; };
var _matches = function (element, selector) {
    return false;
};
var _query = function (element, selector, multi) {
    return [];
};
// Define utility methods for browsers and platform-server(domino) where Element
// and utility methods exist.
var _isNode = isNode();
if (_isNode || typeof Element !== 'undefined') {
    // this is well supported in all browsers
    _contains = function (elm1, elm2) { return elm1.contains(elm2); };
    if (_isNode || Element.prototype.matches) {
        _matches = function (element, selector) { return element.matches(selector); };
    }
    else {
        var proto = Element.prototype;
        var fn_1 = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector ||
            proto.oMatchesSelector || proto.webkitMatchesSelector;
        if (fn_1) {
            _matches = function (element, selector) { return fn_1.apply(element, [selector]); };
        }
    }
    _query = function (element, selector, multi) {
        var results = [];
        if (multi) {
            results.push.apply(results, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(element.querySelectorAll(selector)));
        }
        else {
            var elm = element.querySelector(selector);
            if (elm) {
                results.push(elm);
            }
        }
        return results;
    };
}
function containsVendorPrefix(prop) {
    // Webkit is the only real popular vendor prefix nowadays
    // cc: http://shouldiprefix.com/
    return prop.substring(1, 6) == 'ebkit'; // webkit or Webkit
}
var _CACHED_BODY = null;
var _IS_WEBKIT = false;
function validateStyleProperty(prop) {
    if (!_CACHED_BODY) {
        _CACHED_BODY = getBodyNode() || {};
        _IS_WEBKIT = _CACHED_BODY.style ? ('WebkitAppearance' in _CACHED_BODY.style) : false;
    }
    var result = true;
    if (_CACHED_BODY.style && !containsVendorPrefix(prop)) {
        result = prop in _CACHED_BODY.style;
        if (!result && _IS_WEBKIT) {
            var camelProp = 'Webkit' + prop.charAt(0).toUpperCase() + prop.substr(1);
            result = camelProp in _CACHED_BODY.style;
        }
    }
    return result;
}
function getBodyNode() {
    if (typeof document != 'undefined') {
        return document.body;
    }
    return null;
}
var matchesElement = _matches;
var containsElement = _contains;
var invokeQuery = _query;
function hypenatePropsObject(object) {
    var newObj = {};
    Object.keys(object).forEach(function (prop) {
        var newProp = prop.replace(/([a-z])([A-Z])/g, '$1-$2');
        newObj[newProp] = object[prop];
    });
    return newObj;
}

/**
 * @experimental
 */
var NoopAnimationDriver = /** @class */ (function () {
    function NoopAnimationDriver() {
    }
    NoopAnimationDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
    NoopAnimationDriver.prototype.matchesElement = function (element, selector) {
        return matchesElement(element, selector);
    };
    NoopAnimationDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
    NoopAnimationDriver.prototype.query = function (element, selector, multi) {
        return invokeQuery(element, selector, multi);
    };
    NoopAnimationDriver.prototype.computeStyle = function (element, prop, defaultValue) {
        return defaultValue || '';
    };
    NoopAnimationDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["NoopAnimationPlayer"](duration, delay);
    };
    NoopAnimationDriver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])()
    ], NoopAnimationDriver);
    return NoopAnimationDriver;
}());
/**
 * @experimental
 */
var AnimationDriver = /** @class */ (function () {
    function AnimationDriver() {
    }
    AnimationDriver.NOOP = new NoopAnimationDriver();
    return AnimationDriver;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ONE_SECOND = 1000;
var SUBSTITUTION_EXPR_START = '{{';
var SUBSTITUTION_EXPR_END = '}}';
var ENTER_CLASSNAME = 'ng-enter';
var LEAVE_CLASSNAME = 'ng-leave';
var NG_TRIGGER_CLASSNAME = 'ng-trigger';
var NG_TRIGGER_SELECTOR = '.ng-trigger';
var NG_ANIMATING_CLASSNAME = 'ng-animating';
var NG_ANIMATING_SELECTOR = '.ng-animating';
function resolveTimingValue(value) {
    if (typeof value == 'number')
        return value;
    var matches = value.match(/^(-?[\.\d]+)(m?s)/);
    if (!matches || matches.length < 2)
        return 0;
    return _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
}
function _convertTimeValueToMS(value, unit) {
    switch (unit) {
        case 's':
            return value * ONE_SECOND;
        default: // ms or something else
            return value;
    }
}
function resolveTiming(timings, errors, allowNegativeValues) {
    return timings.hasOwnProperty('duration') ?
        timings :
        parseTimeExpression(timings, errors, allowNegativeValues);
}
function parseTimeExpression(exp, errors, allowNegativeValues) {
    var regex = /^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i;
    var duration;
    var delay = 0;
    var easing = '';
    if (typeof exp === 'string') {
        var matches = exp.match(regex);
        if (matches === null) {
            errors.push("The provided timing value \"" + exp + "\" is invalid.");
            return { duration: 0, delay: 0, easing: '' };
        }
        duration = _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
        var delayMatch = matches[3];
        if (delayMatch != null) {
            delay = _convertTimeValueToMS(Math.floor(parseFloat(delayMatch)), matches[4]);
        }
        var easingVal = matches[5];
        if (easingVal) {
            easing = easingVal;
        }
    }
    else {
        duration = exp;
    }
    if (!allowNegativeValues) {
        var containsErrors = false;
        var startIndex = errors.length;
        if (duration < 0) {
            errors.push("Duration values below 0 are not allowed for this animation step.");
            containsErrors = true;
        }
        if (delay < 0) {
            errors.push("Delay values below 0 are not allowed for this animation step.");
            containsErrors = true;
        }
        if (containsErrors) {
            errors.splice(startIndex, 0, "The provided timing value \"" + exp + "\" is invalid.");
        }
    }
    return { duration: duration, delay: delay, easing: easing };
}
function copyObj(obj, destination) {
    if (destination === void 0) { destination = {}; }
    Object.keys(obj).forEach(function (prop) { destination[prop] = obj[prop]; });
    return destination;
}
function normalizeStyles(styles) {
    var normalizedStyles = {};
    if (Array.isArray(styles)) {
        styles.forEach(function (data) { return copyStyles(data, false, normalizedStyles); });
    }
    else {
        copyStyles(styles, false, normalizedStyles);
    }
    return normalizedStyles;
}
function copyStyles(styles, readPrototype, destination) {
    if (destination === void 0) { destination = {}; }
    if (readPrototype) {
        // we make use of a for-in loop so that the
        // prototypically inherited properties are
        // revealed from the backFill map
        for (var prop in styles) {
            destination[prop] = styles[prop];
        }
    }
    else {
        copyObj(styles, destination);
    }
    return destination;
}
function getStyleAttributeString(element, key, value) {
    // Return the key-value pair string to be added to the style attribute for the
    // given CSS style key.
    if (value) {
        return key + ':' + value + ';';
    }
    else {
        return '';
    }
}
function writeStyleAttribute(element) {
    // Read the style property of the element and manually reflect it to the
    // style attribute. This is needed because Domino on platform-server doesn't
    // understand the full set of allowed CSS properties and doesn't reflect some
    // of them automatically.
    var styleAttrValue = '';
    for (var i = 0; i < element.style.length; i++) {
        var key = element.style.item(i);
        styleAttrValue += getStyleAttributeString(element, key, element.style.getPropertyValue(key));
    }
    for (var key in element.style) {
        // Skip internal Domino properties that don't need to be reflected.
        if (!element.style.hasOwnProperty(key) || key.startsWith('_')) {
            continue;
        }
        var dashKey = camelCaseToDashCase(key);
        styleAttrValue += getStyleAttributeString(element, dashKey, element.style[key]);
    }
    element.setAttribute('style', styleAttrValue);
}
function setStyles(element, styles) {
    if (element['style']) {
        Object.keys(styles).forEach(function (prop) {
            var camelProp = dashCaseToCamelCase(prop);
            element.style[camelProp] = styles[prop];
        });
        // On the server set the 'style' attribute since it's not automatically reflected.
        if (isNode()) {
            writeStyleAttribute(element);
        }
    }
}
function eraseStyles(element, styles) {
    if (element['style']) {
        Object.keys(styles).forEach(function (prop) {
            var camelProp = dashCaseToCamelCase(prop);
            element.style[camelProp] = '';
        });
        // On the server set the 'style' attribute since it's not automatically reflected.
        if (isNode()) {
            writeStyleAttribute(element);
        }
    }
}
function normalizeAnimationEntry(steps) {
    if (Array.isArray(steps)) {
        if (steps.length == 1)
            return steps[0];
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["sequence"])(steps);
    }
    return steps;
}
function validateStyleParams(value, options, errors) {
    var params = options.params || {};
    var matches = extractStyleParams(value);
    if (matches.length) {
        matches.forEach(function (varName) {
            if (!params.hasOwnProperty(varName)) {
                errors.push("Unable to resolve the local animation param " + varName + " in the given list of values");
            }
        });
    }
}
var PARAM_REGEX = new RegExp(SUBSTITUTION_EXPR_START + "\\s*(.+?)\\s*" + SUBSTITUTION_EXPR_END, 'g');
function extractStyleParams(value) {
    var params = [];
    if (typeof value === 'string') {
        var val = value.toString();
        var match = void 0;
        while (match = PARAM_REGEX.exec(val)) {
            params.push(match[1]);
        }
        PARAM_REGEX.lastIndex = 0;
    }
    return params;
}
function interpolateParams(value, params, errors) {
    var original = value.toString();
    var str = original.replace(PARAM_REGEX, function (_, varName) {
        var localVal = params[varName];
        // this means that the value was never overridden by the data passed in by the user
        if (!params.hasOwnProperty(varName)) {
            errors.push("Please provide a value for the animation param " + varName);
            localVal = '';
        }
        return localVal.toString();
    });
    // we do this to assert that numeric values stay as they are
    return str == original ? value : str;
}
function iteratorToArray(iterator) {
    var arr = [];
    var item = iterator.next();
    while (!item.done) {
        arr.push(item.value);
        item = iterator.next();
    }
    return arr;
}
var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
function dashCaseToCamelCase(input) {
    return input.replace(DASH_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        return m[1].toUpperCase();
    });
}
function camelCaseToDashCase(input) {
    return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function allowPreviousPlayerStylesMerge(duration, delay) {
    return duration === 0 || delay === 0;
}
function balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles) {
    var previousStyleProps = Object.keys(previousStyles);
    if (previousStyleProps.length && keyframes.length) {
        var startingKeyframe_1 = keyframes[0];
        var missingStyleProps_1 = [];
        previousStyleProps.forEach(function (prop) {
            if (!startingKeyframe_1.hasOwnProperty(prop)) {
                missingStyleProps_1.push(prop);
            }
            startingKeyframe_1[prop] = previousStyles[prop];
        });
        if (missingStyleProps_1.length) {
            var _loop_1 = function () {
                var kf = keyframes[i];
                missingStyleProps_1.forEach(function (prop) { kf[prop] = computeStyle(element, prop); });
            };
            // tslint:disable-next-line
            for (var i = 1; i < keyframes.length; i++) {
                _loop_1();
            }
        }
    }
    return keyframes;
}
function visitDslNode(visitor, node, context) {
    switch (node.type) {
        case 7 /* Trigger */:
            return visitor.visitTrigger(node, context);
        case 0 /* State */:
            return visitor.visitState(node, context);
        case 1 /* Transition */:
            return visitor.visitTransition(node, context);
        case 2 /* Sequence */:
            return visitor.visitSequence(node, context);
        case 3 /* Group */:
            return visitor.visitGroup(node, context);
        case 4 /* Animate */:
            return visitor.visitAnimate(node, context);
        case 5 /* Keyframes */:
            return visitor.visitKeyframes(node, context);
        case 6 /* Style */:
            return visitor.visitStyle(node, context);
        case 8 /* Reference */:
            return visitor.visitReference(node, context);
        case 9 /* AnimateChild */:
            return visitor.visitAnimateChild(node, context);
        case 10 /* AnimateRef */:
            return visitor.visitAnimateRef(node, context);
        case 11 /* Query */:
            return visitor.visitQuery(node, context);
        case 12 /* Stagger */:
            return visitor.visitStagger(node, context);
        default:
            throw new Error("Unable to resolve animation metadata node #" + node.type);
    }
}
function computeStyle(element, prop) {
    return window.getComputedStyle(element)[prop];
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ANY_STATE = '*';
function parseTransitionExpr(transitionValue, errors) {
    var expressions = [];
    if (typeof transitionValue == 'string') {
        transitionValue
            .split(/\s*,\s*/)
            .forEach(function (str) { return parseInnerTransitionStr(str, expressions, errors); });
    }
    else {
        expressions.push(transitionValue);
    }
    return expressions;
}
function parseInnerTransitionStr(eventStr, expressions, errors) {
    if (eventStr[0] == ':') {
        var result = parseAnimationAlias(eventStr, errors);
        if (typeof result == 'function') {
            expressions.push(result);
            return;
        }
        eventStr = result;
    }
    var match = eventStr.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
    if (match == null || match.length < 4) {
        errors.push("The provided transition expression \"" + eventStr + "\" is not supported");
        return expressions;
    }
    var fromState = match[1];
    var separator = match[2];
    var toState = match[3];
    expressions.push(makeLambdaFromStates(fromState, toState));
    var isFullAnyStateExpr = fromState == ANY_STATE && toState == ANY_STATE;
    if (separator[0] == '<' && !isFullAnyStateExpr) {
        expressions.push(makeLambdaFromStates(toState, fromState));
    }
}
function parseAnimationAlias(alias, errors) {
    switch (alias) {
        case ':enter':
            return 'void => *';
        case ':leave':
            return '* => void';
        case ':increment':
            return function (fromState, toState) { return parseFloat(toState) > parseFloat(fromState); };
        case ':decrement':
            return function (fromState, toState) { return parseFloat(toState) < parseFloat(fromState); };
        default:
            errors.push("The transition alias value \"" + alias + "\" is not supported");
            return '* => *';
    }
}
// DO NOT REFACTOR ... keep the follow set instantiations
// with the values intact (closure compiler for some reason
// removes follow-up lines that add the values outside of
// the constructor...
var TRUE_BOOLEAN_VALUES = new Set(['true', '1']);
var FALSE_BOOLEAN_VALUES = new Set(['false', '0']);
function makeLambdaFromStates(lhs, rhs) {
    var LHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(lhs) || FALSE_BOOLEAN_VALUES.has(lhs);
    var RHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(rhs) || FALSE_BOOLEAN_VALUES.has(rhs);
    return function (fromState, toState) {
        var lhsMatch = lhs == ANY_STATE || lhs == fromState;
        var rhsMatch = rhs == ANY_STATE || rhs == toState;
        if (!lhsMatch && LHS_MATCH_BOOLEAN && typeof fromState === 'boolean') {
            lhsMatch = fromState ? TRUE_BOOLEAN_VALUES.has(lhs) : FALSE_BOOLEAN_VALUES.has(lhs);
        }
        if (!rhsMatch && RHS_MATCH_BOOLEAN && typeof toState === 'boolean') {
            rhsMatch = toState ? TRUE_BOOLEAN_VALUES.has(rhs) : FALSE_BOOLEAN_VALUES.has(rhs);
        }
        return lhsMatch && rhsMatch;
    };
}

var SELF_TOKEN = ':self';
var SELF_TOKEN_REGEX = new RegExp("s*" + SELF_TOKEN + "s*,?", 'g');
/*
 * [Validation]
 * The visitor code below will traverse the animation AST generated by the animation verb functions
 * (the output is a tree of objects) and attempt to perform a series of validations on the data. The
 * following corner-cases will be validated:
 *
 * 1. Overlap of animations
 * Given that a CSS property cannot be animated in more than one place at the same time, it's
 * important that this behaviour is detected and validated. The way in which this occurs is that
 * each time a style property is examined, a string-map containing the property will be updated with
 * the start and end times for when the property is used within an animation step.
 *
 * If there are two or more parallel animations that are currently running (these are invoked by the
 * group()) on the same element then the validator will throw an error. Since the start/end timing
 * values are collected for each property then if the current animation step is animating the same
 * property and its timing values fall anywhere into the window of time that the property is
 * currently being animated within then this is what causes an error.
 *
 * 2. Timing values
 * The validator will validate to see if a timing value of `duration delay easing` or
 * `durationNumber` is valid or not.
 *
 * (note that upon validation the code below will replace the timing data with an object containing
 * {duration,delay,easing}.
 *
 * 3. Offset Validation
 * Each of the style() calls are allowed to have an offset value when placed inside of keyframes().
 * Offsets within keyframes() are considered valid when:
 *
 *   - No offsets are used at all
 *   - Each style() entry contains an offset value
 *   - Each offset is between 0 and 1
 *   - Each offset is greater to or equal than the previous one
 *
 * Otherwise an error will be thrown.
 */
function buildAnimationAst(driver, metadata, errors) {
    return new AnimationAstBuilderVisitor(driver).build(metadata, errors);
}
var ROOT_SELECTOR = '';
var AnimationAstBuilderVisitor = /** @class */ (function () {
    function AnimationAstBuilderVisitor(_driver) {
        this._driver = _driver;
    }
    AnimationAstBuilderVisitor.prototype.build = function (metadata, errors) {
        var context = new AnimationAstBuilderContext(errors);
        this._resetContextStyleTimingState(context);
        return visitDslNode(this, normalizeAnimationEntry(metadata), context);
    };
    AnimationAstBuilderVisitor.prototype._resetContextStyleTimingState = function (context) {
        context.currentQuerySelector = ROOT_SELECTOR;
        context.collectedStyles = {};
        context.collectedStyles[ROOT_SELECTOR] = {};
        context.currentTime = 0;
    };
    AnimationAstBuilderVisitor.prototype.visitTrigger = function (metadata, context) {
        var _this = this;
        var queryCount = context.queryCount = 0;
        var depCount = context.depCount = 0;
        var states = [];
        var transitions = [];
        if (metadata.name.charAt(0) == '@') {
            context.errors.push('animation triggers cannot be prefixed with an `@` sign (e.g. trigger(\'@foo\', [...]))');
        }
        metadata.definitions.forEach(function (def) {
            _this._resetContextStyleTimingState(context);
            if (def.type == 0 /* State */) {
                var stateDef_1 = def;
                var name_1 = stateDef_1.name;
                name_1.toString().split(/\s*,\s*/).forEach(function (n) {
                    stateDef_1.name = n;
                    states.push(_this.visitState(stateDef_1, context));
                });
                stateDef_1.name = name_1;
            }
            else if (def.type == 1 /* Transition */) {
                var transition = _this.visitTransition(def, context);
                queryCount += transition.queryCount;
                depCount += transition.depCount;
                transitions.push(transition);
            }
            else {
                context.errors.push('only state() and transition() definitions can sit inside of a trigger()');
            }
        });
        return {
            type: 7 /* Trigger */,
            name: metadata.name, states: states, transitions: transitions, queryCount: queryCount, depCount: depCount,
            options: null
        };
    };
    AnimationAstBuilderVisitor.prototype.visitState = function (metadata, context) {
        var styleAst = this.visitStyle(metadata.styles, context);
        var astParams = (metadata.options && metadata.options.params) || null;
        if (styleAst.containsDynamicStyles) {
            var missingSubs_1 = new Set();
            var params_1 = astParams || {};
            styleAst.styles.forEach(function (value) {
                if (isObject(value)) {
                    var stylesObj_1 = value;
                    Object.keys(stylesObj_1).forEach(function (prop) {
                        extractStyleParams(stylesObj_1[prop]).forEach(function (sub) {
                            if (!params_1.hasOwnProperty(sub)) {
                                missingSubs_1.add(sub);
                            }
                        });
                    });
                }
            });
            if (missingSubs_1.size) {
                var missingSubsArr = iteratorToArray(missingSubs_1.values());
                context.errors.push("state(\"" + metadata.name + "\", ...) must define default values for all the following style substitutions: " + missingSubsArr.join(', '));
            }
        }
        return {
            type: 0 /* State */,
            name: metadata.name,
            style: styleAst,
            options: astParams ? { params: astParams } : null
        };
    };
    AnimationAstBuilderVisitor.prototype.visitTransition = function (metadata, context) {
        context.queryCount = 0;
        context.depCount = 0;
        var animation = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
        var matchers = parseTransitionExpr(metadata.expr, context.errors);
        return {
            type: 1 /* Transition */,
            matchers: matchers,
            animation: animation,
            queryCount: context.queryCount,
            depCount: context.depCount,
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitSequence = function (metadata, context) {
        var _this = this;
        return {
            type: 2 /* Sequence */,
            steps: metadata.steps.map(function (s) { return visitDslNode(_this, s, context); }),
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitGroup = function (metadata, context) {
        var _this = this;
        var currentTime = context.currentTime;
        var furthestTime = 0;
        var steps = metadata.steps.map(function (step) {
            context.currentTime = currentTime;
            var innerAst = visitDslNode(_this, step, context);
            furthestTime = Math.max(furthestTime, context.currentTime);
            return innerAst;
        });
        context.currentTime = furthestTime;
        return {
            type: 3 /* Group */,
            steps: steps,
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitAnimate = function (metadata, context) {
        var timingAst = constructTimingAst(metadata.timings, context.errors);
        context.currentAnimateTimings = timingAst;
        var styleAst;
        var styleMetadata = metadata.styles ? metadata.styles : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["style"])({});
        if (styleMetadata.type == 5 /* Keyframes */) {
            styleAst = this.visitKeyframes(styleMetadata, context);
        }
        else {
            var styleMetadata_1 = metadata.styles;
            var isEmpty = false;
            if (!styleMetadata_1) {
                isEmpty = true;
                var newStyleData = {};
                if (timingAst.easing) {
                    newStyleData['easing'] = timingAst.easing;
                }
                styleMetadata_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["style"])(newStyleData);
            }
            context.currentTime += timingAst.duration + timingAst.delay;
            var _styleAst = this.visitStyle(styleMetadata_1, context);
            _styleAst.isEmptyStep = isEmpty;
            styleAst = _styleAst;
        }
        context.currentAnimateTimings = null;
        return {
            type: 4 /* Animate */,
            timings: timingAst,
            style: styleAst,
            options: null
        };
    };
    AnimationAstBuilderVisitor.prototype.visitStyle = function (metadata, context) {
        var ast = this._makeStyleAst(metadata, context);
        this._validateStyleAst(ast, context);
        return ast;
    };
    AnimationAstBuilderVisitor.prototype._makeStyleAst = function (metadata, context) {
        var styles = [];
        if (Array.isArray(metadata.styles)) {
            metadata.styles.forEach(function (styleTuple) {
                if (typeof styleTuple == 'string') {
                    if (styleTuple == __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"]) {
                        styles.push(styleTuple);
                    }
                    else {
                        context.errors.push("The provided style string value " + styleTuple + " is not allowed.");
                    }
                }
                else {
                    styles.push(styleTuple);
                }
            });
        }
        else {
            styles.push(metadata.styles);
        }
        var containsDynamicStyles = false;
        var collectedEasing = null;
        styles.forEach(function (styleData) {
            if (isObject(styleData)) {
                var styleMap = styleData;
                var easing = styleMap['easing'];
                if (easing) {
                    collectedEasing = easing;
                    delete styleMap['easing'];
                }
                if (!containsDynamicStyles) {
                    for (var prop in styleMap) {
                        var value = styleMap[prop];
                        if (value.toString().indexOf(SUBSTITUTION_EXPR_START) >= 0) {
                            containsDynamicStyles = true;
                            break;
                        }
                    }
                }
            }
        });
        return {
            type: 6 /* Style */,
            styles: styles,
            easing: collectedEasing,
            offset: metadata.offset, containsDynamicStyles: containsDynamicStyles,
            options: null
        };
    };
    AnimationAstBuilderVisitor.prototype._validateStyleAst = function (ast, context) {
        var _this = this;
        var timings = context.currentAnimateTimings;
        var endTime = context.currentTime;
        var startTime = context.currentTime;
        if (timings && startTime > 0) {
            startTime -= timings.duration + timings.delay;
        }
        ast.styles.forEach(function (tuple) {
            if (typeof tuple == 'string')
                return;
            Object.keys(tuple).forEach(function (prop) {
                if (!_this._driver.validateStyleProperty(prop)) {
                    context.errors.push("The provided animation property \"" + prop + "\" is not a supported CSS property for animations");
                    return;
                }
                var collectedStyles = context.collectedStyles[context.currentQuerySelector];
                var collectedEntry = collectedStyles[prop];
                var updateCollectedStyle = true;
                if (collectedEntry) {
                    if (startTime != endTime && startTime >= collectedEntry.startTime &&
                        endTime <= collectedEntry.endTime) {
                        context.errors.push("The CSS property \"" + prop + "\" that exists between the times of \"" + collectedEntry.startTime + "ms\" and \"" + collectedEntry.endTime + "ms\" is also being animated in a parallel animation between the times of \"" + startTime + "ms\" and \"" + endTime + "ms\"");
                        updateCollectedStyle = false;
                    }
                    // we always choose the smaller start time value since we
                    // want to have a record of the entire animation window where
                    // the style property is being animated in between
                    startTime = collectedEntry.startTime;
                }
                if (updateCollectedStyle) {
                    collectedStyles[prop] = { startTime: startTime, endTime: endTime };
                }
                if (context.options) {
                    validateStyleParams(tuple[prop], context.options, context.errors);
                }
            });
        });
    };
    AnimationAstBuilderVisitor.prototype.visitKeyframes = function (metadata, context) {
        var _this = this;
        var ast = { type: 5 /* Keyframes */, styles: [], options: null };
        if (!context.currentAnimateTimings) {
            context.errors.push("keyframes() must be placed inside of a call to animate()");
            return ast;
        }
        var MAX_KEYFRAME_OFFSET = 1;
        var totalKeyframesWithOffsets = 0;
        var offsets = [];
        var offsetsOutOfOrder = false;
        var keyframesOutOfRange = false;
        var previousOffset = 0;
        var keyframes = metadata.steps.map(function (styles) {
            var style$$1 = _this._makeStyleAst(styles, context);
            var offsetVal = style$$1.offset != null ? style$$1.offset : consumeOffset(style$$1.styles);
            var offset = 0;
            if (offsetVal != null) {
                totalKeyframesWithOffsets++;
                offset = style$$1.offset = offsetVal;
            }
            keyframesOutOfRange = keyframesOutOfRange || offset < 0 || offset > 1;
            offsetsOutOfOrder = offsetsOutOfOrder || offset < previousOffset;
            previousOffset = offset;
            offsets.push(offset);
            return style$$1;
        });
        if (keyframesOutOfRange) {
            context.errors.push("Please ensure that all keyframe offsets are between 0 and 1");
        }
        if (offsetsOutOfOrder) {
            context.errors.push("Please ensure that all keyframe offsets are in order");
        }
        var length = metadata.steps.length;
        var generatedOffset = 0;
        if (totalKeyframesWithOffsets > 0 && totalKeyframesWithOffsets < length) {
            context.errors.push("Not all style() steps within the declared keyframes() contain offsets");
        }
        else if (totalKeyframesWithOffsets == 0) {
            generatedOffset = MAX_KEYFRAME_OFFSET / (length - 1);
        }
        var limit = length - 1;
        var currentTime = context.currentTime;
        var currentAnimateTimings = context.currentAnimateTimings;
        var animateDuration = currentAnimateTimings.duration;
        keyframes.forEach(function (kf, i) {
            var offset = generatedOffset > 0 ? (i == limit ? 1 : (generatedOffset * i)) : offsets[i];
            var durationUpToThisFrame = offset * animateDuration;
            context.currentTime = currentTime + currentAnimateTimings.delay + durationUpToThisFrame;
            currentAnimateTimings.duration = durationUpToThisFrame;
            _this._validateStyleAst(kf, context);
            kf.offset = offset;
            ast.styles.push(kf);
        });
        return ast;
    };
    AnimationAstBuilderVisitor.prototype.visitReference = function (metadata, context) {
        return {
            type: 8 /* Reference */,
            animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context),
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitAnimateChild = function (metadata, context) {
        context.depCount++;
        return {
            type: 9 /* AnimateChild */,
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitAnimateRef = function (metadata, context) {
        return {
            type: 10 /* AnimateRef */,
            animation: this.visitReference(metadata.animation, context),
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitQuery = function (metadata, context) {
        var parentSelector = context.currentQuerySelector;
        var options = (metadata.options || {});
        context.queryCount++;
        context.currentQuery = metadata;
        var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(normalizeSelector(metadata.selector), 2), selector = _a[0], includeSelf = _a[1];
        context.currentQuerySelector =
            parentSelector.length ? (parentSelector + ' ' + selector) : selector;
        getOrSetAsInMap(context.collectedStyles, context.currentQuerySelector, {});
        var animation = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
        context.currentQuery = null;
        context.currentQuerySelector = parentSelector;
        return {
            type: 11 /* Query */,
            selector: selector,
            limit: options.limit || 0,
            optional: !!options.optional, includeSelf: includeSelf, animation: animation,
            originalSelector: metadata.selector,
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitStagger = function (metadata, context) {
        if (!context.currentQuery) {
            context.errors.push("stagger() can only be used inside of query()");
        }
        var timings = metadata.timings === 'full' ?
            { duration: 0, delay: 0, easing: 'full' } :
            resolveTiming(metadata.timings, context.errors, true);
        return {
            type: 12 /* Stagger */,
            animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context), timings: timings,
            options: null
        };
    };
    return AnimationAstBuilderVisitor;
}());
function normalizeSelector(selector) {
    var hasAmpersand = selector.split(/\s*,\s*/).find(function (token) { return token == SELF_TOKEN; }) ? true : false;
    if (hasAmpersand) {
        selector = selector.replace(SELF_TOKEN_REGEX, '');
    }
    // the :enter and :leave selectors are filled in at runtime during timeline building
    selector = selector.replace(/@\*/g, NG_TRIGGER_SELECTOR)
        .replace(/@\w+/g, function (match) { return NG_TRIGGER_SELECTOR + '-' + match.substr(1); })
        .replace(/:animating/g, NG_ANIMATING_SELECTOR);
    return [selector, hasAmpersand];
}
function normalizeParams(obj) {
    return obj ? copyObj(obj) : null;
}
var AnimationAstBuilderContext = /** @class */ (function () {
    function AnimationAstBuilderContext(errors) {
        this.errors = errors;
        this.queryCount = 0;
        this.depCount = 0;
        this.currentTransition = null;
        this.currentQuery = null;
        this.currentQuerySelector = null;
        this.currentAnimateTimings = null;
        this.currentTime = 0;
        this.collectedStyles = {};
        this.options = null;
    }
    return AnimationAstBuilderContext;
}());
function consumeOffset(styles) {
    if (typeof styles == 'string')
        return null;
    var offset = null;
    if (Array.isArray(styles)) {
        styles.forEach(function (styleTuple) {
            if (isObject(styleTuple) && styleTuple.hasOwnProperty('offset')) {
                var obj = styleTuple;
                offset = parseFloat(obj['offset']);
                delete obj['offset'];
            }
        });
    }
    else if (isObject(styles) && styles.hasOwnProperty('offset')) {
        var obj = styles;
        offset = parseFloat(obj['offset']);
        delete obj['offset'];
    }
    return offset;
}
function isObject(value) {
    return !Array.isArray(value) && typeof value == 'object';
}
function constructTimingAst(value, errors) {
    var timings = null;
    if (value.hasOwnProperty('duration')) {
        timings = value;
    }
    else if (typeof value == 'number') {
        var duration = resolveTiming(value, errors).duration;
        return makeTimingAst(duration, 0, '');
    }
    var strValue = value;
    var isDynamic = strValue.split(/\s+/).some(function (v) { return v.charAt(0) == '{' && v.charAt(1) == '{'; });
    if (isDynamic) {
        var ast = makeTimingAst(0, 0, '');
        ast.dynamic = true;
        ast.strValue = strValue;
        return ast;
    }
    timings = timings || resolveTiming(strValue, errors);
    return makeTimingAst(timings.duration, timings.delay, timings.easing);
}
function normalizeAnimationOptions(options) {
    if (options) {
        options = copyObj(options);
        if (options['params']) {
            options['params'] = normalizeParams(options['params']);
        }
    }
    else {
        options = {};
    }
    return options;
}
function makeTimingAst(duration, delay, easing) {
    return { duration: duration, delay: delay, easing: easing };
}

function createTimelineInstruction(element, keyframes, preStyleProps, postStyleProps, duration, delay, easing, subTimeline) {
    if (easing === void 0) { easing = null; }
    if (subTimeline === void 0) { subTimeline = false; }
    return {
        type: 1 /* TimelineAnimation */,
        element: element,
        keyframes: keyframes,
        preStyleProps: preStyleProps,
        postStyleProps: postStyleProps,
        duration: duration,
        delay: delay,
        totalTime: duration + delay, easing: easing, subTimeline: subTimeline
    };
}

var ElementInstructionMap = /** @class */ (function () {
    function ElementInstructionMap() {
        this._map = new Map();
    }
    ElementInstructionMap.prototype.consume = function (element) {
        var instructions = this._map.get(element);
        if (instructions) {
            this._map.delete(element);
        }
        else {
            instructions = [];
        }
        return instructions;
    };
    ElementInstructionMap.prototype.append = function (element, instructions) {
        var existingInstructions = this._map.get(element);
        if (!existingInstructions) {
            this._map.set(element, existingInstructions = []);
        }
        existingInstructions.push.apply(existingInstructions, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(instructions));
    };
    ElementInstructionMap.prototype.has = function (element) { return this._map.has(element); };
    ElementInstructionMap.prototype.clear = function () { this._map.clear(); };
    return ElementInstructionMap;
}());

var ONE_FRAME_IN_MILLISECONDS = 1;
var ENTER_TOKEN = ':enter';
var ENTER_TOKEN_REGEX = new RegExp(ENTER_TOKEN, 'g');
var LEAVE_TOKEN = ':leave';
var LEAVE_TOKEN_REGEX = new RegExp(LEAVE_TOKEN, 'g');
/*
 * The code within this file aims to generate web-animations-compatible keyframes from Angular's
 * animation DSL code.
 *
 * The code below will be converted from:
 *
 * ```
 * sequence([
 *   style({ opacity: 0 }),
 *   animate(1000, style({ opacity: 0 }))
 * ])
 * ```
 *
 * To:
 * ```
 * keyframes = [{ opacity: 0, offset: 0 }, { opacity: 1, offset: 1 }]
 * duration = 1000
 * delay = 0
 * easing = ''
 * ```
 *
 * For this operation to cover the combination of animation verbs (style, animate, group, etc...) a
 * combination of prototypical inheritance, AST traversal and merge-sort-like algorithms are used.
 *
 * [AST Traversal]
 * Each of the animation verbs, when executed, will return an string-map object representing what
 * type of action it is (style, animate, group, etc...) and the data associated with it. This means
 * that when functional composition mix of these functions is evaluated (like in the example above)
 * then it will end up producing a tree of objects representing the animation itself.
 *
 * When this animation object tree is processed by the visitor code below it will visit each of the
 * verb statements within the visitor. And during each visit it will build the context of the
 * animation keyframes by interacting with the `TimelineBuilder`.
 *
 * [TimelineBuilder]
 * This class is responsible for tracking the styles and building a series of keyframe objects for a
 * timeline between a start and end time. The builder starts off with an initial timeline and each
 * time the AST comes across a `group()`, `keyframes()` or a combination of the two wihtin a
 * `sequence()` then it will generate a sub timeline for each step as well as a new one after
 * they are complete.
 *
 * As the AST is traversed, the timing state on each of the timelines will be incremented. If a sub
 * timeline was created (based on one of the cases above) then the parent timeline will attempt to
 * merge the styles used within the sub timelines into itself (only with group() this will happen).
 * This happens with a merge operation (much like how the merge works in mergesort) and it will only
 * copy the most recently used styles from the sub timelines into the parent timeline. This ensures
 * that if the styles are used later on in another phase of the animation then they will be the most
 * up-to-date values.
 *
 * [How Missing Styles Are Updated]
 * Each timeline has a `backFill` property which is responsible for filling in new styles into
 * already processed keyframes if a new style shows up later within the animation sequence.
 *
 * ```
 * sequence([
 *   style({ width: 0 }),
 *   animate(1000, style({ width: 100 })),
 *   animate(1000, style({ width: 200 })),
 *   animate(1000, style({ width: 300 }))
 *   animate(1000, style({ width: 400, height: 400 })) // notice how `height` doesn't exist anywhere
 * else
 * ])
 * ```
 *
 * What is happening here is that the `height` value is added later in the sequence, but is missing
 * from all previous animation steps. Therefore when a keyframe is created it would also be missing
 * from all previous keyframes up until where it is first used. For the timeline keyframe generation
 * to properly fill in the style it will place the previous value (the value from the parent
 * timeline) or a default value of `*` into the backFill object. Given that each of the keyframe
 * styles are objects that prototypically inhert from the backFill object, this means that if a
 * value is added into the backFill then it will automatically propagate any missing values to all
 * keyframes. Therefore the missing `height` value will be properly filled into the already
 * processed keyframes.
 *
 * When a sub-timeline is created it will have its own backFill property. This is done so that
 * styles present within the sub-timeline do not accidentally seep into the previous/future timeline
 * keyframes
 *
 * (For prototypically-inherited contents to be detected a `for(i in obj)` loop must be used.)
 *
 * [Validation]
 * The code in this file is not responsible for validation. That functionality happens with within
 * the `AnimationValidatorVisitor` code.
 */
function buildAnimationTimelines(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
    if (startingStyles === void 0) { startingStyles = {}; }
    if (finalStyles === void 0) { finalStyles = {}; }
    if (errors === void 0) { errors = []; }
    return new AnimationTimelineBuilderVisitor().buildKeyframes(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors);
}
var AnimationTimelineBuilderVisitor = /** @class */ (function () {
    function AnimationTimelineBuilderVisitor() {
    }
    AnimationTimelineBuilderVisitor.prototype.buildKeyframes = function (driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
        if (errors === void 0) { errors = []; }
        subInstructions = subInstructions || new ElementInstructionMap();
        var context = new AnimationTimelineContext(driver, rootElement, subInstructions, enterClassName, leaveClassName, errors, []);
        context.options = options;
        context.currentTimeline.setStyles([startingStyles], null, context.errors, options);
        visitDslNode(this, ast, context);
        // this checks to see if an actual animation happened
        var timelines = context.timelines.filter(function (timeline) { return timeline.containsAnimation(); });
        if (timelines.length && Object.keys(finalStyles).length) {
            var tl = timelines[timelines.length - 1];
            if (!tl.allowOnlyTimelineStyles()) {
                tl.setStyles([finalStyles], null, context.errors, options);
            }
        }
        return timelines.length ? timelines.map(function (timeline) { return timeline.buildKeyframes(); }) :
            [createTimelineInstruction(rootElement, [], [], [], 0, 0, '', false)];
    };
    AnimationTimelineBuilderVisitor.prototype.visitTrigger = function (ast, context) {
        // these values are not visited in this AST
    };
    AnimationTimelineBuilderVisitor.prototype.visitState = function (ast, context) {
        // these values are not visited in this AST
    };
    AnimationTimelineBuilderVisitor.prototype.visitTransition = function (ast, context) {
        // these values are not visited in this AST
    };
    AnimationTimelineBuilderVisitor.prototype.visitAnimateChild = function (ast, context) {
        var elementInstructions = context.subInstructions.consume(context.element);
        if (elementInstructions) {
            var innerContext = context.createSubContext(ast.options);
            var startTime = context.currentTimeline.currentTime;
            var endTime = this._visitSubInstructions(elementInstructions, innerContext, innerContext.options);
            if (startTime != endTime) {
                // we do this on the upper context because we created a sub context for
                // the sub child animations
                context.transformIntoNewTimeline(endTime);
            }
        }
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitAnimateRef = function (ast, context) {
        var innerContext = context.createSubContext(ast.options);
        innerContext.transformIntoNewTimeline();
        this.visitReference(ast.animation, innerContext);
        context.transformIntoNewTimeline(innerContext.currentTimeline.currentTime);
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype._visitSubInstructions = function (instructions, context, options) {
        var startTime = context.currentTimeline.currentTime;
        var furthestTime = startTime;
        // this is a special-case for when a user wants to skip a sub
        // animation from being fired entirely.
        var duration = options.duration != null ? resolveTimingValue(options.duration) : null;
        var delay = options.delay != null ? resolveTimingValue(options.delay) : null;
        if (duration !== 0) {
            instructions.forEach(function (instruction) {
                var instructionTimings = context.appendInstructionToTimeline(instruction, duration, delay);
                furthestTime =
                    Math.max(furthestTime, instructionTimings.duration + instructionTimings.delay);
            });
        }
        return furthestTime;
    };
    AnimationTimelineBuilderVisitor.prototype.visitReference = function (ast, context) {
        context.updateOptions(ast.options, true);
        visitDslNode(this, ast.animation, context);
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitSequence = function (ast, context) {
        var _this = this;
        var subContextCount = context.subContextCount;
        var ctx = context;
        var options = ast.options;
        if (options && (options.params || options.delay)) {
            ctx = context.createSubContext(options);
            ctx.transformIntoNewTimeline();
            if (options.delay != null) {
                if (ctx.previousNode.type == 6 /* Style */) {
                    ctx.currentTimeline.snapshotCurrentStyles();
                    ctx.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
                }
                var delay = resolveTimingValue(options.delay);
                ctx.delayNextStep(delay);
            }
        }
        if (ast.steps.length) {
            ast.steps.forEach(function (s) { return visitDslNode(_this, s, ctx); });
            // this is here just incase the inner steps only contain or end with a style() call
            ctx.currentTimeline.applyStylesToKeyframe();
            // this means that some animation function within the sequence
            // ended up creating a sub timeline (which means the current
            // timeline cannot overlap with the contents of the sequence)
            if (ctx.subContextCount > subContextCount) {
                ctx.transformIntoNewTimeline();
            }
        }
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitGroup = function (ast, context) {
        var _this = this;
        var innerTimelines = [];
        var furthestTime = context.currentTimeline.currentTime;
        var delay = ast.options && ast.options.delay ? resolveTimingValue(ast.options.delay) : 0;
        ast.steps.forEach(function (s) {
            var innerContext = context.createSubContext(ast.options);
            if (delay) {
                innerContext.delayNextStep(delay);
            }
            visitDslNode(_this, s, innerContext);
            furthestTime = Math.max(furthestTime, innerContext.currentTimeline.currentTime);
            innerTimelines.push(innerContext.currentTimeline);
        });
        // this operation is run after the AST loop because otherwise
        // if the parent timeline's collected styles were updated then
        // it would pass in invalid data into the new-to-be forked items
        innerTimelines.forEach(function (timeline) { return context.currentTimeline.mergeTimelineCollectedStyles(timeline); });
        context.transformIntoNewTimeline(furthestTime);
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype._visitTiming = function (ast, context) {
        if (ast.dynamic) {
            var strValue = ast.strValue;
            var timingValue = context.params ? interpolateParams(strValue, context.params, context.errors) : strValue;
            return resolveTiming(timingValue, context.errors);
        }
        else {
            return { duration: ast.duration, delay: ast.delay, easing: ast.easing };
        }
    };
    AnimationTimelineBuilderVisitor.prototype.visitAnimate = function (ast, context) {
        var timings = context.currentAnimateTimings = this._visitTiming(ast.timings, context);
        var timeline = context.currentTimeline;
        if (timings.delay) {
            context.incrementTime(timings.delay);
            timeline.snapshotCurrentStyles();
        }
        var style$$1 = ast.style;
        if (style$$1.type == 5 /* Keyframes */) {
            this.visitKeyframes(style$$1, context);
        }
        else {
            context.incrementTime(timings.duration);
            this.visitStyle(style$$1, context);
            timeline.applyStylesToKeyframe();
        }
        context.currentAnimateTimings = null;
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitStyle = function (ast, context) {
        var timeline = context.currentTimeline;
        var timings = context.currentAnimateTimings;
        // this is a special case for when a style() call
        // directly follows  an animate() call (but not inside of an animate() call)
        if (!timings && timeline.getCurrentStyleProperties().length) {
            timeline.forwardFrame();
        }
        var easing = (timings && timings.easing) || ast.easing;
        if (ast.isEmptyStep) {
            timeline.applyEmptyStep(easing);
        }
        else {
            timeline.setStyles(ast.styles, easing, context.errors, context.options);
        }
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitKeyframes = function (ast, context) {
        var currentAnimateTimings = context.currentAnimateTimings;
        var startTime = (context.currentTimeline).duration;
        var duration = currentAnimateTimings.duration;
        var innerContext = context.createSubContext();
        var innerTimeline = innerContext.currentTimeline;
        innerTimeline.easing = currentAnimateTimings.easing;
        ast.styles.forEach(function (step) {
            var offset = step.offset || 0;
            innerTimeline.forwardTime(offset * duration);
            innerTimeline.setStyles(step.styles, step.easing, context.errors, context.options);
            innerTimeline.applyStylesToKeyframe();
        });
        // this will ensure that the parent timeline gets all the styles from
        // the child even if the new timeline below is not used
        context.currentTimeline.mergeTimelineCollectedStyles(innerTimeline);
        // we do this because the window between this timeline and the sub timeline
        // should ensure that the styles within are exactly the same as they were before
        context.transformIntoNewTimeline(startTime + duration);
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitQuery = function (ast, context) {
        var _this = this;
        // in the event that the first step before this is a style step we need
        // to ensure the styles are applied before the children are animated
        var startTime = context.currentTimeline.currentTime;
        var options = (ast.options || {});
        var delay = options.delay ? resolveTimingValue(options.delay) : 0;
        if (delay && (context.previousNode.type === 6 /* Style */ ||
            (startTime == 0 && context.currentTimeline.getCurrentStyleProperties().length))) {
            context.currentTimeline.snapshotCurrentStyles();
            context.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        }
        var furthestTime = startTime;
        var elms = context.invokeQuery(ast.selector, ast.originalSelector, ast.limit, ast.includeSelf, options.optional ? true : false, context.errors);
        context.currentQueryTotal = elms.length;
        var sameElementTimeline = null;
        elms.forEach(function (element, i) {
            context.currentQueryIndex = i;
            var innerContext = context.createSubContext(ast.options, element);
            if (delay) {
                innerContext.delayNextStep(delay);
            }
            if (element === context.element) {
                sameElementTimeline = innerContext.currentTimeline;
            }
            visitDslNode(_this, ast.animation, innerContext);
            // this is here just incase the inner steps only contain or end
            // with a style() call (which is here to signal that this is a preparatory
            // call to style an element before it is animated again)
            innerContext.currentTimeline.applyStylesToKeyframe();
            var endTime = innerContext.currentTimeline.currentTime;
            furthestTime = Math.max(furthestTime, endTime);
        });
        context.currentQueryIndex = 0;
        context.currentQueryTotal = 0;
        context.transformIntoNewTimeline(furthestTime);
        if (sameElementTimeline) {
            context.currentTimeline.mergeTimelineCollectedStyles(sameElementTimeline);
            context.currentTimeline.snapshotCurrentStyles();
        }
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitStagger = function (ast, context) {
        var parentContext = context.parentContext;
        var tl = context.currentTimeline;
        var timings = ast.timings;
        var duration = Math.abs(timings.duration);
        var maxTime = duration * (context.currentQueryTotal - 1);
        var delay = duration * context.currentQueryIndex;
        var staggerTransformer = timings.duration < 0 ? 'reverse' : timings.easing;
        switch (staggerTransformer) {
            case 'reverse':
                delay = maxTime - delay;
                break;
            case 'full':
                delay = parentContext.currentStaggerTime;
                break;
        }
        var timeline = context.currentTimeline;
        if (delay) {
            timeline.delayNextStep(delay);
        }
        var startingTime = timeline.currentTime;
        visitDslNode(this, ast.animation, context);
        context.previousNode = ast;
        // time = duration + delay
        // the reason why this computation is so complex is because
        // the inner timeline may either have a delay value or a stretched
        // keyframe depending on if a subtimeline is not used or is used.
        parentContext.currentStaggerTime =
            (tl.currentTime - startingTime) + (tl.startTime - parentContext.currentTimeline.startTime);
    };
    return AnimationTimelineBuilderVisitor;
}());
var DEFAULT_NOOP_PREVIOUS_NODE = {};
var AnimationTimelineContext = /** @class */ (function () {
    function AnimationTimelineContext(_driver, element, subInstructions, _enterClassName, _leaveClassName, errors, timelines, initialTimeline) {
        this._driver = _driver;
        this.element = element;
        this.subInstructions = subInstructions;
        this._enterClassName = _enterClassName;
        this._leaveClassName = _leaveClassName;
        this.errors = errors;
        this.timelines = timelines;
        this.parentContext = null;
        this.currentAnimateTimings = null;
        this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        this.subContextCount = 0;
        this.options = {};
        this.currentQueryIndex = 0;
        this.currentQueryTotal = 0;
        this.currentStaggerTime = 0;
        this.currentTimeline = initialTimeline || new TimelineBuilder(this._driver, element, 0);
        timelines.push(this.currentTimeline);
    }
    Object.defineProperty(AnimationTimelineContext.prototype, "params", {
        get: function () { return this.options.params; },
        enumerable: true,
        configurable: true
    });
    AnimationTimelineContext.prototype.updateOptions = function (options, skipIfExists) {
        var _this = this;
        if (!options)
            return;
        var newOptions = options;
        var optionsToUpdate = this.options;
        // NOTE: this will get patched up when other animation methods support duration overrides
        if (newOptions.duration != null) {
            optionsToUpdate.duration = resolveTimingValue(newOptions.duration);
        }
        if (newOptions.delay != null) {
            optionsToUpdate.delay = resolveTimingValue(newOptions.delay);
        }
        var newParams = newOptions.params;
        if (newParams) {
            var paramsToUpdate_1 = optionsToUpdate.params;
            if (!paramsToUpdate_1) {
                paramsToUpdate_1 = this.options.params = {};
            }
            Object.keys(newParams).forEach(function (name) {
                if (!skipIfExists || !paramsToUpdate_1.hasOwnProperty(name)) {
                    paramsToUpdate_1[name] = interpolateParams(newParams[name], paramsToUpdate_1, _this.errors);
                }
            });
        }
    };
    AnimationTimelineContext.prototype._copyOptions = function () {
        var options = {};
        if (this.options) {
            var oldParams_1 = this.options.params;
            if (oldParams_1) {
                var params_1 = options['params'] = {};
                Object.keys(oldParams_1).forEach(function (name) { params_1[name] = oldParams_1[name]; });
            }
        }
        return options;
    };
    AnimationTimelineContext.prototype.createSubContext = function (options, element, newTime) {
        if (options === void 0) { options = null; }
        var target = element || this.element;
        var context = new AnimationTimelineContext(this._driver, target, this.subInstructions, this._enterClassName, this._leaveClassName, this.errors, this.timelines, this.currentTimeline.fork(target, newTime || 0));
        context.previousNode = this.previousNode;
        context.currentAnimateTimings = this.currentAnimateTimings;
        context.options = this._copyOptions();
        context.updateOptions(options);
        context.currentQueryIndex = this.currentQueryIndex;
        context.currentQueryTotal = this.currentQueryTotal;
        context.parentContext = this;
        this.subContextCount++;
        return context;
    };
    AnimationTimelineContext.prototype.transformIntoNewTimeline = function (newTime) {
        this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        this.currentTimeline = this.currentTimeline.fork(this.element, newTime);
        this.timelines.push(this.currentTimeline);
        return this.currentTimeline;
    };
    AnimationTimelineContext.prototype.appendInstructionToTimeline = function (instruction, duration, delay) {
        var updatedTimings = {
            duration: duration != null ? duration : instruction.duration,
            delay: this.currentTimeline.currentTime + (delay != null ? delay : 0) + instruction.delay,
            easing: ''
        };
        var builder = new SubTimelineBuilder(this._driver, instruction.element, instruction.keyframes, instruction.preStyleProps, instruction.postStyleProps, updatedTimings, instruction.stretchStartingKeyframe);
        this.timelines.push(builder);
        return updatedTimings;
    };
    AnimationTimelineContext.prototype.incrementTime = function (time) {
        this.currentTimeline.forwardTime(this.currentTimeline.duration + time);
    };
    AnimationTimelineContext.prototype.delayNextStep = function (delay) {
        // negative delays are not yet supported
        if (delay > 0) {
            this.currentTimeline.delayNextStep(delay);
        }
    };
    AnimationTimelineContext.prototype.invokeQuery = function (selector, originalSelector, limit, includeSelf, optional, errors) {
        var results = [];
        if (includeSelf) {
            results.push(this.element);
        }
        if (selector.length > 0) { // if :self is only used then the selector is empty
            selector = selector.replace(ENTER_TOKEN_REGEX, '.' + this._enterClassName);
            selector = selector.replace(LEAVE_TOKEN_REGEX, '.' + this._leaveClassName);
            var multi = limit != 1;
            var elements = this._driver.query(this.element, selector, multi);
            if (limit !== 0) {
                elements = limit < 0 ? elements.slice(elements.length + limit, elements.length) :
                    elements.slice(0, limit);
            }
            results.push.apply(results, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(elements));
        }
        if (!optional && results.length == 0) {
            errors.push("`query(\"" + originalSelector + "\")` returned zero elements. (Use `query(\"" + originalSelector + "\", { optional: true })` if you wish to allow this.)");
        }
        return results;
    };
    return AnimationTimelineContext;
}());
var TimelineBuilder = /** @class */ (function () {
    function TimelineBuilder(_driver, element, startTime, _elementTimelineStylesLookup) {
        this._driver = _driver;
        this.element = element;
        this.startTime = startTime;
        this._elementTimelineStylesLookup = _elementTimelineStylesLookup;
        this.duration = 0;
        this._previousKeyframe = {};
        this._currentKeyframe = {};
        this._keyframes = new Map();
        this._styleSummary = {};
        this._pendingStyles = {};
        this._backFill = {};
        this._currentEmptyStepKeyframe = null;
        if (!this._elementTimelineStylesLookup) {
            this._elementTimelineStylesLookup = new Map();
        }
        this._localTimelineStyles = Object.create(this._backFill, {});
        this._globalTimelineStyles = this._elementTimelineStylesLookup.get(element);
        if (!this._globalTimelineStyles) {
            this._globalTimelineStyles = this._localTimelineStyles;
            this._elementTimelineStylesLookup.set(element, this._localTimelineStyles);
        }
        this._loadKeyframe();
    }
    TimelineBuilder.prototype.containsAnimation = function () {
        switch (this._keyframes.size) {
            case 0:
                return false;
            case 1:
                return this.getCurrentStyleProperties().length > 0;
            default:
                return true;
        }
    };
    TimelineBuilder.prototype.getCurrentStyleProperties = function () { return Object.keys(this._currentKeyframe); };
    Object.defineProperty(TimelineBuilder.prototype, "currentTime", {
        get: function () { return this.startTime + this.duration; },
        enumerable: true,
        configurable: true
    });
    TimelineBuilder.prototype.delayNextStep = function (delay) {
        // in the event that a style() step is placed right before a stagger()
        // and that style() step is the very first style() value in the animation
        // then we need to make a copy of the keyframe [0, copy, 1] so that the delay
        // properly applies the style() values to work with the stagger...
        var hasPreStyleStep = this._keyframes.size == 1 && Object.keys(this._pendingStyles).length;
        if (this.duration || hasPreStyleStep) {
            this.forwardTime(this.currentTime + delay);
            if (hasPreStyleStep) {
                this.snapshotCurrentStyles();
            }
        }
        else {
            this.startTime += delay;
        }
    };
    TimelineBuilder.prototype.fork = function (element, currentTime) {
        this.applyStylesToKeyframe();
        return new TimelineBuilder(this._driver, element, currentTime || this.currentTime, this._elementTimelineStylesLookup);
    };
    TimelineBuilder.prototype._loadKeyframe = function () {
        if (this._currentKeyframe) {
            this._previousKeyframe = this._currentKeyframe;
        }
        this._currentKeyframe = this._keyframes.get(this.duration);
        if (!this._currentKeyframe) {
            this._currentKeyframe = Object.create(this._backFill, {});
            this._keyframes.set(this.duration, this._currentKeyframe);
        }
    };
    TimelineBuilder.prototype.forwardFrame = function () {
        this.duration += ONE_FRAME_IN_MILLISECONDS;
        this._loadKeyframe();
    };
    TimelineBuilder.prototype.forwardTime = function (time) {
        this.applyStylesToKeyframe();
        this.duration = time;
        this._loadKeyframe();
    };
    TimelineBuilder.prototype._updateStyle = function (prop, value) {
        this._localTimelineStyles[prop] = value;
        this._globalTimelineStyles[prop] = value;
        this._styleSummary[prop] = { time: this.currentTime, value: value };
    };
    TimelineBuilder.prototype.allowOnlyTimelineStyles = function () { return this._currentEmptyStepKeyframe !== this._currentKeyframe; };
    TimelineBuilder.prototype.applyEmptyStep = function (easing) {
        var _this = this;
        if (easing) {
            this._previousKeyframe['easing'] = easing;
        }
        // special case for animate(duration):
        // all missing styles are filled with a `*` value then
        // if any destination styles are filled in later on the same
        // keyframe then they will override the overridden styles
        // We use `_globalTimelineStyles` here because there may be
        // styles in previous keyframes that are not present in this timeline
        Object.keys(this._globalTimelineStyles).forEach(function (prop) {
            _this._backFill[prop] = _this._globalTimelineStyles[prop] || __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"];
            _this._currentKeyframe[prop] = __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"];
        });
        this._currentEmptyStepKeyframe = this._currentKeyframe;
    };
    TimelineBuilder.prototype.setStyles = function (input, easing, errors, options) {
        var _this = this;
        if (easing) {
            this._previousKeyframe['easing'] = easing;
        }
        var params = (options && options.params) || {};
        var styles = flattenStyles(input, this._globalTimelineStyles);
        Object.keys(styles).forEach(function (prop) {
            var val = interpolateParams(styles[prop], params, errors);
            _this._pendingStyles[prop] = val;
            if (!_this._localTimelineStyles.hasOwnProperty(prop)) {
                _this._backFill[prop] = _this._globalTimelineStyles.hasOwnProperty(prop) ?
                    _this._globalTimelineStyles[prop] :
                    __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"];
            }
            _this._updateStyle(prop, val);
        });
    };
    TimelineBuilder.prototype.applyStylesToKeyframe = function () {
        var _this = this;
        var styles = this._pendingStyles;
        var props = Object.keys(styles);
        if (props.length == 0)
            return;
        this._pendingStyles = {};
        props.forEach(function (prop) {
            var val = styles[prop];
            _this._currentKeyframe[prop] = val;
        });
        Object.keys(this._localTimelineStyles).forEach(function (prop) {
            if (!_this._currentKeyframe.hasOwnProperty(prop)) {
                _this._currentKeyframe[prop] = _this._localTimelineStyles[prop];
            }
        });
    };
    TimelineBuilder.prototype.snapshotCurrentStyles = function () {
        var _this = this;
        Object.keys(this._localTimelineStyles).forEach(function (prop) {
            var val = _this._localTimelineStyles[prop];
            _this._pendingStyles[prop] = val;
            _this._updateStyle(prop, val);
        });
    };
    TimelineBuilder.prototype.getFinalKeyframe = function () { return this._keyframes.get(this.duration); };
    Object.defineProperty(TimelineBuilder.prototype, "properties", {
        get: function () {
            var properties = [];
            for (var prop in this._currentKeyframe) {
                properties.push(prop);
            }
            return properties;
        },
        enumerable: true,
        configurable: true
    });
    TimelineBuilder.prototype.mergeTimelineCollectedStyles = function (timeline) {
        var _this = this;
        Object.keys(timeline._styleSummary).forEach(function (prop) {
            var details0 = _this._styleSummary[prop];
            var details1 = timeline._styleSummary[prop];
            if (!details0 || details1.time > details0.time) {
                _this._updateStyle(prop, details1.value);
            }
        });
    };
    TimelineBuilder.prototype.buildKeyframes = function () {
        var _this = this;
        this.applyStylesToKeyframe();
        var preStyleProps = new Set();
        var postStyleProps = new Set();
        var isEmpty = this._keyframes.size === 1 && this.duration === 0;
        var finalKeyframes = [];
        this._keyframes.forEach(function (keyframe, time) {
            var finalKeyframe = copyStyles(keyframe, true);
            Object.keys(finalKeyframe).forEach(function (prop) {
                var value = finalKeyframe[prop];
                if (value == __WEBPACK_IMPORTED_MODULE_1__angular_animations__["ɵPRE_STYLE"]) {
                    preStyleProps.add(prop);
                }
                else if (value == __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"]) {
                    postStyleProps.add(prop);
                }
            });
            if (!isEmpty) {
                finalKeyframe['offset'] = time / _this.duration;
            }
            finalKeyframes.push(finalKeyframe);
        });
        var preProps = preStyleProps.size ? iteratorToArray(preStyleProps.values()) : [];
        var postProps = postStyleProps.size ? iteratorToArray(postStyleProps.values()) : [];
        // special case for a 0-second animation (which is designed just to place styles onscreen)
        if (isEmpty) {
            var kf0 = finalKeyframes[0];
            var kf1 = copyObj(kf0);
            kf0['offset'] = 0;
            kf1['offset'] = 1;
            finalKeyframes = [kf0, kf1];
        }
        return createTimelineInstruction(this.element, finalKeyframes, preProps, postProps, this.duration, this.startTime, this.easing, false);
    };
    return TimelineBuilder;
}());
var SubTimelineBuilder = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(SubTimelineBuilder, _super);
    function SubTimelineBuilder(driver, element, keyframes, preStyleProps, postStyleProps, timings, _stretchStartingKeyframe) {
        if (_stretchStartingKeyframe === void 0) { _stretchStartingKeyframe = false; }
        var _this = _super.call(this, driver, element, timings.delay) || this;
        _this.element = element;
        _this.keyframes = keyframes;
        _this.preStyleProps = preStyleProps;
        _this.postStyleProps = postStyleProps;
        _this._stretchStartingKeyframe = _stretchStartingKeyframe;
        _this.timings = { duration: timings.duration, delay: timings.delay, easing: timings.easing };
        return _this;
    }
    SubTimelineBuilder.prototype.containsAnimation = function () { return this.keyframes.length > 1; };
    SubTimelineBuilder.prototype.buildKeyframes = function () {
        var keyframes = this.keyframes;
        var _a = this.timings, delay = _a.delay, duration = _a.duration, easing = _a.easing;
        if (this._stretchStartingKeyframe && delay) {
            var newKeyframes = [];
            var totalTime = duration + delay;
            var startingGap = delay / totalTime;
            // the original starting keyframe now starts once the delay is done
            var newFirstKeyframe = copyStyles(keyframes[0], false);
            newFirstKeyframe['offset'] = 0;
            newKeyframes.push(newFirstKeyframe);
            var oldFirstKeyframe = copyStyles(keyframes[0], false);
            oldFirstKeyframe['offset'] = roundOffset(startingGap);
            newKeyframes.push(oldFirstKeyframe);
            /*
              When the keyframe is stretched then it means that the delay before the animation
              starts is gone. Instead the first keyframe is placed at the start of the animation
              and it is then copied to where it starts when the original delay is over. This basically
              means nothing animates during that delay, but the styles are still renderered. For this
              to work the original offset values that exist in the original keyframes must be "warped"
              so that they can take the new keyframe + delay into account.
      
              delay=1000, duration=1000, keyframes = 0 .5 1
      
              turns into
      
              delay=0, duration=2000, keyframes = 0 .33 .66 1
             */
            // offsets between 1 ... n -1 are all warped by the keyframe stretch
            var limit = keyframes.length - 1;
            for (var i = 1; i <= limit; i++) {
                var kf = copyStyles(keyframes[i], false);
                var oldOffset = kf['offset'];
                var timeAtKeyframe = delay + oldOffset * duration;
                kf['offset'] = roundOffset(timeAtKeyframe / totalTime);
                newKeyframes.push(kf);
            }
            // the new starting keyframe should be added at the start
            duration = totalTime;
            delay = 0;
            easing = '';
            keyframes = newKeyframes;
        }
        return createTimelineInstruction(this.element, keyframes, this.preStyleProps, this.postStyleProps, duration, delay, easing, true);
    };
    return SubTimelineBuilder;
}(TimelineBuilder));
function roundOffset(offset, decimalPoints) {
    if (decimalPoints === void 0) { decimalPoints = 3; }
    var mult = Math.pow(10, decimalPoints - 1);
    return Math.round(offset * mult) / mult;
}
function flattenStyles(input, allStyles) {
    var styles = {};
    var allProperties;
    input.forEach(function (token) {
        if (token === '*') {
            allProperties = allProperties || Object.keys(allStyles);
            allProperties.forEach(function (prop) { styles[prop] = __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"]; });
        }
        else {
            copyStyles(token, false, styles);
        }
    });
    return styles;
}

var Animation = /** @class */ (function () {
    function Animation(_driver, input) {
        this._driver = _driver;
        var errors = [];
        var ast = buildAnimationAst(_driver, input, errors);
        if (errors.length) {
            var errorMessage = "animation validation failed:\n" + errors.join("\n");
            throw new Error(errorMessage);
        }
        this._animationAst = ast;
    }
    Animation.prototype.buildTimelines = function (element, startingStyles, destinationStyles, options, subInstructions) {
        var start = Array.isArray(startingStyles) ? normalizeStyles(startingStyles) :
            startingStyles;
        var dest = Array.isArray(destinationStyles) ? normalizeStyles(destinationStyles) :
            destinationStyles;
        var errors = [];
        subInstructions = subInstructions || new ElementInstructionMap();
        var result = buildAnimationTimelines(this._driver, element, this._animationAst, ENTER_CLASSNAME, LEAVE_CLASSNAME, start, dest, options, subInstructions, errors);
        if (errors.length) {
            var errorMessage = "animation building failed:\n" + errors.join("\n");
            throw new Error(errorMessage);
        }
        return result;
    };
    return Animation;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @experimental Animation support is experimental.
 */
var AnimationStyleNormalizer = /** @class */ (function () {
    function AnimationStyleNormalizer() {
    }
    return AnimationStyleNormalizer;
}());
/**
 * @experimental Animation support is experimental.
 */
var NoopAnimationStyleNormalizer = /** @class */ (function () {
    function NoopAnimationStyleNormalizer() {
    }
    NoopAnimationStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) { return propertyName; };
    NoopAnimationStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
        return value;
    };
    return NoopAnimationStyleNormalizer;
}());

var WebAnimationsStyleNormalizer = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(WebAnimationsStyleNormalizer, _super);
    function WebAnimationsStyleNormalizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebAnimationsStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) {
        return dashCaseToCamelCase(propertyName);
    };
    WebAnimationsStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
        var unit = '';
        var strVal = value.toString().trim();
        if (DIMENSIONAL_PROP_MAP[normalizedProperty] && value !== 0 && value !== '0') {
            if (typeof value === 'number') {
                unit = 'px';
            }
            else {
                var valAndSuffixMatch = value.match(/^[+-]?[\d\.]+([a-z]*)$/);
                if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
                    errors.push("Please provide a CSS unit value for " + userProvidedProperty + ":" + value);
                }
            }
        }
        return strVal + unit;
    };
    return WebAnimationsStyleNormalizer;
}(AnimationStyleNormalizer));
var DIMENSIONAL_PROP_MAP = makeBooleanMap('width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent,perspective'
    .split(','));
function makeBooleanMap(keys) {
    var map = {};
    keys.forEach(function (key) { return map[key] = true; });
    return map;
}

function createTransitionInstruction(element, triggerName, fromState, toState, isRemovalTransition, fromStyles, toStyles, timelines, queriedElements, preStyleProps, postStyleProps, totalTime, errors) {
    return {
        type: 0 /* TransitionAnimation */,
        element: element,
        triggerName: triggerName,
        isRemovalTransition: isRemovalTransition,
        fromState: fromState,
        fromStyles: fromStyles,
        toState: toState,
        toStyles: toStyles,
        timelines: timelines,
        queriedElements: queriedElements,
        preStyleProps: preStyleProps,
        postStyleProps: postStyleProps,
        totalTime: totalTime,
        errors: errors
    };
}

var EMPTY_OBJECT = {};
var AnimationTransitionFactory = /** @class */ (function () {
    function AnimationTransitionFactory(_triggerName, ast, _stateStyles) {
        this._triggerName = _triggerName;
        this.ast = ast;
        this._stateStyles = _stateStyles;
    }
    AnimationTransitionFactory.prototype.match = function (currentState, nextState, element, params) {
        return oneOrMoreTransitionsMatch(this.ast.matchers, currentState, nextState, element, params);
    };
    AnimationTransitionFactory.prototype.buildStyles = function (stateName, params, errors) {
        var backupStateStyler = this._stateStyles['*'];
        var stateStyler = this._stateStyles[stateName];
        var backupStyles = backupStateStyler ? backupStateStyler.buildStyles(params, errors) : {};
        return stateStyler ? stateStyler.buildStyles(params, errors) : backupStyles;
    };
    AnimationTransitionFactory.prototype.build = function (driver, element, currentState, nextState, enterClassName, leaveClassName, currentOptions, nextOptions, subInstructions, skipAstBuild) {
        var errors = [];
        var transitionAnimationParams = this.ast.options && this.ast.options.params || EMPTY_OBJECT;
        var currentAnimationParams = currentOptions && currentOptions.params || EMPTY_OBJECT;
        var currentStateStyles = this.buildStyles(currentState, currentAnimationParams, errors);
        var nextAnimationParams = nextOptions && nextOptions.params || EMPTY_OBJECT;
        var nextStateStyles = this.buildStyles(nextState, nextAnimationParams, errors);
        var queriedElements = new Set();
        var preStyleMap = new Map();
        var postStyleMap = new Map();
        var isRemoval = nextState === 'void';
        var animationOptions = { params: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, transitionAnimationParams, nextAnimationParams) };
        var timelines = skipAstBuild ? [] : buildAnimationTimelines(driver, element, this.ast.animation, enterClassName, leaveClassName, currentStateStyles, nextStateStyles, animationOptions, subInstructions, errors);
        var totalTime = 0;
        timelines.forEach(function (tl) { totalTime = Math.max(tl.duration + tl.delay, totalTime); });
        if (errors.length) {
            return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, [], [], preStyleMap, postStyleMap, totalTime, errors);
        }
        timelines.forEach(function (tl) {
            var elm = tl.element;
            var preProps = getOrSetAsInMap(preStyleMap, elm, {});
            tl.preStyleProps.forEach(function (prop) { return preProps[prop] = true; });
            var postProps = getOrSetAsInMap(postStyleMap, elm, {});
            tl.postStyleProps.forEach(function (prop) { return postProps[prop] = true; });
            if (elm !== element) {
                queriedElements.add(elm);
            }
        });
        var queriedElementsList = iteratorToArray(queriedElements.values());
        return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, timelines, queriedElementsList, preStyleMap, postStyleMap, totalTime);
    };
    return AnimationTransitionFactory;
}());
function oneOrMoreTransitionsMatch(matchFns, currentState, nextState, element, params) {
    return matchFns.some(function (fn) { return fn(currentState, nextState, element, params); });
}
var AnimationStateStyles = /** @class */ (function () {
    function AnimationStateStyles(styles, defaultParams) {
        this.styles = styles;
        this.defaultParams = defaultParams;
    }
    AnimationStateStyles.prototype.buildStyles = function (params, errors) {
        var finalStyles = {};
        var combinedParams = copyObj(this.defaultParams);
        Object.keys(params).forEach(function (key) {
            var value = params[key];
            if (value != null) {
                combinedParams[key] = value;
            }
        });
        this.styles.styles.forEach(function (value) {
            if (typeof value !== 'string') {
                var styleObj_1 = value;
                Object.keys(styleObj_1).forEach(function (prop) {
                    var val = styleObj_1[prop];
                    if (val.length > 1) {
                        val = interpolateParams(val, combinedParams, errors);
                    }
                    finalStyles[prop] = val;
                });
            }
        });
        return finalStyles;
    };
    return AnimationStateStyles;
}());

/**
 * @experimental Animation support is experimental.
 */
function buildTrigger(name, ast) {
    return new AnimationTrigger(name, ast);
}
/**
* @experimental Animation support is experimental.
*/
var AnimationTrigger = /** @class */ (function () {
    function AnimationTrigger(name, ast) {
        var _this = this;
        this.name = name;
        this.ast = ast;
        this.transitionFactories = [];
        this.states = {};
        ast.states.forEach(function (ast) {
            var defaultParams = (ast.options && ast.options.params) || {};
            _this.states[ast.name] = new AnimationStateStyles(ast.style, defaultParams);
        });
        balanceProperties(this.states, 'true', '1');
        balanceProperties(this.states, 'false', '0');
        ast.transitions.forEach(function (ast) {
            _this.transitionFactories.push(new AnimationTransitionFactory(name, ast, _this.states));
        });
        this.fallbackTransition = createFallbackTransition(name, this.states);
    }
    Object.defineProperty(AnimationTrigger.prototype, "containsQueries", {
        get: function () { return this.ast.queryCount > 0; },
        enumerable: true,
        configurable: true
    });
    AnimationTrigger.prototype.matchTransition = function (currentState, nextState, element, params) {
        var entry = this.transitionFactories.find(function (f) { return f.match(currentState, nextState, element, params); });
        return entry || null;
    };
    AnimationTrigger.prototype.matchStyles = function (currentState, params, errors) {
        return this.fallbackTransition.buildStyles(currentState, params, errors);
    };
    return AnimationTrigger;
}());
function createFallbackTransition(triggerName, states) {
    var matchers = [function (fromState, toState) { return true; }];
    var animation = { type: 2 /* Sequence */, steps: [], options: null };
    var transition = {
        type: 1 /* Transition */,
        animation: animation,
        matchers: matchers,
        options: null,
        queryCount: 0,
        depCount: 0
    };
    return new AnimationTransitionFactory(triggerName, transition, states);
}
function balanceProperties(obj, key1, key2) {
    if (obj.hasOwnProperty(key1)) {
        if (!obj.hasOwnProperty(key2)) {
            obj[key2] = obj[key1];
        }
    }
    else if (obj.hasOwnProperty(key2)) {
        obj[key1] = obj[key2];
    }
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EMPTY_INSTRUCTION_MAP = new ElementInstructionMap();
var TimelineAnimationEngine = /** @class */ (function () {
    function TimelineAnimationEngine(bodyNode, _driver, _normalizer) {
        this.bodyNode = bodyNode;
        this._driver = _driver;
        this._normalizer = _normalizer;
        this._animations = {};
        this._playersById = {};
        this.players = [];
    }
    TimelineAnimationEngine.prototype.register = function (id, metadata) {
        var errors = [];
        var ast = buildAnimationAst(this._driver, metadata, errors);
        if (errors.length) {
            throw new Error("Unable to build the animation due to the following errors: " + errors.join("\n"));
        }
        else {
            this._animations[id] = ast;
        }
    };
    TimelineAnimationEngine.prototype._buildPlayer = function (i, preStyles, postStyles) {
        var element = i.element;
        var keyframes = normalizeKeyframes(this._driver, this._normalizer, element, i.keyframes, preStyles, postStyles);
        return this._driver.animate(element, keyframes, i.duration, i.delay, i.easing, [], true);
    };
    TimelineAnimationEngine.prototype.create = function (id, element, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var errors = [];
        var ast = this._animations[id];
        var instructions;
        var autoStylesMap = new Map();
        if (ast) {
            instructions = buildAnimationTimelines(this._driver, element, ast, ENTER_CLASSNAME, LEAVE_CLASSNAME, {}, {}, options, EMPTY_INSTRUCTION_MAP, errors);
            instructions.forEach(function (inst) {
                var styles = getOrSetAsInMap(autoStylesMap, inst.element, {});
                inst.postStyleProps.forEach(function (prop) { return styles[prop] = null; });
            });
        }
        else {
            errors.push('The requested animation doesn\'t exist or has already been destroyed');
            instructions = [];
        }
        if (errors.length) {
            throw new Error("Unable to create the animation due to the following errors: " + errors.join("\n"));
        }
        autoStylesMap.forEach(function (styles, element) {
            Object.keys(styles).forEach(function (prop) { styles[prop] = _this._driver.computeStyle(element, prop, __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"]); });
        });
        var players = instructions.map(function (i) {
            var styles = autoStylesMap.get(i.element);
            return _this._buildPlayer(i, {}, styles);
        });
        var player = optimizeGroupPlayer(players);
        this._playersById[id] = player;
        player.onDestroy(function () { return _this.destroy(id); });
        this.players.push(player);
        return player;
    };
    TimelineAnimationEngine.prototype.destroy = function (id) {
        var player = this._getPlayer(id);
        player.destroy();
        delete this._playersById[id];
        var index = this.players.indexOf(player);
        if (index >= 0) {
            this.players.splice(index, 1);
        }
    };
    TimelineAnimationEngine.prototype._getPlayer = function (id) {
        var player = this._playersById[id];
        if (!player) {
            throw new Error("Unable to find the timeline player referenced by " + id);
        }
        return player;
    };
    TimelineAnimationEngine.prototype.listen = function (id, element, eventName, callback) {
        // triggerName, fromState, toState are all ignored for timeline animations
        var baseEvent = makeAnimationEvent(element, '', '', '');
        listenOnPlayer(this._getPlayer(id), eventName, baseEvent, callback);
        return function () { };
    };
    TimelineAnimationEngine.prototype.command = function (id, element, command, args) {
        if (command == 'register') {
            this.register(id, args[0]);
            return;
        }
        if (command == 'create') {
            var options = (args[0] || {});
            this.create(id, element, options);
            return;
        }
        var player = this._getPlayer(id);
        switch (command) {
            case 'play':
                player.play();
                break;
            case 'pause':
                player.pause();
                break;
            case 'reset':
                player.reset();
                break;
            case 'restart':
                player.restart();
                break;
            case 'finish':
                player.finish();
                break;
            case 'init':
                player.init();
                break;
            case 'setPosition':
                player.setPosition(parseFloat(args[0]));
                break;
            case 'destroy':
                this.destroy(id);
                break;
        }
    };
    return TimelineAnimationEngine;
}());

var QUEUED_CLASSNAME = 'ng-animate-queued';
var QUEUED_SELECTOR = '.ng-animate-queued';
var DISABLED_CLASSNAME = 'ng-animate-disabled';
var DISABLED_SELECTOR = '.ng-animate-disabled';
var STAR_CLASSNAME = 'ng-star-inserted';
var STAR_SELECTOR = '.ng-star-inserted';
var EMPTY_PLAYER_ARRAY = [];
var NULL_REMOVAL_STATE = {
    namespaceId: '',
    setForRemoval: false,
    setForMove: false,
    hasAnimation: false,
    removedBeforeQueried: false
};
var NULL_REMOVED_QUERIED_STATE = {
    namespaceId: '',
    setForMove: false,
    setForRemoval: false,
    hasAnimation: false,
    removedBeforeQueried: true
};
var REMOVAL_FLAG = '__ng_removed';
var StateValue = /** @class */ (function () {
    function StateValue(input, namespaceId) {
        if (namespaceId === void 0) { namespaceId = ''; }
        this.namespaceId = namespaceId;
        var isObj = input && input.hasOwnProperty('value');
        var value = isObj ? input['value'] : input;
        this.value = normalizeTriggerValue(value);
        if (isObj) {
            var options = copyObj(input);
            delete options['value'];
            this.options = options;
        }
        else {
            this.options = {};
        }
        if (!this.options.params) {
            this.options.params = {};
        }
    }
    Object.defineProperty(StateValue.prototype, "params", {
        get: function () { return this.options.params; },
        enumerable: true,
        configurable: true
    });
    StateValue.prototype.absorbOptions = function (options) {
        var newParams = options.params;
        if (newParams) {
            var oldParams_1 = this.options.params;
            Object.keys(newParams).forEach(function (prop) {
                if (oldParams_1[prop] == null) {
                    oldParams_1[prop] = newParams[prop];
                }
            });
        }
    };
    return StateValue;
}());
var VOID_VALUE = 'void';
var DEFAULT_STATE_VALUE = new StateValue(VOID_VALUE);
var AnimationTransitionNamespace = /** @class */ (function () {
    function AnimationTransitionNamespace(id, hostElement, _engine) {
        this.id = id;
        this.hostElement = hostElement;
        this._engine = _engine;
        this.players = [];
        this._triggers = {};
        this._queue = [];
        this._elementListeners = new Map();
        this._hostClassName = 'ng-tns-' + id;
        addClass(hostElement, this._hostClassName);
    }
    AnimationTransitionNamespace.prototype.listen = function (element, name, phase, callback) {
        var _this = this;
        if (!this._triggers.hasOwnProperty(name)) {
            throw new Error("Unable to listen on the animation trigger event \"" + phase + "\" because the animation trigger \"" + name + "\" doesn't exist!");
        }
        if (phase == null || phase.length == 0) {
            throw new Error("Unable to listen on the animation trigger \"" + name + "\" because the provided event is undefined!");
        }
        if (!isTriggerEventValid(phase)) {
            throw new Error("The provided animation trigger event \"" + phase + "\" for the animation trigger \"" + name + "\" is not supported!");
        }
        var listeners = getOrSetAsInMap(this._elementListeners, element, []);
        var data = { name: name, phase: phase, callback: callback };
        listeners.push(data);
        var triggersWithStates = getOrSetAsInMap(this._engine.statesByElement, element, {});
        if (!triggersWithStates.hasOwnProperty(name)) {
            addClass(element, NG_TRIGGER_CLASSNAME);
            addClass(element, NG_TRIGGER_CLASSNAME + '-' + name);
            triggersWithStates[name] = DEFAULT_STATE_VALUE;
        }
        return function () {
            // the event listener is removed AFTER the flush has occurred such
            // that leave animations callbacks can fire (otherwise if the node
            // is removed in between then the listeners would be deregistered)
            _this._engine.afterFlush(function () {
                var index = listeners.indexOf(data);
                if (index >= 0) {
                    listeners.splice(index, 1);
                }
                if (!_this._triggers[name]) {
                    delete triggersWithStates[name];
                }
            });
        };
    };
    AnimationTransitionNamespace.prototype.register = function (name, ast) {
        if (this._triggers[name]) {
            // throw
            return false;
        }
        else {
            this._triggers[name] = ast;
            return true;
        }
    };
    AnimationTransitionNamespace.prototype._getTrigger = function (name) {
        var trigger = this._triggers[name];
        if (!trigger) {
            throw new Error("The provided animation trigger \"" + name + "\" has not been registered!");
        }
        return trigger;
    };
    AnimationTransitionNamespace.prototype.trigger = function (element, triggerName, value, defaultToFallback) {
        var _this = this;
        if (defaultToFallback === void 0) { defaultToFallback = true; }
        var trigger = this._getTrigger(triggerName);
        var player = new TransitionAnimationPlayer(this.id, triggerName, element);
        var triggersWithStates = this._engine.statesByElement.get(element);
        if (!triggersWithStates) {
            addClass(element, NG_TRIGGER_CLASSNAME);
            addClass(element, NG_TRIGGER_CLASSNAME + '-' + triggerName);
            this._engine.statesByElement.set(element, triggersWithStates = {});
        }
        var fromState = triggersWithStates[triggerName];
        var toState = new StateValue(value, this.id);
        var isObj = value && value.hasOwnProperty('value');
        if (!isObj && fromState) {
            toState.absorbOptions(fromState.options);
        }
        triggersWithStates[triggerName] = toState;
        if (!fromState) {
            fromState = DEFAULT_STATE_VALUE;
        }
        var isRemoval = toState.value === VOID_VALUE;
        // normally this isn't reached by here, however, if an object expression
        // is passed in then it may be a new object each time. Comparing the value
        // is important since that will stay the same despite there being a new object.
        // The removal arc here is special cased because the same element is triggered
        // twice in the event that it contains animations on the outer/inner portions
        // of the host container
        if (!isRemoval && fromState.value === toState.value) {
            // this means that despite the value not changing, some inner params
            // have changed which means that the animation final styles need to be applied
            if (!objEquals(fromState.params, toState.params)) {
                var errors = [];
                var fromStyles_1 = trigger.matchStyles(fromState.value, fromState.params, errors);
                var toStyles_1 = trigger.matchStyles(toState.value, toState.params, errors);
                if (errors.length) {
                    this._engine.reportError(errors);
                }
                else {
                    this._engine.afterFlush(function () {
                        eraseStyles(element, fromStyles_1);
                        setStyles(element, toStyles_1);
                    });
                }
            }
            return;
        }
        var playersOnElement = getOrSetAsInMap(this._engine.playersByElement, element, []);
        playersOnElement.forEach(function (player) {
            // only remove the player if it is queued on the EXACT same trigger/namespace
            // we only also deal with queued players here because if the animation has
            // started then we want to keep the player alive until the flush happens
            // (which is where the previousPlayers are passed into the new palyer)
            if (player.namespaceId == _this.id && player.triggerName == triggerName && player.queued) {
                player.destroy();
            }
        });
        var transition = trigger.matchTransition(fromState.value, toState.value, element, toState.params);
        var isFallbackTransition = false;
        if (!transition) {
            if (!defaultToFallback)
                return;
            transition = trigger.fallbackTransition;
            isFallbackTransition = true;
        }
        this._engine.totalQueuedPlayers++;
        this._queue.push({ element: element, triggerName: triggerName, transition: transition, fromState: fromState, toState: toState, player: player, isFallbackTransition: isFallbackTransition });
        if (!isFallbackTransition) {
            addClass(element, QUEUED_CLASSNAME);
            player.onStart(function () { removeClass(element, QUEUED_CLASSNAME); });
        }
        player.onDone(function () {
            var index = _this.players.indexOf(player);
            if (index >= 0) {
                _this.players.splice(index, 1);
            }
            var players = _this._engine.playersByElement.get(element);
            if (players) {
                var index_1 = players.indexOf(player);
                if (index_1 >= 0) {
                    players.splice(index_1, 1);
                }
            }
        });
        this.players.push(player);
        playersOnElement.push(player);
        return player;
    };
    AnimationTransitionNamespace.prototype.deregister = function (name) {
        var _this = this;
        delete this._triggers[name];
        this._engine.statesByElement.forEach(function (stateMap, element) { delete stateMap[name]; });
        this._elementListeners.forEach(function (listeners, element) {
            _this._elementListeners.set(element, listeners.filter(function (entry) { return entry.name != name; }));
        });
    };
    AnimationTransitionNamespace.prototype.clearElementCache = function (element) {
        this._engine.statesByElement.delete(element);
        this._elementListeners.delete(element);
        var elementPlayers = this._engine.playersByElement.get(element);
        if (elementPlayers) {
            elementPlayers.forEach(function (player) { return player.destroy(); });
            this._engine.playersByElement.delete(element);
        }
    };
    AnimationTransitionNamespace.prototype._signalRemovalForInnerTriggers = function (rootElement, context, animate) {
        var _this = this;
        if (animate === void 0) { animate = false; }
        // emulate a leave animation for all inner nodes within this node.
        // If there are no animations found for any of the nodes then clear the cache
        // for the element.
        this._engine.driver.query(rootElement, NG_TRIGGER_SELECTOR, true).forEach(function (elm) {
            // this means that an inner remove() operation has already kicked off
            // the animation on this element...
            if (elm[REMOVAL_FLAG])
                return;
            var namespaces = _this._engine.fetchNamespacesByElement(elm);
            if (namespaces.size) {
                namespaces.forEach(function (ns) { return ns.triggerLeaveAnimation(elm, context, false, true); });
            }
            else {
                _this.clearElementCache(elm);
            }
        });
    };
    AnimationTransitionNamespace.prototype.triggerLeaveAnimation = function (element, context, destroyAfterComplete, defaultToFallback) {
        var _this = this;
        var triggerStates = this._engine.statesByElement.get(element);
        if (triggerStates) {
            var players_1 = [];
            Object.keys(triggerStates).forEach(function (triggerName) {
                // this check is here in the event that an element is removed
                // twice (both on the host level and the component level)
                if (_this._triggers[triggerName]) {
                    var player = _this.trigger(element, triggerName, VOID_VALUE, defaultToFallback);
                    if (player) {
                        players_1.push(player);
                    }
                }
            });
            if (players_1.length) {
                this._engine.markElementAsRemoved(this.id, element, true, context);
                if (destroyAfterComplete) {
                    optimizeGroupPlayer(players_1).onDone(function () { return _this._engine.processLeaveNode(element); });
                }
                return true;
            }
        }
        return false;
    };
    AnimationTransitionNamespace.prototype.prepareLeaveAnimationListeners = function (element) {
        var _this = this;
        var listeners = this._elementListeners.get(element);
        if (listeners) {
            var visitedTriggers_1 = new Set();
            listeners.forEach(function (listener) {
                var triggerName = listener.name;
                if (visitedTriggers_1.has(triggerName))
                    return;
                visitedTriggers_1.add(triggerName);
                var trigger = _this._triggers[triggerName];
                var transition = trigger.fallbackTransition;
                var elementStates = _this._engine.statesByElement.get(element);
                var fromState = elementStates[triggerName] || DEFAULT_STATE_VALUE;
                var toState = new StateValue(VOID_VALUE);
                var player = new TransitionAnimationPlayer(_this.id, triggerName, element);
                _this._engine.totalQueuedPlayers++;
                _this._queue.push({
                    element: element,
                    triggerName: triggerName,
                    transition: transition,
                    fromState: fromState,
                    toState: toState,
                    player: player,
                    isFallbackTransition: true
                });
            });
        }
    };
    AnimationTransitionNamespace.prototype.removeNode = function (element, context) {
        var _this = this;
        var engine = this._engine;
        if (element.childElementCount) {
            this._signalRemovalForInnerTriggers(element, context, true);
        }
        // this means that a * => VOID animation was detected and kicked off
        if (this.triggerLeaveAnimation(element, context, true))
            return;
        // find the player that is animating and make sure that the
        // removal is delayed until that player has completed
        var containsPotentialParentTransition = false;
        if (engine.totalAnimations) {
            var currentPlayers = engine.players.length ? engine.playersByQueriedElement.get(element) : [];
            // when this `if statement` does not continue forward it means that
            // a previous animation query has selected the current element and
            // is animating it. In this situation want to continue forwards and
            // allow the element to be queued up for animation later.
            if (currentPlayers && currentPlayers.length) {
                containsPotentialParentTransition = true;
            }
            else {
                var parent_1 = element;
                while (parent_1 = parent_1.parentNode) {
                    var triggers = engine.statesByElement.get(parent_1);
                    if (triggers) {
                        containsPotentialParentTransition = true;
                        break;
                    }
                }
            }
        }
        // at this stage we know that the element will either get removed
        // during flush or will be picked up by a parent query. Either way
        // we need to fire the listeners for this element when it DOES get
        // removed (once the query parent animation is done or after flush)
        this.prepareLeaveAnimationListeners(element);
        // whether or not a parent has an animation we need to delay the deferral of the leave
        // operation until we have more information (which we do after flush() has been called)
        if (containsPotentialParentTransition) {
            engine.markElementAsRemoved(this.id, element, false, context);
        }
        else {
            // we do this after the flush has occurred such
            // that the callbacks can be fired
            engine.afterFlush(function () { return _this.clearElementCache(element); });
            engine.destroyInnerAnimations(element);
            engine._onRemovalComplete(element, context);
        }
    };
    AnimationTransitionNamespace.prototype.insertNode = function (element, parent) { addClass(element, this._hostClassName); };
    AnimationTransitionNamespace.prototype.drainQueuedTransitions = function (microtaskId) {
        var _this = this;
        var instructions = [];
        this._queue.forEach(function (entry) {
            var player = entry.player;
            if (player.destroyed)
                return;
            var element = entry.element;
            var listeners = _this._elementListeners.get(element);
            if (listeners) {
                listeners.forEach(function (listener) {
                    if (listener.name == entry.triggerName) {
                        var baseEvent = makeAnimationEvent(element, entry.triggerName, entry.fromState.value, entry.toState.value);
                        baseEvent['_data'] = microtaskId;
                        listenOnPlayer(entry.player, listener.phase, baseEvent, listener.callback);
                    }
                });
            }
            if (player.markedForDestroy) {
                _this._engine.afterFlush(function () {
                    // now we can destroy the element properly since the event listeners have
                    // been bound to the player
                    player.destroy();
                });
            }
            else {
                instructions.push(entry);
            }
        });
        this._queue = [];
        return instructions.sort(function (a, b) {
            // if depCount == 0 them move to front
            // otherwise if a contains b then move back
            var d0 = a.transition.ast.depCount;
            var d1 = b.transition.ast.depCount;
            if (d0 == 0 || d1 == 0) {
                return d0 - d1;
            }
            return _this._engine.driver.containsElement(a.element, b.element) ? 1 : -1;
        });
    };
    AnimationTransitionNamespace.prototype.destroy = function (context) {
        this.players.forEach(function (p) { return p.destroy(); });
        this._signalRemovalForInnerTriggers(this.hostElement, context);
    };
    AnimationTransitionNamespace.prototype.elementContainsData = function (element) {
        var containsData = false;
        if (this._elementListeners.has(element))
            containsData = true;
        containsData =
            (this._queue.find(function (entry) { return entry.element === element; }) ? true : false) || containsData;
        return containsData;
    };
    return AnimationTransitionNamespace;
}());
var TransitionAnimationEngine = /** @class */ (function () {
    function TransitionAnimationEngine(bodyNode, driver, _normalizer) {
        this.bodyNode = bodyNode;
        this.driver = driver;
        this._normalizer = _normalizer;
        this.players = [];
        this.newHostElements = new Map();
        this.playersByElement = new Map();
        this.playersByQueriedElement = new Map();
        this.statesByElement = new Map();
        this.disabledNodes = new Set();
        this.totalAnimations = 0;
        this.totalQueuedPlayers = 0;
        this._namespaceLookup = {};
        this._namespaceList = [];
        this._flushFns = [];
        this._whenQuietFns = [];
        this.namespacesByHostElement = new Map();
        this.collectedEnterElements = [];
        this.collectedLeaveElements = [];
        // this method is designed to be overridden by the code that uses this engine
        this.onRemovalComplete = function (element, context) { };
    }
    /** @internal */
    TransitionAnimationEngine.prototype._onRemovalComplete = function (element, context) { this.onRemovalComplete(element, context); };
    Object.defineProperty(TransitionAnimationEngine.prototype, "queuedPlayers", {
        get: function () {
            var players = [];
            this._namespaceList.forEach(function (ns) {
                ns.players.forEach(function (player) {
                    if (player.queued) {
                        players.push(player);
                    }
                });
            });
            return players;
        },
        enumerable: true,
        configurable: true
    });
    TransitionAnimationEngine.prototype.createNamespace = function (namespaceId, hostElement) {
        var ns = new AnimationTransitionNamespace(namespaceId, hostElement, this);
        if (hostElement.parentNode) {
            this._balanceNamespaceList(ns, hostElement);
        }
        else {
            // defer this later until flush during when the host element has
            // been inserted so that we know exactly where to place it in
            // the namespace list
            this.newHostElements.set(hostElement, ns);
            // given that this host element is apart of the animation code, it
            // may or may not be inserted by a parent node that is an of an
            // animation renderer type. If this happens then we can still have
            // access to this item when we query for :enter nodes. If the parent
            // is a renderer then the set data-structure will normalize the entry
            this.collectEnterElement(hostElement);
        }
        return this._namespaceLookup[namespaceId] = ns;
    };
    TransitionAnimationEngine.prototype._balanceNamespaceList = function (ns, hostElement) {
        var limit = this._namespaceList.length - 1;
        if (limit >= 0) {
            var found = false;
            for (var i = limit; i >= 0; i--) {
                var nextNamespace = this._namespaceList[i];
                if (this.driver.containsElement(nextNamespace.hostElement, hostElement)) {
                    this._namespaceList.splice(i + 1, 0, ns);
                    found = true;
                    break;
                }
            }
            if (!found) {
                this._namespaceList.splice(0, 0, ns);
            }
        }
        else {
            this._namespaceList.push(ns);
        }
        this.namespacesByHostElement.set(hostElement, ns);
        return ns;
    };
    TransitionAnimationEngine.prototype.register = function (namespaceId, hostElement) {
        var ns = this._namespaceLookup[namespaceId];
        if (!ns) {
            ns = this.createNamespace(namespaceId, hostElement);
        }
        return ns;
    };
    TransitionAnimationEngine.prototype.registerTrigger = function (namespaceId, name, trigger) {
        var ns = this._namespaceLookup[namespaceId];
        if (ns && ns.register(name, trigger)) {
            this.totalAnimations++;
        }
    };
    TransitionAnimationEngine.prototype.destroy = function (namespaceId, context) {
        var _this = this;
        if (!namespaceId)
            return;
        var ns = this._fetchNamespace(namespaceId);
        this.afterFlush(function () {
            _this.namespacesByHostElement.delete(ns.hostElement);
            delete _this._namespaceLookup[namespaceId];
            var index = _this._namespaceList.indexOf(ns);
            if (index >= 0) {
                _this._namespaceList.splice(index, 1);
            }
        });
        this.afterFlushAnimationsDone(function () { return ns.destroy(context); });
    };
    TransitionAnimationEngine.prototype._fetchNamespace = function (id) { return this._namespaceLookup[id]; };
    TransitionAnimationEngine.prototype.fetchNamespacesByElement = function (element) {
        // normally there should only be one namespace per element, however
        // if @triggers are placed on both the component element and then
        // its host element (within the component code) then there will be
        // two namespaces returned. We use a set here to simply the dedupe
        // of namespaces incase there are multiple triggers both the elm and host
        var namespaces = new Set();
        var elementStates = this.statesByElement.get(element);
        if (elementStates) {
            var keys = Object.keys(elementStates);
            for (var i = 0; i < keys.length; i++) {
                var nsId = elementStates[keys[i]].namespaceId;
                if (nsId) {
                    var ns = this._fetchNamespace(nsId);
                    if (ns) {
                        namespaces.add(ns);
                    }
                }
            }
        }
        return namespaces;
    };
    TransitionAnimationEngine.prototype.trigger = function (namespaceId, element, name, value) {
        if (isElementNode(element)) {
            var ns = this._fetchNamespace(namespaceId);
            if (ns) {
                ns.trigger(element, name, value);
                return true;
            }
        }
        return false;
    };
    TransitionAnimationEngine.prototype.insertNode = function (namespaceId, element, parent, insertBefore) {
        if (!isElementNode(element))
            return;
        // special case for when an element is removed and reinserted (move operation)
        // when this occurs we do not want to use the element for deletion later
        var details = element[REMOVAL_FLAG];
        if (details && details.setForRemoval) {
            details.setForRemoval = false;
            details.setForMove = true;
            var index = this.collectedLeaveElements.indexOf(element);
            if (index >= 0) {
                this.collectedLeaveElements.splice(index, 1);
            }
        }
        // in the event that the namespaceId is blank then the caller
        // code does not contain any animation code in it, but it is
        // just being called so that the node is marked as being inserted
        if (namespaceId) {
            var ns = this._fetchNamespace(namespaceId);
            // This if-statement is a workaround for router issue #21947.
            // The router sometimes hits a race condition where while a route
            // is being instantiated a new navigation arrives, triggering leave
            // animation of DOM that has not been fully initialized, until this
            // is resolved, we need to handle the scenario when DOM is not in a
            // consistent state during the animation.
            if (ns) {
                ns.insertNode(element, parent);
            }
        }
        // only *directives and host elements are inserted before
        if (insertBefore) {
            this.collectEnterElement(element);
        }
    };
    TransitionAnimationEngine.prototype.collectEnterElement = function (element) { this.collectedEnterElements.push(element); };
    TransitionAnimationEngine.prototype.markElementAsDisabled = function (element, value) {
        if (value) {
            if (!this.disabledNodes.has(element)) {
                this.disabledNodes.add(element);
                addClass(element, DISABLED_CLASSNAME);
            }
        }
        else if (this.disabledNodes.has(element)) {
            this.disabledNodes.delete(element);
            removeClass(element, DISABLED_CLASSNAME);
        }
    };
    TransitionAnimationEngine.prototype.removeNode = function (namespaceId, element, context) {
        if (!isElementNode(element)) {
            this._onRemovalComplete(element, context);
            return;
        }
        var ns = namespaceId ? this._fetchNamespace(namespaceId) : null;
        if (ns) {
            ns.removeNode(element, context);
        }
        else {
            this.markElementAsRemoved(namespaceId, element, false, context);
        }
    };
    TransitionAnimationEngine.prototype.markElementAsRemoved = function (namespaceId, element, hasAnimation, context) {
        this.collectedLeaveElements.push(element);
        element[REMOVAL_FLAG] = {
            namespaceId: namespaceId,
            setForRemoval: context, hasAnimation: hasAnimation,
            removedBeforeQueried: false
        };
    };
    TransitionAnimationEngine.prototype.listen = function (namespaceId, element, name, phase, callback) {
        if (isElementNode(element)) {
            return this._fetchNamespace(namespaceId).listen(element, name, phase, callback);
        }
        return function () { };
    };
    TransitionAnimationEngine.prototype._buildInstruction = function (entry, subTimelines, enterClassName, leaveClassName, skipBuildAst) {
        return entry.transition.build(this.driver, entry.element, entry.fromState.value, entry.toState.value, enterClassName, leaveClassName, entry.fromState.options, entry.toState.options, subTimelines, skipBuildAst);
    };
    TransitionAnimationEngine.prototype.destroyInnerAnimations = function (containerElement) {
        var _this = this;
        var elements = this.driver.query(containerElement, NG_TRIGGER_SELECTOR, true);
        elements.forEach(function (element) { return _this.destroyActiveAnimationsForElement(element); });
        if (this.playersByQueriedElement.size == 0)
            return;
        elements = this.driver.query(containerElement, NG_ANIMATING_SELECTOR, true);
        elements.forEach(function (element) { return _this.finishActiveQueriedAnimationOnElement(element); });
    };
    TransitionAnimationEngine.prototype.destroyActiveAnimationsForElement = function (element) {
        var players = this.playersByElement.get(element);
        if (players) {
            players.forEach(function (player) {
                // special case for when an element is set for destruction, but hasn't started.
                // in this situation we want to delay the destruction until the flush occurs
                // so that any event listeners attached to the player are triggered.
                if (player.queued) {
                    player.markedForDestroy = true;
                }
                else {
                    player.destroy();
                }
            });
        }
    };
    TransitionAnimationEngine.prototype.finishActiveQueriedAnimationOnElement = function (element) {
        var players = this.playersByQueriedElement.get(element);
        if (players) {
            players.forEach(function (player) { return player.finish(); });
        }
    };
    TransitionAnimationEngine.prototype.whenRenderingDone = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.players.length) {
                return optimizeGroupPlayer(_this.players).onDone(function () { return resolve(); });
            }
            else {
                resolve();
            }
        });
    };
    TransitionAnimationEngine.prototype.processLeaveNode = function (element) {
        var _this = this;
        var details = element[REMOVAL_FLAG];
        if (details && details.setForRemoval) {
            // this will prevent it from removing it twice
            element[REMOVAL_FLAG] = NULL_REMOVAL_STATE;
            if (details.namespaceId) {
                this.destroyInnerAnimations(element);
                var ns = this._fetchNamespace(details.namespaceId);
                if (ns) {
                    ns.clearElementCache(element);
                }
            }
            this._onRemovalComplete(element, details.setForRemoval);
        }
        if (this.driver.matchesElement(element, DISABLED_SELECTOR)) {
            this.markElementAsDisabled(element, false);
        }
        this.driver.query(element, DISABLED_SELECTOR, true).forEach(function (node) {
            _this.markElementAsDisabled(element, false);
        });
    };
    TransitionAnimationEngine.prototype.flush = function (microtaskId) {
        var _this = this;
        if (microtaskId === void 0) { microtaskId = -1; }
        var players = [];
        if (this.newHostElements.size) {
            this.newHostElements.forEach(function (ns, element) { return _this._balanceNamespaceList(ns, element); });
            this.newHostElements.clear();
        }
        if (this.totalAnimations && this.collectedEnterElements.length) {
            for (var i = 0; i < this.collectedEnterElements.length; i++) {
                var elm = this.collectedEnterElements[i];
                addClass(elm, STAR_CLASSNAME);
            }
        }
        if (this._namespaceList.length &&
            (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
            var cleanupFns = [];
            try {
                players = this._flushAnimations(cleanupFns, microtaskId);
            }
            finally {
                for (var i = 0; i < cleanupFns.length; i++) {
                    cleanupFns[i]();
                }
            }
        }
        else {
            for (var i = 0; i < this.collectedLeaveElements.length; i++) {
                var element = this.collectedLeaveElements[i];
                this.processLeaveNode(element);
            }
        }
        this.totalQueuedPlayers = 0;
        this.collectedEnterElements.length = 0;
        this.collectedLeaveElements.length = 0;
        this._flushFns.forEach(function (fn) { return fn(); });
        this._flushFns = [];
        if (this._whenQuietFns.length) {
            // we move these over to a variable so that
            // if any new callbacks are registered in another
            // flush they do not populate the existing set
            var quietFns_1 = this._whenQuietFns;
            this._whenQuietFns = [];
            if (players.length) {
                optimizeGroupPlayer(players).onDone(function () { quietFns_1.forEach(function (fn) { return fn(); }); });
            }
            else {
                quietFns_1.forEach(function (fn) { return fn(); });
            }
        }
    };
    TransitionAnimationEngine.prototype.reportError = function (errors) {
        throw new Error("Unable to process animations due to the following failed trigger transitions\n " + errors.join('\n'));
    };
    TransitionAnimationEngine.prototype._flushAnimations = function (cleanupFns, microtaskId) {
        var _this = this;
        var subTimelines = new ElementInstructionMap();
        var skippedPlayers = [];
        var skippedPlayersMap = new Map();
        var queuedInstructions = [];
        var queriedElements = new Map();
        var allPreStyleElements = new Map();
        var allPostStyleElements = new Map();
        var disabledElementsSet = new Set();
        this.disabledNodes.forEach(function (node) {
            disabledElementsSet.add(node);
            var nodesThatAreDisabled = _this.driver.query(node, QUEUED_SELECTOR, true);
            for (var i_1 = 0; i_1 < nodesThatAreDisabled.length; i_1++) {
                disabledElementsSet.add(nodesThatAreDisabled[i_1]);
            }
        });
        var bodyNode = this.bodyNode;
        var allTriggerElements = Array.from(this.statesByElement.keys());
        var enterNodeMap = buildRootMap(allTriggerElements, this.collectedEnterElements);
        // this must occur before the instructions are built below such that
        // the :enter queries match the elements (since the timeline queries
        // are fired during instruction building).
        var enterNodeMapIds = new Map();
        var i = 0;
        enterNodeMap.forEach(function (nodes, root) {
            var className = ENTER_CLASSNAME + i++;
            enterNodeMapIds.set(root, className);
            nodes.forEach(function (node) { return addClass(node, className); });
        });
        var allLeaveNodes = [];
        var mergedLeaveNodes = new Set();
        var leaveNodesWithoutAnimations = new Set();
        for (var i_2 = 0; i_2 < this.collectedLeaveElements.length; i_2++) {
            var element = this.collectedLeaveElements[i_2];
            var details = element[REMOVAL_FLAG];
            if (details && details.setForRemoval) {
                allLeaveNodes.push(element);
                mergedLeaveNodes.add(element);
                if (details.hasAnimation) {
                    this.driver.query(element, STAR_SELECTOR, true).forEach(function (elm) { return mergedLeaveNodes.add(elm); });
                }
                else {
                    leaveNodesWithoutAnimations.add(element);
                }
            }
        }
        var leaveNodeMapIds = new Map();
        var leaveNodeMap = buildRootMap(allTriggerElements, Array.from(mergedLeaveNodes));
        leaveNodeMap.forEach(function (nodes, root) {
            var className = LEAVE_CLASSNAME + i++;
            leaveNodeMapIds.set(root, className);
            nodes.forEach(function (node) { return addClass(node, className); });
        });
        cleanupFns.push(function () {
            enterNodeMap.forEach(function (nodes, root) {
                var className = enterNodeMapIds.get(root);
                nodes.forEach(function (node) { return removeClass(node, className); });
            });
            leaveNodeMap.forEach(function (nodes, root) {
                var className = leaveNodeMapIds.get(root);
                nodes.forEach(function (node) { return removeClass(node, className); });
            });
            allLeaveNodes.forEach(function (element) { _this.processLeaveNode(element); });
        });
        var allPlayers = [];
        var erroneousTransitions = [];
        for (var i_3 = this._namespaceList.length - 1; i_3 >= 0; i_3--) {
            var ns = this._namespaceList[i_3];
            ns.drainQueuedTransitions(microtaskId).forEach(function (entry) {
                var player = entry.player;
                var element = entry.element;
                allPlayers.push(player);
                if (_this.collectedEnterElements.length) {
                    var details = element[REMOVAL_FLAG];
                    // move animations are currently not supported...
                    if (details && details.setForMove) {
                        player.destroy();
                        return;
                    }
                }
                var nodeIsOrphaned = !bodyNode || !_this.driver.containsElement(bodyNode, element);
                var leaveClassName = leaveNodeMapIds.get(element);
                var enterClassName = enterNodeMapIds.get(element);
                var instruction = _this._buildInstruction(entry, subTimelines, enterClassName, leaveClassName, nodeIsOrphaned);
                if (instruction.errors && instruction.errors.length) {
                    erroneousTransitions.push(instruction);
                    return;
                }
                // even though the element may not be apart of the DOM, it may
                // still be added at a later point (due to the mechanics of content
                // projection and/or dynamic component insertion) therefore it's
                // important we still style the element.
                if (nodeIsOrphaned) {
                    player.onStart(function () { return eraseStyles(element, instruction.fromStyles); });
                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                    skippedPlayers.push(player);
                    return;
                }
                // if a unmatched transition is queued to go then it SHOULD NOT render
                // an animation and cancel the previously running animations.
                if (entry.isFallbackTransition) {
                    player.onStart(function () { return eraseStyles(element, instruction.fromStyles); });
                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                    skippedPlayers.push(player);
                    return;
                }
                // this means that if a parent animation uses this animation as a sub trigger
                // then it will instruct the timeline builder to not add a player delay, but
                // instead stretch the first keyframe gap up until the animation starts. The
                // reason this is important is to prevent extra initialization styles from being
                // required by the user in the animation.
                instruction.timelines.forEach(function (tl) { return tl.stretchStartingKeyframe = true; });
                subTimelines.append(element, instruction.timelines);
                var tuple = { instruction: instruction, player: player, element: element };
                queuedInstructions.push(tuple);
                instruction.queriedElements.forEach(function (element) { return getOrSetAsInMap(queriedElements, element, []).push(player); });
                instruction.preStyleProps.forEach(function (stringMap, element) {
                    var props = Object.keys(stringMap);
                    if (props.length) {
                        var setVal_1 = allPreStyleElements.get(element);
                        if (!setVal_1) {
                            allPreStyleElements.set(element, setVal_1 = new Set());
                        }
                        props.forEach(function (prop) { return setVal_1.add(prop); });
                    }
                });
                instruction.postStyleProps.forEach(function (stringMap, element) {
                    var props = Object.keys(stringMap);
                    var setVal = allPostStyleElements.get(element);
                    if (!setVal) {
                        allPostStyleElements.set(element, setVal = new Set());
                    }
                    props.forEach(function (prop) { return setVal.add(prop); });
                });
            });
        }
        if (erroneousTransitions.length) {
            var errors_1 = [];
            erroneousTransitions.forEach(function (instruction) {
                errors_1.push("@" + instruction.triggerName + " has failed due to:\n");
                instruction.errors.forEach(function (error) { return errors_1.push("- " + error + "\n"); });
            });
            allPlayers.forEach(function (player) { return player.destroy(); });
            this.reportError(errors_1);
        }
        var allPreviousPlayersMap = new Map();
        // this map works to tell which element in the DOM tree is contained by
        // which animation. Further down below this map will get populated once
        // the players are built and in doing so it can efficiently figure out
        // if a sub player is skipped due to a parent player having priority.
        var animationElementMap = new Map();
        queuedInstructions.forEach(function (entry) {
            var element = entry.element;
            if (subTimelines.has(element)) {
                animationElementMap.set(element, element);
                _this._beforeAnimationBuild(entry.player.namespaceId, entry.instruction, allPreviousPlayersMap);
            }
        });
        skippedPlayers.forEach(function (player) {
            var element = player.element;
            var previousPlayers = _this._getPreviousPlayers(element, false, player.namespaceId, player.triggerName, null);
            previousPlayers.forEach(function (prevPlayer) {
                getOrSetAsInMap(allPreviousPlayersMap, element, []).push(prevPlayer);
                prevPlayer.destroy();
            });
        });
        // this is a special case for nodes that will be removed (either by)
        // having their own leave animations or by being queried in a container
        // that will be removed once a parent animation is complete. The idea
        // here is that * styles must be identical to ! styles because of
        // backwards compatibility (* is also filled in by default in many places).
        // Otherwise * styles will return an empty value or auto since the element
        // that is being getComputedStyle'd will not be visible (since * = destination)
        var replaceNodes = allLeaveNodes.filter(function (node) {
            return replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements);
        });
        // POST STAGE: fill the * styles
        var postStylesMap = new Map();
        var allLeaveQueriedNodes = cloakAndComputeStyles(postStylesMap, this.driver, leaveNodesWithoutAnimations, allPostStyleElements, __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AUTO_STYLE"]);
        allLeaveQueriedNodes.forEach(function (node) {
            if (replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements)) {
                replaceNodes.push(node);
            }
        });
        // PRE STAGE: fill the ! styles
        var preStylesMap = new Map();
        enterNodeMap.forEach(function (nodes, root) {
            cloakAndComputeStyles(preStylesMap, _this.driver, new Set(nodes), allPreStyleElements, __WEBPACK_IMPORTED_MODULE_1__angular_animations__["ɵPRE_STYLE"]);
        });
        replaceNodes.forEach(function (node) {
            var post = postStylesMap.get(node);
            var pre = preStylesMap.get(node);
            postStylesMap.set(node, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, post, pre));
        });
        var rootPlayers = [];
        var subPlayers = [];
        var NO_PARENT_ANIMATION_ELEMENT_DETECTED = {};
        queuedInstructions.forEach(function (entry) {
            var element = entry.element, player = entry.player, instruction = entry.instruction;
            // this means that it was never consumed by a parent animation which
            // means that it is independent and therefore should be set for animation
            if (subTimelines.has(element)) {
                if (disabledElementsSet.has(element)) {
                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                    player.disabled = true;
                    player.overrideTotalTime(instruction.totalTime);
                    skippedPlayers.push(player);
                    return;
                }
                // this will flow up the DOM and query the map to figure out
                // if a parent animation has priority over it. In the situation
                // that a parent is detected then it will cancel the loop. If
                // nothing is detected, or it takes a few hops to find a parent,
                // then it will fill in the missing nodes and signal them as having
                // a detected parent (or a NO_PARENT value via a special constant).
                var parentWithAnimation_1 = NO_PARENT_ANIMATION_ELEMENT_DETECTED;
                if (animationElementMap.size > 1) {
                    var elm = element;
                    var parentsToAdd = [];
                    while (elm = elm.parentNode) {
                        var detectedParent = animationElementMap.get(elm);
                        if (detectedParent) {
                            parentWithAnimation_1 = detectedParent;
                            break;
                        }
                        parentsToAdd.push(elm);
                    }
                    parentsToAdd.forEach(function (parent) { return animationElementMap.set(parent, parentWithAnimation_1); });
                }
                var innerPlayer = _this._buildAnimation(player.namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap);
                player.setRealPlayer(innerPlayer);
                if (parentWithAnimation_1 === NO_PARENT_ANIMATION_ELEMENT_DETECTED) {
                    rootPlayers.push(player);
                }
                else {
                    var parentPlayers = _this.playersByElement.get(parentWithAnimation_1);
                    if (parentPlayers && parentPlayers.length) {
                        player.parentPlayer = optimizeGroupPlayer(parentPlayers);
                    }
                    skippedPlayers.push(player);
                }
            }
            else {
                eraseStyles(element, instruction.fromStyles);
                player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                // there still might be a ancestor player animating this
                // element therefore we will still add it as a sub player
                // even if its animation may be disabled
                subPlayers.push(player);
                if (disabledElementsSet.has(element)) {
                    skippedPlayers.push(player);
                }
            }
        });
        // find all of the sub players' corresponding inner animation player
        subPlayers.forEach(function (player) {
            // even if any players are not found for a sub animation then it
            // will still complete itself after the next tick since it's Noop
            var playersForElement = skippedPlayersMap.get(player.element);
            if (playersForElement && playersForElement.length) {
                var innerPlayer = optimizeGroupPlayer(playersForElement);
                player.setRealPlayer(innerPlayer);
            }
        });
        // the reason why we don't actually play the animation is
        // because all that a skipped player is designed to do is to
        // fire the start/done transition callback events
        skippedPlayers.forEach(function (player) {
            if (player.parentPlayer) {
                player.syncPlayerEvents(player.parentPlayer);
            }
            else {
                player.destroy();
            }
        });
        // run through all of the queued removals and see if they
        // were picked up by a query. If not then perform the removal
        // operation right away unless a parent animation is ongoing.
        for (var i_4 = 0; i_4 < allLeaveNodes.length; i_4++) {
            var element = allLeaveNodes[i_4];
            var details = element[REMOVAL_FLAG];
            removeClass(element, LEAVE_CLASSNAME);
            // this means the element has a removal animation that is being
            // taken care of and therefore the inner elements will hang around
            // until that animation is over (or the parent queried animation)
            if (details && details.hasAnimation)
                continue;
            var players = [];
            // if this element is queried or if it contains queried children
            // then we want for the element not to be removed from the page
            // until the queried animations have finished
            if (queriedElements.size) {
                var queriedPlayerResults = queriedElements.get(element);
                if (queriedPlayerResults && queriedPlayerResults.length) {
                    players.push.apply(players, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(queriedPlayerResults));
                }
                var queriedInnerElements = this.driver.query(element, NG_ANIMATING_SELECTOR, true);
                for (var j = 0; j < queriedInnerElements.length; j++) {
                    var queriedPlayers = queriedElements.get(queriedInnerElements[j]);
                    if (queriedPlayers && queriedPlayers.length) {
                        players.push.apply(players, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(queriedPlayers));
                    }
                }
            }
            var activePlayers = players.filter(function (p) { return !p.destroyed; });
            if (activePlayers.length) {
                removeNodesAfterAnimationDone(this, element, activePlayers);
            }
            else {
                this.processLeaveNode(element);
            }
        }
        // this is required so the cleanup method doesn't remove them
        allLeaveNodes.length = 0;
        rootPlayers.forEach(function (player) {
            _this.players.push(player);
            player.onDone(function () {
                player.destroy();
                var index = _this.players.indexOf(player);
                _this.players.splice(index, 1);
            });
            player.play();
        });
        return rootPlayers;
    };
    TransitionAnimationEngine.prototype.elementContainsData = function (namespaceId, element) {
        var containsData = false;
        var details = element[REMOVAL_FLAG];
        if (details && details.setForRemoval)
            containsData = true;
        if (this.playersByElement.has(element))
            containsData = true;
        if (this.playersByQueriedElement.has(element))
            containsData = true;
        if (this.statesByElement.has(element))
            containsData = true;
        return this._fetchNamespace(namespaceId).elementContainsData(element) || containsData;
    };
    TransitionAnimationEngine.prototype.afterFlush = function (callback) { this._flushFns.push(callback); };
    TransitionAnimationEngine.prototype.afterFlushAnimationsDone = function (callback) { this._whenQuietFns.push(callback); };
    TransitionAnimationEngine.prototype._getPreviousPlayers = function (element, isQueriedElement, namespaceId, triggerName, toStateValue) {
        var players = [];
        if (isQueriedElement) {
            var queriedElementPlayers = this.playersByQueriedElement.get(element);
            if (queriedElementPlayers) {
                players = queriedElementPlayers;
            }
        }
        else {
            var elementPlayers = this.playersByElement.get(element);
            if (elementPlayers) {
                var isRemovalAnimation_1 = !toStateValue || toStateValue == VOID_VALUE;
                elementPlayers.forEach(function (player) {
                    if (player.queued)
                        return;
                    if (!isRemovalAnimation_1 && player.triggerName != triggerName)
                        return;
                    players.push(player);
                });
            }
        }
        if (namespaceId || triggerName) {
            players = players.filter(function (player) {
                if (namespaceId && namespaceId != player.namespaceId)
                    return false;
                if (triggerName && triggerName != player.triggerName)
                    return false;
                return true;
            });
        }
        return players;
    };
    TransitionAnimationEngine.prototype._beforeAnimationBuild = function (namespaceId, instruction, allPreviousPlayersMap) {
        var e_1, _a;
        var triggerName = instruction.triggerName;
        var rootElement = instruction.element;
        // when a removal animation occurs, ALL previous players are collected
        // and destroyed (even if they are outside of the current namespace)
        var targetNameSpaceId = instruction.isRemovalTransition ? undefined : namespaceId;
        var targetTriggerName = instruction.isRemovalTransition ? undefined : triggerName;
        var _loop_1 = function (timelineInstruction) {
            var element = timelineInstruction.element;
            var isQueriedElement = element !== rootElement;
            var players = getOrSetAsInMap(allPreviousPlayersMap, element, []);
            var previousPlayers = this_1._getPreviousPlayers(element, isQueriedElement, targetNameSpaceId, targetTriggerName, instruction.toState);
            previousPlayers.forEach(function (player) {
                var realPlayer = player.getRealPlayer();
                if (realPlayer.beforeDestroy) {
                    realPlayer.beforeDestroy();
                }
                player.destroy();
                players.push(player);
            });
        };
        var this_1 = this;
        try {
            for (var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(instruction.timelines), _c = _b.next(); !_c.done; _c = _b.next()) {
                var timelineInstruction = _c.value;
                _loop_1(timelineInstruction);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // this needs to be done so that the PRE/POST styles can be
        // computed properly without interfering with the previous animation
        eraseStyles(rootElement, instruction.fromStyles);
    };
    TransitionAnimationEngine.prototype._buildAnimation = function (namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap) {
        var _this = this;
        var triggerName = instruction.triggerName;
        var rootElement = instruction.element;
        // we first run this so that the previous animation player
        // data can be passed into the successive animation players
        var allQueriedPlayers = [];
        var allConsumedElements = new Set();
        var allSubElements = new Set();
        var allNewPlayers = instruction.timelines.map(function (timelineInstruction) {
            var element = timelineInstruction.element;
            allConsumedElements.add(element);
            // FIXME (matsko): make sure to-be-removed animations are removed properly
            var details = element[REMOVAL_FLAG];
            if (details && details.removedBeforeQueried)
                return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["NoopAnimationPlayer"](timelineInstruction.duration, timelineInstruction.delay);
            var isQueriedElement = element !== rootElement;
            var previousPlayers = flattenGroupPlayers((allPreviousPlayersMap.get(element) || EMPTY_PLAYER_ARRAY)
                .map(function (p) { return p.getRealPlayer(); }))
                .filter(function (p) {
                // the `element` is not apart of the AnimationPlayer definition, but
                // Mock/WebAnimations
                // use the element within their implementation. This will be added in Angular5 to
                // AnimationPlayer
                var pp = p;
                return pp.element ? pp.element === element : false;
            });
            var preStyles = preStylesMap.get(element);
            var postStyles = postStylesMap.get(element);
            var keyframes = normalizeKeyframes(_this.driver, _this._normalizer, element, timelineInstruction.keyframes, preStyles, postStyles);
            var player = _this._buildPlayer(timelineInstruction, keyframes, previousPlayers);
            // this means that this particular player belongs to a sub trigger. It is
            // important that we match this player up with the corresponding (@trigger.listener)
            if (timelineInstruction.subTimeline && skippedPlayersMap) {
                allSubElements.add(element);
            }
            if (isQueriedElement) {
                var wrappedPlayer = new TransitionAnimationPlayer(namespaceId, triggerName, element);
                wrappedPlayer.setRealPlayer(player);
                allQueriedPlayers.push(wrappedPlayer);
            }
            return player;
        });
        allQueriedPlayers.forEach(function (player) {
            getOrSetAsInMap(_this.playersByQueriedElement, player.element, []).push(player);
            player.onDone(function () { return deleteOrUnsetInMap(_this.playersByQueriedElement, player.element, player); });
        });
        allConsumedElements.forEach(function (element) { return addClass(element, NG_ANIMATING_CLASSNAME); });
        var player = optimizeGroupPlayer(allNewPlayers);
        player.onDestroy(function () {
            allConsumedElements.forEach(function (element) { return removeClass(element, NG_ANIMATING_CLASSNAME); });
            setStyles(rootElement, instruction.toStyles);
        });
        // this basically makes all of the callbacks for sub element animations
        // be dependent on the upper players for when they finish
        allSubElements.forEach(function (element) { getOrSetAsInMap(skippedPlayersMap, element, []).push(player); });
        return player;
    };
    TransitionAnimationEngine.prototype._buildPlayer = function (instruction, keyframes, previousPlayers) {
        if (keyframes.length > 0) {
            return this.driver.animate(instruction.element, keyframes, instruction.duration, instruction.delay, instruction.easing, previousPlayers);
        }
        // special case for when an empty transition|definition is provided
        // ... there is no point in rendering an empty animation
        return new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["NoopAnimationPlayer"](instruction.duration, instruction.delay);
    };
    return TransitionAnimationEngine;
}());
var TransitionAnimationPlayer = /** @class */ (function () {
    function TransitionAnimationPlayer(namespaceId, triggerName, element) {
        this.namespaceId = namespaceId;
        this.triggerName = triggerName;
        this.element = element;
        this._player = new __WEBPACK_IMPORTED_MODULE_1__angular_animations__["NoopAnimationPlayer"]();
        this._containsRealPlayer = false;
        this._queuedCallbacks = {};
        this.destroyed = false;
        this.markedForDestroy = false;
        this.disabled = false;
        this.queued = true;
        this.totalTime = 0;
    }
    TransitionAnimationPlayer.prototype.setRealPlayer = function (player) {
        var _this = this;
        if (this._containsRealPlayer)
            return;
        this._player = player;
        Object.keys(this._queuedCallbacks).forEach(function (phase) {
            _this._queuedCallbacks[phase].forEach(function (callback) { return listenOnPlayer(player, phase, undefined, callback); });
        });
        this._queuedCallbacks = {};
        this._containsRealPlayer = true;
        this.overrideTotalTime(player.totalTime);
        this.queued = false;
    };
    TransitionAnimationPlayer.prototype.getRealPlayer = function () { return this._player; };
    TransitionAnimationPlayer.prototype.overrideTotalTime = function (totalTime) { this.totalTime = totalTime; };
    TransitionAnimationPlayer.prototype.syncPlayerEvents = function (player) {
        var _this = this;
        var p = this._player;
        if (p.triggerCallback) {
            player.onStart(function () { return p.triggerCallback('start'); });
        }
        player.onDone(function () { return _this.finish(); });
        player.onDestroy(function () { return _this.destroy(); });
    };
    TransitionAnimationPlayer.prototype._queueEvent = function (name, callback) {
        getOrSetAsInMap(this._queuedCallbacks, name, []).push(callback);
    };
    TransitionAnimationPlayer.prototype.onDone = function (fn) {
        if (this.queued) {
            this._queueEvent('done', fn);
        }
        this._player.onDone(fn);
    };
    TransitionAnimationPlayer.prototype.onStart = function (fn) {
        if (this.queued) {
            this._queueEvent('start', fn);
        }
        this._player.onStart(fn);
    };
    TransitionAnimationPlayer.prototype.onDestroy = function (fn) {
        if (this.queued) {
            this._queueEvent('destroy', fn);
        }
        this._player.onDestroy(fn);
    };
    TransitionAnimationPlayer.prototype.init = function () { this._player.init(); };
    TransitionAnimationPlayer.prototype.hasStarted = function () { return this.queued ? false : this._player.hasStarted(); };
    TransitionAnimationPlayer.prototype.play = function () { !this.queued && this._player.play(); };
    TransitionAnimationPlayer.prototype.pause = function () { !this.queued && this._player.pause(); };
    TransitionAnimationPlayer.prototype.restart = function () { !this.queued && this._player.restart(); };
    TransitionAnimationPlayer.prototype.finish = function () { this._player.finish(); };
    TransitionAnimationPlayer.prototype.destroy = function () {
        this.destroyed = true;
        this._player.destroy();
    };
    TransitionAnimationPlayer.prototype.reset = function () { !this.queued && this._player.reset(); };
    TransitionAnimationPlayer.prototype.setPosition = function (p) {
        if (!this.queued) {
            this._player.setPosition(p);
        }
    };
    TransitionAnimationPlayer.prototype.getPosition = function () { return this.queued ? 0 : this._player.getPosition(); };
    /** @internal */
    TransitionAnimationPlayer.prototype.triggerCallback = function (phaseName) {
        var p = this._player;
        if (p.triggerCallback) {
            p.triggerCallback(phaseName);
        }
    };
    return TransitionAnimationPlayer;
}());
function deleteOrUnsetInMap(map, key, value) {
    var currentValues;
    if (map instanceof Map) {
        currentValues = map.get(key);
        if (currentValues) {
            if (currentValues.length) {
                var index = currentValues.indexOf(value);
                currentValues.splice(index, 1);
            }
            if (currentValues.length == 0) {
                map.delete(key);
            }
        }
    }
    else {
        currentValues = map[key];
        if (currentValues) {
            if (currentValues.length) {
                var index = currentValues.indexOf(value);
                currentValues.splice(index, 1);
            }
            if (currentValues.length == 0) {
                delete map[key];
            }
        }
    }
    return currentValues;
}
function normalizeTriggerValue(value) {
    // we use `!= null` here because it's the most simple
    // way to test against a "falsy" value without mixing
    // in empty strings or a zero value. DO NOT OPTIMIZE.
    return value != null ? value : null;
}
function isElementNode(node) {
    return node && node['nodeType'] === 1;
}
function isTriggerEventValid(eventName) {
    return eventName == 'start' || eventName == 'done';
}
function cloakElement(element, value) {
    var oldValue = element.style.display;
    element.style.display = value != null ? value : 'none';
    return oldValue;
}
function cloakAndComputeStyles(valuesMap, driver, elements, elementPropsMap, defaultStyle) {
    var cloakVals = [];
    elements.forEach(function (element) { return cloakVals.push(cloakElement(element)); });
    var failedElements = [];
    elementPropsMap.forEach(function (props, element) {
        var styles = {};
        props.forEach(function (prop) {
            var value = styles[prop] = driver.computeStyle(element, prop, defaultStyle);
            // there is no easy way to detect this because a sub element could be removed
            // by a parent animation element being detached.
            if (!value || value.length == 0) {
                element[REMOVAL_FLAG] = NULL_REMOVED_QUERIED_STATE;
                failedElements.push(element);
            }
        });
        valuesMap.set(element, styles);
    });
    // we use a index variable here since Set.forEach(a, i) does not return
    // an index value for the closure (but instead just the value)
    var i = 0;
    elements.forEach(function (element) { return cloakElement(element, cloakVals[i++]); });
    return failedElements;
}
/*
Since the Angular renderer code will return a collection of inserted
nodes in all areas of a DOM tree, it's up to this algorithm to figure
out which nodes are roots for each animation @trigger.

By placing each inserted node into a Set and traversing upwards, it
is possible to find the @trigger elements and well any direct *star
insertion nodes, if a @trigger root is found then the enter element
is placed into the Map[@trigger] spot.
 */
function buildRootMap(roots, nodes) {
    var rootMap = new Map();
    roots.forEach(function (root) { return rootMap.set(root, []); });
    if (nodes.length == 0)
        return rootMap;
    var NULL_NODE = 1;
    var nodeSet = new Set(nodes);
    var localRootMap = new Map();
    function getRoot(node) {
        if (!node)
            return NULL_NODE;
        var root = localRootMap.get(node);
        if (root)
            return root;
        var parent = node.parentNode;
        if (rootMap.has(parent)) { // ngIf inside @trigger
            root = parent;
        }
        else if (nodeSet.has(parent)) { // ngIf inside ngIf
            root = NULL_NODE;
        }
        else { // recurse upwards
            root = getRoot(parent);
        }
        localRootMap.set(node, root);
        return root;
    }
    nodes.forEach(function (node) {
        var root = getRoot(node);
        if (root !== NULL_NODE) {
            rootMap.get(root).push(node);
        }
    });
    return rootMap;
}
var CLASSES_CACHE_KEY = '$$classes';
function addClass(element, className) {
    if (element.classList) {
        element.classList.add(className);
    }
    else {
        var classes = element[CLASSES_CACHE_KEY];
        if (!classes) {
            classes = element[CLASSES_CACHE_KEY] = {};
        }
        classes[className] = true;
    }
}
function removeClass(element, className) {
    if (element.classList) {
        element.classList.remove(className);
    }
    else {
        var classes = element[CLASSES_CACHE_KEY];
        if (classes) {
            delete classes[className];
        }
    }
}
function removeNodesAfterAnimationDone(engine, element, players) {
    optimizeGroupPlayer(players).onDone(function () { return engine.processLeaveNode(element); });
}
function flattenGroupPlayers(players) {
    var finalPlayers = [];
    _flattenGroupPlayersRecur(players, finalPlayers);
    return finalPlayers;
}
function _flattenGroupPlayersRecur(players, finalPlayers) {
    for (var i = 0; i < players.length; i++) {
        var player = players[i];
        if (player instanceof __WEBPACK_IMPORTED_MODULE_1__angular_animations__["ɵAnimationGroupPlayer"]) {
            _flattenGroupPlayersRecur(player.players, finalPlayers);
        }
        else {
            finalPlayers.push(player);
        }
    }
}
function objEquals(a, b) {
    var k1 = Object.keys(a);
    var k2 = Object.keys(b);
    if (k1.length != k2.length)
        return false;
    for (var i = 0; i < k1.length; i++) {
        var prop = k1[i];
        if (!b.hasOwnProperty(prop) || a[prop] !== b[prop])
            return false;
    }
    return true;
}
function replacePostStylesAsPre(element, allPreStyleElements, allPostStyleElements) {
    var postEntry = allPostStyleElements.get(element);
    if (!postEntry)
        return false;
    var preEntry = allPreStyleElements.get(element);
    if (preEntry) {
        postEntry.forEach(function (data) { return preEntry.add(data); });
    }
    else {
        allPreStyleElements.set(element, postEntry);
    }
    allPostStyleElements.delete(element);
    return true;
}

var AnimationEngine = /** @class */ (function () {
    function AnimationEngine(bodyNode, _driver, normalizer) {
        var _this = this;
        this.bodyNode = bodyNode;
        this._driver = _driver;
        this._triggerCache = {};
        // this method is designed to be overridden by the code that uses this engine
        this.onRemovalComplete = function (element, context) { };
        this._transitionEngine = new TransitionAnimationEngine(bodyNode, _driver, normalizer);
        this._timelineEngine = new TimelineAnimationEngine(bodyNode, _driver, normalizer);
        this._transitionEngine.onRemovalComplete = function (element, context) {
            return _this.onRemovalComplete(element, context);
        };
    }
    AnimationEngine.prototype.registerTrigger = function (componentId, namespaceId, hostElement, name, metadata) {
        var cacheKey = componentId + '-' + name;
        var trigger = this._triggerCache[cacheKey];
        if (!trigger) {
            var errors = [];
            var ast = buildAnimationAst(this._driver, metadata, errors);
            if (errors.length) {
                throw new Error("The animation trigger \"" + name + "\" has failed to build due to the following errors:\n - " + errors.join("\n - "));
            }
            trigger = buildTrigger(name, ast);
            this._triggerCache[cacheKey] = trigger;
        }
        this._transitionEngine.registerTrigger(namespaceId, name, trigger);
    };
    AnimationEngine.prototype.register = function (namespaceId, hostElement) {
        this._transitionEngine.register(namespaceId, hostElement);
    };
    AnimationEngine.prototype.destroy = function (namespaceId, context) {
        this._transitionEngine.destroy(namespaceId, context);
    };
    AnimationEngine.prototype.onInsert = function (namespaceId, element, parent, insertBefore) {
        this._transitionEngine.insertNode(namespaceId, element, parent, insertBefore);
    };
    AnimationEngine.prototype.onRemove = function (namespaceId, element, context) {
        this._transitionEngine.removeNode(namespaceId, element, context);
    };
    AnimationEngine.prototype.disableAnimations = function (element, disable) {
        this._transitionEngine.markElementAsDisabled(element, disable);
    };
    AnimationEngine.prototype.process = function (namespaceId, element, property, value) {
        if (property.charAt(0) == '@') {
            var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(parseTimelineCommand(property), 2), id = _a[0], action = _a[1];
            var args = value;
            this._timelineEngine.command(id, element, action, args);
        }
        else {
            this._transitionEngine.trigger(namespaceId, element, property, value);
        }
    };
    AnimationEngine.prototype.listen = function (namespaceId, element, eventName, eventPhase, callback) {
        // @@listen
        if (eventName.charAt(0) == '@') {
            var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(parseTimelineCommand(eventName), 2), id = _a[0], action = _a[1];
            return this._timelineEngine.listen(id, element, action, callback);
        }
        return this._transitionEngine.listen(namespaceId, element, eventName, eventPhase, callback);
    };
    AnimationEngine.prototype.flush = function (microtaskId) {
        if (microtaskId === void 0) { microtaskId = -1; }
        this._transitionEngine.flush(microtaskId);
    };
    Object.defineProperty(AnimationEngine.prototype, "players", {
        get: function () {
            return this._transitionEngine.players
                .concat(this._timelineEngine.players);
        },
        enumerable: true,
        configurable: true
    });
    AnimationEngine.prototype.whenRenderingDone = function () { return this._transitionEngine.whenRenderingDone(); };
    return AnimationEngine;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var ANIMATION_PROP = 'animation';
var ANIMATIONEND_EVENT = 'animationend';
var ONE_SECOND$1 = 1000;
var ElementAnimationStyleHandler = /** @class */ (function () {
    function ElementAnimationStyleHandler(_element, _name, _duration, _delay, _easing, _fillMode, _onDoneFn) {
        var _this = this;
        this._element = _element;
        this._name = _name;
        this._duration = _duration;
        this._delay = _delay;
        this._easing = _easing;
        this._fillMode = _fillMode;
        this._onDoneFn = _onDoneFn;
        this._finished = false;
        this._destroyed = false;
        this._startTime = 0;
        this._position = 0;
        this._eventFn = function (e) { return _this._handleCallback(e); };
    }
    ElementAnimationStyleHandler.prototype.apply = function () {
        applyKeyframeAnimation(this._element, this._duration + "ms " + this._easing + " " + this._delay + "ms 1 normal " + this._fillMode + " " + this._name);
        addRemoveAnimationEvent(this._element, this._eventFn, false);
        this._startTime = Date.now();
    };
    ElementAnimationStyleHandler.prototype.pause = function () { playPauseAnimation(this._element, this._name, 'paused'); };
    ElementAnimationStyleHandler.prototype.resume = function () { playPauseAnimation(this._element, this._name, 'running'); };
    ElementAnimationStyleHandler.prototype.setPosition = function (position) {
        var index = findIndexForAnimation(this._element, this._name);
        this._position = position * this._duration;
        setAnimationStyle(this._element, 'Delay', "-" + this._position + "ms", index);
    };
    ElementAnimationStyleHandler.prototype.getPosition = function () { return this._position; };
    ElementAnimationStyleHandler.prototype._handleCallback = function (event) {
        var timestamp = event._ngTestManualTimestamp || Date.now();
        var elapsedTime = parseFloat(event.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES)) * ONE_SECOND$1;
        if (event.animationName == this._name &&
            Math.max(timestamp - this._startTime, 0) >= this._delay && elapsedTime >= this._duration) {
            this.finish();
        }
    };
    ElementAnimationStyleHandler.prototype.finish = function () {
        if (this._finished)
            return;
        this._finished = true;
        this._onDoneFn();
        addRemoveAnimationEvent(this._element, this._eventFn, true);
    };
    ElementAnimationStyleHandler.prototype.destroy = function () {
        if (this._destroyed)
            return;
        this._destroyed = true;
        this.finish();
        removeKeyframeAnimation(this._element, this._name);
    };
    return ElementAnimationStyleHandler;
}());
function playPauseAnimation(element, name, status) {
    var index = findIndexForAnimation(element, name);
    setAnimationStyle(element, 'PlayState', status, index);
}
function applyKeyframeAnimation(element, value) {
    var anim = getAnimationStyle(element, '').trim();
    var index = 0;
    if (anim.length) {
        index = countChars(anim, ',') + 1;
        value = anim + ", " + value;
    }
    setAnimationStyle(element, '', value);
    return index;
}
function removeKeyframeAnimation(element, name) {
    var anim = getAnimationStyle(element, '');
    var tokens = anim.split(',');
    var index = findMatchingTokenIndex(tokens, name);
    if (index >= 0) {
        tokens.splice(index, 1);
        var newValue = tokens.join(',');
        setAnimationStyle(element, '', newValue);
    }
}
function findIndexForAnimation(element, value) {
    var anim = getAnimationStyle(element, '');
    if (anim.indexOf(',') > 0) {
        var tokens = anim.split(',');
        return findMatchingTokenIndex(tokens, value);
    }
    return findMatchingTokenIndex([anim], value);
}
function findMatchingTokenIndex(tokens, searchToken) {
    for (var i = 0; i < tokens.length; i++) {
        if (tokens[i].indexOf(searchToken) >= 0) {
            return i;
        }
    }
    return -1;
}
function addRemoveAnimationEvent(element, fn, doRemove) {
    doRemove ? element.removeEventListener(ANIMATIONEND_EVENT, fn) :
        element.addEventListener(ANIMATIONEND_EVENT, fn);
}
function setAnimationStyle(element, name, value, index) {
    var prop = ANIMATION_PROP + name;
    if (index != null) {
        var oldValue = element.style[prop];
        if (oldValue.length) {
            var tokens = oldValue.split(',');
            tokens[index] = value;
            value = tokens.join(',');
        }
    }
    element.style[prop] = value;
}
function getAnimationStyle(element, name) {
    return element.style[ANIMATION_PROP + name];
}
function countChars(value, char) {
    var count = 0;
    for (var i = 0; i < value.length; i++) {
        var c = value.charAt(i);
        if (c === char)
            count++;
    }
    return count;
}

var DEFAULT_FILL_MODE = 'forwards';
var DEFAULT_EASING = 'linear';
var CssKeyframesPlayer = /** @class */ (function () {
    function CssKeyframesPlayer(element, keyframes, animationName, _duration, _delay, easing, _finalStyles) {
        this.element = element;
        this.keyframes = keyframes;
        this.animationName = animationName;
        this._duration = _duration;
        this._delay = _delay;
        this._finalStyles = _finalStyles;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._started = false;
        this.currentSnapshot = {};
        this._state = 0;
        this.easing = easing || DEFAULT_EASING;
        this.totalTime = _duration + _delay;
        this._buildStyler();
    }
    CssKeyframesPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    CssKeyframesPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    CssKeyframesPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    CssKeyframesPlayer.prototype.destroy = function () {
        this.init();
        if (this._state >= 4 /* DESTROYED */)
            return;
        this._state = 4 /* DESTROYED */;
        this._styler.destroy();
        this._flushStartFns();
        this._flushDoneFns();
        this._onDestroyFns.forEach(function (fn) { return fn(); });
        this._onDestroyFns = [];
    };
    CssKeyframesPlayer.prototype._flushDoneFns = function () {
        this._onDoneFns.forEach(function (fn) { return fn(); });
        this._onDoneFns = [];
    };
    CssKeyframesPlayer.prototype._flushStartFns = function () {
        this._onStartFns.forEach(function (fn) { return fn(); });
        this._onStartFns = [];
    };
    CssKeyframesPlayer.prototype.finish = function () {
        this.init();
        if (this._state >= 3 /* FINISHED */)
            return;
        this._state = 3 /* FINISHED */;
        this._styler.finish();
        this._flushStartFns();
        this._flushDoneFns();
    };
    CssKeyframesPlayer.prototype.setPosition = function (value) { this._styler.setPosition(value); };
    CssKeyframesPlayer.prototype.getPosition = function () { return this._styler.getPosition(); };
    CssKeyframesPlayer.prototype.hasStarted = function () { return this._state >= 2 /* STARTED */; };
    CssKeyframesPlayer.prototype.init = function () {
        if (this._state >= 1 /* INITIALIZED */)
            return;
        this._state = 1 /* INITIALIZED */;
        var elm = this.element;
        this._styler.apply();
        if (this._delay) {
            this._styler.pause();
        }
    };
    CssKeyframesPlayer.prototype.play = function () {
        this.init();
        if (!this.hasStarted()) {
            this._flushStartFns();
            this._state = 2 /* STARTED */;
        }
        this._styler.resume();
    };
    CssKeyframesPlayer.prototype.pause = function () {
        this.init();
        this._styler.pause();
    };
    CssKeyframesPlayer.prototype.restart = function () {
        this.reset();
        this.play();
    };
    CssKeyframesPlayer.prototype.reset = function () {
        this._styler.destroy();
        this._buildStyler();
        this._styler.apply();
    };
    CssKeyframesPlayer.prototype._buildStyler = function () {
        var _this = this;
        this._styler = new ElementAnimationStyleHandler(this.element, this.animationName, this._duration, this._delay, this.easing, DEFAULT_FILL_MODE, function () { return _this.finish(); });
    };
    /** @internal */
    CssKeyframesPlayer.prototype.triggerCallback = function (phaseName) {
        var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
        methods.forEach(function (fn) { return fn(); });
        methods.length = 0;
    };
    CssKeyframesPlayer.prototype.beforeDestroy = function () {
        var _this = this;
        this.init();
        var styles = {};
        if (this.hasStarted()) {
            var finished_1 = this._state >= 3 /* FINISHED */;
            Object.keys(this._finalStyles).forEach(function (prop) {
                if (prop != 'offset') {
                    styles[prop] = finished_1 ? _this._finalStyles[prop] : computeStyle(_this.element, prop);
                }
            });
        }
        this.currentSnapshot = styles;
    };
    return CssKeyframesPlayer;
}());

var DirectStylePlayer = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(DirectStylePlayer, _super);
    function DirectStylePlayer(element, styles) {
        var _this = _super.call(this) || this;
        _this.element = element;
        _this._startingStyles = {};
        _this.__initialized = false;
        _this._styles = hypenatePropsObject(styles);
        return _this;
    }
    DirectStylePlayer.prototype.init = function () {
        var _this = this;
        if (this.__initialized || !this._startingStyles)
            return;
        this.__initialized = true;
        Object.keys(this._styles).forEach(function (prop) {
            _this._startingStyles[prop] = _this.element.style[prop];
        });
        _super.prototype.init.call(this);
    };
    DirectStylePlayer.prototype.play = function () {
        var _this = this;
        if (!this._startingStyles)
            return;
        this.init();
        Object.keys(this._styles)
            .forEach(function (prop) { return _this.element.style.setProperty(prop, _this._styles[prop]); });
        _super.prototype.play.call(this);
    };
    DirectStylePlayer.prototype.destroy = function () {
        var _this = this;
        if (!this._startingStyles)
            return;
        Object.keys(this._startingStyles).forEach(function (prop) {
            var value = _this._startingStyles[prop];
            if (value) {
                _this.element.style.setProperty(prop, value);
            }
            else {
                _this.element.style.removeProperty(prop);
            }
        });
        this._startingStyles = null;
        _super.prototype.destroy.call(this);
    };
    return DirectStylePlayer;
}(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["NoopAnimationPlayer"]));

var KEYFRAMES_NAME_PREFIX = 'gen_css_kf_';
var TAB_SPACE = ' ';
var CssKeyframesDriver = /** @class */ (function () {
    function CssKeyframesDriver() {
        this._count = 0;
        this._head = document.querySelector('head');
        this._warningIssued = false;
    }
    CssKeyframesDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
    CssKeyframesDriver.prototype.matchesElement = function (element, selector) {
        return matchesElement(element, selector);
    };
    CssKeyframesDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
    CssKeyframesDriver.prototype.query = function (element, selector, multi) {
        return invokeQuery(element, selector, multi);
    };
    CssKeyframesDriver.prototype.computeStyle = function (element, prop, defaultValue) {
        return window.getComputedStyle(element)[prop];
    };
    CssKeyframesDriver.prototype.buildKeyframeElement = function (element, name, keyframes) {
        keyframes = keyframes.map(function (kf) { return hypenatePropsObject(kf); });
        var keyframeStr = "@keyframes " + name + " {\n";
        var tab = '';
        keyframes.forEach(function (kf) {
            tab = TAB_SPACE;
            var offset = parseFloat(kf.offset);
            keyframeStr += "" + tab + offset * 100 + "% {\n";
            tab += TAB_SPACE;
            Object.keys(kf).forEach(function (prop) {
                var value = kf[prop];
                switch (prop) {
                    case 'offset':
                        return;
                    case 'easing':
                        if (value) {
                            keyframeStr += tab + "animation-timing-function: " + value + ";\n";
                        }
                        return;
                    default:
                        keyframeStr += "" + tab + prop + ": " + value + ";\n";
                        return;
                }
            });
            keyframeStr += tab + "}\n";
        });
        keyframeStr += "}\n";
        var kfElm = document.createElement('style');
        kfElm.innerHTML = keyframeStr;
        return kfElm;
    };
    CssKeyframesDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        if (scrubberAccessRequested) {
            this._notifyFaultyScrubber();
        }
        var previousCssKeyframePlayers = previousPlayers.filter(function (player) { return player instanceof CssKeyframesPlayer; });
        var previousStyles = {};
        if (allowPreviousPlayerStylesMerge(duration, delay)) {
            previousCssKeyframePlayers.forEach(function (player) {
                var styles = player.currentSnapshot;
                Object.keys(styles).forEach(function (prop) { return previousStyles[prop] = styles[prop]; });
            });
        }
        keyframes = balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles);
        var finalStyles = flattenKeyframesIntoStyles(keyframes);
        // if there is no animation then there is no point in applying
        // styles and waiting for an event to get fired. This causes lag.
        // It's better to just directly apply the styles to the element
        // via the direct styling animation player.
        if (duration == 0) {
            return new DirectStylePlayer(element, finalStyles);
        }
        var animationName = "" + KEYFRAMES_NAME_PREFIX + this._count++;
        var kfElm = this.buildKeyframeElement(element, animationName, keyframes);
        document.querySelector('head').appendChild(kfElm);
        var player = new CssKeyframesPlayer(element, keyframes, animationName, duration, delay, easing, finalStyles);
        player.onDestroy(function () { return removeElement(kfElm); });
        return player;
    };
    CssKeyframesDriver.prototype._notifyFaultyScrubber = function () {
        if (!this._warningIssued) {
            console.warn('@angular/animations: please load the web-animations.js polyfill to allow programmatic access...\n', '  visit http://bit.ly/IWukam to learn more about using the web-animation-js polyfill.');
            this._warningIssued = true;
        }
    };
    return CssKeyframesDriver;
}());
function flattenKeyframesIntoStyles(keyframes) {
    var flatKeyframes = {};
    if (keyframes) {
        var kfs = Array.isArray(keyframes) ? keyframes : [keyframes];
        kfs.forEach(function (kf) {
            Object.keys(kf).forEach(function (prop) {
                if (prop == 'offset' || prop == 'easing')
                    return;
                flatKeyframes[prop] = kf[prop];
            });
        });
    }
    return flatKeyframes;
}
function removeElement(node) {
    node.parentNode.removeChild(node);
}

var WebAnimationsPlayer = /** @class */ (function () {
    function WebAnimationsPlayer(element, keyframes, options) {
        this.element = element;
        this.keyframes = keyframes;
        this.options = options;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._initialized = false;
        this._finished = false;
        this._started = false;
        this._destroyed = false;
        this.time = 0;
        this.parentPlayer = null;
        this.currentSnapshot = {};
        this._duration = options['duration'];
        this._delay = options['delay'] || 0;
        this.time = this._duration + this._delay;
    }
    WebAnimationsPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    WebAnimationsPlayer.prototype.init = function () {
        this._buildPlayer();
        this._preparePlayerBeforeStart();
    };
    WebAnimationsPlayer.prototype._buildPlayer = function () {
        var _this = this;
        if (this._initialized)
            return;
        this._initialized = true;
        var keyframes = this.keyframes;
        this.domPlayer =
            this._triggerWebAnimation(this.element, keyframes, this.options);
        this._finalKeyframe = keyframes.length ? keyframes[keyframes.length - 1] : {};
        this.domPlayer.addEventListener('finish', function () { return _this._onFinish(); });
    };
    WebAnimationsPlayer.prototype._preparePlayerBeforeStart = function () {
        // this is required so that the player doesn't start to animate right away
        if (this._delay) {
            this._resetDomPlayerState();
        }
        else {
            this.domPlayer.pause();
        }
    };
    /** @internal */
    WebAnimationsPlayer.prototype._triggerWebAnimation = function (element, keyframes, options) {
        // jscompiler doesn't seem to know animate is a native property because it's not fully
        // supported yet across common browsers (we polyfill it for Edge/Safari) [CL #143630929]
        return element['animate'](keyframes, options);
    };
    WebAnimationsPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    WebAnimationsPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    WebAnimationsPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    WebAnimationsPlayer.prototype.play = function () {
        this._buildPlayer();
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
        this.domPlayer.play();
    };
    WebAnimationsPlayer.prototype.pause = function () {
        this.init();
        this.domPlayer.pause();
    };
    WebAnimationsPlayer.prototype.finish = function () {
        this.init();
        this._onFinish();
        this.domPlayer.finish();
    };
    WebAnimationsPlayer.prototype.reset = function () {
        this._resetDomPlayerState();
        this._destroyed = false;
        this._finished = false;
        this._started = false;
    };
    WebAnimationsPlayer.prototype._resetDomPlayerState = function () {
        if (this.domPlayer) {
            this.domPlayer.cancel();
        }
    };
    WebAnimationsPlayer.prototype.restart = function () {
        this.reset();
        this.play();
    };
    WebAnimationsPlayer.prototype.hasStarted = function () { return this._started; };
    WebAnimationsPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            this._resetDomPlayerState();
            this._onFinish();
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    WebAnimationsPlayer.prototype.setPosition = function (p) { this.domPlayer.currentTime = p * this.time; };
    WebAnimationsPlayer.prototype.getPosition = function () { return this.domPlayer.currentTime / this.time; };
    Object.defineProperty(WebAnimationsPlayer.prototype, "totalTime", {
        get: function () { return this._delay + this._duration; },
        enumerable: true,
        configurable: true
    });
    WebAnimationsPlayer.prototype.beforeDestroy = function () {
        var _this = this;
        var styles = {};
        if (this.hasStarted()) {
            Object.keys(this._finalKeyframe).forEach(function (prop) {
                if (prop != 'offset') {
                    styles[prop] =
                        _this._finished ? _this._finalKeyframe[prop] : computeStyle(_this.element, prop);
                }
            });
        }
        this.currentSnapshot = styles;
    };
    /** @internal */
    WebAnimationsPlayer.prototype.triggerCallback = function (phaseName) {
        var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
        methods.forEach(function (fn) { return fn(); });
        methods.length = 0;
    };
    return WebAnimationsPlayer;
}());

var WebAnimationsDriver = /** @class */ (function () {
    function WebAnimationsDriver() {
        this._isNativeImpl = /\{\s*\[native\s+code\]\s*\}/.test(getElementAnimateFn().toString());
        this._cssKeyframesDriver = new CssKeyframesDriver();
    }
    WebAnimationsDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
    WebAnimationsDriver.prototype.matchesElement = function (element, selector) {
        return matchesElement(element, selector);
    };
    WebAnimationsDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
    WebAnimationsDriver.prototype.query = function (element, selector, multi) {
        return invokeQuery(element, selector, multi);
    };
    WebAnimationsDriver.prototype.computeStyle = function (element, prop, defaultValue) {
        return window.getComputedStyle(element)[prop];
    };
    WebAnimationsDriver.prototype.overrideWebAnimationsSupport = function (supported) { this._isNativeImpl = supported; };
    WebAnimationsDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        var useKeyframes = !scrubberAccessRequested && !this._isNativeImpl;
        if (useKeyframes) {
            return this._cssKeyframesDriver.animate(element, keyframes, duration, delay, easing, previousPlayers);
        }
        var fill = delay == 0 ? 'both' : 'forwards';
        var playerOptions = { duration: duration, delay: delay, fill: fill };
        // we check for this to avoid having a null|undefined value be present
        // for the easing (which results in an error for certain browsers #9752)
        if (easing) {
            playerOptions['easing'] = easing;
        }
        var previousStyles = {};
        var previousWebAnimationPlayers = previousPlayers.filter(function (player) { return player instanceof WebAnimationsPlayer; });
        if (allowPreviousPlayerStylesMerge(duration, delay)) {
            previousWebAnimationPlayers.forEach(function (player) {
                var styles = player.currentSnapshot;
                Object.keys(styles).forEach(function (prop) { return previousStyles[prop] = styles[prop]; });
            });
        }
        keyframes = keyframes.map(function (styles) { return copyStyles(styles, false); });
        keyframes = balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles);
        return new WebAnimationsPlayer(element, keyframes, playerOptions);
    };
    return WebAnimationsDriver;
}());
function supportsWebAnimations() {
    return typeof getElementAnimateFn() === 'function';
}
function getElementAnimateFn() {
    return (isBrowser() && Element.prototype['animate']) || {};
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=browser.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Directionality; });
/* unused harmony export DIR_DOCUMENT */
/* unused harmony export Dir */
/* unused harmony export BidiModule */
/* unused harmony export ɵa */
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Injection token used to inject the document into Directionality.
 * This is used so that the value can be faked in tests.
 *
 * We can't use the real document in tests because changing the real `dir` causes geometry-based
 * tests in Safari to fail.
 *
 * We also can't re-provide the DOCUMENT token from platform-brower because the unit tests
 * themselves use things like `querySelector` in test code.
 *
 * This token is defined in a separate file from Directionality as a workaround for
 * https://github.com/angular/angular/issues/22559
 *
 * \@docs-private
 */
var /** @type {?} */ DIR_DOCUMENT = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('cdk-dir-doc', {
    providedIn: 'root',
    factory: DIR_DOCUMENT_FACTORY,
});
/**
 * \@docs-private
 * @return {?}
 */
function DIR_DOCUMENT_FACTORY() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_common__["DOCUMENT"]);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * The directionality (LTR / RTL) context for the application (or a subtree of it).
 * Exposes the current direction and a stream of direction changes.
 */
var Directionality = /** @class */ (function () {
    function Directionality(_document) {
        /**
         * The current 'ltr' or 'rtl' value.
         */
        this.value = 'ltr';
        /**
         * Stream that emits whenever the 'ltr' / 'rtl' state changes.
         */
        this.change = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        if (_document) {
            // TODO: handle 'auto' value -
            // We still need to account for dir="auto".
            // It looks like HTMLElemenet.dir is also "auto" when that's set to the attribute,
            // but getComputedStyle return either "ltr" or "rtl". avoiding getComputedStyle for now
            var /** @type {?} */ bodyDir = _document.body ? _document.body.dir : null;
            var /** @type {?} */ htmlDir = _document.documentElement ? _document.documentElement.dir : null;
            var /** @type {?} */ value = bodyDir || htmlDir;
            this.value = (value === 'ltr' || value === 'rtl') ? value : 'ltr';
        }
    }
    /**
     * @return {?}
     */
    Directionality.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.change.complete();
    };
    Directionality.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */
    Directionality.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DIR_DOCUMENT,] },] },
    ]; };
    /** @nocollapse */ Directionality.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function Directionality_Factory() { return new Directionality(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(DIR_DOCUMENT, 8)); }, token: Directionality, providedIn: "root" });
    return Directionality;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Directive to listen for changes of direction of part of the DOM.
 *
 * Provides itself as Directionality such that descendant directives only need to ever inject
 * Directionality to get the closest direction.
 */
var Dir = /** @class */ (function () {
    function Dir() {
        this._dir = 'ltr';
        /**
         * Whether the `value` has been set to its initial value.
         */
        this._isInitialized = false;
        /**
         * Event emitted when the direction changes.
         */
        this.change = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(Dir.prototype, "dir", {
        get: /**
         * \@docs-private
         * @return {?}
         */
        function () { return this._dir; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            var /** @type {?} */ old = this._dir;
            this._dir = (value === 'ltr' || value === 'rtl') ? value : 'ltr';
            if (old !== this._dir && this._isInitialized) {
                this.change.emit(this._dir);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dir.prototype, "value", {
        /** Current layout direction of the element. */
        get: /**
         * Current layout direction of the element.
         * @return {?}
         */
        function () { return this.dir; },
        enumerable: true,
        configurable: true
    });
    /** Initialize once default value has been set. */
    /**
     * Initialize once default value has been set.
     * @return {?}
     */
    Dir.prototype.ngAfterContentInit = /**
     * Initialize once default value has been set.
     * @return {?}
     */
    function () {
        this._isInitialized = true;
    };
    /**
     * @return {?}
     */
    Dir.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.change.complete();
    };
    Dir.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[dir]',
                    providers: [{ provide: Directionality, useExisting: Dir }],
                    host: { '[dir]': 'dir' },
                    exportAs: 'dir',
                },] },
    ];
    /** @nocollapse */
    Dir.propDecorators = {
        "change": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['dirChange',] },],
        "dir": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return Dir;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var BidiModule = /** @class */ (function () {
    function BidiModule() {
    }
    BidiModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    exports: [Dir],
                    declarations: [Dir],
                },] },
    ];
    return BidiModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


//# sourceMappingURL=bidi.es5.js.map


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MAC_ENTER */
/* unused harmony export BACKSPACE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TAB; });
/* unused harmony export NUM_CENTER */
/* unused harmony export ENTER */
/* unused harmony export SHIFT */
/* unused harmony export CONTROL */
/* unused harmony export ALT */
/* unused harmony export PAUSE */
/* unused harmony export CAPS_LOCK */
/* unused harmony export ESCAPE */
/* unused harmony export SPACE */
/* unused harmony export PAGE_UP */
/* unused harmony export PAGE_DOWN */
/* unused harmony export END */
/* unused harmony export HOME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LEFT_ARROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UP_ARROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RIGHT_ARROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOWN_ARROW; });
/* unused harmony export PLUS_SIGN */
/* unused harmony export PRINT_SCREEN */
/* unused harmony export INSERT */
/* unused harmony export DELETE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ZERO; });
/* unused harmony export ONE */
/* unused harmony export TWO */
/* unused harmony export THREE */
/* unused harmony export FOUR */
/* unused harmony export FIVE */
/* unused harmony export SIX */
/* unused harmony export SEVEN */
/* unused harmony export EIGHT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NINE; });
/* unused harmony export FF_SEMICOLON */
/* unused harmony export FF_EQUALS */
/* unused harmony export QUESTION_MARK */
/* unused harmony export AT_SIGN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return A; });
/* unused harmony export B */
/* unused harmony export C */
/* unused harmony export D */
/* unused harmony export E */
/* unused harmony export F */
/* unused harmony export G */
/* unused harmony export H */
/* unused harmony export I */
/* unused harmony export J */
/* unused harmony export K */
/* unused harmony export L */
/* unused harmony export M */
/* unused harmony export N */
/* unused harmony export O */
/* unused harmony export P */
/* unused harmony export Q */
/* unused harmony export R */
/* unused harmony export S */
/* unused harmony export T */
/* unused harmony export U */
/* unused harmony export V */
/* unused harmony export W */
/* unused harmony export X */
/* unused harmony export Y */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Z; });
/* unused harmony export META */
/* unused harmony export MAC_WK_CMD_LEFT */
/* unused harmony export MAC_WK_CMD_RIGHT */
/* unused harmony export CONTEXT_MENU */
/* unused harmony export NUMPAD_ZERO */
/* unused harmony export NUMPAD_ONE */
/* unused harmony export NUMPAD_TWO */
/* unused harmony export NUMPAD_THREE */
/* unused harmony export NUMPAD_FOUR */
/* unused harmony export NUMPAD_FIVE */
/* unused harmony export NUMPAD_SIX */
/* unused harmony export NUMPAD_SEVEN */
/* unused harmony export NUMPAD_EIGHT */
/* unused harmony export NUMPAD_NINE */
/* unused harmony export NUMPAD_MULTIPLY */
/* unused harmony export NUMPAD_PLUS */
/* unused harmony export NUMPAD_MINUS */
/* unused harmony export NUMPAD_PERIOD */
/* unused harmony export NUMPAD_DIVIDE */
/* unused harmony export F1 */
/* unused harmony export F2 */
/* unused harmony export F3 */
/* unused harmony export F4 */
/* unused harmony export F5 */
/* unused harmony export F6 */
/* unused harmony export F7 */
/* unused harmony export F8 */
/* unused harmony export F9 */
/* unused harmony export F10 */
/* unused harmony export F11 */
/* unused harmony export F12 */
/* unused harmony export NUM_LOCK */
/* unused harmony export SCROLL_LOCK */
/* unused harmony export FIRST_MEDIA */
/* unused harmony export FF_MINUS */
/* unused harmony export MUTE */
/* unused harmony export VOLUME_DOWN */
/* unused harmony export VOLUME_UP */
/* unused harmony export FF_MUTE */
/* unused harmony export FF_VOLUME_DOWN */
/* unused harmony export LAST_MEDIA */
/* unused harmony export FF_VOLUME_UP */
/* unused harmony export SEMICOLON */
/* unused harmony export EQUALS */
/* unused harmony export COMMA */
/* unused harmony export DASH */
/* unused harmony export SLASH */
/* unused harmony export APOSTROPHE */
/* unused harmony export TILDE */
/* unused harmony export OPEN_SQUARE_BRACKET */
/* unused harmony export BACKSLASH */
/* unused harmony export CLOSE_SQUARE_BRACKET */
/* unused harmony export SINGLE_QUOTE */
/* unused harmony export MAC_META */
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

var /** @type {?} */ MAC_ENTER = 3;
var /** @type {?} */ BACKSPACE = 8;
var /** @type {?} */ TAB = 9;
var /** @type {?} */ NUM_CENTER = 12;
var /** @type {?} */ ENTER = 13;
var /** @type {?} */ SHIFT = 16;
var /** @type {?} */ CONTROL = 17;
var /** @type {?} */ ALT = 18;
var /** @type {?} */ PAUSE = 19;
var /** @type {?} */ CAPS_LOCK = 20;
var /** @type {?} */ ESCAPE = 27;
var /** @type {?} */ SPACE = 32;
var /** @type {?} */ PAGE_UP = 33;
var /** @type {?} */ PAGE_DOWN = 34;
var /** @type {?} */ END = 35;
var /** @type {?} */ HOME = 36;
var /** @type {?} */ LEFT_ARROW = 37;
var /** @type {?} */ UP_ARROW = 38;
var /** @type {?} */ RIGHT_ARROW = 39;
var /** @type {?} */ DOWN_ARROW = 40;
var /** @type {?} */ PLUS_SIGN = 43;
var /** @type {?} */ PRINT_SCREEN = 44;
var /** @type {?} */ INSERT = 45;
var /** @type {?} */ DELETE = 46;
var /** @type {?} */ ZERO = 48;
var /** @type {?} */ ONE = 49;
var /** @type {?} */ TWO = 50;
var /** @type {?} */ THREE = 51;
var /** @type {?} */ FOUR = 52;
var /** @type {?} */ FIVE = 53;
var /** @type {?} */ SIX = 54;
var /** @type {?} */ SEVEN = 55;
var /** @type {?} */ EIGHT = 56;
var /** @type {?} */ NINE = 57;
var /** @type {?} */ FF_SEMICOLON = 59; // Firefox (Gecko) fires this for semicolon instead of 186
var /** @type {?} */ FF_EQUALS = 61; // Firefox (Gecko) fires this for equals instead of 187
var /** @type {?} */ QUESTION_MARK = 63;
var /** @type {?} */ AT_SIGN = 64;
var /** @type {?} */ A = 65;
var /** @type {?} */ B = 66;
var /** @type {?} */ C = 67;
var /** @type {?} */ D = 68;
var /** @type {?} */ E = 69;
var /** @type {?} */ F = 70;
var /** @type {?} */ G = 71;
var /** @type {?} */ H = 72;
var /** @type {?} */ I = 73;
var /** @type {?} */ J = 74;
var /** @type {?} */ K = 75;
var /** @type {?} */ L = 76;
var /** @type {?} */ M = 77;
var /** @type {?} */ N = 78;
var /** @type {?} */ O = 79;
var /** @type {?} */ P = 80;
var /** @type {?} */ Q = 81;
var /** @type {?} */ R = 82;
var /** @type {?} */ S = 83;
var /** @type {?} */ T = 84;
var /** @type {?} */ U = 85;
var /** @type {?} */ V = 86;
var /** @type {?} */ W = 87;
var /** @type {?} */ X = 88;
var /** @type {?} */ Y = 89;
var /** @type {?} */ Z = 90;
var /** @type {?} */ META = 91; // WIN_KEY_LEFT
var /** @type {?} */ MAC_WK_CMD_LEFT = 91;
var /** @type {?} */ MAC_WK_CMD_RIGHT = 93;
var /** @type {?} */ CONTEXT_MENU = 93;
var /** @type {?} */ NUMPAD_ZERO = 96;
var /** @type {?} */ NUMPAD_ONE = 97;
var /** @type {?} */ NUMPAD_TWO = 98;
var /** @type {?} */ NUMPAD_THREE = 99;
var /** @type {?} */ NUMPAD_FOUR = 100;
var /** @type {?} */ NUMPAD_FIVE = 101;
var /** @type {?} */ NUMPAD_SIX = 102;
var /** @type {?} */ NUMPAD_SEVEN = 103;
var /** @type {?} */ NUMPAD_EIGHT = 104;
var /** @type {?} */ NUMPAD_NINE = 105;
var /** @type {?} */ NUMPAD_MULTIPLY = 106;
var /** @type {?} */ NUMPAD_PLUS = 107;
var /** @type {?} */ NUMPAD_MINUS = 109;
var /** @type {?} */ NUMPAD_PERIOD = 110;
var /** @type {?} */ NUMPAD_DIVIDE = 111;
var /** @type {?} */ F1 = 112;
var /** @type {?} */ F2 = 113;
var /** @type {?} */ F3 = 114;
var /** @type {?} */ F4 = 115;
var /** @type {?} */ F5 = 116;
var /** @type {?} */ F6 = 117;
var /** @type {?} */ F7 = 118;
var /** @type {?} */ F8 = 119;
var /** @type {?} */ F9 = 120;
var /** @type {?} */ F10 = 121;
var /** @type {?} */ F11 = 122;
var /** @type {?} */ F12 = 123;
var /** @type {?} */ NUM_LOCK = 144;
var /** @type {?} */ SCROLL_LOCK = 145;
var /** @type {?} */ FIRST_MEDIA = 166;
var /** @type {?} */ FF_MINUS = 173;
var /** @type {?} */ MUTE = 173; // Firefox (Gecko) fires 181 for MUTE
var /** @type {?} */ VOLUME_DOWN = 174; // Firefox (Gecko) fires 182 for VOLUME_DOWN
var /** @type {?} */ VOLUME_UP = 175; // Firefox (Gecko) fires 183 for VOLUME_UP
var /** @type {?} */ FF_MUTE = 181;
var /** @type {?} */ FF_VOLUME_DOWN = 182;
var /** @type {?} */ LAST_MEDIA = 183;
var /** @type {?} */ FF_VOLUME_UP = 183;
var /** @type {?} */ SEMICOLON = 186; // Firefox (Gecko) fires 59 for SEMICOLON
var /** @type {?} */ EQUALS = 187; // Firefox (Gecko) fires 61 for EQUALS
var /** @type {?} */ COMMA = 188;
var /** @type {?} */ DASH = 189; // Firefox (Gecko) fires 173 for DASH/MINUS
var /** @type {?} */ SLASH = 191;
var /** @type {?} */ APOSTROPHE = 192;
var /** @type {?} */ TILDE = 192;
var /** @type {?} */ OPEN_SQUARE_BRACKET = 219;
var /** @type {?} */ BACKSLASH = 220;
var /** @type {?} */ CLOSE_SQUARE_BRACKET = 221;
var /** @type {?} */ SINGLE_QUOTE = 222;
var /** @type {?} */ MAC_META = 224;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


//# sourceMappingURL=keycodes.es5.js.map


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_cdk_coercion__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = __webpack_require__(7);
/* unused harmony export MutationObserverFactory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentObserver; });
/* unused harmony export CdkObserveContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObserversModule; });
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Factory that creates a new MutationObserver and allows us to stub it out in unit tests.
 * \@docs-private
 */
var MutationObserverFactory = /** @class */ (function () {
    function MutationObserverFactory() {
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    MutationObserverFactory.prototype.create = /**
     * @param {?} callback
     * @return {?}
     */
    function (callback) {
        return typeof MutationObserver === 'undefined' ? null : new MutationObserver(callback);
    };
    MutationObserverFactory.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */ MutationObserverFactory.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function MutationObserverFactory_Factory() { return new MutationObserverFactory(); }, token: MutationObserverFactory, providedIn: "root" });
    return MutationObserverFactory;
}());
/**
 * An injectable service that allows watching elements for changes to their content.
 */
var ContentObserver = /** @class */ (function () {
    function ContentObserver(_mutationObserverFactory) {
        this._mutationObserverFactory = _mutationObserverFactory;
        /**
         * Keeps track of the existing MutationObservers so they can be reused.
         */
        this._observedElements = new Map();
    }
    /**
     * @return {?}
     */
    ContentObserver.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this._observedElements.forEach(function (_, element) { return _this._cleanupObserver(element); });
    };
    /**
     * @param {?} elementOrRef
     * @return {?}
     */
    ContentObserver.prototype.observe = /**
     * @param {?} elementOrRef
     * @return {?}
     */
    function (elementOrRef) {
        var _this = this;
        var /** @type {?} */ element = elementOrRef instanceof __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"] ? elementOrRef.nativeElement : elementOrRef;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].create(function (observer) {
            var /** @type {?} */ stream = _this._observeElement(element);
            var /** @type {?} */ subscription = stream.subscribe(observer);
            return function () {
                subscription.unsubscribe();
                _this._unobserveElement(element);
            };
        });
    };
    /**
     * Observes the given element by using the existing MutationObserver if available, or creating a
     * new one if not.
     * @param {?} element
     * @return {?}
     */
    ContentObserver.prototype._observeElement = /**
     * Observes the given element by using the existing MutationObserver if available, or creating a
     * new one if not.
     * @param {?} element
     * @return {?}
     */
    function (element) {
        if (!this._observedElements.has(element)) {
            var /** @type {?} */ stream_1 = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["Subject"]();
            var /** @type {?} */ observer = this._mutationObserverFactory.create(function (mutations) { return stream_1.next(mutations); });
            if (observer) {
                observer.observe(element, {
                    characterData: true,
                    childList: true,
                    subtree: true
                });
            }
            this._observedElements.set(element, { observer: observer, stream: stream_1, count: 1 });
        }
        else {
            /** @type {?} */ ((this._observedElements.get(element))).count++;
        }
        return /** @type {?} */ ((this._observedElements.get(element))).stream;
    };
    /**
     * Un-observes the given element and cleans up the underlying MutationObserver if nobody else is
     * observing this element.
     * @param {?} element
     * @return {?}
     */
    ContentObserver.prototype._unobserveElement = /**
     * Un-observes the given element and cleans up the underlying MutationObserver if nobody else is
     * observing this element.
     * @param {?} element
     * @return {?}
     */
    function (element) {
        if (this._observedElements.has(element)) {
            /** @type {?} */ ((this._observedElements.get(element))).count--;
            if (!/** @type {?} */ ((this._observedElements.get(element))).count) {
                this._cleanupObserver(element);
            }
        }
    };
    /**
     * Clean up the underlying MutationObserver for the specified element.
     * @param {?} element
     * @return {?}
     */
    ContentObserver.prototype._cleanupObserver = /**
     * Clean up the underlying MutationObserver for the specified element.
     * @param {?} element
     * @return {?}
     */
    function (element) {
        if (this._observedElements.has(element)) {
            var _a = /** @type {?} */ ((this._observedElements.get(element))), observer = _a.observer, stream = _a.stream;
            if (observer) {
                observer.disconnect();
            }
            stream.complete();
            this._observedElements.delete(element);
        }
    };
    ContentObserver.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"], args: [{ providedIn: 'root' },] },
    ];
    /** @nocollapse */
    ContentObserver.ctorParameters = function () { return [
        { type: MutationObserverFactory, },
    ]; };
    /** @nocollapse */ ContentObserver.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function ContentObserver_Factory() { return new ContentObserver(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(MutationObserverFactory)); }, token: ContentObserver, providedIn: "root" });
    return ContentObserver;
}());
/**
 * Directive that triggers a callback whenever the content of
 * its associated element has changed.
 */
var CdkObserveContent = /** @class */ (function () {
    function CdkObserveContent(_contentObserver, _elementRef, _ngZone) {
        this._contentObserver = _contentObserver;
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
        /**
         * Event emitted for each change in the element's content.
         */
        this.event = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this._disabled = false;
        this._currentSubscription = null;
    }
    Object.defineProperty(CdkObserveContent.prototype, "disabled", {
        get: /**
         * Whether observing content is disabled. This option can be used
         * to disconnect the underlying MutationObserver until it is needed.
         * @return {?}
         */
        function () { return this._disabled; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._disabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_cdk_coercion__["a" /* coerceBooleanProperty */])(value);
            if (this._disabled) {
                this._unsubscribe();
            }
            else {
                this._subscribe();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkObserveContent.prototype, "debounce", {
        get: /**
         * Debounce interval for emitting the changes.
         * @return {?}
         */
        function () { return this._debounce; },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._debounce = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_cdk_coercion__["b" /* coerceNumberProperty */])(value);
            this._subscribe();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkObserveContent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        if (!this._currentSubscription && !this.disabled) {
            this._subscribe();
        }
    };
    /**
     * @return {?}
     */
    CdkObserveContent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this._unsubscribe();
    };
    /**
     * @return {?}
     */
    CdkObserveContent.prototype._subscribe = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this._unsubscribe();
        var /** @type {?} */ stream = this._contentObserver.observe(this._elementRef);
        // TODO(mmalerba): We shouldn't be emitting on this @Output() outside the zone.
        // Consider brining it back inside the zone next time we're making breaking changes.
        // Bringing it back inside can cause things like infinite change detection loops and changed
        // after checked errors if people's code isn't handling it properly.
        this._ngZone.runOutsideAngular(function () {
            _this._currentSubscription =
                (_this.debounce ? stream.pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["debounceTime"])(_this.debounce)) : stream).subscribe(_this.event);
        });
    };
    /**
     * @return {?}
     */
    CdkObserveContent.prototype._unsubscribe = /**
     * @return {?}
     */
    function () {
        if (this._currentSubscription) {
            this._currentSubscription.unsubscribe();
        }
    };
    CdkObserveContent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                    selector: '[cdkObserveContent]',
                    exportAs: 'cdkObserveContent',
                },] },
    ];
    /** @nocollapse */
    CdkObserveContent.ctorParameters = function () { return [
        { type: ContentObserver, },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
    ]; };
    CdkObserveContent.propDecorators = {
        "event": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['cdkObserveContent',] },],
        "disabled": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"], args: ['cdkObserveContentDisabled',] },],
        "debounce": [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    };
    return CdkObserveContent;
}());
var ObserversModule = /** @class */ (function () {
    function ObserversModule() {
    }
    ObserversModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    exports: [CdkObserveContent],
                    declarations: [CdkObserveContent],
                    providers: [MutationObserverFactory]
                },] },
    ];
    return ObserversModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */


//# sourceMappingURL=observers.es5.js.map


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(null, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // THIS CODE IS GENERATED - DO NOT MODIFY
    // See angular/tools/gulp-tasks/cldr/extract.js
    var u = undefined;
    function plural(n) {
        var i = Math.floor(Math.abs(n));
        if (i === 0 || i === 1)
            return 1;
        return 5;
    }
    exports.default = [
        'fr', [['AM', 'PM'], u, u], u,
        [
            ['D', 'L', 'M', 'M', 'J', 'V', 'S'], ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
            ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
            ['di', 'lu', 'ma', 'me', 'je', 've', 'sa']
        ],
        u,
        [
            ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
            [
                'janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.',
                'déc.'
            ],
            [
                'janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre',
                'octobre', 'novembre', 'décembre'
            ]
        ],
        u, [['av. J.-C.', 'ap. J.-C.'], u, ['avant Jésus-Christ', 'après Jésus-Christ']], 1, [6, 0],
        ['dd/MM/y', 'd MMM y', 'd MMMM y', 'EEEE d MMMM y'],
        ['HH:mm', 'HH:mm:ss', 'HH:mm:ss z', 'HH:mm:ss zzzz'], ['{1} {0}', '{1} \'à\' {0}', u, u],
        [',', ' ', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
        ['#,##0.###', '#,##0 %', '#,##0.00 ¤', '#E0'], '€', 'euro', {
            'ARS': ['$AR', '$'],
            'AUD': ['$AU', '$'],
            'BEF': ['FB'],
            'BMD': ['$BM', '$'],
            'BND': ['$BN', '$'],
            'BSD': ['$BS', '$'],
            'BZD': ['$BZ', '$'],
            'CAD': ['$CA', '$'],
            'CLP': ['$CL', '$'],
            'CNY': [u, '¥'],
            'COP': ['$CO', '$'],
            'CYP': ['£CY'],
            'EGP': [u, '£E'],
            'FJD': ['$FJ', '$'],
            'FKP': ['£FK', '£'],
            'FRF': ['F'],
            'GBP': ['£GB', '£'],
            'GIP': ['£GI', '£'],
            'HKD': [u, '$'],
            'IEP': ['£IE'],
            'ILP': ['£IL'],
            'ITL': ['₤IT'],
            'JPY': [u, '¥'],
            'KMF': [u, 'FC'],
            'LBP': ['£LB', '£L'],
            'MTP': ['£MT'],
            'MXN': ['$MX', '$'],
            'NAD': ['$NA', '$'],
            'NIO': [u, '$C'],
            'NZD': ['$NZ', '$'],
            'RHD': ['$RH'],
            'RON': [u, 'L'],
            'RWF': [u, 'FR'],
            'SBD': ['$SB', '$'],
            'SGD': ['$SG', '$'],
            'SRD': ['$SR', '$'],
            'TTD': ['$TT', '$'],
            'TWD': [u, 'NT$'],
            'USD': ['$US', '$'],
            'UYU': ['$UY', '$'],
            'WST': ['WS$'],
            'XCD': [u, '$'],
            'XPF': ['FCFP'],
            'ZMW': [u, 'Kw']
        },
        plural
    ];
});
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_animations__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(15);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_g", function() { return BaseAnimationRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_e", function() { return BROWSER_ANIMATIONS_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_f", function() { return BROWSER_NOOP_ANIMATIONS_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_a", function() { return InjectableAnimationEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_c", function() { return instantiateDefaultStyleNormalizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_d", function() { return instantiateRendererFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_platform_browser_animations_animations_b", function() { return instantiateSupportedAnimationDriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserAnimationsModule", function() { return BrowserAnimationsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoopAnimationsModule", function() { return NoopAnimationsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANIMATION_MODULE_TYPE", function() { return ANIMATION_MODULE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserAnimationBuilder", function() { return BrowserAnimationBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserAnimationFactory", function() { return BrowserAnimationFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationRenderer", function() { return AnimationRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAnimationRendererFactory", function() { return AnimationRendererFactory; });
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */








var BrowserAnimationBuilder = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(BrowserAnimationBuilder, _super);
    function BrowserAnimationBuilder(rootRenderer, doc) {
        var _this = _super.call(this) || this;
        _this._nextAnimationId = 0;
        var typeData = {
            id: '0',
            encapsulation: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].None,
            styles: [],
            data: { animation: [] }
        };
        _this._renderer = rootRenderer.createRenderer(doc.body, typeData);
        return _this;
    }
    BrowserAnimationBuilder.prototype.build = function (animation) {
        var id = this._nextAnimationId.toString();
        this._nextAnimationId++;
        var entry = Array.isArray(animation) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["sequence"])(animation) : animation;
        issueAnimationCommand(this._renderer, null, id, 'register', [entry]);
        return new BrowserAnimationFactory(id, this._renderer);
    };
    BrowserAnimationBuilder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["DOCUMENT"])),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_core__["RendererFactory2"], Object])
    ], BrowserAnimationBuilder);
    return BrowserAnimationBuilder;
}(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["AnimationBuilder"]));
var BrowserAnimationFactory = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(BrowserAnimationFactory, _super);
    function BrowserAnimationFactory(_id, _renderer) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this._renderer = _renderer;
        return _this;
    }
    BrowserAnimationFactory.prototype.create = function (element, options) {
        return new RendererAnimationPlayer(this._id, element, options || {}, this._renderer);
    };
    return BrowserAnimationFactory;
}(__WEBPACK_IMPORTED_MODULE_1__angular_animations__["AnimationFactory"]));
var RendererAnimationPlayer = /** @class */ (function () {
    function RendererAnimationPlayer(id, element, options, _renderer) {
        this.id = id;
        this.element = element;
        this._renderer = _renderer;
        this.parentPlayer = null;
        this._started = false;
        this.totalTime = 0;
        this._command('create', options);
    }
    RendererAnimationPlayer.prototype._listen = function (eventName, callback) {
        return this._renderer.listen(this.element, "@@" + this.id + ":" + eventName, callback);
    };
    RendererAnimationPlayer.prototype._command = function (command) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return issueAnimationCommand(this._renderer, this.element, this.id, command, args);
    };
    RendererAnimationPlayer.prototype.onDone = function (fn) { this._listen('done', fn); };
    RendererAnimationPlayer.prototype.onStart = function (fn) { this._listen('start', fn); };
    RendererAnimationPlayer.prototype.onDestroy = function (fn) { this._listen('destroy', fn); };
    RendererAnimationPlayer.prototype.init = function () { this._command('init'); };
    RendererAnimationPlayer.prototype.hasStarted = function () { return this._started; };
    RendererAnimationPlayer.prototype.play = function () {
        this._command('play');
        this._started = true;
    };
    RendererAnimationPlayer.prototype.pause = function () { this._command('pause'); };
    RendererAnimationPlayer.prototype.restart = function () { this._command('restart'); };
    RendererAnimationPlayer.prototype.finish = function () { this._command('finish'); };
    RendererAnimationPlayer.prototype.destroy = function () { this._command('destroy'); };
    RendererAnimationPlayer.prototype.reset = function () { this._command('reset'); };
    RendererAnimationPlayer.prototype.setPosition = function (p) { this._command('setPosition', p); };
    RendererAnimationPlayer.prototype.getPosition = function () { return 0; };
    return RendererAnimationPlayer;
}());
function issueAnimationCommand(renderer, element, id, command, args) {
    return renderer.setProperty(element, "@@" + id + ":" + command, args);
}

var ANIMATION_PREFIX = '@';
var DISABLE_ANIMATIONS_FLAG = '@.disabled';
var AnimationRendererFactory = /** @class */ (function () {
    function AnimationRendererFactory(delegate, engine, _zone) {
        this.delegate = delegate;
        this.engine = engine;
        this._zone = _zone;
        this._currentId = 0;
        this._microtaskId = 1;
        this._animationCallbacksBuffer = [];
        this._rendererCache = new Map();
        this._cdRecurDepth = 0;
        this.promise = Promise.resolve(0);
        engine.onRemovalComplete = function (element, delegate) {
            // Note: if an component element has a leave animation, and the component
            // a host leave animation, the view engine will call `removeChild` for the parent
            // component renderer as well as for the child component renderer.
            // Therefore, we need to check if we already removed the element.
            if (delegate && delegate.parentNode(element)) {
                delegate.removeChild(element.parentNode, element);
            }
        };
    }
    AnimationRendererFactory.prototype.createRenderer = function (hostElement, type) {
        var _this = this;
        var EMPTY_NAMESPACE_ID = '';
        // cache the delegates to find out which cached delegate can
        // be used by which cached renderer
        var delegate = this.delegate.createRenderer(hostElement, type);
        if (!hostElement || !type || !type.data || !type.data['animation']) {
            var renderer = this._rendererCache.get(delegate);
            if (!renderer) {
                renderer = new BaseAnimationRenderer(EMPTY_NAMESPACE_ID, delegate, this.engine);
                // only cache this result when the base renderer is used
                this._rendererCache.set(delegate, renderer);
            }
            return renderer;
        }
        var componentId = type.id;
        var namespaceId = type.id + '-' + this._currentId;
        this._currentId++;
        this.engine.register(namespaceId, hostElement);
        var animationTriggers = type.data['animation'];
        animationTriggers.forEach(function (trigger) { return _this.engine.registerTrigger(componentId, namespaceId, hostElement, trigger.name, trigger); });
        return new AnimationRenderer(this, namespaceId, delegate, this.engine);
    };
    AnimationRendererFactory.prototype.begin = function () {
        this._cdRecurDepth++;
        if (this.delegate.begin) {
            this.delegate.begin();
        }
    };
    AnimationRendererFactory.prototype._scheduleCountTask = function () {
        var _this = this;
        // always use promise to schedule microtask instead of use Zone
        this.promise.then(function () { _this._microtaskId++; });
    };
    /** @internal */
    AnimationRendererFactory.prototype.scheduleListenerCallback = function (count, fn, data) {
        var _this = this;
        if (count >= 0 && count < this._microtaskId) {
            this._zone.run(function () { return fn(data); });
            return;
        }
        if (this._animationCallbacksBuffer.length == 0) {
            Promise.resolve(null).then(function () {
                _this._zone.run(function () {
                    _this._animationCallbacksBuffer.forEach(function (tuple) {
                        var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(tuple, 2), fn = _a[0], data = _a[1];
                        fn(data);
                    });
                    _this._animationCallbacksBuffer = [];
                });
            });
        }
        this._animationCallbacksBuffer.push([fn, data]);
    };
    AnimationRendererFactory.prototype.end = function () {
        var _this = this;
        this._cdRecurDepth--;
        // this is to prevent animations from running twice when an inner
        // component does CD when a parent component insted has inserted it
        if (this._cdRecurDepth == 0) {
            this._zone.runOutsideAngular(function () {
                _this._scheduleCountTask();
                _this.engine.flush(_this._microtaskId);
            });
        }
        if (this.delegate.end) {
            this.delegate.end();
        }
    };
    AnimationRendererFactory.prototype.whenRenderingDone = function () { return this.engine.whenRenderingDone(); };
    AnimationRendererFactory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_core__["RendererFactory2"], __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["a" /* ɵAnimationEngine */], __WEBPACK_IMPORTED_MODULE_2__angular_core__["NgZone"]])
    ], AnimationRendererFactory);
    return AnimationRendererFactory;
}());
var BaseAnimationRenderer = /** @class */ (function () {
    function BaseAnimationRenderer(namespaceId, delegate, engine) {
        this.namespaceId = namespaceId;
        this.delegate = delegate;
        this.engine = engine;
        this.destroyNode = this.delegate.destroyNode ? function (n) { return delegate.destroyNode(n); } : null;
    }
    Object.defineProperty(BaseAnimationRenderer.prototype, "data", {
        get: function () { return this.delegate.data; },
        enumerable: true,
        configurable: true
    });
    BaseAnimationRenderer.prototype.destroy = function () {
        this.engine.destroy(this.namespaceId, this.delegate);
        this.delegate.destroy();
    };
    BaseAnimationRenderer.prototype.createElement = function (name, namespace) {
        return this.delegate.createElement(name, namespace);
    };
    BaseAnimationRenderer.prototype.createComment = function (value) { return this.delegate.createComment(value); };
    BaseAnimationRenderer.prototype.createText = function (value) { return this.delegate.createText(value); };
    BaseAnimationRenderer.prototype.appendChild = function (parent, newChild) {
        this.delegate.appendChild(parent, newChild);
        this.engine.onInsert(this.namespaceId, newChild, parent, false);
    };
    BaseAnimationRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
        this.delegate.insertBefore(parent, newChild, refChild);
        this.engine.onInsert(this.namespaceId, newChild, parent, true);
    };
    BaseAnimationRenderer.prototype.removeChild = function (parent, oldChild) {
        this.engine.onRemove(this.namespaceId, oldChild, this.delegate);
    };
    BaseAnimationRenderer.prototype.selectRootElement = function (selectorOrNode) { return this.delegate.selectRootElement(selectorOrNode); };
    BaseAnimationRenderer.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
    BaseAnimationRenderer.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
    BaseAnimationRenderer.prototype.setAttribute = function (el, name, value, namespace) {
        this.delegate.setAttribute(el, name, value, namespace);
    };
    BaseAnimationRenderer.prototype.removeAttribute = function (el, name, namespace) {
        this.delegate.removeAttribute(el, name, namespace);
    };
    BaseAnimationRenderer.prototype.addClass = function (el, name) { this.delegate.addClass(el, name); };
    BaseAnimationRenderer.prototype.removeClass = function (el, name) { this.delegate.removeClass(el, name); };
    BaseAnimationRenderer.prototype.setStyle = function (el, style, value, flags) {
        this.delegate.setStyle(el, style, value, flags);
    };
    BaseAnimationRenderer.prototype.removeStyle = function (el, style, flags) {
        this.delegate.removeStyle(el, style, flags);
    };
    BaseAnimationRenderer.prototype.setProperty = function (el, name, value) {
        if (name.charAt(0) == ANIMATION_PREFIX && name == DISABLE_ANIMATIONS_FLAG) {
            this.disableAnimations(el, !!value);
        }
        else {
            this.delegate.setProperty(el, name, value);
        }
    };
    BaseAnimationRenderer.prototype.setValue = function (node, value) { this.delegate.setValue(node, value); };
    BaseAnimationRenderer.prototype.listen = function (target, eventName, callback) {
        return this.delegate.listen(target, eventName, callback);
    };
    BaseAnimationRenderer.prototype.disableAnimations = function (element, value) {
        this.engine.disableAnimations(element, value);
    };
    return BaseAnimationRenderer;
}());
var AnimationRenderer = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(AnimationRenderer, _super);
    function AnimationRenderer(factory, namespaceId, delegate, engine) {
        var _this = _super.call(this, namespaceId, delegate, engine) || this;
        _this.factory = factory;
        _this.namespaceId = namespaceId;
        return _this;
    }
    AnimationRenderer.prototype.setProperty = function (el, name, value) {
        if (name.charAt(0) == ANIMATION_PREFIX) {
            if (name.charAt(1) == '.' && name == DISABLE_ANIMATIONS_FLAG) {
                value = value === undefined ? true : !!value;
                this.disableAnimations(el, value);
            }
            else {
                this.engine.process(this.namespaceId, el, name.substr(1), value);
            }
        }
        else {
            this.delegate.setProperty(el, name, value);
        }
    };
    AnimationRenderer.prototype.listen = function (target, eventName, callback) {
        var _this = this;
        var _a;
        if (eventName.charAt(0) == ANIMATION_PREFIX) {
            var element = resolveElementFromTarget(target);
            var name_1 = eventName.substr(1);
            var phase = '';
            // @listener.phase is for trigger animation callbacks
            // @@listener is for animation builder callbacks
            if (name_1.charAt(0) != ANIMATION_PREFIX) {
                _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(parseTriggerCallbackName(name_1), 2), name_1 = _a[0], phase = _a[1];
            }
            return this.engine.listen(this.namespaceId, element, name_1, phase, function (event) {
                var countId = event['_data'] || -1;
                _this.factory.scheduleListenerCallback(countId, callback, event);
            });
        }
        return this.delegate.listen(target, eventName, callback);
    };
    return AnimationRenderer;
}(BaseAnimationRenderer));
function resolveElementFromTarget(target) {
    switch (target) {
        case 'body':
            return document.body;
        case 'document':
            return document;
        case 'window':
            return window;
        default:
            return target;
    }
}
function parseTriggerCallbackName(triggerName) {
    var dotIndex = triggerName.indexOf('.');
    var trigger = triggerName.substring(0, dotIndex);
    var phase = triggerName.substr(dotIndex + 1);
    return [trigger, phase];
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var InjectableAnimationEngine = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(InjectableAnimationEngine, _super);
    function InjectableAnimationEngine(doc, driver, normalizer) {
        return _super.call(this, doc.body, driver, normalizer) || this;
    }
    InjectableAnimationEngine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Injectable"])(),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_5__angular_common__["DOCUMENT"])),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [Object, __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["b" /* AnimationDriver */], __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["c" /* ɵAnimationStyleNormalizer */]])
    ], InjectableAnimationEngine);
    return InjectableAnimationEngine;
}(__WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["a" /* ɵAnimationEngine */]));
function instantiateSupportedAnimationDriver() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["d" /* ɵsupportsWebAnimations */])() ? new __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["e" /* ɵWebAnimationsDriver */]() : new __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["f" /* ɵCssKeyframesDriver */]();
}
function instantiateDefaultStyleNormalizer() {
    return new __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["g" /* ɵWebAnimationsStyleNormalizer */]();
}
function instantiateRendererFactory(renderer, engine, zone) {
    return new AnimationRendererFactory(renderer, engine, zone);
}
/**
 * @experimental Animation support is experimental.
 */
var ANIMATION_MODULE_TYPE = new __WEBPACK_IMPORTED_MODULE_2__angular_core__["InjectionToken"]('AnimationModuleType');
var SHARED_ANIMATION_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_animations__["AnimationBuilder"], useClass: BrowserAnimationBuilder },
    { provide: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["c" /* ɵAnimationStyleNormalizer */], useFactory: instantiateDefaultStyleNormalizer },
    { provide: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["a" /* ɵAnimationEngine */], useClass: InjectableAnimationEngine }, {
        provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["RendererFactory2"],
        useFactory: instantiateRendererFactory,
        deps: [__WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["ɵDomRendererFactory2"], __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["a" /* ɵAnimationEngine */], __WEBPACK_IMPORTED_MODULE_2__angular_core__["NgZone"]]
    }
];
/**
 * Separate providers from the actual module so that we can do a local modification in Google3 to
 * include them in the BrowserModule.
 */
var BROWSER_ANIMATIONS_PROVIDERS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([
    { provide: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["b" /* AnimationDriver */], useFactory: instantiateSupportedAnimationDriver },
    { provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }
], SHARED_ANIMATION_PROVIDERS);
/**
 * Separate providers from the actual module so that we can do a local modification in Google3 to
 * include them in the BrowserTestingModule.
 */
var BROWSER_NOOP_ANIMATIONS_PROVIDERS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([
    { provide: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["b" /* AnimationDriver */], useClass: __WEBPACK_IMPORTED_MODULE_4__angular_animations_browser__["h" /* ɵNoopAnimationDriver */] },
    { provide: ANIMATION_MODULE_TYPE, useValue: 'NoopAnimations' }
], SHARED_ANIMATION_PROVIDERS);

/**
 * Exports `BrowserModule` with additional [dependency-injection providers](guide/glossary#provider)
 * for use with animations. See [Animations](guide/animations).
 * @experimental
 */
var BrowserAnimationsModule = /** @class */ (function () {
    function BrowserAnimationsModule() {
    }
    BrowserAnimationsModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["NgModule"])({
            exports: [__WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["BrowserModule"]],
            providers: BROWSER_ANIMATIONS_PROVIDERS,
        })
    ], BrowserAnimationsModule);
    return BrowserAnimationsModule;
}());
/**
 * A null player that must be imported to allow disabling of animations.
 * @experimental
 */
var NoopAnimationsModule = /** @class */ (function () {
    function NoopAnimationsModule() {
    }
    NoopAnimationsModule = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_core__["NgModule"])({
            exports: [__WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["BrowserModule"]],
            providers: BROWSER_NOOP_ANIMATIONS_PROVIDERS,
        })
    ], NoopAnimationsModule);
    return NoopAnimationsModule;
}());

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=animations.js.map


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(4);
var activate_email_component_1 = __webpack_require__(136);
var activate_account_component_1 = __webpack_require__(135);
var app_constants_1 = __webpack_require__(11);
exports.activateEmailRoute = {
    path: 'activate-email',
    component: activate_email_component_1.ActivateEmailComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Activation" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};
exports.activateAccountRoute = [
    {
        path: 'activate-account',
        component: activate_account_component_1.ActivateAccountComponent,
        data: {
            needAuthentication: false,
            pageTitle: "Activation" + app_constants_1.PAGE_TITLE_SUFFIX
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'activate',
        component: activate_account_component_1.ActivateAccountComponent,
        data: {
            needAuthentication: false,
            pageTitle: "Activation" + app_constants_1.PAGE_TITLE_SUFFIX
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(28);
var util_2 = __webpack_require__(47);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var CredentialsComponent = /** @class */ (function () {
    function CredentialsComponent(form, cd) {
        this.form = form;
        this.cd = cd;
        this.isNewAccount = true;
        this.isFCUser = false;
        this.showsPWFields = false;
        this.specialCharacters = '~ \" # \' { ( [ - | è ` _ ç ^ à @ ) ] ° = } + ^ ¨ $ £ ¤ % ù * µ ! § / : ; . , ? < >';
    }
    CredentialsComponent.prototype.ngOnInit = function () {
        this.confirmEmail = this.confirmEmail || {};
        this.confirmEmail.confirmEmail = this.confirmEmail.confirmEmail || this.credentials.email;
        this.isFCUser = !util_2.isNullOrUndefined(this.credentials.franceConnectSubscription);
        this.isPasswordRequired = this.isNewAccount;
    };
    CredentialsComponent.prototype.ngAfterContentChecked = function () {
        this.cd.detectChanges();
    };
    CredentialsComponent.prototype.updateValueAndValidity = function (controlNames) {
        var _this = this;
        (controlNames || [])
            .map(function (controlName) { return _this.form.controls[controlName]; })
            .filter(function (control) { return control && control.touched; })
            .forEach(function (control) { return control.updateValueAndValidity(); });
    };
    CredentialsComponent.prototype.checkRequiredPasswords = function (_event) {
        this.isPasswordRequired =
            this.isNewAccount || !util_1.isEmpty(this.credentials.oldPassword || this.credentials.password || this.confirmPassword);
        if (!this.isPasswordRequired) {
            this.credentials.password = null;
            this.credentials.oldPassword = null;
        }
        this.cd.detectChanges();
    };
    CredentialsComponent.prototype.showPWFields = function () {
        this.showsPWFields = !this.showsPWFields;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], CredentialsComponent.prototype, "confirmEmail", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], CredentialsComponent.prototype, "credentials", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], CredentialsComponent.prototype, "isRepresentant", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], CredentialsComponent.prototype, "isNewAccount", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], CredentialsComponent.prototype, "isCreateAccountBtnClicked", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], CredentialsComponent.prototype, "emailRollBack", void 0);
    CredentialsComponent = __decorate([
        core_1.Component({
            selector: 'jhi-credentials',
            template: __webpack_require__(765),
            styles: [__webpack_require__(866)],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        }),
        __metadata("design:paramtypes", [forms_1.NgForm, core_1.ChangeDetectorRef])
    ], CredentialsComponent);
    return CredentialsComponent;
}());
exports.CredentialsComponent = CredentialsComponent;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var fc_auth_redirect_component_1 = __webpack_require__(139);
exports.fcAuthRedirectRoute = {
    path: 'franceconnect/userinfo',
    component: fc_auth_redirect_component_1.FcAuthRedirectComponent,
    data: {
        needAuthentication: false,
        pageTitle: "France Connect" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(133));
__export(__webpack_require__(134));
__export(__webpack_require__(138));
__export(__webpack_require__(150));
__export(__webpack_require__(143));
__export(__webpack_require__(152));
__export(__webpack_require__(51));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var password_reset_finish_component_1 = __webpack_require__(140);
exports.passwordResetFinishRoute = {
    path: 'reset/finish',
    component: password_reset_finish_component_1.PasswordResetFinishComponent,
    data: {
        needAuthentication: false,
        pageTitle: "R\u00E9initialisation du mot de passe" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(28);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var password_validation_error_type_1 = __webpack_require__(145);
var PasswordStrengthBarComponent = /** @class */ (function () {
    function PasswordStrengthBarComponent(form) {
        this.form = form;
        this.minLength = false;
        this.lowercase = false;
        this.uppercase = false;
        this.number = false;
        this.special = false;
        this.confirmationValide = false;
    }
    PasswordStrengthBarComponent.prototype.ngAfterContentChecked = function () {
        var passwordInput = this.form.controls[this.passwordInputName];
        this.minLength = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, password_validation_error_type_1.ValidationErrorType.MIN_LENGTH);
        this.lowercase = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, password_validation_error_type_1.ValidationErrorType.LOWERCASE);
        this.uppercase = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, password_validation_error_type_1.ValidationErrorType.UPPERCASE);
        this.number = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, password_validation_error_type_1.ValidationErrorType.NUMBER);
        this.special = this.hasNewValue(passwordInput) && !this.hasError(passwordInput, password_validation_error_type_1.ValidationErrorType.SPECIAL);
        var confirmPassword = this.form.controls[this.confirmPasswordName];
        this.confirmationValide = confirmPassword && confirmPassword.dirty && confirmPassword.valid;
    };
    PasswordStrengthBarComponent.prototype.hasError = function (control, errorKey) {
        return control && control.errors && control.errors[errorKey];
    };
    PasswordStrengthBarComponent.prototype.hasNewValue = function (control) {
        return control && control.dirty && !util_1.isEmpty(control.value);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PasswordStrengthBarComponent.prototype, "passwordInputName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PasswordStrengthBarComponent.prototype, "confirmPasswordName", void 0);
    PasswordStrengthBarComponent = __decorate([
        core_1.Component({
            selector: 'jhi-password-strength-bar',
            template: "\n        <div class=\"row no-indent col-12\" id=\"passwordChecks\">\n            <div\n                id=\"passwordChecks-left\"\n                class=\"col-lg-6\"\n                [class.neutre]=\"!form.dirty\">\n                <ul>\n                    <li [class.valid]=\"minLength\">\n                        Longueur minimale 12 caract\u00E8res\n                    </li>\n                    <li [class.valid]=\"lowercase\">\n                        Contient au moins une lettre minuscule\n                    </li>\n                    <li [class.valid]=\"uppercase\">\n                        Contient au moins une lettre majuscule\n                    </li>\n                    <li [class.valid]=\"number\">Contient au moins un chiffre</li>\n                    <li [class.valid]=\"special\">\n                        Contient au moins un caract\u00E8re parmi les \u00E9l\u00E9ments\n                        suivants : \u00B2 & \u00E9 ~ \" # ' {{ \"{\" }} ( [ - | \u00E8 ` _ \u00E7 ^ \u00E0\n                        @ ) ] \u00B0 = {{ \"}\" }} + ^ \u00A8 $ \u00A3 \u00A4 % \u00F9 * \u00B5 ! \u00A7 / : ; . , ?\n                        < >\n                    </li>\n                </ul>\n            </div>\n        </div>\n    ",
            styles: [__webpack_require__(869)],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        }),
        __metadata("design:paramtypes", [forms_1.NgForm])
    ], PasswordStrengthBarComponent);
    return PasswordStrengthBarComponent;
}());
exports.PasswordStrengthBarComponent = PasswordStrengthBarComponent;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = __webpack_require__(4);
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(19);
var PaginationConfig = /** @class */ (function () {
    function PaginationConfig(config) {
        this.config = config;
        config.boundaryLinks = true;
        config.maxSize = 5;
        config.pageSize = shared_1.ITEMS_PER_PAGE;
        config.size = 'sm';
    }
    PaginationConfig = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbPaginationConfig])
    ], PaginationConfig);
    return PaginationConfig;
}());
exports.PaginationConfig = PaginationConfig;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(4);
var inactivity_service_1 = __webpack_require__(92);
var operators_1 = __webpack_require__(7);
var AuthExpiredInterceptor = /** @class */ (function () {
    function AuthExpiredInterceptor(injector, stateStorageService, inactivityService) {
        this.injector = injector;
        this.stateStorageService = stateStorageService;
        this.inactivityService = inactivityService;
    }
    AuthExpiredInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        return next.handle(req).pipe(operators_1.tap(function (event) {
            if (event instanceof http_1.HttpResponse) {
                if (event.url && event.url.indexOf('api/remember-me') === -1) {
                    _this.inactivityService.registerUserActivity();
                }
            }
            return event;
        }, function (error) {
            if (error.status === 401 &&
                error.url &&
                error.url.indexOf('/api/authentication') === -1 &&
                error.url.indexOf('/api/account') === -1) {
                _this.stateStorageService.storePreviousState(_this.stateStorageService.getDestinationState());
                _this.injector.get(shared_1.LoginService).logout(); // NOSONAR
            }
            throw error;
        }));
    };
    AuthExpiredInterceptor = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [core_1.Injector,
            shared_1.StateStorageService,
            inactivity_service_1.InactivityService])
    ], AuthExpiredInterceptor);
    return AuthExpiredInterceptor;
}());
exports.AuthExpiredInterceptor = AuthExpiredInterceptor;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__(10);
var core_1 = __webpack_require__(0);
var draft_depot_requete_service_1 = __webpack_require__(16);
var error_constants_1 = __webpack_require__(60);
var http_code_constants_1 = __webpack_require__(71);
var operators_1 = __webpack_require__(7);
var application_constants_1 = __webpack_require__(191);
var DraftHeaderInterceptor = /** @class */ (function () {
    function DraftHeaderInterceptor(injector) {
        this.injector = injector;
        this.draftUrl = '/api/my-draft-requete';
    }
    DraftHeaderInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        if (req.url.includes(this.draftUrl)) {
            var version = this.injector.get(draft_depot_requete_service_1.DraftDepotRequeteService)
                .getDepotRequeteStateVersion();
            /* console.log('===> version: ', version); */
            req = req.clone({
                headers: req.headers.set(application_constants_1.HEADER_DRAFT_VERSION, "" + version)
            });
        }
        return next.handle(req).pipe(operators_1.tap(function (event) {
            if (event instanceof http_1.HttpResponse && event.url.includes(_this.draftUrl)) {
                var ver = _this.injector
                    .get(draft_depot_requete_service_1.DraftDepotRequeteService)
                    .updateVersionWithResponseHeader(event.headers);
                console.log('===> response - version: ', ver);
            }
        }), operators_1.catchError(function (error) {
            if (error && error.url && error.url.includes(_this.draftUrl)) {
                _this.processError(error);
            }
            throw error;
        }));
    };
    DraftHeaderInterceptor.prototype.processError = function (error) {
        var errorBody = error;
        if (error.status === http_code_constants_1.HttpCodeEnum.CONFLICT &&
            errorBody && errorBody.code === error_constants_1.ErrorEnum.INVALID_DRAFT_VERSION) {
            this.injector
                .get(draft_depot_requete_service_1.DraftDepotRequeteService)
                .displayDraftModal();
        }
    };
    DraftHeaderInterceptor = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [core_1.Injector])
    ], DraftHeaderInterceptor);
    return DraftHeaderInterceptor;
}());
exports.DraftHeaderInterceptor = DraftHeaderInterceptor;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var depot_requete_data_1 = __webpack_require__(59);
var StepDetail = /** @class */ (function () {
    function StepDetail(stepDetailInit) {
        this.route = stepDetailInit.route;
        this.breadTitle = stepDetailInit.breadTitle;
        this._pageTitle = stepDetailInit.pageTitle;
    }
    Object.defineProperty(StepDetail.prototype, "pageTitle", {
        get: function () {
            return this._pageTitle || this.breadTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StepDetail.prototype, "fullRoute", {
        get: function () {
            return depot_requete_data_1.depotRequeteBasePath + "/" + this.route;
        },
        enumerable: true,
        configurable: true
    });
    return StepDetail;
}());
exports.StepDetail = StepDetail;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng2_dragula_1 = __webpack_require__(46);
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var shared_1 = __webpack_require__(4);
var draft_modal_component_1 = __webpack_require__(96);
var depot_requete_component_1 = __webpack_require__(153);
var depot_requete_route_1 = __webpack_require__(154);
var draft_depot_requete_service_1 = __webpack_require__(16);
var draft_requete_resolver_1 = __webpack_require__(155);
var load_draft_component_1 = __webpack_require__(156);
var steps_1 = __webpack_require__(157);
var a11y_1 = __webpack_require__(44);
var TelerecourspnrDepotRequeteModule = /** @class */ (function () {
    function TelerecourspnrDepotRequeteModule() {
    }
    TelerecourspnrDepotRequeteModule = __decorate([
        core_1.NgModule({
            imports: [
                a11y_1.A11yModule,
                ng2_dragula_1.DragulaModule,
                shared_1.TelerecourspnrSharedModule,
                router_1.RouterModule.forRoot([depot_requete_route_1.DEPOT_REQUETE_ROUTE], { useHash: true })
            ],
            declarations: [
                depot_requete_component_1.DepotRequeteComponent,
                steps_1.AvertissementComponent,
                steps_1.RequerantsComponent,
                steps_1.JuridictionComponent,
                steps_1.RequeteComponent,
                steps_1.UrgenceRequeteSectionComponent,
                steps_1.ContentieuxSocialSectionComponent,
                steps_1.JustificatifsComponent,
                steps_1.RecapitulatifComponent,
                steps_1.JuridictionSectionComponent,
                steps_1.SiteJuridictionSectionComponent,
                steps_1.TypeActeAttaqueSectionComponent,
                steps_1.TypeActeAttaqueInfoComponent,
                steps_1.TypeActeAttaqueAvertissementComponent,
                steps_1.RequerantTypeSectionComponent,
                steps_1.AddRequerantSectionComponent,
                steps_1.SearchFormComponent,
                steps_1.ResultFormComponent,
                steps_1.AddedRequerantComponent,
                steps_1.EditFormComponent,
                steps_1.AddRequerantHeaderComponent,
                steps_1.ActeAttaqueComponent,
                steps_1.ReclamationPrealableComponent,
                load_draft_component_1.LoadDraftComponent,
            ],
            entryComponents: [draft_modal_component_1.DraftModalComponent],
            providers: [draft_depot_requete_service_1.DraftDepotRequeteService, draft_requete_resolver_1.DraftRequeteResolver]
        })
    ], TelerecourspnrDepotRequeteModule);
    return TelerecourspnrDepotRequeteModule;
}());
exports.TelerecourspnrDepotRequeteModule = TelerecourspnrDepotRequeteModule;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(7);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var draft_depot_requete_service_1 = __webpack_require__(16);
var AvertissementComponent = /** @class */ (function () {
    function AvertissementComponent(draftDepotRequeteService) {
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.isSubmitted = false;
        // For validation only
        this._cgu = false;
        this._teleprocedures = false;
        this.cguTypeEnum = "cgu" /* CGU_DEPOT_REQUETE */;
        this.previousStep = new core_1.EventEmitter();
        this.nextStep = new core_1.EventEmitter();
        this.hideAlertDraft = new core_1.EventEmitter();
        this.showErrorAlertDraft = new core_1.EventEmitter();
    }
    AvertissementComponent.prototype.ngOnInit = function () {
        this.hideAlertDraft.emit();
    };
    AvertissementComponent.prototype.ngAfterViewInit = function () {
        document.getElementById('logo-link').focus();
    };
    AvertissementComponent.prototype.next = function () {
        var _this = this;
        this.isSubmitted = true;
        if (this.form.valid) {
            return this.draftDepotRequeteService.acceptCgu().pipe(operators_1.tap(function () {
                _this.nextStep.emit();
            }, function (error) {
                _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
            }));
        }
    };
    AvertissementComponent.prototype.previous = function () {
        this.previousStep.emit();
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AvertissementComponent.prototype, "previousStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AvertissementComponent.prototype, "nextStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AvertissementComponent.prototype, "hideAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AvertissementComponent.prototype, "showErrorAlertDraft", void 0);
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], AvertissementComponent.prototype, "form", void 0);
    AvertissementComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(775),
            styles: [__webpack_require__(875)]
        }),
        __metadata("design:paramtypes", [draft_depot_requete_service_1.DraftDepotRequeteService])
    ], AvertissementComponent);
    return AvertissementComponent;
}());
exports.AvertissementComponent = AvertissementComponent;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(420));
__export(__webpack_require__(422));
__export(__webpack_require__(425));
__export(__webpack_require__(424));
__export(__webpack_require__(423));
__export(__webpack_require__(421));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(5);
var parameters_service_1 = __webpack_require__(25);
var JuridictionSectionComponent = /** @class */ (function (_super) {
    __extends(JuridictionSectionComponent, _super);
    function JuridictionSectionComponent(injector, parametersService) {
        var _this = _super.call(this, injector) || this;
        _this.parametersService = parametersService;
        _this.juridictionTexts = [
            {
                value: 'TA',
                title: 'Tribunal administratif',
                description: 'Les tribunaux administratifs sont les juridictions de droit commun compétentes en première instance. ' +
                    'C\'est à eux que le requérant doit d\'abord s\'adresser.'
            },
            {
                value: 'CAA',
                title: 'Cour administrative d\'appel',
                description: 'Les cours administratives d\'appel sont les juridictions compétentes pour statuer en appel, ' +
                    'à la demande d\'une personne privée ou d\'une administration, ' +
                    'contre un jugement de tribunal administratif. Elles peuvent, à titre exceptionnel, être juges de premier ressort. '
            },
            {
                value: 'CE',
                title: 'Conseil d\'État',
                description: 'Principalement juge de cassation des décisions rendues par les cours administratives d\'appel, ' +
                    'les tribunaux administratifs et les juridictions administratives spécialisées, le Conseil d’État est également, ' +
                    'à titre exceptionnel, juge d\'appel et juge de premier ressort.'
            }
        ];
        _this.state = { index: 1 };
        return _this;
    }
    JuridictionSectionComponent_1 = JuridictionSectionComponent;
    JuridictionSectionComponent.prototype.ngOnInit = function () {
        this.loadTypeJuridictions();
        console.log('state', this.state);
    };
    JuridictionSectionComponent.prototype.ngAfterViewInit = function () {
        document.getElementById('logo-link').focus();
    };
    JuridictionSectionComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        _super.prototype.ngOnDestroy.call(this);
    };
    JuridictionSectionComponent.prototype.modelValueChanged = function (value) {
        if (!value) {
            return this.onSetJuridiction(this.juridictionTexts[0].value);
        }
        if (typeof value !== 'string') {
            this.juridiction = value;
            this.selectedJuridictionCode = value.code;
        }
        else {
            this.onSetJuridiction('TA');
        } // TODO: This is a temporary patch, to be fixed @youssef
    };
    JuridictionSectionComponent.prototype.onSetJuridiction = function (code) {
        this.onChange(this.typeJuridictions.find(function (juridiction) { return juridiction.code === code; }));
    };
    JuridictionSectionComponent.prototype.loadTypeJuridictions = function () {
        var _this = this;
        this.subscription = this.parametersService.getParameters()
            .subscribe(function (parameters) { return (_this.typeJuridictions = parameters.juridictions); });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], JuridictionSectionComponent.prototype, "state", void 0);
    JuridictionSectionComponent = JuridictionSectionComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-juridiction-section',
            template: __webpack_require__(776),
            styles: [__webpack_require__(876)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: JuridictionSectionComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector, parameters_service_1.ParametersService])
    ], JuridictionSectionComponent);
    return JuridictionSectionComponent;
    var JuridictionSectionComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.JuridictionSectionComponent = JuridictionSectionComponent;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(7);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var shared_1 = __webpack_require__(4);
var error_service_1 = __webpack_require__(22);
var draft_depot_requete_service_1 = __webpack_require__(16);
var JuridictionComponent = /** @class */ (function () {
    function JuridictionComponent(scrollToService, errorService, draftDepotRequeteService) {
        this.scrollToService = scrollToService;
        this.errorService = errorService;
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.scrollToError = false;
        this.requerantAutoSaveSuccess = false;
        this.autoSaveError = false;
        this.saveDraftSuccess = false;
        this.saveDraftError = false;
        this.previousStep = new core_1.EventEmitter();
        this.nextStep = new core_1.EventEmitter();
        this.hideAlertDraft = new core_1.EventEmitter();
        this.showErrorAlertDraft = new core_1.EventEmitter();
        this.showSuccessAlertDraft = new core_1.EventEmitter();
        this.showAutoSaveSuccessAlertDraft = new core_1.EventEmitter();
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        if (this.depotRequeteState.isStepRequerantAutoSaveSucceed && !this.depotRequeteState.isStepJuridictionAutoSaveSucceed) {
            this.requerantAutoSaveSuccess = true;
            this.autoSaveTime = this.draftDepotRequeteService.getAutoSaveTime();
            this.draftDepotRequeteService.sendData(this.autoSaveTime);
        }
    }
    JuridictionComponent.prototype.ngOnInit = function () {
        this.hideAlertDraft.emit();
        if (this.requerantAutoSaveSuccess) {
            this.showAutoSaveSuccessAlertDraft.emit();
        }
    };
    JuridictionComponent.prototype.ngAfterViewInit = function () {
        document.getElementById('logo-link').focus();
    };
    JuridictionComponent.prototype.ngAfterViewChecked = function () {
        if (this.scrollTarget) {
            this.scrollToService.scrollBySelector(this.scrollTarget);
            this.scrollTarget = null;
        }
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstError();
            this.scrollToError = false;
        }
    };
    JuridictionComponent.prototype.next = function () {
        var _this = this;
        this.hideAlertDraft.emit();
        if (this.form.valid) {
            return this.saveJuridiction().pipe(operators_1.tap(function () {
                _this.depotRequeteState.isStepJuridictionAutoSaveSucceed = true;
                _this.nextStep.emit();
            }, function (error) {
                _this.autoSaveError = true;
                _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
            }));
        }
        else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    };
    JuridictionComponent.prototype.saveDraft = function () {
        var _this = this;
        this.hideAlertDraft.emit();
        return this.saveJuridiction().pipe(operators_1.tap(function () {
            _this.saveDraftSuccess = true;
            _this.requerantAutoSaveSuccess = false;
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.saveDraftError = true;
            _this.requerantAutoSaveSuccess = false;
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        }));
    };
    JuridictionComponent.prototype.saveJuridiction = function () {
        return this.draftDepotRequeteService.saveJuridiction();
    };
    JuridictionComponent.prototype.saveDraftAgain = function () {
        var _this = this;
        this.saveJuridiction().subscribe(function () {
            _this.saveDraftSuccess = true;
            _this.requerantAutoSaveSuccess = false;
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.saveDraftError = true;
            _this.requerantAutoSaveSuccess = false;
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        });
    };
    JuridictionComponent.prototype.close = function () {
        this.autoSaveError = false;
    };
    JuridictionComponent.prototype.previous = function () {
        this.depotRequeteState.isStepJuridictionAutoSaveSucceed = false;
        this.previousStep.emit();
    };
    JuridictionComponent.prototype.onTypeJuridictionChange = function (typeJuridiction) {
        this.resetFields();
        if (typeJuridiction.code === "CE" /* CE */) {
            this.depotRequeteState.siteJuridiction = typeJuridiction.siteJuridictions[0];
            this.scrollTarget = '.jhi-juridiction-section';
        }
        else {
            this.scrollTarget = '.jhi-juridiction-section';
        }
    };
    JuridictionComponent.prototype.resetFields = function () {
        this.depotRequeteState.siteJuridiction = undefined;
        this.resetField('site-juridiction');
        this.depotRequeteState.urgenceRequete = undefined;
        /* this.resetField('urgence-requete'); */
        this.depotRequeteState.typeActeAttaque = undefined;
        this.resetField('type-acte-attaque');
    };
    JuridictionComponent.prototype.displaySiteJuridictionSection = function () {
        return (this.depotRequeteState.typeJuridiction &&
            this.depotRequeteState.typeJuridiction.code !== "CE" /* CE */);
    };
    JuridictionComponent.prototype.displayTypeActeAttaqueSection = function () {
        return Boolean(this.depotRequeteState.typeJuridiction &&
            this.depotRequeteState.typeJuridiction.code === "CAA" /* CAA */ &&
            this.depotRequeteState.siteJuridiction);
    };
    JuridictionComponent.prototype.resetField = function (fieldName) {
        var field = this.form.controls[fieldName];
        if (field) {
            field.markAsUntouched();
            field.markAsPristine();
        }
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JuridictionComponent.prototype, "previousStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JuridictionComponent.prototype, "nextStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JuridictionComponent.prototype, "hideAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JuridictionComponent.prototype, "showErrorAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JuridictionComponent.prototype, "showSuccessAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JuridictionComponent.prototype, "showAutoSaveSuccessAlertDraft", void 0);
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], JuridictionComponent.prototype, "form", void 0);
    JuridictionComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(777),
            styles: [__webpack_require__(877)]
        }),
        __metadata("design:paramtypes", [shared_1.ScrollToService,
            error_service_1.ErrorService,
            draft_depot_requete_service_1.DraftDepotRequeteService])
    ], JuridictionComponent);
    return JuridictionComponent;
}());
exports.JuridictionComponent = JuridictionComponent;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var type_juridiction_1 = __webpack_require__(445);
var forms_1 = __webpack_require__(5);
var SiteJuridictionSectionComponent = /** @class */ (function (_super) {
    __extends(SiteJuridictionSectionComponent, _super);
    function SiteJuridictionSectionComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.state = { index: 2, isHelpOpen: true, isToggleable: false };
        return _this;
    }
    SiteJuridictionSectionComponent_1 = SiteJuridictionSectionComponent;
    SiteJuridictionSectionComponent.prototype.modelValueChanged = function (value) {
        this.siteJuridictionId = value && value.id.toString();
        this.siteJuridiction = value;
    };
    SiteJuridictionSectionComponent.prototype.onSiteJuridictionChange = function (value) {
        this.onChange(this.siteJuridiction = this.typeJuridiction.siteJuridictions.find(function (siteJuridiction) { return siteJuridiction.id === +value; }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", type_juridiction_1.TypeJuridiction)
    ], SiteJuridictionSectionComponent.prototype, "typeJuridiction", void 0);
    SiteJuridictionSectionComponent = SiteJuridictionSectionComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-site-juridiction-section',
            template: __webpack_require__(778),
            styles: [__webpack_require__(878)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: SiteJuridictionSectionComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector])
    ], SiteJuridictionSectionComponent);
    return SiteJuridictionSectionComponent;
    var SiteJuridictionSectionComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.SiteJuridictionSectionComponent = SiteJuridictionSectionComponent;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var site_juridiction_1 = __webpack_require__(160);
var TypeActeAttaqueAvertissementComponent = /** @class */ (function () {
    function TypeActeAttaqueAvertissementComponent() {
    }
    TypeActeAttaqueAvertissementComponent.prototype.ngOnInit = function () {
    };
    TypeActeAttaqueAvertissementComponent.prototype.isOnlyProcessedByCA44 = function () {
        var _this = this;
        return ['DRIPERM', 'DRORPEPSM', 'DRCIPPTD'].some(function (code) { return code === _this.typeActeAttaqueCode; });
    };
    TypeActeAttaqueAvertissementComponent.prototype.isOnlyProcessedByCA75 = function () {
        var _this = this;
        return ['AMTRRS', 'ADGARSPE', 'DARCARLC', 'DMCRVEC', 'DACNCP', 'OUAJOP'].some(function (code) { return code === _this.typeActeAttaqueCode; });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TypeActeAttaqueAvertissementComponent.prototype, "typeActeAttaqueCode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", site_juridiction_1.SiteJuridiction)
    ], TypeActeAttaqueAvertissementComponent.prototype, "siteJuridiction", void 0);
    TypeActeAttaqueAvertissementComponent = __decorate([
        core_1.Component({
            selector: 'jhi-type-acte-attaque-avertissement',
            template: __webpack_require__(779),
            styles: [__webpack_require__(879)]
        })
    ], TypeActeAttaqueAvertissementComponent);
    return TypeActeAttaqueAvertissementComponent;
}());
exports.TypeActeAttaqueAvertissementComponent = TypeActeAttaqueAvertissementComponent;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var TypeActeAttaqueInfoComponent = /** @class */ (function () {
    function TypeActeAttaqueInfoComponent() {
    }
    TypeActeAttaqueInfoComponent.prototype.ngOnInit = function () {
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TypeActeAttaqueInfoComponent.prototype, "typeActeAttaqueCode", void 0);
    TypeActeAttaqueInfoComponent = __decorate([
        core_1.Component({
            selector: 'jhi-type-acte-attaque-info',
            template: __webpack_require__(780),
            styles: [__webpack_require__(880)]
        })
    ], TypeActeAttaqueInfoComponent);
    return TypeActeAttaqueInfoComponent;
}());
exports.TypeActeAttaqueInfoComponent = TypeActeAttaqueInfoComponent;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var base_control_value_accessor_1 = __webpack_require__(20);
var site_juridiction_1 = __webpack_require__(160);
var parameters_service_1 = __webpack_require__(25);
var TypeActeAttaqueSectionComponent = /** @class */ (function (_super) {
    __extends(TypeActeAttaqueSectionComponent, _super);
    function TypeActeAttaqueSectionComponent(injector, parametersService) {
        var _this = _super.call(this, injector) || this;
        _this.parametersService = parametersService;
        _this.state = { index: 3 };
        _this.typeActeAttaqueFaqItemRank = '141';
        return _this;
    }
    TypeActeAttaqueSectionComponent_1 = TypeActeAttaqueSectionComponent;
    TypeActeAttaqueSectionComponent.prototype.ngOnInit = function () {
        this.loadTypeActeAttaques();
    };
    TypeActeAttaqueSectionComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        _super.prototype.ngOnDestroy.call(this);
    };
    TypeActeAttaqueSectionComponent.prototype.loadTypeActeAttaques = function () {
        var _this = this;
        this.subscription = this.parametersService.getParameters()
            .subscribe(function (parameters) {
            return _this.typeActesAttaques = parameters.typeActeAttaques
                .filter(function (taa) { return ['AMTRRS', 'ADGARSPE', 'DARCARLC', 'DMCRVEC', 'DACNCP', 'OUAJOP', 'AUTRES'].includes(taa.code); });
        });
    };
    TypeActeAttaqueSectionComponent.prototype.modelValueChanged = function (value) {
        this.typeActeAttaqueCode = value;
        this.typeActeAttaque = this.typeActesAttaques.find(function (typeActeAttaque) { return typeActeAttaque.code === value; });
    };
    // TODO: Find why this method is not Fired and adapt code
    TypeActeAttaqueSectionComponent.prototype.onTypeActesAttaqueChange = function (typeActeAttaqueCode) {
        this.onChange(this.typeActeAttaque = this.typeActesAttaques.find(function (typeActeAttaque) { return typeActeAttaque.code === typeActeAttaqueCode; }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", site_juridiction_1.SiteJuridiction)
    ], TypeActeAttaqueSectionComponent.prototype, "siteJuridiction", void 0);
    TypeActeAttaqueSectionComponent = TypeActeAttaqueSectionComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-type-acte-attaque-section',
            template: __webpack_require__(781),
            styles: [__webpack_require__(881)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: TypeActeAttaqueSectionComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector, parameters_service_1.ParametersService])
    ], TypeActeAttaqueSectionComponent);
    return TypeActeAttaqueSectionComponent;
    var TypeActeAttaqueSectionComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.TypeActeAttaqueSectionComponent = TypeActeAttaqueSectionComponent;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = __webpack_require__(5);
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var piece_jointe_1 = __webpack_require__(38);
var file_uploader_component_1 = __webpack_require__(52);
var draft_depot_requete_service_1 = __webpack_require__(16);
var a11y_1 = __webpack_require__(44);
var ng2_dragula_1 = __webpack_require__(46);
var ActeAttaqueComponent = /** @class */ (function (_super) {
    __extends(ActeAttaqueComponent, _super);
    function ActeAttaqueComponent(injector, draftDepotRequeteService, liveAnnouncer, dragulaService) {
        var _this = _super.call(this, injector) || this;
        _this.draftDepotRequeteService = draftDepotRequeteService;
        _this.liveAnnouncer = liveAnnouncer;
        _this.dragulaService = dragulaService;
        _this.acteAttaques = [];
        // --- drag n drop keyboard accessible
        _this.selectedItem = null;
        _this.dragulaService.drop.subscribe(function () {
            _this.liveAnnouncer.announce('élément relaché');
        });
        _this.dragulaService.drag.subscribe(function () {
            _this.liveAnnouncer.announce('élément selectionné ');
        });
        return _this;
    }
    ActeAttaqueComponent_1 = ActeAttaqueComponent;
    ActeAttaqueComponent.prototype.modelValueChanged = function (value) {
        this.acteAttaques = value;
    };
    ActeAttaqueComponent.prototype.onActeAttaqueAdd = function (file) {
        if (file) {
            this.acteAttaques.push(new piece_jointe_1.PieceActeAttaque(file));
            this.pieceAdder.deleteFile();
        }
        this.onChange(this.acteAttaques);
    };
    ActeAttaqueComponent.prototype.onActeAttaqueDelete = function (index, file) {
        if (!file) {
            this.acteAttaques.splice(index, 1);
        }
        this.onChange(this.acteAttaques);
    };
    ActeAttaqueComponent.prototype.moveUp = function (index) {
        if (index > 0) {
            this.swapActeAttaques(index - 1, index);
        }
    };
    ActeAttaqueComponent.prototype.moveDown = function (index) {
        if (index < this.acteAttaques.length - 1) {
            this.swapActeAttaques(index + 1, index);
        }
    };
    ActeAttaqueComponent.prototype.trackByFileApiId = function (_index, item) {
        return item.fileModel.fileApiId;
    };
    ActeAttaqueComponent.prototype.swapActeAttaques = function (piece1Index, piece2Index) {
        var piece1 = this.acteAttaques[piece1Index];
        var piece2 = this.acteAttaques[piece2Index];
        this.acteAttaques[piece2Index] = piece1;
        this.acteAttaques[piece1Index] = piece2;
    };
    Object.defineProperty(ActeAttaqueComponent.prototype, "uploadUrl", {
        get: function () {
            return this.draftDepotRequeteService.buildUploadUrl();
        },
        enumerable: true,
        configurable: true
    });
    // --- drag n drop keyboard accessible
    ActeAttaqueComponent.prototype.onMoveup = function (data) {
        console.log('onMoveup', data);
        this.moveUp(data.i);
    };
    ActeAttaqueComponent.prototype.onMovedown = function (data) {
        console.log('onMovedown', data);
        this.moveDown(data.i);
    };
    ActeAttaqueComponent.prototype.onSelect = function (data) {
        console.log('onSelect', data);
        this.selectedItem = data.piece.fileModel.fileApiId;
    };
    ActeAttaqueComponent.prototype.onEscape = function (data) {
        console.log('onEscape', data);
        this.selectedItem = null;
    };
    __decorate([
        core_1.ViewChild('acteAttaquesAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ActeAttaqueComponent.prototype, "pieceAdder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ActeAttaqueComponent.prototype, "maxActeAttaquesForMerge", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ActeAttaqueComponent.prototype, "draftRequeteId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ActeAttaqueComponent.prototype, "adderLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ActeAttaqueComponent.prototype, "acteRequired", void 0);
    ActeAttaqueComponent = ActeAttaqueComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-acte-attaque',
            template: __webpack_require__(782),
            styles: [__webpack_require__(882)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: ActeAttaqueComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector, draft_depot_requete_service_1.DraftDepotRequeteService,
            a11y_1.LiveAnnouncer,
            ng2_dragula_1.DragulaService])
    ], ActeAttaqueComponent);
    return ActeAttaqueComponent;
    var ActeAttaqueComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.ActeAttaqueComponent = ActeAttaqueComponent;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(7);
var ng2_dragula_1 = __webpack_require__(46);
var rxjs_1 = __webpack_require__(12);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var piece_jointe_1 = __webpack_require__(38);
var shared_1 = __webpack_require__(4);
var file_uploader_component_1 = __webpack_require__(52);
var filesConstraints_constants_1 = __webpack_require__(192);
var error_service_1 = __webpack_require__(22);
var parameters_service_1 = __webpack_require__(25);
var draft_depot_requete_service_1 = __webpack_require__(16);
var a11y_1 = __webpack_require__(44);
var contentieux_social_1 = __webpack_require__(90);
var JustificatifsComponent = /** @class */ (function () {
    function JustificatifsComponent(dragulaService, parametersService, errorService, scrollToService, draftDepotRequeteService, liveAnnouncer, cdRef) {
        var _this = this;
        this.dragulaService = dragulaService;
        this.parametersService = parametersService;
        this.errorService = errorService;
        this.scrollToService = scrollToService;
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.liveAnnouncer = liveAnnouncer;
        this.cdRef = cdRef;
        this.PieceJointTypeEnum = piece_jointe_1.PieceJointType;
        this.maxNumberJointsPiecesExceptRequete = 98; // Nombre maximum de pièces jointes pour une requete est fixé à 99
        this.showLengthWarningForFileName = false;
        this.actualFileNameLength = 0;
        this.sections = {
            obligatoires: { index: 1, isToggleable: false, isHelpOpen: true },
            complementaires: { index: 2, isToggleable: false, isHelpOpen: true },
            postales: { index: 3, isToggleable: false, isHelpOpen: true }
        };
        // For validation only
        this._justificatifRenommage = false;
        this.scrollToError = false;
        this.requeteAutoSaveSuccess = false;
        this.autoSaveError = false;
        this.saveDraftSuccess = false;
        this.saveDraftError = false;
        this.previousStep = new core_1.EventEmitter();
        this.nextStep = new core_1.EventEmitter();
        this.hideAlertDraft = new core_1.EventEmitter();
        this.showErrorAlertDraft = new core_1.EventEmitter();
        this.showSuccessAlertDraft = new core_1.EventEmitter();
        this.showAutoSaveSuccessAlertDraft = new core_1.EventEmitter();
        // --- drag n drop keyboard accessible
        this.selectedItem = null;
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        if (this.depotRequeteState.isStepRequeteAutoSaveSucceed && !this.depotRequeteState.isStepJustificatifsAutoSaveSucceed) {
            this.requeteAutoSaveSuccess = true;
            this.autoSaveTime = this.draftDepotRequeteService.getAutoSaveTime();
            this.draftDepotRequeteService.sendData(this.autoSaveTime);
        }
        if (this.dragulaService.find('piecesComplementairesBag') === undefined) {
            dragulaService.setOptions('piecesComplementairesBag', {});
        }
        this.parameterSubscription = this.parametersService.getParameters().subscribe(function (parameters) {
            _this.maxFileNameWithoutExtensionLength = parameters.maxFileNameWithoutExtensionLength;
            _this.maxFileSize = parameters.maxFileSize;
            _this.maxActeAttaquesForMerge = parameters.maxActeAttaquesForMerge;
            _this.maxReclamationPrealablesForMerge = parameters.maxActeAttaquesForMerge;
        });
        this.dropSubscription = this.dragulaService.out.subscribe(function () {
            _this.liveAnnouncer.announce('élément relaché');
        });
        this.dragSubscription = this.dragulaService.drag.subscribe(function () {
            _this.liveAnnouncer.announce('élément selectionné');
        });
    }
    JustificatifsComponent.prototype.ngOnInit = function () {
        // refresh pieces complémentaires => permet de continuer d utiliser dragula sans rafraichir la page
        this.depotRequeteState.piecesComplementaires = this.depotRequeteState.piecesComplementaires.map(function (x) { return x; });
        this.hideAlertDraft.emit();
        if (this.requeteAutoSaveSuccess) {
            this.showAutoSaveSuccessAlertDraft.emit();
        }
    };
    JustificatifsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.draftDepotRequeteService.refreshRequete().pipe(operators_1.tap(function (draftRequete) { return _this.updateDepotRequeteState(draftRequete); }), operators_1.switchMap(function (draftRequete) { return draftRequete.contentieuxSocialId ?
            _this.draftDepotRequeteService.getContentieuxSocial(draftRequete.contentieuxSocialId) :
            rxjs_1.of(new contentieux_social_1.ContentieuxSocial()); }), operators_1.tap(function (cs) { return _this.depotRequeteState.requeteCS = cs; })).subscribe();
        document.getElementById('logo-link').focus();
    };
    JustificatifsComponent.prototype.updateDepotRequeteState = function (draftRequete) {
        if (draftRequete.typeRequeteId == null) {
            this.depotRequeteState.urgenceRequete = undefined;
        }
        else {
            this.depotRequeteState.urgenceRequete = this.depotRequeteState.typeJuridiction.urgencesRequete.find(function (urgenceRequete) {
                return urgenceRequete.id === draftRequete.typeRequeteId;
            });
        }
        this.depotRequeteState.concernContentieuxSocial = draftRequete.concernContentieuxSocial;
        this.depotRequeteState.formActivated = draftRequete.formActivated;
        this.draftDepotRequeteService.refreshPiecesFromDraft(draftRequete, this.depotRequeteState);
    };
    JustificatifsComponent.prototype.ngAfterViewChecked = function () {
        this.cdRef.detectChanges();
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstError();
            this.scrollToError = false;
        }
    };
    JustificatifsComponent.prototype.next = function () {
        this.hideAlertDraft.emit();
        if (this.form.valid && !this.isActeAttaquesMaxSizeExceeded) {
            return this.saveJustificatifsAndMergeActeAttaquesIfNeeded();
        }
        else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    };
    JustificatifsComponent.prototype.previous = function () {
        this.depotRequeteState.isStepJustificatifsAutoSaveSucceed = false;
        this.previousStep.emit();
    };
    JustificatifsComponent.prototype.onRequeteChange = function (file) {
        if (this.depotRequeteState.requete) {
            this.depotRequeteState.requete.fileModel = file;
        }
        else {
            this.depotRequeteState.requete = new piece_jointe_1.PieceRequete(file);
        }
    };
    JustificatifsComponent.prototype.onPieceComplementaireAdd = function (file) {
        if (file) {
            this.depotRequeteState.piecesComplementaires.push(new piece_jointe_1.PieceComplementaire(file, piece_jointe_1.PieceJointType.PIECE_JOINTE_REQUETE, piece_jointe_1.PieceComplementaireOrigineType.DEFAULT));
            this.pieceAdder.deleteFile();
        }
    };
    JustificatifsComponent.prototype.disableDeletion = function (piece) {
        return piece.complementaryFileOriginType !== piece_jointe_1.PieceComplementaireOrigineType.DEFAULT;
    };
    JustificatifsComponent.prototype.onPieceComplementaireDelete = function (index, file) {
        if (!file) {
            this.depotRequeteState.piecesComplementaires.splice(index, 1);
        }
    };
    JustificatifsComponent.prototype.moveUp = function (index) {
        if (index > 0) {
            this.swapPiecesComplementaire(index - 1, index);
        }
    };
    JustificatifsComponent.prototype.moveDown = function (index) {
        if (index < this.depotRequeteState.piecesComplementaires.length - 1) {
            this.swapPiecesComplementaire(index + 1, index);
        }
    };
    // @ts-ignore
    JustificatifsComponent.prototype.trackByFileApiId = function (index, item) {
        return item.fileModel.fileApiId;
    };
    JustificatifsComponent.prototype.swapPiecesComplementaire = function (piece1Index, piece2Index) {
        var piece1 = this.depotRequeteState.piecesComplementaires[piece1Index];
        var piece2 = this.depotRequeteState.piecesComplementaires[piece2Index];
        this.depotRequeteState.piecesComplementaires[piece2Index] = piece1;
        this.depotRequeteState.piecesComplementaires[piece1Index] = piece2;
    };
    JustificatifsComponent.prototype.ngOnDestroy = function () {
        this.parameterSubscription.unsubscribe();
        this.dragSubscription.unsubscribe();
        this.dropSubscription.unsubscribe();
    };
    JustificatifsComponent.prototype.checkLengthForFileName = function (value) {
        if (value) {
            this.actualFileNameLength = value.length;
            this.showLengthWarningForFileName = value.length > this.maxFileNameWithoutExtensionLength;
        }
    };
    JustificatifsComponent.prototype.resetGeneratedActeAttaque = function () {
        this.depotRequeteState.acteAttaque = new piece_jointe_1.PieceActeAttaque(null);
    };
    JustificatifsComponent.prototype.resetGeneratedReclamationPrealable = function () {
        this.depotRequeteState.reclamationPrealable = new piece_jointe_1.PieceReclamationPrealable(null);
    };
    Object.defineProperty(JustificatifsComponent.prototype, "isActeAttaquesMaxSizeExceeded", {
        get: function () {
            return (this.depotRequeteState.acteAttaquesAFusioner.reduce(function (acc, aa) { return acc + aa.fileModel.fileSize; }, 0) >
                this.maxFileSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JustificatifsComponent.prototype, "isReclamationPrealablesMaxSizeExceeded", {
        get: function () {
            return (this.depotRequeteState.reclamationPrealablesAFusioner.reduce(function (acc, aa) { return acc + aa.fileModel.fileSize; }, 0) >
                this.maxFileSize);
        },
        enumerable: true,
        configurable: true
    });
    JustificatifsComponent.prototype.saveJustificatifsAndMergeActeAttaquesIfNeeded = function () {
        var _this = this;
        return this.saveJustificatifs().pipe(operators_1.tap(function (model) {
            console.log('saveJustificatifsAndMergeActeAttaquesIfNeeded model | ', model);
            _this.depotRequeteState.isStepJustificatifsAutoSaveSucceed = true;
            if (Array.isArray(model) && model.length === 1) {
                if (model[0].fileItem.name === 'Acte attaqué') {
                    _this.depotRequeteState.acteAttaque = new piece_jointe_1.PieceActeAttaque(model[0]);
                }
                else {
                    _this.depotRequeteState.reclamationPrealable = new piece_jointe_1.PieceReclamationPrealable(model[0]);
                }
            }
            else if (Array.isArray(model) && model.length === 2) {
                _this.depotRequeteState.acteAttaque =
                    new piece_jointe_1.PieceActeAttaque(model.find(function (m) { return m.fileItem.name === 'Acte attaqué'; }));
                _this.depotRequeteState.reclamationPrealable =
                    new piece_jointe_1.PieceReclamationPrealable(model.find(function (m) { return m.fileItem.name === 'Réclamation préalable'; }));
            }
            _this.nextStep.emit();
        }, function (error) {
            if (error.error.code === filesConstraints_constants_1.MAX_FILE_EXCEEDED_ERROR_CODE) {
                _this.form.controls['acteAttaques'].setErrors({ invalid: true, 'max-file-length-exceeded': true });
                _this.errorService.markAllControlsAsTouched(_this.form);
                _this.scrollToError = true;
            }
            else {
                _this.autoSaveError = true;
                _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
            }
        }));
    };
    JustificatifsComponent.prototype.saveDraft = function () {
        var _this = this;
        this.hideAlertDraft.emit();
        return this.saveJustificatifs().pipe(operators_1.tap(function () {
            _this.saveDraftSuccess = true;
            _this.requeteAutoSaveSuccess = false;
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.saveDraftError = true;
            _this.requeteAutoSaveSuccess = false;
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        }));
    };
    JustificatifsComponent.prototype.saveDraftAgain = function () {
        var _this = this;
        this.saveJustificatifs().subscribe(function () {
            _this.saveDraftSuccess = true;
            _this.requeteAutoSaveSuccess = false;
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.saveDraftError = true;
            _this.requeteAutoSaveSuccess = false;
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        });
    };
    JustificatifsComponent.prototype.close = function () {
        this.autoSaveError = false;
    };
    JustificatifsComponent.prototype.saveJustificatifs = function () {
        return this.draftDepotRequeteService.saveJustificatifsAndMergeActeAttaquesIfNeeded();
    };
    Object.defineProperty(JustificatifsComponent.prototype, "uploadUrl", {
        get: function () {
            return this.draftDepotRequeteService.buildUploadUrl();
        },
        enumerable: true,
        configurable: true
    });
    // --- drag n drop keyboard accessible
    JustificatifsComponent.prototype.onMoveup = function (data) {
        console.log('onMoveup', data);
        this.moveUp(data.i);
    };
    JustificatifsComponent.prototype.onMovedown = function (data) {
        console.log('onMovedown', data);
        this.moveDown(data.i);
    };
    JustificatifsComponent.prototype.onSelect = function (data) {
        console.log('onSelect', data);
        this.selectedItem = data.piece.fileModel.fileApiId;
    };
    JustificatifsComponent.prototype.onEscape = function (data) {
        console.log('onEscape', data);
        this.selectedItem = null;
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JustificatifsComponent.prototype, "previousStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JustificatifsComponent.prototype, "nextStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JustificatifsComponent.prototype, "hideAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JustificatifsComponent.prototype, "showErrorAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JustificatifsComponent.prototype, "showSuccessAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], JustificatifsComponent.prototype, "showAutoSaveSuccessAlertDraft", void 0);
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], JustificatifsComponent.prototype, "form", void 0);
    __decorate([
        core_1.ViewChild('pieceAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], JustificatifsComponent.prototype, "pieceAdder", void 0);
    JustificatifsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(783),
            styles: [__webpack_require__(883)]
        }),
        __metadata("design:paramtypes", [ng2_dragula_1.DragulaService,
            parameters_service_1.ParametersService,
            error_service_1.ErrorService,
            shared_1.ScrollToService,
            draft_depot_requete_service_1.DraftDepotRequeteService,
            a11y_1.LiveAnnouncer,
            core_1.ChangeDetectorRef])
    ], JustificatifsComponent);
    return JustificatifsComponent;
}());
exports.JustificatifsComponent = JustificatifsComponent;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(7);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var requete_1 = __webpack_require__(17);
var util_1 = __webpack_require__(28);
var error_service_1 = __webpack_require__(22);
var draft_depot_requete_service_1 = __webpack_require__(16);
var shared_1 = __webpack_require__(4);
var acteurSectionTitles = (_a = {},
    _a[requete_1.RequeteCategory.REQUERANT_SEUL] = 'Requérant principal (demandeur)',
    _a[requete_1.RequeteCategory.COLLECTIVE] = 'Vous êtes le représentant unique des requérants',
    _a[requete_1.RequeteCategory.AVEC_MANDATAIRE] = 'Vous êtes le mandataire',
    _a);
var RecapitulatifComponent = /** @class */ (function () {
    function RecapitulatifComponent(errorService, draftDepotRequeteService, scrollToService) {
        this.errorService = errorService;
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.scrollToService = scrollToService;
        this.isDeactivatedPopup = false;
        this.isLoading = false;
        this.scrollToError = false;
        this.justificatifsAutoSaveSuccess = false;
        this.saveDraftSuccess = false;
        this.saveDraftError = false;
        this.sections = {
            acteur: { isToggleable: false },
            juridiction: { isToggleable: false },
            piecesObligatoires: { isToggleable: false },
            piecesComplementaires: { isToggleable: false },
            piecesPostales: { isToggleable: false },
            inventaire: { isToggleable: false }
        };
        // For validation only
        this._recapitulatifEnregistrement = false;
        this._recapitulatifRequeteAbusif = false;
        this.previousStep = new core_1.EventEmitter();
        this.hideAlertDraft = new core_1.EventEmitter();
        this.showErrorAlertDraft = new core_1.EventEmitter();
        this.showSuccessAlertDraft = new core_1.EventEmitter();
        this.showAutoSaveSuccessAlertDraft = new core_1.EventEmitter();
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        if (this.depotRequeteState.isStepJustificatifsAutoSaveSucceed) {
            this.justificatifsAutoSaveSuccess = true;
            this.autoSaveTime = this.draftDepotRequeteService.getAutoSaveTime();
            this.draftDepotRequeteService.sendData(this.autoSaveTime);
        }
        if (this.depotRequeteState.requeteCategory) {
            this.generateInventaire();
            this.acteurSectionTitle = acteurSectionTitles[this.depotRequeteState.requeteCategory];
        }
    }
    RecapitulatifComponent.prototype.ngOnInit = function () {
        this.hideAlertDraft.emit();
        if (this.justificatifsAutoSaveSuccess) {
            this.showAutoSaveSuccessAlertDraft.emit();
        }
    };
    RecapitulatifComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.draftRequeteSubscription = this.draftDepotRequeteService.refreshRequete().subscribe(function (draftRequete) {
            console.log('ngAfterViewInit | draftRequete : ', draftRequete);
            _this.depotRequeteState.concernContentieuxSocial =
                draftRequete.concernContentieuxSocial;
            if (draftRequete.contentieuxSocialId !== null) {
                _this.contentieuxSocialSubscription =
                    _this.draftDepotRequeteService.getContentieuxSocial(draftRequete.contentieuxSocialId)
                        .subscribe(function (cs) {
                        _this.depotRequeteState.requeteCS = cs;
                        console.log('ngAfterViewInit | requeteCS : ', _this.depotRequeteState.requeteCS);
                        if (_this.depotRequeteState.requeteCS && _this.depotRequeteState.requeteCS.souhait) {
                            if ((_this.depotRequeteState.requeteCS.souhait ===
                                'Remplir le formulaire : litige lié à une somme d\'argent' &&
                                _this.depotRequeteState.requeteCS.typeLitige ===
                                    'Vous contestez une somme d\'argent réclamée par l\'administration') ||
                                _this.depotRequeteState.requeteCS.souhait === 'Déposer une requête que vous avez rédigée') {
                                _this.reclamationPrealableIsComplementary = true;
                                _this.reclamationPrealableIsMandatory = false;
                            }
                            else if (_this.depotRequeteState.requeteCS.souhait ===
                                'Remplir le formulaire : litige lié à une somme d\'argent' &&
                                _this.depotRequeteState.requeteCS.typeLitige !==
                                    'Vous contestez une somme d\'argent réclamée par l\'administration') {
                                _this.reclamationPrealableIsMandatory = true;
                                _this.reclamationPrealableIsComplementary = false;
                            }
                        }
                        else {
                            _this.reclamationPrealableIsComplementary = false;
                            _this.reclamationPrealableIsMandatory = false;
                        }
                    });
            }
        });
        document.getElementById('logo-link').focus();
    };
    RecapitulatifComponent.prototype.ngAfterViewChecked = function () {
        if (this.scrollTarget) {
            this.scrollToService.scrollBySelector(this.scrollTarget);
            this.scrollTarget = null;
        }
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstError();
            this.scrollToError = false;
        }
    };
    RecapitulatifComponent.prototype.ngOnDestroy = function () {
        this.draftRequeteSubscription.unsubscribe();
        if (this.contentieuxSocialSubscription) {
            this.contentieuxSocialSubscription.unsubscribe();
        }
    };
    RecapitulatifComponent.prototype.save = function () {
        var _this = this;
        this.hideAlertDraft.emit();
        if (this.form.valid) {
            this.isLoading = true;
            this.draftDepotRequeteService.depotRequete().subscribe(function () {
                _this.isLoading = false;
            }, function (error) {
                _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
                _this.isLoading = false;
            });
        }
        else {
            this.errorService.markAllControlsAsTouched(this.form);
        }
    };
    RecapitulatifComponent.prototype.previous = function () {
        this.previousStep.emit();
    };
    RecapitulatifComponent.prototype.saveDraft = function () {
        var _this = this;
        this.hideAlertDraft.emit();
        return this.draftDepotRequeteService.updateStatusToRecapitulatif().pipe(operators_1.tap(function () {
            _this.saveDraftSuccess = true;
            _this.justificatifsAutoSaveSuccess = false;
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.saveDraftError = true;
            _this.justificatifsAutoSaveSuccess = false;
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        }));
    };
    RecapitulatifComponent.prototype.generateInventaire = function () {
        var _this = this;
        this.draftDepotRequeteService.generateInventairePreview().subscribe(function (blob) {
            _this.inventaireBlob = blob;
        });
    };
    RecapitulatifComponent.prototype.openInventaire = function () {
        if (this.inventaireBlob) {
            this.draftDepotRequeteService.trackInventairePreviewDownload();
            try {
                util_1.saveOrOpenRawFile(this.inventaireBlob, 'Inventaire_des_pièces.pdf');
            }
            catch (e) {
                this.isDeactivatedPopup = true;
            }
        }
        else {
            this.draftDepotRequeteService.trackInventairePreviewFail();
        }
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RecapitulatifComponent.prototype, "previousStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RecapitulatifComponent.prototype, "hideAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RecapitulatifComponent.prototype, "showErrorAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RecapitulatifComponent.prototype, "showSuccessAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RecapitulatifComponent.prototype, "showAutoSaveSuccessAlertDraft", void 0);
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], RecapitulatifComponent.prototype, "form", void 0);
    RecapitulatifComponent = __decorate([
        core_1.Component({
            selector: 'jhi-step-recapitulatif',
            template: __webpack_require__(784),
            styles: [__webpack_require__(884)]
        }),
        __metadata("design:paramtypes", [error_service_1.ErrorService, draft_depot_requete_service_1.DraftDepotRequeteService,
            shared_1.ScrollToService])
    ], RecapitulatifComponent);
    return RecapitulatifComponent;
}());
exports.RecapitulatifComponent = RecapitulatifComponent;
var _a;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var AddRequerantHeaderComponent = /** @class */ (function () {
    function AddRequerantHeaderComponent() {
        this.onAdd = new core_1.EventEmitter();
        this.onClose = new core_1.EventEmitter();
        this.isAdding = false;
    }
    AddRequerantHeaderComponent.prototype.edit = function () {
        this.isAdding = true;
        this.onAdd.emit();
    };
    AddRequerantHeaderComponent.prototype.close = function () {
        this.isAdding = false;
        this.onClose.emit();
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AddRequerantHeaderComponent.prototype, "onAdd", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AddRequerantHeaderComponent.prototype, "onClose", void 0);
    __decorate([
        core_1.HostBinding('class.adding'),
        __metadata("design:type", Object)
    ], AddRequerantHeaderComponent.prototype, "isAdding", void 0);
    AddRequerantHeaderComponent = __decorate([
        core_1.Component({
            selector: 'jhi-add-requerant-header',
            template: __webpack_require__(785),
            styles: [__webpack_require__(885)]
        })
    ], AddRequerantHeaderComponent);
    return AddRequerantHeaderComponent;
}());
exports.AddRequerantHeaderComponent = AddRequerantHeaderComponent;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var AddedRequerantComponent = /** @class */ (function () {
    function AddedRequerantComponent() {
        this.onRemoveRequerant = new core_1.EventEmitter();
        this.onMoveToPrincipal = new core_1.EventEmitter();
    }
    AddedRequerantComponent.prototype.removeRequerant = function (requerant) {
        var index = this.requerants.indexOf(requerant);
        this.onRemoveRequerant.emit(index);
    };
    AddedRequerantComponent.prototype.moveToRequerantPricipal = function (requerant) {
        var index = this.requerants.indexOf(requerant);
        this.onMoveToPrincipal.emit(index);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], AddedRequerantComponent.prototype, "requerants", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], AddedRequerantComponent.prototype, "onRemoveRequerant", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], AddedRequerantComponent.prototype, "onMoveToPrincipal", void 0);
    AddedRequerantComponent = __decorate([
        core_1.Component({
            selector: 'jhi-added-requerant',
            template: __webpack_require__(787),
            styles: [
                __webpack_require__(887)
            ]
        }),
        __metadata("design:paramtypes", [])
    ], AddedRequerantComponent);
    return AddedRequerantComponent;
}());
exports.AddedRequerantComponent = AddedRequerantComponent;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var requete_1 = __webpack_require__(17);
var shared_1 = __webpack_require__(4);
var error_service_1 = __webpack_require__(22);
var EditFormComponent = /** @class */ (function () {
    function EditFormComponent(errorService, scrollService) {
        this.errorService = errorService;
        this.scrollService = scrollService;
        this.identityType = shared_1.AccountType.PHYSIQUE;
        this.AccountTypeEnum = shared_1.AccountType;
        this.onAddRequerant = new core_1.EventEmitter();
        this.displayEditForm = false;
    }
    EditFormComponent.prototype.ngAfterViewChecked = function () {
        if (this.enableScroll) {
            this.scrollService.scrollToFirstError();
            this.enableScroll = false;
        }
    };
    EditFormComponent.prototype.addRequerant = function () {
        if (this.form.valid) {
            this.onAddRequerant.emit(this.requerant.clone());
        }
        else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.enableScroll = true;
        }
    };
    EditFormComponent.prototype.addNewRequerant = function () {
        this.initRequerant();
        this.displayEditForm = true;
    };
    EditFormComponent.prototype.initRequerant = function () {
        this.requerant = new requete_1.PartieDepot();
        this.requerant.type = this.identityType;
        this.requerant.qualite = requete_1.QualityType.Requerant;
    };
    EditFormComponent.prototype.close = function () {
        this.displayEditForm = false;
    };
    Object.defineProperty(EditFormComponent.prototype, "isMoraleIdentity", {
        get: function () {
            return this.identityType === shared_1.AccountType.MORALE;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", requete_1.PartieDepot)
    ], EditFormComponent.prototype, "requerant", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], EditFormComponent.prototype, "onAddRequerant", void 0);
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], EditFormComponent.prototype, "form", void 0);
    EditFormComponent = __decorate([
        core_1.Component({
            selector: 'jhi-edit-form',
            template: __webpack_require__(788),
            styles: [__webpack_require__(888)]
        }),
        __metadata("design:paramtypes", [error_service_1.ErrorService, shared_1.ScrollToService])
    ], EditFormComponent);
    return EditFormComponent;
}());
exports.EditFormComponent = EditFormComponent;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var requete_1 = __webpack_require__(17);
var add_requerant_section_component_1 = __webpack_require__(158);
var ResultFormComponent = /** @class */ (function () {
    function ResultFormComponent() {
        this.RequerantsHandlingErrorEnum = add_requerant_section_component_1.RequerantsHandlingError;
        this.onAddRequerant = new core_1.EventEmitter();
    }
    ResultFormComponent.prototype.addRequerant = function () {
        this.onAddRequerant.emit();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", requete_1.PartieDepot)
    ], ResultFormComponent.prototype, "requerant", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ResultFormComponent.prototype, "errorType", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], ResultFormComponent.prototype, "onAddRequerant", void 0);
    ResultFormComponent = __decorate([
        core_1.Component({
            selector: 'jhi-result-form',
            template: __webpack_require__(789),
            styles: [
                __webpack_require__(889)
            ]
        }),
        __metadata("design:paramtypes", [])
    ], ResultFormComponent);
    return ResultFormComponent;
}());
exports.ResultFormComponent = ResultFormComponent;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var error_service_1 = __webpack_require__(22);
var search_form_model_1 = __webpack_require__(434);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var shared_1 = __webpack_require__(4);
var SearchFormComponent = /** @class */ (function () {
    function SearchFormComponent(errorService, scrollToService) {
        this.errorService = errorService;
        this.scrollToService = scrollToService;
        this.onSearch = new core_1.EventEmitter;
        this.displaySearchForm = false;
        this.searchForm = new search_form_model_1.SearchForm();
    }
    SearchFormComponent.prototype.ngAfterViewChecked = function () {
        if (this.form && this.form.submitted && !this.form.valid && this.enableScroll) {
            this.scrollToService.scrollToFirstError();
            this.enableScroll = false;
        }
    };
    SearchFormComponent.prototype.search = function () {
        if (!this.form.valid) {
            this.errorService.markAllControlsAsTouched(this.form);
            this.enableScroll = true;
        }
        else {
            this.onSearch.emit(this.searchForm);
        }
    };
    SearchFormComponent.prototype.reset = function () {
        this.form.reset();
        this.onSearch.emit(null);
    };
    SearchFormComponent.prototype.addNewRequerant = function () {
        this.displaySearchForm = true;
    };
    SearchFormComponent.prototype.close = function () {
        this.displaySearchForm = false;
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], SearchFormComponent.prototype, "onSearch", void 0);
    __decorate([
        core_1.ViewChild('form'),
        __metadata("design:type", forms_1.NgForm)
    ], SearchFormComponent.prototype, "form", void 0);
    SearchFormComponent = __decorate([
        core_1.Component({
            selector: 'jhi-search-form',
            template: __webpack_require__(790),
            styles: [
                __webpack_require__(890)
            ],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        }),
        __metadata("design:paramtypes", [error_service_1.ErrorService, shared_1.ScrollToService])
    ], SearchFormComponent);
    return SearchFormComponent;
}());
exports.SearchFormComponent = SearchFormComponent;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SearchForm = /** @class */ (function () {
    function SearchForm() {
    }
    return SearchForm;
}());
exports.SearchForm = SearchForm;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(158));
__export(__webpack_require__(430));
__export(__webpack_require__(433));
__export(__webpack_require__(432));
__export(__webpack_require__(429));
__export(__webpack_require__(431));
__export(__webpack_require__(436));
__export(__webpack_require__(437));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(5);
var requete_1 = __webpack_require__(17);
var RequerantTypeSectionComponent = /** @class */ (function (_super) {
    __extends(RequerantTypeSectionComponent, _super);
    function RequerantTypeSectionComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.RequeteCategoryEnum = requete_1.RequeteCategory;
        _this.requerantTypes = [
            {
                value: _this.RequeteCategoryEnum.REQUERANT_SEUL,
                title: 'En tant que seul requérant',
                description: 'Le terme requérant désigne la personne qui s’adresse au juge pour lui soumettre un litige.'
            },
            {
                value: _this.RequeteCategoryEnum.COLLECTIVE,
                title: 'Avec d\'autres requérants',
                description: 'Plusieurs personnes physiques ou morales peuvent déposer la même requête. L’un d’entre eux doit être' +
                    ' désigné comme représentant unique des requérants. Lorsque cette requête est déposée par Télérecours citoyens,' +
                    ' la personne qui l’a introduite est désignée représentant unique. Pour plus d\'informations, lisez '
            },
            {
                value: _this.RequeteCategoryEnum.AVEC_MANDATAIRE,
                title: 'En tant que mandataire',
                description: 'Le requérant vous a donné un mandat par lequel il vous autorise à agir en justice en son nom.' +
                    ' Vous devrez joindre ce mandat, ou pouvoir spécial, à l\'appui de la requête.'
            }
        ];
        return _this;
    }
    RequerantTypeSectionComponent_1 = RequerantTypeSectionComponent;
    RequerantTypeSectionComponent.prototype.modelValueChanged = function (value) {
        this.selectedRequerantTypeCode = value;
    };
    RequerantTypeSectionComponent.prototype.onSetRequeteType = function (requeteCategory) {
        this.onChange(requeteCategory);
    };
    RequerantTypeSectionComponent.prototype.ngAfterViewInit = function () {
        document.getElementById('logo-link').focus();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], RequerantTypeSectionComponent.prototype, "state", void 0);
    RequerantTypeSectionComponent = RequerantTypeSectionComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-requerant-type-section',
            template: __webpack_require__(791),
            styles: [__webpack_require__(891)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: RequerantTypeSectionComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector])
    ], RequerantTypeSectionComponent);
    return RequerantTypeSectionComponent;
    var RequerantTypeSectionComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.RequerantTypeSectionComponent = RequerantTypeSectionComponent;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(7);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var router_1 = __webpack_require__(6);
var requete_1 = __webpack_require__(17);
var shared_1 = __webpack_require__(4);
var error_service_1 = __webpack_require__(22);
var draft_depot_requete_service_1 = __webpack_require__(16);
var RequerantsComponent = /** @class */ (function () {
    function RequerantsComponent(requeteService, userService, accountService, errorService, scrollToService, router, draftDepotRequeteService) {
        var _this = this;
        this.requeteService = requeteService;
        this.userService = userService;
        this.accountService = accountService;
        this.errorService = errorService;
        this.scrollToService = scrollToService;
        this.router = router;
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.RequeteCategoryEnum = requete_1.RequeteCategory;
        this.nombreRequetes = 0;
        this.sections = {
            selectTypeRequete: { index: 1, isToggleable: false, isHelpOpen: false },
            displayActeur: { index: 2, isToggleable: false },
            addRequerant: { index: 3, isToggleable: false, isHelpOpen: true }
        };
        this.scrollToError = false;
        this.autoSaveError = false;
        this.previousStep = new core_1.EventEmitter();
        this.nextStep = new core_1.EventEmitter();
        this.hideAlertDraft = new core_1.EventEmitter();
        this.showErrorAlertDraft = new core_1.EventEmitter();
        this.showSuccessAlertDraft = new core_1.EventEmitter();
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        this.userService
            .getAccount()
            .then(function (account) { return (_this.depotRequeteState.currentActeur = _this.accountService.mapAccountToPartieDepot(account)); });
        this.getNombreRequetesAujourdhui();
    }
    RequerantsComponent.prototype.ngOnInit = function () {
        this.hideAlertDraft.emit();
    };
    RequerantsComponent.prototype.ngAfterViewChecked = function () {
        if (this.scrollTarget) {
            this.scrollToService.scrollBySelector(this.scrollTarget);
            this.scrollTarget = null;
        }
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstError();
            this.scrollToError = false;
        }
    };
    RequerantsComponent.prototype.next = function () {
        var _this = this;
        this.hideAlertDraft.emit();
        if (this.form.valid) {
            if (this.depotRequeteState.requeteCategory === requete_1.RequeteCategory.REQUERANT_SEUL) {
                this.depotRequeteState.currentActeur.qualite = requete_1.QualityType.Requerant;
                this.depotRequeteState.requerants.push(this.depotRequeteState.currentActeur);
            }
            return this.saveRequerants().pipe(operators_1.tap(function () {
                _this.depotRequeteState.isStepRequerantAutoSaveSucceed = true;
                _this.nextStep.emit();
            }, function (error) {
                _this.autoSaveError = true;
                _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
            }));
        }
        else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    };
    RequerantsComponent.prototype.previous = function () {
        this.previousStep.emit();
    };
    RequerantsComponent.prototype.saveDraft = function () {
        var _this = this;
        this.hideAlertDraft.emit();
        return this.saveRequerants().pipe(operators_1.tap(function () {
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        }));
    };
    RequerantsComponent.prototype.saveDraftAgain = function () {
        var _this = this;
        this.saveRequerants().subscribe(function () {
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        });
    };
    RequerantsComponent.prototype.close = function () {
        this.autoSaveError = false;
    };
    RequerantsComponent.prototype.onRequerantTypeChange = function (requeteCategory) {
        this.depotRequeteState.requeteCategory = requeteCategory;
        this.resetRequerants();
        this.scrollTarget = 'jhi-requerant-type-section';
    };
    RequerantsComponent.prototype.resetRequerants = function () {
        this.depotRequeteState.requerants = [];
        var addRequerantControl = this.form.controls['add-requerant'];
        if (addRequerantControl) {
            addRequerantControl.markAsUntouched();
            addRequerantControl.markAsPristine();
        }
    };
    RequerantsComponent.prototype.hasCaptcha = function () {
        return this.nombreRequetes >= 1;
    };
    RequerantsComponent.prototype.goToProfile = function () {
        this.router.navigate(['/mon-profil']);
    };
    RequerantsComponent.prototype.saveRequerants = function () {
        if (this.depotRequeteState.requeteCategory !== undefined) {
            return this.draftDepotRequeteService.saveParties(this.depotRequeteState.requeteCategory, this.depotRequeteState.requerants);
        }
    };
    RequerantsComponent.prototype.getNombreRequetesAujourdhui = function () {
        var _this = this;
        this.requeteService.readRequeteNumberToday().subscribe(function (res) {
            _this.nombreRequetes = res;
        });
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequerantsComponent.prototype, "previousStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequerantsComponent.prototype, "nextStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequerantsComponent.prototype, "hideAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequerantsComponent.prototype, "showErrorAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequerantsComponent.prototype, "showSuccessAlertDraft", void 0);
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], RequerantsComponent.prototype, "form", void 0);
    RequerantsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(792),
            styles: [__webpack_require__(892)]
        }),
        __metadata("design:paramtypes", [requete_1.RequeteService,
            shared_1.UserService,
            shared_1.AccountService,
            error_service_1.ErrorService,
            shared_1.ScrollToService,
            router_1.Router,
            draft_depot_requete_service_1.DraftDepotRequeteService])
    ], RequerantsComponent);
    return RequerantsComponent;
}());
exports.RequerantsComponent = RequerantsComponent;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var base_control_value_accessor_1 = __webpack_require__(20);
var contentieux_social_1 = __webpack_require__(90);
var depot_requete_state_model_1 = __webpack_require__(89);
var draft_depot_requete_service_1 = __webpack_require__(16);
var piece_jointe_1 = __webpack_require__(38);
var ng_bootstrap_1 = __webpack_require__(19);
var parameters_service_1 = __webpack_require__(25);
var file_uploader_component_1 = __webpack_require__(52);
var ng2_dragula_1 = __webpack_require__(46);
var a11y_1 = __webpack_require__(44);
var reclamation_prealable_component_1 = __webpack_require__(159);
var ContentieuxSocialSectionComponent = /** @class */ (function (_super) {
    __extends(ContentieuxSocialSectionComponent, _super);
    function ContentieuxSocialSectionComponent(injector, dragulaService, liveAnnouncer, draftDepotRequeteService, modalService, parametersService) {
        var _this = _super.call(this, injector) || this;
        _this.dragulaService = dragulaService;
        _this.liveAnnouncer = liveAnnouncer;
        _this.draftDepotRequeteService = draftDepotRequeteService;
        _this.modalService = modalService;
        _this.parametersService = parametersService;
        _this.showSouhaitSection = false;
        _this.showRapoSection = true;
        _this.showNomAdministrationsSection = true;
        _this.showIntituleDemandeSection = true;
        _this.showTypeLitigeSection = false;
        _this.showSommeDueSection = false;
        _this.showMontantDuSection = false;
        _this.showReclamationPrealableSection = false;
        _this.showDecisionAttaqueSection = true;
        _this.showMotifSection = true;
        _this.showContexteInterventionDecision = false;
        _this.showRaisonsContesterDecisionSection = false;
        _this.showFaitConduitLitigeSection = false;
        _this.showTypeActeEmisSection = false;
        _this.showAvisImpositionIrregulerSection = false;
        _this.showRaisonPasPayerImpotSection = false;
        _this.showTitreEmisIrregulerSection = false;
        _this.showDALOConclusionSection = true;
        _this.showConclusionLitigeAdminSection = false;
        _this.showConclusionReclamerSommeSection = false;
        _this.showConclusionAvisImpositionImpotSection = false;
        _this.showConclusionTitreEmisIrregulerSection = false;
        _this.showFaitConduitSituationReparationSection = false;
        _this.showTypePrejudiceEvaluableEnArgentSection = false;
        _this.showPrecisionPrejudiceSection = false;
        _this.showOriginePrejudiceSection = false;
        _this.showConclusionIndemnisationSection = false;
        _this.showRequeteRedigeeSection = false;
        _this.showRequeteRedigeeJustificatifsSection = false;
        _this.sections = {
            rapo: { index: 3, isToggleable: false },
            souhait: { index: 3, isToggleable: false },
            typeLitige: { index: 4, isToggleable: false },
            hasDecisionAttaque: { index: 4, isToggleable: false },
            requeteRedigeeDecisionAttaque: { index: 4, isToggleable: false },
            reclamationPrealable: { index: 5, isToggleable: false },
            administrationDecision: { index: 5, isToggleable: false },
            depotRequeteRedigee: { index: 5, isToggleable: false },
            intituleDemande: { index: 6, isToggleable: false },
            requeteRedigeeJustificatifs: { index: 6, isToggleable: false },
            motifDemande: { index: 7, isToggleable: false },
            contexteInterventionDecision: { index: 7, isToggleable: false },
            faitConduitLitigeSection: { index: 8, isToggleable: false },
            conclusionDALO: { index: 8, isToggleable: false },
            raisonsContesterDecision: { index: 8, isToggleable: false },
            faitConduitSituationReparationSection: { index: 8, isToggleable: false },
            typeActeEmisSection: { index: 9, isToggleable: false },
            conclusionLitigeAdmin: { index: 9, isToggleable: false },
            typePrejudiceEvaluableEnArgentSection: { index: 9, isToggleable: false },
            sommeDueSection: { index: 9, isToggleable: false },
            avisImpositionIrregulerSection: { index: 10, isToggleable: false },
            titreEmisIrregulerSection: { index: 10, isToggleable: false },
            precisionPrejudiceSection: { index: 10, isToggleable: false },
            montantDuSection: { index: 10, isToggleable: false },
            conclusionTitreEmisIrregulerSection: { index: 11, isToggleable: false },
            erreurCalculMontantSection: { index: 11, isToggleable: false },
            raisonPasPayerImpotSection: { index: 11, isToggleable: false },
            originePrejudiceSection: { index: 11, isToggleable: false },
            conclusionReclamerSommeSection: { index: 11, isToggleable: false },
            conclusionAvisImpositionImpotSection: { index: 12, isToggleable: false },
            conclusionIndemnisationSection: { index: 12, isToggleable: false }
        };
        _this.souhaitTexts = [
            {
                value: 'souhait 1',
                title: 'litige lié à une décision de l\'administration',
                description: 'Remplir le formulaire : litige lié à une décision de l\'administration'
            },
            {
                value: 'souhait 2',
                title: 'litige lié à une somme d\'argent',
                description: 'Remplir le formulaire : litige lié à une somme d\'argent'
            },
            {
                value: 'souhait 3',
                title: 'Deposer requete',
                description: 'Déposer une requête que vous avez rédigée'
            }
        ];
        _this.typeLitigeTexts = [
            {
                value: 'type 1',
                title: 'Vous réclamez une somme d\'argent à l\'administration',
                description: ''
            },
            {
                value: 'type 2',
                title: 'Vous contestez une somme d\'argent réclamée par l\'administration',
                description: ''
            },
            {
                value: 'type 3',
                title: 'Vous réclamez une indemnisation pour une faute commise par l\'administration ou une situation anormale ' +
                    '(la faute peut relever d\'une action ou d\'une inaction de l\'administration)',
                description: "trou pr\u00E9sent dans la chauss\u00E9e, d\u00E9faut de surveillance d'un h\u00F4pital, infection nosocomiale, etc."
            }
        ];
        _this.typeActeEmisTexts = [
            {
                value: 'acte 1',
                title: 'Un avis d\'imposition',
                description: 'impôt sur le revenu, taxe d\'habitation, taxe foncière, etc.'
            },
            {
                value: 'acte 2',
                title: 'Un titre de recette, un avis de somme à payer, ou autre',
                description: 'rappel, mise en demeure, facture d\'hôpital, frais de cantine, etc'
            }
        ];
        _this.typeRaisonContestations = [];
        _this.typeRaisonInvalidationTitres = [];
        _this.typeRaisonAvisDimpositionIrreguliers = [];
        _this.typePrejudiceEvaluableEnArgents = [];
        _this.maxNumberJointsComplementaryPieces = 98;
        _this.showLengthWarningForFileName = false;
        _this.actualFileNameLength = 0;
        // --- drag n drop keyboard accessible
        _this.selectedItemMI = null;
        _this.selectedItemMA = null;
        _this.selectedItemSommeDue = null;
        _this.selectedItemMontantDu = null;
        _this.selectedItemAIEC = null;
        _this.selectedItemAIIA = null;
        _this.selectedItemPrecisionPrejudice = null;
        _this.selectedItemRRJ = null;
        _this.contentieuxSocial = new contentieux_social_1.ContentieuxSocial();
        if (_this.dragulaService.find('piecesComplementairesBagMI') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagMI', {});
        }
        if (_this.dragulaService.find('piecesComplementairesBagMA') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagMA', {});
        }
        if (_this.dragulaService.find('piecesComplementairesBagSommeDue') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagSommeDue', {});
        }
        if (_this.dragulaService.find('piecesComplementairesBagMontantDu') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagMontantDu', {});
        }
        if (_this.dragulaService.find('piecesComplementairesBagAvisImpositionInfondeeEtAutre') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagAvisImpositionInfondeeEtAutre', {});
        }
        if (_this.dragulaService.find('piecesComplementairesBagPrecisionPrejudice') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagPrecisionPrejudice', {});
        }
        if (_this.dragulaService.find('piecesComplementairesBagRequeteRedigeeJustificatifs') === undefined) {
            dragulaService.setOptions('piecesComplementairesBagRequeteRedigeeJustificatifs', {});
        }
        _this.dropSubscription = _this.dragulaService.out.subscribe(function () {
            (_a = _this.depotRequeteState.piecesComplementaires).push.apply(_a, __spread(_this.pieceComplementaireMalInterprete));
            (_b = _this.depotRequeteState.piecesComplementaires).push.apply(_b, __spread(_this.pieceComplementaireMalApprecie));
            (_c = _this.depotRequeteState.piecesComplementaires).push.apply(_c, __spread(_this.pieceComplementaireSommeDue));
            (_d = _this.depotRequeteState.piecesComplementaires).push.apply(_d, __spread(_this.pieceComplementaireMontantDu));
            (_e = _this.depotRequeteState.piecesComplementaires).push.apply(_e, __spread(_this.pieceComplmentaireAvisImpositionInfondeeEtAutre));
            (_f = _this.depotRequeteState.piecesComplementaires).push.apply(_f, __spread(_this.pieceComplementairePrecisionPrejudice));
            (_g = _this.depotRequeteState.piecesComplementaires).push.apply(_g, __spread(_this.pieceComplementaireRequeteRedigeeJust));
            _this.liveAnnouncer.announce('élément relaché');
            var _a, _b, _c, _d, _e, _f, _g;
        });
        _this.dragSubscription = _this.dragulaService.drag.subscribe(function () {
            _this.liveAnnouncer.announce('élément selectionné');
        });
        return _this;
    }
    ContentieuxSocialSectionComponent_1 = ContentieuxSocialSectionComponent;
    Object.defineProperty(ContentieuxSocialSectionComponent.prototype, "uploadUrl", {
        get: function () {
            return this.draftDepotRequeteService.buildUploadUrl();
        },
        enumerable: true,
        configurable: true
    });
    ContentieuxSocialSectionComponent.prototype.ngOnInit = function () {
        console.log('ngOnInit');
    };
    // initiation is done here
    ContentieuxSocialSectionComponent.prototype.writeValue = function (_value) {
        console.log('writeValue | depotRequeteState.formActivated : ', this.depotRequeteState.formActivated);
        this.initPiecesComplementaires();
        this.loadChoixMultiple();
        // if config is ON, show different forms
        if (this.depotRequeteState.formActivated) {
            this.initFormWhenJurisdictionIsON();
            // if config is OFF, show only DALO form if concernContentieuxSocial when urgenceRequete is 'une procédure normale'
        }
        else {
            if (this.depotRequeteState.urgenceRequete && this.depotRequeteState.urgenceRequete.codeUrgence === 0) {
                if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                    this.setAllSectionsInvisible();
                }
                else {
                    if (!this.depotRequeteState.concernContentieuxSocial) {
                        this.setAllSectionsInvisible();
                    }
                    else {
                        // show formulaire DALO
                        this.showSociauxDALOSections();
                    }
                }
            }
            else {
                this.setAllSectionsInvisible();
            }
        }
    };
    ContentieuxSocialSectionComponent.prototype.initPiecesComplementaires = function () {
        this.pieceComplementaireMalInterprete = new Array();
        this.pieceComplementaireMalApprecie = new Array();
        this.pieceComplementaireSommeDue = new Array();
        this.pieceComplementaireMontantDu = new Array();
        this.pieceComplmentaireAvisImpositionInfondeeEtAutre = new Array();
        this.pieceComplementairePrecisionPrejudice = new Array();
        this.pieceComplementaireRequeteRedigeeJust = new Array();
        this.pieceComplementaireRAPO =
            this.depotRequeteState.piecesComplementaires.find(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.RAPO;
            });
        this.pieceComplementaireMalInterprete =
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_INTERPRETE;
            });
        this.pieceComplementaireMalApprecie =
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_APPRECIE;
            });
        this.pieceComplementaireSommeDue =
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.SOMME_DUE;
            });
        this.pieceComplementaireMontantDu =
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MONTANT_DU;
            });
        this.pieceComplmentaireAvisImpositionInfondeeEtAutre =
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE;
            });
        this.pieceComplementairePrecisionPrejudice =
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.PRECISION_PREJUDICE;
            });
        this.pieceComplementaireRequeteRedigeeJust =
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF;
            });
    };
    ContentieuxSocialSectionComponent.prototype.loadChoixMultiple = function () {
        var _this = this;
        this.subscription = this.parametersService.getParameters()
            .subscribe(function (parameters) {
            _this.maxFileNameWithoutExtensionLength = parameters.maxFileNameWithoutExtensionLength;
            _this.maxFileSize = parameters.maxFileSize;
            _this.maxActeAttaquesForMerge = parameters.maxActeAttaquesForMerge;
            _this.maxReclamationPrealablesForMerge = parameters.maxActeAttaquesForMerge; // comme acte attaqué
            _this.typeRaisonContestations = parameters.typeRaisonContestations;
            _this.typeRaisonInvalidationTitres = parameters.typeRaisonInvalidationTitres;
            _this.typeRaisonAvisDimpositionIrreguliers = parameters.typeRaisonAvisDimpositionIrreguliers;
            _this.typePrejudiceEvaluableEnArgents = parameters.typePrejudiceEvaluableEnArgents;
            // si requeteCS est null, nettoie les données de ces 3 listes
            if (_this.depotRequeteState && !_this.depotRequeteState.requeteCS) {
                _this.clearTypeRaisonContestations();
                _this.clearTypeRaisonInvalidationTitres();
                _this.clearTypeRaisonAvisDimpositionIrreguliers();
                _this.clearTypePrejudiceEvaluableEnArgents();
            }
            if (_this.depotRequeteState && _this.depotRequeteState.requeteCS) {
                if (!_this.depotRequeteState.requeteCS.raisonContestations) {
                    _this.clearTypeRaisonContestations();
                }
                else {
                    _this.noneRCchecked = false;
                    _this.initTypeRaisonContestations();
                }
                if (!_this.depotRequeteState.requeteCS.raisonInvalidationTitres) {
                    _this.clearTypeRaisonInvalidationTitres();
                }
                else {
                    _this.noneRITchecked = false;
                    _this.initTypeRaisonInvalidationTitres();
                }
                if (!_this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers) {
                    _this.clearTypeRaisonAvisDimpositionIrreguliers();
                }
                else {
                    _this.noneRADIchecked = false;
                    _this.initTypeRaisonAvisDimpositionIrreguliers();
                }
                if (!_this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents) {
                    _this.clearTypePrejudiceEvaluableEnArgents();
                }
                else {
                    _this.nonePEEAchecked = false;
                    _this.initTypePrejudiceEvaluableEnArgents();
                }
            }
        });
    };
    ContentieuxSocialSectionComponent.prototype.clearTypeRaisonContestations = function () {
        this.noneRCchecked = true;
        try {
            for (var _a = __values(this.typeRaisonContestations), _b = _a.next(); !_b.done; _b = _a.next()) {
                var rc = _b.value;
                rc.checked = false;
                rc.detail = '';
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var e_1, _c;
    };
    ContentieuxSocialSectionComponent.prototype.clearTypeRaisonInvalidationTitres = function () {
        this.noneRITchecked = true;
        try {
            for (var _a = __values(this.typeRaisonInvalidationTitres), _b = _a.next(); !_b.done; _b = _a.next()) {
                var rit = _b.value;
                rit.checked = false;
                rit.detail = '';
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var e_2, _c;
    };
    ContentieuxSocialSectionComponent.prototype.clearTypeRaisonAvisDimpositionIrreguliers = function () {
        this.noneRADIchecked = true;
        try {
            for (var _a = __values(this.typeRaisonAvisDimpositionIrreguliers), _b = _a.next(); !_b.done; _b = _a.next()) {
                var ra = _b.value;
                ra.checked = false;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var e_3, _c;
    };
    ContentieuxSocialSectionComponent.prototype.clearTypePrejudiceEvaluableEnArgents = function () {
        this.nonePEEAchecked = true;
        try {
            for (var _a = __values(this.typePrejudiceEvaluableEnArgents), _b = _a.next(); !_b.done; _b = _a.next()) {
                var peea = _b.value;
                peea.checked = false;
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_4) throw e_4.error; }
        }
        var e_4, _c;
    };
    ContentieuxSocialSectionComponent.prototype.initTypeRaisonContestations = function () {
        var _loop_1 = function (rc) {
            var typeRaison = this_1.typeRaisonContestations.find(function (trc) { return trc.id === rc.typeRaisonContestationId; });
            if (typeRaison) {
                typeRaison.checked = true;
                typeRaison.detail = rc.detail;
            }
        };
        var this_1 = this;
        try {
            for (var _a = __values(this.depotRequeteState.requeteCS.raisonContestations), _b = _a.next(); !_b.done; _b = _a.next()) {
                var rc = _b.value;
                _loop_1(rc);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_5) throw e_5.error; }
        }
        var e_5, _c;
    };
    ContentieuxSocialSectionComponent.prototype.initTypeRaisonInvalidationTitres = function () {
        var _loop_2 = function (rit) {
            var typeRIT = this_2.typeRaisonInvalidationTitres.find(function (t) { return t.id === rit.typeRaisonInvalidationTitreId; });
            if (typeRIT) {
                typeRIT.checked = true;
                typeRIT.detail = rit.detail;
            }
        };
        var this_2 = this;
        try {
            for (var _a = __values(this.depotRequeteState.requeteCS.raisonInvalidationTitres), _b = _a.next(); !_b.done; _b = _a.next()) {
                var rit = _b.value;
                _loop_2(rit);
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_6) throw e_6.error; }
        }
        var e_6, _c;
    };
    ContentieuxSocialSectionComponent.prototype.initTypeRaisonAvisDimpositionIrreguliers = function () {
        var _loop_3 = function (ra) {
            var typeRA = this_3.typeRaisonAvisDimpositionIrreguliers.find(function (t) { return t.id === ra.typeRaisonAvisDimpositionIrregulierId; });
            if (typeRA) {
                typeRA.checked = true;
            }
        };
        var this_3 = this;
        try {
            for (var _a = __values(this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers), _b = _a.next(); !_b.done; _b = _a.next()) {
                var ra = _b.value;
                _loop_3(ra);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_7) throw e_7.error; }
        }
        var e_7, _c;
    };
    ContentieuxSocialSectionComponent.prototype.initTypePrejudiceEvaluableEnArgents = function () {
        var _loop_4 = function (peea) {
            var typePEEA = this_4.typePrejudiceEvaluableEnArgents.find(function (t) { return t.id === peea.typePrejudiceEvaluableEnArgentId; });
            if (typePEEA) {
                typePEEA.checked = true;
            }
        };
        var this_4 = this;
        try {
            for (var _a = __values(this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents), _b = _a.next(); !_b.done; _b = _a.next()) {
                var peea = _b.value;
                _loop_4(peea);
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_8) throw e_8.error; }
        }
        var e_8, _c;
    };
    ContentieuxSocialSectionComponent.prototype.initFormWhenJurisdictionIsON = function () {
        if (this.depotRequeteState.urgenceRequete && this.depotRequeteState.urgenceRequete.codeUrgence === 0) {
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.setAllSectionsInvisibleExceptSouhait();
                if (this.depotRequeteState.requeteCS) {
                    if (this.depotRequeteState.requeteCS.souhait) {
                        this.setSectionVisibilityBySouhait(this.depotRequeteState.requeteCS.souhait);
                        if (this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
                            this.showLitigeAvocat = true;
                            this.showTypeLitigeSection = true;
                            this.sections.typeLitige.index = 3;
                            this.setSectionVisibilityByTypeLitige(this.depotRequeteState.requeteCS.typeLitige);
                            if (this.depotRequeteState.requeteCS.typeLitige ===
                                'Vous contestez une somme d\'argent réclamée par l\'administration') {
                                this.setSectionVisibilityByTypeActe(this.depotRequeteState.requeteCS.typeActe);
                            }
                        }
                    }
                }
            }
            else {
                if (this.depotRequeteState.concernContentieuxSocial == null) {
                    this.setAllSectionsInvisible();
                }
                else if (this.depotRequeteState.concernContentieuxSocial != null &&
                    !this.depotRequeteState.concernContentieuxSocial && this.depotRequeteState.requeteCS) {
                    this.setSectionVisibilityBySouhait(this.depotRequeteState.requeteCS.souhait);
                    if (this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
                        this.showLitigeAvocat = true;
                        this.setSectionVisibilityByTypeLitige(this.depotRequeteState.requeteCS.typeLitige);
                        if (this.depotRequeteState.requeteCS.typeLitige ===
                            'Vous contestez une somme d\'argent réclamée par l\'administration') {
                            this.setSectionVisibilityByTypeActe(this.depotRequeteState.requeteCS.typeActe);
                        }
                    }
                }
            }
        }
        else {
            this.setAllSectionsInvisible();
        }
    };
    ContentieuxSocialSectionComponent.prototype.setAllSectionsInvisible = function () {
        this.showSouhaitSection = false;
        this.showRapoSection = false;
        this.showNomAdministrationsSection = false;
        this.showIntituleDemandeSection = false;
        this.showTypeLitigeSection = false;
        this.showReclamationPrealableSection = false;
        this.showDecisionAttaqueSection = false;
        this.showMotifSection = false;
        this.showContexteInterventionDecision = false;
        this.showRaisonsContesterDecisionSection = false;
        this.showSommeDueSection = false;
        this.showMontantDuSection = false;
        this.showFaitConduitLitigeSection = false;
        this.showTypeActeEmisSection = false;
        this.showAvisImpositionIrregulerSection = false;
        this.showRaisonPasPayerImpotSection = false;
        this.showTitreEmisIrregulerSection = false;
        this.showDALOConclusionSection = false;
        this.showConclusionLitigeAdminSection = false;
        this.showConclusionReclamerSommeSection = false;
        this.showConclusionAvisImpositionImpotSection = false;
        this.showConclusionTitreEmisIrregulerSection = false;
        this.showFaitConduitSituationReparationSection = false;
        this.showTypePrejudiceEvaluableEnArgentSection = false;
        this.showPrecisionPrejudiceSection = false;
        this.showOriginePrejudiceSection = false;
        this.showConclusionIndemnisationSection = false;
        this.showRequeteRedigeeSection = false;
        this.showRequeteRedigeeJustificatifsSection = false;
    };
    ContentieuxSocialSectionComponent.prototype.setAllSectionsInvisibleExceptSouhait = function () {
        this.setAllSectionsInvisible();
        this.showSouhaitSection = true;
        this.sections.souhait.index = 2;
        if (this.depotRequeteState.requeteCS &&
            this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
            this.showLitigeAvocat = true;
        }
        else {
            this.showLitigeAvocat = false;
        }
    };
    ContentieuxSocialSectionComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        console.log('ngOnChanges | changes.depotRequeteState.currentValue : ', changes.depotRequeteState.currentValue);
        if (changes.depotRequeteState.currentValue.urgenceRequete &&
            changes.depotRequeteState.currentValue.urgenceRequete.codeUrgence === 0) {
            this.depotRequeteState.concernContentieuxSocial = changes.depotRequeteState.currentValue.concernContentieuxSocial;
            if (this.depotRequeteState.concernContentieuxSocial) {
                Object.keys(this.sociauxDALOChampsObligatoiresFilled).forEach(function (v) { return _this.sociauxDALOChampsObligatoiresFilled[v] = true; });
            }
            else {
                Object.keys(this.litigeLieDecisionChampsObligatoiresFilled).forEach(function (v) {
                    return _this.litigeLieDecisionChampsObligatoiresFilled[v] = true;
                });
                Object.keys(this.reclamerUneSommeChampsObligatoiresFilled).forEach(function (v) {
                    return _this.reclamerUneSommeChampsObligatoiresFilled[v] = true;
                });
                Object.keys(this.contesterUneSommeChampsObligatoiresFilled).forEach(function (v) {
                    return _this.contesterUneSommeChampsObligatoiresFilled[v] = true;
                });
                Object.keys(this.indemnisationChampsObligatoiresFilled).forEach(function (v) {
                    return _this.indemnisationChampsObligatoiresFilled[v] = true;
                });
            }
        }
        else {
            Object.keys(this.sociauxDALOChampsObligatoiresFilled).forEach(function (v) { return _this.sociauxDALOChampsObligatoiresFilled[v] = true; });
            Object.keys(this.litigeLieDecisionChampsObligatoiresFilled).forEach(function (v) {
                return _this.litigeLieDecisionChampsObligatoiresFilled[v] = true;
            });
            Object.keys(this.reclamerUneSommeChampsObligatoiresFilled).forEach(function (v) {
                return _this.reclamerUneSommeChampsObligatoiresFilled[v] = true;
            });
            Object.keys(this.contesterUneSommeChampsObligatoiresFilled).forEach(function (v) {
                return _this.contesterUneSommeChampsObligatoiresFilled[v] = true;
            });
            Object.keys(this.indemnisationChampsObligatoiresFilled).forEach(function (v) {
                return _this.indemnisationChampsObligatoiresFilled[v] = true;
            });
        }
        this.updateSectionsIndiceAndVisibility(changes.depotRequeteState.currentValue);
    };
    ContentieuxSocialSectionComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.dragSubscription.unsubscribe();
        this.dropSubscription.unsubscribe();
        _super.prototype.ngOnDestroy.call(this);
    };
    Object.defineProperty(ContentieuxSocialSectionComponent.prototype, "isActeAttaquesMaxSizeExceeded", {
        get: function () {
            return (this.depotRequeteState.acteAttaquesAFusioner.reduce(function (acc, aa) { return acc + aa.fileModel.fileSize; }, 0) >
                this.maxFileSize);
        },
        enumerable: true,
        configurable: true
    });
    ContentieuxSocialSectionComponent.prototype.updateSectionsIndiceAndVisibility = function (depotRequeteState) {
        if (depotRequeteState.formActivated) {
            if (depotRequeteState.urgenceRequete && depotRequeteState.urgenceRequete.codeUrgence === 0) {
                if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                    this.setAllSectionsInvisibleExceptSouhait();
                    if (this.contentieuxSocial.souhait) {
                        this.setSectionVisibilityBySouhait(this.contentieuxSocial.souhait);
                    }
                }
                else {
                    if (depotRequeteState.concernContentieuxSocial == null) {
                        this.setAllSectionsInvisible();
                    }
                    else if (depotRequeteState.concernContentieuxSocial === true) {
                        this.showSociauxDALOSections();
                    }
                    else {
                        this.showRapoSection = false;
                        this.showSouhaitSection = true;
                        this.showMotifSection = false;
                        this.showDALOConclusionSection = false;
                        this.setSectionVisibilityBySouhait(this.contentieuxSocial.souhait);
                        if (this.depotRequeteState.requeteCS &&
                            this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
                            this.setSectionVisibilityByTypeLitige(this.depotRequeteState.requeteCS.typeLitige);
                            if (this.depotRequeteState.requeteCS.typeLitige ===
                                'Vous contestez une somme d\'argent réclamée par l\'administration') {
                                this.setSectionVisibilityByTypeActe(this.depotRequeteState.requeteCS.typeActe);
                            }
                        }
                    }
                }
            }
            else {
                this.setAllSectionsInvisible();
            }
        }
        else {
            if (depotRequeteState.urgenceRequete && depotRequeteState.urgenceRequete.codeUrgence === 0) {
                if (depotRequeteState.concernContentieuxSocial === true) {
                    this.showSociauxDALOSections();
                }
                else {
                    this.setAllSectionsInvisible();
                }
            }
            else {
                this.setAllSectionsInvisible();
            }
        }
    };
    ContentieuxSocialSectionComponent.prototype.showSociauxDALOSections = function () {
        this.showRapoSection = true;
        this.showDecisionAttaqueSection = true;
        this.showNomAdministrationsSection = true;
        this.showIntituleDemandeSection = true;
        this.showMotifSection = true;
        this.showDALOConclusionSection = true;
        this.showConclusionLitigeAdminSection = false;
        this.showTypeLitigeSection = false;
        this.showFaitConduitLitigeSection = false;
        this.showTypeActeEmisSection = false;
        this.showAvisImpositionIrregulerSection = false;
        this.showRaisonPasPayerImpotSection = false;
        this.showTitreEmisIrregulerSection = false;
        this.showReclamationPrealableSection = false;
        this.showSouhaitSection = false;
        this.showContexteInterventionDecision = false;
        this.showRaisonsContesterDecisionSection = false;
        this.showSommeDueSection = false;
        this.showMontantDuSection = false;
        this.showConclusionReclamerSommeSection = false;
        this.showConclusionAvisImpositionImpotSection = false;
        this.showConclusionTitreEmisIrregulerSection = false;
        this.showFaitConduitSituationReparationSection = false;
        this.showTypePrejudiceEvaluableEnArgentSection = false;
        this.showPrecisionPrejudiceSection = false;
        this.showOriginePrejudiceSection = false;
        this.showConclusionIndemnisationSection = false;
        this.showRequeteRedigeeSection = false;
        this.showRequeteRedigeeJustificatifsSection = false;
        this.sections.hasDecisionAttaque.index = 4;
        this.sections.administrationDecision.index = 5;
        this.sections.intituleDemande.index = 6;
        this.sections.motifDemande.index = 7;
        this.sections.conclusionDALO.index = 8;
    };
    ContentieuxSocialSectionComponent.prototype.registerOnChange = function (fn) {
        _super.prototype.registerOnChange.call(this, fn);
    };
    ContentieuxSocialSectionComponent.prototype.modelValueChanged = function (value) {
        this.contentieuxSocial = value || new contentieux_social_1.ContentieuxSocial();
        if (value && value.hasDocument) {
            this.contentieuxSocial.raisonSansDocument = '';
        }
    };
    ContentieuxSocialSectionComponent.prototype.clearDecisionAttaqueeJointPiece = function (value) {
        console.log('clearDecisionAttaqueJointPiece value', value);
        if (value !== null) {
            this.depotRequeteState.acteAttaquesAFusioner.length = 0;
        }
    };
    ContentieuxSocialSectionComponent.prototype.onContentieuxSocialChange = function () {
        this.onChange(this.contentieuxSocial);
    };
    ContentieuxSocialSectionComponent.prototype.onSetSouhait = function (value) {
        var _this = this;
        this.clearRequete();
        if (value === 'Remplir le formulaire : litige lié à une somme d\'argent') {
            this.showLitigeAvocat = true;
        }
        else {
            this.showLitigeAvocat = false;
        }
        if (this.souhaitTexts.find(function (s) { return s.description === value; })) {
            this.contentieuxSocial.souhait = this.souhaitTexts.find(function (s) { return s.description === value; }).description;
            this.onContentieuxSocialChange();
        }
        Object.keys(this.litigeLieDecisionChampsObligatoiresFilled).forEach(function (v) {
            return _this.litigeLieDecisionChampsObligatoiresFilled[v] = true;
        });
        Object.keys(this.reclamerUneSommeChampsObligatoiresFilled).forEach(function (v) {
            return _this.reclamerUneSommeChampsObligatoiresFilled[v] = true;
        });
        Object.keys(this.contesterUneSommeChampsObligatoiresFilled).forEach(function (v) {
            return _this.contesterUneSommeChampsObligatoiresFilled[v] = true;
        });
        Object.keys(this.indemnisationChampsObligatoiresFilled).forEach(function (v) {
            return _this.indemnisationChampsObligatoiresFilled[v] = true;
        });
        this.setSectionVisibilityBySouhait(value);
    };
    ContentieuxSocialSectionComponent.prototype.clearRequete = function () {
        if (this.depotRequeteState.requete) {
            this.depotRequeteState.requete = null;
        }
    };
    ContentieuxSocialSectionComponent.prototype.setSectionVisibilityBySouhait = function (checkedSouhait) {
        if (checkedSouhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
            this.showTypeLitigeSection = true;
            this.showReclamationPrealableSection = false;
            this.showNomAdministrationsSection = false;
            this.showIntituleDemandeSection = false;
            this.showContexteInterventionDecision = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDecisionAttaqueSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.typeLitige.index = 3;
            }
            else {
                this.sections.typeLitige.index = 4;
            }
            this.setSectionVisibilityByTypeLitige(this.contentieuxSocial.typeLitige);
            this.showLitigeAvocat = true;
        }
        else if (checkedSouhait === 'Déposer une requête que vous avez rédigée') {
            this.showNomAdministrationsSection = false;
            this.showIntituleDemandeSection = false;
            this.showContexteInterventionDecision = false;
            this.showTypeLitigeSection = false;
            this.showDecisionAttaqueSection = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showDALOConclusionSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showReclamationPrealableSection = true;
            this.showRequeteRedigeeSection = true;
            this.showRequeteRedigeeJustificatifsSection = true;
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.requeteRedigeeDecisionAttaque.index = 3;
                this.sections.reclamationPrealable.index = 4;
                this.sections.depotRequeteRedigee.index = 5;
                this.sections.requeteRedigeeJustificatifs.index = 6;
            }
            else {
                this.sections.requeteRedigeeDecisionAttaque.index = 4;
                this.sections.reclamationPrealable.index = 5;
                this.sections.depotRequeteRedigee.index = 6;
                this.sections.requeteRedigeeJustificatifs.index = 7;
            }
            this.showLitigeAvocat = false;
        }
        else if (checkedSouhait === 'Remplir le formulaire : litige lié à une décision de l\'administration') {
            this.showDecisionAttaqueSection = true;
            this.showNomAdministrationsSection = true;
            this.showIntituleDemandeSection = true;
            this.showContexteInterventionDecision = true;
            this.showRaisonsContesterDecisionSection = true;
            this.showConclusionLitigeAdminSection = true;
            this.showDALOConclusionSection = false;
            this.showTypeLitigeSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showReclamationPrealableSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.hasDecisionAttaque.index = 3;
                this.sections.administrationDecision.index = 4;
                this.sections.intituleDemande.index = 5;
                this.sections.contexteInterventionDecision.index = 6;
                this.sections.raisonsContesterDecision.index = 7;
                this.sections.conclusionLitigeAdmin.index = 8;
            }
            else {
                this.sections.hasDecisionAttaque.index = 4;
                this.sections.administrationDecision.index = 5;
                this.sections.intituleDemande.index = 6;
                this.sections.contexteInterventionDecision.index = 7;
            }
            this.showLitigeAvocat = false;
            // arrive pour la 1ère fois au formulaire
        }
        else {
            this.showDecisionAttaqueSection = false;
            this.showNomAdministrationsSection = false;
            this.showIntituleDemandeSection = false;
            this.showContexteInterventionDecision = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showDALOConclusionSection = false;
            this.showTypeLitigeSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showReclamationPrealableSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
            this.showLitigeAvocat = false;
        }
    };
    ContentieuxSocialSectionComponent.prototype.onSetTypeLitige = function (value) {
        var _this = this;
        if (this.reclamationPrealableComponent) {
            this.reclamationPrealableComponent.markAsUntouched();
        }
        if (this.typeLitigeTexts.find(function (t) { return t.title === value; })) {
            this.contentieuxSocial.typeLitige = this.typeLitigeTexts.find(function (t) { return t.title === value; }).title;
            console.log('onSetTypeLitige | typeLitige ', this.contentieuxSocial.typeLitige);
            this.onContentieuxSocialChange();
        }
        this.setSectionVisibilityByTypeLitige(value);
        Object.keys(this.reclamerUneSommeChampsObligatoiresFilled).forEach(function (v) {
            return _this.reclamerUneSommeChampsObligatoiresFilled[v] = true;
        });
        Object.keys(this.contesterUneSommeChampsObligatoiresFilled).forEach(function (v) {
            return _this.contesterUneSommeChampsObligatoiresFilled[v] = true;
        });
        Object.keys(this.indemnisationChampsObligatoiresFilled).forEach(function (v) {
            return _this.indemnisationChampsObligatoiresFilled[v] = true;
        });
    };
    ContentieuxSocialSectionComponent.prototype.setSectionVisibilityByTypeLitige = function (checkedTypeLitige) {
        if (!checkedTypeLitige) {
            this.showReclamationPrealableSection = false;
            this.showNomAdministrationsSection = false;
            this.showIntituleDemandeSection = false;
            this.showContexteInterventionDecision = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showDecisionAttaqueSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
        }
        else if (checkedTypeLitige === 'Vous réclamez une somme d\'argent à l\'administration') {
            this.showReclamationPrealableSection = true;
            this.showNomAdministrationsSection = true;
            this.showIntituleDemandeSection = true;
            this.showContexteInterventionDecision = true;
            this.showSommeDueSection = true;
            this.showMontantDuSection = true;
            this.showConclusionReclamerSommeSection = true;
            this.showRaisonsContesterDecisionSection = false;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showDecisionAttaqueSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.reclamationPrealable.index = 4;
                this.sections.administrationDecision.index = 5;
                this.sections.intituleDemande.index = 6;
                this.sections.contexteInterventionDecision.index = 7;
                this.sections.sommeDueSection.index = 8;
                this.sections.montantDuSection.index = 9;
                this.sections.conclusionReclamerSommeSection.index = 10;
            }
            else {
                this.sections.reclamationPrealable.index = 5;
                this.sections.administrationDecision.index = 6;
                this.sections.intituleDemande.index = 7;
                this.sections.contexteInterventionDecision.index = 8;
                this.sections.sommeDueSection.index = 9;
                this.sections.montantDuSection.index = 10;
                this.sections.conclusionReclamerSommeSection.index = 11;
            }
        }
        else if (checkedTypeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration') {
            this.showReclamationPrealableSection = true;
            this.showNomAdministrationsSection = true;
            this.showIntituleDemandeSection = true;
            this.showFaitConduitLitigeSection = true;
            this.showTypeActeEmisSection = true;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showContexteInterventionDecision = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDecisionAttaqueSection = false;
            this.showFaitConduitSituationReparationSection = false;
            this.showTypePrejudiceEvaluableEnArgentSection = false;
            this.showPrecisionPrejudiceSection = false;
            this.showOriginePrejudiceSection = false;
            this.showConclusionIndemnisationSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.reclamationPrealable.index = 4;
                this.sections.administrationDecision.index = 5;
                this.sections.intituleDemande.index = 6;
                this.sections.faitConduitLitigeSection.index = 7;
                this.sections.typeActeEmisSection.index = 8;
            }
            else {
                this.sections.reclamationPrealable.index = 5;
                this.sections.administrationDecision.index = 6;
                this.sections.intituleDemande.index = 7;
                this.sections.contexteInterventionDecision.index = 8;
            }
            this.setSectionVisibilityByTypeActe(this.contentieuxSocial.typeActe);
        }
        else {
            this.showReclamationPrealableSection = true;
            this.showNomAdministrationsSection = true;
            this.showIntituleDemandeSection = true;
            this.showFaitConduitSituationReparationSection = true;
            this.showTypePrejudiceEvaluableEnArgentSection = true;
            this.showPrecisionPrejudiceSection = true;
            this.showOriginePrejudiceSection = true;
            this.showConclusionIndemnisationSection = true;
            this.showFaitConduitLitigeSection = false;
            this.showTypeActeEmisSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showRaisonPasPayerImpotSection = false;
            this.showTitreEmisIrregulerSection = false;
            this.showContexteInterventionDecision = false;
            this.showRaisonsContesterDecisionSection = false;
            this.showSommeDueSection = false;
            this.showMontantDuSection = false;
            this.showConclusionReclamerSommeSection = false;
            this.showDALOConclusionSection = false;
            this.showConclusionLitigeAdminSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showDecisionAttaqueSection = false;
            this.showRequeteRedigeeSection = false;
            this.showRequeteRedigeeJustificatifsSection = false;
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.reclamationPrealable.index = 4;
                this.sections.administrationDecision.index = 5;
                this.sections.intituleDemande.index = 6;
                this.sections.faitConduitSituationReparationSection.index = 7;
                this.sections.typePrejudiceEvaluableEnArgentSection.index = 8;
                this.sections.precisionPrejudiceSection.index = 9;
                this.sections.originePrejudiceSection.index = 10;
                this.sections.conclusionIndemnisationSection.index = 11;
            }
            else {
                this.sections.reclamationPrealable.index = 5;
                this.sections.administrationDecision.index = 6;
                this.sections.intituleDemande.index = 7;
                this.sections.faitConduitSituationReparationSection.index = 8;
                this.sections.typePrejudiceEvaluableEnArgentSection.index = 9;
                this.sections.precisionPrejudiceSection.index = 10;
                this.sections.originePrejudiceSection.index = 11;
                this.sections.conclusionIndemnisationSection.index = 12;
            }
        }
    };
    ContentieuxSocialSectionComponent.prototype.onSetTypeActe = function (value) {
        console.log('onSetTypeActe checked type acte ', value);
        if (this.typeActeEmisTexts.find(function (t) { return t.title === value; })) {
            this.contentieuxSocial.typeActe = this.typeActeEmisTexts.find(function (t) { return t.title === value; }).title;
            if (value === 'Un avis d\'imposition') {
                this.typeActeAdderLabel = 'Avis d\'imposition';
            }
            else {
                this.typeActeAdderLabel = 'Acte émis par l\'administration';
            }
            this.onContentieuxSocialChange();
        }
        // enlève pièces complémentaires avis imposition erreur calcul ou infondee et autre si existe
        this.pieceComplmentaireAvisImpositionInfondeeEtAutre.length = 0;
        this.depotRequeteState.piecesComplementaires = this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType !== piece_jointe_1.PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE;
        });
        this.contesterUneSommeChampsObligatoiresFilled.raisonAvisDimpositionIrreguliers = true;
        this.contesterUneSommeChampsObligatoiresFilled.conclusionAvisImpositionImpot = true;
        this.contesterUneSommeChampsObligatoiresFilled.avisImpositionErreurCalcul = true;
        this.contesterUneSommeChampsObligatoiresFilled.raisonPasPayerImpot = true;
        this.contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitres = true;
        this.contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitreDetail = true;
        this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierDes = true;
        this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierMontant = true;
        this.setSectionVisibilityByTypeActe(value);
    };
    ContentieuxSocialSectionComponent.prototype.setSectionVisibilityByTypeActe = function (checkedTypeActe) {
        if (!checkedTypeActe) {
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            this.showAvisImpositionIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showRaisonPasPayerImpotSection = false;
        }
        else if (checkedTypeActe === 'Un avis d\'imposition') {
            this.typeActeAdderLabel = 'Avis d\'imposition';
            this.showAvisImpositionIrregulerSection = true;
            this.showRaisonPasPayerImpotSection = true;
            this.showConclusionAvisImpositionImpotSection = true;
            this.showTitreEmisIrregulerSection = false;
            this.showConclusionTitreEmisIrregulerSection = false;
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.avisImpositionIrregulerSection.index = 9;
                this.sections.raisonPasPayerImpotSection.index = 10;
                this.sections.conclusionAvisImpositionImpotSection.index = 11;
            }
            else {
                this.sections.avisImpositionIrregulerSection.index = 10;
                this.sections.raisonPasPayerImpotSection.index = 11;
                this.sections.conclusionAvisImpositionImpotSection.index = 12;
            }
        }
        else {
            this.typeActeAdderLabel = 'Acte émis par l\'administration';
            this.showTitreEmisIrregulerSection = true;
            this.showConclusionTitreEmisIrregulerSection = true;
            this.showAvisImpositionIrregulerSection = false;
            this.showConclusionAvisImpositionImpotSection = false;
            this.showRaisonPasPayerImpotSection = false;
            if (this.depotRequeteState.typeJuridiction.code === 'CE') {
                this.sections.titreEmisIrregulerSection.index = 9;
                this.sections.conclusionTitreEmisIrregulerSection.index = 10;
            }
            else {
                this.sections.titreEmisIrregulerSection.index = 10;
                this.sections.conclusionTitreEmisIrregulerSection.index = 11;
            }
        }
    };
    ContentieuxSocialSectionComponent.prototype.reclamerSommeNomAdminsFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
            !this.reclamerUneSommeChampsObligatoiresFilled.nomsAdministrations &&
            this.contentieuxSocial.nomsAdministrations == null;
    };
    ContentieuxSocialSectionComponent.prototype.reclamerSommeObjectDemandeFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
            !this.reclamerUneSommeChampsObligatoiresFilled.objetDemande &&
            this.contentieuxSocial.objetDemande == null;
    };
    ContentieuxSocialSectionComponent.prototype.reclamerSommeContexteInterventionDecisionFilled = function () {
        return this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
            !this.reclamerUneSommeChampsObligatoiresFilled.contexteInterventionDecision &&
            this.contentieuxSocial.contexteInterventionDecision == null;
    };
    ContentieuxSocialSectionComponent.prototype.reclamerSommePourquoiSommeDueFilled = function () {
        return this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
            !this.reclamerUneSommeChampsObligatoiresFilled.pourquoiSommeDue &&
            this.contentieuxSocial.pourquoiSommeDue == null;
    };
    ContentieuxSocialSectionComponent.prototype.reclamerSommeMontantDuMontantFilled = function () {
        return this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
            !this.reclamerUneSommeChampsObligatoiresFilled.montantDuMontant &&
            this.contentieuxSocial.montantDuMontant == null;
    };
    ContentieuxSocialSectionComponent.prototype.reclamerSommeConclusionFilled = function () {
        return this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration' &&
            !this.reclamerUneSommeChampsObligatoiresFilled.conclusionReclamerSommeCondamnerAdmin &&
            !this.contentieuxSocial.conclusionReclamerSommeCondamnerAdmin;
    };
    ContentieuxSocialSectionComponent.prototype.contesterSommeNomAdminsFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
            !this.contesterUneSommeChampsObligatoiresFilled.nomsAdministrations &&
            this.contentieuxSocial.nomsAdministrations == null;
    };
    ContentieuxSocialSectionComponent.prototype.contesterSommeObjectDemandeFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
            !this.contesterUneSommeChampsObligatoiresFilled.objetDemande &&
            this.contentieuxSocial.objetDemande == null;
    };
    ContentieuxSocialSectionComponent.prototype.contesterSommeFaitConduitAuLitigeFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
            !this.contesterUneSommeChampsObligatoiresFilled.faitConduitAuLitige &&
            this.contentieuxSocial.faitConduitAuLitige == null;
    };
    ContentieuxSocialSectionComponent.prototype.contesterSommeRaisonPasPayerImpotFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
            this.contentieuxSocial.typeActe === 'Un avis d\'imposition' &&
            !this.contesterUneSommeChampsObligatoiresFilled.raisonPasPayerImpot &&
            this.contentieuxSocial.raisonPasPayerImpot == null;
    };
    ContentieuxSocialSectionComponent.prototype.contesterSommeConclusionAvisImpositionImpotFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
            this.contentieuxSocial.typeActe === 'Un avis d\'imposition' &&
            !this.contesterUneSommeChampsObligatoiresFilled.conclusionAvisImpositionImpot &&
            this.contentieuxSocial.conclusionAvisImpositionImpot == null;
    };
    ContentieuxSocialSectionComponent.prototype.contesterSommeConclusionContesterSommeTitreEmisIrregulierDesFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
            this.contentieuxSocial.typeActe === 'Un titre de recette, un avis de somme à payer, ou autre' &&
            !this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierDes &&
            this.contentieuxSocial.conclusionContesterSommeTitreEmisIrregulierDes == null;
    };
    ContentieuxSocialSectionComponent.prototype.contesterSommeConclusionContesterSommeTitreEmisIrregulierMontantFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous contestez une somme d\'argent réclamée par l\'administration' &&
            this.contentieuxSocial.typeActe === 'Un titre de recette, un avis de somme à payer, ou autre' &&
            !this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierMontant &&
            this.contentieuxSocial.conclusionContesterSommeTitreEmisIrregulierMontant == null;
    };
    ContentieuxSocialSectionComponent.prototype.indemnisationNomAdminsFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
                ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
            !this.indemnisationChampsObligatoiresFilled.nomsAdministrations &&
            this.contentieuxSocial.nomsAdministrations == null;
    };
    ContentieuxSocialSectionComponent.prototype.indemnisationObjetDemandeFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
                ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
            !this.indemnisationChampsObligatoiresFilled.objetDemande &&
            this.contentieuxSocial.objetDemande == null;
    };
    ContentieuxSocialSectionComponent.prototype.indemnisationFaitConduitSituationReparationFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
                ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
            !this.indemnisationChampsObligatoiresFilled.faitConduitSituationReparation &&
            this.contentieuxSocial.faitConduitSituationReparation == null;
    };
    ContentieuxSocialSectionComponent.prototype.indemnisationPrecisionPrejudiceFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
                ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
            !this.indemnisationChampsObligatoiresFilled.precisionPrejudice &&
            this.contentieuxSocial.precisionPrejudice == null;
    };
    ContentieuxSocialSectionComponent.prototype.indemnisationOriginePrejudiceFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
                ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
            !this.indemnisationChampsObligatoiresFilled.originePrejudice &&
            this.contentieuxSocial.originePrejudice == null;
    };
    ContentieuxSocialSectionComponent.prototype.indemnisationConclusionIndemnisationCondamnerAdminFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
                ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
            !this.indemnisationChampsObligatoiresFilled.conclusionIndemnisationCondamnerAdmin &&
            this.contentieuxSocial.conclusionIndemnisationCondamnerAdmin == null;
    };
    ContentieuxSocialSectionComponent.prototype.indemnisationConclusionIndemnisationMontantFilled = function () {
        return !this.depotRequeteState.concernContentieuxSocial &&
            this.contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent' &&
            this.contentieuxSocial.typeLitige === 'Vous réclamez une indemnisation pour une faute commise par' +
                ' l\'administration ou une situation anormale (la faute peut relever d\'une action ou d\'une inaction de l\'administration)' &&
            !this.indemnisationChampsObligatoiresFilled.conclusionIndemnisationMontant &&
            this.contentieuxSocial.conclusionIndemnisationMontant == null;
    };
    ContentieuxSocialSectionComponent.prototype.onRAPOChange = function (file) {
        if (file) {
            // clear the pieces complementaires array first
            this.pieceComplementaireRAPO = undefined;
            this.depotRequeteState.piecesComplementaires.push(new piece_jointe_1.PieceComplementaire(file, piece_jointe_1.PieceJointType.PIECE_JOINTE_REQUETE, piece_jointe_1.PieceComplementaireOrigineType.RAPO));
        }
    };
    ContentieuxSocialSectionComponent.prototype.onRequeteRedigeeChange = function (file) {
        if (file) {
            // clear exist requete first
            this.depotRequeteState.requete = null;
            this.depotRequeteState.requete = new piece_jointe_1.PieceRequete(file);
        }
    };
    ContentieuxSocialSectionComponent.prototype.resetGeneratedActeAttaque = function () {
        this.depotRequeteState.acteAttaque = new piece_jointe_1.PieceActeAttaque(null);
    };
    ContentieuxSocialSectionComponent.prototype.resetGeneratedReclamationPrealable = function () {
        this.depotRequeteState.reclamationPrealable = new piece_jointe_1.PieceReclamationPrealable(null);
    };
    Object.defineProperty(ContentieuxSocialSectionComponent.prototype, "isReclamationPrealablesMaxSizeExceeded", {
        get: function () {
            return (this.depotRequeteState.reclamationPrealablesAFusioner.reduce(function (acc, aa) { return acc + aa.fileModel.fileSize; }, 0) >
                this.maxFileSize);
        },
        enumerable: true,
        configurable: true
    });
    ContentieuxSocialSectionComponent.prototype.onRaisonContestationCheck = function () {
        var checkedRC = this.typeRaisonContestations.filter(function (rct) { return rct.checked; });
        this.contentieuxSocial.raisonContestations = checkedRC.map(function (rc) { return ({ typeRaisonContestationId: rc.id, detail: rc.detail }); });
        this.onContentieuxSocialChange();
        if (this.contentieuxSocial.raisonContestations.length === 0) {
            this.noneRCchecked = true;
        }
        else {
            this.noneRCchecked = false;
        }
    };
    ContentieuxSocialSectionComponent.prototype.noRaisonContestationChecked = function () {
        return this.typeRaisonContestations.some(function (t) { return t.checked; });
    };
    ContentieuxSocialSectionComponent.prototype.onRaisonInvalidationTitreCheck = function () {
        var checkedRIT = this.typeRaisonInvalidationTitres.filter(function (rit) { return rit.checked; });
        this.contentieuxSocial.raisonInvalidationTitres = checkedRIT.map(function (rit) {
            return ({ typeRaisonInvalidationTitreId: rit.id, detail: rit.detail });
        });
        this.onContentieuxSocialChange();
        if (this.contentieuxSocial.raisonInvalidationTitres.length === 0) {
            this.noneRITchecked = true;
        }
        else {
            this.noneRITchecked = false;
        }
    };
    ContentieuxSocialSectionComponent.prototype.noRaisonInvalidationTitreChecked = function () {
        return this.typeRaisonInvalidationTitres.some(function (t) { return t.checked; });
    };
    ContentieuxSocialSectionComponent.prototype.onRaisonAvisDimpositionIrregulierCheck = function () {
        var checkedRADI = this.typeRaisonAvisDimpositionIrreguliers.filter(function (r) { return r.checked; });
        this.contentieuxSocial.raisonAvisDimpositionIrreguliers = checkedRADI.map(function (r) { return ({ typeRaisonAvisDimpositionIrregulierId: r.id }); });
        this.onContentieuxSocialChange();
        if (this.contentieuxSocial.raisonAvisDimpositionIrreguliers.length === 0) {
            this.noneRADIchecked = true;
        }
        else {
            this.noneRADIchecked = false;
        }
    };
    ContentieuxSocialSectionComponent.prototype.noRaisonAvisDimpositionIrregulierChecked = function () {
        return this.typeRaisonAvisDimpositionIrreguliers.some(function (r) { return r.checked; });
    };
    ContentieuxSocialSectionComponent.prototype.onPrejudiceEvaluableEnArgentCheck = function () {
        var checkedPEEA = this.typePrejudiceEvaluableEnArgents.filter(function (p) { return p.checked; });
        this.contentieuxSocial.prejudiceEvaluableEnArgents = checkedPEEA.map(function (p) { return ({ typePrejudiceEvaluableEnArgentId: p.id }); });
        this.onContentieuxSocialChange();
        if (this.contentieuxSocial.prejudiceEvaluableEnArgents.length === 0) {
            this.nonePEEAchecked = true;
        }
        else {
            this.nonePEEAchecked = false;
        }
    };
    ContentieuxSocialSectionComponent.prototype.noPrejudiceEvaluableEnArgentChecked = function () {
        return this.typePrejudiceEvaluableEnArgents.some(function (t) { return t.checked; });
    };
    ContentieuxSocialSectionComponent.prototype.sansRaisonDisabled = function () {
        return this.depotRequeteState.requeteCS == null
            || this.depotRequeteState.requeteCS.hasDocument == null
            || this.contentieuxSocial.hasDocument;
    };
    ContentieuxSocialSectionComponent.prototype.openWarningModal = function (modal) {
        var _this = this;
        this.modalReference = this.modalService.open(modal, { size: 'lg' });
        this.modalReference.result.then(function (_) {
            _this.modalReference.close();
        }, function (_) {
            _this.modalReference.close();
        });
        // RGAA workaround
        var modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', 'Avertissement');
    };
    ContentieuxSocialSectionComponent.prototype.onPieceComplementaireDelete = function (index, file, piecesComplementaires) {
        if (!file) {
            // delete from piecesComplementaires;
            var piece = piecesComplementaires[index];
            piecesComplementaires.splice(index, 1);
            // delete from depotRequeteState.piecesComplementaires
            var idxInStatePC = this.depotRequeteState.piecesComplementaires.indexOf(piece);
            this.depotRequeteState.piecesComplementaires.splice(idxInStatePC, 1);
        }
    };
    ContentieuxSocialSectionComponent.prototype.onPieceComplementaireMIAdd = function (file) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireMalInterprete, piece_jointe_1.PieceComplementaireOrigineType.MAL_INTERPRETE, this.pieceMIAdder);
        }
    };
    ContentieuxSocialSectionComponent.prototype.onPieceComplementaireMAAdd = function (file) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireMalApprecie, piece_jointe_1.PieceComplementaireOrigineType.MAL_APPRECIE, this.pieceMAAdder);
        }
    };
    ContentieuxSocialSectionComponent.prototype.onPieceComplementaireSommeDueAdd = function (file) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireSommeDue, piece_jointe_1.PieceComplementaireOrigineType.SOMME_DUE, this.pieceSommeDueAdder);
        }
    };
    ContentieuxSocialSectionComponent.prototype.onPieceComplementaireMontantDuAdd = function (file) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireMontantDu, piece_jointe_1.PieceComplementaireOrigineType.MONTANT_DU, this.pieceMontantDuAdder);
        }
    };
    ContentieuxSocialSectionComponent.prototype.onPieceComplementaireAIIAAdd = function (file) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplmentaireAvisImpositionInfondeeEtAutre, piece_jointe_1.PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE, this.pieceAIIAAdder);
        }
    };
    ContentieuxSocialSectionComponent.prototype.onPieceComplementairePrecisionPrejudiceAdd = function (file) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementairePrecisionPrejudice, piece_jointe_1.PieceComplementaireOrigineType.PRECISION_PREJUDICE, this.piecePrecisionPrejudiceAdder);
        }
    };
    ContentieuxSocialSectionComponent.prototype.onPieceComplementaireRequeteRedigeeJustAdd = function (file) {
        if (file) {
            this.addPieceComplementaire(file, this.pieceComplementaireRequeteRedigeeJust, piece_jointe_1.PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF, this.pieceRequeteRedigeeJustAdder);
        }
    };
    ContentieuxSocialSectionComponent.prototype.addPieceComplementaire = function (file, pieceList, originType, pieceAdder) {
        pieceList.push(new piece_jointe_1.PieceComplementaire(file, piece_jointe_1.PieceJointType.PIECE_JOINTE_REQUETE, originType));
        this.depotRequeteState.piecesComplementaires.push(new piece_jointe_1.PieceComplementaire(file, piece_jointe_1.PieceJointType.PIECE_JOINTE_REQUETE, originType));
        pieceAdder.deleteFile();
    };
    ContentieuxSocialSectionComponent.prototype.checkLengthForFileName = function (value, file) {
        if (value) {
            this.actualFileNameLength = value.length;
            this.showLengthWarningForFileName = value.length > this.maxFileNameWithoutExtensionLength;
            if (!this.showLengthWarningForFileName) {
                var piece = this.depotRequeteState.piecesComplementaires.find(function (pc) { return pc.fileModel === file.fileModel; });
                if (piece) {
                    piece.libelle = file.libelle;
                }
            }
        }
    };
    // @ts-ignore
    ContentieuxSocialSectionComponent.prototype.trackByFileApiId = function (index, item) {
        return item.fileModel.fileApiId;
    };
    // --- drag n drop keyboard accessible
    ContentieuxSocialSectionComponent.prototype.onMoveup = function (data, pieceComplementaire) {
        this.moveUp(data.i, pieceComplementaire);
    };
    ContentieuxSocialSectionComponent.prototype.onMovedown = function (data, pieceComplementaire) {
        this.moveDown(data.i, pieceComplementaire);
    };
    ContentieuxSocialSectionComponent.prototype.moveUp = function (index, pieceComplementaire) {
        if (index > 0) {
            this.swapPiecesComplementaire(index - 1, index, pieceComplementaire);
        }
    };
    ContentieuxSocialSectionComponent.prototype.moveDown = function (index, pieceComplementaire) {
        if (index < pieceComplementaire.length - 1) {
            this.swapPiecesComplementaire(index + 1, index, pieceComplementaire);
        }
    };
    ContentieuxSocialSectionComponent.prototype.swapPiecesComplementaire = function (piece1Index, piece2Index, pieceComplementaire) {
        var piece1 = pieceComplementaire[piece1Index];
        var piece2 = pieceComplementaire[piece2Index];
        var idxPiece1 = this.depotRequeteState.piecesComplementaires.indexOf(piece1);
        var idxPiece2 = this.depotRequeteState.piecesComplementaires.indexOf(piece2);
        pieceComplementaire[piece2Index] = piece1;
        pieceComplementaire[piece1Index] = piece2;
        this.depotRequeteState.piecesComplementaires[idxPiece2] = piece1;
        this.depotRequeteState.piecesComplementaires[idxPiece1] = piece2;
    };
    ContentieuxSocialSectionComponent.prototype.onSelectMI = function (data) {
        console.log('onSelectMI', data);
        this.selectedItemMI = data.piece.fileModel.fileApiId;
    };
    ContentieuxSocialSectionComponent.prototype.onEscapeMI = function (data) {
        console.log('onEscapeMI', data);
        this.selectedItemMI = null;
    };
    ContentieuxSocialSectionComponent.prototype.onSelectMA = function (data) {
        console.log('onSelectMA', data);
        this.selectedItemMA = data.piece.fileModel.fileApiId;
    };
    ContentieuxSocialSectionComponent.prototype.onEscapeMA = function (data) {
        console.log('onEscapeMA', data);
        this.selectedItemMA = null;
    };
    ContentieuxSocialSectionComponent.prototype.onSelectSommeDue = function (data) {
        console.log('onSelectSommeDue', data);
        this.selectedItemSommeDue = data.piece.fileModel.fileApiId;
    };
    ContentieuxSocialSectionComponent.prototype.onEscapeSommeDue = function (data) {
        console.log('onEscapeSommeDue', data);
        this.selectedItemSommeDue = null;
    };
    ContentieuxSocialSectionComponent.prototype.onSelectMontantDu = function (data) {
        console.log('onSelectMontantDu', data);
        this.selectedItemMontantDu = data.piece.fileModel.fileApiId;
    };
    ContentieuxSocialSectionComponent.prototype.onEscapeMontantDu = function (data) {
        console.log('onEscapeMontantDu', data);
        this.selectedItemMontantDu = null;
    };
    ContentieuxSocialSectionComponent.prototype.onSelectAIEC = function (data) {
        console.log('onSelectAIEC', data);
        this.selectedItemAIEC = data.piece.fileModel.fileApiId;
    };
    ContentieuxSocialSectionComponent.prototype.onEscapeAIEC = function (data) {
        console.log('onEscapeAIEC', data);
        this.selectedItemAIEC = null;
    };
    ContentieuxSocialSectionComponent.prototype.onSelectAIIA = function (data) {
        console.log('onSelectAIIA', data);
        this.selectedItemAIIA = data.piece.fileModel.fileApiId;
    };
    ContentieuxSocialSectionComponent.prototype.onEscapeAIIA = function (data) {
        console.log('onEscapeAIIA', data);
        this.selectedItemAIIA = null;
    };
    ContentieuxSocialSectionComponent.prototype.onSelectPrecisionPrejudice = function (data) {
        console.log('onSelectPrecisionPrejudice', data);
        this.selectedItemPrecisionPrejudice = data.piece.fileModel.fileApiId;
    };
    ContentieuxSocialSectionComponent.prototype.onEscapePrecisionPrejudice = function (data) {
        console.log('onEscapePrecisionPrejudice', data);
        this.selectedItemPrecisionPrejudice = null;
    };
    ContentieuxSocialSectionComponent.prototype.onSelectRequeteRedigeeJust = function (data) {
        console.log('onSelectRequeteRedigeeJust', data);
        this.selectedItemRRJ = data.piece.fileModel.fileApiId;
    };
    ContentieuxSocialSectionComponent.prototype.onEscapeRequeteRedigeeJust = function (data) {
        console.log('onEscapeRequeteRedigeeJust', data);
        this.selectedItemRRJ = null;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", depot_requete_state_model_1.DepotRequeteState)
    ], ContentieuxSocialSectionComponent.prototype, "depotRequeteState", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ContentieuxSocialSectionComponent.prototype, "sociauxDALOChampsObligatoiresFilled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ContentieuxSocialSectionComponent.prototype, "litigeLieDecisionChampsObligatoiresFilled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ContentieuxSocialSectionComponent.prototype, "reclamerUneSommeChampsObligatoiresFilled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ContentieuxSocialSectionComponent.prototype, "contesterUneSommeChampsObligatoiresFilled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ContentieuxSocialSectionComponent.prototype, "indemnisationChampsObligatoiresFilled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ContentieuxSocialSectionComponent.prototype, "requeteRedigeePieceComplementaireLebelleFilled", void 0);
    __decorate([
        core_1.ViewChild(reclamation_prealable_component_1.ReclamationPrealableComponent),
        __metadata("design:type", reclamation_prealable_component_1.ReclamationPrealableComponent)
    ], ContentieuxSocialSectionComponent.prototype, "reclamationPrealableComponent", void 0);
    __decorate([
        core_1.ViewChild('pieceMIAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ContentieuxSocialSectionComponent.prototype, "pieceMIAdder", void 0);
    __decorate([
        core_1.ViewChild('pieceMAAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ContentieuxSocialSectionComponent.prototype, "pieceMAAdder", void 0);
    __decorate([
        core_1.ViewChild('pieceSommeDueAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ContentieuxSocialSectionComponent.prototype, "pieceSommeDueAdder", void 0);
    __decorate([
        core_1.ViewChild('pieceMontantDuAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ContentieuxSocialSectionComponent.prototype, "pieceMontantDuAdder", void 0);
    __decorate([
        core_1.ViewChild('pieceAIECAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ContentieuxSocialSectionComponent.prototype, "pieceAIECAdder", void 0);
    __decorate([
        core_1.ViewChild('pieceAIIAAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ContentieuxSocialSectionComponent.prototype, "pieceAIIAAdder", void 0);
    __decorate([
        core_1.ViewChild('piecePrecisionPrejudiceAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ContentieuxSocialSectionComponent.prototype, "piecePrecisionPrejudiceAdder", void 0);
    __decorate([
        core_1.ViewChild('pieceRequeteRedigeeJustAdder'),
        __metadata("design:type", file_uploader_component_1.FileUploaderComponent)
    ], ContentieuxSocialSectionComponent.prototype, "pieceRequeteRedigeeJustAdder", void 0);
    ContentieuxSocialSectionComponent = ContentieuxSocialSectionComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-contentieux-social-section',
            template: __webpack_require__(793),
            styles: [__webpack_require__(893)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: ContentieuxSocialSectionComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector,
            ng2_dragula_1.DragulaService,
            a11y_1.LiveAnnouncer,
            draft_depot_requete_service_1.DraftDepotRequeteService,
            ng_bootstrap_1.NgbModal,
            parameters_service_1.ParametersService])
    ], ContentieuxSocialSectionComponent);
    return ContentieuxSocialSectionComponent;
    var ContentieuxSocialSectionComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.ContentieuxSocialSectionComponent = ContentieuxSocialSectionComponent;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(441));
__export(__webpack_require__(438));
__export(__webpack_require__(440));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = __webpack_require__(7);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var shared_1 = __webpack_require__(4);
var error_service_1 = __webpack_require__(22);
var draft_depot_requete_service_1 = __webpack_require__(16);
var rxjs_1 = __webpack_require__(12);
var piece_jointe_1 = __webpack_require__(38);
var parameters_service_1 = __webpack_require__(25);
var contentieux_social_1 = __webpack_require__(90);
var RequeteComponent = /** @class */ (function () {
    function RequeteComponent(scrollToService, errorService, draftDepotRequeteService, parametersService, changeDetectorRef) {
        var _this = this;
        this.scrollToService = scrollToService;
        this.errorService = errorService;
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.parametersService = parametersService;
        this.changeDetectorRef = changeDetectorRef;
        this.showErrorMessageUrgenceRequete = false;
        this.scrollToError = false;
        this.juridictionAutoSaveSuccess = false;
        this.autoSaveError = false;
        this.saveDraftSuccess = false;
        this.saveDraftError = false;
        this.urgenceRequeteChampsObligatoireFilled = {
            concernContentieuxSocial: true
        };
        this.sociauxDALOChampsObligatoiresFilled = {
            hasDocument: true,
            raisonSansDocument: true,
            nomsAdministrations: true,
            objetDemande: true,
            motifs: true,
            conclusionDALO: true
        };
        this.litigeLieDecisionChampsObligatoiresFilled = {
            souhait: true,
            hasDocument: true,
            raisonSansDocument: true,
            nomsAdministrations: true,
            objetDemande: true,
            contexteInterventionDecision: true,
            raisonContestations: true,
            raisonContestationDetail: true,
            pieceMalInterpreteLibelle: true,
            pieceMalApprecieLibelle: true,
            conclusionLitigeAdminCheckbox: true
        };
        this.reclamerUneSommeChampsObligatoiresFilled = {
            typeLitige: true,
            nomsAdministrations: true,
            objetDemande: true,
            contexteInterventionDecision: true,
            pourquoiSommeDue: true,
            pieceSommeDue: true,
            montantDuMontant: true,
            pieceMontantDu: true,
            conclusionReclamerSommeCondamnerAdmin: true
        };
        this.contesterUneSommeChampsObligatoiresFilled = {
            nomsAdministrations: true,
            objetDemande: true,
            faitConduitAuLitige: true,
            typeActe: true,
            raisonAvisDimpositionIrreguliers: true,
            conclusionAvisImpositionImpot: true,
            raisonPasPayerImpot: true,
            pieceAvisImpositionInfondeeEtAutreLibelle: true,
            raisonInvalidationTitres: true,
            raisonInvalidationTitreDetail: true,
            conclusionContesterSommeTitreEmisIrregulierDes: true,
            conclusionContesterSommeTitreEmisIrregulierMontant: true
        };
        this.indemnisationChampsObligatoiresFilled = {
            nomsAdministrations: true,
            objetDemande: true,
            faitConduitSituationReparation: true,
            prejudiceEvaluableEnArgents: true,
            precisionPrejudice: true,
            piecePrecisionPrejudiceLibelle: true,
            originePrejudice: true,
            conclusionIndemnisationCondamnerAdmin: true,
            conclusionIndemnisationMontant: true
        };
        this.requeteRedigeePieceComplementaireLebelleFilled = {
            requeteRedigeePCLibelle: true
        };
        this.previousStep = new core_1.EventEmitter();
        this.nextStep = new core_1.EventEmitter();
        this.hideAlertDraft = new core_1.EventEmitter();
        this.showErrorAlertDraft = new core_1.EventEmitter();
        this.showSuccessAlertDraft = new core_1.EventEmitter();
        this.showAutoSaveSuccessAlertDraft = new core_1.EventEmitter();
        this.depotRequeteState = this.draftDepotRequeteService.depotRequeteState;
        if (this.depotRequeteState.isStepJuridictionAutoSaveSucceed && !this.depotRequeteState.isStepRequeteAutoSaveSucceed) {
            this.juridictionAutoSaveSuccess = true;
            this.autoSaveTime = this.draftDepotRequeteService.getAutoSaveTime();
            this.draftDepotRequeteService.sendData(this.autoSaveTime);
        }
        this.parameterSubscription = this.parametersService.getParameters().subscribe(function (parameters) {
            _this.maxFileSize = parameters.maxFileSize;
        });
    }
    RequeteComponent.prototype.ngOnInit = function () {
        this.hideAlertDraft.emit();
        if (this.juridictionAutoSaveSuccess) {
            this.showAutoSaveSuccessAlertDraft.emit();
        }
    };
    RequeteComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.draftDepotRequeteService.refreshRequete().pipe(operators_1.tap(function (draftRequete) { return _this.updateDepotRequeteState(draftRequete); }), operators_1.switchMap(function (draftRequete) { return draftRequete.contentieuxSocialId ?
            _this.draftDepotRequeteService.getContentieuxSocial(draftRequete.contentieuxSocialId) :
            rxjs_1.of(new contentieux_social_1.ContentieuxSocial()); }), operators_1.tap(function (cs) { return _this.depotRequeteState.requeteCS = cs; })).subscribe();
        document.getElementById('logo-link').focus();
    };
    RequeteComponent.prototype.updateDepotRequeteState = function (draftRequete) {
        if (draftRequete.typeRequeteId == null) {
            this.depotRequeteState.urgenceRequete = undefined;
        }
        else {
            this.depotRequeteState.urgenceRequete = this.depotRequeteState.typeJuridiction.urgencesRequete.find(function (urgenceRequete) {
                return urgenceRequete.id === draftRequete.typeRequeteId;
            });
        }
        this.depotRequeteState.concernContentieuxSocial = draftRequete.concernContentieuxSocial;
        this.depotRequeteState.formActivated = draftRequete.formActivated;
        this.draftDepotRequeteService.refreshPiecesFromDraft(draftRequete, this.depotRequeteState);
    };
    RequeteComponent.prototype.ngAfterViewChecked = function () {
        if (this.scrollTarget) {
            this.scrollToService.scrollBySelector(this.scrollTarget);
            this.scrollTarget = null;
        }
        if (this.scrollToError) {
            this.scrollToService.scrollToFirstErrorForStepRequeteInDepotRequete();
            /* this.scrollToService.scrollToFirstError(); */
            this.scrollToError = false;
        }
        // TODO: TRC-890 put it to where changes happened
        this.changeDetectorRef.detectChanges();
    };
    RequeteComponent.prototype.ngOnDestroy = function () {
        this.parameterSubscription.unsubscribe();
    };
    RequeteComponent.prototype.next = function () {
        if (this.depotRequeteState.urgenceRequete == null) {
            this.showErrorMessageUrgenceRequete = true;
        }
        this.hideAlertDraft.emit();
        if (this.depotRequeteState.urgenceRequete && this.depotRequeteState.urgenceRequete.codeUrgence === 0) {
            return this.nextStepWithNormalProceeding();
        }
        else {
            return this.nextStepWithInterimProceeding();
        }
    };
    RequeteComponent.prototype.nextStepWithNormalProceeding = function () {
        var _this = this;
        if (this.form.valid && this.checkIfUrgenceRequeteFilled() && this.checkIfCSFormFilled()) {
            return this.saveRequete().pipe(operators_1.tap(function () {
                _this.depotRequeteState.isStepRequeteAutoSaveSucceed = true;
                _this.draftDepotRequeteService.depotRequeteState.isStepRequeteAutoSaveSucceed = true;
                _this.nextStep.emit();
            }, function (error) {
                _this.autoSaveError = true;
                _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
            }));
        }
        else {
            this.updateUrgenceRequeteChampsObligatoiresFilled();
            if (this.depotRequeteState.formActivated) {
                if (this.depotRequeteState.concernContentieuxSocial) {
                    this.updateSociauxDALOChampsObligatoireFilledObj();
                }
                else {
                    if (this.depotRequeteState.requeteCS.souhait == null ||
                        this.depotRequeteState.requeteCS.souhait ===
                            'Remplir le formulaire : litige lié à une décision de l\'administration') {
                        this.updateLitigeLieDecisionChampsObligatoireFilledObj();
                    }
                    else if (this.depotRequeteState.requeteCS.souhait ===
                        'Remplir le formulaire : litige lié à une somme d\'argent') {
                        if (this.depotRequeteState.requeteCS.typeLitige == null || this.depotRequeteState.requeteCS.typeLitige ===
                            'Vous réclamez une somme d\'argent à l\'administration') {
                            this.updateReclamerUneSommeChampsObligatoireFilledObj();
                        }
                        else if (this.depotRequeteState.requeteCS.typeLitige ===
                            'Vous contestez une somme d\'argent réclamée par l\'administration') {
                            this.updateContesterUneSommeChampsObligatoireFilledObj();
                        }
                        else {
                            this.updateIndemnisationChampsObligatoireFilledObj();
                        }
                    }
                    else {
                        this.updateRequeteRedigeePCFilledObj();
                    }
                }
            }
            else {
                if (this.depotRequeteState.concernContentieuxSocial) {
                    this.updateSociauxDALOChampsObligatoireFilledObj();
                }
            }
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    };
    RequeteComponent.prototype.nextStepWithInterimProceeding = function () {
        var _this = this;
        if (this.form.valid) {
            return this.saveRequete().pipe(operators_1.tap(function () {
                _this.depotRequeteState.isStepRequeteAutoSaveSucceed = true;
                _this.draftDepotRequeteService.depotRequeteState.isStepRequeteAutoSaveSucceed = true;
                _this.nextStep.emit();
            }, function (error) {
                _this.autoSaveError = true;
                _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
            }));
        }
        else {
            this.errorService.markAllControlsAsTouched(this.form);
            this.scrollToError = true;
        }
    };
    RequeteComponent.prototype.previous = function () {
        this.depotRequeteState.isStepRequeteAutoSaveSucceed = false;
        this.previousStep.emit();
    };
    RequeteComponent.prototype.saveDraft = function () {
        var _this = this;
        this.hideAlertDraft.emit();
        return this.saveRequete().pipe(operators_1.tap(function () {
            _this.saveDraftSuccess = true;
            _this.juridictionAutoSaveSuccess = false;
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.saveDraftError = true;
            _this.juridictionAutoSaveSuccess = false;
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        }));
    };
    RequeteComponent.prototype.saveDraftAgain = function () {
        var _this = this;
        this.saveRequete().subscribe(function () {
            _this.saveDraftSuccess = true;
            _this.juridictionAutoSaveSuccess = false;
            _this.showSuccessAlertDraft.emit();
        }, function (error) {
            _this.saveDraftError = true;
            _this.juridictionAutoSaveSuccess = false;
            _this.draftDepotRequeteService.displayOrNotErrorAlertDraft(error, _this.showErrorAlertDraft);
        });
    };
    RequeteComponent.prototype.updateState = function (concerneCSDALO) {
        console.log('updateState concerneCSDALO ', concerneCSDALO);
        this.depotRequeteState = __assign({}, this.depotRequeteState, { concernContentieuxSocial: concerneCSDALO });
        console.log('updateState state concern cs dalo ', this.depotRequeteState.concernContentieuxSocial);
        this.draftDepotRequeteService.depotRequeteState = this.depotRequeteState;
    };
    RequeteComponent.prototype.updateURState = function (urgenceRequete) {
        console.log('updateURState urgenceRequete ', urgenceRequete);
        this.depotRequeteState = __assign({}, this.depotRequeteState, { urgenceRequete: urgenceRequete });
        console.log('updateState state concern u r ', this.depotRequeteState.urgenceRequete);
        this.draftDepotRequeteService.depotRequeteState = this.depotRequeteState;
    };
    RequeteComponent.prototype.close = function () {
        this.autoSaveError = false;
    };
    RequeteComponent.prototype.saveRequete = function () {
        return this.draftDepotRequeteService.saveRequeteByEmergencyType(this.depotRequeteState.urgenceRequete);
    };
    RequeteComponent.prototype.displayContentieuxSocialSection = function () {
        return this.depotRequeteState.concernContentieuxSocial;
    };
    RequeteComponent.prototype.checkIfUrgenceRequeteFilled = function () {
        this.updateUrgenceRequeteChampsObligatoiresFilled();
        return this.depotRequeteState.urgenceRequete && (typeof this.depotRequeteState.urgenceRequete !== 'boolean') &&
            this.checkRadioConcernCSChecked();
    };
    RequeteComponent.prototype.updateUrgenceRequeteChampsObligatoiresFilled = function () {
        if (this.depotRequeteState.typeJuridiction.code !== 'CE') {
            if (this.depotRequeteState.concernContentieuxSocial == null) {
                this.urgenceRequeteChampsObligatoireFilled.concernContentieuxSocial = false;
            }
        }
    };
    RequeteComponent.prototype.checkRadioConcernCSChecked = function () {
        var radioChecked = true;
        if (this.depotRequeteState.typeJuridiction.code !== 'CE') {
            if (this.depotRequeteState.concernContentieuxSocial == null) {
                radioChecked = false;
            }
            else {
                radioChecked = true;
            }
        }
        return radioChecked;
    };
    RequeteComponent.prototype.checkIfCSFormFilled = function () {
        if (this.depotRequeteState.formActivated) {
            if (this.depotRequeteState.concernContentieuxSocial && this.depotRequeteState.requeteCS) {
                return this.checkConcernContentieuxSocial();
            }
            else if (!this.depotRequeteState.concernContentieuxSocial && this.depotRequeteState.requeteCS) {
                return !!(this.depotRequeteState.requeteCS.souhait) && this.checkNotConcernContentieuxSocial();
            }
            else {
                return true;
            }
        }
        else {
            if (this.depotRequeteState.concernContentieuxSocial && this.depotRequeteState.requeteCS) {
                return this.checkConcernContentieuxSocial();
            }
            else {
                return true;
            }
        }
    };
    RequeteComponent.prototype.checkConcernContentieuxSocial = function () {
        // piece complémentaire rapo obligatoire
        var rapo = this.depotRequeteState.piecesComplementaires.some(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.RAPO;
        });
        var acteAttaquee = this.depotRequeteState.acteAttaquesAFusioner[0];
        this.updateSociauxDALOChampsObligatoireFilledObj();
        if (this.depotRequeteState.requeteCS.hasDocument == null) {
            return false;
        }
        else if (this.depotRequeteState.requeteCS.hasDocument) {
            return rapo && !!acteAttaquee && !!(this.depotRequeteState.requeteCS.nomsAdministrations) &&
                !!(this.depotRequeteState.requeteCS.objetDemande) &&
                !!(this.depotRequeteState.requeteCS.motifs) &&
                !!(this.depotRequeteState.requeteCS.conclusionDALO);
        }
        else {
            return rapo && !!(this.depotRequeteState.requeteCS.raisonSansDocument) &&
                !!(this.depotRequeteState.requeteCS.nomsAdministrations) &&
                !!(this.depotRequeteState.requeteCS.objetDemande) &&
                !!(this.depotRequeteState.requeteCS.motifs) &&
                !!(this.depotRequeteState.requeteCS.conclusionDALO);
        }
    };
    RequeteComponent.prototype.updateSociauxDALOChampsObligatoireFilledObj = function () {
        if (this.depotRequeteState.requeteCS.hasDocument == null) {
            this.sociauxDALOChampsObligatoiresFilled.hasDocument = false;
        }
        if (this.depotRequeteState.requeteCS.hasDocument === false &&
            this.depotRequeteState.requeteCS.raisonSansDocument == null) {
            this.sociauxDALOChampsObligatoiresFilled.raisonSansDocument = false;
        }
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.sociauxDALOChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.sociauxDALOChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.motifs == null) {
            this.sociauxDALOChampsObligatoiresFilled.motifs = false;
        }
        if (this.depotRequeteState.requeteCS.conclusionDALO == null) {
            this.sociauxDALOChampsObligatoiresFilled.conclusionDALO = false;
        }
    };
    RequeteComponent.prototype.checkNotConcernContentieuxSocial = function () {
        if (this.depotRequeteState.requeteCS.souhait == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.souhait = false;
            return false;
        }
        else if (this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une décision de l\'administration') {
            // souhait choix 1
            var acteAttaquee = this.depotRequeteState.acteAttaquesAFusioner[0];
            this.updateLitigeLieDecisionChampsObligatoireFilledObj();
            if (this.depotRequeteState.requeteCS.hasDocument == null) {
                return false;
            }
            else if (this.depotRequeteState.requeteCS.hasDocument) {
                return !!acteAttaquee && !!(this.depotRequeteState.requeteCS.nomsAdministrations) &&
                    !!(this.depotRequeteState.requeteCS.objetDemande) &&
                    !!(this.depotRequeteState.requeteCS.contexteInterventionDecision) &&
                    this.checkRaisonContestation() && this.checkRaisonContestationPieceComplementaire() &&
                    this.depotRequeteState.requeteCS.conclusionLitigeAdminCheckbox;
            }
            else {
                return !!acteAttaquee && !!(this.depotRequeteState.requeteCS.raisonSansDocument) &&
                    !!(this.depotRequeteState.requeteCS.nomsAdministrations) &&
                    !!(this.depotRequeteState.requeteCS.objetDemande) &&
                    !!(this.depotRequeteState.requeteCS.contexteInterventionDecision) &&
                    this.checkRaisonContestation() && this.checkRaisonContestationPieceComplementaire() &&
                    this.depotRequeteState.requeteCS.conclusionLitigeAdminCheckbox;
            }
        }
        else if (this.depotRequeteState.requeteCS.souhait === 'Remplir le formulaire : litige lié à une somme d\'argent') {
            if (!!this.depotRequeteState.requeteCS.typeLitige) {
                if (this.depotRequeteState.requeteCS.typeLitige === 'Vous réclamez une somme d\'argent à l\'administration') {
                    return this.checkReclamerUneSomme();
                }
                else if (this.depotRequeteState.requeteCS.typeLitige ===
                    'Vous contestez une somme d\'argent réclamée par l\'administration') {
                    return this.checkContesterUneSomme();
                }
                else {
                    return this.checkReclamerUneIndemnisation();
                }
            }
            else {
                this.updateReclamerUneSommeChampsObligatoireFilledObj();
                return false;
            }
        }
        else {
            var acteAttaquee = this.depotRequeteState.acteAttaquesAFusioner[0];
            this.updateRequeteRedigeePCFilledObj();
            return !!acteAttaquee && !!this.depotRequeteState.requete && this.allPiecesComplementairesHaveLibelle();
        }
    };
    RequeteComponent.prototype.allPiecesComplementairesHaveLibelle = function () {
        var libelleFilled = true;
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF;
        }).length > 0) {
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF;
            }).forEach(function (p) {
                if (!p.libelle || p.libelle.trim() === '') {
                    libelleFilled = false;
                }
            });
        }
        return libelleFilled;
    };
    RequeteComponent.prototype.updateLitigeLieDecisionChampsObligatoireFilledObj = function () {
        var _this = this;
        if (this.depotRequeteState.requeteCS.souhait == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.souhait = false;
            return;
        }
        if (this.depotRequeteState.requeteCS.hasDocument == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.hasDocument = false;
        }
        if (this.depotRequeteState.requeteCS.hasDocument === false &&
            this.depotRequeteState.requeteCS.raisonSansDocument == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.raisonSansDocument = false;
        }
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.contexteInterventionDecision == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.contexteInterventionDecision = false;
        }
        if (this.depotRequeteState.requeteCS.raisonContestations == null ||
            this.depotRequeteState.requeteCS.raisonContestations === undefined ||
            this.depotRequeteState.requeteCS.raisonContestations.length === 0) {
            this.litigeLieDecisionChampsObligatoiresFilled.raisonContestations = false;
        }
        if (this.depotRequeteState.requeteCS.raisonContestations != null &&
            this.depotRequeteState.requeteCS.raisonContestations.length > 0 &&
            this.depotRequeteState.requeteCS.raisonContestations.some(function (rc) { return !rc.detail; })) {
            this.litigeLieDecisionChampsObligatoiresFilled.raisonContestationDetail = false;
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_INTERPRETE;
        }).length > 0) {
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_INTERPRETE;
            }).forEach(function (mi) {
                if (!mi.libelle || mi.libelle.trim() === '') {
                    _this.litigeLieDecisionChampsObligatoiresFilled.pieceMalInterpreteLibelle = false;
                }
            });
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_APPRECIE;
        }).length > 0) {
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_APPRECIE;
            }).forEach(function (ma) {
                if (!ma.libelle || ma.libelle.trim() === '') {
                    _this.litigeLieDecisionChampsObligatoiresFilled.pieceMalApprecieLibelle = false;
                }
            });
        }
        if (this.depotRequeteState.requeteCS.conclusionLitigeAdminCheckbox == null) {
            this.litigeLieDecisionChampsObligatoiresFilled.conclusionLitigeAdminCheckbox = false;
        }
    };
    RequeteComponent.prototype.checkRaisonContestation = function () {
        // au moins un choix doit être coché
        // une fois coché, le détail doit être rempli
        var raisonContestationValid = true;
        if (!this.depotRequeteState.requeteCS.raisonContestations) {
            raisonContestationValid = false;
        }
        else {
            if (this.depotRequeteState.requeteCS.raisonContestations.length <= 0) {
                raisonContestationValid = false;
            }
            else {
                this.depotRequeteState.requeteCS.raisonContestations.forEach(function (rc) {
                    if (!rc.detail) {
                        raisonContestationValid = false;
                    }
                });
            }
        }
        return raisonContestationValid;
    };
    RequeteComponent.prototype.checkRaisonContestationPieceComplementaire = function () {
        var pieceComplementaireValid = true;
        var pieceMalInterpreter = this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_INTERPRETE;
        });
        pieceMalInterpreter.forEach(function (pmi) {
            if (!pmi.libelle || pmi.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        });
        var pieceMalAppreciee = this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MAL_APPRECIE;
        });
        pieceMalAppreciee.forEach(function (pma) {
            if (!pma.libelle || pma.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        });
        return pieceComplementaireValid;
    };
    RequeteComponent.prototype.checkReclamerUneSomme = function () {
        this.updateReclamerUneSommeChampsObligatoireFilledObj();
        return this.checkReclamerUneSommePieceComplementaire() &&
            this.depotRequeteState.reclamationPrealablesAFusioner.length > 0 &&
            !!this.depotRequeteState.requeteCS.nomsAdministrations &&
            !!this.depotRequeteState.requeteCS.objetDemande &&
            !!this.depotRequeteState.requeteCS.contexteInterventionDecision &&
            !!this.depotRequeteState.requeteCS.pourquoiSommeDue &&
            !!this.depotRequeteState.requeteCS.montantDuMontant &&
            !!this.depotRequeteState.requeteCS.conclusionReclamerSommeCondamnerAdmin;
    };
    RequeteComponent.prototype.updateReclamerUneSommeChampsObligatoireFilledObj = function () {
        var _this = this;
        if (this.depotRequeteState.requeteCS.typeLitige == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.typeLitige = false;
            return;
        }
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.contexteInterventionDecision == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.contexteInterventionDecision = false;
        }
        if (this.depotRequeteState.requeteCS.pourquoiSommeDue == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.pourquoiSommeDue = false;
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.SOMME_DUE;
        }).length > 0) {
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.SOMME_DUE;
            }).forEach(function (sd) {
                if (!sd.libelle || sd.libelle.trim() === '') {
                    _this.reclamerUneSommeChampsObligatoiresFilled.pieceSommeDue = false;
                }
            });
        }
        if (this.depotRequeteState.requeteCS.montantDuMontant == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.montantDuMontant = false;
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MONTANT_DU;
        }).length > 0) {
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MONTANT_DU;
            }).forEach(function (md) {
                if (!md.libelle || md.libelle.trim() === '') {
                    _this.reclamerUneSommeChampsObligatoiresFilled.pieceMontantDu = false;
                }
            });
        }
        if (this.depotRequeteState.requeteCS.conclusionReclamerSommeCondamnerAdmin == null) {
            this.reclamerUneSommeChampsObligatoiresFilled.conclusionReclamerSommeCondamnerAdmin = false;
        }
    };
    RequeteComponent.prototype.checkReclamerUneSommePieceComplementaire = function () {
        var pieceComplementaireValid = true;
        var pieceSommeDue = this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.SOMME_DUE;
        });
        pieceSommeDue.forEach(function (psd) {
            if (!psd.libelle || psd.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        });
        var pieceMontantDu = this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.MONTANT_DU;
        });
        pieceMontantDu.forEach(function (pmd) {
            if (!pmd.libelle || pmd.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        });
        return pieceComplementaireValid;
    };
    RequeteComponent.prototype.checkContesterUneSomme = function () {
        this.updateContesterUneSommeChampsObligatoireFilledObj();
        var champsCommuns = !!this.depotRequeteState.acteAttaquesAFusioner[0] &&
            !!this.depotRequeteState.requeteCS.nomsAdministrations &&
            !!this.depotRequeteState.requeteCS.objetDemande &&
            !!this.depotRequeteState.requeteCS.faitConduitAuLitige &&
            !!this.depotRequeteState.requeteCS.typeActe;
        if (this.depotRequeteState.requeteCS.typeActe === 'Un avis d\'imposition') {
            return champsCommuns && this.checkAvisImposition();
        }
        else {
            return champsCommuns && this.checkAutreActe();
        }
    };
    RequeteComponent.prototype.checkAvisImposition = function () {
        var champsCommuns = !!this.depotRequeteState.requeteCS.raisonPasPayerImpot &&
            !!this.depotRequeteState.requeteCS.conclusionAvisImpositionImpot &&
            this.checkLibellePieceComplementaire(piece_jointe_1.PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE);
        return champsCommuns && this.checkRaisonAvisDimpositionIrregulier();
    };
    RequeteComponent.prototype.checkRaisonAvisDimpositionIrregulier = function () {
        // au moins un choix doit être coché
        var raisonAvisDimpositionIrregulierValid = true;
        if (!this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers) {
            raisonAvisDimpositionIrregulierValid = false;
        }
        else {
            if (this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers.length <= 0) {
                raisonAvisDimpositionIrregulierValid = false;
            }
        }
        return raisonAvisDimpositionIrregulierValid;
    };
    RequeteComponent.prototype.checkLibellePieceComplementaire = function (originType) {
        var pieceComplementaireValid = true;
        var pcs = this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === originType;
        });
        pcs.forEach(function (p) {
            if (!p.libelle || p.libelle.trim() === '') {
                pieceComplementaireValid = false;
            }
        });
        return pieceComplementaireValid;
    };
    RequeteComponent.prototype.checkAutreActe = function () {
        return this.checkRaisonInvalidationTitre() &&
            !!this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierDes &&
            !!this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierMontant;
    };
    RequeteComponent.prototype.checkRaisonInvalidationTitre = function () {
        // au moins un choix doit être coché
        // une fois coché, le détail doit être rempli
        var raisonInvalidationTitreValid = true;
        if (!this.depotRequeteState.requeteCS.raisonInvalidationTitres) {
            raisonInvalidationTitreValid = false;
        }
        else {
            if (this.depotRequeteState.requeteCS.raisonInvalidationTitres.length <= 0) {
                raisonInvalidationTitreValid = false;
            }
            else {
                this.depotRequeteState.requeteCS.raisonInvalidationTitres.forEach(function (rit) {
                    if (!rit.detail) {
                        raisonInvalidationTitreValid = false;
                    }
                });
            }
        }
        return raisonInvalidationTitreValid;
    };
    RequeteComponent.prototype.updateContesterUneSommeChampsObligatoireFilledObj = function () {
        var _this = this;
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.contesterUneSommeChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.contesterUneSommeChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.faitConduitAuLitige == null) {
            this.contesterUneSommeChampsObligatoiresFilled.faitConduitAuLitige = false;
        }
        if (this.depotRequeteState.requeteCS.typeActe == null) {
            this.contesterUneSommeChampsObligatoiresFilled.typeActe = false;
        }
        else {
            this.contesterUneSommeChampsObligatoiresFilled.typeActe = true;
            if (this.depotRequeteState.requeteCS.typeActe === 'Un avis d\'imposition') {
                if (this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers == null ||
                    this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers === undefined ||
                    this.depotRequeteState.requeteCS.raisonAvisDimpositionIrreguliers.length === 0) {
                    this.contesterUneSommeChampsObligatoiresFilled.raisonAvisDimpositionIrreguliers = false;
                }
                if (this.depotRequeteState.requeteCS.conclusionAvisImpositionImpot == null) {
                    this.contesterUneSommeChampsObligatoiresFilled.conclusionAvisImpositionImpot = false;
                }
                if (this.depotRequeteState.requeteCS.raisonPasPayerImpot == null) {
                    this.contesterUneSommeChampsObligatoiresFilled.raisonPasPayerImpot = false;
                }
                if (this.depotRequeteState.piecesComplementaires
                    .filter(function (pc) { return pc.complementaryFileOriginType ===
                    piece_jointe_1.PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE; }).length > 0) {
                    this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                        return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.AVIS_IMPOSITION_INFONDEE_ET_AUTRE;
                    })
                        .forEach(function (aiec) {
                        if (!aiec.libelle || aiec.libelle.trim() === '') {
                            _this.contesterUneSommeChampsObligatoiresFilled.pieceAvisImpositionInfondeeEtAutreLibelle
                                = false;
                        }
                    });
                }
            }
            else {
                if (this.depotRequeteState.requeteCS.raisonInvalidationTitres == null ||
                    this.depotRequeteState.requeteCS.raisonInvalidationTitres === undefined ||
                    this.depotRequeteState.requeteCS.raisonInvalidationTitres.length === 0) {
                    this.contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitres = false;
                }
                if (this.depotRequeteState.requeteCS.raisonInvalidationTitres != null &&
                    this.depotRequeteState.requeteCS.raisonInvalidationTitres.length > 0 &&
                    this.depotRequeteState.requeteCS.raisonInvalidationTitres.some(function (r) { return !r.detail; })) {
                    this.contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitreDetail = false;
                }
                if (this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierDes == null) {
                    this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierDes = false;
                }
                if (this.depotRequeteState.requeteCS.conclusionContesterSommeTitreEmisIrregulierMontant == null) {
                    this.contesterUneSommeChampsObligatoiresFilled.conclusionContesterSommeTitreEmisIrregulierMontant = false;
                }
            }
        }
    };
    RequeteComponent.prototype.checkReclamerUneIndemnisation = function () {
        this.updateIndemnisationChampsObligatoireFilledObj();
        return !!this.depotRequeteState.reclamationPrealablesAFusioner[0] &&
            !!this.depotRequeteState.requeteCS.nomsAdministrations &&
            !!this.depotRequeteState.requeteCS.objetDemande &&
            !!this.depotRequeteState.requeteCS.faitConduitSituationReparation &&
            this.checkPrejudiceEvaluableEnArgent() &&
            this.checkLibellePieceComplementaire(piece_jointe_1.PieceComplementaireOrigineType.PRECISION_PREJUDICE) &&
            !!this.depotRequeteState.requeteCS.precisionPrejudice &&
            !!this.depotRequeteState.requeteCS.originePrejudice &&
            !!this.depotRequeteState.requeteCS.conclusionIndemnisationCondamnerAdmin &&
            !!this.depotRequeteState.requeteCS.conclusionIndemnisationMontant;
    };
    RequeteComponent.prototype.checkPrejudiceEvaluableEnArgent = function () {
        // au moins un choix doit être coché
        var prejudiceEvaluableEnArgentValid = true;
        if (!this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents) {
            prejudiceEvaluableEnArgentValid = false;
        }
        else {
            if (this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents.length <= 0) {
                prejudiceEvaluableEnArgentValid = false;
            }
        }
        return prejudiceEvaluableEnArgentValid;
    };
    RequeteComponent.prototype.updateIndemnisationChampsObligatoireFilledObj = function () {
        var _this = this;
        if (this.depotRequeteState.requeteCS.nomsAdministrations == null) {
            this.indemnisationChampsObligatoiresFilled.nomsAdministrations = false;
        }
        if (this.depotRequeteState.requeteCS.objetDemande == null) {
            this.indemnisationChampsObligatoiresFilled.objetDemande = false;
        }
        if (this.depotRequeteState.requeteCS.faitConduitSituationReparation == null) {
            this.indemnisationChampsObligatoiresFilled.faitConduitSituationReparation = false;
        }
        if (this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents == null ||
            this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents === undefined ||
            this.depotRequeteState.requeteCS.prejudiceEvaluableEnArgents.length === 0) {
            this.indemnisationChampsObligatoiresFilled.prejudiceEvaluableEnArgents = false;
        }
        if (this.depotRequeteState.requeteCS.precisionPrejudice == null) {
            this.indemnisationChampsObligatoiresFilled.precisionPrejudice = false;
        }
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.PRECISION_PREJUDICE;
        }).length > 0) {
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.PRECISION_PREJUDICE;
            }).forEach(function (pp) {
                if (!pp.libelle || pp.libelle.trim() === '') {
                    _this.indemnisationChampsObligatoiresFilled.piecePrecisionPrejudiceLibelle = false;
                }
            });
        }
        if (this.depotRequeteState.requeteCS.originePrejudice == null) {
            this.indemnisationChampsObligatoiresFilled.originePrejudice = false;
        }
        if (this.depotRequeteState.requeteCS.conclusionIndemnisationCondamnerAdmin == null) {
            this.indemnisationChampsObligatoiresFilled.conclusionIndemnisationCondamnerAdmin = false;
        }
        if (this.depotRequeteState.requeteCS.conclusionIndemnisationMontant == null) {
            this.indemnisationChampsObligatoiresFilled.conclusionIndemnisationMontant = false;
        }
    };
    RequeteComponent.prototype.updateRequeteRedigeePCFilledObj = function () {
        var _this = this;
        if (this.depotRequeteState.piecesComplementaires.filter(function (pc) {
            return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF;
        }).length > 0) {
            this.depotRequeteState.piecesComplementaires.filter(function (pc) {
                return pc.complementaryFileOriginType === piece_jointe_1.PieceComplementaireOrigineType.REQUETE_REDIGEE_JUSTIFICATIF;
            }).forEach(function (rr) {
                if (!rr.libelle || rr.libelle.trim() === '') {
                    _this.requeteRedigeePieceComplementaireLebelleFilled.requeteRedigeePCLibelle = false;
                }
            });
        }
        else {
            this.requeteRedigeePieceComplementaireLebelleFilled.requeteRedigeePCLibelle = true;
        }
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequeteComponent.prototype, "previousStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequeteComponent.prototype, "nextStep", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequeteComponent.prototype, "hideAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequeteComponent.prototype, "showErrorAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequeteComponent.prototype, "showSuccessAlertDraft", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], RequeteComponent.prototype, "showAutoSaveSuccessAlertDraft", void 0);
    __decorate([
        core_1.ViewChild(forms_1.NgForm),
        __metadata("design:type", forms_1.NgForm)
    ], RequeteComponent.prototype, "form", void 0);
    RequeteComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(795),
            styles: [__webpack_require__(895)]
        }),
        __metadata("design:paramtypes", [shared_1.ScrollToService,
            error_service_1.ErrorService,
            draft_depot_requete_service_1.DraftDepotRequeteService,
            parameters_service_1.ParametersService,
            core_1.ChangeDetectorRef])
    ], RequeteComponent);
    return RequeteComponent;
}());
exports.RequeteComponent = RequeteComponent;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var base_control_value_accessor_1 = __webpack_require__(20);
var depot_requete_state_model_1 = __webpack_require__(89);
var ng_bootstrap_1 = __webpack_require__(19);
var UrgenceRequeteSectionComponent = /** @class */ (function (_super) {
    __extends(UrgenceRequeteSectionComponent, _super);
    function UrgenceRequeteSectionComponent(injector, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.modalService = modalService;
        _this.onConcernCSDALOChange = new core_1.EventEmitter();
        _this.onUrgenceRequeteChangeEvt = new core_1.EventEmitter();
        _this.state = { index: 1 };
        _this.stateDalo = { index: 2, isToggleable: false };
        _this.urgenceRequeteFaqCategoryId = '20';
        return _this;
    }
    UrgenceRequeteSectionComponent_1 = UrgenceRequeteSectionComponent;
    UrgenceRequeteSectionComponent.prototype.ngOnInit = function () {
        this.filteredUrgencesRequete =
            this.depotRequeteState.typeJuridiction.urgencesRequete.filter(function (u) { return !u.isDeleted; });
    };
    UrgenceRequeteSectionComponent.prototype.registerOnChange = function (fn) {
        _super.prototype.registerOnChange.call(this, fn);
    };
    UrgenceRequeteSectionComponent.prototype.modelValueChanged = function (value) {
        if (typeof value !== 'boolean') {
            this.urgenceRequeteId = value && value.id.toString();
            this.urgenceRequete = value;
        }
    };
    UrgenceRequeteSectionComponent.prototype.onUrgenceRequeteChange = function (urgenceRequeteId) {
        this.onChange(this.urgenceRequete = this.depotRequeteState.typeJuridiction.urgencesRequete.find(function (urgenceRequete) {
            return urgenceRequete.id === +urgenceRequeteId;
        }));
        console.log('onUrgenceRequeteChange | this.urgenceRequete : ', this.urgenceRequete);
        this.onUrgenceRequeteChangeEvt.emit(this.urgenceRequete);
    };
    UrgenceRequeteSectionComponent.prototype.onConcernCSChange = function (value) {
        /* this.onChange(this.depotRequeteState.concernContentieuxSocial = value);
        console.log('onConcerneCSChange', this.depotRequeteState.concernContentieuxSocial); */
        this.onConcernCSDALOChange.emit(value);
    };
    UrgenceRequeteSectionComponent.prototype.openWarningModal = function (modal) {
        var _this = this;
        this.modalReference = this.modalService.open(modal, { size: 'lg' });
        this.modalReference.result.then(function (_) {
            _this.modalReference.close();
        }, function (_) {
            _this.modalReference.close();
        });
        // RGAA workaround
        var modalEl = document.querySelector('ngb-modal-window');
        modalEl.setAttribute('aria-label', 'Avertissement');
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", depot_requete_state_model_1.DepotRequeteState)
    ], UrgenceRequeteSectionComponent.prototype, "depotRequeteState", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], UrgenceRequeteSectionComponent.prototype, "urgenceRequeteChampsObligatoireFilled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], UrgenceRequeteSectionComponent.prototype, "showErrorMessageUrgenceRequete", void 0);
    __decorate([
        core_1.ViewChild('notificationModal'),
        __metadata("design:type", Object)
    ], UrgenceRequeteSectionComponent.prototype, "notificationModal", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], UrgenceRequeteSectionComponent.prototype, "onConcernCSDALOChange", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], UrgenceRequeteSectionComponent.prototype, "onUrgenceRequeteChangeEvt", void 0);
    UrgenceRequeteSectionComponent = UrgenceRequeteSectionComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-urgence-requete-section',
            template: __webpack_require__(796),
            styles: [__webpack_require__(896)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: UrgenceRequeteSectionComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector,
            ng_bootstrap_1.NgbModal])
    ], UrgenceRequeteSectionComponent);
    return UrgenceRequeteSectionComponent;
    var UrgenceRequeteSectionComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.UrgenceRequeteSectionComponent = UrgenceRequeteSectionComponent;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentieuxSocial = /** @class */ (function () {
    function ContentieuxSocial() {
    }
    return ContentieuxSocial;
}());
exports.ContentieuxSocial = ContentieuxSocial;
var RaisonContestation = /** @class */ (function () {
    function RaisonContestation() {
    }
    return RaisonContestation;
}());
exports.RaisonContestation = RaisonContestation;
var RaisonInvalidationTitre = /** @class */ (function () {
    function RaisonInvalidationTitre() {
    }
    return RaisonInvalidationTitre;
}());
exports.RaisonInvalidationTitre = RaisonInvalidationTitre;
var RaisonAvisDimpositionIrregulier = /** @class */ (function () {
    function RaisonAvisDimpositionIrregulier() {
    }
    return RaisonAvisDimpositionIrregulier;
}());
exports.RaisonAvisDimpositionIrregulier = RaisonAvisDimpositionIrregulier;
var PrejudiceEvaluableEnArgent = /** @class */ (function () {
    function PrejudiceEvaluableEnArgent() {
    }
    return PrejudiceEvaluableEnArgent;
}());
exports.PrejudiceEvaluableEnArgent = PrejudiceEvaluableEnArgent;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PieceJointType;
(function (PieceJointType) {
    PieceJointType["REQUETE"] = "REQ";
    PieceJointType["ACTE_ATTAQUE"] = "DEC";
    PieceJointType["RECLAMATION_PREALABLE"] = "REP";
    PieceJointType["INVENTAIRE_REQUETE"] = "RIN";
    PieceJointType["PIECE_JOINTE_REQUETE"] = "PRQ";
    PieceJointType["PIECE_JOINTE_DOCUMENT"] = "PJD";
    PieceJointType["MEMOIRE"] = "MEM";
    PieceJointType["INVENTAIRE_DOSSIER"] = "DIN";
    PieceJointType["PIECES"] = "PIE";
    PieceJointType["PIECE_POSTALE"] = "POSTALE";
})(PieceJointType = exports.PieceJointType || (exports.PieceJointType = {}));
var PieceComplementaireOrigineType;
(function (PieceComplementaireOrigineType) {
    PieceComplementaireOrigineType["MAL_INTERPRETE"] = "MLINTER";
    PieceComplementaireOrigineType["MAL_APPRECIE"] = "MLAPP";
    PieceComplementaireOrigineType["RAPO"] = "RAPO";
    PieceComplementaireOrigineType["SOMME_DUE"] = "SOMDUE";
    PieceComplementaireOrigineType["MONTANT_DU"] = "MONTDU";
    PieceComplementaireOrigineType["AVIS_IMPOSITION_INFONDEE_ET_AUTRE"] = "AIINFAUT";
    PieceComplementaireOrigineType["PRECISION_PREJUDICE"] = "PRECPREJ";
    PieceComplementaireOrigineType["REQUETE_REDIGEE_JUSTIFICATIF"] = "REREJU";
    PieceComplementaireOrigineType["DEFAULT"] = "DEFAULT";
})(PieceComplementaireOrigineType = exports.PieceComplementaireOrigineType || (exports.PieceComplementaireOrigineType = {}));
var GenericPiece = /** @class */ (function () {
    function GenericPiece(fileModel) {
        this.fileModel = fileModel;
    }
    // Serialize
    GenericPiece.prototype.toDTO = function () {
        var ret = {
            fileApiId: this.fileModel.fileApiId,
            libelle: this.libelle,
            fileType: this.fileType,
            complementaryFileOriginType: this.complementaryFileOriginType
        };
        return ret;
    };
    return GenericPiece;
}());
exports.GenericPiece = GenericPiece;
var Memoire = /** @class */ (function (_super) {
    __extends(Memoire, _super);
    function Memoire(fileModel) {
        var _this = _super.call(this, fileModel) || this;
        _this.libelle = 'Memoire';
        _this.fileType = PieceJointType.MEMOIRE;
        return _this;
    }
    return Memoire;
}(GenericPiece));
exports.Memoire = Memoire;
var PieceRequete = /** @class */ (function (_super) {
    __extends(PieceRequete, _super);
    function PieceRequete(fileModel) {
        var _this = _super.call(this, fileModel) || this;
        _this.libelle = 'Requête';
        _this.fileType = PieceJointType.REQUETE;
        return _this;
    }
    return PieceRequete;
}(GenericPiece));
exports.PieceRequete = PieceRequete;
var PieceActeAttaque = /** @class */ (function (_super) {
    __extends(PieceActeAttaque, _super);
    function PieceActeAttaque(fileModel) {
        var _this = _super.call(this, fileModel) || this;
        _this.libelle = 'Acte attaqué';
        _this.fileType = PieceJointType.ACTE_ATTAQUE;
        return _this;
    }
    return PieceActeAttaque;
}(GenericPiece));
exports.PieceActeAttaque = PieceActeAttaque;
var PieceReclamationPrealable = /** @class */ (function (_super) {
    __extends(PieceReclamationPrealable, _super);
    function PieceReclamationPrealable(fileModel) {
        var _this = _super.call(this, fileModel) || this;
        _this.libelle = 'Réclamation préalable';
        _this.fileType = PieceJointType.RECLAMATION_PREALABLE;
        return _this;
    }
    return PieceReclamationPrealable;
}(GenericPiece));
exports.PieceReclamationPrealable = PieceReclamationPrealable;
var PieceComplementaire = /** @class */ (function (_super) {
    __extends(PieceComplementaire, _super);
    function PieceComplementaire(fileModel, type, complementaryFileOriginType) {
        var _this = _super.call(this, fileModel) || this;
        _this.fileType = type;
        _this.complementaryFileOriginType = complementaryFileOriginType;
        return _this;
    }
    return PieceComplementaire;
}(GenericPiece));
exports.PieceComplementaire = PieceComplementaire;
var PiecePostale = /** @class */ (function () {
    function PiecePostale(libelle) {
        this.libelle = libelle;
        this.fileType = PieceJointType.PIECE_POSTALE;
    }
    // Serialize
    PiecePostale.prototype.toDTO = function () {
        return {
            libelle: this.libelle,
            fileType: this.fileType
        };
    };
    return PiecePostale;
}());
exports.PiecePostale = PiecePostale;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SiteJuridiction = /** @class */ (function () {
    function SiteJuridiction(id, libelleCourt, libelleLong, code) {
        this.id = id;
        this.libelleCourt = libelleCourt;
        this.libelleLong = libelleLong;
        this.code = code;
    }
    return SiteJuridiction;
}());
exports.SiteJuridiction = SiteJuridiction;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(446));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TypeJuridiction = /** @class */ (function () {
    function TypeJuridiction() {
    }
    return TypeJuridiction;
}());
exports.TypeJuridiction = TypeJuridiction;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var FaqCategoryComponent = /** @class */ (function () {
    function FaqCategoryComponent(route) {
        this.route = route;
    }
    FaqCategoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.frangementSub$ = this.route.fragment.subscribe(function (fragment) { _this.fragment = fragment; });
    };
    FaqCategoryComponent.prototype.ngAfterViewInit = function () {
        try {
            if (document.querySelector('#' + this.fragment) != null) {
                document.querySelector('#' + this.fragment).scrollIntoView();
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    FaqCategoryComponent.prototype.ngOnDestroy = function () {
        this.frangementSub$.unsubscribe();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], FaqCategoryComponent.prototype, "category", void 0);
    FaqCategoryComponent = __decorate([
        core_1.Component({
            selector: 'jhi-faq-category',
            template: __webpack_require__(797),
            styles: [__webpack_require__(897)]
        }),
        __metadata("design:paramtypes", [router_1.ActivatedRoute])
    ], FaqCategoryComponent);
    return FaqCategoryComponent;
}());
exports.FaqCategoryComponent = FaqCategoryComponent;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var scroll_to_service_1 = __webpack_require__(101);
var core_1 = __webpack_require__(0);
var FaqHighlightComponent = /** @class */ (function () {
    function FaqHighlightComponent(scrollToService) {
        this.scrollToService = scrollToService;
    }
    FaqHighlightComponent.prototype.ngOnInit = function () {
    };
    FaqHighlightComponent.prototype.scrollToCategoryItem = function () {
        this.scrollToService.scrollBySelector('.faq-category-item-' + this.matchedItem.id);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], FaqHighlightComponent.prototype, "matchedItem", void 0);
    FaqHighlightComponent = __decorate([
        core_1.Component({
            selector: 'jhi-faq-highlight',
            template: __webpack_require__(798),
            styles: [__webpack_require__(898)]
        }),
        __metadata("design:paramtypes", [scroll_to_service_1.ScrollToService])
    ], FaqHighlightComponent);
    return FaqHighlightComponent;
}());
exports.FaqHighlightComponent = FaqHighlightComponent;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var highlight_search_pipe_1 = __webpack_require__(161);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(43);
var app_constants_1 = __webpack_require__(11);
var FaqSearchComponent = /** @class */ (function () {
    function FaqSearchComponent(highlightSearchPipe, titleService) {
        this.highlightSearchPipe = highlightSearchPipe;
        this.titleService = titleService;
    }
    FaqSearchComponent.prototype.ngOnInit = function () {
    };
    FaqSearchComponent.prototype.ngOnChanges = function (_changes) {
        var _this = this;
        if (this.categories) {
            this.items = [];
            this.categories.forEach(function (category) {
                // because we need escape html tag after
                var copyItems = jQuery.extend(true, [], category.items);
                _this.items = _this.items.concat(copyItems);
            });
        }
    };
    FaqSearchComponent.prototype.resetSearch = function () {
        this.searchText = null;
    };
    FaqSearchComponent.prototype.getHighLightItems = function () {
        this.matchedItems = this.highlightSearchPipe.transform(this.items, this.searchText);
        this.titleService.setTitle("Aide : " + this.matchedItems.length + " r\u00E9sultats de recherche pour le terme \"" + this.searchText + "\"" + app_constants_1.PAGE_TITLE_SUFFIX);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], FaqSearchComponent.prototype, "categories", void 0);
    FaqSearchComponent = __decorate([
        core_1.Component({
            selector: 'jhi-faq-search',
            template: __webpack_require__(799),
            styles: [__webpack_require__(899)]
        }),
        __metadata("design:paramtypes", [highlight_search_pipe_1.HighlightSearchPipe,
            platform_browser_1.Title])
    ], FaqSearchComponent);
    return FaqSearchComponent;
}());
exports.FaqSearchComponent = FaqSearchComponent;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(377)))

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(4);
var FaqSummaryComponent = /** @class */ (function () {
    function FaqSummaryComponent(scrollToService) {
        this.scrollToService = scrollToService;
    }
    FaqSummaryComponent.prototype.scrollToCategory = function (categoryId) {
        this.scrollToService.scrollBySelector(".faq-category-" + categoryId);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], FaqSummaryComponent.prototype, "categories", void 0);
    FaqSummaryComponent = __decorate([
        core_1.Component({
            selector: 'jhi-faq-summary',
            template: __webpack_require__(800),
            styles: [__webpack_require__(900)]
        }),
        __metadata("design:paramtypes", [shared_1.ScrollToService])
    ], FaqSummaryComponent);
    return FaqSummaryComponent;
}());
exports.FaqSummaryComponent = FaqSummaryComponent;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var faq_highlight_component_1 = __webpack_require__(448);
var core_1 = __webpack_require__(0);
var faq_component_1 = __webpack_require__(162);
var faq_category_component_1 = __webpack_require__(447);
var faq_summary_component_1 = __webpack_require__(450);
var static_content_service_1 = __webpack_require__(102);
var router_1 = __webpack_require__(6);
var faq_route_1 = __webpack_require__(163);
var faq_search_component_1 = __webpack_require__(449);
var highlight_search_pipe_1 = __webpack_require__(161);
var shared_1 = __webpack_require__(4);
var TelerecourspnrFaqModule = /** @class */ (function () {
    function TelerecourspnrFaqModule() {
    }
    TelerecourspnrFaqModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_1.TelerecourspnrSharedModule,
                router_1.RouterModule.forRoot([faq_route_1.faqRoute], { useHash: true }),
            ],
            declarations: [
                faq_component_1.FaqComponent,
                faq_summary_component_1.FaqSummaryComponent,
                faq_category_component_1.FaqCategoryComponent,
                faq_search_component_1.FaqSearchComponent,
                faq_highlight_component_1.FaqHighlightComponent,
                highlight_search_pipe_1.HighlightSearchPipe
            ],
            providers: [
                static_content_service_1.StaticContentService,
                highlight_search_pipe_1.HighlightSearchPipe
            ]
        })
    ], TelerecourspnrFaqModule);
    return TelerecourspnrFaqModule;
}());
exports.TelerecourspnrFaqModule = TelerecourspnrFaqModule;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var table_1 = __webpack_require__(132);
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var draft_depot_requete_service_1 = __webpack_require__(16);
var rename_dossier_component_1 = __webpack_require__(185);
var shared_1 = __webpack_require__(4);
var home_component_1 = __webpack_require__(164);
var home_route_1 = __webpack_require__(453);
var auto_focus_directive_1 = __webpack_require__(454);
var dossier_modal_component_1 = __webpack_require__(165);
var filter_block_component_1 = __webpack_require__(455);
var mes_dossiers_component_1 = __webpack_require__(456);
var mobile_sort_block_component_1 = __webpack_require__(457);
var numero_dossier_component_1 = __webpack_require__(458);
var sort_status_component_1 = __webpack_require__(459);
var ng_bootstrap_1 = __webpack_require__(19);
/* import { TooltipsComponent } from '../requete/historique-requete/timeline/tooltips/tooltips.component'; */
var TelerecourspnrHomeModule = /** @class */ (function () {
    function TelerecourspnrHomeModule() {
    }
    TelerecourspnrHomeModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_1.TelerecourspnrSharedModule,
                router_1.RouterModule.forRoot([home_route_1.HOME_ROUTE, home_route_1.DEFAULT_ROUTE], { useHash: true }),
                table_1.CdkTableModule,
                ng_bootstrap_1.NgbTooltipModule
            ],
            declarations: [
                home_component_1.HomeComponent,
                mes_dossiers_component_1.MesDossiersComponent,
                numero_dossier_component_1.NumeroDossierComponent,
                dossier_modal_component_1.DossierModalComponent,
                filter_block_component_1.FilterBlockComponent,
                mobile_sort_block_component_1.MobileSortBlockComponent,
                auto_focus_directive_1.AutofocusDirective,
                sort_status_component_1.SortStatusComponent,
                rename_dossier_component_1.RenameDossierComponent,
            ],
            entryComponents: [dossier_modal_component_1.DossierModalComponent, rename_dossier_component_1.RenameDossierComponent],
            providers: [draft_depot_requete_service_1.DraftDepotRequeteService],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
        })
    ], TelerecourspnrHomeModule);
    return TelerecourspnrHomeModule;
}());
exports.TelerecourspnrHomeModule = TelerecourspnrHomeModule;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var home_component_1 = __webpack_require__(164);
exports.HOME_ROUTE = {
    path: 'accueil',
    component: home_component_1.HomeComponent,
    data: {
        needAuthentication: true,
        pageTitle: "Accueil" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};
exports.DEFAULT_ROUTE = {
    path: '',
    redirectTo: 'authentication',
    pathMatch: 'full'
};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var AutofocusDirective = /** @class */ (function () {
    function AutofocusDirective(el) {
        this.el = el;
        this.focus = true;
    }
    AutofocusDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (this.focus) {
            // Otherwise Angular throws error: Expression has changed after it was checked.
            window.setTimeout(function () {
                _this.el.nativeElement.focus();
            });
        }
    };
    Object.defineProperty(AutofocusDirective.prototype, "autofocus", {
        set: function (condition) {
            this.focus = condition !== false;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], AutofocusDirective.prototype, "autofocus", null);
    AutofocusDirective = __decorate([
        core_1.Directive({
            selector: '[jhiAutofocus]'
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], AutofocusDirective);
    return AutofocusDirective;
}());
exports.AutofocusDirective = AutofocusDirective;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var FilterBlockComponent = /** @class */ (function () {
    function FilterBlockComponent() {
        this.statusChanges = new core_1.EventEmitter();
    }
    FilterBlockComponent.prototype.ngOnInit = function () { };
    FilterBlockComponent.prototype.applyFilter = function (value) {
        this.statusChanges.emit(value);
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], FilterBlockComponent.prototype, "statusChanges", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], FilterBlockComponent.prototype, "statutFilter", void 0);
    FilterBlockComponent = __decorate([
        core_1.Component({
            selector: 'jhi-filter-block',
            template: __webpack_require__(803),
            styles: [__webpack_require__(903)]
        }),
        __metadata("design:paramtypes", [])
    ], FilterBlockComponent);
    return FilterBlockComponent;
}());
exports.FilterBlockComponent = FilterBlockComponent;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var requete_1 = __webpack_require__(17);
var router_1 = __webpack_require__(6);
var ng_bootstrap_1 = __webpack_require__(19);
var dossier_modal_component_1 = __webpack_require__(165);
var mes_dossiers_datasource_1 = __webpack_require__(166);
var tracking_enum_1 = __webpack_require__(31);
var tracking_service_1 = __webpack_require__(32);
var MesDossiersComponent = /** @class */ (function () {
    function MesDossiersComponent(router, modalService, requeteService, trackingService) {
        this.router = router;
        this.modalService = modalService;
        this.requeteService = requeteService;
        this.trackingService = trackingService;
        this.dataSource$ = new mes_dossiers_datasource_1.RequetesDataSource();
        this.displayedColumns = Object.keys(mes_dossiers_datasource_1.DisplayedColumn).map(function (key) { return mes_dossiers_datasource_1.DisplayedColumn[key]; });
    }
    MesDossiersComponent.prototype.ngOnInit = function () {
        this.sortKey = this.dataSource$.sortKey$.getValue();
        this.statutFilter = this.dataSource$.statutFilter$.getValue();
        this.populateRequeteList();
    };
    MesDossiersComponent.prototype.openRequete = function (requete) {
        if ((requete.statut === requete_1.RequeteStatut.EN_ATTENTE_DE_RATTACHEMENT)) {
            var modalRef = this.modalService.open(dossier_modal_component_1.DossierModalComponent, { size: 'lg' });
            modalRef.componentInstance.requete = requete;
        }
        else {
            this.requeteService.clear();
            this.router.navigateByUrl("/historique/" + requete.id);
        }
    };
    MesDossiersComponent.prototype.addDocument = function (requete) {
        this.router.navigateByUrl("/historique/" + requete.id + "/document");
    };
    MesDossiersComponent.prototype.adjustSort = function (key) {
        this.dataSource$.adjustSort(key);
    };
    MesDossiersComponent.prototype.applyFilter = function (key) {
        this._track(tracking_enum_1.TrackingAction.CLIQUER, "Filtre : " + key);
        this.dataSource$.applyFilter(key);
    };
    MesDossiersComponent.prototype.displayAddDocumentBtn = function (requete) {
        return this.requeteService.canAddPieces(requete);
    };
    MesDossiersComponent.prototype.populateRequeteList = function () {
        var _this = this;
        this.isLoading = true;
        this.requeteService.getAll()
            .subscribe(function (requetes) {
            _this.dataSource$.init(requetes);
            _this.isLoading = false;
        }, function (_err) {
            _this.isLoading = false;
            _this.isError = true;
        });
    };
    MesDossiersComponent.prototype._track = function (action, name) {
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.MES_DOSSIER,
                name: name
            }
        });
    };
    MesDossiersComponent = __decorate([
        core_1.Component({
            selector: 'jhi-mes-dossiers',
            template: __webpack_require__(804),
            styles: [__webpack_require__(904)]
        }),
        __metadata("design:paramtypes", [router_1.Router,
            ng_bootstrap_1.NgbModal,
            requete_1.RequeteService,
            tracking_service_1.TrackingService])
    ], MesDossiersComponent);
    return MesDossiersComponent;
}());
exports.MesDossiersComponent = MesDossiersComponent;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var MobileSortBlockComponent = /** @class */ (function () {
    function MobileSortBlockComponent() {
        this.sortKeyChanges = new core_1.EventEmitter();
    }
    MobileSortBlockComponent.prototype.ngOnInit = function () { };
    MobileSortBlockComponent.prototype.adjustSort = function (key) {
        this.sortKeyChanges.emit(key);
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], MobileSortBlockComponent.prototype, "sortKeyChanges", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], MobileSortBlockComponent.prototype, "sortKey", void 0);
    MobileSortBlockComponent = __decorate([
        core_1.Component({
            selector: 'jhi-mobile-sort-block',
            template: __webpack_require__(805),
            styles: [__webpack_require__(905)]
        }),
        __metadata("design:paramtypes", [])
    ], MobileSortBlockComponent);
    return MobileSortBlockComponent;
}());
exports.MobileSortBlockComponent = MobileSortBlockComponent;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var requete_1 = __webpack_require__(17);
var NumeroDossierComponent = /** @class */ (function () {
    function NumeroDossierComponent() {
    }
    NumeroDossierComponent.prototype.ngOnInit = function () {
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", requete_1.RequeteSummary)
    ], NumeroDossierComponent.prototype, "dossier", void 0);
    NumeroDossierComponent = __decorate([
        core_1.Component({
            selector: 'jhi-numero-dossier',
            template: __webpack_require__(806),
            styles: [__webpack_require__(906)]
        }),
        __metadata("design:paramtypes", [])
    ], NumeroDossierComponent);
    return NumeroDossierComponent;
}());
exports.NumeroDossierComponent = NumeroDossierComponent;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var mes_dossiers_datasource_1 = __webpack_require__(166);
var SortStatusComponent = /** @class */ (function () {
    function SortStatusComponent() {
        this.orderLiteral = 'l\'ordre';
        this.defaultSortingTitle = 'Trier par ';
    }
    SortStatusComponent.prototype.ngOnInit = function () {
        switch (this.cellKey) {
            case 'description':
                this.columnName = 'le numéro du dossier';
                this.defaultSortingTitle += this.columnName;
                break;
            case 'juridiction':
                this.columnName = 'la juridiction';
                this.defaultSortingTitle += this.columnName;
                break;
            case 'statut':
                this.columnName = 'l\'état du dossier';
                this.defaultSortingTitle += this.columnName;
                break;
            case 'dateModification':
                this.columnName = 'la date de l\'état';
                this.defaultSortingTitle += this.columnName;
                break;
            default:
                this.columnName = 'les actions';
                this.defaultSortingTitle = 'Trier';
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SortStatusComponent.prototype, "sortKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SortStatusComponent.prototype, "sortDirection", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SortStatusComponent.prototype, "cellKey", void 0);
    SortStatusComponent = __decorate([
        core_1.Component({
            selector: 'jhi-sort-status',
            template: "<div *ngIf=\"sortKey === cellKey\"\n                    class=\"{{ sortDirection === 'asc' ? 'fa fa-fw fa-sort-asc' : 'fa fa-fw fa-sort-desc' }}\"\n                    aria-hidden=\"true\"\n                    title=\"{{ sortDirection === 'asc' ? 'Trier ' + columnName + ' dans ' + orderLiteral + ' croissant'\n                                                      : 'Trier ' + columnName + ' dans ' + orderLiteral + ' d\u00E9croissant'}}\">\n                </div>\n                <div *ngIf=\"sortKey !== cellKey\"\n                     class=\"fa fa-fw fa-sort\"\n                     aria-hidden=\"true\"\n                     title=\"{{defaultSortingTitle}}\">\n                </div>\n              ",
            styles: [__webpack_require__(907)]
        })
    ], SortStatusComponent);
    return SortStatusComponent;
}());
exports.SortStatusComponent = SortStatusComponent;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var error_component_1 = __webpack_require__(167);
exports.errorRoute = [
    {
        path: 'error',
        component: error_component_1.ErrorComponent,
        data: {
            needAuthentication: false,
            pageTitle: "Erreur 404" + app_constants_1.PAGE_TITLE_SUFFIX
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var shared_1 = __webpack_require__(4);
var tracking_service_1 = __webpack_require__(32);
var tracking_enum_1 = __webpack_require__(31);
var FooterComponent = /** @class */ (function () {
    function FooterComponent(userService, trackingService) {
        this.userService = userService;
        this.trackingService = trackingService;
    }
    FooterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.auth2Observable.subscribe(function (isUserAuthenticated) {
            if (!isUserAuthenticated) {
                _this.joinedUserClub = true;
            }
            else {
                _this.userService.getIsUserClubMember().then(function (isUserClubMember) {
                    _this.joinedUserClub = isUserClubMember;
                }).catch(function () {
                    _this.joinedUserClub = true;
                });
            }
        });
    };
    FooterComponent.prototype.trackCliquer = function () {
        this._track(tracking_enum_1.TrackingAction.CLIQUER);
    };
    FooterComponent.prototype._track = function (action) {
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.FOOTER,
                name: 'Mise à jour du site'
            }
        });
    };
    FooterComponent = __decorate([
        core_1.Component({
            selector: 'jhi-footer',
            template: __webpack_require__(810),
            styles: [__webpack_require__(910)]
        }),
        __metadata("design:paramtypes", [shared_1.UserService,
            tracking_service_1.TrackingService])
    ], FooterComponent);
    return FooterComponent;
}());
exports.FooterComponent = FooterComponent;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var PlanSiteItemComponent = /** @class */ (function () {
    function PlanSiteItemComponent() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PlanSiteItemComponent.prototype, "routePath", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PlanSiteItemComponent.prototype, "routeTitle", void 0);
    __decorate([
        core_1.HostBinding('class.sub-item'),
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], PlanSiteItemComponent.prototype, "isSubItem", void 0);
    PlanSiteItemComponent = __decorate([
        core_1.Component({
            selector: 'jhi-plan-site-item',
            template: __webpack_require__(814),
            styles: [__webpack_require__(913)]
        }),
        __metadata("design:paramtypes", [])
    ], PlanSiteItemComponent);
    return PlanSiteItemComponent;
}());
exports.PlanSiteItemComponent = PlanSiteItemComponent;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var plan_site_component_1 = __webpack_require__(173);
exports.planSiteRoute = {
    path: 'plan-site',
    component: plan_site_component_1.PlanSiteComponent,
    data: {
        needAuthentication: false,
        pageTitle: "Plan du site" + app_constants_1.PAGE_TITLE_SUFFIX
    }
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(466));
__export(__webpack_require__(461));
__export(__webpack_require__(467));
__export(__webpack_require__(167));
__export(__webpack_require__(171));
__export(__webpack_require__(169));
__export(__webpack_require__(174));
__export(__webpack_require__(175));
__export(__webpack_require__(465));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var app_route_1 = __webpack_require__(88);
var error_route_1 = __webpack_require__(460);
var plan_site_route_1 = __webpack_require__(463);
var LAYOUT_ROUTES = __spread([
    app_route_1.navbarRoute,
    app_route_1.mentionLegaleRoute,
    app_route_1.conditionGeneraleRoute,
    app_route_1.accessibiliteRoute,
    app_route_1.personalDataRoute,
    plan_site_route_1.planSiteRoute,
    app_route_1.changelogRoute
], error_route_1.errorRoute);
var LayoutRoutingModule = /** @class */ (function () {
    function LayoutRoutingModule() {
    }
    LayoutRoutingModule = __decorate([
        core_1.NgModule({
            imports: [
                router_1.RouterModule.forRoot(LAYOUT_ROUTES, { useHash: true })
            ],
            exports: [
                router_1.RouterModule
            ]
        })
    ], LayoutRoutingModule);
    return LayoutRoutingModule;
}());
exports.LayoutRoutingModule = LayoutRoutingModule;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var ng_jhipster_1 = __webpack_require__(30);
var shared_1 = __webpack_require__(4);
var piwik_1 = __webpack_require__(534);
var navigation_service_1 = __webpack_require__(99);
var parameters_service_1 = __webpack_require__(25);
var JhiMainComponent = /** @class */ (function () {
    function JhiMainComponent(jhiLanguageHelper, router, stateStorageService, navigationService, parametersService, 
    // @ts-ignore
    angulartics2Piwik, 
    // @ts-ignore (load the translation just by being requested)
    jhiLanguageService) {
        this.jhiLanguageHelper = jhiLanguageHelper;
        this.router = router;
        this.stateStorageService = stateStorageService;
        this.navigationService = navigationService;
        this.parametersService = parametersService;
        this.angulartics2Piwik = angulartics2Piwik;
        this.jhiLanguageService = jhiLanguageService;
        this.showNavigationButton = false;
        // The navigation button on the main content area will not be visible on its pages
        this.routeExcluded = ['/authentication', '/reset/request', '/register/morale', '/register/particulier', '/'];
        this.angulartics2Piwik.startTracking();
    }
    JhiMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.parametersService.loadParameters();
        this.showNavigationButton = this.router && this.routeExcluded.indexOf(this.router.url) === -1;
        this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                _this.jhiLanguageHelper.updateTitle();
                window.scrollTo(0, 0);
                _this.showNavigationButton = _this.routeExcluded.indexOf(event.url) === -1;
            }
            if (event instanceof router_1.RoutesRecognized) {
                _this.stateStorageService.storeDestinationState(event.urlAfterRedirects);
            }
        });
    };
    JhiMainComponent.prototype.onPopState = function (_event) {
        this.navigationService.markAsGoingBack();
    };
    __decorate([
        core_1.HostListener('window:popstate', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], JhiMainComponent.prototype, "onPopState", null);
    JhiMainComponent = __decorate([
        core_1.Component({
            selector: 'jhi-main',
            template: __webpack_require__(816),
            styles: [__webpack_require__(915)]
        }),
        __metadata("design:paramtypes", [shared_1.JhiLanguageHelper,
            router_1.Router,
            shared_1.StateStorageService,
            navigation_service_1.NavigationService,
            parameters_service_1.ParametersService,
            piwik_1.Angulartics2Piwik,
            ng_jhipster_1.JhiLanguageService])
    ], JhiMainComponent);
    return JhiMainComponent;
}());
exports.JhiMainComponent = JhiMainComponent;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var profile_service_1 = __webpack_require__(175);
var PageRibbonComponent = /** @class */ (function () {
    function PageRibbonComponent(profileService) {
        this.profileService = profileService;
    }
    PageRibbonComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.profileService.getProfileInfo().subscribe(function (profileInfo) {
            _this.profileInfo = profileInfo;
            _this.ribbonEnv = profileInfo.ribbonEnv;
        });
    };
    PageRibbonComponent = __decorate([
        core_1.Component({
            selector: 'jhi-page-ribbon',
            template: "<div class=\"ribbon\" *ngIf=\"ribbonEnv\">\n    <a href=\"\" jhiTranslate=\"global.ribbon.{{ribbonEnv}}\">{{ribbonEnv}}</a></div>",
            styles: [
                __webpack_require__(917)
            ]
        }),
        __metadata("design:paramtypes", [profile_service_1.ProfileService])
    ], PageRibbonComponent);
    return PageRibbonComponent;
}());
exports.PageRibbonComponent = PageRibbonComponent;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(19);
var shared_1 = __webpack_require__(4);
var inactivity_service_1 = __webpack_require__(92);
var InactivityModalComponent = /** @class */ (function () {
    function InactivityModalComponent(modalService, userService, loginService, inactivityService, injector) {
        this.modalService = modalService;
        this.userService = userService;
        this.loginService = loginService;
        this.inactivityService = inactivityService;
        this.injector = injector;
        this.isSessionExtended = false;
    }
    InactivityModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.inactivityService.openModal.subscribe(function () {
            // Implementing userAuth validation in InactivityService directly will
            // lead to cyclic dependency errors from AuthExpiredInterceptor
            _this.userService.getIsAuthenticated().subscribe(function (isAuthenticated) {
                if (isAuthenticated && !_this.isModalActive) {
                    _this._openModal();
                }
            });
        });
    };
    InactivityModalComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    InactivityModalComponent.prototype.onExtendSession = function () {
        var _this = this;
        this.isSessionExtended = true;
        this._clearModalCountdown();
        this._pingServer();
        setTimeout(function () { return _this.activeModal.close(); }, 3000);
    };
    InactivityModalComponent.prototype.onLogout = function () {
        this._clearModalCountdown();
        this.loginService.logout();
        this.activeModal.close();
    };
    InactivityModalComponent.prototype._openModal = function () {
        var _this = this;
        this.injector.get(shared_1.UserService).isRememberMe().then(function (isRememeberMe) {
            if (!isRememeberMe) {
                _this.activeModal = _this.modalService.open(_this.modalRef, {
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false
                });
                // RGAA workaround
                var modalEl = document.querySelector('ngb-modal-window');
                modalEl.setAttribute('aria-label', 'Votre session va bientôt expirer');
                if (_this.currentCountdown) {
                    _this._clearModalCountdown();
                }
                _this._startNewModalCountdown();
            }
        });
    };
    InactivityModalComponent.prototype._clearModalCountdown = function () {
        clearInterval(this.currentCountdown);
    };
    InactivityModalComponent.prototype._startNewModalCountdown = function () {
        var _this = this;
        this.counter = 59;
        this.isSessionExtended = false;
        this.currentCountdown = setInterval(function () {
            if (_this.counter === 0) {
                _this.onLogout();
                _this._clearModalCountdown();
            }
            _this.counter--;
        }, 1000);
    };
    /**
     * @brief Sends a request to the server to maintain activity and prevent automatic session expiration
     */
    InactivityModalComponent.prototype._pingServer = function () {
        this.userService.getIsAuthenticated(true).toPromise();
    };
    __decorate([
        core_1.ViewChild('modal'),
        __metadata("design:type", ng_bootstrap_1.NgbActiveModal)
    ], InactivityModalComponent.prototype, "modalRef", void 0);
    InactivityModalComponent = __decorate([
        core_1.Component({
            selector: 'jhi-inactivity-modal',
            template: __webpack_require__(818),
            styles: [__webpack_require__(918)],
        }),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
            shared_1.UserService,
            shared_1.LoginService,
            inactivity_service_1.InactivityService,
            core_1.Injector])
    ], InactivityModalComponent);
    return InactivityModalComponent;
}());
exports.InactivityModalComponent = InactivityModalComponent;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(178));
__export(__webpack_require__(177));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var document_component_1 = __webpack_require__(182);
exports.addDocumentRoute = {
    path: 'historique/:id/document',
    component: document_component_1.DocumentComponent,
    data: {
        needAuthentication: true,
        pageTitle: "Ajout des documents compl\u00E9mentaires au dossier" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(19);
var requete_model_1 = __webpack_require__(68);
var requete_model_2 = __webpack_require__(68);
var rename_dossier_component_1 = __webpack_require__(185);
var requete_1 = __webpack_require__(17);
var tracking_enum_1 = __webpack_require__(31);
var tracking_service_1 = __webpack_require__(32);
var ng_jhipster_1 = __webpack_require__(30);
var DossierComponent = /** @class */ (function () {
    function DossierComponent(requeteService, modalService, trackingService, alertService) {
        this.requeteService = requeteService;
        this.modalService = modalService;
        this.trackingService = trackingService;
        this.alertService = alertService;
        this.orderAsc = false;
    }
    DossierComponent.prototype.ngOnInit = function () {
        this.mandataires = this.filterParties(requete_model_2.QualityType.Mandataire);
        this.defendeurs = this.filterParties(requete_model_2.QualityType.Defendeur);
        this.requerants = this.filterParties(requete_model_2.QualityType.Requerant);
        this.observateurs = this.filterParties(requete_model_2.QualityType.Observateur);
        this.intervenantsDef = this.filterParties(requete_model_2.QualityType.IntervenantEnDefense);
        this.intervenantsReq = this.filterParties(requete_model_2.QualityType.IntervenantEnRequete);
    };
    DossierComponent.prototype.toggleOrder = function () {
        this._track(tracking_enum_1.TrackingAction.CLIQUER, 'Inverser ordre chronologique');
        this.dossier.events.reverse();
    };
    DossierComponent.prototype.canAddPieces = function () {
        return this.requeteService.canAddPieces(this.dossier);
    };
    DossierComponent.prototype.filterParties = function (qualite) {
        return this.dossier.parties.filter(function (elem) { return elem.qualite === qualite; });
    };
    DossierComponent.prototype.openRequete = function () {
        this.dossier.renamed = false;
        this._track(tracking_enum_1.TrackingAction.CLIQUER, 'Renommer votre dossier');
        var modalRef = this.modalService.open(rename_dossier_component_1.RenameDossierComponent, { size: 'lg' });
        modalRef.componentInstance.dossier = this.dossier;
        this.addSuccessAlert();
    };
    DossierComponent.prototype.addSuccessAlert = function () {
        this.alertService.addAlert({ type: 'success', msg: 'historique.messages.success', timeout: 10000 }, []);
    };
    DossierComponent.prototype.trackAjoutDoc = function () {
        this._track(tracking_enum_1.TrackingAction.CLIQUER, 'Ajouter des documents complémentaires');
    };
    DossierComponent.prototype._track = function (action, name) {
        this.trackingService.trackEvent({
            action: action,
            properties: {
                category: tracking_enum_1.TrackingCategory.CONSULTATION_DOSSIER,
                name: name
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", requete_model_1.RequeteDetail)
    ], DossierComponent.prototype, "dossier", void 0);
    DossierComponent = __decorate([
        core_1.Component({
            selector: 'jhi-dossier',
            template: __webpack_require__(824),
            styles: [__webpack_require__(924)]
        }),
        __metadata("design:paramtypes", [requete_1.RequeteService,
            ng_bootstrap_1.NgbModal,
            tracking_service_1.TrackingService,
            ng_jhipster_1.JhiAlertService])
    ], DossierComponent);
    return DossierComponent;
}());
exports.DossierComponent = DossierComponent;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var historique_component_1 = __webpack_require__(183);
exports.historiqueRoute = {
    path: 'historique/:id',
    component: historique_component_1.HistoriqueComponent,
    data: {
        needAuthentication: true,
        pageTitle: "Consultation de dossier" + app_constants_1.PAGE_TITLE_SUFFIX
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var common_1 = __webpack_require__(15);
var util_1 = __webpack_require__(28);
var tracking_service_1 = __webpack_require__(32);
var tracking_enum_1 = __webpack_require__(31);
var util_2 = __webpack_require__(47);
var event_piece_service_1 = __webpack_require__(184);
var requete_1 = __webpack_require__(17);
var TimelineElementComponent = /** @class */ (function () {
    function TimelineElementComponent(datePipe, route, trackingService, requeteService, timelineElementService) {
        this.datePipe = datePipe;
        this.route = route;
        this.trackingService = trackingService;
        this.requeteService = requeteService;
        this.timelineElementService = timelineElementService;
        this.isCourrierLu = false;
    }
    TimelineElementComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub = this.route.params.subscribe(function (params) {
            _this.dossierId = +params['id'];
        });
        this.isCourrierLu = this.isAccuseCourrierLu();
    };
    TimelineElementComponent.prototype.ngOnChanges = function (_changes) {
        this.getDirection();
    };
    TimelineElementComponent.prototype.getDirection = function () {
        // evenement TRC
        if (this.mesure.isTrc) {
            if (this.mesure.direction === 'ENVOYE') {
                this.de = this.juridiction;
                this.a = this.mesure.nomActeur;
                this.cssStr = 'communication-juridiction';
            }
            else {
                this.de = this.mesure.nomActeur;
                this.a = this.juridiction;
                if (this.mesure.acteurIdTr) {
                    this.cssStr = this.couleurMap.get(Number(this.mesure.acteurIdTr));
                }
                else {
                    this.cssStr = 'lecteur';
                }
            }
        }
        else {
            // evenement TR
            this.de = this.juridiction;
            this.a = this.mesure.nomActeur;
            this.cssStr = 'communication-juridiction';
        }
    };
    TimelineElementComponent.prototype.ngOnDestroy = function () {
        this.sub.unsubscribe();
    };
    TimelineElementComponent.prototype.convertTime = function (dateInput) {
        var dateArray = dateInput.toString().split('T');
        if (dateArray[1] === '00:00:00') {
            return null;
        }
        else {
            var timeArray = dateArray[1].split(':');
            return timeArray[0] + ":" + timeArray[1];
        }
    };
    TimelineElementComponent.prototype.downloadFile = function (eventId, eventType, fichier) {
        if (this.isAccuseCourrier() && util_2.isNullOrUndefined(this.mesure.dateReception)) {
            this.notifyAccuseCourrier();
        }
        this.trackDownloadedFile(fichier);
        this.timelineElementService.downloadEventPieceFile(this.dossierId, eventId, eventType, fichier.fileApiId, fichier.libelle, fichier.origin, { responseType: 'blob' })
            .subscribe(function (blob) {
            var fileN = !/(.+)(\.pdf)+$/.test(fichier.libelle) ?
                fichier.libelle + ".pdf" :
                fichier.libelle;
            util_1.saveOrOpenRawFile(blob, fileN);
        });
    };
    TimelineElementComponent.prototype.getClass = function () {
        return this.cssStr;
    };
    TimelineElementComponent.prototype.isAccuseCourrierLu = function () {
        return this.isAccuseCourrier() && this.mesure.dateReception != null;
    };
    TimelineElementComponent.prototype.isAccuseCourrier = function () {
        return this.mesure.pieces.some(function (piece) { return piece.fileType === 'NCOU'; });
    };
    TimelineElementComponent.prototype.notifyAccuseCourrier = function () {
        var _this = this;
        this.requeteService.notifyAccuseCourrier(this.dossierId, this.mesure.id, null).subscribe(function (res) {
            _this.isCourrierLu = true;
            _this.mesure.dateReception = res;
        });
    };
    TimelineElementComponent.prototype.formatDate = function (date) {
        if ((date.getHours() === 0) && (date.getMinutes() === 0)) {
            return this.datePipe.transform(date, 'dd/MM/yyyy');
        }
        else {
            return this.datePipe.transform(date, 'dd/MM/yyyy à HH:mm:ss');
        }
    };
    TimelineElementComponent.prototype.getFichier = function () {
        if (this.mesure.pieces && this.mesure.pieces.length > 0) {
            return this.mesure.pieces.filter(function (piece) { return piece.fileType !== 'POSTALE'; });
        }
        return null;
    };
    TimelineElementComponent.prototype.trackDownloadedFile = function (fichier) {
        this.trackingService.trackEvent({
            action: tracking_enum_1.TrackingAction.DOWNLOAD,
            properties: {
                category: tracking_enum_1.TrackingCategory.CONSULTATION_DOSSIER,
                name: "Type de fichier : " + fichier.fileType
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TimelineElementComponent.prototype, "mesure", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Map)
    ], TimelineElementComponent.prototype, "couleurMap", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TimelineElementComponent.prototype, "juridiction", void 0);
    TimelineElementComponent = __decorate([
        core_1.Component({
            selector: 'jhi-timeline-element',
            template: __webpack_require__(826),
            styles: [__webpack_require__(926)]
        }),
        __metadata("design:paramtypes", [common_1.DatePipe,
            router_1.ActivatedRoute,
            tracking_service_1.TrackingService,
            requete_1.RequeteService,
            event_piece_service_1.EventPieceService])
    ], TimelineElementComponent);
    return TimelineElementComponent;
}());
exports.TimelineElementComponent = TimelineElementComponent;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var index_1 = __webpack_require__(4);
var TimelineComponent = /** @class */ (function () {
    function TimelineComponent(userService) {
        this.userService = userService;
        this.orderAsc = true;
        this.couleurMap = new Map();
    }
    TimelineComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userService.getAccount().then(function (account) {
            _this.idLecteur = account.id;
            _this.initCouleurMap(_this.idLecteur);
        });
    };
    TimelineComponent.prototype.initCouleurMap = function (idLecteur) {
        var _this = this;
        this.parties.forEach(function (partie) {
            if (partie.userId === idLecteur) {
                _this.couleurMap.set(Number(partie.userId), 'lecteur');
            }
            else {
                _this.couleurMap.set(Number(partie.userId), 'autre-partie');
            }
        });
    };
    TimelineComponent.prototype.getCouleurMap = function () {
        return this.couleurMap;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TimelineComponent.prototype, "parties", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], TimelineComponent.prototype, "mesures", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], TimelineComponent.prototype, "orderAsc", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TimelineComponent.prototype, "juridiction", void 0);
    TimelineComponent = __decorate([
        core_1.Component({
            selector: 'jhi-timeline',
            template: __webpack_require__(827),
            styles: [__webpack_require__(927)]
        }),
        __metadata("design:paramtypes", [index_1.UserService])
    ], TimelineComponent);
    return TimelineComponent;
}());
exports.TimelineComponent = TimelineComponent;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var TooltipsComponent = /** @class */ (function () {
    function TooltipsComponent(cdRef) {
        this.cdRef = cdRef;
        this.isEllipsised = false;
    }
    TooltipsComponent.prototype.ngAfterViewChecked = function () {
        this.isEllipsised = this.container.nativeElement.scrollWidth > this.container.nativeElement.clientWidth;
        this.cdRef.detectChanges();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], TooltipsComponent.prototype, "text", void 0);
    __decorate([
        core_1.ViewChild('container'),
        __metadata("design:type", core_1.ElementRef)
    ], TooltipsComponent.prototype, "container", void 0);
    TooltipsComponent = __decorate([
        core_1.Component({
            selector: 'jhi-abbreviate',
            template: __webpack_require__(828),
            styles: [__webpack_require__(928)]
        }),
        __metadata("design:paramtypes", [core_1.ChangeDetectorRef])
    ], TooltipsComponent);
    return TooltipsComponent;
}());
exports.TooltipsComponent = TooltipsComponent;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var RequeteTitleComponent = /** @class */ (function () {
    function RequeteTitleComponent() {
    }
    RequeteTitleComponent.prototype.ngOnInit = function () {
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RequeteTitleComponent.prototype, "numeroRequete", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RequeteTitleComponent.prototype, "siteJuridictionLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RequeteTitleComponent.prototype, "affectation", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], RequeteTitleComponent.prototype, "titre", void 0);
    RequeteTitleComponent = __decorate([
        core_1.Component({
            selector: 'jhi-requete-title',
            template: __webpack_require__(830),
            styles: [__webpack_require__(930)]
        }),
        __metadata("design:paramtypes", [])
    ], RequeteTitleComponent);
    return RequeteTitleComponent;
}());
exports.RequeteTitleComponent = RequeteTitleComponent;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var ng_bootstrap_1 = __webpack_require__(19);
var shared_1 = __webpack_require__(4);
var ng2_dragula_1 = __webpack_require__(46);
var common_1 = __webpack_require__(15);
var historique_route_1 = __webpack_require__(472);
var document_route_1 = __webpack_require__(470);
var historique_component_1 = __webpack_require__(183);
var dossier_component_1 = __webpack_require__(471);
var timeline_component_1 = __webpack_require__(474);
var timeline_element_component_1 = __webpack_require__(473);
var document_component_1 = __webpack_require__(182);
var requete_title_component_1 = __webpack_require__(476);
var tooltips_component_1 = __webpack_require__(475);
var a11y_1 = __webpack_require__(44);
var TelerecourspnrRequeteModule = /** @class */ (function () {
    function TelerecourspnrRequeteModule() {
    }
    TelerecourspnrRequeteModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_1.TelerecourspnrSharedModule,
                ng_bootstrap_1.NgbModule,
                router_1.RouterModule.forRoot([historique_route_1.historiqueRoute, document_route_1.addDocumentRoute], {
                    useHash: true
                }),
                ng2_dragula_1.DragulaModule,
                common_1.CommonModule,
                a11y_1.A11yModule,
            ],
            declarations: [
                historique_component_1.HistoriqueComponent,
                tooltips_component_1.TooltipsComponent,
                dossier_component_1.DossierComponent,
                timeline_component_1.TimelineComponent,
                timeline_element_component_1.TimelineElementComponent,
                document_component_1.DocumentComponent,
                requete_title_component_1.RequeteTitleComponent
            ],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
        })
    ], TelerecourspnrRequeteModule);
    return TelerecourspnrRequeteModule;
}());
exports.TelerecourspnrRequeteModule = TelerecourspnrRequeteModule;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var AdBlockDetectorComponent = /** @class */ (function () {
    function AdBlockDetectorComponent() {
        this.adBlockerDetected = false;
    }
    AdBlockDetectorComponent.prototype.ngOnInit = function () {
        this.detectAdBlock().then();
    };
    AdBlockDetectorComponent.prototype.detectAdBlock = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var googleAdUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        googleAdUrl = '/fload.js';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, fetch(new Request(googleAdUrl)).catch(function (_) { return _this.adBlockerDetected = true; })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.adBlockerDetected = true;
                        return [3 /*break*/, 5];
                    case 4:
                        console.log("AdBlock Enabled: " + this.adBlockerDetected);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AdBlockDetectorComponent = __decorate([
        core_1.Component({
            selector: 'jhi-adblocker-detector',
            template: __webpack_require__(831),
            styles: [__webpack_require__(931)]
        })
    ], AdBlockDetectorComponent);
    return AdBlockDetectorComponent;
}());
exports.AdBlockDetectorComponent = AdBlockDetectorComponent;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var parameters_service_1 = __webpack_require__(25);
var AddressComponent = /** @class */ (function () {
    function AddressComponent(parametersService) {
        this.parametersService = parametersService;
    }
    AddressComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.parametersService
            .getParameters()
            .subscribe(function (parameters) { return (_this.countries = parameters.countries); });
    };
    AddressComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AddressComponent.prototype, "address", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AddressComponent.prototype, "isCreateAccountBtnClicked", void 0);
    AddressComponent = __decorate([
        core_1.Component({
            selector: 'jhi-address',
            template: __webpack_require__(832),
            styles: [__webpack_require__(932)],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        }),
        __metadata("design:paramtypes", [parameters_service_1.ParametersService])
    ], AddressComponent);
    return AddressComponent;
}());
exports.AddressComponent = AddressComponent;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var BreadcrumbComponent = /** @class */ (function () {
    function BreadcrumbComponent(router) {
        this.router = router;
        this.steps = [];
    }
    BreadcrumbComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeStepIndex = this.steps.findIndex(function (step) { return step.isActive; });
        this.subscription = this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                _this.steps.forEach(function (step, stepIndex) {
                    step.isActive = step.route === event.urlAfterRedirects;
                    _this.activeStepIndex = step.isActive ? stepIndex : _this.activeStepIndex;
                });
            }
        });
    };
    BreadcrumbComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], BreadcrumbComponent.prototype, "steps", void 0);
    BreadcrumbComponent = __decorate([
        core_1.Component({
            selector: 'jhi-breadcrumb',
            template: __webpack_require__(833),
            styles: [__webpack_require__(933)]
        }),
        __metadata("design:paramtypes", [router_1.Router])
    ], BreadcrumbComponent);
    return BreadcrumbComponent;
}());
exports.BreadcrumbComponent = BreadcrumbComponent;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var operators_1 = __webpack_require__(7);
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var captcha_service_1 = __webpack_require__(69);
var router_1 = __webpack_require__(6);
var CAPTCHA_LENGTH = 5;
var CAPTCHA_MAX_RETRY_EXCEEDED_ERROR_CODE = '1041';
var CaptchaValidatorDirective = /** @class */ (function () {
    function CaptchaValidatorDirective(captchaService, router) {
        this.captchaService = captchaService;
        this.router = router;
    }
    CaptchaValidatorDirective_1 = CaptchaValidatorDirective;
    CaptchaValidatorDirective.prototype.validate = function (c) {
        var _this = this;
        if (!c.value) {
            return rxjs_1.of(null);
        }
        if (c.value.length !== CAPTCHA_LENGTH) {
            return rxjs_1.of({ 'invalid-captcha': true });
        }
        return rxjs_1.of(c.value).pipe(operators_1.switchMap(function (captcha) { return _this.captchaService.isValid(captcha, _this.email || '').pipe(operators_1.map(function (isValid) { return isValid === 'true' ? null : { 'invalid-captcha': true }; }), operators_1.catchError(function (err) {
            if (err.status === 400 && err.code === CAPTCHA_MAX_RETRY_EXCEEDED_ERROR_CODE) {
                _this.router.navigate([_this.redirectAfterMaxRetryPath || '/']);
            }
            return rxjs_1.of({ 'invalid-captcha': true });
        })); }));
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], CaptchaValidatorDirective.prototype, "redirectAfterMaxRetryPath", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], CaptchaValidatorDirective.prototype, "email", void 0);
    CaptchaValidatorDirective = CaptchaValidatorDirective_1 = __decorate([
        core_1.Directive({
            selector: '[jhiCaptchaValidator][ngModel]',
            providers: [
                { provide: forms_1.NG_ASYNC_VALIDATORS, useExisting: core_1.forwardRef(function () { return CaptchaValidatorDirective_1; }), multi: true }
            ]
        }),
        __metadata("design:paramtypes", [captcha_service_1.CaptchaService, router_1.Router])
    ], CaptchaValidatorDirective);
    return CaptchaValidatorDirective;
    var CaptchaValidatorDirective_1;
}());
exports.CaptchaValidatorDirective = CaptchaValidatorDirective;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = __webpack_require__(12);
var core_1 = __webpack_require__(0);
var static_content_service_1 = __webpack_require__(102);
var ChangelogComponent = /** @class */ (function () {
    function ChangelogComponent(staticContentService) {
        this.staticContentService = staticContentService;
    }
    ChangelogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getChangeLog().subscribe(function (changelog) { return _this.changelog = changelog; });
    };
    ChangelogComponent.prototype.getChangeLog = function () {
        if (this.changelog) {
            return rxjs_1.of(this.changelog);
        }
        return this.staticContentService.getChangeLog(this.changelog);
    };
    ChangelogComponent = __decorate([
        core_1.Component({
            selector: 'jhi-changelog',
            template: __webpack_require__(835),
            styles: [__webpack_require__(935)]
        }),
        __metadata("design:paramtypes", [static_content_service_1.StaticContentService])
    ], ChangelogComponent);
    return ChangelogComponent;
}());
exports.ChangelogComponent = ChangelogComponent;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var cgu_service_1 = __webpack_require__(199);
var CguComponent = /** @class */ (function () {
    function CguComponent(cguService) {
        this.cguService = cguService;
    }
    CguComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.cguService.getCgu(this.cguTypeEnum)
            .subscribe(function (cguText) { return _this.cguText = cguText; });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], CguComponent.prototype, "cguTypeEnum", void 0);
    CguComponent = __decorate([
        core_1.Component({
            selector: 'jhi-cgu',
            template: __webpack_require__(836),
            styles: [__webpack_require__(936)]
        }),
        __metadata("design:paramtypes", [cgu_service_1.CguService])
    ], CguComponent);
    return CguComponent;
}());
exports.CguComponent = CguComponent;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var ContactComponent = /** @class */ (function () {
    function ContactComponent() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ContactComponent.prototype, "contact", void 0);
    ContactComponent = __decorate([
        core_1.Component({
            selector: 'jhi-contact',
            template: __webpack_require__(837),
            styles: [__webpack_require__(937)],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        }),
        __metadata("design:paramtypes", [])
    ], ContactComponent);
    return ContactComponent;
}());
exports.ContactComponent = ContactComponent;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var requete_1 = __webpack_require__(17);
var FicheType;
(function (FicheType) {
    FicheType["default"] = "default-list";
    FicheType["resultList"] = "result-list";
    FicheType["addedList"] = "added-list";
})(FicheType = exports.FicheType || (exports.FicheType = {}));
var FicheActeurComponent = /** @class */ (function () {
    function FicheActeurComponent(elementRef) {
        this.elementRef = elementRef;
        this.isOnClickUsed = false;
        this.FicheTypeEnum = FicheType;
        this.onClick = new core_1.EventEmitter();
        this.onMoveToPrincipal = new core_1.EventEmitter();
        var elt = this.elementRef.nativeElement;
        this.type = elt.getAttribute(FicheType.resultList) != null ? FicheType.resultList
            : elt.getAttribute(FicheType.addedList) != null ? FicheType.addedList : FicheType.default;
    }
    FicheActeurComponent.prototype.onClickIcon = function () {
        this.onClick.emit();
    };
    FicheActeurComponent.prototype.onClickToPrincipalButton = function () {
        this.onMoveToPrincipal.emit();
    };
    FicheActeurComponent.prototype.ngOnInit = function () {
        this.isOnClickUsed = this.onClick.observers.length > 0;
        this.addr1Line = this.acteur.address.adresse1;
        this.addr2Line = this.acteur.address.codePostal + "&nbsp;" + this.acteur.address.ville + ", " + this.acteur.address.pays;
        if (this.acteur.contact) {
            var phoneSeparator = this.acteur.contact.numeroPortable && this.acteur.contact.numeroFixe ? '&nbsp;- ' : '';
            this.phoneLine = "" + (this.acteur.contact.numeroPortable || '') + phoneSeparator + (this.acteur.contact.numeroFixe || '');
        }
        this.setTextForTooltip();
    };
    FicheActeurComponent.prototype.setTextForTooltip = function () {
        switch (this.type) {
            case FicheType.resultList:
                this.tooltip = 'Ajouter ce requérant';
                break;
            case FicheType.addedList:
                this.tooltip = 'Supprimer définitivement ce requérant';
                break;
            default:
                this.tooltip = 'Modifier mes informations personnelles';
                break;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", requete_1.PartieDepot)
    ], FicheActeurComponent.prototype, "acteur", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FicheActeurComponent.prototype, "isPrincipal", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], FicheActeurComponent.prototype, "onClick", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], FicheActeurComponent.prototype, "onMoveToPrincipal", void 0);
    FicheActeurComponent = __decorate([
        core_1.Component({
            selector: 'jhi-fiche-acteur',
            template: __webpack_require__(839),
            styles: [__webpack_require__(939)]
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], FicheActeurComponent);
    return FicheActeurComponent;
}());
exports.FicheActeurComponent = FicheActeurComponent;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(6);
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent(router) {
        this.router = router;
        this.isOnClickUsed = false;
        this.onClick = new core_1.EventEmitter();
    }
    ButtonComponent.prototype.ngOnInit = function () {
        this.isOnClickUsed = this.onClick.observers.length > 0 || this.buttonLink !== undefined;
    };
    ButtonComponent.prototype.onClickButton = function (event) {
        if (this.buttonLink) {
            this.router.navigate([this.buttonLink]);
        }
        else {
            this.onClick.emit(event);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ButtonComponent.prototype, "buttonLink", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ButtonComponent.prototype, "icon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "isLoading", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], ButtonComponent.prototype, "isDisabled", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], ButtonComponent.prototype, "onClick", void 0);
    ButtonComponent = __decorate([
        core_1.Component({
            selector: 'jhi-button',
            template: __webpack_require__(841),
            styles: [__webpack_require__(941)]
        }),
        __metadata("design:paramtypes", [router_1.Router])
    ], ButtonComponent);
    return ButtonComponent;
}());
exports.ButtonComponent = ButtonComponent;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var NextButtonComponent = /** @class */ (function () {
    function NextButtonComponent() {
    }
    NextButtonComponent.prototype.onClickButton = function () {
        var _this = this;
        this.disableButton();
        var observable = this.clickHandler();
        if (observable) {
            observable.subscribe(function () { return _this.enableButton(); }, function () { return _this.enableButton(); });
        }
        else {
            this.enableButton();
        }
    };
    NextButtonComponent.prototype.disableButton = function () {
        this.isDisabled = true;
        this.isLoading = true;
    };
    NextButtonComponent.prototype.enableButton = function () {
        this.isDisabled = false;
        this.isLoading = false;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], NextButtonComponent.prototype, "clickHandler", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], NextButtonComponent.prototype, "label", void 0);
    NextButtonComponent = __decorate([
        core_1.Component({
            selector: 'jhi-next-button',
            template: __webpack_require__(842)
        }),
        __metadata("design:paramtypes", [])
    ], NextButtonComponent);
    return NextButtonComponent;
}());
exports.NextButtonComponent = NextButtonComponent;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var PreviousButtonComponent = /** @class */ (function () {
    function PreviousButtonComponent() {
    }
    PreviousButtonComponent.prototype.onClickButton = function () {
        var _this = this;
        this.disableButton();
        var observable = this.clickHandler();
        if (observable) {
            observable.subscribe(function () { return _this.enableButton(); }, function () { return _this.enableButton(); });
        }
        else {
            this.enableButton();
        }
    };
    PreviousButtonComponent.prototype.disableButton = function () {
        this.isDisabled = true;
        this.isLoading = true;
    };
    PreviousButtonComponent.prototype.enableButton = function () {
        this.isDisabled = false;
        this.isLoading = false;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], PreviousButtonComponent.prototype, "clickHandler", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PreviousButtonComponent.prototype, "label", void 0);
    PreviousButtonComponent = __decorate([
        core_1.Component({
            selector: 'jhi-previous-button',
            template: __webpack_require__(843),
            styles: [__webpack_require__(942)]
        }),
        __metadata("design:paramtypes", [])
    ], PreviousButtonComponent);
    return PreviousButtonComponent;
}());
exports.PreviousButtonComponent = PreviousButtonComponent;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var SaveDraftRequeteButtonComponent = /** @class */ (function () {
    function SaveDraftRequeteButtonComponent() {
    }
    SaveDraftRequeteButtonComponent.prototype.onClickButton = function () {
        var _this = this;
        this.disableButton();
        var observable = this.clickHandler();
        if (observable) {
            observable.subscribe(function () { return _this.enableButton(); }, function () { return _this.enableButton(); });
        }
        else {
            this.enableButton();
        }
    };
    SaveDraftRequeteButtonComponent.prototype.disableButton = function () {
        this.isDisabled = true;
        this.isLoading = true;
    };
    SaveDraftRequeteButtonComponent.prototype.enableButton = function () {
        this.isDisabled = false;
        this.isLoading = false;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], SaveDraftRequeteButtonComponent.prototype, "isDisabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Function)
    ], SaveDraftRequeteButtonComponent.prototype, "clickHandler", void 0);
    SaveDraftRequeteButtonComponent = __decorate([
        core_1.Component({
            selector: 'jhi-save-draft-requete-button',
            template: __webpack_require__(844)
        }),
        __metadata("design:paramtypes", [])
    ], SaveDraftRequeteButtonComponent);
    return SaveDraftRequeteButtonComponent;
}());
exports.SaveDraftRequeteButtonComponent = SaveDraftRequeteButtonComponent;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(5);
var CheckBoxComponent = /** @class */ (function (_super) {
    __extends(CheckBoxComponent, _super);
    function CheckBoxComponent(injector) {
        return _super.call(this, injector) || this;
    }
    CheckBoxComponent_1 = CheckBoxComponent;
    CheckBoxComponent.prototype.modelValueChanged = function (value) {
        this.value = value;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], CheckBoxComponent.prototype, "disabled", void 0);
    CheckBoxComponent = CheckBoxComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-checkbox',
            template: __webpack_require__(845),
            styles: [__webpack_require__(943)],
            providers: [{
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: CheckBoxComponent_1,
                    multi: true
                }]
        }),
        __metadata("design:paramtypes", [core_1.Injector])
    ], CheckBoxComponent);
    return CheckBoxComponent;
    var CheckBoxComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.CheckBoxComponent = CheckBoxComponent;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var message_component_1 = __webpack_require__(189);
var messages_component_1 = __webpack_require__(190);
var util_1 = __webpack_require__(47);
var ValidationDirective = /** @class */ (function () {
    function ValidationDirective(form, messagesComponent) {
        this.form = form;
        this.messagesComponent = messagesComponent;
    }
    ValidationDirective.prototype.ngAfterContentInit = function () {
        var _this = this;
        // reset
        this.messages.changes.subscribe(function (_) { return _this.messagesComponent.isInvalid = false; });
    };
    ValidationDirective.prototype.ngDoCheck = function () {
        var _this = this;
        if (this.messages) {
            var controls = this.messages.map(function (message) { return message.controlKey; });
            if (controls.some(function (controlKey) { return !util_1.isNullOrUndefined(_this.form.controls[controlKey]); })) {
                this.displayMessages();
            }
        }
    };
    ValidationDirective.prototype.displayMessages = function () {
        var _this = this;
        this.messagesComponent.isInvalid = false;
        this.messages.forEach(function (messageComponent) {
            messageComponent.isInvalid = false;
            if (_this.form.controls[messageComponent.controlKey]) {
                var errorKeys = _this.getErrorKeys(messageComponent.controlKey);
                messageComponent.isInvalid = _this.isTouched(messageComponent.controlKey) &&
                    errorKeys.some(function (key) { return key === messageComponent.error; });
                _this.messagesComponent.isInvalid = _this.messagesComponent.isInvalid || messageComponent.isInvalid;
                if (_this.form.submitted && _this.messagesComponent.isInvalid) {
                    _this.form.controls[messageComponent.controlKey].markAsTouched();
                }
            }
        });
    };
    ValidationDirective.prototype.isTouched = function (controlKey) {
        return this.form.controls[controlKey].touched || this.form.controls[controlKey].dirty;
    };
    ValidationDirective.prototype.getErrorKeys = function (controlKey) {
        return Object.keys(this.form.controls[controlKey].errors || {});
    };
    __decorate([
        core_1.ContentChildren(message_component_1.MessageComponent),
        __metadata("design:type", core_1.QueryList)
    ], ValidationDirective.prototype, "messages", void 0);
    ValidationDirective = __decorate([
        core_1.Directive({
            // tslint:disable-next-line:directive-selector
            selector: 'jhi-messages'
        }),
        __param(0, core_1.Optional()), __param(1, core_1.Self()), __param(1, core_1.Optional()),
        __metadata("design:paramtypes", [forms_1.NgForm, messages_component_1.MessagesComponent])
    ], ValidationDirective);
    return ValidationDirective;
}());
exports.ValidationDirective = ValidationDirective;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var FieldComponent = /** @class */ (function () {
    function FieldComponent() {
    }
    FieldComponent.prototype.ngOnInit = function () {
    };
    FieldComponent = __decorate([
        core_1.Component({
            selector: 'jhi-field',
            template: '<ng-content></ng-content>',
            styles: [__webpack_require__(944)]
        }),
        __metadata("design:paramtypes", [])
    ], FieldComponent);
    return FieldComponent;
}());
exports.FieldComponent = FieldComponent;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_button_component_1 = __webpack_require__(487);
var previous_button_component_1 = __webpack_require__(488);
var core_1 = __webpack_require__(0);
var input_component_1 = __webpack_require__(188);
var validation_directive_1 = __webpack_require__(491);
var postcode_validator_1 = __webpack_require__(499);
var email_validator_1 = __webpack_require__(497);
var password_validator_1 = __webpack_require__(498);
var message_component_1 = __webpack_require__(189);
var messages_component_1 = __webpack_require__(190);
var common_1 = __webpack_require__(15);
var forms_1 = __webpack_require__(5);
var birthdate_validator_1 = __webpack_require__(496);
var field_component_1 = __webpack_require__(492);
var option_component_1 = __webpack_require__(97);
var radio_box_component_1 = __webpack_require__(494);
var select_component_1 = __webpack_require__(495);
var checkbox_component_1 = __webpack_require__(490);
var whitespace_validator_1 = __webpack_require__(500);
var button_component_1 = __webpack_require__(486);
var save_draft_requete_button_component_1 = __webpack_require__(489);
var TelerecoursFormModule = /** @class */ (function () {
    function TelerecoursFormModule() {
    }
    TelerecoursFormModule = __decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule
            ],
            declarations: [
                validation_directive_1.ValidationDirective,
                postcode_validator_1.PostCodeValidatorDirective,
                email_validator_1.EmailValidatorDirective,
                password_validator_1.PasswordValidatorDirective,
                birthdate_validator_1.BirthDateValidatorDirective,
                whitespace_validator_1.WhiteSpaceValidatorDirective,
                message_component_1.MessageComponent,
                messages_component_1.MessagesComponent,
                input_component_1.InputComponent,
                option_component_1.OptionComponent,
                radio_box_component_1.RadioBoxComponent,
                select_component_1.SelectComponent,
                checkbox_component_1.CheckBoxComponent,
                field_component_1.FieldComponent,
                button_component_1.ButtonComponent,
                previous_button_component_1.PreviousButtonComponent,
                next_button_component_1.NextButtonComponent,
                save_draft_requete_button_component_1.SaveDraftRequeteButtonComponent
            ],
            exports: [
                validation_directive_1.ValidationDirective,
                postcode_validator_1.PostCodeValidatorDirective,
                email_validator_1.EmailValidatorDirective,
                password_validator_1.PasswordValidatorDirective,
                birthdate_validator_1.BirthDateValidatorDirective,
                whitespace_validator_1.WhiteSpaceValidatorDirective,
                message_component_1.MessageComponent,
                messages_component_1.MessagesComponent,
                input_component_1.InputComponent,
                option_component_1.OptionComponent,
                radio_box_component_1.RadioBoxComponent,
                select_component_1.SelectComponent,
                checkbox_component_1.CheckBoxComponent,
                field_component_1.FieldComponent,
                button_component_1.ButtonComponent,
                previous_button_component_1.PreviousButtonComponent,
                next_button_component_1.NextButtonComponent,
                save_draft_requete_button_component_1.SaveDraftRequeteButtonComponent
            ]
        })
    ], TelerecoursFormModule);
    return TelerecoursFormModule;
}());
exports.TelerecoursFormModule = TelerecoursFormModule;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(5);
var option_component_1 = __webpack_require__(97);
var RadioBoxComponent = /** @class */ (function (_super) {
    __extends(RadioBoxComponent, _super);
    function RadioBoxComponent(injector) {
        return _super.call(this, injector) || this;
    }
    RadioBoxComponent_1 = RadioBoxComponent;
    RadioBoxComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        _super.prototype.ngAfterContentInit.call(this);
        this.options = this.components.map(function (component) { return ({
            label: component.label,
            value: component.value,
            selected: _this.isEquals(component.value, _this.value),
            disabled: component.disabled
        }); });
    };
    RadioBoxComponent.prototype.modelValueChanged = function (value) {
        var _this = this;
        this.value = value;
        this.options.forEach(function (option) { return option.selected = _this.isEquals(_this.value, option.value); });
    };
    __decorate([
        core_1.ContentChildren(option_component_1.OptionComponent),
        __metadata("design:type", core_1.QueryList)
    ], RadioBoxComponent.prototype, "components", void 0);
    RadioBoxComponent = RadioBoxComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-radio-box',
            template: __webpack_require__(847),
            styles: [__webpack_require__(949)],
            providers: [{
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: RadioBoxComponent_1,
                    multi: true
                }]
        }),
        __metadata("design:paramtypes", [core_1.Injector])
    ], RadioBoxComponent);
    return RadioBoxComponent;
    var RadioBoxComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.RadioBoxComponent = RadioBoxComponent;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var option_component_1 = __webpack_require__(97);
var base_control_value_accessor_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(5);
/**
 * Usage:
 *
 * <jhi-select name="civiliteSelect"
 *  [(ngModel)]="account.civilite" [label]="'Civilité'" [hiddenOptionLabel]="'Choisir une civilité'" required>
 *     <jhi-option value="Monsieur">Monsieur</jhi-option>
 *     <jhi-option value="Madame">Madame</jhi-option>
 *  </jhi-select>
 */
var SelectComponent = /** @class */ (function (_super) {
    __extends(SelectComponent, _super);
    function SelectComponent(injector) {
        return _super.call(this, injector) || this;
    }
    SelectComponent_1 = SelectComponent;
    SelectComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        _super.prototype.ngAfterContentInit.call(this);
        this.initOptions(this.components);
        this.subscription = this.components.changes.subscribe(function (components) {
            _this.initOptions(components);
        });
    };
    SelectComponent.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        _super.prototype.ngOnDestroy.call(this);
    };
    SelectComponent.prototype.initOptions = function (components) {
        var _this = this;
        this.options = components.map(function (component) { return ({
            label: component.label,
            value: component.value,
            selected: _this.isEquals(component.value, _this.value),
            disabled: component.disabled
        }); });
    };
    SelectComponent.prototype.modelValueChanged = function (value) {
        var _this = this;
        this.value = value;
        this.options.forEach(function (option) { return option.selected = _this.isEquals(value, _this.value); });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectComponent.prototype, "label", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectComponent.prototype, "hiddenOptionLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SelectComponent.prototype, "id", void 0);
    __decorate([
        core_1.ContentChildren(option_component_1.OptionComponent),
        __metadata("design:type", core_1.QueryList)
    ], SelectComponent.prototype, "components", void 0);
    SelectComponent = SelectComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-select',
            template: __webpack_require__(848),
            styles: [__webpack_require__(950)],
            providers: [{
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: SelectComponent_1,
                    multi: true
                }]
        }),
        __metadata("design:paramtypes", [core_1.Injector])
    ], SelectComponent);
    return SelectComponent;
    var SelectComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.SelectComponent = SelectComponent;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var common_1 = __webpack_require__(15);
var BIRTHDAY_PATTERN = /^(\d{2})\/(\d{2})\/((19\d{2})|(2\d{3}))$/;
var BirthDateValidatorDirective = /** @class */ (function () {
    function BirthDateValidatorDirective(datePipe) {
        this.datePipe = datePipe;
    }
    BirthDateValidatorDirective_1 = BirthDateValidatorDirective;
    BirthDateValidatorDirective.prototype.validate = function (c) {
        if (!c.value) {
            return null;
        }
        try {
            if (!this.datePipe.transform(c.value, 'dd/MM/yyyy').match(BIRTHDAY_PATTERN)) {
                return { 'invalid-birth-date': true };
            }
            if (this.isGreaterThanToday(c.value)) {
                return { 'birth-date-gt-currentday': true };
            }
        }
        catch (e) {
            return { 'invalid-birth-date': true };
        }
        return null;
    };
    BirthDateValidatorDirective.prototype.isGreaterThanToday = function (birthday) {
        var currentDate = new Date();
        var date = new Date(birthday);
        return date > currentDate;
    };
    BirthDateValidatorDirective = BirthDateValidatorDirective_1 = __decorate([
        core_1.Directive({
            selector: '[jhiBirthDate][ngModel]',
            providers: [
                { provide: forms_1.NG_VALIDATORS, useExisting: BirthDateValidatorDirective_1, multi: true }
            ]
        }),
        __metadata("design:paramtypes", [common_1.DatePipe])
    ], BirthDateValidatorDirective);
    return BirthDateValidatorDirective;
    var BirthDateValidatorDirective_1;
}());
exports.BirthDateValidatorDirective = BirthDateValidatorDirective;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
// tslint:disable-next-line:max-line-length
var EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var EmailValidatorDirective = /** @class */ (function () {
    function EmailValidatorDirective() {
    }
    EmailValidatorDirective_1 = EmailValidatorDirective;
    EmailValidatorDirective.prototype.validate = function (c) {
        if (!c.value) {
            return null;
        }
        if (this.matchTo && this.matchTo !== c.value) {
            return { 'invalid-confirmaton-email': true };
        }
        if (!c.value.match(EMAIL_PATTERN)) {
            return { 'invalid-email': true };
        }
        return null;
    };
    EmailValidatorDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onChange = fn;
    };
    EmailValidatorDirective.prototype.ngOnChanges = function (changes) {
        if ('matchTo' in changes && this.onChange) {
            this.onChange();
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EmailValidatorDirective.prototype, "matchTo", void 0);
    EmailValidatorDirective = EmailValidatorDirective_1 = __decorate([
        core_1.Directive({
            selector: '[jhiEmail][ngModel]',
            providers: [
                { provide: forms_1.NG_VALIDATORS, useExisting: EmailValidatorDirective_1, multi: true }
            ]
        })
    ], EmailValidatorDirective);
    return EmailValidatorDirective;
    var EmailValidatorDirective_1;
}());
exports.EmailValidatorDirective = EmailValidatorDirective;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var password_validation_error_type_1 = __webpack_require__(145);
var PasswordValidatorDirective = /** @class */ (function () {
    function PasswordValidatorDirective() {
    }
    PasswordValidatorDirective_1 = PasswordValidatorDirective;
    PasswordValidatorDirective.prototype.validate = function (c) {
        if (!c.value) {
            return null;
        }
        var result = {};
        if (this.matchTo && this.matchTo !== c.value) {
            return { 'not-matched': true };
        }
        if (!this.isValidMinLength(c.value)) {
            result[password_validation_error_type_1.ValidationErrorType.MIN_LENGTH] = true;
        }
        if (!this.includeLowerCase(c.value)) {
            result[password_validation_error_type_1.ValidationErrorType.LOWERCASE] = true;
        }
        if (!this.includeUperCase(c.value)) {
            result[password_validation_error_type_1.ValidationErrorType.UPPERCASE] = true;
        }
        if (!this.includeNumber(c.value)) {
            result[password_validation_error_type_1.ValidationErrorType.NUMBER] = true;
        }
        if (!this.includeSpecial(c.value)) {
            result[password_validation_error_type_1.ValidationErrorType.SPECIAL] = true;
        }
        return Object.keys(result).length > 0 ? result : null;
    };
    PasswordValidatorDirective.prototype.isValidMinLength = function (password) {
        return password.length >= 12;
    };
    PasswordValidatorDirective.prototype.includeLowerCase = function (password) {
        return /[a-z]+/.test(password);
    };
    PasswordValidatorDirective.prototype.includeUperCase = function (password) {
        return /[A-Z]+/.test(password);
    };
    PasswordValidatorDirective.prototype.includeNumber = function (password) {
        return /[0-9]+/.test(password);
    };
    PasswordValidatorDirective.prototype.includeSpecial = function (password) {
        return /[!@#\$%\^\&*\)\(+=éèà²'\'|\`¨£¤µ/:;,?<>ç\[\]\{\}°~=\*€._§\-ù]/.test(password);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PasswordValidatorDirective.prototype, "matchTo", void 0);
    PasswordValidatorDirective = PasswordValidatorDirective_1 = __decorate([
        core_1.Directive({
            selector: '[jhiPassword][ngModel]',
            providers: [
                {
                    provide: forms_1.NG_VALIDATORS,
                    useExisting: PasswordValidatorDirective_1,
                    multi: true
                }
            ]
        })
    ], PasswordValidatorDirective);
    return PasswordValidatorDirective;
    var PasswordValidatorDirective_1;
}());
exports.PasswordValidatorDirective = PasswordValidatorDirective;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var POSTCODE_PATTERN = /^((\d{5})|(\d{6}))$/;
var PostCodeValidatorDirective = /** @class */ (function () {
    function PostCodeValidatorDirective() {
    }
    PostCodeValidatorDirective_1 = PostCodeValidatorDirective;
    PostCodeValidatorDirective.prototype.validate = function (c) {
        if (!c.value) {
            return null;
        }
        if (!c.value.match(POSTCODE_PATTERN)) {
            return { 'invalid-postcode': true };
        }
        return null;
    };
    PostCodeValidatorDirective = PostCodeValidatorDirective_1 = __decorate([
        core_1.Directive({
            selector: '[jhiPostcode][ngModel]',
            providers: [
                { provide: forms_1.NG_VALIDATORS, useExisting: PostCodeValidatorDirective_1, multi: true }
            ]
        })
    ], PostCodeValidatorDirective);
    return PostCodeValidatorDirective;
    var PostCodeValidatorDirective_1;
}());
exports.PostCodeValidatorDirective = PostCodeValidatorDirective;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var NO_WHITESPACE_PATTERN = /^\s*$/;
var WhiteSpaceValidatorDirective = /** @class */ (function () {
    function WhiteSpaceValidatorDirective() {
    }
    WhiteSpaceValidatorDirective_1 = WhiteSpaceValidatorDirective;
    WhiteSpaceValidatorDirective.prototype.validate = function (c) {
        if (c.value && NO_WHITESPACE_PATTERN.test(c.value)) {
            return { 'invalid-whitespace': true };
        }
        return null;
    };
    WhiteSpaceValidatorDirective = WhiteSpaceValidatorDirective_1 = __decorate([
        core_1.Directive({
            selector: '[jhiWhitespace][ngModel]',
            providers: [
                { provide: forms_1.NG_VALIDATORS, useExisting: WhiteSpaceValidatorDirective_1, multi: true }
            ]
        }),
        __metadata("design:paramtypes", [])
    ], WhiteSpaceValidatorDirective);
    return WhiteSpaceValidatorDirective;
    var WhiteSpaceValidatorDirective_1;
}());
exports.WhiteSpaceValidatorDirective = WhiteSpaceValidatorDirective;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var FranceConnectButtonComponent = /** @class */ (function () {
    function FranceConnectButtonComponent() {
    }
    FranceConnectButtonComponent.prototype.openFranceConnectPopup = function () {
        window.open('/franceconnect/redirect', '_parent', 'resizable,scrollbars,status');
    };
    FranceConnectButtonComponent = __decorate([
        core_1.Component({
            selector: 'jhi-franceconnect-button',
            template: __webpack_require__(849),
            styles: [__webpack_require__(951)]
        })
    ], FranceConnectButtonComponent);
    return FranceConnectButtonComponent;
}());
exports.FranceConnectButtonComponent = FranceConnectButtonComponent;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var account_model_1 = __webpack_require__(53);
var forms_1 = __webpack_require__(5);
var IdentiteOrganismeComponent = /** @class */ (function () {
    function IdentiteOrganismeComponent() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", account_model_1.EditableAccount)
    ], IdentiteOrganismeComponent.prototype, "identite", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IdentiteOrganismeComponent.prototype, "isCreateAccountBtnClicked", void 0);
    IdentiteOrganismeComponent = __decorate([
        core_1.Component({
            selector: 'jhi-identite-organisme',
            template: __webpack_require__(850),
            styles: [__webpack_require__(952)],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        })
    ], IdentiteOrganismeComponent);
    return IdentiteOrganismeComponent;
}());
exports.IdentiteOrganismeComponent = IdentiteOrganismeComponent;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var base_control_value_accessor_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(5);
var MAX_NAME_COMPANY_LENGTH = 32;
var NomEntrepriseComponent = /** @class */ (function (_super) {
    __extends(NomEntrepriseComponent, _super);
    function NomEntrepriseComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.showLengthWarningForCompanyName = false;
        _this.maxCompanyNameLength = MAX_NAME_COMPANY_LENGTH;
        _this.actualNameCompanyLength = 0;
        return _this;
    }
    NomEntrepriseComponent_1 = NomEntrepriseComponent;
    NomEntrepriseComponent.prototype.modelValueChanged = function (nomEntreprise) {
        this.nomEntreprise = nomEntreprise;
        this.checkLengthForCompanyName(this.nomEntreprise);
    };
    NomEntrepriseComponent.prototype.checkLengthForCompanyName = function (value) {
        if (value) {
            this.actualNameCompanyLength = value.length;
            this.showLengthWarningForCompanyName =
                value.length > this.maxCompanyNameLength;
        }
    };
    NomEntrepriseComponent = NomEntrepriseComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-nom-entreprise',
            template: __webpack_require__(851),
            styles: [__webpack_require__(953)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: NomEntrepriseComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector])
    ], NomEntrepriseComponent);
    return NomEntrepriseComponent;
    var NomEntrepriseComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.NomEntrepriseComponent = NomEntrepriseComponent;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var parameters_service_1 = __webpack_require__(25);
var base_control_value_accessor_1 = __webpack_require__(20);
var forms_1 = __webpack_require__(5);
var CiviliteComponent = /** @class */ (function (_super) {
    __extends(CiviliteComponent, _super);
    function CiviliteComponent(injector, parametersService) {
        var _this = _super.call(this, injector) || this;
        _this.parametersService = parametersService;
        _this.civilities = [];
        _this._AllCivilities = [];
        return _this;
    }
    CiviliteComponent_1 = CiviliteComponent;
    CiviliteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.parametersService
            .getParameters()
            .subscribe(function (parameters) {
            _this._AllCivilities = parameters.civilities;
            _this.updateDispalyedCivilities(_this.isForMoraleIdentity);
        });
    };
    CiviliteComponent.prototype.ngOnChanges = function (changes) {
        if (changes.isForMoraleIdentity) {
            this.updateDispalyedCivilities(changes.isForMoraleIdentity.currentValue);
        }
    };
    CiviliteComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        _super.prototype.ngOnDestroy.call(this);
    };
    CiviliteComponent.prototype.modelValueChanged = function (value) {
        this.value = value;
    };
    CiviliteComponent.prototype.updateDispalyedCivilities = function (isForMoraleIdentity) {
        this.civilities = this._AllCivilities.filter(function (civility) { return isForMoraleIdentity || ['Monsieur', 'Madame'].some(function (c) { return c === civility; }); });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], CiviliteComponent.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], CiviliteComponent.prototype, "isForMoraleIdentity", void 0);
    CiviliteComponent = CiviliteComponent_1 = __decorate([
        core_1.Component({
            selector: 'jhi-civilite',
            template: __webpack_require__(852),
            styles: [__webpack_require__(954)],
            providers: [
                {
                    provide: forms_1.NG_VALUE_ACCESSOR,
                    useExisting: CiviliteComponent_1,
                    multi: true
                }
            ]
        }),
        __metadata("design:paramtypes", [core_1.Injector, parameters_service_1.ParametersService])
    ], CiviliteComponent);
    return CiviliteComponent;
    var CiviliteComponent_1;
}(base_control_value_accessor_1.BaseControlValueAccessor));
exports.CiviliteComponent = CiviliteComponent;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var account_model_1 = __webpack_require__(53);
var IdentitePersonneComponent = /** @class */ (function () {
    function IdentitePersonneComponent() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", account_model_1.EditableAccount)
    ], IdentitePersonneComponent.prototype, "identite", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IdentitePersonneComponent.prototype, "isFCUser", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IdentitePersonneComponent.prototype, "isRepresentant", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], IdentitePersonneComponent.prototype, "isCreateAccountBtnClicked", void 0);
    IdentitePersonneComponent = __decorate([
        core_1.Component({
            selector: 'jhi-identite-personne',
            template: __webpack_require__(853),
            styles: [__webpack_require__(955)],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        })
    ], IdentitePersonneComponent);
    return IdentitePersonneComponent;
}());
exports.IdentitePersonneComponent = IdentitePersonneComponent;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var JumbotronComponent = /** @class */ (function () {
    function JumbotronComponent() {
    }
    JumbotronComponent = __decorate([
        core_1.Component({
            selector: 'jhi-jumbotron',
            template: __webpack_require__(854),
            styles: [__webpack_require__(956)]
        })
    ], JumbotronComponent);
    return JumbotronComponent;
}());
exports.JumbotronComponent = JumbotronComponent;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var util_1 = __webpack_require__(28);
var piece_jointe_1 = __webpack_require__(38);
var PiecePostalesComponent = /** @class */ (function () {
    function PiecePostalesComponent() {
    }
    PiecePostalesComponent.prototype.onPiecePostaleAdd = function () {
        if (!util_1.isEmpty(this.adderValue)) {
            this.pieces.push(new piece_jointe_1.PiecePostale(this.adderValue));
            this.adderValue = '';
        }
    };
    PiecePostalesComponent.prototype.onPiecePostaleDelete = function (index) {
        this.pieces.splice(index, 1);
    };
    PiecePostalesComponent.prototype.deletePieceWithEmptyLibelle = function (index) {
        if (util_1.isEmpty(this.pieces[index].libelle)) {
            this.onPiecePostaleDelete(index);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], PiecePostalesComponent.prototype, "pieces", void 0);
    PiecePostalesComponent = __decorate([
        core_1.Component({
            selector: 'jhi-piece-postales',
            template: __webpack_require__(855),
            styles: [__webpack_require__(957)],
            viewProviders: [{ provide: forms_1.ControlContainer, useExisting: forms_1.NgForm }]
        })
    ], PiecePostalesComponent);
    return PiecePostalesComponent;
}());
exports.PiecePostalesComponent = PiecePostalesComponent;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var draft_depot_requete_service_1 = __webpack_require__(16);
var util_1 = __webpack_require__(28);
var error_constants_1 = __webpack_require__(60);
var PreviewPieceComponent = /** @class */ (function () {
    function PreviewPieceComponent(draftDepotRequeteService) {
        this.draftDepotRequeteService = draftDepotRequeteService;
        this.showLabel = false;
    }
    PreviewPieceComponent.prototype.ngOnInit = function () {
    };
    PreviewPieceComponent.prototype.visualiserPiece = function () {
        var _this = this;
        this.draftDepotRequeteService.downloadJustificatif(this.piece.fileApiId)
            .subscribe(function (blob) { return util_1.saveOrOpenRawFile(blob, _this.piece.libelle + ".pdf"); }, function (error) {
            if (error.errorType === error_constants_1.ErrorEnum.TR_FUNCTIONAL_ERROR) {
                _this.errorTrFonctionnel = true;
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], PreviewPieceComponent.prototype, "piece", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], PreviewPieceComponent.prototype, "showLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PreviewPieceComponent.prototype, "id", void 0);
    PreviewPieceComponent = __decorate([
        core_1.Component({
            selector: 'jhi-preview-piece',
            template: "\n    <div class=\"input-group\">\n    <ng-container *ngIf=\"showLabel\">\n        <input type=\"text\" class=\"form-control\" id=\"{{id}}\" readonly [value]=\"piece.libelle\">\n    </ng-container>\n    <ng-container *ngIf=\"!showLabel\">\n        <input type=\"text\" class=\"form-control\" readonly [value]=\"piece.fileName\">\n    </ng-container>\n    <button class=\"input-group-addon pointer no-border\" aria-label=\"visualiser la pi\u00E8ce\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\" (click)=\"visualiserPiece()\" title=\"visualiser la pi\u00E8ce\"></i>\n        <span class=\"sr-only\">Visualiser la pi\u00E8ce</span>\n    </button>\n    <jhi-message *ngIf=\"errorTrFonctionnel\">\n        <span>Nous rencontrons actuellement un probl\u00E8me technique qui ne permet pas l'acc\u00E8s \u00E0 ce document.\n            L'incident est en cours de r\u00E9solution. Nous vous invitons \u00E0 r\u00E9essayer dans 24h.</span>\n    </jhi-message>\n</div>\n    ",
            styles: [" .input-group-addon {\n        background: transparent;\n        border: 0;\n    }\n    .pointer {\n        cursor: pointer;\n    }\n    button.no-border {\n        border: none;\n    }\n    "]
        }),
        __metadata("design:paramtypes", [draft_depot_requete_service_1.DraftDepotRequeteService])
    ], PreviewPieceComponent);
    return PreviewPieceComponent;
}());
exports.PreviewPieceComponent = PreviewPieceComponent;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ProgressSpinnerComponent = /** @class */ (function () {
    function ProgressSpinnerComponent() {
    }
    ProgressSpinnerComponent.prototype.ngOnInit = function () {
    };
    ProgressSpinnerComponent = __decorate([
        core_1.Component({
            selector: 'jhi-progress-spinner',
            template: __webpack_require__(856),
            styles: [__webpack_require__(958)]
        }),
        __metadata("design:paramtypes", [])
    ], ProgressSpinnerComponent);
    return ProgressSpinnerComponent;
}());
exports.ProgressSpinnerComponent = ProgressSpinnerComponent;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var animations_1 = __webpack_require__(84);
exports.HELP_ANIMATIONS = [
    animations_1.trigger('fade', [
        animations_1.state('fadeIn', animations_1.style({
            display: 'block'
        })),
        animations_1.state('fadeOut', animations_1.style({
            display: 'none',
            height: 0,
            opacity: 0
        })),
        animations_1.transition('fadeIn => fadeOut', animations_1.animate('0.3s ease-in')),
        animations_1.transition('fadeOut => fadeIn', animations_1.animate('0.3s ease-in')),
    ]),
];


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var section_animations_1 = __webpack_require__(510);
var SectionComponent = /** @class */ (function () {
    function SectionComponent() {
    }
    SectionComponent.prototype.ngOnInit = function () {
    };
    SectionComponent.prototype.toggle = function () {
        this.state.isHelpOpen = !this.state.isHelpOpen;
    };
    __decorate([
        core_1.ContentChild('header'),
        __metadata("design:type", core_1.TemplateRef)
    ], SectionComponent.prototype, "headerRef", void 0);
    __decorate([
        core_1.ContentChild('help'),
        __metadata("design:type", core_1.TemplateRef)
    ], SectionComponent.prototype, "helpRef", void 0);
    __decorate([
        core_1.ContentChild('content'),
        __metadata("design:type", core_1.TemplateRef)
    ], SectionComponent.prototype, "contentRef", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SectionComponent.prototype, "state", void 0);
    SectionComponent = __decorate([
        core_1.Component({
            selector: 'jhi-section',
            template: __webpack_require__(857),
            styles: [__webpack_require__(959)],
            animations: __spread(section_animations_1.HELP_ANIMATIONS)
        }),
        __metadata("design:paramtypes", [])
    ], SectionComponent);
    return SectionComponent;
}());
exports.SectionComponent = SectionComponent;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var animations_1 = __webpack_require__(406);
var common_1 = __webpack_require__(15);
var section_component_1 = __webpack_require__(511);
var SectionModule = /** @class */ (function () {
    function SectionModule() {
    }
    SectionModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule, animations_1.BrowserAnimationsModule],
            declarations: [section_component_1.SectionComponent],
            exports: [section_component_1.SectionComponent]
        })
    ], SectionModule);
    return SectionModule;
}());
exports.SectionModule = SectionModule;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var trc_admin_config_service_1 = __webpack_require__(204);
var TRCAdminConfigComponent = /** @class */ (function () {
    function TRCAdminConfigComponent(configService) {
        this.configService = configService;
        this.code = 'message_bandeau';
    }
    TRCAdminConfigComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configService.getConfigByCode(this.code).subscribe(function (adminConfig) {
            _this.adminConfig = adminConfig;
        });
    };
    TRCAdminConfigComponent = __decorate([
        core_1.Component({
            selector: 'jhi-trc-admin-config',
            template: __webpack_require__(858),
            styles: [__webpack_require__(960)]
        }),
        __metadata("design:paramtypes", [trc_admin_config_service_1.TRCAdminConfigService])
    ], TRCAdminConfigComponent);
    return TRCAdminConfigComponent;
}());
exports.TRCAdminConfigComponent = TRCAdminConfigComponent;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ITEMS_PER_PAGE = 20;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var piece_jointe_1 = __webpack_require__(38);
var a11y_1 = __webpack_require__(44);
var A11yDragNDropDirective = /** @class */ (function () {
    function A11yDragNDropDirective(el, liveAnnouncer) {
        this.el = el;
        this.liveAnnouncer = liveAnnouncer;
        this.a11yMoveup = new core_1.EventEmitter();
        this.a11yMovedown = new core_1.EventEmitter();
        this.a11ySelect = new core_1.EventEmitter();
        this.a11yEscape = new core_1.EventEmitter();
    }
    Object.defineProperty(A11yDragNDropDirective.prototype, "selectedItem", {
        set: function (selectedItem) {
            this._selectedItem = selectedItem;
            if (this.isSelected(this.piece)) {
                this.el.nativeElement.classList.add('is-pressed');
            }
            else {
                this.el.nativeElement.classList.remove('is-pressed');
            }
        },
        enumerable: true,
        configurable: true
    });
    A11yDragNDropDirective.prototype.ngAfterViewInit = function () {
        this.el.nativeElement.setAttribute('aria-label', this.getFileName(this.piece));
    };
    A11yDragNDropDirective.prototype.getFileName = function (piece) {
        return piece && piece.fileModel &&
            piece.fileModel.fileItem ? piece.fileModel.fileItem.name : '';
    };
    A11yDragNDropDirective.prototype.onKeyDown = function (event) {
        switch (event.key) {
            case 'ArrowUp':
                this.onArrowUp();
                break;
            case 'ArrowDown':
                this.onArrowDown();
                break;
            case 'Space':
                this.onSelect();
                break;
            case ' ':
                this.onSelect();
                break;
            case 'Enter':
                this.onSelect();
                break;
            case 'Escape':
                this.onEscape();
        }
    };
    A11yDragNDropDirective.prototype.onArrowUp = function () {
        if (this.isSelected(this.piece)) {
            console.log('onArrowUp');
            this.a11yMoveup.emit({ 'i': this.index, 'piece': this.piece });
            this.liveAnnouncer.announce(this.getFileName(this.piece) + ' est deplacé vers le haut');
            event.preventDefault();
        }
    };
    A11yDragNDropDirective.prototype.onArrowDown = function () {
        if (this.isSelected(this.piece)) {
            console.log('onArrowDown');
            this.a11yMovedown.emit({ 'i': this.index, 'piece': this.piece });
            this.liveAnnouncer.announce(this.getFileName(this.piece) + ' est deplacé vers le bas');
            event.preventDefault();
        }
    };
    A11yDragNDropDirective.prototype.onSelect = function () {
        if (!this.isSelected(this.piece)) {
            this.a11ySelect.emit({ 'i': this.index, 'piece': this.piece });
            this.liveAnnouncer.announce(this.getFileName(this.piece) + ' est sélectionné');
            event.preventDefault();
        }
        else {
            this.onEscape();
        }
    };
    A11yDragNDropDirective.prototype.onEscape = function () {
        this.a11yEscape.emit({ 'i': this.index, 'piece': this.piece });
        this.liveAnnouncer.announce(this.getFileName(this.piece) + ' est désélectionné');
        event.preventDefault();
    };
    A11yDragNDropDirective.prototype.isSelected = function (piece) {
        return this._selectedItem === piece.fileModel.fileApiId;
    };
    // pour garder le focus quand l'element se deplace
    A11yDragNDropDirective.prototype.onKeyDownAll = function (event) {
        var selectedItemElem = document.getElementById(this._selectedItem);
        switch (event.key) {
            case 'ArrowUp':
                if (this._selectedItem) {
                    event.preventDefault();
                    if (selectedItemElem) {
                        selectedItemElem.focus();
                    }
                    console.log('Focus elem', this._selectedItem);
                }
                break;
            case 'Escape':
                event.preventDefault();
                this.liveAnnouncer.announce('annulé');
                if (selectedItemElem) {
                    selectedItemElem.blur();
                }
                console.log('Escape', selectedItemElem);
                this.a11yEscape.emit({ 'i': this.index, 'piece': this.piece });
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", piece_jointe_1.GenericPiece)
    ], A11yDragNDropDirective.prototype, "piece", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], A11yDragNDropDirective.prototype, "index", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], A11yDragNDropDirective.prototype, "selectedItem", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], A11yDragNDropDirective.prototype, "a11yMoveup", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], A11yDragNDropDirective.prototype, "a11yMovedown", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], A11yDragNDropDirective.prototype, "a11ySelect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], A11yDragNDropDirective.prototype, "a11yEscape", void 0);
    __decorate([
        core_1.HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], A11yDragNDropDirective.prototype, "onKeyDown", null);
    __decorate([
        core_1.HostListener('document:keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], A11yDragNDropDirective.prototype, "onKeyDownAll", null);
    A11yDragNDropDirective = __decorate([
        core_1.Directive({
            selector: '[jhiA11yDragNDropDirective]'
        }),
        __metadata("design:paramtypes", [core_1.ElementRef,
            a11y_1.LiveAnnouncer])
    ], A11yDragNDropDirective);
    return A11yDragNDropDirective;
}());
exports.A11yDragNDropDirective = A11yDragNDropDirective;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var alpha_string_pipe_1 = __webpack_require__(196);
var CustomAlphaStringDirective = /** @class */ (function () {
    function CustomAlphaStringDirective(alphaStringPipe, el) {
        this.alphaStringPipe = alphaStringPipe;
        this.el = el;
    }
    CustomAlphaStringDirective.prototype.ngOnInit = function () {
        this.el.nativeElement.addEventListener('input', this.listenerFunction.bind(this), true);
    };
    CustomAlphaStringDirective.prototype.ngOnDestroy = function () {
        this.el.nativeElement.removeEventListener('input', this.listenerFunction);
    };
    CustomAlphaStringDirective.prototype.listenerFunction = function (event) {
        event.target.value = this.getNormalizedValue(event.target.value);
    };
    CustomAlphaStringDirective.prototype.getNormalizedValue = function (value) {
        return this.alphaStringPipe.transform(value);
    };
    CustomAlphaStringDirective = __decorate([
        core_1.Directive({
            selector: '[ngModel][jhiAlphaString]'
        }),
        __metadata("design:paramtypes", [alpha_string_pipe_1.TrcAlphaStringPipe, core_1.ElementRef])
    ], CustomAlphaStringDirective);
    return CustomAlphaStringDirective;
}());
exports.CustomAlphaStringDirective = CustomAlphaStringDirective;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var capitalize_pipe_1 = __webpack_require__(197);
var CustomCapitalizeDirective = /** @class */ (function () {
    function CustomCapitalizeDirective(capitalizePipe, el) {
        this.capitalizePipe = capitalizePipe;
        this.el = el;
    }
    CustomCapitalizeDirective.prototype.ngOnInit = function () {
        this.el.nativeElement.addEventListener('input', this.listenerFunction.bind(this), true);
    };
    CustomCapitalizeDirective.prototype.ngOnDestroy = function () {
        this.el.nativeElement.removeEventListener('input', this.listenerFunction);
    };
    CustomCapitalizeDirective.prototype.listenerFunction = function (event) {
        event.target.value = this.getNormalizedValue(event.target.value);
    };
    CustomCapitalizeDirective.prototype.getNormalizedValue = function (value) {
        return this.capitalizePipe.transform(value);
    };
    CustomCapitalizeDirective = __decorate([
        core_1.Directive({
            selector: '[ngModel][jhiCapitalize]'
        }),
        __metadata("design:paramtypes", [capitalize_pipe_1.CustomCapitalizePipe, core_1.ElementRef])
    ], CustomCapitalizeDirective);
    return CustomCapitalizeDirective;
}());
exports.CustomCapitalizeDirective = CustomCapitalizeDirective;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var IgnoreDirtyDirective = /** @class */ (function () {
    function IgnoreDirtyDirective(control) {
        var _this = this;
        this.control = control;
        this.control.valueChanges.subscribe(function () {
            if (_this.control.dirty) {
                _this.control.control.markAsPristine();
            }
        });
    }
    IgnoreDirtyDirective = __decorate([
        core_1.Directive({
            selector: '[ngModel][jhiIgnoreDirty]'
        }),
        __metadata("design:paramtypes", [forms_1.NgControl])
    ], IgnoreDirtyDirective);
    return IgnoreDirtyDirective;
}());
exports.IgnoreDirtyDirective = IgnoreDirtyDirective;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var input_component_1 = __webpack_require__(188);
var OnlyNumbersDirective = /** @class */ (function () {
    function OnlyNumbersDirective(el, input) {
        this.el = el;
        this.input = input;
        this.regex = new RegExp(/^[0-9]+$/g);
        this.specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'ArrowLeft', 'ArrowRight'];
    }
    OnlyNumbersDirective.prototype.ngOnInit = function () {
        this.el.nativeElement.addEventListener('keydown', this.onKeyDown.bind(this), true);
    };
    OnlyNumbersDirective.prototype.ngOnDestroy = function () {
        this.el.nativeElement.removeEventListener('keydown', this.onKeyDown);
    };
    OnlyNumbersDirective.prototype.onKeyDown = function (event) {
        if ((this.specialKeys.indexOf(event.key) !== -1) || ((event.getModifierState) && (event.getModifierState('Accel')))) {
            return;
        }
        // Do not use event.keycode this is deprecated.
        // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
        var current = this.el.nativeElement.value || (this.input || { value: '' }).value || '';
        // We need this because the current value on the DOM element
        // is not yet updated with the value from this event
        var next = current.concat(event.key);
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    };
    OnlyNumbersDirective = __decorate([
        core_1.Directive({
            selector: '[jhiOnlyNumber]'
        }),
        __param(1, core_1.Self()), __param(1, core_1.Optional()),
        __metadata("design:paramtypes", [core_1.ElementRef, input_component_1.InputComponent])
    ], OnlyNumbersDirective);
    return OnlyNumbersDirective;
}());
exports.OnlyNumbersDirective = OnlyNumbersDirective;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
// tslint:disable-next-line:directive-selector
var ScrollToDirective = /** @class */ (function () {
    function ScrollToDirective(elementRef) {
        this.elementRef = elementRef;
    }
    ScrollToDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function (_args) { return _this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 100);
    };
    ScrollToDirective = __decorate([
        core_1.Directive({ selector: '[scrollTo]' }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], ScrollToDirective);
    return ScrollToDirective;
}());
exports.ScrollToDirective = ScrollToDirective;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* Reference: https://medium.com/allenhwkim/angular-trap-focus-with-in-a-block-79b7572f23c2 */
var core_1 = __webpack_require__(0);
var TrapFocusDirective = /** @class */ (function () {
    function TrapFocusDirective(el) {
        this.el = el;
    }
    TrapFocusDirective.prototype.ngAfterViewInit = function () {
        this.trapFocus(this.el.nativeElement);
    };
    TrapFocusDirective.prototype.trapFocus = function (element) {
        var focusableEls1 = element.querySelectorAll('a[href], button, textarea, input[type="text"],' +
            'input[type="radio"], input[type="checkbox"], select');
        var focusableEls = Array.from(focusableEls1)
            .filter(function (el) { return !el.disabled; });
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        element.addEventListener('keydown', function (e) {
            var isTabPressed = e.keyCode === 9; // isTabPressed
            if (!isTabPressed) {
                return;
            }
            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            }
            else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        });
    };
    TrapFocusDirective = __decorate([
        core_1.Directive({
            selector: '[jhiTrapFocus]'
        }),
        __metadata("design:paramtypes", [core_1.ElementRef])
    ], TrapFocusDirective);
    return TrapFocusDirective;
}());
exports.TrapFocusDirective = TrapFocusDirective;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PARAMETERS = {
    countries: [],
    juridictions: [],
    typeRaisonContestations: [],
    typeRaisonInvalidationTitres: [],
    typeRaisonAvisDimpositionIrreguliers: [],
    typePrejudiceEvaluableEnArgents: [],
    contentieuxSociaux: [],
    civilities: [],
    typeActeAttaques: [],
    maxFileNameWithoutExtensionLength: 220,
    maxFileSize: 32 * 1024 * 1024,
    maxActeAttaquesForMerge: 10
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__(10);
exports.createRequestOption = function (req) {
    var options = {};
    if (req) {
        var params = new http_1.HttpParams();
        params.set('page', req.page);
        params.set('size', req.size);
        if (req.sort) {
            params.set('sort', req.sort);
        }
        params.set('query', req.query);
        options['params'] = params;
    }
    return options;
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ResponseWrapper = /** @class */ (function () {
    function ResponseWrapper(headers, json, status) {
        this.headers = headers;
        this.json = json;
        this.status = status;
    }
    return ResponseWrapper;
}());
exports.ResponseWrapper = ResponseWrapper;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ChangeExtension = /** @class */ (function () {
    function ChangeExtension() {
    }
    ChangeExtension.prototype.transform = function (item) {
        if (item && !/(.+)(\.pdf)+$/.test(item)) {
            return item + '.pdf';
        }
        return item;
    };
    ChangeExtension = __decorate([
        core_1.Pipe({ name: 'extToPdf' })
    ], ChangeExtension);
    return ChangeExtension;
}());
exports.ChangeExtension = ChangeExtension;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var FILE_SIZE_UNITS = ['O', 'Ko', 'Mo'];
var FormatFileSizePipe = /** @class */ (function () {
    function FormatFileSizePipe() {
    }
    FormatFileSizePipe.prototype.transform = function (sizeInBytes) {
        /**
         * We are looking for power (0 < power < 3) as:
         * sizeInBytes = 1024^power
         * <=> ln(sizeInBytes) = ln(1024^power)
         * <=> ln(sizeInBytes) = power*ln(1024)
         * <=> power = ln(sizeInBytes)/ln(1024)
         */
        var power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
        power = Math.min(power, FILE_SIZE_UNITS.length - 1);
        var size = sizeInBytes / Math.pow(1024, power); // size in new units
        var formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
        var unit = FILE_SIZE_UNITS[power];
        return (formattedSize + " " + unit).replace('.', ',');
    };
    FormatFileSizePipe = __decorate([
        core_1.Pipe({
            name: 'formatFileSize'
        })
    ], FormatFileSizePipe);
    return FormatFileSizePipe;
}());
exports.FormatFileSizePipe = FormatFileSizePipe;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(15);
var moment = __webpack_require__(1);
/**
 * DatePipe: date time without TimeZone doesn't work with IOS
 */
var LocalDatePipe = /** @class */ (function () {
    function LocalDatePipe(datePipe) {
        this.datePipe = datePipe;
    }
    LocalDatePipe.prototype.transform = function (value, pattern) {
        return this.datePipe.transform(this.toUtc(value), pattern);
    };
    LocalDatePipe.prototype.toUtc = function (value) {
        try {
            return value ? moment(value).utc(false).format() : value;
        }
        catch (e) {
            return value;
        }
    };
    LocalDatePipe = __decorate([
        core_1.Pipe({ name: 'localDate' }),
        __metadata("design:paramtypes", [common_1.DatePipe])
    ], LocalDatePipe);
    return LocalDatePipe;
}());
exports.LocalDatePipe = LocalDatePipe;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(43);
var SafeHtmlPipe = /** @class */ (function () {
    function SafeHtmlPipe(sanitized) {
        this.sanitized = sanitized;
    }
    SafeHtmlPipe.prototype.transform = function (value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    };
    SafeHtmlPipe = __decorate([
        core_1.Pipe({ name: 'safeHtml' }),
        __metadata("design:paramtypes", [platform_browser_1.DomSanitizer])
    ], SafeHtmlPipe);
    return SafeHtmlPipe;
}());
exports.SafeHtmlPipe = SafeHtmlPipe;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var router_auth_service_1 = __webpack_require__(100);
var UserRouteAccessService = /** @class */ (function () {
    function UserRouteAccessService(auth) {
        this.auth = auth;
    }
    UserRouteAccessService.prototype.canActivate = function (route) {
        return this.auth.authorize(route);
    };
    UserRouteAccessService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [router_auth_service_1.RouterAuthService])
    ], UserRouteAccessService);
    return UserRouteAccessService;
}());
exports.UserRouteAccessService = UserRouteAccessService;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(5);
var shared_libs_module_1 = __webpack_require__(103);
var extension_changer_pipe_1 = __webpack_require__(525);
var captcha_service_1 = __webpack_require__(69);
var cgu_service_1 = __webpack_require__(199);
var scroll_to_directive_1 = __webpack_require__(520);
var scroll_to_service_1 = __webpack_require__(101);
var error_service_1 = __webpack_require__(22);
var tracking_service_1 = __webpack_require__(32);
var navigation_service_1 = __webpack_require__(99);
var nav_back_guard_1 = __webpack_require__(194);
var parameters_service_1 = __webpack_require__(25);
var login_service_1 = __webpack_require__(87);
var account_service_1 = __webpack_require__(72);
var state_storage_service_1 = __webpack_require__(73);
var user_service_1 = __webpack_require__(74);
var csrf_service_1 = __webpack_require__(200);
var auth_session_service_1 = __webpack_require__(98);
var router_auth_service_1 = __webpack_require__(100);
var event_piece_service_1 = __webpack_require__(184);
var requete_service_1 = __webpack_require__(203);
var draft_requete_service_1 = __webpack_require__(201);
var shared_common_module_1 = __webpack_require__(205);
var trc_admin_config_service_1 = __webpack_require__(204);
var TelerecourspnrSharedModule = /** @class */ (function () {
    function TelerecourspnrSharedModule() {
    }
    TelerecourspnrSharedModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_libs_module_1.TelerecourspnrSharedLibsModule,
                shared_common_module_1.TelerecourspnrSharedCommonModule,
                forms_1.ReactiveFormsModule
            ],
            declarations: [
                scroll_to_directive_1.ScrollToDirective,
                extension_changer_pipe_1.ChangeExtension
            ],
            providers: [
                login_service_1.LoginService,
                account_service_1.AccountService,
                state_storage_service_1.StateStorageService,
                user_service_1.UserService,
                csrf_service_1.CSRFService,
                auth_session_service_1.AuthServerProvider,
                router_auth_service_1.RouterAuthService,
                cgu_service_1.CguService,
                extension_changer_pipe_1.ChangeExtension,
                captcha_service_1.CaptchaService,
                scroll_to_service_1.ScrollToService,
                error_service_1.ErrorService,
                tracking_service_1.TrackingService,
                navigation_service_1.NavigationService,
                parameters_service_1.ParametersService,
                nav_back_guard_1.NavBackGuard,
                event_piece_service_1.EventPieceService,
                requete_service_1.RequeteService,
                draft_requete_service_1.DraftRequeteService,
                trc_admin_config_service_1.TRCAdminConfigService
            ],
            exports: [
                shared_common_module_1.TelerecourspnrSharedCommonModule,
                scroll_to_directive_1.ScrollToDirective,
                extension_changer_pipe_1.ChangeExtension
            ],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
        })
    ], TelerecourspnrSharedModule);
    return TelerecourspnrSharedModule;
}());
exports.TelerecourspnrSharedModule = TelerecourspnrSharedModule;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(19);
var user_club_modal_component_1 = __webpack_require__(206);
var UserClubComponent = /** @class */ (function () {
    function UserClubComponent(modalService) {
        this.modalService = modalService;
    }
    UserClubComponent.prototype.openJucModal = function () {
        this.modalService.open(user_club_modal_component_1.UserClubModalComponent, { size: 'lg' });
    };
    UserClubComponent = __decorate([
        core_1.Component({
            selector: 'jhi-user-club',
            template: __webpack_require__(861),
            styles: [__webpack_require__(963)],
        }),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal])
    ], UserClubComponent);
    return UserClubComponent;
}());
exports.UserClubComponent = UserClubComponent;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var user_club_modal_component_1 = __webpack_require__(206);
var shared_1 = __webpack_require__(4);
var user_club_component_1 = __webpack_require__(531);
var user_club_unsubscribe_component_1 = __webpack_require__(207);
var router_1 = __webpack_require__(6);
var user_club_route_1 = __webpack_require__(533);
var TelerecourspnrUserClubModule = /** @class */ (function () {
    function TelerecourspnrUserClubModule() {
    }
    TelerecourspnrUserClubModule = __decorate([
        core_1.NgModule({
            imports: [
                shared_1.TelerecourspnrSharedModule,
                router_1.RouterModule.forRoot([user_club_route_1.UserClubRoute], { useHash: true }),
            ],
            declarations: [
                user_club_component_1.UserClubComponent,
                user_club_modal_component_1.UserClubModalComponent,
                user_club_unsubscribe_component_1.UserClubUnsubscribeComponent
            ],
            entryComponents: [user_club_modal_component_1.UserClubModalComponent],
            exports: [
                user_club_component_1.UserClubComponent
            ],
            providers: [
                shared_1.UserService,
            ]
        })
    ], TelerecourspnrUserClubModule);
    return TelerecourspnrUserClubModule;
}());
exports.TelerecourspnrUserClubModule = TelerecourspnrUserClubModule;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_constants_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(4);
var user_club_unsubscribe_component_1 = __webpack_require__(207);
exports.UserClubRoute = {
    path: 'club',
    children: [
        {
            path: 'desinscription',
            component: user_club_unsubscribe_component_1.UserClubUnsubscribeComponent,
            data: {
                needAuthentication: true,
                pageTitle: "D\u00E9sinscription du club utilisateur" + app_constants_1.PAGE_TITLE_SUFFIX
            },
            canActivate: [shared_1.UserRouteAccessService]
        }
    ]
};


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angulartics2__ = __webpack_require__(104);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Angulartics2Piwik", function() { return Angulartics2Piwik; });




var Angulartics2Piwik = /** @class */ (function () {
    function Angulartics2Piwik(angulartics2) {
        var _this = this;
        this.angulartics2 = angulartics2;
        if (typeof (_paq) === 'undefined') {
            console.warn('Piwik not found');
        }
        this.angulartics2.setUsername
            .subscribe(function (x) { return _this.setUsername(x); });
        this.angulartics2.setUserProperties
            .subscribe(function (x) { return _this.setUserProperties(x); });
    }
    Angulartics2Piwik.prototype.startTracking = function () {
        var _this = this;
        this.angulartics2.pageTrack
            .pipe(this.angulartics2.filterDeveloperMode())
            .subscribe(function (x) { return _this.pageTrack(x.path); });
        this.angulartics2.eventTrack
            .pipe(this.angulartics2.filterDeveloperMode())
            .subscribe(function (x) { return _this.eventTrack(x.action, x.properties); });
    };
    Angulartics2Piwik.prototype.pageTrack = function (path, location) {
        try {
            _paq.push(['setDocumentTitle', window.document.title]);
            _paq.push(['setCustomUrl', path]);
            _paq.push(['trackPageView']);
        }
        catch (e) {
            if (!(e instanceof ReferenceError)) {
                throw e;
            }
        }
    };
    /**
     * Track a basic event in Piwik, or send an ecommerce event.
     *
     * @param action A string corresponding to the type of event that needs to be tracked.
     * @param properties The properties that need to be logged with the event.
     */
    Angulartics2Piwik.prototype.eventTrack = function (action, properties) {
        if (properties === void 0) { properties = {}; }
        var params = [];
        switch (action) {
            /**
             * @description Sets the current page view as a product or category page view. When you call
             * setEcommerceView it must be followed by a call to trackPageView to record the product or
             * category page view.
             *
             * @link https://piwik.org/docs/ecommerce-analytics/#tracking-product-page-views-category-page-views-optional
             * @link https://developer.piwik.org/api-reference/tracking-javascript#ecommerce
             *
             * @property productSKU (required) SKU: Product unique identifier
             * @property productName (optional) Product name
             * @property categoryName (optional) Product category, or array of up to 5 categories
             * @property price (optional) Product Price as displayed on the page
             */
            case 'setEcommerceView':
                params = ['setEcommerceView',
                    properties.productSKU,
                    properties.productName,
                    properties.categoryName,
                    properties.price,
                ];
                break;
            /**
             * @description Adds a product into the ecommerce order. Must be called for each product in
             * the order.
             *
             * @link https://piwik.org/docs/ecommerce-analytics/#tracking-ecommerce-orders-items-purchased-required
             * @link https://developer.piwik.org/api-reference/tracking-javascript#ecommerce
             *
             * @property productSKU (required) SKU: Product unique identifier
             * @property productName (optional) Product name
             * @property categoryName (optional) Product category, or array of up to 5 categories
             * @property price (recommended) Product price
             * @property quantity (optional, default to 1) Product quantity
             */
            case 'addEcommerceItem':
                params = [
                    'addEcommerceItem',
                    properties.productSKU,
                    properties.productName,
                    properties.productCategory,
                    properties.price,
                    properties.quantity,
                ];
                break;
            /**
             * @description Tracks a shopping cart. Call this javascript function every time a user is
             * adding, updating or deleting a product from the cart.
             *
             * @link https://piwik.org/docs/ecommerce-analytics/#tracking-add-to-cart-items-added-to-the-cart-optional
             * @link https://developer.piwik.org/api-reference/tracking-javascript#ecommerce
             *
             * @property grandTotal (required) Cart amount
             */
            case 'trackEcommerceCartUpdate':
                params = ['trackEcommerceCartUpdate', properties.grandTotal];
                break;
            /**
             * @description Tracks an Ecommerce order, including any ecommerce item previously added to
             * the order. orderId and grandTotal (ie. revenue) are required parameters.
             *
             * @link https://piwik.org/docs/ecommerce-analytics/#tracking-ecommerce-orders-items-purchased-required
             * @link https://developer.piwik.org/api-reference/tracking-javascript#ecommerce
             *
             * @property orderId (required) Unique Order ID
             * @property grandTotal (required) Order Revenue grand total (includes tax, shipping, and subtracted discount)
             * @property subTotal (optional) Order sub total (excludes shipping)
             * @property tax (optional) Tax amount
             * @property shipping (optional) Shipping amount
             * @property discount (optional) Discount offered (set to false for unspecified parameter)
             */
            case 'trackEcommerceOrder':
                params = [
                    'trackEcommerceOrder',
                    properties.orderId,
                    properties.grandTotal,
                    properties.subTotal,
                    properties.tax,
                    properties.shipping,
                    properties.discount,
                ];
                break;
            /**
             * @description Tracks an Ecommerce goal
             *
             * @link https://piwik.org/docs/tracking-goals-web-analytics/
             * @link https://developer.piwik.org/guides/tracking-javascript-guide#manually-trigger-goal-conversions
             *
             * @property goalId (required) Unique Goal ID
             * @property value (optional) passed to goal tracking
             */
            case 'trackGoal':
                params = [
                    'trackGoal',
                    properties.goalId,
                    properties.value,
                ];
                break;
            /**
             * @description Tracks a site search
             *
             * @link https://piwik.org/docs/site-search/
             * @link https://developer.piwik.org/guides/tracking-javascript-guide#internal-search-tracking
             *
             * @property keyword (required) Keyword searched for
             * @property category (optional) Search category
             * @property searchCount (optional) Number of results
             */
            case 'trackSiteSearch':
                params = [
                    'trackSiteSearch',
                    properties.keyword,
                    properties.category,
                    properties.searchCount,
                ];
                break;
            /**
             * @description Logs an event with an event category (Videos, Music, Games...), an event
             * action (Play, Pause, Duration, Add Playlist, Downloaded, Clicked...), and an optional
             * event name and optional numeric value.
             *
             * @link https://piwik.org/docs/event-tracking/
             * @link https://developer.piwik.org/api-reference/tracking-javascript#using-the-tracker-object
             *
             * @property category
             * @property action
             * @property name (optional, recommended)
             * @property value (optional)
             */
            default:
                // PAQ requires that eventValue be an integer, see: http://piwik.org/docs/event-tracking
                if (properties.value) {
                    var parsed = parseInt(properties.value, 10);
                    properties.value = isNaN(parsed) ? 0 : parsed;
                }
                params = [
                    'trackEvent',
                    properties.category,
                    action,
                    properties.name || properties.label,
                    properties.value,
                ];
        }
        try {
            _paq.push(params);
        }
        catch (e) {
            if (!(e instanceof ReferenceError)) {
                throw e;
            }
        }
    };
    Angulartics2Piwik.prototype.setUsername = function (userId) {
        try {
            _paq.push(['setUserId', userId]);
        }
        catch (e) {
            if (!(e instanceof ReferenceError)) {
                throw e;
            }
        }
    };
    /**
     * Sets custom dimensions if at least one property has the key "dimension<n>",
     * e.g. dimension10. If there are custom dimensions, any other property is ignored.
     *
     * If there are no custom dimensions in the given properties object, the properties
     * object is saved as a custom variable.
     *
     * If in doubt, prefer custom dimensions.
     * @link https://piwik.org/docs/custom-variables/
     */
    Angulartics2Piwik.prototype.setUserProperties = function (properties) {
        var dimensions = this.setCustomDimensions(properties);
        try {
            if (dimensions.length === 0) {
                _paq.push(['setCustomVariable', properties]);
            }
        }
        catch (e) {
            if (!(e instanceof ReferenceError)) {
                throw e;
            }
        }
    };
    Angulartics2Piwik.prototype.setCustomDimensions = function (properties) {
        var dimensionRegex = /dimension[1-9]\d*/;
        var dimensions = Object.keys(properties)
            .filter(function (key) { return dimensionRegex.exec(key); });
        dimensions.forEach(function (dimension) {
            var number = Number(dimension.substr(9));
            _paq.push(['setCustomDimension', number, properties[dimension]]);
        });
        return dimensions;
    };
    Angulartics2Piwik.ngInjectableDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["defineInjectable"])({ factory: function Angulartics2Piwik_Factory() { return new Angulartics2Piwik(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["inject"])(__WEBPACK_IMPORTED_MODULE_2_angulartics2__["Angulartics2"])); }, token: Angulartics2Piwik, providedIn: "root" });
    Angulartics2Piwik = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])({ providedIn: 'root' }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2_angulartics2__["Angulartics2"]])
    ], Angulartics2Piwik);
    return Angulartics2Piwik;
}());

/**
 * Generated bundle index. Do not edit.
 */


//# sourceMappingURL=angulartics2-piwik.js.map


/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = function atoa (a, n) { return Array.prototype.slice.call(a, n); }


/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;charset=utf-8;base64,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"

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ticky = __webpack_require__(863);

module.exports = function debounce (fn, args, ctx) {
  if (!fn) { return; }
  ticky(function run () {
    fn.apply(ctx || null, args || []);
  });
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var atoa = __webpack_require__(535);
var debounce = __webpack_require__(537);

module.exports = function emitter (thing, options) {
  var opts = options || {};
  var evt = {};
  if (thing === undefined) { thing = {}; }
  thing.on = function (type, fn) {
    if (!evt[type]) {
      evt[type] = [fn];
    } else {
      evt[type].push(fn);
    }
    return thing;
  };
  thing.once = function (type, fn) {
    fn._once = true; // thing.off(fn) still works!
    thing.on(type, fn);
    return thing;
  };
  thing.off = function (type, fn) {
    var c = arguments.length;
    if (c === 1) {
      delete evt[type];
    } else if (c === 0) {
      evt = {};
    } else {
      var et = evt[type];
      if (!et) { return thing; }
      et.splice(et.indexOf(fn), 1);
    }
    return thing;
  };
  thing.emit = function () {
    var args = atoa(arguments);
    return thing.emitterSnapshot(args.shift()).apply(this, args);
  };
  thing.emitterSnapshot = function (type) {
    var et = (evt[type] || []).slice(0);
    return function () {
      var args = atoa(arguments);
      var ctx = this || thing;
      if (type === 'error' && opts.throws !== false && !et.length) { throw args.length === 1 ? args[0] : args; }
      et.forEach(function emitter (listen) {
        if (opts.async) { debounce(listen, args, ctx); } else { listen.apply(ctx, args); }
        if (listen._once) { thing.off(type, listen); }
      });
      return thing;
    };
  };
  return thing;
};


/***/ }),
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var customEvent = __webpack_require__(754);
var eventmap = __webpack_require__(654);
var doc = global.document;
var addEvent = addEventEasy;
var removeEvent = removeEventEasy;
var hardCache = [];

if (!global.addEventListener) {
  addEvent = addEventHard;
  removeEvent = removeEventHard;
}

module.exports = {
  add: addEvent,
  remove: removeEvent,
  fabricate: fabricateEvent
};

function addEventEasy (el, type, fn, capturing) {
  return el.addEventListener(type, fn, capturing);
}

function addEventHard (el, type, fn) {
  return el.attachEvent('on' + type, wrap(el, type, fn));
}

function removeEventEasy (el, type, fn, capturing) {
  return el.removeEventListener(type, fn, capturing);
}

function removeEventHard (el, type, fn) {
  var listener = unwrap(el, type, fn);
  if (listener) {
    return el.detachEvent('on' + type, listener);
  }
}

function fabricateEvent (el, type, model) {
  var e = eventmap.indexOf(type) === -1 ? makeCustomEvent() : makeClassicEvent();
  if (el.dispatchEvent) {
    el.dispatchEvent(e);
  } else {
    el.fireEvent('on' + type, e);
  }
  function makeClassicEvent () {
    var e;
    if (doc.createEvent) {
      e = doc.createEvent('Event');
      e.initEvent(type, true, true);
    } else if (doc.createEventObject) {
      e = doc.createEventObject();
    }
    return e;
  }
  function makeCustomEvent () {
    return new customEvent(type, { detail: model });
  }
}

function wrapperFactory (el, type, fn) {
  return function wrapper (originalEvent) {
    var e = originalEvent || global.event;
    e.target = e.target || e.srcElement;
    e.preventDefault = e.preventDefault || function preventDefault () { e.returnValue = false; };
    e.stopPropagation = e.stopPropagation || function stopPropagation () { e.cancelBubble = true; };
    e.which = e.which || e.keyCode;
    fn.call(el, e);
  };
}

function wrap (el, type, fn) {
  var wrapper = unwrap(el, type, fn) || wrapperFactory(el, type, fn);
  hardCache.push({
    wrapper: wrapper,
    element: el,
    type: type,
    fn: fn
  });
  return wrapper;
}

function unwrap (el, type, fn) {
  var i = find(el, type, fn);
  if (i) {
    var wrapper = hardCache[i].wrapper;
    hardCache.splice(i, 1); // free up a tad of memory
    return wrapper;
  }
}

function find (el, type, fn) {
  var i, item;
  for (i = 0; i < hardCache.length; i++) {
    item = hardCache[i];
    if (item.element === el && item.type === type && item.fn === fn) {
      return i;
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var eventmap = [];
var eventname = '';
var ron = /^on/;

for (eventname in global) {
  if (ron.test(eventname)) {
    eventmap.push(eventname.slice(2));
  }
}

module.exports = eventmap;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "@media (min-width:992px){:host .row.vdivide section:not(:last-child):after{background:#e0e0e0;content:\"\";width:1px;display:block;position:absolute;top:10px;bottom:0;right:0;min-height:100px}}:host a{color:#767676;text-decoration:underline;font-size:14px;font-style:italic}:host .explication.explication_why{background-color:transparent;border-radius:2px;border:1px solid #9b9b9b;margin:2rem 0}:host .explication.explication_why p{margin-top:1rem}:host .input-group-addon{margin-left:.2rem}:host .input-group-addon:focus{outline-offset:.1rem;outline:2px solid #2087c8;box-shadow:none;border-radius:2px}:host .focus-outline{margin-bottom:0}:host h2{font-size:1.5rem}:host .input-group-addon-btn{background-color:unset;border:unset}", ""]);

// exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-wrap:wrap;width:100%}:host #show-password-fields-btn{float:left}", ""]);

// exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;justify-content:center;align-items:center;min-height:inherit}:host .loader-message{color:#464a4c;display:inline-flex;margin-left:5px;text-transform:uppercase}:host .bounceball{position:relative;display:inline-flex;height:37px;width:15px}:host .bounceball:before{position:absolute;content:\"\";display:block;top:0;width:15px;height:15px;border-radius:50%;background-color:#464a4c;transform-origin:50%;animation:bounce .5s alternate infinite ease}@keyframes bounce{0%{top:30px;height:5px;border-radius:60px 60px 20px 20px;transform:scaleX(2)}35%{height:15px;border-radius:50%;transform:scaleX(1)}to{top:0}}", ""]);

// exports


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "#linkalert a{color:#fff;text-decoration:underline}", ""]);

// exports


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "ul#strength{display:inline;list-style:none;margin:0;margin-left:15px;padding:0;vertical-align:2px}.point{background:#ddd;border-radius:2px;display:inline-block;height:5px;margin-right:1px;width:20px}.point:last-child{margin:0!important}ul{list-style-type:none;padding-left:0}.invalid{color:#a00313}li.invalid:before{content:\"\\2717   \\A0   \"}.alert{font-size:.8rem}ul>li{color:#a00313}ul>li.valid{color:#016547}ul>li.valid:before{content:\"\\2713   \\A0   \"}div.neutre>ul>li{color:#000}#passwordChecks,#passwordChecks-left{padding-left:0!important}#passwordChecks{padding-right:0!important}@media only screen and (min-device-width:320px) and (max-device-width:480px){#passwordChecks-right{padding-left:0!important}}", ""]);

// exports


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".btn-group{justify-content:center}", ""]);

// exports


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "div.row{margin-top:20px}div.row fieldset{width:100%}div.row legend{font-family:Perpetua;font-size:2rem}button{height:56px;width:170px;border-radius:2px}jhi-button[cancellation]{float:left}", ""]);

// exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host div.row{margin-top:20px}:host div.row fieldset{width:100%}:host div.row legend{font-family:Perpetua;font-size:2rem}:host a{color:#005092;font-weight:600;text-decoration:underline}:host .warning_franceConnect{line-height:1.6rem;border-radius:2px;margin:2rem 0}:host .warning_franceConnect p{margin:.5rem 0}:host .warning_franceConnect ul li:before{content:\"-\";line-height:1.6rem;margin-left:1rem;padding-right:.5rem}:host hr{border-top:1px solid #000}:host .en_savoir_plus{color:#9b8c8c;text-decoration:none;font-family:Open Sans,sans-serif;font-size:.8rem;line-height:1rem;display:block;margin:auto}:host .en_savoir_plus a{color:#9b8c8c;text-decoration:underline}:host jhi-button[cancellation]{float:left}", ""]);

// exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host::ng-deep ngb-alert .alert-danger{max-width:1200px;margin:auto}:host legend{font-family:Perpetua;font-size:2rem}:host fieldset{width:100%}:host a{color:#005092;font-weight:600;text-decoration:underline}:host .alert.alert-warning{padding:.75rem 1.25rem;margin-top:5px}:host .identifiant,:host .notification{padding:0}.modal-content{padding:2.5rem}.modal-header{text-align:center;font-weight:900}.modal-body{margin-top:1.5rem}.my-info-modal-cancel-btn{margin-left:0}", ""]);

// exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host .msg-band{position:relative;top:-2rem}", ""]);

// exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host a{font-weight:600;text-decoration:underline}", ""]);

// exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary,.radio-fieldset__item--active{border-color:#007bff!important}.border-secondary,.radio-fieldset__item--inactive{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important}.rounded-right,.rounded-top{border-top-right-radius:.25rem!important}.rounded-bottom,.rounded-right{border-bottom-right-radius:.25rem!important}.rounded-bottom,.rounded-left{border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important}.rounded-circle{border-radius:50%!important}.rounded-0{border-radius:0!important}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex,.radio-fieldset__item__input{display:flex!important}.d-inline-flex{display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:flex!important}.d-sm-inline-flex{display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:flex!important}.d-md-inline-flex{display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:flex!important}.d-lg-inline-flex{display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:flex!important}.d-xl-inline-flex{display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:flex!important}.d-print-inline-flex{display:inline-flex!important}}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0,.radio-fieldset__item__label label{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3,.radio-fieldset__item{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3,.radio-fieldset__item{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1,.radio-fieldset__item__input{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3,.radio-fieldset__item{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-auto,.radio-fieldset__item__input input{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.radio-fieldset__item,.row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto,.radio-fieldset__item__input,.radio-fieldset__item__label{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px}.col{flex-basis:0;flex-grow:1;max-width:100%}.col-auto{flex:0 0 auto;width:auto;max-width:none}.col-1{flex:0 0 8.33333%;max-width:8.33333%}.col-2,.radio-fieldset__item__input{flex:0 0 16.66667%;max-width:16.66667%}.col-3{flex:0 0 25%;max-width:25%}.col-4{flex:0 0 33.33333%;max-width:33.33333%}.col-5{flex:0 0 41.66667%;max-width:41.66667%}.col-6{flex:0 0 50%;max-width:50%}.col-7{flex:0 0 58.33333%;max-width:58.33333%}.col-8{flex:0 0 66.66667%;max-width:66.66667%}.col-9{flex:0 0 75%;max-width:75%}.col-10,.radio-fieldset__item__label{flex:0 0 83.33333%;max-width:83.33333%}.col-11{flex:0 0 91.66667%;max-width:91.66667%}.col-12{flex:0 0 100%;max-width:100%}.order-first{order:-1}.order-last{order:13}.order-0{order:0}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.offset-1{margin-left:8.33333%}.offset-2{margin-left:16.66667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333%}.offset-5{margin-left:41.66667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333%}.offset-8{margin-left:66.66667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333%}.offset-11{margin-left:91.66667%}@media (min-width:576px){.col-sm{flex-basis:0;flex-grow:1;max-width:100%}.col-sm-auto{flex:0 0 auto;width:auto;max-width:none}.col-sm-1,.radio-fieldset__item__input{flex:0 0 8.33333%;max-width:8.33333%}.col-sm-2{flex:0 0 16.66667%;max-width:16.66667%}.col-sm-3{flex:0 0 25%;max-width:25%}.col-sm-4{flex:0 0 33.33333%;max-width:33.33333%}.col-sm-5{flex:0 0 41.66667%;max-width:41.66667%}.col-sm-6{flex:0 0 50%;max-width:50%}.col-sm-7{flex:0 0 58.33333%;max-width:58.33333%}.col-sm-8{flex:0 0 66.66667%;max-width:66.66667%}.col-sm-9{flex:0 0 75%;max-width:75%}.col-sm-10{flex:0 0 83.33333%;max-width:83.33333%}.col-sm-11{flex:0 0 91.66667%;max-width:91.66667%}.col-sm-12{flex:0 0 100%;max-width:100%}.order-sm-first{order:-1}.order-sm-last{order:13}.order-sm-0{order:0}.order-sm-1{order:1}.order-sm-2{order:2}.order-sm-3{order:3}.order-sm-4{order:4}.order-sm-5{order:5}.order-sm-6{order:6}.order-sm-7{order:7}.order-sm-8{order:8}.order-sm-9{order:9}.order-sm-10{order:10}.order-sm-11{order:11}.order-sm-12{order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333%}.offset-sm-2{margin-left:16.66667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333%}.offset-sm-5{margin-left:41.66667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333%}.offset-sm-8{margin-left:66.66667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333%}.offset-sm-11{margin-left:91.66667%}}@media (min-width:768px){.col-md{flex-basis:0;flex-grow:1;max-width:100%}.col-md-auto{flex:0 0 auto;width:auto;max-width:none}.col-md-1{flex:0 0 8.33333%;max-width:8.33333%}.col-md-2{flex:0 0 16.66667%;max-width:16.66667%}.col-md-3{flex:0 0 25%;max-width:25%}.col-md-4{flex:0 0 33.33333%;max-width:33.33333%}.col-md-5{flex:0 0 41.66667%;max-width:41.66667%}.col-md-6{flex:0 0 50%;max-width:50%}.col-md-7{flex:0 0 58.33333%;max-width:58.33333%}.col-md-8{flex:0 0 66.66667%;max-width:66.66667%}.col-md-9{flex:0 0 75%;max-width:75%}.col-md-10{flex:0 0 83.33333%;max-width:83.33333%}.col-md-11{flex:0 0 91.66667%;max-width:91.66667%}.col-md-12{flex:0 0 100%;max-width:100%}.order-md-first{order:-1}.order-md-last{order:13}.order-md-0{order:0}.order-md-1{order:1}.order-md-2{order:2}.order-md-3{order:3}.order-md-4{order:4}.order-md-5{order:5}.order-md-6{order:6}.order-md-7{order:7}.order-md-8{order:8}.order-md-9{order:9}.order-md-10{order:10}.order-md-11{order:11}.order-md-12{order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333%}.offset-md-2{margin-left:16.66667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333%}.offset-md-5{margin-left:41.66667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333%}.offset-md-8{margin-left:66.66667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333%}.offset-md-11{margin-left:91.66667%}}@media (min-width:992px){.col-lg{flex-basis:0;flex-grow:1;max-width:100%}.col-lg-auto{flex:0 0 auto;width:auto;max-width:none}.col-lg-1{flex:0 0 8.33333%;max-width:8.33333%}.col-lg-2{flex:0 0 16.66667%;max-width:16.66667%}.col-lg-3{flex:0 0 25%;max-width:25%}.col-lg-4{flex:0 0 33.33333%;max-width:33.33333%}.col-lg-5{flex:0 0 41.66667%;max-width:41.66667%}.col-lg-6{flex:0 0 50%;max-width:50%}.col-lg-7{flex:0 0 58.33333%;max-width:58.33333%}.col-lg-8{flex:0 0 66.66667%;max-width:66.66667%}.col-lg-9{flex:0 0 75%;max-width:75%}.col-lg-10{flex:0 0 83.33333%;max-width:83.33333%}.col-lg-11{flex:0 0 91.66667%;max-width:91.66667%}.col-lg-12{flex:0 0 100%;max-width:100%}.order-lg-first{order:-1}.order-lg-last{order:13}.order-lg-0{order:0}.order-lg-1{order:1}.order-lg-2{order:2}.order-lg-3{order:3}.order-lg-4{order:4}.order-lg-5{order:5}.order-lg-6{order:6}.order-lg-7{order:7}.order-lg-8{order:8}.order-lg-9{order:9}.order-lg-10{order:10}.order-lg-11{order:11}.order-lg-12{order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333%}.offset-lg-2{margin-left:16.66667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333%}.offset-lg-5{margin-left:41.66667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333%}.offset-lg-8{margin-left:66.66667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333%}.offset-lg-11{margin-left:91.66667%}}@media (min-width:1200px){.col-xl{flex-basis:0;flex-grow:1;max-width:100%}.col-xl-auto{flex:0 0 auto;width:auto;max-width:none}.col-xl-1{flex:0 0 8.33333%;max-width:8.33333%}.col-xl-2{flex:0 0 16.66667%;max-width:16.66667%}.col-xl-3{flex:0 0 25%;max-width:25%}.col-xl-4{flex:0 0 33.33333%;max-width:33.33333%}.col-xl-5{flex:0 0 41.66667%;max-width:41.66667%}.col-xl-6{flex:0 0 50%;max-width:50%}.col-xl-7{flex:0 0 58.33333%;max-width:58.33333%}.col-xl-8{flex:0 0 66.66667%;max-width:66.66667%}.col-xl-9{flex:0 0 75%;max-width:75%}.col-xl-10{flex:0 0 83.33333%;max-width:83.33333%}.col-xl-11{flex:0 0 91.66667%;max-width:91.66667%}.col-xl-12{flex:0 0 100%;max-width:100%}.order-xl-first{order:-1}.order-xl-last{order:13}.order-xl-0{order:0}.order-xl-1{order:1}.order-xl-2{order:2}.order-xl-3{order:3}.order-xl-4{order:4}.order-xl-5{order:5}.order-xl-6{order:6}.order-xl-7{order:7}.order-xl-8{order:8}.order-xl-9{order:9}.order-xl-10{order:10}.order-xl-11{order:11}.order-xl-12{order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333%}.offset-xl-2{margin-left:16.66667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333%}.offset-xl-5{margin-left:41.66667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333%}.offset-xl-8{margin-left:66.66667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333%}.offset-xl-11{margin-left:91.66667%}}.radio-fieldset__item{border-radius:1rem;border:1px solid #f8f9fa}.radio-fieldset__item--active{border-width:2px}.radio-fieldset__item{transition:.1s ease-out}.radio-fieldset__item--active{background-color:#e6f2ff}.radio-fieldset__item__input input[type=radio],input[type=radio].radio{width:30px;height:30px}.radio-fieldset__item{cursor:pointer}.radio-fieldset__item:not(.radio-fieldset__item--active):hover{background-color:#f2f4f6}.radio-fieldset__item__label label{color:#005092;font-weight:400;font-size:2rem;font-family:perpetua;pointer-events:all}:host{display:block}:host a{font-weight:600;text-decoration:underline}", ""]);

// exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column}", ""]);

// exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host a{font-weight:600;text-decoration:underline}", ""]);

// exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column}:host .avertissement-header{font-size:17px;font-weight:600;line-height:2rem}:host .avertissement-header,:host .explication{font-family:Open Sans}:host strong{font-size:15px}", ""]);

// exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column;font-family:Open Sans}:host .explication{background-color:#bbd6f5}:host .avertissement-header{font-size:17px;font-weight:600;line-height:2rem}:host .avertissement-header,:host .explication{font-family:Open Sans}", ""]);

// exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}", ""]);

// exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .is-pressed{font-size:1.4em}", ""]);

// exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column}:host h3{font-weight:300;font-family:Open Sans;margin-bottom:1rem}:host .is-pressed{font-size:1.4em}:host .nommer-piece-label{color:#5a4e4e}", ""]);

// exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}section{margin:2rem 0}a{color:#005092;font-weight:600;text-decoration:underline}.input-group-append{align-items:center;padding:0 .7rem;cursor:pointer}.input-group-append:focus{outline-offset:2px;outline:2px solid #2087c8;box-shadow:none;border-radius:4px}div.form-group div.input-group input.inventaire{padding-top:0}.has-value{color:#5a4e4e}", ""]);

// exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;width:100%;background-color:#f3f2ed}:host .row{display:flex;justify-content:space-between;align-items:center}:host .row,:host .row>*{padding:.5rem}:host .row .title-block{display:flex;flex-direction:column}:host .row .title-block .title{font-weight:700;font-size:1.2rem;color:#191919}:host .row .title-block .sub-title{font-size:1.1rem;color:#191919}", ""]);

// exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host a{font-weight:600;text-decoration:underline}", ""]);

// exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block;margin-top:1rem}:host jhi-fiche-acteur{margin-bottom:1rem}:host .explication{margin-top:0;margin-bottom:2rem}", ""]);

// exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{border-radius:2px;background-color:#fafafa;border-bottom:.15rem solid #f3f2ed}:host,:host .container{display:flex;flex-direction:column}:host .container{padding-top:2rem;padding-bottom:2rem}:host .container .btn-group{width:100%;justify-content:flex-end;margin-top:0}:host .container .btn-group jhi-button:first-child{margin-right:1rem}", ""]);

// exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block;margin-top:1rem}:host jhi-fiche-acteur{margin-bottom:1rem}:host jhi-button{float:right}:host .fa{margin-right:1rem}:host ul{list-style-type:none;padding-inline-start:0}", ""]);

// exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;align-items:center;flex-direction:column;background-color:#fafafa;border-bottom:.15rem solid #f3f2ed}:host .container{display:flex;flex-wrap:wrap;padding-top:2rem;padding-bottom:2rem}:host .container .btn-group{justify-content:flex-end;margin-top:0;width:100%}:host .container .btn-group jhi-button{margin-left:1rem}", ""]);

// exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary,.radio-fieldset__item--active{border-color:#007bff!important}.border-secondary,.radio-fieldset__item--inactive{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important}.rounded-right,.rounded-top{border-top-right-radius:.25rem!important}.rounded-bottom,.rounded-right{border-bottom-right-radius:.25rem!important}.rounded-bottom,.rounded-left{border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important}.rounded-circle{border-radius:50%!important}.rounded-0{border-radius:0!important}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex,.radio-fieldset__item__input{display:flex!important}.d-inline-flex{display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:flex!important}.d-sm-inline-flex{display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:flex!important}.d-md-inline-flex{display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:flex!important}.d-lg-inline-flex{display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:flex!important}.d-xl-inline-flex{display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:flex!important}.d-print-inline-flex{display:inline-flex!important}}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0,.radio-fieldset__item__label label{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3,.radio-fieldset__item{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3,.radio-fieldset__item{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1,.radio-fieldset__item__input{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3,.radio-fieldset__item{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-auto,.radio-fieldset__item__input input{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.radio-fieldset__item,.row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10,.col-11,.col-12,.col-auto,.col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-auto,.col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-auto,.col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-auto,.radio-fieldset__item__input,.radio-fieldset__item__label{position:relative;width:100%;min-height:1px;padding-right:15px;padding-left:15px}.col{flex-basis:0;flex-grow:1;max-width:100%}.col-auto{flex:0 0 auto;width:auto;max-width:none}.col-1{flex:0 0 8.33333%;max-width:8.33333%}.col-2,.radio-fieldset__item__input{flex:0 0 16.66667%;max-width:16.66667%}.col-3{flex:0 0 25%;max-width:25%}.col-4{flex:0 0 33.33333%;max-width:33.33333%}.col-5{flex:0 0 41.66667%;max-width:41.66667%}.col-6{flex:0 0 50%;max-width:50%}.col-7{flex:0 0 58.33333%;max-width:58.33333%}.col-8{flex:0 0 66.66667%;max-width:66.66667%}.col-9{flex:0 0 75%;max-width:75%}.col-10,.radio-fieldset__item__label{flex:0 0 83.33333%;max-width:83.33333%}.col-11{flex:0 0 91.66667%;max-width:91.66667%}.col-12{flex:0 0 100%;max-width:100%}.order-first{order:-1}.order-last{order:13}.order-0{order:0}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.order-5{order:5}.order-6{order:6}.order-7{order:7}.order-8{order:8}.order-9{order:9}.order-10{order:10}.order-11{order:11}.order-12{order:12}.offset-1{margin-left:8.33333%}.offset-2{margin-left:16.66667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.33333%}.offset-5{margin-left:41.66667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.33333%}.offset-8{margin-left:66.66667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.33333%}.offset-11{margin-left:91.66667%}@media (min-width:576px){.col-sm{flex-basis:0;flex-grow:1;max-width:100%}.col-sm-auto{flex:0 0 auto;width:auto;max-width:none}.col-sm-1,.radio-fieldset__item__input{flex:0 0 8.33333%;max-width:8.33333%}.col-sm-2{flex:0 0 16.66667%;max-width:16.66667%}.col-sm-3{flex:0 0 25%;max-width:25%}.col-sm-4{flex:0 0 33.33333%;max-width:33.33333%}.col-sm-5{flex:0 0 41.66667%;max-width:41.66667%}.col-sm-6{flex:0 0 50%;max-width:50%}.col-sm-7{flex:0 0 58.33333%;max-width:58.33333%}.col-sm-8{flex:0 0 66.66667%;max-width:66.66667%}.col-sm-9{flex:0 0 75%;max-width:75%}.col-sm-10{flex:0 0 83.33333%;max-width:83.33333%}.col-sm-11{flex:0 0 91.66667%;max-width:91.66667%}.col-sm-12{flex:0 0 100%;max-width:100%}.order-sm-first{order:-1}.order-sm-last{order:13}.order-sm-0{order:0}.order-sm-1{order:1}.order-sm-2{order:2}.order-sm-3{order:3}.order-sm-4{order:4}.order-sm-5{order:5}.order-sm-6{order:6}.order-sm-7{order:7}.order-sm-8{order:8}.order-sm-9{order:9}.order-sm-10{order:10}.order-sm-11{order:11}.order-sm-12{order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333%}.offset-sm-2{margin-left:16.66667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333%}.offset-sm-5{margin-left:41.66667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333%}.offset-sm-8{margin-left:66.66667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333%}.offset-sm-11{margin-left:91.66667%}}@media (min-width:768px){.col-md{flex-basis:0;flex-grow:1;max-width:100%}.col-md-auto{flex:0 0 auto;width:auto;max-width:none}.col-md-1{flex:0 0 8.33333%;max-width:8.33333%}.col-md-2{flex:0 0 16.66667%;max-width:16.66667%}.col-md-3{flex:0 0 25%;max-width:25%}.col-md-4{flex:0 0 33.33333%;max-width:33.33333%}.col-md-5{flex:0 0 41.66667%;max-width:41.66667%}.col-md-6{flex:0 0 50%;max-width:50%}.col-md-7{flex:0 0 58.33333%;max-width:58.33333%}.col-md-8{flex:0 0 66.66667%;max-width:66.66667%}.col-md-9{flex:0 0 75%;max-width:75%}.col-md-10{flex:0 0 83.33333%;max-width:83.33333%}.col-md-11{flex:0 0 91.66667%;max-width:91.66667%}.col-md-12{flex:0 0 100%;max-width:100%}.order-md-first{order:-1}.order-md-last{order:13}.order-md-0{order:0}.order-md-1{order:1}.order-md-2{order:2}.order-md-3{order:3}.order-md-4{order:4}.order-md-5{order:5}.order-md-6{order:6}.order-md-7{order:7}.order-md-8{order:8}.order-md-9{order:9}.order-md-10{order:10}.order-md-11{order:11}.order-md-12{order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333%}.offset-md-2{margin-left:16.66667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333%}.offset-md-5{margin-left:41.66667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333%}.offset-md-8{margin-left:66.66667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333%}.offset-md-11{margin-left:91.66667%}}@media (min-width:992px){.col-lg{flex-basis:0;flex-grow:1;max-width:100%}.col-lg-auto{flex:0 0 auto;width:auto;max-width:none}.col-lg-1{flex:0 0 8.33333%;max-width:8.33333%}.col-lg-2{flex:0 0 16.66667%;max-width:16.66667%}.col-lg-3{flex:0 0 25%;max-width:25%}.col-lg-4{flex:0 0 33.33333%;max-width:33.33333%}.col-lg-5{flex:0 0 41.66667%;max-width:41.66667%}.col-lg-6{flex:0 0 50%;max-width:50%}.col-lg-7{flex:0 0 58.33333%;max-width:58.33333%}.col-lg-8{flex:0 0 66.66667%;max-width:66.66667%}.col-lg-9{flex:0 0 75%;max-width:75%}.col-lg-10{flex:0 0 83.33333%;max-width:83.33333%}.col-lg-11{flex:0 0 91.66667%;max-width:91.66667%}.col-lg-12{flex:0 0 100%;max-width:100%}.order-lg-first{order:-1}.order-lg-last{order:13}.order-lg-0{order:0}.order-lg-1{order:1}.order-lg-2{order:2}.order-lg-3{order:3}.order-lg-4{order:4}.order-lg-5{order:5}.order-lg-6{order:6}.order-lg-7{order:7}.order-lg-8{order:8}.order-lg-9{order:9}.order-lg-10{order:10}.order-lg-11{order:11}.order-lg-12{order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333%}.offset-lg-2{margin-left:16.66667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333%}.offset-lg-5{margin-left:41.66667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333%}.offset-lg-8{margin-left:66.66667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333%}.offset-lg-11{margin-left:91.66667%}}@media (min-width:1200px){.col-xl{flex-basis:0;flex-grow:1;max-width:100%}.col-xl-auto{flex:0 0 auto;width:auto;max-width:none}.col-xl-1{flex:0 0 8.33333%;max-width:8.33333%}.col-xl-2{flex:0 0 16.66667%;max-width:16.66667%}.col-xl-3{flex:0 0 25%;max-width:25%}.col-xl-4{flex:0 0 33.33333%;max-width:33.33333%}.col-xl-5{flex:0 0 41.66667%;max-width:41.66667%}.col-xl-6{flex:0 0 50%;max-width:50%}.col-xl-7{flex:0 0 58.33333%;max-width:58.33333%}.col-xl-8{flex:0 0 66.66667%;max-width:66.66667%}.col-xl-9{flex:0 0 75%;max-width:75%}.col-xl-10{flex:0 0 83.33333%;max-width:83.33333%}.col-xl-11{flex:0 0 91.66667%;max-width:91.66667%}.col-xl-12{flex:0 0 100%;max-width:100%}.order-xl-first{order:-1}.order-xl-last{order:13}.order-xl-0{order:0}.order-xl-1{order:1}.order-xl-2{order:2}.order-xl-3{order:3}.order-xl-4{order:4}.order-xl-5{order:5}.order-xl-6{order:6}.order-xl-7{order:7}.order-xl-8{order:8}.order-xl-9{order:9}.order-xl-10{order:10}.order-xl-11{order:11}.order-xl-12{order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333%}.offset-xl-2{margin-left:16.66667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333%}.offset-xl-5{margin-left:41.66667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333%}.offset-xl-8{margin-left:66.66667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333%}.offset-xl-11{margin-left:91.66667%}}.radio-fieldset__item{border-radius:1rem;border:1px solid #f8f9fa}.radio-fieldset__item--active{border-width:2px}.radio-fieldset__item{transition:.1s ease-out}.radio-fieldset__item--active{background-color:#e6f2ff}.radio-fieldset__item__input input[type=radio],input[type=radio].radio{width:30px;height:30px}.radio-fieldset__item{cursor:pointer}.radio-fieldset__item:not(.radio-fieldset__item--active):hover{background-color:#f2f4f6}.radio-fieldset__item__label label{color:#005092;font-weight:400;font-size:2rem;font-family:perpetua;pointer-events:all}:host{display:block}:host .explication{margin-bottom:0}", ""]);

// exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host .captcha-section{margin-top:5rem}:host h5{font-size:1.2rem;font-weight:600}", ""]);

// exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host h3{font-weight:300;font-family:Open Sans;margin-bottom:1rem}:host h5{margin:1rem}:host textarea{height:100px;padding-top:10px}:host .star-warning{color:#a00313}:host .cs-alert,:host .cs-section{margin:1% 0}:host .form-check{margin:.5% 1%}:host .error-msg{margin-top:2rem}:host .souhait-btn,:host .under-line{text-decoration:underline}:host .souhait-btn{border:none;background-color:#fff;font-size:medium;color:#e49a10}:host .litige-avocat{font-size:2rem;font-family:Open Sans,sans-serif;margin:1rem;color:#0b6ba8}:host .rapo-btn{border:none;text-decoration:underline;background-color:#f3f2ed}:host .list-cs{text-decoration:none;list-style-type:\"- \";padding-left:.2rem;margin:.5rem 0}:host .raison-no-document{margin:1% 0 1% 2%;width:98%}:host .exp{color:#5a4444}:host .char-counter{margin-top:1%;font-size:small;float:right}:host .detail-raison-contestation,:host .piece-in-multi-choice{margin-top:2rem;margin-left:2rem;margin-bottom:2rem}:host .alert-contestation{flex-grow:0}:host .autre-conc-litige-admin,:host .litige-avocat-exp{margin-top:2rem;margin-left:1rem}:host .montant-du-montant{width:30%;margin-left:2rem;margin-top:1rem}:host .raison-invalidation-titre-type{margin-top:1rem;margin-bottom:1rem;text-decoration:underline}.footer-centered{justify-content:space-between;padding-left:0;padding-right:0}.modal-title{font-family:Open Sans;margin-bottom:1.5rem}.modal-body{padding:0}.modal-header{margin:0;padding:0;border-bottom:0}.modal-footer{border-top:0}.btn-group{justify-content:right;margin-top:0}.modal-content{padding:2.5rem}.litige-modal-content{text-decoration:underline}.list-cs{text-decoration:none;list-style-type:\"- \";padding-left:.2rem;margin:.5rem 0}", ""]);

// exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .is-pressed{font-size:1.4em}", ""]);

// exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .obligatoire-hint{text-align:right}", ""]);

// exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host a{font-weight:600;text-decoration:underline}:host h3{font-weight:300;font-family:Open Sans;margin-bottom:1rem}:host .star-warning{color:#a00313}:host .form-check{margin:.5% 1%}:host .exp{color:#5a4444}:host .has-value{color:#5a4e4e}:host #question-concern-cs{margin-top:2%}:host .refere-alert-msg{margin-top:1rem}:host .refere-alert{text-decoration:underline}.footer-centered{justify-content:space-between;padding-left:0;padding-right:0}.modal-title{font-family:Open Sans;margin-bottom:1.5rem}.modal-body{padding:0}.modal-header{margin:0;padding:0;border-bottom:0}.modal-footer{border-top:0}.btn-group{justify-content:right;margin-top:0}.modal-content{padding:2.5rem}.dalo-btn{border:none;color:#5a4444;background-color:#f3f2ed}.cas-cs,.dalo-btn{text-decoration:underline}.list-cs{text-decoration:none;list-style-type:\"- \";padding-left:.2rem}.cas-cs-sublist{margin-left:-.5rem}", ""]);

// exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column}:host h3{font-weight:700;font-family:Open Sans;margin:1.5rem 0}:host .category-item-seperator:not(:last-child){display:flex;height:.06rem;background-color:#000;opacity:.125;margin:auto;margin:1rem 0 1.5rem 2.5rem}:host::ng-deep{display:flex;flex-direction:column;margin-left:2.5rem}:host::ng-deep h4,:host::ng-deep h5{font-family:Open Sans;font-weight:700}:host::ng-deep h4{font-size:1.3rem;margin-bottom:1rem}:host::ng-deep h5{font-size:1.2rem;margin-bottom:.6rem}:host::ng-deep h5,:host::ng-deep h5~p{margin-left:2.5rem}:host::ng-deep a{font-weight:600;text-decoration:underline}:host::ng-deep ul.condi{list-style-type:\"> \";margin-left:1rem}:host::ng-deep ul.condi>li{margin:1rem 0}:host::ng-deep ul.sub-condi{list-style-type:disc}:host::ng-deep ul.sub-condi>li{margin:1rem 0}:host::ng-deep ul.decision-jur,:host::ng-deep ul.situ-piece{margin-left:1rem}:host::ng-deep ul.decision-jur>li,:host::ng-deep ul.situ-piece>li{margin:1rem}:host::ng-deep table,:host::ng-deep td,:host::ng-deep th{border:1px solid #000}:host::ng-deep p.text-bold,:host::ng-deep span.text-bold{font-weight:700}:host::ng-deep .calcul-italic{font-style:italic}:host::ng-deep .tel{display:inline-flex;align-items:center;text-decoration:none;height:2rem;padding-left:.2rem;width:15rem;background:url(" + __webpack_require__(757) + ") no-repeat 50%;background-size:cover}:host::ng-deep .aide-jur{margin-left:-2.5rem}", ""]);

// exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column;width:100%}:host .content{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:left}:host .content .btn{color:#005092;font-style:italic}:host .highlight-item-seperator{display:flex;height:.05rem;background-color:#000;opacity:.125;margin:1rem 0}:host::ng-deep mark{background-color:#f4d73a}", ""]);

// exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column;margin:2.5rem 0}:host .search-header{display:flex;flex-direction:row;justify-content:space-between}:host .search-header h2{padding-left:0;margin-bottom:0}:host .search-header div.form-group{display:flex;align-items:center;border:none}:host .search-header div.form-group label{position:absolute;top:.5rem;padding-left:3rem;color:#5a4e4e}:host .search-header div.form-group input.ng-valid{border-radius:5rem;padding:1rem 2.5rem;height:2.5rem}:host .search-header div.form-group .fa-search{position:absolute;left:2rem}:host .search-header div.form-group .fa-remove{position:absolute;right:2rem}:host .search-header div.form-group .fa-remove:hover{cursor:pointer}:host .search-seperator{display:flex;height:.05rem;background-color:#000;opacity:.125;margin:.5rem 0}", ""]);

// exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column;margin-bottom:2rem}:host h3{font-weight:600;font-family:Open Sans;margin:1.5rem 0}:host li{display:list-item;font-weight:600;line-height:1.5rem;cursor:pointer;text-align:left;text-decoration:underline}:host ul{list-style-type:disc}", ""]);

// exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column}:host .category-seperator:not(:last-child){display:flex;height:.06rem;background-color:#000;opacity:.125;margin:1.5rem 0}:host .back-to-top{position:fixed;bottom:.7rem;right:.7rem;display:flex;align-self:flex-end;background-color:#00142e;padding-bottom:10px;padding-top:8px;color:#fff;font-weight:700;border:none}:host .back-to-top:hover{background-color:#093c7e}:host .back-to-top:focus{outline-offset:2px;outline:2px solid #2087c8;box-shadow:none;border-radius:4px}", ""]);

// exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".btn{height:146px;border-radius:2px;font-weight:600;white-space:normal}.welcome-block{background-color:#f3f2ed;padding:1rem;text-align:center;font-family:Open Sans}.welcome-block p{margin-bottom:0}.welcome-block a:hover{text-decoration:underline}.welcome-block .title{color:#0b6ba8;font-family:Open Sans,sans-serif;font-size:2.7rem;font-weight:500;margin-top:15px}.welcome-block .btn-group{justify-content:center;margin-top:2rem}@media screen and (max-width:768px){.welcome-block .btn-group{flex-direction:column}}.welcome-block .alert{background-color:#fff}.welcome-block .text-danger:before{content:\"\\F06A\"}.welcome-block .text-success{color:#016547!important}.welcome-block .text-success:before{content:\"\\F058\"}.welcome-block .section-draft{background-color:#fff;padding:1rem;text-align:left}.welcome-block .section-draft h4{color:#0b6ba8;font-family:Open Sans;font-weight:500}.welcome-block .section-draft .container-draft{display:flex;justify-content:center}.welcome-block .section-draft .container-draft .draft{flex:1;max-width:100%;background-color:#f3f2ed}.welcome-block .section-draft .container-draft .draft p{margin-top:1rem}.welcome-block .section-draft .container-draft .draft div{float:left}.welcome-block .section-draft .container-draft .vertical-line{position:relative;border-left:1px solid #d2d3d7;display:inline-block;height:100%;left:50%}.welcome-block .section-draft .container-draft .vertical-line span{position:relative;background:#f3f2ed;border-radius:50%;top:45%;padding:10px;z-index:1;right:50%}.hors-pers-m{color:#6e6e6e;font-size:.8rem;margin-top:3rem}.hors-pers-m a:hover{text-decoration:underline}.mes-dossiers{padding:0}", ""]);

// exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;justify-content:flex-end;margin:1rem 0}:host .filter-block{padding:0;margin:0}:host .filter-block label{word-spacing:.1em;font-weight:600;border:0;background-color:initial}:host .filter-block select.filter-block-custom-select{border-radius:0;min-width:10rem;border:1px solid #767676}", ""]);

// exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column;justify-items:center;margin:auto}:host .title{color:#0b6ba8;font-family:Open Sans,sans-serif;font-size:2rem}:host .cdk-table{display:flex;flex-direction:column;font-family:Open Sans;margin-bottom:2rem}:host .cdk-table .cdk-header-row{display:none}:host .cdk-table .cdk-row{position:relative;display:flex;flex-flow:column wrap;font-weight:600;margin-top:1rem;padding:.5rem 1rem;box-shadow:.1rem .1rem .1rem rgba(0,0,0,.11);box-sizing:border-box}:host .cdk-table .cdk-row.inactive{background-color:#f5f5f5}:host .cdk-table .cdk-row.active{background-color:#f0ede6}:host .cdk-table .cdk-row .cdk-cell{display:flex;flex-direction:column;box-sizing:border-box;padding:.5rem 0;line-height:1.2rem}@media screen and (max-width:768px){:host .cdk-table .cdk-row .cdk-cell.actions{position:absolute;top:25%;justify-items:center;align-self:flex-end}}:host .cdk-table .cdk-row .cdk-cell.actions .btn-circle{display:flex;align-items:center;justify-content:center;background:#fff;width:2rem;height:2rem;margin:.5rem 0}:host .cdk-table .cdk-row .cdk-cell.actions .btn-circle:hover{color:#fff;background:#005092}:host .cdk-table .cdk-row.linked{font-family:Open Sans;margin-top:0}:host .cdk-table .cdk-row.linked:before{position:absolute;left:2rem;display:flex;justify-content:center;height:.1rem;width:calc(100% - 2rem * 2);content:\" \";background-color:#fff;transform:translateY(-.6rem)}:host .cdk-table .cdk-row.linked:after{position:absolute;right:50%;display:flex;justify-content:center;align-items:center;font-family:FontAwesome;height:1.6rem;width:1.6rem;border-radius:.8rem;background-color:#fff;color:#e2dcce;content:\"\\F07D\";transform:translateY(-1.4rem)}:host .header-cell-small{display:flex;margin:0;font-family:Open Sans;font-weight:700;font-size:1rem;text-transform:uppercase}@media screen and (min-width:768px){:host .cdk-table{flex-direction:column;color:#707070}:host .cdk-table .cdk-header-row{display:flex;margin-top:1rem;text-transform:uppercase;padding:0 1rem}:host .cdk-table .cdk-header-row .cdk-header-cell{display:flex;font-weight:700;font-size:.9rem;cursor:pointer}:host .cdk-table .cdk-row{flex-direction:row;flex-wrap:nowrap;color:#3d3c3c}:host .cdk-table .cdk-row .cdk-cell{align-items:flex-start;justify-content:center;padding:.2rem 0}:host .cdk-table .cdk-row .cdk-cell.actions{align-items:center;flex-direction:row;justify-content:space-evenly}:host .cdk-table .cdk-row .cdk-cell.actions .btn-circle{margin:0}:host .cdk-table .cdk-cell-1,:host .cdk-table .cdk-header-cell-1{width:10rem}:host .cdk-table .cdk-cell-4,:host .cdk-table .cdk-header-cell-4{width:13rem}:host .cdk-table .cdk-cell-5,:host .cdk-table .cdk-header-cell-5{width:5rem}:host .cdk-table .cdk-cell-2,:host .cdk-table .cdk-cell-3,:host .cdk-table .cdk-header-cell-2,:host .cdk-table .cdk-header-cell-3{box-sizing:border-box;width:calc((100% - 10rem - 13rem - 5rem) / 2);margin:0 .5rem}:host .header-cell-small{display:none}}:host jhi-alert{position:fixed;right:0;left:0;bottom:1rem}:host .btn-avis{display:flex;align-self:center;width:200px;height:64px;left:583px;margin-top:40px;border-radius:0}:host .container{margin-left:0;padding-left:0;display:flex;flex-flow:row nowrap;justify-content:flex-start}:host .status-text{margin-right:2%}:host .en-cours-denvoi-btn{padding-top:0;background-color:#f0ede6;font-size:80%;position:relative;top:-20%;left:-2%}:host .fa-exclamation-circle{color:#a00313}", ""]);

// exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;font-family:Open Sans;font-weight:700;font-size:1rem;margin-bottom:1rem}:host .sort-block{padding:0;margin:0}:host .sort-block label{word-spacing:.1em;font-weight:600;border:0;background-color:initial}:host .sort-block select{border-radius:0}@media screen and (min-width:768px){:host{display:none}}", ""]);

// exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column;width:100%}:host input{display:inline-block;vertical-align:top;margin-left:1rem}", ""]);

// exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:inline-flex;color:#005092}:host .fa-fw{text-align:left}", ""]);

// exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host,:host h2{display:flex;font-family:Open Sans}:host h2{justify-content:center;font-size:2.2rem;font-weight:600;margin:4rem auto}:host .btn-error{height:8rem;font-size:1.5rem}:host .btn-error:last-child i{margin-right:.2rem}:host .icon{font-size:4rem;margin:4rem auto 0}", ""]);

// exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".accessibilite{display:block;color:#000}.accessibilite section{font-style:normal;font-weight:400;font-size:17px;line-height:26px;letter-spacing:0;text-align:left;margin:40px 0}.accessibilite .acces-rapide{font-family:Open Sans;color:#4e5a62}.accessibilite section a{color:#797676;font-weight:400;font-size:17px;line-height:23px;border-bottom:1px solid #e1e1e1}.accessibilite section a:hover{text-decoration:none;border-bottom:0}.accessibilite section h3,.accessibilite section h4,.accessibilite section h5{font-size:25px}.accessibilite section h3{font-weight:600;line-height:34px}.accessibilite section h4{font-weight:400;line-height:150%}.accessibilite section ul li{color:#000;line-height:150%}.accessibilite section ul li .address{display:inline-block}.accessibilite section ul li i{color:#797676;font-size:1.3rem;position:relative;bottom:-.2rem;padding-left:.5rem}.accessibilite .link-list{list-style:none}.accessibilite .link-list li:before{content:\"\\2022\";color:#797676;font-weight:700;display:inline-block;width:1em;margin-left:-1em}.accessibilite .test-outils{display:flex;flex-direction:column;gap:1rem;justify-content:space-between}.accessibilite .test-env{list-style:none}.accessibilite .pseudo-link{color:#797676;font-weight:400;font-size:17px;line-height:23px}.accessibilite .address-list{list-style:none;font-weight:600}.accessibilite section p{color:#000}.accessibilite section pre{color:#000;line-height:37.5px;margin:0;padding:0}.accessibilite .title{color:#0b6ba8;font-size:3rem;font-weight:400;line-height:150%}.accessibilite .accessibilite-seperator{border:1px solid #e0e0e0;width:1061px;margin-top:2.5rem;margin-bottom:2rem}", ""]);

// exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host(jhi-footer){width:100%;min-height:5px}.footer{padding:10px 0}hr{margin-bottom:0;margin-top:1em}.copyright,a,span{text-align:center;height:12px;line-height:normal;letter-spacing:-.2px;color:#5a5858}li,ul{display:inline-block}li{margin:4px 20px}.copyright a{border-bottom:1px solid #e1e1e1}.copyright a:hover{text-decoration:none;border-bottom:0}", ""]);

// exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "table{width:100%;margin-bottom:.8em}td,th{border:1px solid #212529;padding:2px 10px}th{text-align:center}td{font-size:90%}a{color:#005092;font-weight:600;text-decoration:underline}", ""]);

// exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".personal-data{display:block;font-family:Open Sans}.personal-data .summary{color:#797676}.personal-data .summary ul{list-style:disc}.personal-data .summary li a{color:#797676!important}.personal-data h2,.personal-data h3,.personal-data h4,.personal-data h5{font-family:Perpetua}.personal-data h2{font-size:42px;color:#315870}.personal-data h3{color:#2f373d}.personal-data h4{color:#166393}.personal-data h5{color:#315870;font-size:24px;font-weight:400;line-height:28px}.personal-data .hint{color:#4e5a62}.personal-data section{font-style:normal;font-weight:400;font-size:17px;line-height:25px;letter-spacing:0;text-align:left;margin:40px 0}.personal-data section p{color:#000}.personal-data section ul{margin:0}.personal-data section a{-webkit-text-decoration-line:underline;text-decoration-line:underline;color:#797676}.personal-data em{margin-left:.5rem}.personal-data table{width:100%;margin-bottom:.8em}.personal-data table th{font-size:70%;color:#707070}.personal-data table td{font-size:90%;background-color:#f3f2ed}", ""]);

// exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;font-weight:600;line-height:1.2rem}:host:before{display:flex;align-self:center;content:\" >\";width:.45rem;height:.45rem;background-color:#464a4c;margin-right:.7rem}:host.sub-item{font-weight:400;margin-left:2.2rem;line-height:.8rem}:host.sub-item:before{width:.45rem;height:.45rem;border-radius:50%}", ""]);

// exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{flex-wrap:wrap}:host,:host .plan-container{display:flex;flex-direction:column}:host .plan-container{max-width:800px}", ""]);

// exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".container-main{padding:0 0 4rem;min-height:770px;display:block;box-sizing:border-box;max-width:100%;overflow-x:hidden}.skip{position:absolute;top:7.5rem;left:2rem;font-size:1rem;padding:.7rem;color:#005092;font-weight:700;border:none;border-radius:.2rem;background-color:#fff;box-shadow:0 .2rem .5rem .1rem rgba(0,0,0,.25);opacity:0}.skip:focus{opacity:1;z-index:1}", ""]);

// exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".navbar-version{font-size:10px;color:#ccc}.jh-navbar{padding:.2em 1em;background-color:#00142e}.jh-navbar .profile-image{margin:-10px 0;height:40px;width:40px;border-radius:50%}.jh-navbar .dropdown-item.active,.jh-navbar .dropdown-item.active:focus,.jh-navbar .dropdown-item.active:hover{background-color:#353d47}.jh-navbar .dropdown-toggle:after{margin-left:.15em}.jh-navbar ul.navbar-nav{padding:.5em}.jh-navbar ul.navbar-nav .nav-item{margin-left:.8rem}.jh-navbar a.nav-link{font-weight:400;color:#a5a6a7}.jh-navbar a.nav-link:hover{color:#f0f2f4}.jh-navbar .jh-navbar-toggler{color:#ccc;font-size:1.5em;padding:10px}.jh-navbar .jh-navbar-toggler:hover{color:#fff}.nav-item.active span{border-bottom:2px solid #fff;font-weight:700;color:#fff;padding-bottom:5px}@media screen and (max-width:992px){.jh-logo-container{width:100%}}.navbar-brand{display:flex;justify-content:center}.navbar-brand .logo-img{height:6rem;width:20vw;max-width:170px;display:inline-block;background:url(" + __webpack_require__(758) + ") no-repeat 50%;background-size:contain}.navbar-brand div{align-self:center}.logout:before{content:\" | \";width:1px;height:15px;margin-right:1.5rem;color:#d5d5d5}.navbar-title{letter-spacing:-1.1px;text-align:left;color:#fff;display:inline-block;vertical-align:middle;font-size:2rem;white-space:normal;width:38vw}@media screen and (min-width:1200px){.navbar-title{width:30vw}}.collapse.show{position:relative;z-index:999;background-color:#00142e}", ""]);

// exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".ribbon{background-color:rgba(170,0,0,.5);left:-3.5em;overflow:hidden;position:fixed;bottom:0;white-space:nowrap;width:15em;z-index:9999;opacity:.75}.ribbon,.ribbon a{pointer-events:none}.ribbon a{color:#fff;display:block;font-weight:400;margin:1px 0;padding:10px 50px;text-align:center;text-decoration:none;text-shadow:0 0 5px #444}", ""]);

// exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block;max-width:800px;margin:auto}:host .fa-envelope-o{color:#9c8c8c}", ""]);

// exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .explication{font-size:.8rem;color:#7a6262;font-style:italic}", ""]);

// exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "section{margin-bottom:3rem}.name,jhi-file-uploader{margin-top:.5rem;margin-bottom:.5rem}.handle{display:flex;align-items:center;justify-content:center}.gu-transit{background-color:#d3d3d3}.input-group{padding-right:.3rem}.input-group-append{align-items:center;padding:0 .7rem;cursor:pointer}.rename-check{display:flex;justify-content:center;align-items:center}.rename-check input{margin-right:1rem}.btn-group div{margin-bottom:.6rem}.btn-group .btn-link{margin-top:1rem}.is-pressed{font-size:1.4em}", ""]);

// exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "h2{font-family:Open Sans;font-size:14px;color:#5a4444;text-transform:uppercase;font-weight:400}.sidebar>div{margin-bottom:1.3em}.sidebar p{font-weight:600;line-height:1.2;width:100%;margin-bottom:.5em}div.btn{display:flex;align-items:stretch;min-height:5rem;margin:1em 0;padding:0;white-space:normal}div.btn a{color:inherit;display:flex;align-items:center;justify-content:space-between;padding:1em;width:100%}div.btn a .fa{margin-right:.5em;font-size:1.5em}div.btn a:active,div.btn a:hover{text-decoration:none;color:inherit}.inverser-lordre-chr{font-family:Open Sans;font-size:1rem;text-align:right;border:none;background-color:#fff;color:#005092;text-decoration:underline}.container-inline{display:flex;justify-content:space-between}.edit-button{cursor:pointer;padding-left:.3rem}.alias-container{align-items:center;display:flex}.abbreviate-container{max-width:calc(100% - 17px - .3rem)}button.no-border{border:none;background-color:#fff}", ""]);

// exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column}:host .error{color:#a00313}", ""]);

// exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".autre-partie{background-color:#fafafa}.communication-juridiction{border-radius:2px;border:2px solid #e2dcce}.lecteur{background-color:#f3f2ec}.avocat,.defendeur{background-color:#e2dcce}.date{color:#5a4444;font-size:14px}.puce{border:1px solid #9c8c8c;background-color:#fff;border-radius:1rem;box-shadow:0 0 5px rgba(0,0,0,.1);content:\"\";height:1rem;width:1rem}.center,.puce{margin:auto}.puce-container{margin-top:.5rem}.puce-container:after{background-color:#9c8c8c;content:\"\";height:calc(100% + 1.6rem);left:50%;position:absolute;width:1px}div#qualite{font-size:18px;color:#9c8c8c;text-transform:uppercase}div#mesure{font-family:Open Sans;font-size:1rem;font-weight:600;font-style:normal;font-stretch:normal;letter-spacing:normal;color:#4a4a4a}.divider{height:1rem;background-color:#fff;width:100%}.accuseLecture{font-style:italic;color:#5a4444;font-size:14px;text-transform:none}hr{margin:.5rem 0}.fichier{font-size:14px}.fichier a{color:#000}.fichier-libelle{text-decoration:underline}@media screen and (max-width:768px){.fichier a{text-decoration:underline}}a{word-wrap:break-word}.destinataire,.expediteur{line-height:normal;color:#5a4444}.destinataire,.destinataire_nom,.expediteur,.expediteur_nom{font-family:Open Sans;font-weight:400;font-style:normal;font-stretch:normal;letter-spacing:normal}.destinataire_nom,.expediteur_nom{color:#4a4a4a}.titre-timeline{text-transform:uppercase}button.no-border{border:none;cursor:pointer}", ""]);

// exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".timelineElement{clear:both;margin:.8rem 0}.timelineElement:last-child{margin-bottom:0}.timelineElement:last-child /deep/ .puce-container:after{content:none}.timelineElement:first-child{margin-top:0}div.timeline{font-size:1rem}", ""]);

// exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "span{display:inline-block;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;vertical-align:top}", ""]);

// exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block;padding:2rem}", ""]);

// exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column}:host h4{font-size:20px;margin-top:-1rem;text-transform:uppercase}:host h4 em.fa{margin-right:1rem}.container-inline{display:flex;justify-content:space-around}.banner-subtitle{margin-top:0;margin-bottom:2rem;overflow-wrap:break-word;display:inline;line-height:1.4rem;font-family:Open sans,sans-serif;font-size:1.2rem;font-weight:300}", ""]);

// exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .container-fuild{display:flex;flex-wrap:wrap;color:#fff;background-color:#a00313}:host .exclamation-icon{font-size:80px;text-align:center;justify-content:center;width:7%}:host .exclamation-icon>i{position:relative;top:calc(50% - 60px)}:host .adblock-warning-title{margin:1.5%;float:left;font-family:Open Sans,sans-serif;font-weight:700}:host .adblock-warning-text{margin:1.5%}@media screen and (max-width:1183px){:host .container-fuild{display:flex;flex-direction:column}:host .exclamation-icon{width:100%;text-align:center}}", ""]);

// exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-wrap:wrap}", ""]);

// exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}@media screen and (min-width:991px){:host{margin-bottom:60px;min-height:80px}}:host .col{flex-basis:fit-content}:host li:after{content:\"\";height:1.5rem;width:1.5rem;background-color:#fff;border:.2rem solid #9c8c8c;border-radius:50%;position:absolute;bottom:-3rem;right:50%;z-index:10}:host li.active:after{border:.2rem solid #7a6262}:host li.active:after,:host li.validated:after{background-color:#9c8c8c}:host .titre{color:#7a6262}", ""]);

// exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host audio{display:none}:host a{margin-bottom:.3rem}:host .form-group{margin-top:.2rem}:host img{margin-left:auto;margin-right:auto;display:block}:host .btn-circle{display:flex;align-items:center;justify-content:center;background:#fff;width:2rem;height:2rem;margin:.5rem 0}:host .btn-circle:hover{color:#fff;background:#005092}", ""]);

// exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host::ng-deep h2{font-weight:600;font-family:Open Sans,sans-serif;margin-bottom:2rem;text-align:center}:host::ng-deep .version .date_version{display:flex;flex-direction:row;align-items:center;margin-bottom:1rem}:host::ng-deep .version .date_version h2{font-size:1.5rem;margin-bottom:0;font-weight:600;font-family:Open Sans,sans-serif;text-align:left}:host::ng-deep .version .date_version i{width:5%;display:flex;justify-content:center;font-size:1.5rem}@media only screen and (max-width:480px){:host::ng-deep .version .date_version i{width:10%}}:host::ng-deep .version .important_message{background-color:#f3f2ed;border-radius:.15rem;padding:1rem}:host::ng-deep .version .problem{background-color:#fafafa;border-radius:.15rem;padding:1rem;display:flex;flex-direction:row;align-items:center}:host::ng-deep .version .problem p{margin-bottom:0}:host::ng-deep .version .problem i{width:10%;display:flex;justify-content:center;font-size:1.5rem}:host::ng-deep .version:not(:last-child):after{border-bottom:2px solid #f3f2ed;margin-bottom:1rem;display:block;content:\"\"}", ""]);

// exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host::ng-deep{display:block;margin-bottom:2rem;margin-top:2rem}:host::ng-deep .cgu_point{display:flex;align-items:center;margin-bottom:2rem}:host::ng-deep .cgu_point p{font-size:1rem;justify-content:flex-end;margin-top:0;margin-bottom:0}:host::ng-deep .cgu_point span{font-size:1rem}@media screen and (max-width:576px){:host::ng-deep .cgu_point{flex-direction:column}}:host::ng-deep .row{margin-top:1rem}:host::ng-deep .row p{font-size:1rem;text-align:left}@media screen and (max-width:576px){:host::ng-deep .row,:host::ng-deep .row p{text-align:center}}:host::ng-deep .numberCircle{font-size:2rem;padding:0 1rem;height:2.5rem;box-sizing:initial;background:#fff;border:.09rem solid #666;color:#666;text-align:center;border-radius:50%;line-height:2.5rem;margin-right:2.5rem;flex-grow:0}@media screen and (max-width:576px){:host::ng-deep .numberCircle{margin-top:1.5rem;margin-bottom:1.5rem;text-align:center}}:host::ng-deep .scollbarStyle{overflow-y:scroll;border:1px solid #979797}:host::ng-deep .scollbarStyle div{height:43rem;margin:1rem}:host::ng-deep br{display:block;margin:.3rem 0}:host::ng-deep h1{line-height:2rem;margin-bottom:2rem}", ""]);

// exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-wrap:wrap;width:100%}", ""]);

// exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".footer-centered{justify-content:space-between;padding-left:0;padding-right:0}.modal-title{font-family:Open Sans;margin-bottom:1.5rem}.modal-body{padding:0}.modal-header{margin:0;padding:0;border-bottom:0}.modal-content{padding:2.5rem}.modal-footer{border-top:0}.modal-footer .btn-group{margin-top:inherit}.btn-group{justify-content:right}", ""]);

// exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{width:100%;padding:.5rem 2rem;background-color:#042d58;box-shadow:.1rem .1rem .2rem rgba(0,0,0,.11);border-radius:2px;color:#fff}:host,:host .main-content{display:flex;justify-content:space-between}:host .main-content{flex:1;flex-wrap:wrap}:host .address-card,:host .info-cards,:host .requerant-card{flex:1}:host .address-card,:host .info-card,:host .requerant-card{display:flex;align-items:baseline;min-width:15rem;margin:.5rem 0}:host .address-card .fa,:host .info-card .fa,:host .requerant-card .fa{margin-right:1rem}:host .info-cards{flex-direction:column}:host .requerant-card{flex-wrap:wrap;flex:2;margin-top:0rem;margin-bottom:0rem}:host .requerant-card.with-principal-button{margin-top:-.5rem}:host .requerant-card .card-content{margin-right:2rem}:host .requerant-card div,:host .requerant-card jhi-button{margin-top:.5rem;margin-bottom:.5rem}:host .info-card .name{font-weight:600}:host .button{width:3rem;height:3rem;min-width:3rem;min-height:3rem;margin-left:1rem;align-self:center}:host .button .btn-circle{background-color:#fff}:host .button .fa:before{content:\"\\F044\"}:host[added-list],:host[result-list]{background-color:#f3f2ed;color:#3a3a3a}:host[result-list] .button .btn-circle{color:#005092}:host[result-list] .button .btn-circle .fa:before{content:\"\\F234\"}:host[added-list] .button .btn-circle{color:#7e0b09;background:#fff}:host[added-list] .button .btn-circle .fa:before{content:\"\\F235\"}:host[added-list] .button .btn-circle:hover{background-color:#7e0b09;color:#fff}", ""]);

// exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block;width:100%}:host .input-group{padding-right:.3rem}:host .input-group-append{align-items:center;padding:0 .7rem;cursor:pointer}:host input[type=file]:disabled{opacity:0}:host input[readonly]{background:transparent}:host label{color:#5a4e4e}:host .uploading{background:repeating-linear-gradient(-90deg,transparent,transparent 20px,#e9e9e5 0,#e9e9e5 40px);animation:progressBackground 3s linear alternate infinite;box-shadow:none}:host .download-btn:focus,:host .input-group-append:focus{z-index:1}:host .trash-btn{margin-right:-.25rem;border-radius:4px}:host .add-btn{background-color:unset}:host .input-group-append:focus{outline-offset:2px;outline:2px solid #2087c8;box-shadow:none;border-radius:4px}@keyframes progressBackground{0%{background-position:6rem 0}to{background-position:0 0}}button{border:none}", ""]);

// exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .isLoading:host[deletion],:host .shadow,:host :host[deletion]:active,:host :host[deletion]:hover,:host[cancellation] button.isLoading,:host[cancellation] button:active,:host[cancellation] button:hover,:host[confirmation] button.isLoading,:host[confirmation] button:active,:host[confirmation] button:hover,:host[outline-secondary] button.isLoading,:host[outline-secondary] button:active,:host[outline-secondary] button:hover,:host[saving] button.isLoading,:host[saving] button:active,:host[saving] button:hover,:host[secondary] button.isLoading,:host[secondary] button:active,:host[secondary] button:hover,:host button.isLoading,:host button:active,:host button:hover{box-shadow:0 0 .8rem rgba(0,0,0,.56)}:host[secondary] button{background-color:#fff;color:#3d3c3c}:host[secondary] button:hover{background-color:#f9f9f9}:host[secondary] button.isLoading,:host[secondary] button:active{background-color:#efefef}:host[secondary][flat] button{background-color:#fbfbfb;color:#525558;border-color:#525558}:host[secondary][flat] button:active,:host[secondary][flat] button:hover{color:#3a3a3a;background-color:#fff;border-color:#6c757d}:host[outline-secondary] button{background-color:#fff;color:#3d3c3c}:host[outline-secondary] button:hover{background-color:#005092;color:#fff}:host[outline-secondary] button.isLoading,:host[outline-secondary] button:active{background-color:#042d58;color:#fff}:host[cancellation] button{background-color:#595959}:host[cancellation] button:hover{background-color:#5b5b5b}:host[cancellation] button.isLoading,:host[cancellation] button:active{background-color:#4b4b4b}:host[confirmation] button{background-color:#016547}:host[confirmation] button:hover{background-color:#014c35}:host[confirmation] button.isLoading,:host[confirmation] button:active{background-color:#013d2b}:host[saving] button{color:#3d3c3c}:host[saving] button,:host[saving] button:hover{background-color:#fff}:host[saving] button.isLoading,:host[saving] button:active{background-color:#fcfcfc}:host[deletion]{background-color:#fff}:host[deletion]:hover{background-color:#f9f9f9}:host[deletion].isLoading,:host[deletion]:active{background-color:#efefef}:host[iconRight] button i.icon{order:3;margin-left:1rem;margin-right:0}:host[flat] button{box-shadow:none;border:1px solid;padding:.5rem .8rem}:host[flat] button:active,:host[flat] button:hover{box-shadow:none}:host button{display:flex;position:relative;flex-direction:row;align-items:baseline;justify-content:center;font-family:Open Sans;font-size:1rem;padding:.9rem;color:#fff;border:none;border-radius:.2rem;background-color:#005092;box-shadow:0 .2rem .5rem .1rem rgba(0,0,0,.25);width:100%}:host button:not(:disabled):not(.disabled){cursor:pointer}:host button:disabled{cursor:default;opacity:.5}:host button:hover{background-color:#004a87}:host button.isLoading,:host button:active{background-color:#042d58;z-index:150}:host button i.icon{font-size:1.1rem;margin-left:0;margin-right:1rem}:host button span.label{display:inline-flex;flex:1;font-weight:600}:host .overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:100;background:#6c757d;animation-delay:3s;animation-name:overlayPage;animation-duration:30s;animation-fill-mode:both;animation-direction:alternate;animation-iteration-count:infinite}@keyframes overlayPage{0%{opacity:0}to{opacity:.5}}@media only screen and (max-width:320px){:host,:host button{width:100%}}", ""]);

// exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}", ""]);

// exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .label-text{padding-left:.5rem}:host input{margin-top:.7em}", ""]);

// exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block;padding:0;margin:0}", ""]);

// exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{background-color:#fff;display:none}:host:not(.hidden){display:block}:host label{z-index:10;color:#5a4e4e}:host small{color:#5a4e4e!important}:host .input-group-addon-btn{background-color:unset;border:unset}", ""]);

// exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:none}:host.display-message{display:flex}", ""]);

// exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:none;margin-top:5px}:host.show-messages{display:block}", ""]);

// exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host label{color:#5a4e4e}", ""]);

// exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host button{display:block;background:url(" + __webpack_require__(536) + ") no-repeat 50%;background-size:contain;height:100px;width:100%;border:1px solid #005092}:host button,:host p{max-width:32rem;margin:auto}:host p{margin-top:10px;color:#767676;font-size:14px;line-height:24px}:host p a{color:#767676;text-decoration:underline;font-style:italic}", ""]);

// exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-wrap:wrap;width:100%}", ""]);

// exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column;width:100%}", ""]);

// exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-wrap:wrap;width:100%}", ""]);

// exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .jumbotron-container{margin-bottom:2rem;min-height:4rem;display:flex}:host .jumbotron-container .jumbotron-content{flex:1;padding:1rem 2rem;background:#f2eeeb}:host .jumbotron-container .jumbotron-content::ng-deep h1{margin:0;font-size:3.2rem;font-family:Perpetua;color:#2c2f33}:host .jumbotron-container .jumbotron-image{display:none;flex:1;background:url(" + __webpack_require__(759) + ") 0 no-repeat #f2eeeb;background-size:cover}@media screen and (min-width:768px){:host .jumbotron-container{min-height:6rem}:host .jumbotron-container .jumbotron-content{padding:3rem}:host .jumbotron-container .jumbotron-content::ng-deep h1{font-size:4rem;font-weight:400;line-height:4.5rem}:host .jumbotron-container .jumbotron-image{display:block}}", ""]);

// exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block}:host .input-group{padding-right:.3rem}:host .input-group .input-group-append{cursor:pointer;padding:0 .7rem}:host .input-group.piece-postale-adder input{padding-top:0}", ""]);

// exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;justify-content:center}:host .loading-block{display:flex;flex-direction:column;text-align:center;font-family:Open Sans;padding:2rem 0}:host .loading-block em{font-size:2rem}", ""]);

// exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:flex;flex-direction:column;padding:0;margin-bottom:3rem}:host .section-header{display:inline-flex;margin-bottom:.5rem;align-items:baseline;color:#0b6ba8;font-family:Open Sans,sans-serif;font-weight:300;font-size:2.2rem}:host .section-header .section-index{margin-right:5px}:host .section-header .section-index:after{content:\".\";margin-right:5px}:host .section-header::ng-deep h2{width:inherit;font-family:Open Sans,sans-serif;font-weight:300;font-size:2.2rem}:host .help-icon{margin-left:20px;font-size:27px;cursor:pointer;color:#005092}:host .section-body,:host .section-help{display:flex;background-color:#fff;width:100%}:host .section-body{flex-direction:column;z-index:5}:host .section-help{z-index:4}", ""]);

// exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host .container-fuild{display:flex;flex-wrap:nowrap;color:#a00313;background-color:#fcefef}:host .exclamation-icon{margin:1.5rem}:host .info{margin-top:1rem}", ""]);

// exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ":host{display:block;padding:2rem}:host .alert-danger a{color:#f8f9fa;text-decoration:underline}:host .alert-danger a:hover{color:#bdc6d0}:host label{pointer-events:all!important}:host .form-check>input,:host .form-check>label{cursor:pointer}", ""]);

// exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".block{background-color:#f3f2ed;margin-top:3em;margin-bottom:3em;padding:2em}.block p{margin-bottom:2em}.block p:first-child{font-weight:700;font-size:20px;line-height:27px;color:#315870}", ""]);

// exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(undefined);
// imports


// module
exports.push([module.i, ".sz-30px{width:30px;height:30px}@media only screen and (min-width:992px){.btn--join-user-club{transform:translateX(-3rem)}}@media only screen and (max-width:768px){.btn--join-user-club{width:100%}}@media only screen and (min-width:992px){.pl-lg-6{padding-left:5.5rem}}.bg-primary-blue{background-color:#042d58}", ""]);

// exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var NativeCustomEvent = global.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

module.exports = useNative() ? NativeCustomEvent :

// IE >= 9
'undefined' !== typeof document && 'function' === typeof document.createEvent ? function CustomEvent (type, params) {
  var e = document.createEvent('CustomEvent');
  if (params) {
    e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
  } else {
    e.initCustomEvent(type, false, false, void 0);
  }
  return e;
} :

// IE <= 8
function CustomEvent (type, params) {
  var e = document.createEventObject();
  e.type = type;
  if (params) {
    e.bubbles = Boolean(params.bubbles);
    e.cancelable = Boolean(params.cancelable);
    e.detail = params.detail;
  } else {
    e.bubbles = false;
    e.cancelable = false;
    e.detail = void 0;
  }
  return e;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cache = {};
var start = '(?:^|\\s)';
var end = '(?:\\s|$)';

function lookupClass (className) {
  var cached = cache[className];
  if (cached) {
    cached.lastIndex = 0;
  } else {
    cache[className] = cached = new RegExp(start + className + end, 'g');
  }
  return cached;
}

function addClass (el, className) {
  var current = el.className;
  if (!current.length) {
    el.className = className;
  } else if (!lookupClass(className).test(current)) {
    el.className += ' ' + className;
  }
}

function rmClass (el, className) {
  el.className = el.className.replace(lookupClass(className), ' ').trim();
}

module.exports = {
  add: addClass,
  rm: rmClass
};


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var emitter = __webpack_require__(538);
var crossvent = __webpack_require__(653);
var classes = __webpack_require__(755);
var doc = document;
var documentElement = doc.documentElement;

function dragula (initialContainers, options) {
  var len = arguments.length;
  if (len === 1 && Array.isArray(initialContainers) === false) {
    options = initialContainers;
    initialContainers = [];
  }
  var _mirror; // mirror image
  var _source; // source container
  var _item; // item being dragged
  var _offsetX; // reference x
  var _offsetY; // reference y
  var _moveX; // reference move x
  var _moveY; // reference move y
  var _initialSibling; // reference sibling when grabbed
  var _currentSibling; // reference sibling now
  var _copy; // item used for copying
  var _renderTimer; // timer for setTimeout renderMirrorImage
  var _lastDropTarget = null; // last container item was over
  var _grabbed; // holds mousedown context until first mousemove

  var o = options || {};
  if (o.moves === void 0) { o.moves = always; }
  if (o.accepts === void 0) { o.accepts = always; }
  if (o.invalid === void 0) { o.invalid = invalidTarget; }
  if (o.containers === void 0) { o.containers = initialContainers || []; }
  if (o.isContainer === void 0) { o.isContainer = never; }
  if (o.copy === void 0) { o.copy = false; }
  if (o.copySortSource === void 0) { o.copySortSource = false; }
  if (o.revertOnSpill === void 0) { o.revertOnSpill = false; }
  if (o.removeOnSpill === void 0) { o.removeOnSpill = false; }
  if (o.direction === void 0) { o.direction = 'vertical'; }
  if (o.ignoreInputTextSelection === void 0) { o.ignoreInputTextSelection = true; }
  if (o.mirrorContainer === void 0) { o.mirrorContainer = doc.body; }

  var drake = emitter({
    containers: o.containers,
    start: manualStart,
    end: end,
    cancel: cancel,
    remove: remove,
    destroy: destroy,
    canMove: canMove,
    dragging: false
  });

  if (o.removeOnSpill === true) {
    drake.on('over', spillOver).on('out', spillOut);
  }

  events();

  return drake;

  function isContainer (el) {
    return drake.containers.indexOf(el) !== -1 || o.isContainer(el);
  }

  function events (remove) {
    var op = remove ? 'remove' : 'add';
    touchy(documentElement, op, 'mousedown', grab);
    touchy(documentElement, op, 'mouseup', release);
  }

  function eventualMovements (remove) {
    var op = remove ? 'remove' : 'add';
    touchy(documentElement, op, 'mousemove', startBecauseMouseMoved);
  }

  function movements (remove) {
    var op = remove ? 'remove' : 'add';
    crossvent[op](documentElement, 'selectstart', preventGrabbed); // IE8
    crossvent[op](documentElement, 'click', preventGrabbed);
  }

  function destroy () {
    events(true);
    release({});
  }

  function preventGrabbed (e) {
    if (_grabbed) {
      e.preventDefault();
    }
  }

  function grab (e) {
    _moveX = e.clientX;
    _moveY = e.clientY;

    var ignore = whichMouseButton(e) !== 1 || e.metaKey || e.ctrlKey;
    if (ignore) {
      return; // we only care about honest-to-god left clicks and touch events
    }
    var item = e.target;
    var context = canStart(item);
    if (!context) {
      return;
    }
    _grabbed = context;
    eventualMovements();
    if (e.type === 'mousedown') {
      if (isInput(item)) { // see also: https://github.com/bevacqua/dragula/issues/208
        item.focus(); // fixes https://github.com/bevacqua/dragula/issues/176
      } else {
        e.preventDefault(); // fixes https://github.com/bevacqua/dragula/issues/155
      }
    }
  }

  function startBecauseMouseMoved (e) {
    if (!_grabbed) {
      return;
    }
    if (whichMouseButton(e) === 0) {
      release({});
      return; // when text is selected on an input and then dragged, mouseup doesn't fire. this is our only hope
    }

    // truthy check fixes #239, equality fixes #207, fixes #501
    if ((e.clientX !== void 0 && Math.abs(e.clientX - _moveX) <= (o.slideFactorX || 0)) &&
      (e.clientY !== void 0 && Math.abs(e.clientY - _moveY) <= (o.slideFactorY || 0))) {
      return;
    }

    if (o.ignoreInputTextSelection) {
      var clientX = getCoord('clientX', e) || 0;
      var clientY = getCoord('clientY', e) || 0;
      var elementBehindCursor = doc.elementFromPoint(clientX, clientY);
      if (isInput(elementBehindCursor)) {
        return;
      }
    }

    var grabbed = _grabbed; // call to end() unsets _grabbed
    eventualMovements(true);
    movements();
    end();
    start(grabbed);

    var offset = getOffset(_item);
    _offsetX = getCoord('pageX', e) - offset.left;
    _offsetY = getCoord('pageY', e) - offset.top;

    classes.add(_copy || _item, 'gu-transit');
    renderMirrorImage();
    drag(e);
  }

  function canStart (item) {
    if (drake.dragging && _mirror) {
      return;
    }
    if (isContainer(item)) {
      return; // don't drag container itself
    }
    var handle = item;
    while (getParent(item) && isContainer(getParent(item)) === false) {
      if (o.invalid(item, handle)) {
        return;
      }
      item = getParent(item); // drag target should be a top element
      if (!item) {
        return;
      }
    }
    var source = getParent(item);
    if (!source) {
      return;
    }
    if (o.invalid(item, handle)) {
      return;
    }

    var movable = o.moves(item, source, handle, nextEl(item));
    if (!movable) {
      return;
    }

    return {
      item: item,
      source: source
    };
  }

  function canMove (item) {
    return !!canStart(item);
  }

  function manualStart (item) {
    var context = canStart(item);
    if (context) {
      start(context);
    }
  }

  function start (context) {
    if (isCopy(context.item, context.source)) {
      _copy = context.item.cloneNode(true);
      drake.emit('cloned', _copy, context.item, 'copy');
    }

    _source = context.source;
    _item = context.item;
    _initialSibling = _currentSibling = nextEl(context.item);

    drake.dragging = true;
    drake.emit('drag', _item, _source);
  }

  function invalidTarget () {
    return false;
  }

  function end () {
    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    drop(item, getParent(item));
  }

  function ungrab () {
    _grabbed = false;
    eventualMovements(true);
    movements(true);
  }

  function release (e) {
    ungrab();

    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    var clientX = getCoord('clientX', e) || 0;
    var clientY = getCoord('clientY', e) || 0;
    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
    if (dropTarget && ((_copy && o.copySortSource) || (!_copy || dropTarget !== _source))) {
      drop(item, dropTarget);
    } else if (o.removeOnSpill) {
      remove();
    } else {
      cancel();
    }
  }

  function drop (item, target) {
    var parent = getParent(item);
    if (_copy && o.copySortSource && target === _source) {
      parent.removeChild(_item);
    }
    if (isInitialPlacement(target)) {
      drake.emit('cancel', item, _source, _source);
    } else {
      drake.emit('drop', item, target, _source, _currentSibling);
    }
    cleanup();
  }

  function remove () {
    if (!drake.dragging) {
      return;
    }
    var item = _copy || _item;
    var parent = getParent(item);
    if (parent) {
      parent.removeChild(item);
    }
    drake.emit(_copy ? 'cancel' : 'remove', item, parent, _source);
    cleanup();
  }

  function cancel (revert) {
    if (!drake.dragging) {
      return;
    }
    var reverts = arguments.length > 0 ? revert : o.revertOnSpill;
    var item = _copy || _item;
    var parent = getParent(item);
    var initial = isInitialPlacement(parent);
    if (initial === false && reverts) {
      if (_copy) {
        if (parent) {
          parent.removeChild(_copy);
        }
      } else {
        _source.insertBefore(item, _initialSibling);
      }
    }
    if (initial || reverts) {
      drake.emit('cancel', item, _source, _source);
    } else {
      drake.emit('drop', item, parent, _source, _currentSibling);
    }
    cleanup();
  }

  function cleanup () {
    var item = _copy || _item;
    ungrab();
    removeMirrorImage();
    if (item) {
      classes.rm(item, 'gu-transit');
    }
    if (_renderTimer) {
      clearTimeout(_renderTimer);
    }
    drake.dragging = false;
    if (_lastDropTarget) {
      drake.emit('out', item, _lastDropTarget, _source);
    }
    drake.emit('dragend', item);
    _source = _item = _copy = _initialSibling = _currentSibling = _renderTimer = _lastDropTarget = null;
  }

  function isInitialPlacement (target, s) {
    var sibling;
    if (s !== void 0) {
      sibling = s;
    } else if (_mirror) {
      sibling = _currentSibling;
    } else {
      sibling = nextEl(_copy || _item);
    }
    return target === _source && sibling === _initialSibling;
  }

  function findDropTarget (elementBehindCursor, clientX, clientY) {
    var target = elementBehindCursor;
    while (target && !accepted()) {
      target = getParent(target);
    }
    return target;

    function accepted () {
      var droppable = isContainer(target);
      if (droppable === false) {
        return false;
      }

      var immediate = getImmediateChild(target, elementBehindCursor);
      var reference = getReference(target, immediate, clientX, clientY);
      var initial = isInitialPlacement(target, reference);
      if (initial) {
        return true; // should always be able to drop it right back where it was
      }
      return o.accepts(_item, target, _source, reference);
    }
  }

  function drag (e) {
    if (!_mirror) {
      return;
    }
    e.preventDefault();

    var clientX = getCoord('clientX', e) || 0;
    var clientY = getCoord('clientY', e) || 0;
    var x = clientX - _offsetX;
    var y = clientY - _offsetY;

    _mirror.style.left = x + 'px';
    _mirror.style.top = y + 'px';

    var item = _copy || _item;
    var elementBehindCursor = getElementBehindPoint(_mirror, clientX, clientY);
    var dropTarget = findDropTarget(elementBehindCursor, clientX, clientY);
    var changed = dropTarget !== null && dropTarget !== _lastDropTarget;
    if (changed || dropTarget === null) {
      out();
      _lastDropTarget = dropTarget;
      over();
    }
    var parent = getParent(item);
    if (dropTarget === _source && _copy && !o.copySortSource) {
      if (parent) {
        parent.removeChild(item);
      }
      return;
    }
    var reference;
    var immediate = getImmediateChild(dropTarget, elementBehindCursor);
    if (immediate !== null) {
      reference = getReference(dropTarget, immediate, clientX, clientY);
    } else if (o.revertOnSpill === true && !_copy) {
      reference = _initialSibling;
      dropTarget = _source;
    } else {
      if (_copy && parent) {
        parent.removeChild(item);
      }
      return;
    }
    if (
      (reference === null && changed) ||
      reference !== item &&
      reference !== nextEl(item)
    ) {
      _currentSibling = reference;
      dropTarget.insertBefore(item, reference);
      drake.emit('shadow', item, dropTarget, _source);
    }
    function moved (type) { drake.emit(type, item, _lastDropTarget, _source); }
    function over () { if (changed) { moved('over'); } }
    function out () { if (_lastDropTarget) { moved('out'); } }
  }

  function spillOver (el) {
    classes.rm(el, 'gu-hide');
  }

  function spillOut (el) {
    if (drake.dragging) { classes.add(el, 'gu-hide'); }
  }

  function renderMirrorImage () {
    if (_mirror) {
      return;
    }
    var rect = _item.getBoundingClientRect();
    _mirror = _item.cloneNode(true);
    _mirror.style.width = getRectWidth(rect) + 'px';
    _mirror.style.height = getRectHeight(rect) + 'px';
    classes.rm(_mirror, 'gu-transit');
    classes.add(_mirror, 'gu-mirror');
    o.mirrorContainer.appendChild(_mirror);
    touchy(documentElement, 'add', 'mousemove', drag);
    classes.add(o.mirrorContainer, 'gu-unselectable');
    drake.emit('cloned', _mirror, _item, 'mirror');
  }

  function removeMirrorImage () {
    if (_mirror) {
      classes.rm(o.mirrorContainer, 'gu-unselectable');
      touchy(documentElement, 'remove', 'mousemove', drag);
      getParent(_mirror).removeChild(_mirror);
      _mirror = null;
    }
  }

  function getImmediateChild (dropTarget, target) {
    var immediate = target;
    while (immediate !== dropTarget && getParent(immediate) !== dropTarget) {
      immediate = getParent(immediate);
    }
    if (immediate === documentElement) {
      return null;
    }
    return immediate;
  }

  function getReference (dropTarget, target, x, y) {
    var horizontal = o.direction === 'horizontal';
    var reference = target !== dropTarget ? inside() : outside();
    return reference;

    function outside () { // slower, but able to figure out any position
      var len = dropTarget.children.length;
      var i;
      var el;
      var rect;
      for (i = 0; i < len; i++) {
        el = dropTarget.children[i];
        rect = el.getBoundingClientRect();
        if (horizontal && (rect.left + rect.width / 2) > x) { return el; }
        if (!horizontal && (rect.top + rect.height / 2) > y) { return el; }
      }
      return null;
    }

    function inside () { // faster, but only available if dropped inside a child element
      var rect = target.getBoundingClientRect();
      if (horizontal) {
        return resolve(x > rect.left + getRectWidth(rect) / 2);
      }
      return resolve(y > rect.top + getRectHeight(rect) / 2);
    }

    function resolve (after) {
      return after ? nextEl(target) : target;
    }
  }

  function isCopy (item, container) {
    return typeof o.copy === 'boolean' ? o.copy : o.copy(item, container);
  }
}

function touchy (el, op, type, fn) {
  var touch = {
    mouseup: 'touchend',
    mousedown: 'touchstart',
    mousemove: 'touchmove'
  };
  var pointers = {
    mouseup: 'pointerup',
    mousedown: 'pointerdown',
    mousemove: 'pointermove'
  };
  var microsoft = {
    mouseup: 'MSPointerUp',
    mousedown: 'MSPointerDown',
    mousemove: 'MSPointerMove'
  };
  if (global.navigator.pointerEnabled) {
    crossvent[op](el, pointers[type], fn);
  } else if (global.navigator.msPointerEnabled) {
    crossvent[op](el, microsoft[type], fn);
  } else {
    crossvent[op](el, touch[type], fn);
    crossvent[op](el, type, fn);
  }
}

function whichMouseButton (e) {
  if (e.touches !== void 0) { return e.touches.length; }
  if (e.which !== void 0 && e.which !== 0) { return e.which; } // see https://github.com/bevacqua/dragula/issues/261
  if (e.buttons !== void 0) { return e.buttons; }
  var button = e.button;
  if (button !== void 0) { // see https://github.com/jquery/jquery/blob/99e8ff1baa7ae341e94bb89c3e84570c7c3ad9ea/src/event.js#L573-L575
    return button & 1 ? 1 : button & 2 ? 3 : (button & 4 ? 2 : 0);
  }
}

function getOffset (el) {
  var rect = el.getBoundingClientRect();
  return {
    left: rect.left + getScroll('scrollLeft', 'pageXOffset'),
    top: rect.top + getScroll('scrollTop', 'pageYOffset')
  };
}

function getScroll (scrollProp, offsetProp) {
  if (typeof global[offsetProp] !== 'undefined') {
    return global[offsetProp];
  }
  if (documentElement.clientHeight) {
    return documentElement[scrollProp];
  }
  return doc.body[scrollProp];
}

function getElementBehindPoint (point, x, y) {
  point = point || {};
  var state = point.className || '';
  var el;
  point.className += ' gu-hide';
  el = doc.elementFromPoint(x, y);
  point.className = state;
  return el;
}

function never () { return false; }
function always () { return true; }
function getRectWidth (rect) { return rect.width || (rect.right - rect.left); }
function getRectHeight (rect) { return rect.height || (rect.bottom - rect.top); }
function getParent (el) { return el.parentNode === doc ? null : el.parentNode; }
function isInput (el) { return el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || isEditable(el); }
function isEditable (el) {
  if (!el) { return false; } // no parents were editable
  if (el.contentEditable === 'false') { return false; } // stop the lookup
  if (el.contentEditable === 'true') { return true; } // found a contentEditable element in the chain
  return isEditable(getParent(el)); // contentEditable is set to 'inherit'
}

function nextEl (el) {
  return el.nextElementSibling || manually();
  function manually () {
    var sibling = el;
    do {
      sibling = sibling.nextSibling;
    } while (sibling && sibling.nodeType !== 1);
    return sibling;
  }
}

function getEventHost (e) {
  // on touchend event, we have to use `e.changedTouches`
  // see http://stackoverflow.com/questions/7192563/touchend-event-properties
  // see https://github.com/bevacqua/dragula/issues/34
  if (e.targetTouches && e.targetTouches.length) {
    return e.targetTouches[0];
  }
  if (e.changedTouches && e.changedTouches.length) {
    return e.changedTouches[0];
  }
  return e;
}

function getCoord (coord, e) {
  var host = getEventHost(e);
  var missMap = {
    pageX: 'clientX', // IE8
    pageY: 'clientY' // IE8
  };
  if (coord in missMap && !(coord in host) && missMap[coord] in host) {
    coord = missMap[coord];
  }
  return host[coord];
}

module.exports = dragula;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5025d08794d1053c611b80032551f0aa.png";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83e53f1b89071ac0a62a7d5fc940c795.png";

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5500b848a2a66e260d2942191a0d942a.png";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 241,
	"./af.js": 241,
	"./ar": 248,
	"./ar-dz": 242,
	"./ar-dz.js": 242,
	"./ar-kw": 243,
	"./ar-kw.js": 243,
	"./ar-ly": 244,
	"./ar-ly.js": 244,
	"./ar-ma": 245,
	"./ar-ma.js": 245,
	"./ar-sa": 246,
	"./ar-sa.js": 246,
	"./ar-tn": 247,
	"./ar-tn.js": 247,
	"./ar.js": 248,
	"./az": 249,
	"./az.js": 249,
	"./be": 250,
	"./be.js": 250,
	"./bg": 251,
	"./bg.js": 251,
	"./bm": 252,
	"./bm.js": 252,
	"./bn": 254,
	"./bn-bd": 253,
	"./bn-bd.js": 253,
	"./bn.js": 254,
	"./bo": 255,
	"./bo.js": 255,
	"./br": 256,
	"./br.js": 256,
	"./bs": 257,
	"./bs.js": 257,
	"./ca": 258,
	"./ca.js": 258,
	"./cs": 259,
	"./cs.js": 259,
	"./cv": 260,
	"./cv.js": 260,
	"./cy": 261,
	"./cy.js": 261,
	"./da": 262,
	"./da.js": 262,
	"./de": 265,
	"./de-at": 263,
	"./de-at.js": 263,
	"./de-ch": 264,
	"./de-ch.js": 264,
	"./de.js": 265,
	"./dv": 266,
	"./dv.js": 266,
	"./el": 267,
	"./el.js": 267,
	"./en-au": 268,
	"./en-au.js": 268,
	"./en-ca": 269,
	"./en-ca.js": 269,
	"./en-gb": 270,
	"./en-gb.js": 270,
	"./en-ie": 271,
	"./en-ie.js": 271,
	"./en-il": 272,
	"./en-il.js": 272,
	"./en-in": 273,
	"./en-in.js": 273,
	"./en-nz": 274,
	"./en-nz.js": 274,
	"./en-sg": 275,
	"./en-sg.js": 275,
	"./eo": 276,
	"./eo.js": 276,
	"./es": 280,
	"./es-do": 277,
	"./es-do.js": 277,
	"./es-mx": 278,
	"./es-mx.js": 278,
	"./es-us": 279,
	"./es-us.js": 279,
	"./es.js": 280,
	"./et": 281,
	"./et.js": 281,
	"./eu": 282,
	"./eu.js": 282,
	"./fa": 283,
	"./fa.js": 283,
	"./fi": 284,
	"./fi.js": 284,
	"./fil": 285,
	"./fil.js": 285,
	"./fo": 286,
	"./fo.js": 286,
	"./fr": 289,
	"./fr-ca": 287,
	"./fr-ca.js": 287,
	"./fr-ch": 288,
	"./fr-ch.js": 288,
	"./fr.js": 289,
	"./fy": 290,
	"./fy.js": 290,
	"./ga": 291,
	"./ga.js": 291,
	"./gd": 292,
	"./gd.js": 292,
	"./gl": 293,
	"./gl.js": 293,
	"./gom-deva": 294,
	"./gom-deva.js": 294,
	"./gom-latn": 295,
	"./gom-latn.js": 295,
	"./gu": 296,
	"./gu.js": 296,
	"./he": 297,
	"./he.js": 297,
	"./hi": 298,
	"./hi.js": 298,
	"./hr": 299,
	"./hr.js": 299,
	"./hu": 300,
	"./hu.js": 300,
	"./hy-am": 301,
	"./hy-am.js": 301,
	"./id": 302,
	"./id.js": 302,
	"./is": 303,
	"./is.js": 303,
	"./it": 305,
	"./it-ch": 304,
	"./it-ch.js": 304,
	"./it.js": 305,
	"./ja": 306,
	"./ja.js": 306,
	"./jv": 307,
	"./jv.js": 307,
	"./ka": 308,
	"./ka.js": 308,
	"./kk": 309,
	"./kk.js": 309,
	"./km": 310,
	"./km.js": 310,
	"./kn": 311,
	"./kn.js": 311,
	"./ko": 312,
	"./ko.js": 312,
	"./ku": 313,
	"./ku.js": 313,
	"./ky": 314,
	"./ky.js": 314,
	"./lb": 315,
	"./lb.js": 315,
	"./lo": 316,
	"./lo.js": 316,
	"./lt": 317,
	"./lt.js": 317,
	"./lv": 318,
	"./lv.js": 318,
	"./me": 319,
	"./me.js": 319,
	"./mi": 320,
	"./mi.js": 320,
	"./mk": 321,
	"./mk.js": 321,
	"./ml": 322,
	"./ml.js": 322,
	"./mn": 323,
	"./mn.js": 323,
	"./mr": 324,
	"./mr.js": 324,
	"./ms": 326,
	"./ms-my": 325,
	"./ms-my.js": 325,
	"./ms.js": 326,
	"./mt": 327,
	"./mt.js": 327,
	"./my": 328,
	"./my.js": 328,
	"./nb": 329,
	"./nb.js": 329,
	"./ne": 330,
	"./ne.js": 330,
	"./nl": 332,
	"./nl-be": 331,
	"./nl-be.js": 331,
	"./nl.js": 332,
	"./nn": 333,
	"./nn.js": 333,
	"./oc-lnc": 334,
	"./oc-lnc.js": 334,
	"./pa-in": 335,
	"./pa-in.js": 335,
	"./pl": 336,
	"./pl.js": 336,
	"./pt": 338,
	"./pt-br": 337,
	"./pt-br.js": 337,
	"./pt.js": 338,
	"./ro": 339,
	"./ro.js": 339,
	"./ru": 340,
	"./ru.js": 340,
	"./sd": 341,
	"./sd.js": 341,
	"./se": 342,
	"./se.js": 342,
	"./si": 343,
	"./si.js": 343,
	"./sk": 344,
	"./sk.js": 344,
	"./sl": 345,
	"./sl.js": 345,
	"./sq": 346,
	"./sq.js": 346,
	"./sr": 348,
	"./sr-cyrl": 347,
	"./sr-cyrl.js": 347,
	"./sr.js": 348,
	"./ss": 349,
	"./ss.js": 349,
	"./sv": 350,
	"./sv.js": 350,
	"./sw": 351,
	"./sw.js": 351,
	"./ta": 352,
	"./ta.js": 352,
	"./te": 353,
	"./te.js": 353,
	"./tet": 354,
	"./tet.js": 354,
	"./tg": 355,
	"./tg.js": 355,
	"./th": 356,
	"./th.js": 356,
	"./tk": 357,
	"./tk.js": 357,
	"./tl-ph": 358,
	"./tl-ph.js": 358,
	"./tlh": 359,
	"./tlh.js": 359,
	"./tr": 360,
	"./tr.js": 360,
	"./tzl": 361,
	"./tzl.js": 361,
	"./tzm": 363,
	"./tzm-latn": 362,
	"./tzm-latn.js": 362,
	"./tzm.js": 363,
	"./ug-cn": 364,
	"./ug-cn.js": 364,
	"./uk": 365,
	"./uk.js": 365,
	"./ur": 366,
	"./ur.js": 366,
	"./uz": 368,
	"./uz-latn": 367,
	"./uz-latn.js": 367,
	"./uz.js": 368,
	"./vi": 369,
	"./vi.js": 369,
	"./x-pseudo": 370,
	"./x-pseudo.js": 370,
	"./yo": 371,
	"./yo.js": 371,
	"./zh-cn": 372,
	"./zh-cn.js": 372,
	"./zh-hk": 373,
	"./zh-hk.js": 373,
	"./zh-mo": 374,
	"./zh-mo.js": 374,
	"./zh-tw": 375,
	"./zh-tw.js": 375
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 760;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var dragula_directive_1 = __webpack_require__(376);
var dragula_provider_1 = __webpack_require__(128);
var DragulaModule = (function () {
    function DragulaModule() {
    }
    return DragulaModule;
}());
DragulaModule = __decorate([
    core_1.NgModule({
        exports: [dragula_directive_1.DragulaDirective],
        declarations: [dragula_directive_1.DragulaDirective],
        providers: [dragula_provider_1.DragulaService]
    })
], DragulaModule);
exports.DragulaModule = DragulaModule;


/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1 mt-5\">\n            <div class=\"col-md-10 offset-md-1\">\n                <h2>Activation de votre compte.</h2>\n                <br>\n\n                <div *ngIf=\"success\">\n                    <div role=\"alert\" class=\"alert alert-success\" >\n                        <h2>Votre compte a été activé. </h2>\n                    </div>\n                    <p>\n                        Pour continuer, merci de\n                        <a (click)=\"login()\" href=\"#\">\n                            vous connecter\n                        </a>.\n                    </p>\n                </div>\n\n                <div role=\"alert\" class=\"alert alert-danger\"  *ngIf=\"!success\" jhiTranslate=\"activate.messages.error\">\n                    <strong>Your user could not be activated.</strong> Please use the registration form to sign up.\n                </div>\n\n            </div>\n        </div>\n    </div>\n"

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"col-md-10 offset-md-1 mt-5\">\n            <div class=\"col-md-10 offset-md-1\">\n                <h2>Activation de votre nouvelle adresse de messagerie électronique</h2>\n                <br>\n\n                <div *ngIf=\"success\">\n                    <div role=\"alert\" class=\"alert alert-success\">\n                        <h2>La nouvelle adresse de messagerie électronique que vous avez renseignée a été activée. </h2>\n                    </div>\n                    <p>\n                        Pour continuer, merci de\n                        <a (click)=\"login()\" href=\"#\">\n                            vous connecter\n                        </a>.\n                    </p>\n                </div>\n\n                <div role=\"alert\" class=\"alert alert-danger\" *ngIf=\"!success\">\n                    <p><strong>Votre adresse de messagerie électronique n'a pas pu être activée.</strong> Veuillez réessayer depuis votre profil.</p>\n                </div>\n\n            </div>\n        </div>\n    </div>\n"

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "<jhi-trc-admin-config></jhi-trc-admin-config>\n<div class=\"container\">\n\t<div class=\"explication explication_why\">\n        <h2>Pourquoi utiliser Télérecours citoyens&nbsp;?</h2>\n        <p>\n            Télérecours citoyens vous permet de déposer une requête de façon dématérialisée et de suivre vos dossiers.\n            Vous pourrez ainsi accéder immédiatement au contenu de vos dossiers et échanger rapidement avec le Conseil d’État, les cours administratives d’appel et les tribunaux administratifs.\n        </p>\n    </div>\n\n    <section class=\"row vdivide my-4\">\n        <h1>Vous avez déjà un compte ?</h1>\n        <!-- France connect -->\n        <section class=\"col-md-12 col-lg-6 px-0\">\n            <div class=\"col-12 pl-0\">\n                <h2>Se connecter avec FranceConnect</h2>\n                <jhi-franceconnect-button></jhi-franceconnect-button>\n            </div>\n        </section>\n\n        <!-- Login password -->\n        <section class=\"col-md-12 col-lg-6\">\n            <div class=\"col-12\">\n                <hr class=\"d-lg-none\"/>\n                <form id=\"loginForm\" role=\"form\" (ngSubmit)=\"login()\">\n                    <h2>Se connecter avec un compte Télérecours citoyens</h2>\n                    <div class=\"field-hint\">\n                        <span> * champ obligatoire</span>\n                    </div>\n                    <div *ngIf=\"authenticationError\">\n                        <div role=\"alert\" class=\"alert alert-danger\">\n                            <span><strong>Erreur d'authentification !</strong> Veuillez vérifier vos identifiants de connexion.</span>\n                        </div>\n                    </div>\n                    <div class=\"pb-3\">\n                        <div class=\"form-group required\">\n                            <label for=\"username\" [ngClass]=\" (username) ? 'has-value':'no-value'\">Adresse de messagerie électronique</label>\n                            <input type=\"email\" id=\"username\" name=\"username\" #email required class=\"form-control focus-outline\" (ngModelChange)=\"resetAuthErrors()\" [(ngModel)]=\"username\" autocomplete=\"email\"\n                                   aria-invalid=\"true\" aria-describedby=\"usernameHintLabel errorMessageEmail errorMessageEmailFormat\" pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$\" #un=\"ngModel\">\n                            <small id=\"usernameHintLabel\" class=\"form-text text-muted mb-3\">Exemple : adresse@mail.com</small>\n                            <jhi-messages [id]=\"'errorMessageEmail'\">\n                                <jhi-message error=\"required\" controlKey=\"username\">\n                                    <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Adresse de messagerie électronique' }\"></div>\n                                </jhi-message>\n                            </jhi-messages>\n                            <div *ngIf=\"un.errors && (un.dirty && un.touched)\">\n                                <div *ngIf=\"un.errors['pattern']\" class=\"alert alert-danger alert-secondary\" id=\"errorMessageEmailFormat\">\n                                    Le champ Adresse de messagerie électronique est incorrect. ex: adresse@mail.com\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div>\n                        <div class=\"form-group required focus-outline\">\n                            <label for=\"password\" [ngClass]=\" (password) ? 'has-value':'no-value'\">Mot de passe</label>\n                            <div class=\"input-group\">\n                                <input [type]=\"showPassword ? 'text' : 'password'\" class=\"form-control\" id=\"password\" name=\"password\" autocomplete=\"current-password\" [(ngModel)]=\"password\"\n                                       (ngModelChange)=\"resetAuthErrors()\" required aria-invalid=\"true\" aria-describedby=\"errorMessagePassword\">\n                                <button class=\"input-group-addon input-group-addon-btn\" [attr.aria-label]=\"showPassword ? 'cacher le mot de passe' : 'afficher le mot de passe'\" (click)=\"togglePassword($event)\">\n                                   <em [ngClass]=\"(showPassword) ? 'fa fa-eye-slash blue2':'fa fa-eye'\"></em>\n\n                                   <em *ngIf=\"showPassword\" class=\"sr-only\">Cacher le mot de passe</em>\n                                   <em *ngIf=\"!showPassword\" class=\"sr-only\">Afficher le mot de passe</em>\n                                </button>\n                            </div>\n                        </div>\n                        <jhi-messages [id]=\"'errorMessagePassword'\">\n                            <jhi-message error=\"required\" controlKey=\"password\">\n                                <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Mot de passe' }\"></div>\n                            </jhi-message>\n                        </jhi-messages>\n                    </div>\n                    <div class=\"col-12 btn-block pb-2 text-right\">\n                        <a routerLink=\"/reset/request\" href=\"#\">\n                            Mot de passe oublié ?\n                        </a>\n                    </div>\n                    <div class=\"form-check pb-3\">\n                        <input type=\"checkbox\" name=\"rememberMe\" id=\"rememberMe2\" [(ngModel)]=\"rememberMe\">\n                        <label class=\"form-check-label lb_clickable\" for=\"rememberMe2\">Rester connecté</label>\n                    </div>\n                    <jhi-button class=\"pull-right\"\n                        [isLoading]=\"isSigning\" icon=\"fa-sign-in\">Je me connecte</jhi-button>\n                </form>\n            </div>\n        </section>\n    </section>\n\n    <!-- Type de compte -->\n    <section class=\"row my-4\">\n        <h1>Vous n'avez pas de compte ?</h1>\n        <span class=\"explication col-12 my-3 p-3\">\n            <dl>\n                <dt>Vous êtes un particulier ?</dt>\n                <dd>Toute personne physique disposant de la capacité juridique peut saisir la justice.</dd>\n\n                <dt>Vous êtes une personne morale ?</dt>\n                <dd>Les personnes morales de droit privé les plus courantes sont les sociétés, associations, syndicats.</dd>\n            </dl>\n        </span>\n        <div class=\"col-md-12 col-lg-6 mb-2\">\n            <button class=\"btn big-outline-button\" routerLink=\"../register/particulier\">Compte particulier</button>\n        </div>\n        <div class=\"col-md-12 col-lg-6 mb-2\">\n            <button class=\"btn big-outline-button\" routerLink=\"../register/morale\">Compte personne morale</button>\n        </div>\n    </section>\n</div>\n"

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "<jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n    <jhi-input [id]=\"'email'\" name=\"email\" [type]=\"'email'\" [autocomplete]=\"'email'\"\n        label=\"{{ isRepresentant ? 'Adresse de messagerie de l’organisme' : 'Adresse de messagerie' }}\"\n        hintLabel=\"Exemple : adresse@mail.com\"\n        [(ngModel)]=\"credentials.email\"\n        required\n        jhiEmail\n        #email=\"ngModel\"\n        [disabled]=\"isFCUser\"\n        [ariaDescribedBy]=\"'errorMessageInvalidEmail'\">\n    </jhi-input>\n<!--     (change)=\"updateValueAndValidity(['confirmationEmail'])\" -->\n    <jhi-messages [id]=\"'errorMessageInvalidEmail'\">\n        <jhi-message error=\"required\" controlKey=\"email\" *ngIf=\"isCreateAccountBtnClicked\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Adresse de messagerie'}\"></div>\n        </jhi-message>\n        <jhi-message error=\"invalid-email\" controlKey=\"email\">\n            <div>L'adresse de messagerie renseignée n'est pas valide.</div>\n        </jhi-message>\n        <jhi-message error=\"emailexists\" controlKey=\"email\">\n            <div jhiTranslate=\"settings.messages.error.emailexists\"></div>\n        </jhi-message>\n    </jhi-messages>\n    <jhi-button id=\"show-password-fields-btn\" class=\"row\" (onClick)=\"showPWFields()\" *ngIf=\"!isNewAccount && !showsPWFields\">Modifier mon mot de passe</jhi-button>\n</jhi-field>\n\n<ng-container *ngIf=\"!isFCUser\">\n    <jhi-field class=\"col-12 col-lg-6 py-2\">\n        <jhi-input [id]=\"'confirmationEmail'\" name=\"confirmationEmail\" [type]=\"'email'\" [autocomplete]=\"'email'\"\n            label=\"Confirmation de l'adresse de messagerie\"\n            [(ngModel)]=\"confirmEmail.confirmEmail\"\n            [matchTo]=\"email.value\"\n            [disabled]=\"!email.dirty && !isNewAccount\"\n            jhiEmail\n            [required]=\"isNewAccount || credentials.email !== credentials.oldEmail\"\n            [ariaDescribedBy]=\"'errorMessageDifferentEmails'\">\n        </jhi-input>\n        <jhi-messages [id]=\"'errorMessageDifferentEmails'\">\n            <jhi-message error=\"required\" controlKey=\"confirmationEmail\" *ngIf=\"isCreateAccountBtnClicked\">\n                <div jhiTranslate=\"entity.validation.required\"\n                translateValues=\"{champ: 'Confirmation de l’adresse de messagerie électronique'}\"></div>\n            </jhi-message>\n            <jhi-message error=\"invalid-confirmaton-email\" controlKey=\"confirmationEmail\">\n                <div>Les deux adresses de messageries renseignées ne sont pas identiques.</div>\n            </jhi-message>\n        </jhi-messages>\n    </jhi-field>\n\n    <jhi-field class=\"col-12 col-lg-4 py-2 pr-lg-3\" *ngIf=\"!isNewAccount && showsPWFields\">\n        <jhi-input [id]=\"'oldPassword'\" type=\"password\"\n            name=\"oldPassword\"\n            [autocomplete]=\"''\"\n            label=\"Mot de passe actuel\"\n            #oldPassword=\"ngModel\"\n            [(ngModel)]=\"credentials.oldPassword\"\n            (input)=\"checkRequiredPasswords($event)\"\n            [required]=\"isPasswordRequired\"\n            jhiIgnoreDirty\n            [ariaDescribedBy]=\"'errorMessagePassword'\">\n        </jhi-input>\n        <jhi-messages [id]=\"'errorMessagePassword'\">\n            <jhi-message error=\"required\" controlKey=\"oldPassword\" *ngIf=\"isCreateAccountBtnClicked\">\n                <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Mot de passe actuel'}\"></div>\n            </jhi-message>\n            <jhi-message error=\"wrongpassword\" controlKey=\"oldPassword\">\n                <span>Mot de passe actuel incorrect.</span>\n            </jhi-message>\n        </jhi-messages>\n    </jhi-field>\n\n    <jhi-field class=\"col-12 py-2 pr-lg-3\" [ngClass]=\"{'col-lg-6':  isNewAccount, 'col-lg-4': !isNewAccount}\" *ngIf=\"isNewAccount || (!isNewAccount && showsPWFields)\">\n        <jhi-input [id]=\"'password'\" type=\"password\"\n            name=\"password\"\n            [autocomplete]=\"'new-password'\"\n            label=\"{{ isNewAccount ? 'Mot de passe' : 'Nouveau mot de passe' }}\"\n            #password=\"ngModel\"\n            [(ngModel)]=\"credentials.password\"\n            jhiPassword\n            [required]=\"isPasswordRequired\"\n            (input)=\"checkRequiredPasswords($event)\"\n            (change)=\"updateValueAndValidity(['confirmPwd'])\"\n            [ariaDescribedBy]=\"'errorMessageInvalidPassword errorMessageInvalidFormatPassword'\"\n            #enterPS=\"ngModel\">\n        </jhi-input>\n        <jhi-messages [id]=\"'errorMessageInvalidPassword'\">\n            <jhi-message error=\"required\" controlKey=\"password\" *ngIf=\"isCreateAccountBtnClicked\">\n                <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Mot de passe'}\"></div>\n            </jhi-message>\n            <jhi-message error=\"invalidPassword\" controlKey=\"password\">\n                <div>Mot de passe invalide.</div>\n            </jhi-message>\n            <jhi-message error=\"invalidNewPassword\" controlKey=\"password\">\n                <div>Nouveau mot de passe invalide.</div>\n            </jhi-message>\n        </jhi-messages>\n        <div id=\"errorMessageInvalidFormatPassword\" role=\"list\">\n            <div *ngIf=\"enterPS.touched && enterPS.dirty && enterPS.hasError('min-length')\" class=\"alert alert-danger alert-secondary\" role=\"listitem\">\n              La longueur minimale de mot de passe est de 12 caractères.\n            </div>\n            <div *ngIf=\"enterPS.touched && enterPS.dirty && enterPS.hasError('require-lowercase')\" class=\"alert alert-danger alert-secondary\" role=\"listitem\">\n              Le mot de passe doit contenir au moins une lettre en minuscule.\n            </div>\n            <div *ngIf=\"enterPS.touched && enterPS.dirty && enterPS.hasError('require-upercase')\" class=\"alert alert-danger alert-secondary\" role=\"listitem\">\n              Le mot de passe doit contenir au moins une lettre en majuscule.\n            </div>\n            <div *ngIf=\"enterPS.touched && enterPS.dirty && enterPS.hasError('require-number')\" class=\"alert alert-danger alert-secondary\" role=\"listitem\">\n              Le mot de passe doit contenir au moins un chiffre.\n            </div>\n            <div *ngIf=\"enterPS.touched && enterPS.dirty && enterPS.hasError('require-special')\" class=\"alert alert-danger alert-secondary\" role=\"listitem\">\n              Le mot de passe doit contenir au moins un caractère parmi les éléments suivants : {{specialCharacters}}.\n            </div>\n        </div>\n    </jhi-field>\n\n    <jhi-field class=\"col-12 py-2\" [ngClass]=\"{'col-lg-6':  isNewAccount, 'col-lg-4': !isNewAccount}\" *ngIf=\"isNewAccount || (!isNewAccount && showsPWFields)\">\n        <jhi-input [id]=\"'confirmPwd'\" type=\"password\" name=\"confirmPwd\"\n            label=\"Confirmation du mot de passe\"\n            [autocomplete]=\"'new-password'\"\n            #confirmPwd=\"ngModel\"\n            [(ngModel)]=\"confirmPassword\"\n            [matchTo]=\"credentials.password\"\n            jhiPassword\n            (input)=\"checkRequiredPasswords($event)\"\n            [required]=\"isPasswordRequired\"\n            [ariaDescribedBy]=\"'errorMessageConfirmPassword'\">\n        </jhi-input>\n        <jhi-messages [id]=\"'errorMessageConfirmPassword'\">\n            <jhi-message error=\"required\" controlKey=\"confirmPwd\" *ngIf=\"isCreateAccountBtnClicked\">\n                <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Confirmation de mot de passe'}\"></div>\n            </jhi-message>\n            <jhi-message error=\"not-matched\" controlKey=\"confirmPwd\">\n                <div>Le mot de passe et sa confirmation doivent être identiques</div>\n            </jhi-message>\n        </jhi-messages>\n    </jhi-field>\n    <div class=\"col-sm-12 my-2\" [ngClass]=\"{'col-md-8 offset-md-4': !isNewAccount, 'col-md-12': isNewAccount }\" *ngIf=\"isPasswordRequired && (isNewAccount || (!isNewAccount && showsPWFields))\">\n        <jhi-password-strength-bar\n            passwordInputName=\"password\"\n            confirmPasswordName=\"confirmPwd\">\n        </jhi-password-strength-bar>\n    </div>\n</ng-container>\n"

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "<div class=\"loader\">\n    <div class=\"loading\">\n        <div class=\"bounceball\"></div>\n        <div class=\"loader-message\">Connexion en cours</div>\n    </div>\n</div>"

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n    <div class=\"row justify-content-md-center mt-5\">\n        <div class=\"col-lg-10 sol-sm-12 m-5\">\n            <h1 jhiTranslate=\"reset.finish.title\">Reset password</h1>\n\n            <div role=\"alert\" class=\"alert alert-danger\" jhiTranslate=\"reset.finish.messages.keymissing\" *ngIf=\"keyMissing\">\n                <strong>The password reset key is missing.</strong>\n            </div>\n\n            <div class=\"explication\" *ngIf=\"resetResult !== ResetResultEnum.SUCCESS && !keyMissing\">\n                <p jhiTranslate=\"reset.finish.messages.info\">Choose a new password</p>\n            </div>\n\n            <div role=\"alert\" class=\"alert alert-danger\" *ngIf=\"resetResult === ResetResultEnum.ERROR\">\n                <p jhiTranslate=\"reset.finish.messages.error\">Your password couldn't be reset. Remember a password request is only valid for 24 hours.</p>\n            </div>\n\n            <p id=\"linkalert\" role=\"alert\" class=\"alert alert-success\" *ngIf=\"resetResult === ResetResultEnum.SUCCESS\">\n                <span>Votre mot de passe a été réinitialisé. Merci de\n                    <a class=\"linkalert\" (click)=\"login()\">vous connecter</a> avec votre nouveau mot de passe.</span>\n            </p>\n\n            <form *ngIf=\"resetResult !== ResetResultEnum.SUCCESS && !keyMissing\" name=\"form\" class=\"w-100\" role=\"form\" (ngSubmit)=\"finishReset()\" #passwordForm=\"ngForm\">\n                <div *ngIf=\"!keyMissing\" class=\"row\">\n                    <jhi-field class=\"col-12 col-lg-6 py-3 pr-lg-3\">\n                        <jhi-input [id]=\"'password'\" type=\"password\"\n                            name=\"password\"\n                            label=\"Nouveau mot de passe\"\n                            #password=\"ngModel\"\n                            [autocomplete]=\"'new-password'\"\n                            [(ngModel)]=\"resetAccount.password\"\n                            (change)=\"updateValueAndValidity(['confirmPwd'])\"\n                            jhiPassword\n                            required\n                            [ariaDescribedBy]=\"'errorMessagePassword'\">\n                        </jhi-input>\n                        <jhi-messages [id]=\"'errorMessagePassword'\">\n                            <jhi-message error=\"required\" controlKey=\"password\">\n                                <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Nouveau mot de passe'}\"></div>\n                            </jhi-message>\n                        </jhi-messages>\n                    </jhi-field>\n\n                    <jhi-field class=\"col-12 col-lg-6 py-3\">\n                        <jhi-input [id]=\"'confirmPwd'\" type=\"password\"\n                            name=\"confirmPwd\"\n                            label=\"Confirmation du nouveau mot de passe\"\n                            #confirmPwd=\"ngModel\"\n                            [(ngModel)]=\"confirmPassword\"\n                            [matchTo]=\"resetAccount.password\"\n                            jhiPassword\n                            required\n                            [ariaDescribedBy]=\"'errorMessageConfirmPassword'\">\n                        </jhi-input>\n                        <jhi-messages [id]=\"'errorMessageConfirmPassword'\">\n                            <jhi-message error=\"required\" controlKey=\"confirmPwd\">\n                                <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Confirmation du nouveau mot de passe'}\">\n                                </div>\n                            </jhi-message>\n                        </jhi-messages>\n                    </jhi-field>\n                </div>\n                <div class=\"col-12\">\n                    <jhi-password-strength-bar passwordInputName=\"password\" confirmPasswordName=\"confirmPwd\">\n                    </jhi-password-strength-bar>\n                </div>\n                <div class=\"btn-group justify-content-end\">\n                    <jhi-button>\n                            Réinitialiser le mot de passe\n                    </jhi-button>\n                </div>\n            </form>\n\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n    <div class=\"row justify-content-md-center mt-5\">\n        <div class=\"col-lg-10 col-sm-12 offset-md-2 m-5\">\n            <h1 jhiTranslate=\"reset.request.title\">Reset your password</h1>\n            <ng-container *ngIf=\"success\">\n                <div role=\"status\" class=\"alert alert-success\">\n                    <span jhiTranslate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</span>\n                </div>\n                <div class=\"text-center\">\n                    <a routerLink=\"/\">Revenir à la page d'accueil</a>\n                </div>\n            </ng-container>\n            <div  class=\"py-3\" *ngIf=\"!success\">\n                <div role=\"alert\" class=\"alert alert-warning alert-secondary\">\n                    <span aria-hidden=\"true\" jhiTranslate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</span>\n                </div>\n                <form name=\"form\" role=\"form\" (ngSubmit)=\"requestReset()\" #resetRequestForm=\"ngForm\"\n                    novalidate>\n                    <div class=\"form-group required\">\n                        <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\"\n                            [ngClass]=\" (resetAccount.email) ? 'has-value':'no-value'\">Adresse de messagerie électronique</label>\n                        <input type=\"email\" class=\"form-control focus-outline\" id=\"email\" name=\"emailInput\" [(ngModel)]=\"resetAccount.email\"\n                            #emailInput=\"ngModel\" required jhiEmail autocomplete=\"email\" aria-describedby=\"emailHintLabel errorMessageEmail\">\n\n                        <small id=\"emailHintLabel\" class=\"form-text text-muted mb-3\">Exemple : adresse@mail.com</small>\n\n                        <jhi-messages [id]=\"'errorMessageEmail'\">\n                            <jhi-message [error]=\"'required'\" [controlKey]=\"'emailInput'\">\n                                <div jhiTranslate=\"entity.validation.required\"\n                                     translateValues=\"{champ: 'Adresse de messagerie électronique'}\"></div>\n                            </jhi-message>\n                            <jhi-message [error]=\"'invalid-email'\" [controlKey]=\"'emailInput'\">\n                                <div>L'adresse de messagerie électronique renseignée n'est pas valide.</div>\n                            </jhi-message>\n                        </jhi-messages>\n                    </div>\n                    <div class=\"btn-group justify-content-end\">\n                        <jhi-button confirmation>Réinitialiser le mot de passe</jhi-button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container justify-content-md-center\">\n    <div class=\"col-lg-8 offset-lg-2 col-sm-12 text-center mt-5\">\n        <i class=\"fa fa-envelope-o fa-5x\"  aria-hidden=\"true\"></i>\n        <h2>Nous venons de vous envoyer un courriel à l'adresse {{email}}</h2>\n        <h3>Pour finaliser la création de votre compte, veuillez cliquer sur le lien contenu dans le message que vous\n            allez recevoir</h3>\n\n        <p>Si vous vous êtes trompé d'adresse de messagerie électronique, vous pouvez créer un nouveau compte</p>\n\n\n            <div class=\"col-12 btn-group\">\n                <jhi-button icon=\"fa-home\"\n                    (onClick)=\"goToAcceuil()\"> Revenir à l'accueil\n                </jhi-button>\n            </div>\n\n    </div>\n</div>\n"

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "<form id=\"creerComptePersonneMorale\" (ngSubmit)=\"register()\" (keydown.enter)=\"$event.preventDefault()\" #registerForm=\"ngForm\" novalidate>\n    <div role=\"alert\" class=\"alert alert-danger mt-3\" *ngIf=\"newAccount.credentials.franceConnectSubscription\">\n        FranceConnect n'est pas encore disponible pour les personnes morales.\n    </div>\n    <div class=\"row py-3\">\n        <h2>Créer un compte Télérecours citoyens en saisissant le formulaire</h2>\n    </div>\n    <div class=\"field-hint\">\n        <span> * champ obligatoire</span>\n    </div>\n    <div class=\"row py-3\" id=\"identiteOrganisme\">\n        <fieldset>\n            <legend>Identité de l'organisme</legend>\n            <jhi-identite-organisme [identite]=\"newAccount\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"></jhi-identite-organisme>\n        </fieldset>\n    </div>\n\n    <div class=\"row py-3\" id=\"Representant\">\n        <fieldset>\n            <legend>Représentant de la personne morale</legend>\n            <jhi-identite-personne [identite]=\"newAccount\" [isRepresentant]=\"true\" [isFCUser]=\"false\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\">\n            </jhi-identite-personne>\n\n            <jhi-credentials [credentials]=\"newAccount.credentials\" [isRepresentant]=\"true\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\">\n            </jhi-credentials>\n        </fieldset>\n    </div>\n\n    <div class=\"row\" id=\"Telephones\">\n        <fieldset>\n            <legend>Téléphones</legend>\n            <div class=\"explication col-12\">\n                Le numéro de téléphone vous permet d’être contacté par le greffe de la juridiction en cas de question\n                urgente, liée, par exemple, à la tenue d’une audience. Nous privilégierons le téléphone\n                portable au téléphone fixe pour les éventuelles communications.\n            </div>\n            <jhi-contact [contact]=\"newAccount.contact\"></jhi-contact>\n        </fieldset>\n    </div>\n\n    <div class=\"row\" id=\"Adresse\">\n        <fieldset>\n            <legend>Adresse</legend>\n            <jhi-address [address]=\"newAccount.address\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"></jhi-address>\n        </fieldset>\n    </div>\n\n    <div class=\"row  py-3\" id=\"captcha\">\n        <fieldset>\n            <legend>Sécurité</legend>\n            <jhi-captcha class=\"col-12 p-0\" name=\"captcha\" [(ngModel)]=\"newAccount.captcha\" [email]=\"newAccount.credentials.email\"  required jhiCaptchaValidator></jhi-captcha>\n            <div class=\"col-12 col-md-5 px-0\">\n                <jhi-messages [id]=\"'errorMessageCaptcha'\" role=\"alert\">\n                    <jhi-message [error]=\"'required'\" [controlKey]=\"'captcha'\" *ngIf=\"isCreateAccountBtnClicked\">\n                        <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Captcha'}\"></div>\n                    </jhi-message>\n                    <jhi-message [error]=\"'invalid-captcha'\" [controlKey]=\"'captcha'\">\n                        <div>Le captcha n'est pas valide. Merci de recommencer.</div>\n                    </jhi-message>\n                </jhi-messages>\n            </div>\n        </fieldset>\n    </div>\n\n    <ng-container *ngIf=\"isTechnicalError\">\n        <div role=\"alert\" class=\"alert alert-danger mb-4\">\n            <span>Une erreur est survenue.</span>\n        </div>\n    </ng-container>\n\n    <div class=\"col-12 btn-group\">\n        <jhi-button cancellation (onClick)=\"cancel()\">Annuler</jhi-button>\n        <jhi-button confirmation icon=\"fa-save\" iconRight (click)=\"clickCheck()\">Créer mon compte</jhi-button>\n    </div>\n</form>\n"

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "\n<form id=\"creerComptePersonnePhysique\" (ngSubmit)=\"register()\" (keydown.enter)=\"$event.preventDefault()\" #registerForm=\"ngForm\" novalidate>\n    <input type=\"hidden\" name=\"franceConnectSubscription\" #franceConnectSubscription=\"ngModel\" [(ngModel)]=\"newAccount.credentials.franceConnectSubscription\">\n\n    <ng-container *ngIf=\"!newAccount.credentials.franceConnectSubscription\">\n        <div class=\"warning_franceConnect explication p-3 mb-5\">\n            <p>\n                <strong>\n                    Pour créer un compte Télérecours citoyens vous avez la possibilité :\n                </strong>\n            </p>\n            <ul class=\"list-unstyled\">\n                <li>\n                    D'utiliser FranceConnect en cliquant sur le bouton \"S'identifier avec FranceConnect\".\n                </li>\n                <li>\n                    Créer un compte Télérecours citoyens en remplissant le formulaire Télérecours citoyens ci-dessous.\n                </li>\n            </ul>\n        </div>\n        <!-- France connect -->\n        <div class=\"row\">\n            <h2>Créer un compte Télérecours citoyens avec FranceConnect</h2>\n            <jhi-franceconnect-button class=\"col-12\"></jhi-franceconnect-button>\n\n        </div>\n        <div class=\"row mt-1 align-items-center\">\n            <hr class=\"col-5\"><span class=\"col-1 text-center\">Ou</span><hr class=\"col-5\">\n        </div>\n    </ng-container>\n\n\n    <div class=\"row py-3\">\n        <h2>Créer un compte Télérecours citoyens en saisissant le formulaire</h2>\n    </div>\n    <div class=\"field-hint\">\n        <span> * champ obligatoire</span>\n    </div>\n    <div class=\"row py-3\" id=\"informationsPersonnelles\">\n        <fieldset>\n            <legend>Informations personnelles</legend>\n            <jhi-identite-personne [identite]=\"newAccount\" [isRepresentant]=\"false\" [isFCUser]=\"isFCUser\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\">\n            </jhi-identite-personne>\n        </fieldset>\n    </div>\n\n    <div class=\"row  py-3\" id=\"Acces\">\n        <fieldset>\n            <legend>Accès</legend>\n            <div class=\"explication col-12\">\n                Pour votre mot de passe, utilisez au moins 12 caractères, une majuscule, des chiffres et des caractères spéciaux. Évitez\n                d'indiquer un mot de passe que vous utilisez déjà sur un autre site ou qui serait trop évident.\n                <a href=\"https://www.cnil.fr/fr/les-conseils-de-la-cnil-pour-un-bon-mot-de-passe\" rel=\"noopener noreferrer\" target=\"_blank\">Pourquoi ?</a>\n            </div>\n            <jhi-credentials [credentials]=\"newAccount.credentials\" [isRepresentant]=\"false\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\">\n            </jhi-credentials>\n        </fieldset>\n    </div>\n\n    <div class=\"row  py-3\" id=\"Telephones\">\n        <fieldset>\n            <legend>Téléphones</legend>\n            <div class=\"explication col-12\">\n                Le numéro de téléphone vous permet d’être contacté par le greffe de la juridiction en cas de question urgente, liée, par exemple, à la tenue d’une audience. Nous privilégierons le téléphone portable au téléphone fixe pour les éventuelles communications.\n            </div>\n            <jhi-contact [contact]=\"newAccount.contact\"></jhi-contact>\n        </fieldset>\n    </div>\n    <div class=\"row  py-3\" id=\"Adresse\">\n        <fieldset>\n            <legend>Adresse</legend>\n            <jhi-address [address]=\"newAccount.address\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"></jhi-address>\n        </fieldset>\n    </div>\n\n    <div class=\"row  py-3\" id=\"captcha\">\n        <fieldset>\n            <legend>Sécurité</legend>\n            <jhi-captcha class=\"col-12 p-0\" name=\"captcha\" [(ngModel)]=\"newAccount.captcha\" [email]=\"newAccount.credentials.email\"  required jhiCaptchaValidator></jhi-captcha>\n            <div class=\"col-12 col-md-5 px-0\">\n                <!-- errorMessageCaptcha -> captcha's input's id (defined in captcha component) -->\n                <jhi-messages [id]=\"'errorMessageCaptcha'\">\n                    <jhi-message [error]=\"'required'\" [controlKey]=\"'captcha'\" *ngIf=\"isCreateAccountBtnClicked\">\n                        <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Captcha'}\"></div>\n                    </jhi-message>\n                    <jhi-message [error]=\"'invalid-captcha'\" [controlKey]=\"'captcha'\">\n                        <div>Le captcha n'est pas valide. Merci de recommencer.</div>\n                    </jhi-message>\n                </jhi-messages>\n            </div>\n        </fieldset>\n    </div>\n\n    <ng-container *ngIf=\"isTechnicalError\">\n        <div role=\"alert\" class=\"alert alert-danger mb-4\">\n            <span>Une erreur est survenue.</span>\n        </div>\n    </ng-container>\n\n    <div class=\"col-12 btn-group\">\n        <jhi-button cancellation (onClick)=\"cancel()\">Annuler</jhi-button>\n        <jhi-button confirmation\n        icon=\"fa-save\"\n        iconRight (click)=\"clickCheck()\">Créer mon compte</jhi-button>\n    </div>\n</form>\n"

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n    <router-outlet></router-outlet>\n</div>\n"

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "<jhi-jumbotron>\n    <h1>Mon compte</h1>\n</jhi-jumbotron>\n\n<div class=\"container\">\n    <div class=\"row\" *ngIf=\"account\">\n        <form (ngSubmit)=\"save()\" #compteForm=\"ngForm\" (keydown.enter)=\"$event.preventDefault()\" novalidate>\n            <div role=\"alert\" class=\"alert alert-warning alert-secondary\">\n                Pour rappel, votre compte Télérecours citoyens est strictement personnel.\n                Vous pouvez modifier vos informations uniquement dans le cas d'un changement d'adresse, de civilité, de nom ou de prénom.\n            </div>\n\t\t\t<div class=\"py-3\">\n                <ng-container *ngIf=\"!isMorale\">\n                    <div role=\"alert\" class=\"alert alert-warning\" *ngIf=\"isFCUser\">\n                        <h2>Vous vous êtes inscrit(e) via FranceConnect</h2>\n                        <p>Pour modifier vos coordonnées, rendez-vous directement dans l’espace utilisé pour vous connecter (Impots.gouv.fr ou Ameli.fr ou Loggin La Poste ou Mobile Connect et moi). Vos modifications seront prises en compte par Télérecours citoyens lors de votre prochaine connexion.</p>\n                    </div>\n                    <div class=\"field-hint\">\n                        <span> * champ obligatoire</span>\n                    </div>\n                    <fieldset>\n                        <legend class=\"pt-3\">Mes informations</legend>\n                        <jhi-identite-personne [identite]=\"account\" [isRepresentant]=\"false\" [isFCUser]=\"isFCUser\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\">\n                        </jhi-identite-personne>\n                        <jhi-contact [contact]=\"account.contact\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"></jhi-contact>\n                        <jhi-address [address]=\"account.address\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"></jhi-address>\n                    </fieldset>\n                </ng-container>\n\n                <ng-container *ngIf=\"isMorale\">\n                    <fieldset>\n                        <legend class=\"pt-3\">Identité de l'organisme</legend>\n                        <jhi-identite-organisme  [identite]=\"account\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"></jhi-identite-organisme>\n                    </fieldset>\n\n                    <fieldset>\n                        <legend class=\"w-100 pt-3\">Représentant de la personne morale</legend>\n                        <jhi-identite-personne [identite]=\"account\" [isRepresentant]=\"true\" [isFCUser]=\"isFCUser\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\">\n                        </jhi-identite-personne>\n                        <jhi-contact [contact]=\"account.contact\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"></jhi-contact>\n                        <jhi-address [address]=\"account.address\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"></jhi-address>\n                    </fieldset>\n                </ng-container>\n            </div>\n\n            <div class=\"row col-12 py-3 identifiant\">\n                <fieldset>\n                    <legend>Identifiants</legend>\n                    <div class=\"row explication col-12\" *ngIf=\"!isFCUser\">\n                        Pour votre mot de passe, utilisez au moins 12 caractères, une majuscule, des chiffres et des caractères spéciaux. Évitez\n                        d'indiquer un mot de passe que vous utilisez déjà sur un autre site ou qui serait trop évident.\n                        <a href=\"https://www.cnil.fr/fr/les-conseils-de-la-cnil-pour-un-bon-mot-de-passe\" rel=\"noopener noreferrer\" title=\"voir les conseils de la CNIL pour un bon mot de passe\" target=\"_blank\">Pourquoi ?</a>\n                    </div>\n\n                    <div class=\"row w-100\">\n                        <jhi-credentials [credentials]=\"account.credentials\" [isRepresentant]=\"isMorale\"\n                        [isNewAccount]=\"false\" [isCreateAccountBtnClicked]=\"isCreateAccountBtnClicked\"\n                        [confirmEmail]=\"confirmEmail\"\n                        >\n                        </jhi-credentials>\n                    </div>\n                </fieldset>\n            </div>\n\n            <div class=\"row col-12 py-3 notification\" id=\"Notification\">\n                <fieldset>\n                    <legend>Notification</legend>\n                    <div class=\"explication col-12\">\n                        Les notifications vous permettent d'être tenu au courant par courrier électronique des nouveautés qui paraissent dans\n                        vos dossiers.\n                    </div>\n                    <jhi-field class=\"col-12 py-3\">\n                        <jhi-select [id]=\"'notification'\" name=\"notification\"\n                            label=\"Type de notification\"\n                            hiddenOptionLabel=\"Choisir une civilité\"\n                            [(ngModel)]=\"account.notification\"\n                            (change)=\"onNotificationValueChange(notificationModal)\" required>\n                            <jhi-option value=\"AUCUNE\">Aucune notification</jhi-option>\n                            <jhi-option value=\"EMAIL\">Courrier électronique</jhi-option>\n                        </jhi-select>\n                    </jhi-field>\n                </fieldset>\n            </div>\n\n            <ng-container *ngIf=\"isTechnicalError\">\n                <div role=\"alert\" class=\"alert alert-danger mb-4\">\n                    <span>Une erreur est survenue.</span>\n                </div>\n            </ng-container>\n            <div *ngIf=\"showSaveMsg || showUpgradeWarning\">\n                <jhi-alert></jhi-alert>\n            </div>\n            <div class=\"row col-12 btn-group\">\n                <jhi-button [isDisabled]=\"disableAnnulerBtn\" cancellation (onClick)=\"cancel()\" (keyup.enter)=\"cancel()\">Annuler</jhi-button>\n                <jhi-button [isDisabled]=\"!compteForm.dirty\" [isLoading]=\"isLoading\" confirmation icon=\"fa-save\" (click)=\"clickCheck()\" \n                (keyup.enter)=\"clickCheckAndSave()\" iconRight>\n                    Enregistrer\n                </jhi-button>\n            </div>\n\n        </form>\n    </div>\n\n</div>\n\n<ng-template #notificationModal let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-content\"\n        aria-modal=\"true\"\n        role=\"alertdialog\"\n        aria-labelledby=\"alert_dialog_notif_label\"\n        aria-describedby=\"alert_dialog_notif_desc\"\n        jhiTrapFocus>\n        <div class=\"modal-header\">\n            <h2 class=\"modal-title\" id=\"alert_dialog_notif_label\">Avertissement</h2>\n            <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Quitter')\">\n                <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n                <span class=\"sr-only\">Fermer la fenêtre</span>\n            </button>\n        </div>\n        <div class=\"modal-body\">\n            <p id=\"alert_dialog_notif_desc\">Les notifications vous permettent d'être tenu au courant par courrier électronique des nouveautés qui paraissent dans vos dossiers.</p>\n        </div>\n        <div class=\"modal-footer btn-group\">\n            <jhi-button (onClick)=\"c('Annuler')\" cancellation>\n                Annuler\n            </jhi-button>\n            <jhi-button (onClick)=\"c('Confirmer')\" confirmation>\n                Confirmer\n            </jhi-button>\n        </div>\n    </div>\n</ng-template>\n\n<ng-template #credentialsChangeModal let-c=\"close\" let-d=\"dismiss\">\n    <div class=\"modal-content\"\n        aria-modal=\"true\"\n        role=\"alertdialog\"\n        aria-labelledby=\"alert_dialog_credential_change_label\"\n        aria-describedby=\"alert_dialog_credential_change_desc\" jhiTrapFocus>\n        <div class=\"modal-header\">\n            <h2 class=\"modal-title\" id=\"alert_dialog_credential_change_label\">Vos identifiants</h2>\n            <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"c('Annuler')\">\n                <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n                <span class=\"sr-only\">Fermer la fenêtre</span>\n            </button>\n        </div>\n        <div class=\"modal-body\">\n            <p id=\"alert_dialog_credential_change_desc\"><strong>Vous allez modifier vos identifiants.</strong> A l'enregistrement, vous allez être déconnecté. Merci d'utiliser vos nouveaux identifiants pour vous reconnecter à votre\n                compte.</p>\n            <p *ngIf=\"account.credentials.email !== account.credentials.oldEmail\">\n                <strong>Vous allez modifier votre adresse de messagerie électronique.</strong>\n                En confirmant, votre nouvelle adresse sera prise en compte.\n                Pour valider celle-ci, cliquez sur le lien présent dans le courrier électronique qui va vous être envoyé.\n            </p>\n        </div>\n        <div class=\"modal-footer btn-group\">\n                <jhi-button (onClick)=\"c('Annuler')\" cancellation>\n                        Annuler\n                </jhi-button>\n                <jhi-button (onClick)=\"c('Confirmer')\" confirmation>\n                        Confirmer\n                </jhi-button>\n        </div>\n\n    </div>\n</ng-template>\n\n\n<ng-template #myInfoChangeModal let-c=\"close\" let-d=\"dismiss\">\n    <div\n        class=\"modal-content\"\n        aria-modal=\"true\"\n        role=\"alertdialog\"\n        aria-labelledby=\"alert_dialog_ma_info_change_label\"\n        aria-describedby=\"alert_dialog_ma_info_change_desc\" jhiTrapFocus>\n        <div class=\"modal-header\">\n            <h2 class=\"modal-title\" id=\"alert_dialog_my_info_change_label\">Avertissement</h2>\n            <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"c('Annuler')\">\n                <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n                <span class=\"sr-only\">Fermer la fenêtre</span>\n            </button>\n        </div>\n        <div class=\"modal-body\">\n            <p id=\"alert_dialog_my_info_change_desc\">\n                Vous vous apprêtez à modifier vos informations personnelles. Pour rappel, votre compte Télérecours citoyens est\n                strictement personnel, vous ne pouvez pas l'utiliser pour déposer un recours pour une autre personne.\n            </p>\n        </div>\n        <div class=\"modal-footer btn-group\">\n                <jhi-button (onClick)=\"c('Annuler')\" cancellation class=\"my-info-modal-cancel-btn\">\n                        Annuler les modifications\n                </jhi-button>\n                <jhi-button (onClick)=\"c('Confirmer')\" confirmation>\n                        Enregistrer quand même\n                </jhi-button>\n        </div>\n    </div>\n</ng-template>\n"

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "<jhi-jumbotron>\n    <h1>Dépôt d'une requête</h1>\n</jhi-jumbotron>\n<jhi-trc-admin-config class=\"msg-band\"></jhi-trc-admin-config>\n<div class=\"container\">\n    <jhi-breadcrumb [steps]=\"steps\"></jhi-breadcrumb>\n    <div role=\"alert\" class=\"alert alert-success alert-dismissible\" *ngIf=\"isRetakenDraft\">\n        <button type=\"button\" class=\"close\" aria-label=\"Fermer\" (click)=\"close()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <span>La sauvegarde de votre brouillon en date du {{ dateAndHour[0] }}, {{ dateAndHour[1] }}, a bien été rétablie. \n        </span>\n    </div>\n    <router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n</div>\n"

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-12\">\n    <h2 class=\"display-4 mb-4 text-center\">Avertissement avant le dépôt d'une requête</h2>\n    <div class=\"explication\">\n        <p>\n            Vous allez saisir la justice administrative par le dépôt d’une requête contentieuse.\n        </p>\n        <p>\n            Avant d’envisager un recours contentieux, vous pouvez\n            <a href=\"https://www.conseil-etat.fr/vos-demarches/je-suis-un-particulier/recourir-a-la-mediation\" rel=\"noopener noreferrer\" target=\"_blank\">recourir à\n                la médiation</a>\n            afin de parvenir à une résolution amiable du litige qui vous oppose à l'administration concernée.\n        </p>\n        <p>\n            Vous pouvez <a [routerLink]=\"['/faq']\" fragment=\"item-49\" rel=\"noopener noreferrer\" target=\"_blank\">faire une demande d'aide juridictionnelle</a> afin de bénéficier d'une prise en charge totale ou partielle \n            par l'État de vos frais de justice (honoraires d'avocat notamment) selon le niveau de vos ressources.\n        </p>\n    </div>\n</div>\n<jhi-cgu [cguTypeEnum]=\"cguTypeEnum\" class=\"col-12\"></jhi-cgu>\n<form novalidate class=\"col-lg-6 col-12 offset-lg-3 mb-2\">\n    <div role=\"list\">\n        <div class=\"form-check\" role=\"listitem\">\n            <input\n                type=\"checkbox\"\n                class=\"form-check-input\"\n                name=\"teleprocedureCheckbox\"\n                id=\"teleprocedureCheckbox\"\n                [(ngModel)]=\"_teleprocedures\"\n                aria-describedby=\"errorMessage\"\n                required>\n            <label class=\"form-check-label lb_clickable\" for=\"teleprocedureCheckbox\">J'accepte l'utilisation des\n                téléprocédures pour cette requête.</label>\n        </div>\n\n        <div class=\"form-check\" role=\"listitem\">\n            <input\n                type=\"checkbox\"\n                class=\"form-check-input\"\n                name=\"cguCheckbox\"\n                id=\"cguCheckbox\"\n                [(ngModel)]=\"_cgu\"\n                aria-describedby=\"errorMessage\"\n                required>\n            <label class=\"form-check-label lb_clickable\" for=\"cguCheckbox\">J’ai lu et j’accepte les conditions générales\n                d’utilisation.</label>\n        </div>\n    </div>\n</form>\n<div class=\"col-12\">\n    <div\n        class=\"alert alert-danger alert-secondary\"\n        *ngIf=\"form.invalid && isSubmitted\"\n        id=\"errorMessage\">\n        Vous devez accepter ces 2 éléments en cochant les cases pour passer à l'étape suivante.\n    </div>\n</div>\n\n<!-- Alert -->\n<jhi-alert></jhi-alert>\n\n<div class=\"btn pull-right\">\n    <jhi-next-button [label]=\"'Page suivante - Requérant'\" [clickHandler]=\"next.bind(this)\"></jhi-next-button>\n</div>\n"

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "<jhi-section [state]=\"state\" class=\"col-12\">\n    <ng-template #header>\n        <h2 aria-hidden=\"true\">Choisissez la juridiction</h2>\n    </ng-template>\n    <ng-template #help>\n        <div class=\"explication\">\n            <strong>Vous hésitez ?</strong>\n            <p>Consultez <a href=\"https://www.conseil-etat.fr/tribunaux-cours/organisation\" rel=\"noopener noreferrer\" title=\"Ouvrir l'article sur l'organisation des tribunaux et cours dans une nouvelle fenêtre\" target=\"_blank\">cet\n                article</a> pour vous orienter dans votre processus</p>\n        </div>\n    </ng-template>\n    <ng-template #content>\n        <div class=\"py-3 field-hint\">\n            <span> * champ obligatoire</span>\n        </div>\n        <fieldset class=\"row radio-fieldset\">\n            <legend class=\"sr-only\">\n                Choisissez la juridiction\n            </legend>\n            <div class=\"col-sm-12 radio-fieldset__wrapper\">\n                <div (click)=\"onSetJuridiction(juridictionText.value)\"\n                     *ngFor=\"let juridictionText of juridictionTexts\"\n                     [ngClass]=\"{\n                        'radio-fieldset__item--inactive': selectedJuridictionCode !== juridictionText.value,\n                        'radio-fieldset__item--active': selectedJuridictionCode == juridictionText.value\n                     }\"\n                     class=\"radio-fieldset__item\">\n                    <div class=\"radio-fieldset__item__input\">\n                        <input\n                            (ngModelChange)=\"onSetJuridiction($event)\"\n                            [(ngModel)]=\"selectedJuridictionCode\"\n                            [attr.aria-describedby]=\"juridictionText.value + ' errorMessageJuridiction'\"\n                            required\n                            id=\"radio-{{ juridictionText.value }}\"\n                            name=\"chosen-jurisdiction\"\n                            type=\"radio\"\n                            value=\"{{ juridictionText.value }}\"\n                            tabindex=\"0\">\n                    </div>\n                    <div class=\"radio-fieldset__item__label\">\n                        <label\n                            for=\"radio-{{ juridictionText.value }}\">\n                            {{ juridictionText.title }}\n                        </label>\n                        <p [id]=\"juridictionText.value\">{{ juridictionText.description }}</p>\n                    </div>\n                </div>\n            </div>\n        </fieldset>\n    </ng-template>\n</jhi-section>\n"

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"requerantAutoSaveSuccess\">\n    <jhi-alert></jhi-alert>\n</div>\n\n<form class=\"col-12\">\n    <!-- Juridiction -->\n    <jhi-juridiction-section\n        name=\"type-juridiction\"\n        [(ngModel)]=\"depotRequeteState.typeJuridiction\"\n        (ngModelChange)=\"onTypeJuridictionChange($event)\" required>\n    </jhi-juridiction-section>\n    <jhi-messages [id]=\"'errorMessageJuridiction'\">\n        <jhi-message error=\"required\" controlKey=\"type-juridiction\">\n            <div>Pour continuer, merci de sélectionner un type de juridiction.</div>\n        </jhi-message>\n    </jhi-messages>\n\n     <!-- Site juridiction  -->\n    <ng-container *ngIf=\"displaySiteJuridictionSection()\">\n        <jhi-site-juridiction-section name=\"site-juridiction\" class=\"site-juridiction\"\n            [typeJuridiction]=\"depotRequeteState.typeJuridiction\"\n            [(ngModel)]=\"depotRequeteState.siteJuridiction\"\n            required>\n        </jhi-site-juridiction-section>\n        <jhi-messages [id]=\"'errorMessageSiteJuridiction'\">\n            <jhi-message error=\"required\" controlKey=\"site-juridiction\">\n                <div >Pour continuer, merci de sélectionner une juridiction de dépôt.</div>\n            </jhi-message>\n        </jhi-messages>\n    </ng-container>\n\n    <!-- Acte attaqué - CAA -->\n    <ng-container *ngIf=\"displayTypeActeAttaqueSection()\">\n        <jhi-type-acte-attaque-section name=\"type-acte-attaque\"\n            [siteJuridiction]=\"depotRequeteState.siteJuridiction\"\n            [(ngModel)]=\"depotRequeteState.typeActeAttaque\"\n            required>\n        </jhi-type-acte-attaque-section>\n        <jhi-messages [id]=\"'errorMessageActe'\">\n            <jhi-message error=\"required\" controlKey=\"type-acte-attaque\">\n                <div >Pour continuer, merci de sélectionner le type d'acte attaqué.</div>\n            </jhi-message>\n        </jhi-messages>\n    </ng-container>\n</form>\n\n<!-- Alert -->\n<div *ngIf=\"saveDraftSuccess || saveDraftError\">\n    <jhi-alert></jhi-alert>\n</div>\n\n<div role=\"alert\" class=\"alert alert-warning alert-dismissible\" *ngIf=\"autoSaveError\">\n    <button type=\"button\" class=\"close\" aria-label=\"Fermer\" (click)=\"close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <span>Nous n'avons pas pu effectuer de sauvegarde automatique de votre requête. Vous pouvez tenter de \n        <a href=\"javascript:void(0);\" class=\"restart-request\" (click)=\"saveDraftAgain()\">sauvegarder à nouveau</a>\n        ou <a class=\"restart-request\" href=\"#/depot-requete/avertissement\">recommencer au début.</a></span>\n</div>\n\n<!-- Buttons -->\n<div class=\"col-12 btn-group\">\n    <jhi-previous-button [label]=\"'Page précédente - Requérant'\" [clickHandler]=\"previous.bind(this)\"></jhi-previous-button>\n    <jhi-save-draft-requete-button [clickHandler]=\"saveDraft.bind(this)\"></jhi-save-draft-requete-button>\n    <jhi-next-button [label]=\"'Page suivante - Requête'\" [clickHandler]=\"next.bind(this)\"></jhi-next-button>\n</div>\n"

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "<input type=\"text\" name=\"site-juridiction-hidden\" [(ngModel)]=\"siteJuridiction\" hidden>\n<jhi-section class=\"col-12\" [state]=\"state\">\n    <ng-template #header>\n        <h2>Choisissez votre juridiction de dépôt</h2>\n    </ng-template>\n    <ng-template #help>\n        <div class=\"explication col-12\">\n            <strong>Vous hésitez ?</strong>\n            <!-- help for TA -->\n            <div *ngIf=\"typeJuridiction.code === 'TA'\">\n                <p>\n                    En principe, le tribunal administratif compétent est celui du département du siège de l’administration qui a pris la décision attaquée ou a signé le contrat litigieux.\n                    Pour savoir quel est le tribunal compétent, effectuez une recherche par département sur la <a href=\"https://www.conseil-etat.fr/#carte-juridiction\" rel=\"noopener noreferrer\" target=\"_blank\">carte des juridictions.</a><br>\n                </p>\n                <p>\n                    Des exceptions existent toutefois, pour plus d'explications <a href=\"https://www.conseil-etat.fr/qui-sommes-nous/tribunaux-et-cours/missions#anchor3\" rel=\"noopener noreferrer\" target=\"_blank\">consultez cet article.</a>\n                </p>\n\n            </div>\n            <!-- help for CAA -->\n            <div *ngIf=\"typeJuridiction.code === 'CAA'\">\n                  <p>\n                      Si vous souhaitez faire appel d'un jugement, le courrier de notification de ce jugement vous indique la juridiction de dépôt compétente.<br>\n                      Si vous souhaitez saisir une cour administrative d'appel en premier ressort, vous pouvez consulter nos explications dans <a href=\"https://www.conseil-etat.fr/tribunaux-cours/organisation\" rel=\"noopener noreferrer\" target=\"_blank\">cet article</a>.\n                  <p>\n              </div>\n        </div>\n    </ng-template>\n    <ng-template #content>\n        <div class=\"form-group\" [ngClass]=\"{ 'invalid': isInvalid, 'valid': isValid, 'required': isRequired }\">\n            <label for=\"site-juridiction-id\" class=\"has-value\">Veuillez sélectionner une juridiction de dépôt</label>\n            <select name=\"site-juridiction-id\" class=\"custom-select focus-outline\" id=\"site-juridiction-id\"\n                [(ngModel)]=\"siteJuridictionId\" (ngModelChange)=\"onSiteJuridictionChange($event)\">\n                <option hidden [value]=\"undefined\">Choisir une juridiction</option>\n                <option *ngFor=\"let siteJuridiction of typeJuridiction.siteJuridictions\" [value]=\"siteJuridiction.id\">\n                    {{siteJuridiction.libelleCourt}}\n                </option>\n            </select>\n        </div>\n    </ng-template>\n</jhi-section>\n"

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = "<div class=\"explication col-12\"\n    *ngIf=\"siteJuridiction.code !== 'CA44' && isOnlyProcessedByCA44()\" > <!-- Nantes-->\n    <div class=\"avertissement-header\">Avertissement sur le choix de votre juridiction de dépôt</div>\n    <div>\n        Le type d'acte attaqué que vous venez de sélectionner, relève de la <strong>Cour administrative d'appel de Nantes</strong>.\n        Votre requête est donc susceptible de lui être transférée, occasionnant ainsi un délai supplémentaire.\n        Vous pouvez encore modifier le choix de la juridiction de dépôt à l'étape 2 de ce formulaire.\n    </div>\n</div>\n\n<div class=\"explication col-12\"\n    *ngIf=\"siteJuridiction.code !== 'CA75' && isOnlyProcessedByCA75()\" > <!-- Paris-->\n    <div class=\"avertissement-header\">Avertissement sur le choix de votre juridiction de dépôt</div>\n    <div>\n        Le type d'acte attaqué que vous avez sélectionné relève de la <strong>Cour administrative d'appel de Paris</strong>.\n        Veuillez sélectionner \"Paris\" comme juridiction de dépôt dans le champ \"2. Choisissez votre juridiction de dépôt\" ci-dessus.\n    </div>\n</div>"

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "<div class=\"explication col-12\">\n    <div class=\"avertissement-header\" *ngIf=\"typeActeAttaqueCode !== 'AUTRES'\">Votre requête concerne :</div>\n    <ng-container [ngSwitch]=\"typeActeAttaqueCode\">\n        <div *ngSwitchCase=\"'DCNACOM'\">\n            Les décisions prises par la Commission nationale d'aménagement commercial en application de l'article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000005634379&idArticle=LEGIARTI000006241322&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">L.&nbsp;752-17</a> du code de commerce (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=LEGIARTI000030345238&amp;cidTexte=LEGITEXT000006070933&amp;categorieLien=id\"\n               rel=\"noopener noreferrer\" target=\"_blank\">R.&nbsp;311-3</a> du code de justice administrative).\n        </div>\n\n        <div *ngSwitchCase=\"'DCNACINE'\">\n            Les décisions prises par la Commission nationale d'aménagement cinématographique en application de l'article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000020908868&idArticle=LEGIARTI000029105556&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">L.&nbsp;212-10-3</a> du code du cinéma et de l'image animée\n            (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=LEGIARTI000030345238&amp;cidTexte=LEGITEXT000006070933&amp;categorieLien=id\"\n               rel=\"noopener noreferrer\" target=\"_blank\">R.&nbsp;311-3</a> du code de justice administrative).\n        </div>\n\n        <div *ngSwitchCase=\"'DMCGV'\">\n            Les litiges en matière de contraventions de grande voirie mentionnés à l'article\n            <a href=\"https://www.legifrance.gouv.fr/affichCode.do?idSectionTA=LEGISCTA000006150408&cidTexte=LEGITEXT000006070933&dateTexte=20181113\"\n               rel=\"noopener noreferrer\" target=\"_blank\">\n                L.&nbsp;774-1&nbsp;et&nbsp;suivants\n            </a>\n            du code de justice administrative.\n        </div>\n\n        <div *ngSwitchCase=\"'AMTRRS'\">\n            Des arrêtés du ministre chargé du travail relatifs à la représentativité des organisations syndicales de\n            salariés et des\n            organisations professionnelles d'employeurs, pris en application des articles\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006072050&idArticle=LEGIARTI000019347748&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">L.&nbsp;2122-11</a> et\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006072050&idArticle=LEGIARTI000028689669&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">L.&nbsp;2152-6</a> du code du travail (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=LEGIARTI000026476391&amp;cidTexte=LEGITEXT000006070933\"\n               rel=\"noopener noreferrer\" target=\"_blank\">R.&nbsp;311-2</a> du code de justice administrative).\n        </div>\n\n        <div *ngSwitchCase=\"'DCSARLC'\">\n            Des litiges relatifs aux décisions prises par le Conseil supérieur de l'audiovisuel en application des\n            articles\n            <a href=\"https://www.legifrance.gouv.fr/affichTexteArticle.do?cidTexte=JORFTEXT000000512205&idArticle=LEGIARTI000006420319&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">28-1, 28-3 et 29 à 30-7 de la loi n°&nbsp;86-1067 du 30\n                septembre 1986</a>\n            relative à la liberté de communication, à l'exception de celles concernant les services de télévision à\n            vocation nationale\n            (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=LEGIARTI000026476391&cidTexte=LEGITEXT000006070933\"\n               rel=\"noopener noreferrer\" target=\"_blank\">R. 311-2</a> du code de justice administrative).\n        </div>\n\n        <div *ngSwitchCase=\"'DMCRVEC'\">\n            Les décisions du ministre chargé de la culture relatives à la délivrance ou au refus de délivrance du visa\n            d'exploitation cinématographique aux œuvres ou documents cinématographiques ou audiovisuels destinés\n            à une représentation cinématographique, prises en application de l'article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000020908868&idArticle=LEGIARTI000020907879&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">L.&nbsp;211-1</a> du code du cinéma et de l'image animée\n            (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=LEGIARTI000026476391&cidTexte=LEGITEXT000006070933\"\n               rel=\"noopener noreferrer\" target=\"_blank\">R.&nbsp;311-2</a> du code de justice administrative).\n        </div>\n\n        <div *ngSwitchCase=\"'DLPC'\">\n            Les décisions de l'autorité polynésienne de la concurrence qui ne relèvent pas du juge judiciaire (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=LEGIARTI000026476391&cidTexte=LEGITEXT000006070933\"\n               rel=\"noopener noreferrer\" target=\"_blank\">\n                R.&nbsp;311-2\n            </a>\n            du code de justice administrative).\n        </div>\n\n        <div *ngSwitchCase=\"'DRIPERM'\">\n            Les décisions relatives aux installations de production d'énergie renouvelable en mer et leurs ouvrages\n            connexes (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000031845644&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">\n                R.&nbsp;311-4\n            </a>\n            du code de justice administrative).\n        </div>\n\n        <div *ngSwitchCase=\"'DRCIPPTD'\">\n            Les décisions relatives aux infrastructures portuaires rendues nécessaires pour la construction,\n            le stockage et le pré-assemblage des installations mentionnées aux I et II de l’article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000031845644&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">R.&nbsp;311-4</a> du code de justice administrative ainsi qu'aux opérations de transport\n            et de dragage connexes\n            (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000031845644&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">R.&nbsp;311-4</a> du code de justice administrative).\n        </div>\n        <div *ngSwitchCase=\"'DRORPEPSM'\">\n            Les décisions relatives aux ouvrages des réseaux publics d'électricité dont au moins une partie est située\n            en mer,\n            jusques et y compris aux premiers postes de raccordement à terre (article\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000031845644&dateTexte=&categorieLien=cid\"\n               rel=\"noopener noreferrer\" target=\"_blank\">\n                R.&nbsp;311-4\n            </a>\n            du code de justice administrative).\n        </div>\n        <div *ngSwitchCase=\"'DBAJ'\">\n            Les décisions des bureaux d’aide juridictionnelle relatifs aux affaires portées ou susceptibles d'être\n            portées\n            devant les tribunaux administratifs, les cours administratives d’appel ou le Conseil d’Etat (Articles\n            <a href=\"https://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000000721124\"\n               rel=\"noopener noreferrer\" target=\"_blank\">\n                56 et suivants\n            </a>\n            du décret n°&nbsp;91-1266 du 19 décembre 1991 portant application de la loi n°&nbsp;91-647 du 10\n            juillet 1991 relative à l'aide juridique).\n        </div>\n        <div *ngSwitchCase=\"'AUTRES'\">\n            Attention, en dehors des cas énumérés ci-dessus, il pourra vous être demandé de régulariser votre requête\n            en la présentant par un avocat (articles\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000027432314\"\n               rel=\"noopener noreferrer\" target=\"_blank\">\n                R.&nbsp;431-11\n            </a> et\n            <a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?idArticle=LEGIARTI000034386094&cidTexte=LEGITEXT000006070933&dateTexte=20181113\"\n               rel=\"noopener noreferrer\" target=\"_blank\">\n                R.&nbsp;811-7\n            </a>\n            du code de justice administrative)\n        </div>\n    </ng-container>\n</div>\n"

/***/ }),
/* 781 */
/***/ (function(module, exports) {

module.exports = "<jhi-section class=\"col-12\" [state]=\"state\">\n    <ng-template #header>\n        <h2>Indiquez le type d'acte attaqué</h2>\n    </ng-template>\n    <ng-template #help>\n        <div class=\"explication col-12\">\n            <p>La plupart des requêtes devant une cour administrative d’appel doivent être présentées par un avocat.</p>\n            <p>\n                Dans certains cas, ce n’est pas obligatoire : il s’agit des cas figurant dans la liste ci-dessous.\n                Si vous choisissez l’option « Autres », il pourra vous être demandé de régulariser votre requête en\n                la présentant par un avocat.\n            </p>\n            <p>\n                Pour plus d'informations, veuillez consulter les\n                <a routerLink=\"/faq\" [queryParams]=\"{rank: typeActeAttaqueFaqItemRank}\" target=\"_blank\">explications suivantes</a>\n            </p>\n        </div>\n    </ng-template>\n    <ng-template #content>\n        <div class=\"form-group\" [ngClass]=\"{ 'invalid': isInvalid, 'valid': isValid, 'required': isRequired }\">\n            <label for=\"type-acte-attaque-id\" class=\"has-value\">Veuillez sélectionner le type d'acte attaqué</label>\n            <select name=\"type-acte-attaque-id\" class=\"custom-select focus-outline\" id=\"type-acte-attaque-id\"\n                    [(ngModel)]=\"typeActeAttaqueCode\"\n                    (ngModelChange)=\"onTypeActesAttaqueChange($event)\">\n                <option hidden [value]=\"undefined\">Choisir un type d'acte attaqué</option>\n                <option *ngFor=\"let typeActeAttaque of typeActesAttaques\" [value]=\"typeActeAttaque.code\">\n                    {{typeActeAttaque.description}}\n                </option>\n            </select>\n        </div>\n\n        <!-- <jhi-type-acte-attaque-info\n            [typeActeAttaqueCode]=\"typeActeAttaqueCode\"\n            *ngIf=\"typeActeAttaqueCode\">\n        </jhi-type-acte-attaque-info> -->\n\n        <jhi-type-acte-attaque-avertissement\n            [siteJuridiction]=\"siteJuridiction\"\n            [typeActeAttaqueCode]=\"typeActeAttaqueCode\"\n            *ngIf=\"typeActeAttaqueCode\">\n        </jhi-type-acte-attaque-avertissement>\n\n    </ng-template>\n</jhi-section>\n"

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "<div dragula=\"acteAttaqueBag\" [dragulaModel]=\"acteAttaques\">\n    <div class=\"row no-gutters\"\n        *ngFor=\"let piece of acteAttaques; let i = index; trackBy: trackByFileApiId\">\n        <div class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n             tabindex=\"0\" [id]=\"trackByFileApiId(i, piece)\" role=\"button\" aria-label=\"déplacer ce fichier\"\n             jhiA11yDragNDropDirective [index]=\"i\" [piece]=\"piece\" [selectedItem]=\"selectedItem\"\n             (a11ySelect)=\"onSelect($event)\" (a11yMoveup)=\"onMoveup($event)\"\n             (a11yMovedown)=\"onMovedown($event)\" (a11yEscape)=\"onEscape($event)\">\n            <span class=\"fa fa-arrows fa-2x\" aria-hidden=\"true\"></span>\n        </div>\n        <div class=\"col-lg-11 col-12\">\n            <div class=\"d-lg-none text-center \">\n                <button type=\"button\" (click)=\"moveUp(i)\" class=\"btn btn-outline mx-3\">\n                    <span class=\"fa fa-arrow-up\" aria-hidden=\"true\" title=\"déplacer ce fichier vers le haut\"></span>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                </button>\n                <button type=\"button\" (click)=\"moveDown(i)\" class=\"btn btn-outline mx-3\">\n                    <span class=\"fa fa-arrow-down\" aria-hidden=\"true\" title=\"descendre ce fichier\"></span>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                </button>\n            </div>\n            <jhi-file-uploader inputName=\"piece-{{piece.fileModel.fileApiId}}\" label=\"{{adderLabel}} - document {{i + 1}}\"\n                [file]=\"piece.fileModel\"\n                [id]=\"'acte-attaque-piece-'+ i + 1\"\n                [url]=\"uploadUrl\"\n                (fileChange)=\"onActeAttaqueDelete(i, $event)\">\n            </jhi-file-uploader>\n        </div>\n    </div>\n</div>\n<jhi-file-uploader inputName=\"acte-attaque-piece-adder\"\n    label=\"{{adderLabel}} - document {{acteAttaques.length + 1}}\"\n    [id]=\"'acte-attaque-document-' + acteAttaques.length + 1\"\n    (fileChange)=\"onActeAttaqueAdd($event)\"\n    [required]=\"acteRequired && acteAttaques.length === 0\"\n    [url]=\"uploadUrl\"\n    *ngIf=\"acteAttaques.length < maxActeAttaquesForMerge\" #acteAttaquesAdder>\n</jhi-file-uploader>\n"

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"requeteAutoSaveSuccess\">\n    <jhi-alert></jhi-alert>\n</div>\n\n<div class=\"col-12\">\n    <p role=\"alert\" class=\"alert alert-warning\">\n        Formats acceptés : PDF, DOC, DOCX, ODT, RTF, GIF, JPG et PNG.<br />\n        Les documents qui ne sont pas en PDF sont automatiquement convertis dans\n        ce format.<br />\n        Taille maximale par fichier : {{ maxFileSize | formatFileSize }}.\n    </p>\n</div>\n\n<form class=\"col-12\">\n    <jhi-section [state]=\"sections.obligatoires\">\n        <ng-template #header>\n            <h2>Pièces obligatoires</h2>\n        </ng-template>\n        <ng-template #content>\n            <div class=\"field-hint\">\n                <span> * champ obligatoire</span>\n            </div>\n            <div>\n                <h3>Requête</h3>\n                <p class=\"explication\" *ngIf=\"!depotRequeteState.formActivated && !depotRequeteState.concernContentieuxSocial\">\n                    Pour déposer votre requête, vous devez produire une requête\n                    (qui expose votre demande, rappelle les faits et présente\n                    vos arguments) et fournir l’acte que vous souhaitez\n                    attaquer.\n                </p>\n                <p class=\"explication\"\n                *ngIf=\"(depotRequeteState.formActivated && depotRequeteState.requeteCS?.souhait !== 'Déposer une requête que vous avez rédigée') ||\n                (!depotRequeteState.formActivated && depotRequeteState.concernContentieuxSocial)\">\n                <strong>Important</strong>: votre document de requête a été généré suite aux informations saisies précédemment (étape 4 « Requête »).\n                Vous pouvez visualiser votre requête en la téléchargeant. <strong>Si vous souhaitez modifier</strong> votre requête, il vous suffit\n                de retourner à l’étape précédente.\n                </p>\n                <p class=\"explication\" *ngIf=\"depotRequeteState.formActivated && depotRequeteState.requeteCS?.souhait === 'Déposer une requête que vous avez rédigée'\">\n                    Dans votre requête, vous devez rappeler le contexte de votre demande, présenter vos arguments et indiquer ce que vous demandez au juge.\n                </p>\n                <jhi-file-uploader\n                    inputName=\"requete\"\n                    [id]=\"'requete'\"\n                    [label]=\"depotRequeteState.requete?.libelle || 'Requête'\"\n                    [file]=\"depotRequeteState.requete?.fileModel\"\n                    [required]=\"true\"\n                    [url]=\"uploadUrl\"\n                    (fileChange)=\"onRequeteChange($event)\"\n                ></jhi-file-uploader>\n            </div>\n            <div *ngIf=\"(depotRequeteState.concernContentieuxSocial &&\n                depotRequeteState.requeteCS?.hasDocument) ||\n                (depotRequeteState.formActivated &&\n                !depotRequeteState.concernContentieuxSocial &&\n                depotRequeteState.requeteCS?.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration') ||\n                (depotRequeteState.formActivated &&\n                !depotRequeteState.concernContentieuxSocial &&\n                depotRequeteState.requeteCS?.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent' &&\n                depotRequeteState.requeteCS?.typeLitige === 'Vous contestez une somme d\\'argent réclamée par l\\'administration') ||\n                (depotRequeteState.formActivated &&\n                !depotRequeteState.concernContentieuxSocial &&\n                depotRequeteState.requeteCS?.souhait === 'Déposer une requête que vous avez rédigée') ||\n                (!depotRequeteState.formActivated && !depotRequeteState.concernContentieuxSocial) ||\n                (depotRequeteState.urgenceRequete?.codeUrgence !== 0)\">\n                <h3>Acte attaqué</h3>\n                <p class=\"explication\" *ngIf=\"!depotRequeteState.concernContentieuxSocial\">\n                    Si vous versez plusieurs documents pour l'acte attaqué, ils\n                    seront automatiquement fusionnés dans l'ordre que vous avez\n                    choisi, afin de produire un document unique. Ce nouveau\n                    document ne doit pas dépasser\n                    {{ maxFileSize | formatFileSize }}. Si vous n’êtes pas en\n                    mesure de produire l’acte attaqué, vous devez télécharger un\n                    document dans lequel vous expliquez les raisons de son\n                    absence.\n                </p>\n                <p class=\"explication\" *ngIf=\"depotRequeteState.concernContentieuxSocial\">\n                    Si vous versez plusieurs documents pour l'acte attaqué, ils\n                    seront automatiquement fusionnés dans l'ordre que vous avez\n                    choisi, afin de produire un document unique. Ce nouveau\n                    document ne doit pas dépasser {{ maxFileSize | formatFileSize }}.\n                    <strong>Si vous n’êtes pas en mesure de produire l’acte attaqué,\n                        vous devez télécharger le document justificatif d’envoi de votre demande\n                        restée sans réponse de la part de l’administration.</strong>\n                </p>\n                <jhi-acte-attaque\n                    name=\"acteAttaques\"\n                    [(ngModel)]=\"depotRequeteState.acteAttaquesAFusioner\"\n                    [adderLabel]=\"'Acte attaqué'\"\n                    [maxActeAttaquesForMerge]=\"maxActeAttaquesForMerge\"\n                    [acteRequired]=\"true\"\n                    [class.invalid]=\"isActeAttaquesMaxSizeExceeded\"\n                    (change)=\"resetGeneratedActeAttaque()\"\n                >\n                </jhi-acte-attaque>\n                <div\n                    role=\"alert\"\n                    class=\"alert alert-danger\"\n                    *ngIf=\"isActeAttaquesMaxSizeExceeded\"\n                >\n                    La taille de l'ensemble des fichiers ci-dessus et formant\n                    l'acte attaqué dépasse le maximum de\n                    {{ maxFileSize | formatFileSize }}.\n                </div>\n                <jhi-messages role=\"alert\">\n                    <jhi-message\n                        error=\"max-file-length-exceeded\"\n                        controlKey=\"acteAttaques\"\n                        role=\"alert\"\n                    >\n                        <span>\n                            La taille du document généré par l'ensemble des\n                            fichiers ci-dessus et formant l'acte attaqué dépasse\n                            le maximum de {{ maxFileSize | formatFileSize }}.\n                        </span>\n                    </jhi-message>\n                </jhi-messages>\n            </div>\n            <div\n                *ngIf=\"depotRequeteState.formActivated &&\n                (depotRequeteState?.concernContentieuxSocial === false ||\n                depotRequeteState.typeJuridiction?.code === 'CE') &&\n                (depotRequeteState?.requeteCS?.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent' &&\n                depotRequeteState?.requeteCS?.typeLitige !== 'Vous contestez une somme d\\'argent réclamée par l\\'administration')\"\n            >\n                <h3>Réclamation préalable</h3>\n                <p class=\"explication\">\n                    Si vous versez plusieurs documents pour la réclamation préalable, ils\n                    seront automatiquement fusionnés dans l'ordre que vous avez\n                    choisi, afin de produire un document unique. Ce nouveau\n                    document ne doit pas dépasser {{ maxFileSize | formatFileSize }}.\n                    Si vous n’êtes pas en mesure de produire la réclamation préalable,\n                    vous devez télécharger un document dans lequel vous expliquez les raisons de son absence.\n                </p>\n                <jhi-reclamation-prealable\n                    name=\"reclamationPrealables\"\n                    [(ngModel)]=\"depotRequeteState.reclamationPrealablesAFusioner\"\n                    [maxReclamationPrealablesForMerge]=\"maxReclamationPrealablesForMerge\"\n                    [class.invalid]=\"isReclamationPrealablesMaxSizeExceeded\"\n                    [required]=\"true\"\n                    (change)=\"resetGeneratedReclamationPrealable()\"\n                >\n                </jhi-reclamation-prealable>\n                <div\n                    role=\"alert\"\n                    class=\"alert alert-danger\"\n                    *ngIf=\"isReclamationPrealablesMaxSizeExceeded\"\n                >\n                    La taille de l'ensemble des fichiers ci-dessus et formant\n                    la réclamation préalable dépasse le maximum de\n                    {{ maxFileSize | formatFileSize }}.\n                </div>\n                <jhi-messages role=\"alert\">\n                    <jhi-message\n                        error=\"max-file-length-exceeded\"\n                        controlKey=\"reclamationPrealables\"\n                        role=\"alert\"\n                    >\n                        <span>\n                            La taille du document généré par l'ensemble des\n                            fichiers ci-dessus et formant la réclamation préalable dépasse\n                            le maximum de {{ maxFileSize | formatFileSize }}.\n                        </span>\n                    </jhi-message>\n                </jhi-messages>\n            </div>\n        </ng-template>\n    </jhi-section>\n\n    <jhi-section [state]=\"sections.complementaires\">\n        <ng-template #header>\n            <h2>Pièces complémentaires</h2>\n        </ng-template>\n        <ng-template #help>\n            <div class=\"explication\">\n                <p>\n                    Vous pouvez déposer ici, à l’appui de votre requête, toutes\n                    les pièces en votre possession qui permettront d’éclairer le\n                    juge.\n                </p>\n                <p>\n                    Vous pouvez les classer selon l’ordre qui vous semble le\n                    plus adapté pour une meilleure compréhension de votre\n                    requête.\n                </p>\n                <p>\n                    Afin de ne pas ralentir le téléchargement des documents, nous vous invitons à envoyer lors du dépôt de recours\n                    uniquement les documents qui appuient directement votre demande, et d'envoyer les documents complémentaires\n                    restants une fois votre dossier enregistré, via la section \"ajouter des documents complémentaires\"\n                    de la consultation de dossier.\n                </p>\n                <p>\n                    Pour que votre requête puisse être recevable, il vous faut\n                    déposer un fichier par pièce.\n                </p>\n                <p>\n                    Les fichiers doivent être nommés en leur donnant un intitulé\n                    qui décrit leur contenu de manière suffisamment explicite,\n                    sous peine d’être écartés des débats.\n                </p>\n            </div>\n        </ng-template>\n        <ng-template #content>\n            <div\n                dragula=\"piecesComplementairesBag\"\n                [dragulaModel]=\"depotRequeteState.piecesComplementaires\"\n            >\n                <div\n                    class=\"row no-gutters\"\n                    *ngFor=\"\n                        let piece of depotRequeteState.piecesComplementaires;\n                        let i = index;\n                        trackBy: trackByFileApiId\n                    \"\n                >\n                    <div\n                        class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n                        tabindex=\"0\"\n                        [id]=\"trackByFileApiId(i, piece)\"\n                        role=\"button\"\n                        aria-label=\"déplacer ce fichier\"\n                        jhiA11yDragNDropDirective\n                        [index]=\"i\"\n                        [piece]=\"piece\"\n                        [selectedItem]=\"selectedItem\"\n                        (a11ySelect)=\"onSelect($event)\"\n                        (a11yMoveup)=\"onMoveup($event)\"\n                        (a11yMovedown)=\"onMovedown($event)\"\n                        (a11yEscape)=\"onEscape($event)\"\n                    >\n                        <i\n                            class=\"fa fa-arrows fa-2x\"\n                            aria-hidden=\"true\"\n                            title=\"déplacer ce fichier\"\n                        ></i>\n                    </div>\n                    <div class=\"col-lg-11 col-12\">\n                        <div class=\"d-lg-none text-center\">\n                            <button\n                                type=\"button\"\n                                (click)=\"moveUp(i)\"\n                                class=\"btn btn-outline mx-3\"\n                            >\n                                <i\n                                    class=\"fa fa-arrow-up\"\n                                    aria-hidden=\"true\"\n                                    title=\"déplacer ce fichier vers le haut\"\n                                ></i>\n                                <span class=\"sr-only\"\n                                    >déplacer ce fichier vers le haut</span\n                                >\n                            </button>\n                            <button\n                                type=\"button\"\n                                (click)=\"moveDown(i)\"\n                                class=\"btn btn-outline mx-3\"\n                            >\n                                <i\n                                    class=\"fa fa-arrow-down\"\n                                    aria-hidden=\"true\"\n                                    title=\"descendre ce fichier\"\n                                ></i>\n                                <span class=\"sr-only\"\n                                    >descendre ce fichier</span\n                                >\n                            </button>\n                        </div>\n                        <jhi-file-uploader\n                            inputName=\"piece-{{ piece.fileModel.fileApiId }}\"\n                            [id]=\"'piece-complementaire-' + i + 1\"\n                            label=\"Pièce complémentaire n°{{ i + 1 }}\"\n                            [file]=\"piece.fileModel\"\n                            [url]=\"uploadUrl\"\n                            [disabled]=\"disableDeletion(piece)\"\n                            (fileChange)=\"\n                                onPieceComplementaireDelete(i, $event)\n                            \"\n                        >\n                        </jhi-file-uploader>\n                        <div class=\"form-group required name\">\n                            <label\n                                [class.has-value]=\"renameInput.value\"\n                                class=\"nommer-piece-label\"\n                                >Nommer la pièce n°{{ i + 1 }}</label\n                            >\n                            <div class=\"input-group\">\n                                <input\n                                    [attr.aria-label]=\"piece.libelle\"\n                                    type=\"text\"\n                                    class=\"form-control\"\n                                    name=\"piece-{{\n                                        piece.fileModel.fileApiId\n                                    }}-name\"\n                                    required\n                                    jhiWhitespace\n                                    aria-describedby=\"errorMessagePieceComplementaire\"\n                                    [(ngModel)]=\"piece.libelle\"\n                                    (ngModelChange)=\"\n                                        checkLengthForFileName($event)\n                                    \"\n                                    #renameInput\n                                />\n                            </div>\n                        </div>\n                        <div\n                            *ngIf=\"showLengthWarningForFileName\"\n                            role=\"alert\"\n                            class=\"alert alert-warning alert-secondary\"\n                        >\n                            <div\n                                jhiTranslate=\"entity.warning.maxlength\"\n                                translateValues=\"{actualLength: {{\n                                    actualFileNameLength\n                                }}, max: {{\n                                    maxFileNameWithoutExtensionLength\n                                }}}\"\n                            ></div>\n                        </div>\n                        <jhi-messages [id]=\"'errorMessagePieceComplementaire'\">\n                            <jhi-message\n                                [error]=\"'required'\"\n                                controlKey=\"piece-{{\n                                    piece.fileModel.fileApiId\n                                }}-name\"\n                            >\n                                <span\n                                    >Pour passer à l'étape suivante, vous devez\n                                    nommer cette pièce complémentaire</span\n                                >\n                            </jhi-message>\n                            <jhi-message\n                                [error]=\"'invalid-whitespace'\"\n                                controlKey=\"piece-{{\n                                    piece.fileModel.fileApiId\n                                }}-name\"\n                            >\n                                <span\n                                    >Pour passer à l'étape suivante, vous devez\n                                    utiliser au moins un caractère</span\n                                >\n                            </jhi-message>\n                        </jhi-messages>\n                    </div>\n                </div>\n            </div>\n            <jhi-file-uploader\n                inputName=\"piece-adder\"\n                [id]=\"\n                    'piece-complementaire-adder-' +\n                    depotRequeteState.piecesComplementaires.length +\n                    1\n                \"\n                label=\"Pièce complémentaire n°{{\n                    depotRequeteState.piecesComplementaires.length + 1\n                }}\"\n                (fileChange)=\"onPieceComplementaireAdd($event)\"\n                [url]=\"uploadUrl\"\n                *ngIf=\"depotRequeteState.piecesComplementaires.length < maxNumberJointsPiecesExceptRequete -\n                depotRequeteState.acteAttaquesAFusioner?.length - depotRequeteState.reclamationPrealablesAFusioner?.length\"\n                #pieceAdder\n            >\n            </jhi-file-uploader>\n            <div\n                *ngIf=\"depotRequeteState.formActivated &&\n                (depotRequeteState?.concernContentieuxSocial === false ||\n                depotRequeteState.typeJuridiction?.code === 'CE') &&\n                (depotRequeteState?.requeteCS?.souhait === 'Déposer une requête que vous avez rédigée' ||\n                (depotRequeteState?.requeteCS?.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent' &&\n                depotRequeteState?.requeteCS?.typeLitige === 'Vous contestez une somme d\\'argent réclamée par l\\'administration'))\"\n            >\n                <h3>Réclamation préalable</h3>\n                <p class=\"explication\">\n                    Si vous versez plusieurs documents pour la réclamation préalable, ils\n                    seront automatiquement fusionnés dans l'ordre que vous avez\n                    choisi, afin de produire un document unique. Ce nouveau\n                    document ne doit pas dépasser {{ maxFileSize | formatFileSize }}.\n                    Si vous n’êtes pas en mesure de produire la réclamation préalable,\n                    vous devez télécharger un document dans lequel vous expliquez les raisons de son absence.\n                </p>\n                <jhi-reclamation-prealable\n                    name=\"reclamationPrealables\"\n                    [(ngModel)]=\"depotRequeteState.reclamationPrealablesAFusioner\"\n                    [maxReclamationPrealablesForMerge]=\"maxReclamationPrealablesForMerge\"\n                    [class.invalid]=\"isReclamationPrealablesMaxSizeExceeded\"\n                    (change)=\"resetGeneratedReclamationPrealable()\"\n                >\n                </jhi-reclamation-prealable>\n                <div\n                    role=\"alert\"\n                    class=\"alert alert-danger\"\n                    *ngIf=\"isReclamationPrealablesMaxSizeExceeded\"\n                >\n                    La taille de l'ensemble des fichiers ci-dessus et formant\n                    la réclamation préalable dépasse le maximum de\n                    {{ maxFileSize | formatFileSize }}.\n                </div>\n                <jhi-messages role=\"alert\">\n                    <jhi-message\n                        error=\"max-file-length-exceeded\"\n                        controlKey=\"reclamationPrealables\"\n                        role=\"alert\"\n                    >\n                        <span>\n                            La taille du document généré par l'ensemble des\n                            fichiers ci-dessus et formant la réclamation préalable dépasse\n                            le maximum de {{ maxFileSize | formatFileSize }}.\n                        </span>\n                    </jhi-message>\n                </jhi-messages>\n            </div>\n        </ng-template>\n    </jhi-section>\n\n    <jhi-section [state]=\"sections.postales\">\n        <ng-template #header>\n            <h2>Autres pièces complémentaires transmises par voie postale</h2>\n        </ng-template>\n        <ng-template #help>\n            <div class=\"explication\">\n                <p>\n                    Vous souhaitez joindre des éléments qui ne peuvent faire\n                    l’objet d’une numérisation du fait de leur format (plans\n                    d’architecte, etc.)&nbsp;?\n                </p>\n                <p>\n                    Vous pouvez les transmettre sur support matériel, par voie\n                    postale ou en les déposant directement au greffe de la\n                    juridiction administrative que vous avez sélectionnée, en\n                    les nommant ci-dessous et en reportant le même nom sur\n                    celles-ci. Les pièces transmises devront être accompagnées\n                    de copies en nombre égal à celui des autres parties,\n                    augmenté de deux.\n                </p>\n            </div>\n        </ng-template>\n        <ng-template #content>\n            <jhi-piece-postales\n                [pieces]=\"depotRequeteState.piecesPostales\"\n            ></jhi-piece-postales>\n        </ng-template>\n    </jhi-section>\n\n    <ng-container\n        *ngIf=\"\n            depotRequeteState.piecesComplementaires.length ||\n            depotRequeteState.piecesPostales.length\n        \"\n    >\n        <div class=\"row no-gutter\">\n            <div class=\"offset-lg-3 col-lg-6\">\n                <div class=\"form-check\">\n                    <input\n                        type=\"checkbox\"\n                        class=\"form-check-input\"\n                        name=\"conditionRenommageCheckbox\"\n                        id=\"conditionRenommageCheckbox\"\n                        [(ngModel)]=\"_justificatifRenommage\"\n                        aria-describedby=\"errorMessagePieceCheckbox\"\n                        required\n                    />\n                    <label\n                        for=\"conditionRenommageCheckbox\"\n                        class=\"form-check-label lb_clickable\"\n                        >J’ai bien nommé mes pièces complémentaires en leur\n                        donnant un intitulé qui décrit leur contenu de manière\n                        suffisamment explicite (Articles R 414-5 & R 611-8-5 du\n                        code de justice administrative).</label\n                    >\n                </div>\n            </div>\n            <jhi-messages [id]=\"'errorMessagePieceCheckbox'\" class=\"col-12\">\n                <jhi-message\n                    [error]=\"'required'\"\n                    [controlKey]=\"'conditionRenommageCheckbox'\"\n                >\n                    <span\n                        >Pour poursuivre, vous devez cocher la case relative au\n                        nommage de pièces complémentaires.</span\n                    >\n                </jhi-message>\n            </jhi-messages>\n        </div>\n    </ng-container>\n</form>\n\n<!-- Alert -->\n<div *ngIf=\"saveDraftSuccess || saveDraftError\">\n    <jhi-alert></jhi-alert>\n</div>\n<div role=\"alert\" class=\"alert alert-warning alert-dismissible\" *ngIf=\"autoSaveError\">\n    <button type=\"button\" class=\"close\" aria-label=\"Fermer\" (click)=\"close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <span>Nous n'avons pas pu effectuer de sauvegarde automatique de votre requête. Vous pouvez tenter de\n        <a href=\"javascript:void(0);\" class=\"restart-request\" (click)=\"saveDraftAgain()\">sauvegarder à nouveau</a>\n        ou <a class=\"restart-request\" href=\"#/depot-requete/avertissement\">recommencer au début.</a></span>\n</div>\n\n<!-- Buttons -->\n<div class=\"col-12 btn-group\">\n    <jhi-previous-button\n        [label]=\"'Page précédente - Requête'\"\n        [clickHandler]=\"previous.bind(this)\"\n    ></jhi-previous-button>\n    <jhi-save-draft-requete-button\n        [isDisabled]=\"!depotRequeteState.requete &&\n        (!depotRequeteState.acteAttaquesAFusioner || depotRequeteState.acteAttaquesAFusioner.length === 0) &&\n        (!depotRequeteState.reclamationPrealablesAFusioner || depotRequeteState.reclamationPrealablesAFusioner.length === 0) &&\n        (!depotRequeteState.piecesComplementaires || depotRequeteState.piecesComplementaires.length === 0)\"\n        [clickHandler]=\"saveDraft.bind(this)\"\n    ></jhi-save-draft-requete-button>\n    <jhi-next-button\n        [label]=\"'Page suivante - Récapitulatif'\"\n        [clickHandler]=\"next.bind(this)\"\n    ></jhi-next-button>\n</div>\n"

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"justificatifsAutoSaveSuccess\">\n    <jhi-alert></jhi-alert>\n</div>\n\n<form class=\"col-12\" *ngIf=\"depotRequeteState.requeteCategory\">\n\n    <jhi-section [state]=\"sections.acteur\">\n        <ng-template #header>\n            <h2>{{acteurSectionTitle}}</h2>\n        </ng-template>\n        <ng-template #content>\n            <jhi-fiche-acteur [acteur]=\"depotRequeteState.currentActeur\"></jhi-fiche-acteur>\n        </ng-template>\n    </jhi-section>\n\n    <jhi-section [state]=\"sections.juridiction\">\n        <ng-template #header>\n            <h2>Juridiction</h2>\n        </ng-template>\n        <ng-template #content>\n            <div class=\"form-group my-2\">\n                <label class=\"has-value\" for=\"type-juridiction\">Type Juridiction</label>\n                <div class=\"input-group\">\n                    <input type=\"text\" class=\"form-control\" id=\"type-juridiction\" [value]=\"depotRequeteState.typeJuridiction.libelle\" readonly>\n                </div>\n            </div>\n            <ng-container *ngIf=\"depotRequeteState.typeJuridiction?.code.toString() != 'CE'\">\n                <div class=\"form-group my-2\">\n                    <label class=\"has-value\" for=\"deposit-court\">Tribunal de dépôt</label>\n                    <div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" id=\"deposit-court\" [value]=\"depotRequeteState.siteJuridiction.libelleCourt\" readonly>\n                    </div>\n                </div>\n            </ng-container>\n            <div class=\"form-group my-2\">\n                <label class=\"has-value\" for=\"type-requete\">Type de procédure</label>\n                <div class=\"input-group\">\n                    <input type=\"text\" class=\"form-control\" id=\"type-requete\" [value]=\"depotRequeteState.urgenceRequete.libelle\" readonly>\n                </div>\n            </div>\n        </ng-template>\n    </jhi-section>\n\n    <jhi-section [state]=\"sections.piecesObligatoires\">\n        <ng-template #header>\n            <h2>Pièces obligatoires</h2>\n        </ng-template>\n        <ng-template #content>\n            <div class=\"form-group my-2\">\n                <label class=\"has-value\" for=\"preview-piece-requete\">Requête</label>\n                <jhi-preview-piece [showLabel]=\"true\" [id]=\"'preview-piece-requete'\" [piece]=\"depotRequeteState.requete.toDTO()\"></jhi-preview-piece>\n            </div>\n            <div class=\"form-group my-2\" *ngIf=\"depotRequeteState.acteAttaque?.fileModel\">\n                <label class=\"has-value\" for=\"preview-piece-acte-attaque\">Acte attaqué</label>\n                <jhi-preview-piece [showLabel]=\"true\" [id]=\"'preview-piece-acte-attaque'\" [piece]=\"depotRequeteState.acteAttaque.toDTO()\"></jhi-preview-piece>\n            </div>\n            <div class=\"form-group my-2\" *ngIf=\"reclamationPrealableIsMandatory && depotRequeteState.reclamationPrealable.fileModel\">\n                <label class=\"has-value\" for=\"preview-piece-reclamation-prealable\">Réclamation préalable</label>\n                <jhi-preview-piece [showLabel]=\"true\" [id]=\"'preview-piece-reclamation-prealable'\" [piece]=\"depotRequeteState.reclamationPrealable.toDTO()\"></jhi-preview-piece>\n            </div>\n\n        </ng-template>\n    </jhi-section>\n\n    <jhi-section [state]=\"sections.piecesComplementaires\" *ngIf=\"depotRequeteState.piecesComplementaires?.length > 0 ||\n        (reclamationPrealableIsComplementary && depotRequeteState.reclamationPrealable?.fileModel)\">\n        <ng-template #header>\n            <h2>Pièces complémentaires</h2>\n        </ng-template>\n        <ng-template #content>\n            <ng-container *ngFor=\"let piece of depotRequeteState.piecesComplementaires; let i = index;\">\n                <div class=\"form-group my-2\">\n                    <label class=\"has-value\" for=\"preview-piece-pieces-complementaires\">Pièce complémentaire n° {{i + 1}}</label>\n                    <jhi-preview-piece [id]=\"'preview-piece-pieces-complementaires'\" [piece]=\"piece.toDTO()\" [showLabel]=\"true\"></jhi-preview-piece>\n                </div>\n            </ng-container>\n            <div class=\"form-group my-2\"\n                *ngIf=\"reclamationPrealableIsComplementary && depotRequeteState.reclamationPrealable.fileModel\"\n            >\n                <label class=\"has-value\" for=\"preview-piece-reclamation-prealable\">Réclamation préalable</label>\n                <jhi-preview-piece [showLabel]=\"true\" [id]=\"'preview-piece-reclamation-prealable'\" [piece]=\"depotRequeteState.reclamationPrealable.toDTO()\"></jhi-preview-piece>\n            </div>\n        </ng-template>\n    </jhi-section>\n\n    <jhi-section [state]=\"sections.piecesPostales\" *ngIf=\"depotRequeteState.piecesPostales.length\">\n        <ng-template #header>\n            <h2>Autres pièces complémentaires transmises par voie postale</h2>\n        </ng-template>\n        <ng-template #content>\n            <div class=\"form-group my-2\" *ngFor=\"let piece of depotRequeteState.piecesPostales; let i = index;\">\n                <label class=\"has-value\" for=\"preview-piece-piece-postale\">Pièce postale n° {{i + 1}}</label>\n                <div class=\"input-group\">\n                    <input type=\"text\" id=\"preview-piece-piece-postale\" readonly class=\"form-control\" [value]=\"piece.libelle\">\n                </div>\n            </div>\n        </ng-template>\n    </jhi-section>\n\n    <jhi-section [state]=\"sections.inventaire\" *ngIf=\"depotRequeteState.piecesComplementaires.length || depotRequeteState.piecesPostales.length\">\n        <ng-template #header>\n            <h2>Inventaire des pièces</h2>\n        </ng-template>\n        <ng-template #content>\n            <div class=\"form-group my-2\">\n                <div class=\"input-group\">\n                    <input type=\"text\" readonly class=\"form-control inventaire\" value=\"Voir l'inventaire de vos pieces\" aria-labelledby=\"voir l'inventaire de vos pieces\">\n                    <div class=\"input-group-append\" (click)=\"openInventaire()\" tabindex=\"0\">\n                        <i class=\"fa fa-eye\" aria-hidden=\"true\" title=\"ouvrir l'inventaire\"></i>\n                        <button class=\"sr-only\">Ouvrir l'inventaire</button>\n                    </div>\n                </div>\n            </div>\n            <div *ngIf=\"isDeactivatedPopup\" role=\"alert\" class=\"alert alert-danger\">\n                Pour visualiser l'inventaire de vos pièces complémentaires, merci d'autoriser les popups.\n            </div>\n        </ng-template>\n    </jhi-section>\n\n    <section>\n        <div class=\"col-lg-10 offset-lg-1 text-center\">\n            <div class=\"form-check\">\n                <input type=\"checkbox\" class=\"form-check-input\" name=\"avertissement\" id=\"avertissement\" #avertissement=\"ngModel\" [(ngModel)]=\"_recapitulatifEnregistrement\" required>\n                <label for=\"avertissement\" class=\"form-check-label lb_clickable\">Une fois votre requête envoyée, vous devez attendre le message vous informant que votre requête a été\n                    enregistrée par le greffe pour déposer des fichiers complémentaires.</label>\n            </div>\n            <div class=\"form-check\">\n                <input\n                    type=\"checkbox\"\n                    class=\"form-check-input\"\n                    name=\"requeteAbusifCheckbox\"\n                    id=\"requeteAbusifCheckbox\"\n                    #requeteAbusifCheckbox=\"ngModel\"\n                    [(ngModel)]=\"_recapitulatifRequeteAbusif\"\n                    aria-describedby=\"errorMessage\"\n                    required>\n                <label class=\"form-check-label lb_clickable\" for=\"requeteAbusifCheckbox\">Je suis informé(e) que le juge peut ordonner à la partie perdante d’une instance de rembourser tout ou\n                    partie des frais supportés par son adversaire (<a\n                        href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000006449380\" rel=\"noopener noreferrer\" target=\"_blank\">article L. 761-1 du\n                        code de justice administrative</a>), et qu’il peut par ailleurs infliger à l’auteur d’une requête qu’il estime abusive une\n                    amende pouvant atteindre 10&nbsp;000 euros (<a\n                        href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000006450228\" rel=\"noopener noreferrer\" target=\"_blank\">article R. 741-12 du\n                        code de justice\n                        administrative</a>).\n                </label>\n            </div>\n            <div\n                class=\"alert alert-danger alert-secondary\"\n                id=\"errorMessage\"\n                *ngIf=\"(avertissement.invalid && avertissement.touched) || (requeteAbusifCheckbox.invalid && requeteAbusifCheckbox.touched)\">\n                Pour envoyer votre requête, vous devez accepter les termes du dépôt de requête en cochant les deux cases.\n            </div>\n        </div>\n    </section>\n</form>\n\n<!-- Alert -->\n<div *ngIf=\"saveDraftSuccess || saveDraftError\">\n    <jhi-alert></jhi-alert>\n</div>\n\n<!-- Buttons -->\n<div class=\"col-12 btn-group\">\n    <jhi-previous-button [label]=\"'Page précédente - Justificatifs'\" [clickHandler]=\"previous.bind(this)\"></jhi-previous-button>\n    <jhi-save-draft-requete-button [clickHandler]=\"saveDraft.bind(this)\"></jhi-save-draft-requete-button>\n    <jhi-button icon=\"fa-check-circle\" iconRight (onClick)=\"save()\"\n        [isDisabled]=\"isLoading\" [isLoading]=\"isLoading\" confirmation>\n        Envoyer ma requête\n    </jhi-button>\n</div>\n"

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <div class=\"row col-12\">\n    <div class=\"title-block\">\n      <div class=\"title\">Ajout d'un requérant</div>\n      <div class=\"sub-title\"><ng-content></ng-content></div>\n    </div>\n    <jhi-button secondary icon=\"fa-user-plus\" iconLeft (onClick)=\"edit()\" *ngIf=\"!isAdding\">\n      Ajouter un requérant\n    </jhi-button>\n    <div class=\"btn\" *ngIf=\"isAdding\">\n        <span (click)=\"close()\">\n            <span class=\"fa fa-times\" aria-hidden=\"true\"></span>\n            Fermer\n        </span>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<input type=\"text\" name=\"requerant-list\" [(ngModel)]=\"addedRequerants\" hidden>\n<jhi-section class=\"col-12\" [state]=\"state\" *ngIf=\"requeteCategory === RequeteCategoryEnum.AVEC_MANDATAIRE\">\n    <ng-template #header>\n        <h2>Renseignez le ou les requérants</h2>\n    </ng-template>\n    <ng-template #help>\n        <div class=\"explication col-12\">\n            <p>\n                Pour déposer une requête en tant que mandataire, vous devez désigner le requérant. Ce dernier doit obligatoirement avoir <strong>un compte\n                Télérecours citoyens activé</strong> pour permettre le dépôt de la requête via Télérecours citoyens\n                (<a href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000036781231\" rel=\"noopener noreferrer\" target=\"_blank\">article R. 414-6 du code de justice administrative</a>).\n            </p>\n            <p>Utilisez <strong>l’interface de recherche</strong> ci-dessous pour sélectionner le compte Télérecours citoyens du requérant principal.</p>\n            <p>Si la requête concerne <strong>plusieurs requérants</strong>, ajoutez-les un à un en saisissant leurs informations puis en cliquant sur\n                le bouton correspondant. Il vous faudra ensuite indiquer le représentant unique des requérants (requérant principal).\n            </p>\n        </div>\n    </ng-template>\n    <ng-template #content>\n        <jhi-search-form class=\"full-width\" (onSearch)=\"search($event)\">\n        </jhi-search-form>\n        <jhi-result-form  *ngIf=\"requerant || errorType != null\" [requerant]=\"requerant\" [errorType]=\"errorType\" (onAddRequerant)=\"addQualifiedRequerant()\">\n        </jhi-result-form>\n        <jhi-added-requerant *ngIf=\"addedRequerants && addedRequerants.length\" [requerants]=\"addedRequerants\"\n            (onRemoveRequerant)=\"removeRequerant($event)\"\n            (onMoveToPrincipal)=\"moveToRequerantPrincipal($event)\">\n        </jhi-added-requerant>\n    </ng-template>\n</jhi-section>\n\n<jhi-section class=\"col-12\" [state]=\"state\" *ngIf=\"requeteCategory === RequeteCategoryEnum.COLLECTIVE\">\n    <ng-template #header>\n        <h2>Autres requérants (demandeurs complémentaires)</h2>\n    </ng-template>\n    <ng-template #content>\n        <jhi-added-requerant *ngIf=\"addedRequerants && addedRequerants.length\" [requerants]=\"addedRequerants\"\n            (onRemoveRequerant)=\"removeRequerant($event)\">\n        </jhi-added-requerant>\n        <ng-container *ngIf=\"errorType === RequerantsHandlingErrorEnum.AlreadyAdded\">\n            <p role=\"alert\" class=\"alert alert-danger error py-3\">\n                Vous avez déjà ajouté un requérant avec ces coordonnées.\n            </p>\n        </ng-container>\n        <jhi-edit-form class=\"full-width\" (onAddRequerant)=\"addAnonymousRequerant($event)\">\n        </jhi-edit-form>\n    </ng-template>\n</jhi-section>\n"

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "<h3>Liste des requérants</h3>\n<div *ngFor=\"let requerant of requerants; let first = first\" class=\"added-requerant\">\n    <jhi-fiche-acteur added-list\n        [acteur]=\"requerant\"\n        [isPrincipal]=\"first && !requerant.isAnonymous\"\n        (onClick)=\"removeRequerant(requerant)\"\n        (onMoveToPrincipal)=\"moveToRequerantPricipal(requerant)\">\n    </jhi-fiche-acteur>\n</div>\n"

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = "<jhi-add-requerant-header (onAdd)=\"addNewRequerant()\" (onClose)=\"close()\">\n  Entrez les coordonnées d'un requérant\n</jhi-add-requerant-header>\n<div class=\"container\" *ngIf=\"displayEditForm\">\n  <form (ngSubmit)=\"addRequerant()\" (keydown.enter)=\"$event.preventDefault()\" class=\"col-12\" novalidate>\n\n    <div class=\"row\">\n      <jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n        <jhi-civilite name=\"civilite\" [(ngModel)]=\"requerant.civilite\" [isForMoraleIdentity]=\"isMoraleIdentity\"\n          required>\n        </jhi-civilite>\n        <jhi-messages role=\"alert\">\n          <jhi-message error=\"required\" controlKey=\"civilite\" >\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Civilité'}\"></div>\n          </jhi-message>\n        </jhi-messages>\n      </jhi-field>\n\n      <jhi-field class=\"col-12 col-lg-6 py-2\">\n        <jhi-select [id]=\"'typePersonne'\" name=\"typePersonne\" label=\"Personne physique ou personne morale\" [(ngModel)]=\"identityType\"\n          (change)=\"initRequerant()\" required>\n          <jhi-option [value]=\"AccountTypeEnum.PHYSIQUE\">Personne physique</jhi-option>\n          <jhi-option [value]=\"AccountTypeEnum.MORALE\">Personne morale</jhi-option>\n        </jhi-select>\n      </jhi-field>\n    </div>\n\n    <div class=\"row\" *ngIf=\"isMoraleIdentity\">\n      <jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n        <jhi-nom-entreprise name=\"nomEntreprise\" [(ngModel)]=\"requerant.nomEntreprise\" required></jhi-nom-entreprise>\n        <!-- errorMessageNomEntreprise aria-describedby attribute defined in jhi-nom-entreprise input -->\n        <jhi-messages [id]=\"'errorMessageNomEntreprise'\">\n          <jhi-message error=\"required\" controlKey=\"nomEntreprise\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Forme et dénomination sociale'}\">\n            </div>\n          </jhi-message>\n        </jhi-messages>\n      </jhi-field>\n\n      <jhi-field class=\"col-12 col-lg-6 py-2\">\n        <jhi-input [id]=\"'sigleEntreprise'\"  name=\"sigleEntreprise\" label=\"Sigle\" [(ngModel)]=\"requerant.sigleEntreprise\" maxlength=\"20\" [ariaDescribedBy]=\"'errorMessageSingleEntreprise'\">\n        </jhi-input>\n        <jhi-messages [id]=\"'errorMessageSingleEntreprise'\">\n          <jhi-message error=\"maxlength\" controlKey=\"sigleEntreprise\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 20}\"></div>\n          </jhi-message>\n        </jhi-messages>\n      </jhi-field>\n    </div>\n\n    <div class=\"row\">\n      <jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n        <jhi-input [id]=\"'firstName'\" name=\"firstName\" label=\"{{ isMoraleIdentity ? 'Prénom du représentant' : 'Prénom' }}\"\n          [(ngModel)]=\"requerant.firstName\" required jhiCapitalize jhiAlphaString maxlength=\"32\" [ariaDescribedBy]=\"'errorMessagePrenom'\">\n        </jhi-input>\n        <jhi-messages [id]=\"'errorMessagePrenom'\">\n          <jhi-message error=\"required\" controlKey=\"firstName\" *ngIf=\"!isMoraleIdentity\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Prénom' }\"></div>\n          </jhi-message>\n          <jhi-message error=\"required\" controlKey=\"firstName\" *ngIf=\"isMoraleIdentity\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Prénom du représentant' }\"></div>\n          </jhi-message>\n          <jhi-message error=\"maxlength\" controlKey=\"firstName\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 32}\"></div>\n          </jhi-message>\n        </jhi-messages>\n      </jhi-field>\n\n      <jhi-field class=\"col-12 col-lg-6 py-2\">\n        <jhi-input [id]=\"'lastName'\" name=\"lastName\" label=\"{{ isMoraleIdentity ? 'Nom du représentant' : 'Nom' }}\"\n          [(ngModel)]=\"requerant.lastName\" required jhiCapitalize jhiAlphaString maxlength=\"32\" [ariaDescribedBy]=\"'errorMessageLastName'\">\n        </jhi-input>\n        <jhi-messages [id]=\"'errorMessageLastName'\">\n          <jhi-message error=\"required\" controlKey=\"lastName\" *ngIf=\"!isMoraleIdentity\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Nom' }\"></div>\n          </jhi-message>\n          <jhi-message error=\"required\" controlKey=\"lastName\" *ngIf=\"isMoraleIdentity\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Nom du représentant' }\"></div>\n          </jhi-message>\n          <jhi-message error=\"maxlength\" controlKey=\"lastName\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 32}\"></div>\n          </jhi-message>\n        </jhi-messages>\n      </jhi-field>\n    </div>\n\n    <jhi-contact class=\"row\" [contact]=\"requerant.contact\"></jhi-contact>\n\n    <jhi-address class=\"row\" [address]=\"requerant.address\"></jhi-address>\n\n    <div class=\"btn-group\">\n      <jhi-button secondary icon=\"fa-refresh\" iconLeft (onClick)=\"initRequerant()\">\n        Réinitialiser\n      </jhi-button>\n      <jhi-button icon=\"fa-user-plus\" iconLeft>\n        Ajouter\n      </jhi-button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports = "<h3>Résultat de la recherche</h3>\n<jhi-fiche-acteur result-list  *ngIf=\"requerant\" [acteur]=\"requerant\" (onClick)=\"addRequerant()\">\n</jhi-fiche-acteur>\n<ng-container *ngIf=\"errorType != null\">\n    <div class=\"explication not-found\" [ngSwitch]=\"errorType\">\n        <ng-container *ngSwitchCase=\"RequerantsHandlingErrorEnum.NotFound\">\n                <p><span class=\"fa fa-ban\" aria-hidden=\"true\"></span> Aucun compte utilisateur Télérecours citoyens ne correspond à votre recherche</p>\n                <ul>\n                    <li><strong>Vous ne trouvez pas la personne que vous cherchez ?</strong></li>\n                    <li>- Votre saisie correspond-elle aux informations fournies par le requérant ?</li>\n                    <li>- Le requérant principal n’a peut-être pas de compte activé sur Télérecours citoyens ?</li>\n                    <li>Nous vous invitons à contacter le requérant principal pour qu’il créé un compte Télérecours citoyens. En cas d’urgence, vous avez la possibilité de déposer votre requête sous forme papier.</li>\n                </ul>\n\n        </ng-container>\n        <ng-container *ngSwitchCase=\"RequerantsHandlingErrorEnum.AlreadyAdded\">\n                <p><span class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></span> Vous avez déjà ajouté un requérant avec ces coordonnées.</p>\n        </ng-container>\n        <ng-container *ngSwitchCase=\"RequerantsHandlingErrorEnum.Mandataire\">\n                <p><span class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></span> Le mandataire ne peut pas être requérant.</p>\n        </ng-container>\n    </div>\n</ng-container>\n"

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = "<jhi-add-requerant-header (onAdd)=\"addNewRequerant()\" (onClose)=\"close()\">\n    Entrez les coordonnées d'un particulier, ou du représentant d'une personne morale\n</jhi-add-requerant-header>\n<div class=\"container\"  *ngIf=\"displaySearchForm\">\n    <form (ngSubmit)=\"search()\" (keydown.enter)=\"$event.preventDefault()\" #form=\"ngForm\" novalidate class=\"row col-12\">\n        <jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n            <jhi-input [id]=\"'firstName'\" name=\"firstName\"\n                        label=\"Prénom\"\n                        [autocomplete]=\"'given-name'\"\n                        [(ngModel)]=\"searchForm.firstName\"\n                        [ariaDescribedBy]=\"'errorMessageFirstName'\"\n                        required\n                        jhiCapitalize\n                        jhiAlphaString>\n            </jhi-input>\n            <jhi-messages [id]=\"'errorMessageFirstName'\">\n                <jhi-message error=\"required\" controlKey=\"firstName\">\n                    <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Prénom' }\"></div>\n                </jhi-message>\n            </jhi-messages>\n        </jhi-field>\n\n        <jhi-field class=\"col-12 col-lg-6 py-2\">\n            <jhi-input  [id]=\"'lastName'\" name=\"lastName\"\n                        label=\"Nom\"\n                        [autocomplete]=\"'family-name'\"\n                        [(ngModel)]=\"searchForm.lastName\"\n                        [ariaDescribedBy]=\"'errorMessageLastName'\"\n                        required\n                        jhiCapitalize\n                        jhiAlphaString>\n            </jhi-input>\n            <jhi-messages [id]=\"'errorMessageLastName'\">\n                <jhi-message error=\"required\" controlKey=\"lastName\">\n                    <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Nom' }\"></div>\n                </jhi-message>\n            </jhi-messages>\n        </jhi-field>\n\n        <jhi-field class=\"col-12 py-2\">\n            <jhi-input [id]=\"'email'\" name=\"email\"\n                        label=\"Adresse de messagerie\"\n                        [autocomplete]=\"'email'\"\n                        [(ngModel)]=\"searchForm.email\"\n                        [ariaDescribedBy]=\"'errorMessageEmail'\"\n                        required\n                        jhiEmail>\n            </jhi-input>\n            <jhi-messages [id]=\"'errorMessageEmail'\">\n                <jhi-message error=\"required\" controlKey=\"email\">\n                    <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Adresse de messagerie' }\"></div>\n                </jhi-message>\n                <jhi-message error=\"invalid-email\" controlKey=\"email\">\n                    <div>L'adresse de messagerie renseignée n'est pas valide.</div>\n                </jhi-message>\n            </jhi-messages>\n        </jhi-field>\n        <div class=\"btn-group\">\n            <jhi-button secondary icon=\"fa-refresh\" iconRight (onClick)=\"reset()\">\n                Réinitialiser\n            </jhi-button>\n            <jhi-button icon=\"fa-search\" iconRight>\n                Rechercher\n            </jhi-button>\n        </div>\n    </form>\n</div>\n"

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = "<input type=\"text\" name=\"selectedRequeteCategory\" [(ngModel)]=\"requeteCategory\" hidden>\n<jhi-section class=\"col-12\" [state]=\"state\">\n    <ng-template #header>\n        <h2 aria-hidden=\"true\">Vous déposez un recours</h2>\n    </ng-template>\n    <ng-template #content>\n        <fieldset class=\"row radio-fieldset\">\n            <legend class=\"sr-only\">\n                Vous déposez un recours :\n            </legend>\n            <div class=\"col-sm-12 radio-fieldset__wrapper\">\n                <div (click)=\"onSetRequeteType(requerantType.value)\"\n                     *ngFor=\"let requerantType of requerantTypes\" \n                     [ngClass]=\"{\n                        'radio-fieldset__item--inactive': selectedRequerantTypeCode !== requerantType.value,\n                        'radio-fieldset__item--active': selectedRequerantTypeCode == requerantType.value\n                     }\"\n                     class=\"radio-fieldset__item\">\n                    <div class=\"radio-fieldset__item__input\">\n                        <input\n                            (ngModelChange)=\"onSetRequeteType($event)\"\n                            [(ngModel)]=\"selectedRequerantTypeCode\"\n                            [attr.aria-describedby]=\"requerantType.value + ' errorMessageRequerant'\"\n                            required\n                            id=\"radio-{{ requerantType.value }}\"\n                            name=\"chosen-applicant\"\n                            type=\"radio\"\n                            value=\"{{ requerantType.value }}\"\n                            tabindex=\"0\"\n                        >\n                    </div>\n                    <div class=\"radio-fieldset__item__label\">\n                        <label\n                            for=\"radio-{{ requerantType.value }}\">\n                            {{ requerantType.title }}\n                        </label>\n                        <p [id]=\"requerantType.value\">\n                            {{ requerantType.description }}\n                            <a *ngIf=\"requerantType.value === RequeteCategoryEnum.COLLECTIVE\" \n                                href=\"https://www.legifrance.gouv.fr/affichCodeArticle.do?cidTexte=LEGITEXT000006070933&idArticle=LEGIARTI000006449924\"\n                                rel=\"noopener noreferrer\" \n                                target=\"_blank\">\n                                l'article R. 411-5 du code de justice administrative\n                            </a>\n                        </p>\n                    </div>\n                </div>\n            </div>\n        </fieldset>\n    </ng-template>\n</jhi-section>\n"

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "<form class=\"col-12\" novalidate>\n\n    <!-- Requerant type -->\n    <jhi-requerant-type-section\n        name=\"requerant-type\"\n        [(ngModel)]=\"depotRequeteState.requeteCategory\"\n        (ngModelChange)=\"onRequerantTypeChange($event)\"\n        [state]=\"sections.selectTypeRequete\" required>\n    </jhi-requerant-type-section>\n\n    <jhi-messages [id]=\"'errorMessageRequerant'\">\n        <jhi-message error=\"required\" controlKey=\"requerant-type\" role=\"alert   \">\n            <div >Pour continuer, merci de sélectionner un type de requérant.</div>\n        </jhi-message>\n    </jhi-messages>\n\n    <jhi-section *ngIf=\"depotRequeteState.requeteCategory\" [state]=\"sections.displayActeur\">\n        <ng-template #header>\n            <h2 *ngIf=\"depotRequeteState.requeteCategory === RequeteCategoryEnum.REQUERANT_SEUL\">Vous êtes seul requérant</h2>\n            <h2 *ngIf=\"depotRequeteState.requeteCategory === RequeteCategoryEnum.AVEC_MANDATAIRE\">Vous êtes le mandataire</h2>\n            <h2 *ngIf=\"depotRequeteState.requeteCategory === RequeteCategoryEnum.COLLECTIVE\">Vous êtes le représentant unique des requérants</h2>\n        </ng-template>\n        <ng-template #content>\n            <jhi-fiche-acteur [acteur]=\"depotRequeteState.currentActeur\" (onClick)=\"goToProfile()\" icon=\"fa-edit\">\n            </jhi-fiche-acteur>\n        </ng-template>\n    </jhi-section>\n    <ng-container *ngIf=\"depotRequeteState.requeteCategory && depotRequeteState.requeteCategory !== RequeteCategoryEnum.REQUERANT_SEUL\">\n        <jhi-add-requerant-section\n            name=\"add-requerant\"\n            [(ngModel)]=\"depotRequeteState.requerants\"\n            [requeteCategory]=\"depotRequeteState.requeteCategory\"\n            [state]=\"sections.addRequerant\"\n            required>\n        </jhi-add-requerant-section>\n        <jhi-messages role=\"alert\">\n            <jhi-message error=\"required\" controlKey=\"add-requerant\" role=\"alert\">\n                <div>\n                    Pour passer à l’étape suivante, merci d'ajouter au moins un requérant, ou de sélectionner\n                    «&nbsp;En tant que seul requérant&nbsp;».\n                </div>\n            </jhi-message>\n        </jhi-messages>\n    </ng-container>\n    <div class=\"captcha-section\" *ngIf=\"hasCaptcha() && depotRequeteState.requeteCategory\">\n        <h5>Sécurité</h5>\n        <jhi-captcha class=\"col-12 p-0\" name=\"captcha\" ngModel required jhiCaptchaValidator></jhi-captcha>\n        <div class=\"col-12 col-md-5 px-0\">\n            <jhi-messages [id]=\"'errorMessageCaptcha'\">\n                <jhi-message [error]=\"'required'\" [controlKey]=\"'captcha'\">\n                    <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Captcha'}\"></div>\n                </jhi-message>\n                <jhi-message [error]=\"'invalid-captcha'\" [controlKey]=\"'captcha'\">\n                    <div>Le captcha n'est pas valide. Merci de recommencer.</div>\n                </jhi-message>\n            </jhi-messages>\n        </div>\n    </div>\n</form>\n\n<!-- Alert -->\n<jhi-alert></jhi-alert>\n<div role=\"alert\" class=\"alert alert-warning alert-dismissible\" *ngIf=\"autoSaveError\">\n    <button type=\"button\" class=\"close\" aria-label=\"Fermer\" (click)=\"close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <span>Nous n'avons pas pu effectuer de sauvegarde automatique de votre requête. Vous pouvez tenter de \n        <a href=\"javascript:void(0);\" class=\"restart-request\" (click)=\"saveDraftAgain()\">sauvegarder à nouveau</a>\n        ou <a class=\"restart-request\" href=\"#/depot-requete/avertissement\">recommencer au début.</a></span>\n</div>\n\n<!-- Buttons -->\n<div class=\"col-12 btn-group\">\n    <jhi-previous-button [label]=\"'Page précédente - Avertissement'\" [clickHandler]=\"previous.bind(this)\"></jhi-previous-button>\n    <jhi-save-draft-requete-button [isDisabled]=\"!depotRequeteState.requeteCategory\" [clickHandler]=\"saveDraft.bind(this)\"></jhi-save-draft-requete-button>\n    <jhi-next-button [label]=\"'Page suivante - Juridiction'\" [clickHandler]=\"next.bind(this)\"></jhi-next-button>\n</div>\n"

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports = "<input\n  type=\"text\"\n  name=\"contentieux-social-hidden\"\n  [(ngModel)]=\"contentieuxSocial\"\n  hidden\n/>\n\n<!-- SOUHAIT -->\n<jhi-section class=\"col-12\" [state]=\"sections.souhait\" *ngIf=\"showSouhaitSection\">\n  <ng-template #header>\n    <h2>Vous souhaitez : <span class=\"danger-hint\">*</span><span><button class=\"souhait-btn\" (click)=\"openWarningModal(litigeModal)\">Besoin d'aide ?</button></span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div *ngFor=\"let souhait of souhaitTexts; let idx = index\">\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          (ngModelChange)=\"onSetSouhait($event)\"\n          [(ngModel)]=\"contentieuxSocial.souhait\"\n          [required]=\"showSouhaitSection\"\n          id=\"radio-{{souhait.value}}\"\n          name=\"radio-{{souhait.value}}\"\n          type=\"radio\"\n          role=\"radio\"\n          value=\"{{ souhait.description }}\"\n          [checked]=\"(idx === 0)\"\n          aria-describedby=\"error-msg-souhait-radio\"\n          tabindex=\"0\"\n          />\n        <label for=\"radio-{{souhait.value}}\" class=\"form-check-label\">\n          {{souhait.description}}\n        </label>\n      </div>\n    </div>\n    <div id=\"error-msg-souhait-radio\" role=\"alert\"\n      *ngIf=\"!litigeLieDecisionChampsObligatoiresFilled.souhait && contentieuxSocial.souhait == null\"\n      class=\"alert alert-danger alert-secondary cs-alert\">\n      Vous devez indiquer le formulaire que vous souhaitez remplir, ou si vous souhaitez déposer une requête que vous avez rédigée.\n    </div>\n    <div *ngIf=\"showLitigeAvocat\">\n      <h2 class=\"litige-avocat\">Attention, ce litige doit être présenté par un avocat\n        <span><button class=\"souhait-btn\" (click)=\"openWarningModal(litigeExempteAvocatModal)\">Besoin d'aide ?</button></span>\n      </h2>\n      <p class=\"litige-avocat-exp\">sauf s'il concerne :</p>\n      <ul>\n        <li class=\"list-cs\">\n          une décision pour sanctionner les atteintes portées au domaine public (biens immobiliers publics :\n          voirie, cours d'eau, plages, etc.)\n        </li>\n        <li class=\"list-cs\">\n          une décision relative aux impôts\n        </li>\n        <li class=\"list-cs\">\n          une décision d'ordre individuel concernant les fonctionnaires, agents publics, agents de l'État\n        </li>\n        <li class=\"list-cs\">\n          une demande dirigée contre une commune, un département, une région,\n          un établissement public de coopération ou un hôpital\n        </li>\n        <li class=\"list-cs\">\n          une demande d'exécution d'un jugement définitif\n        </li>\n      </ul>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- TYPE LITIGE -->\n<jhi-section class=\"col-12\" [state]=\"sections.typeLitige\" *ngIf=\"showTypeLitigeSection\">\n  <ng-template #header>\n    <h2>Quel type de litige vous concerne ? <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div *ngFor=\"let typeLitige of typeLitigeTexts; let idx = index\">\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          (ngModelChange)=\"onSetTypeLitige($event)\"\n          [(ngModel)]=\"contentieuxSocial.typeLitige\"\n          [required]=\"showTypeLitigeSection\"\n          id=\"radio-{{typeLitige.value}}\"\n          name=\"radio-{{typeLitige.value}}\"\n          type=\"radio\"\n          role=\"radio\"\n          value=\"{{ typeLitige.title }}\"\n          [checked]=\"(idx === 0)\"\n          aria-describedby=\"error-msg-type-litige-radio\"\n          tabindex=\"0\"\n          />\n        <label for=\"radio-{{typeLitige.value}}\" class=\"form-check-label\">\n          {{typeLitige.title}}\n          <div class=\"explication\" *ngIf=\"typeLitige.description\">\n            <p class=\"exp\">\n              Exemples : {{typeLitige.description}}\n            </p>\n          </div>\n        </label>\n      </div>\n    </div>\n    <div id=\"error-msg-type-litige-radio\" role=\"alert\"\n      *ngIf=\"!reclamerUneSommeChampsObligatoiresFilled.typeLitige && contentieuxSocial.typeLitige == null\"\n      class=\"alert alert-danger alert-secondary cs-alert\">\n      Vous devez préciser le type de litige qui vous concerne.\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- ~~~~~~~~~~~~~ DALO ~~~~~~~~~~~~~~~~ -->\n<!-- RAPO -->\n<jhi-section class=\"col-12\" [state]=\"sections.rapo\" *ngIf=\"showRapoSection\">\n  <ng-template #header>\n    <h2>Avez-vous votre RAPO ?</h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"explication\">\n      <p>Avant de saisir le juge, vous devez avoir déposé un <button class=\"rapo-btn\" (click)=\"openWarningModal(rapoModal)\">recours administratif préalable obligatoire</button> (RAPO),\n        sauf pour les demandes liées au droit au logement opposable (DALO) :</p>\n      <ul>\n        <li>\n          Si votre demande concerne le DALO, vous devez joindre la décision de la commission de médiation. S'il n'y a pas eu de commission de médiation,\n          vous devez joindre l'accusé de réception de votre demande auprès du préfet.\n        </li>\n        <li>\n          Si votre demande concerne une indemnisation du préjudice subi pour le non-respect de l’obligation de relogement,\n          vous devez joindre l'accusé de réception de votre demande.\n        </li>\n      </ul>\n    </div>\n    <div>\n      <jhi-file-uploader\n          inputName=\"rapo\"\n          [id]=\"'rapo'\"\n          label=\"RAPO\"\n          [file]=\"pieceComplementaireRAPO?.fileModel\"\n          [required]=\"showRapoSection\"\n          [url]=\"uploadUrl\"\n          (fileChange)=\"onRAPOChange($event)\"\n      ></jhi-file-uploader>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- DECISION ATTAQUEE -->\n<jhi-section class=\"col-12\" [state]=\"sections.hasDecisionAttaque\" *ngIf=\"showDecisionAttaqueSection\">\n  <ng-template #header>\n    <h2>Avez-vous la décision attaquée ? <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          type=\"radio\"\n          role=\"radio\"\n          name=\"choose-has-document\"\n          id=\"has-document\"\n          aria-describedby=\"error-msg-decision-attaquee-radio\"\n          [(ngModel)]=\"contentieuxSocial.hasDocument\"\n          [value]=\"true\"\n          [required]=\"showDecisionAttaqueSection\"\n          (change)=\"onContentieuxSocialChange()\"\n          (ngModelChange)=\"clearDecisionAttaqueeJointPiece($event)\"\n          tabindex=\"0\"\n        />\n        <label class=\"form-check-label\" for=\"has-document\">\n          Oui\n        </label>\n      </div>\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          type=\"radio\"\n          role=\"radio\"\n          name=\"choose-has-document\"\n          id=\"no-document\"\n          aria-describedby=\"error-msg-decision-attaquee-radio\"\n          [(ngModel)]=\"contentieuxSocial.hasDocument\"\n          [value]=\"false\"\n          [required]=\"showDecisionAttaqueSection\"\n          (change)=\"onContentieuxSocialChange()\"\n          (ngModelChange)=\"clearDecisionAttaqueeJointPiece($event)\"\n          tabindex=\"0\"\n        />\n        <label class=\"form-check-label\" for=\"no-document\">\n          Non\n        </label>\n      </div>\n      <div id=\"error-msg-decision-attaquee-radio\" role=\"alert\"\n      *ngIf=\"((depotRequeteState.concernContentieuxSocial && !sociauxDALOChampsObligatoiresFilled.hasDocument) ||\n      (!depotRequeteState.concernContentieuxSocial && !litigeLieDecisionChampsObligatoiresFilled.hasDocument)) &&\n      contentieuxSocial.hasDocument == null\" class=\"alert alert-danger alert-secondary cs-alert\">\n        Vous devez préciser si vous possédez ou non la décision attaquée.\n      </div>\n      <div *ngIf=\"contentieuxSocial.hasDocument === true\">\n        <h5>Joignez la décision attaquée</h5>\n        <jhi-acte-attaque\n          name=\"acteAttaques\"\n          [(ngModel)]=\"depotRequeteState.acteAttaquesAFusioner\"\n          [adderLabel]=\"'Décision attaquée'\"\n          [maxActeAttaquesForMerge]=\"maxActeAttaquesForMerge\"\n          [acteRequired]=\"showDecisionAttaqueSection && contentieuxSocial.hasDocument === true\"\n          [class.invalid]=\"isActeAttaquesMaxSizeExceeded\"\n          (change)=\"resetGeneratedActeAttaque()\"\n        >\n        </jhi-acte-attaque>\n        <div\n          role=\"alert\"\n          class=\"alert alert-danger\"\n          *ngIf=\"isActeAttaquesMaxSizeExceeded\"\n        >\n          La taille de l'ensemble des fichiers ci-dessus et formant\n          l'acte attaqué dépasse le maximum de\n          {{ maxFileSize | formatFileSize }}.\n        </div>\n      </div>\n      <div *ngIf=\"contentieuxSocial.hasDocument === false\">\n        <div *ngIf=\"!depotRequeteState.concernContentieuxSocial\">\n          <h5>Joignez un justificatif de votre demande d'obtention de la décision attaquée</h5>\n          <div class=\"explication\">\n            <p>Si l’administration a refusé de vous envoyer la décision, vous devez joindre la réponse négative de l'administration.\n              Si l'administration ne vous a pas répondu, vous devez joindre un justificatif du dépôt de votre demande d’obtention de la décision.\n            </p>\n            <p class=\"exp\">Exemples : accusé de réception, accusé de dépôt, etc.</p>\n          </div>\n          <jhi-acte-attaque\n            name=\"acteAttaques\"\n            [(ngModel)]=\"depotRequeteState.acteAttaquesAFusioner\"\n            [adderLabel]=\"'Document attestant de la réception de votre demande'\"\n            [maxActeAttaquesForMerge]=\"maxActeAttaquesForMerge\"\n            [acteRequired]=\"showDecisionAttaqueSection && contentieuxSocial.hasDocument === false && !depotRequeteState.concernContentieuxSocial\"\n            [class.invalid]=\"isActeAttaquesMaxSizeExceeded\"\n            (change)=\"resetGeneratedActeAttaque()\"\n          >\n          </jhi-acte-attaque>\n          <div\n            role=\"alert\"\n            class=\"alert alert-danger\"\n            *ngIf=\"isActeAttaquesMaxSizeExceeded\"\n          >\n            La taille de l'ensemble des fichiers ci-dessus et formant\n            l'acte attaqué dépasse le maximum de\n            {{ maxFileSize | formatFileSize }}.\n          </div>\n        </div>\n        \n        <h5>Indiquez pourquoi vous n'êtes pas en possession de la décision attaquée <span class=\"danger-hint\">*</span></h5>\n        <textarea\n          class=\"form-control required focus-outline\"\n          [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n          id=\"raison-no-document\"\n          name=\"raison-no-document\"\n          maxlength=\"200\"\n          [(ngModel)]=\"contentieuxSocial.raisonSansDocument\"\n          (change)=\"onContentieuxSocialChange()\"\n          [required]=\"showDecisionAttaqueSection && contentieuxSocial.hasDocument === false\"\n          jhiWhitespace\n          aria-describedby=\"errorMessageRaisonSansDocument\"\n          #raison=\"ngModel\">\n        </textarea>\n        <div class=\"char-counter\">\n          {{contentieuxSocial.raisonSansDocument? contentieuxSocial.raisonSansDocument.length : 0}} / 200 caractères\n        </div>\n        <div id=\"errorMessageRaisonSansDocument\" class=\"error-msg\">\n          <div\n            *ngIf=\"(raison.touched && raison.hasError('required')) ||\n            (depotRequeteState.concernContentieuxSocial && !sociauxDALOChampsObligatoiresFilled.raisonSansDocument && contentieuxSocial.raisonSansDocument == null) ||\n            (!depotRequeteState.concernContentieuxSocial && !litigeLieDecisionChampsObligatoiresFilled.raisonSansDocument && contentieuxSocial.raisonSansDocument == null)\"\n            class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n            Indiquez pourquoi vous n'êtes pas en possession de la décision attaquée.\n          </div>\n          <div\n            *ngIf=\"raison.hasError('invalid-whitespace')\"\n            class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n            Pour poursuivre, vous devez saisir au moins un caractère.\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- DECISION ATTAQUEE POUR REQUETE REDIGEE -->\n<jhi-section class=\"col-12\" [state]=\"sections.requeteRedigeeDecisionAttaque\" *ngIf=\"showRequeteRedigeeSection\">\n  <ng-template #header>\n    <h2>Joignez la décision attaquée</h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p>\n          Si vous n'êtes pas en mesure de produire l'acte attaqué, vous devez télécharger un document dans lequel vous expliquez\n          les raisons de son absence.\n        </p>\n      </div>\n      <jhi-acte-attaque\n          name=\"acteAttaques\"\n          [(ngModel)]=\"depotRequeteState.acteAttaquesAFusioner\"\n          [adderLabel]=\"'Décision attaquée'\"\n          [maxActeAttaquesForMerge]=\"maxActeAttaquesForMerge\"\n          [acteRequired]=\"showRequeteRedigeeSection\"\n          [class.invalid]=\"isActeAttaquesMaxSizeExceeded\"\n          (change)=\"resetGeneratedActeAttaque()\"\n        >\n        </jhi-acte-attaque>\n        <div\n          role=\"alert\"\n          class=\"alert alert-danger\"\n          *ngIf=\"isActeAttaquesMaxSizeExceeded\"\n        >\n          La taille de l'ensemble des fichiers ci-dessus et formant\n          l'acte attaqué dépasse le maximum de\n          {{ maxFileSize | formatFileSize }}.\n        </div>\n    </div>\n  </ng-template>\n</jhi-section>  \n\n\n<!-- RECLAMATION PREALABLE -->\n<jhi-section class=\"col-12\" [state]=\"sections.reclamationPrealable\" *ngIf=\"showReclamationPrealableSection\">\n  <ng-template #header>\n    <h2>Avez-vous réclamé préalablement à l'administration de régulariser votre situation ?</h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p>Avant de saisir le juge, vous devez adresser une demande à l'administration concernée par le litige.\n          <span *ngIf=\"contentieuxSocial.souhait === 'Déposer une requête que vous avez rédigée'\">Si celle-ci\n            a refusé votre demande, vous disposez de deux mois pour déposer votre requête. Si au bout de deux\n            mois l'administration n'a pas répondu, vous disposez de deux mois pour déposer votre requête.\n          </span>\n          <span *ngIf=\"(contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent' &&\n            contentieuxSocial.typeLitige === 'Vous contestez une somme d\\'argent réclamée par l\\'administration') ||\n            (contentieuxSocial.souhait === 'Déposer une requête que vous avez rédigée')\">\n            Cette réclamation est obligatoire, sauf pour les sanctions administratives d’ordre pécuniaire et les titres exécutoires émis par\n            les collectivités territoriales et établissements publics de santé. Elle est tout de même vivement conseillée pour ces situations.\n          </span>\n        </p>\n        <div *ngIf=\"contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent' &&\n          contentieuxSocial.typeLitige !== 'Vous contestez une somme d\\'argent réclamée par l\\'administration'\">\n          <p><b>Si celle-ci a refusé votre demande :</b></p>\n          <ul>\n            <li>vous disposez de deux mois pour déposer votre requête,</li>\n            <li>vous devez joindre la réponse de l’administration.</li>\n          </ul>\n          <p><b>Si au bout de deux mois l'administration n'a pas répondu : </b></p>\n          <ul>\n            <li>vous disposez de deux mois pour déposer votre requête,</li>\n            <li>vous devez joindre un justificatif de dépôt ou de réception si vous en possédez un.</li>\n          </ul>\n        </div>\n        <div *ngIf=\"contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent' &&\n          contentieuxSocial.typeLitige === 'Vous contestez une somme d\\'argent réclamée par l\\'administration'\">\n          <ul>\n            <li>Si l’administration a refusé votre demande, vous disposez de deux mois pour déposer votre requête.</li>\n            <li>Si au bout de deux mois l’administration n’a pas répondu, vous disposez de deux mois pour déposer votre requête.</li>\n            <li>Si votre demande concerne un avis d’imposition, et que l’administration ne vous a pas répondu au bout de six mois,\n              vous devez déposer votre requête dans les plus brefs délais.\n            </li>\n          </ul>\n        </div>\n      </div>\n      <h5>Joignez votre réclamation préalable</h5>\n      <jhi-reclamation-prealable\n        name=\"reclamationPrealables\"\n        [(ngModel)]=\"depotRequeteState.reclamationPrealablesAFusioner\"\n        [maxReclamationPrealablesForMerge]=\"maxReclamationPrealablesForMerge\"\n        [class.invalid]=\"isReclamationPrealablesMaxSizeExceeded\"\n        [required]=\"showReclamationPrealableSection &&\n        (contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent' &&\n        contentieuxSocial.typeLitige !== 'Vous contestez une somme d\\'argent réclamée par l\\'administration')\"\n        (change)=\"resetGeneratedReclamationPrealable()\">\n      </jhi-reclamation-prealable>\n      <div\n        role=\"alert\"\n        class=\"alert alert-danger\"\n        *ngIf=\"isReclamationPrealablesMaxSizeExceeded\"\n      >\n        La taille de l'ensemble des fichiers ci-dessus et formant\n        la réclamation préalable dépasse le maximum de\n        {{ maxFileSize | formatFileSize }}.\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- NOM ADMINISTRATIONS -->\n<jhi-section class=\"col-12\" [state]=\"sections.administrationDecision\" *ngIf=\"showNomAdministrationsSection\">\n  <ng-template #header>\n    <h2 *ngIf=\"depotRequeteState.concernContentieuxSocial ||\n      (!depotRequeteState.concernContentieuxSocial &&\n      contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration') ||\n      (!depotRequeteState.concernContentieuxSocial && !contentieuxSocial.souhait)\">\n      Quelle administration a pris cette décision ? <span class=\"danger-hint\">*</span>\n    </h2>\n    <h2 *ngIf=\"!depotRequeteState.concernContentieuxSocial &&\n      contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent'\">\n      Quelle est l'administration concernée ? <span class=\"danger-hint\">*</span>\n    </h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p class=\"exp\" *ngIf=\"depotRequeteState.concernContentieuxSocial ||\n          (!depotRequeteState.concernContentieuxSocial && !contentieuxSocial.souhait)\">\n          Exemples : Pôle emploi de l’Oise, la Caisse d’assurance maladie des Hauts de Seine,\n          CAF de la Seine Maritime, etc.\n        </p>\n        <p class=\"exp\" *ngIf=\"!depotRequeteState.concernContentieuxSocial &&\n          contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration'\">\n          Exemples : Préfecture des Hauts-de-Seine, mairie de Montpellier, ministère de l'Intérieur, etc.\n        </p>\n        <div *ngIf=\"!depotRequeteState.concernContentieuxSocial &&\n          contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent'\">\n          <p class=\"exp\" *ngIf=\"!contentieuxSocial.typeLitige ||\n            (contentieuxSocial.typeLitige &&\n            contentieuxSocial.typeLitige === 'Vous réclamez une somme d\\'argent à l\\'administration')\">\n            Exemples : Préfecture des Hauts-de-Seine, mairie de Montpellier, ministère de l'Intérieur, etc.\n          </p>\n          <p class=\"exp\" *ngIf=\"contentieuxSocial.typeLitige &&\n            contentieuxSocial.typeLitige === 'Vous contestez une somme d\\'argent réclamée par l\\'administration'\">\n            Exemples : la mairie de Poitiers, la Direction générale des finances publics, etc.\n          </p>\n          <p class=\"exp\" *ngIf=\"contentieuxSocial.typeLitige &&\n            contentieuxSocial.typeLitige !== 'Vous réclamez une somme d\\'argent à l\\'administration' &&\n            contentieuxSocial.typeLitige !== 'Vous contestez une somme d\\'argent réclamée par l\\'administration'\">\n            Exemples : la mairie de Marseille, l'hôpital de la Pitié-Salpétrière, etc.\n          </p>\n        </div>\n      </div>\n      <input\n        id=\"nom-administration\"\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        type=\"text\"\n        maxlength=\"200\"\n        name=\"nom-administration\"\n        [(ngModel)]=\"contentieuxSocial.nomsAdministrations\"\n        (change)=\"onContentieuxSocialChange()\"\n        aria-describedby=\"errorMessageNomAdministration\"\n        [required]=\"showNomAdministrationsSection\"\n        jhiWhitespace\n        tabindex=\"0\"\n        #admin=\"ngModel\"\n      />\n      <div class=\"char-counter\">\n        {{contentieuxSocial.nomsAdministrations? contentieuxSocial.nomsAdministrations.length : 0}} / 200 caractères\n      </div>\n      <div id=\"errorMessageNomAdministration\" class=\"error-msg\">\n        <div\n          *ngIf=\"(admin.touched && admin.hasError('required')) ||\n          (depotRequeteState.concernContentieuxSocial && !sociauxDALOChampsObligatoiresFilled.nomsAdministrations && contentieuxSocial.nomsAdministrations == null) ||\n          (!depotRequeteState.concernContentieuxSocial && contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration' &&\n          !litigeLieDecisionChampsObligatoiresFilled.nomsAdministrations && contentieuxSocial.nomsAdministrations == null) ||\n          reclamerSommeNomAdminsFilled() ||\n          contesterSommeNomAdminsFilled() ||\n          indemnisationNomAdminsFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, veuillez préciser le nom de l'administration, ainsi que la ville ou le département dans lequel elle se trouve.\n        </div>\n        <div\n          *ngIf=\"admin.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- TITRE DEMANDE -->\n<jhi-section class=\"col-12\" [state]=\"sections.intituleDemande\" *ngIf=\"showIntituleDemandeSection\">\n  <ng-template #header>\n    <h2>Donnez un titre à votre demande <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p clas=\"exp\" *ngIf=\"depotRequeteState.concernContentieuxSocial\">\n          Exemples : Revenu de solidarité active (RSA), carte de stationnement pour personnes handicapées,\n          aide personnalisée au logement (APL), radiation des listes des demandeurs d’emploi, etc.\n        </p>\n        <p clas=\"exp\" *ngIf=\"!depotRequeteState.concernContentieuxSocial &&\n        !contentieuxSocial.typeLitige\">\n          Exemples : contestation d'un refus de titre de séjour, contestation d'une évaluation professionnelle, etc.\n        </p>\n        <p class=\"exp\" *ngIf=\"!depotRequeteState.concernContentieuxSocial &&\n        contentieuxSocial.typeLitige &&\n        contentieuxSocial.typeLitige === 'Vous réclamez une somme d\\'argent à l\\'administration'\">\n          Exemples : demande de rémunération pour heures supplémentaires/astreintes effectuées.\n        </p>\n        <p class=\"exp\" *ngIf=\"!depotRequeteState.concernContentieuxSocial &&\n        contentieuxSocial.typeLitige &&\n        contentieuxSocial.typeLitige === 'Vous contestez une somme d\\'argent réclamée par l\\'administration'\">\n          Exemples : contestation d'un avis d'imposition, contestation de frais médicaux, etc.\n        </p>\n        <p class=\"exp\" *ngIf=\"!depotRequeteState.concernContentieuxSocial &&\n        contentieuxSocial.typeLitige &&\n        contentieuxSocial.typeLitige !== 'Vous réclamez une somme d\\'argent à l\\'administration' &&\n        contentieuxSocial.typeLitige !== 'Vous contestez une somme d\\'argent réclamée par l\\'administration'\">\n          Exemples : indemnisation liée à des frais médicaux, remboursement de la réparation d'un véhicule, etc.\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"objet-demande\"\n        name=\"objet-demande\"\n        maxlength=\"200\"\n        [(ngModel)]=\"contentieuxSocial.objetDemande\"\n        (change)=\"onContentieuxSocialChange()\"\n        aria-describedby=\"errorMessageObjetDemande\"\n        [required]=\"showIntituleDemandeSection\"\n        jhiWhitespace\n        tabindex=\"0\"\n        #objet=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">{{contentieuxSocial.objetDemande ? contentieuxSocial.objetDemande.length : 0}} / 200 caractères</div>\n      <div id=\"errorMessageObjetDemande\" class=\"error-msg\">\n        <div\n          *ngIf=\"(objet.touched && objet.hasError('required') && depotRequeteState.concernContentieuxSocial) ||\n          (depotRequeteState.concernContentieuxSocial && !sociauxDALOChampsObligatoiresFilled.objetDemande && contentieuxSocial.objetDemande == null)\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, veuillez indiquer la prestation, l’allocation ou le droit concerné par votre demande.\n        </div>\n        <div\n          *ngIf=\"(objet.touched && objet.hasError('required') && !depotRequeteState.concernContentieuxSocial) ||\n          (!depotRequeteState.concernContentieuxSocial && contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration' &&\n          !litigeLieDecisionChampsObligatoiresFilled.objetDemande && contentieuxSocial.objetDemande == null) ||\n          reclamerSommeObjectDemandeFilled() ||\n          contesterSommeObjectDemandeFilled() ||\n          indemnisationObjetDemandeFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, veuillez donner un titre à votre demande.\n        </div>\n        <div\n          *ngIf=\"objet.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- MOTIFS DEMANDES -->\n<jhi-section class=\"col-12\" [state]=\"sections.motifDemande\" *ngIf=\"showMotifSection\">\n  <ng-template #header>\n    <h2>Indiquez les motifs de votre demande <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication col-12\">\n        <p>\n          Vous devez présenter les arguments montrant que la décision que vous contestez n’a pas respecté vos droits.\n          Si vous ne détaillez pas assez vos motifs de demande, votre requête pourra être rejetée.\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"motifs-demande\"\n        name=\"motifs-demande\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.motifs\"\n        (change)=\"onContentieuxSocialChange()\"\n        [required]=\"showMotifSection\"\n        jhiWhitespace\n        aria-describedby=\"errorMessageMotifsDemande\"\n        tabindex=\"0\"\n        #motifs=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">\n        {{contentieuxSocial.motifs? contentieuxSocial.motifs.length : 0}} / 1000 caractères\n      </div>\n      <div id=\"errorMessageMotifsDemande\" class=\"error-msg\">\n        <div\n          *ngIf=\"(motifs.touched && motifs.hasError('required')) ||\n          (!sociauxDALOChampsObligatoiresFilled.motifs && contentieuxSocial.motifs == null)\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir vos motifs de demande.\n        </div>\n        <div\n          *ngIf=\"motifs.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n    </div> \n  </ng-template>\n</jhi-section>\n\n<!-- CONCLUSION DALO-->\n<jhi-section class=\"col-12\" [state]=\"sections.conclusionDALO\" *ngIf=\"showDALOConclusionSection\">\n  <ng-template #header>\n    <h2>Conclusion <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <!-- <h3>Indiquez les motifs de votre demande : <span class=\"star-warning\">*</span></h3> -->\n      <div class=\"explication col-12\">\n        <p>\n          Précisez ce que vous demandez au juge.\n        </p>\n        <p class=\"exp\">\n          Exemples: annulation de la décision, remboursement des sommes que l'administration vous a réclamées,\n          versement des sommes que vous estimez vous être dues, etc.\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"conclusionDALO-demande\"\n        name=\"conclusionDALO-demande\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.conclusionDALO\"\n        (change)=\"onContentieuxSocialChange()\"\n        [required]=\"showDALOConclusionSection\"\n        jhiWhitespace\n        aria-describedby=\"errorMessageConclusion\"\n        #conclusionDALO=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">\n        {{contentieuxSocial.conclusionDALO? contentieuxSocial.conclusionDALO.length : 0}} / 1000 caractères\n      </div>\n      <div id=\"errorMessageConclusion\" class=\"error-msg\">\n        <div\n          *ngIf=\"(conclusionDALO.touched && conclusionDALO.hasError('required')) ||\n          (!sociauxDALOChampsObligatoiresFilled.conclusionDALO && contentieuxSocial.conclusionDALO == null)\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir la conclusion de votre demande.\n        </div>\n        <div\n          *ngIf=\"conclusionDALO.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- ~~~~~~~~~~~~~~~~~ FIN DALO ~~~~~~~~~~~~~~~~ -->\n<!-- ~~~~~~~~~~~ LITIGE LIE A UNE DECISION ADMIN ~~~~~~~~~~~~  -->\n\n<!-- CONTEXTE INTERVENTION DECISION -->\n<jhi-section class=\"col-12\" [state]=\"sections.contexteInterventionDecision\" *ngIf=\"showContexteInterventionDecision\">\n  <ng-template #header>\n    <h2 *ngIf=\"contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration' || !contentieuxSocial.souhait\">\n      Expliquez dans quel contexte est intervenue la décision <span class=\"danger-hint\">*</span>\n    </h2>\n    <h2 *ngIf=\"contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent'\">\n      Expliquez le contexte de votre demande (votre situation, ce qu'il s'est passé) <span class=\"danger-hint\">*</span>\n    </h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p *ngIf=\"contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration' || !contentieuxSocial.souhait\" class=\"exp\">\n          Exemple : « J'habite actuellement à Toulouse mais je vais déménager dans 6 mois. J'ai donc demandé à ce que mon enfant\n          ne soit pas affecté dans la commune de Toulouse mais dans celle où j'habiterai dans 6 mois. Cette dérogation m'a été refusée. »\n        </p>\n        <p *ngIf=\"contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent'\" class=\"exp\">\n          Exemple :\n          « J'exerce les fonctions de technicien informatique en charge du support à la commune de Nice depuis 2014.\n          L'exercice de mes fonctions comporte des astreintes le week-end et les jours fériés. Le samedi 14 et le dimanche 15 octobre 2023,\n          j'ai été d'astreinte toute la journée de 8 heures à 16 heures. Ces astreintes n'apparaissent pas sur mon bulletin de paye du\n          mois d'octobre. J'ai demandé à mon employeur le paiement de la somme de X € pour ces astreintes. Par courrier, du 25/11/2023 la commune\n          a rejeté ma demande. »\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"contexte-intervention-decision\"\n        name=\"contexte-intervention-decision\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.contexteInterventionDecision\"\n        (change)=\"onContentieuxSocialChange()\"\n        aria-describedby=\"errorMessageContexteInterventionDecision\"\n        [required]=\"showContexteInterventionDecision\"\n        jhiWhitespace\n        tabindex=\"0\"\n        #contexteIntervention=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">{{contentieuxSocial.contexteInterventionDecision ? contentieuxSocial.contexteInterventionDecision.length : 0}} / 1000 caractères</div>\n      <div id=\"errorMessageContexteInterventionDecision\" class=\"error-msg\">\n        <div\n          *ngIf=\"(contexteIntervention.touched && contexteIntervention.hasError('required') &&\n          contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration') ||\n          (contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une décision de l\\'administration' &&\n          !litigeLieDecisionChampsObligatoiresFilled.contexteInterventionDecision &&\n          contentieuxSocial.contexteInterventionDecision == null)\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, veuillez indiquer le contexte dans lequel est intervenue la décision.\n        </div>\n        <div\n          *ngIf=\"(contexteIntervention.touched && contexteIntervention.hasError('required') &&\n          contentieuxSocial.souhait === 'Remplir le formulaire : litige lié à une somme d\\'argent') ||\n          reclamerSommeContexteInterventionDecisionFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, veuillez indiquer le contexte de votre demande.\n        </div>\n        <div\n          *ngIf=\"contexteIntervention.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- RAISON CONTESTER DECISION -->\n<jhi-section class=\"col-12\" [state]=\"sections.raisonsContesterDecision\" *ngIf=\"showRaisonsContesterDecisionSection\">\n  <ng-template #header>\n    <h2>Pour quelle(s) raison(s) contestez-vous la décision ? <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <p class=\"alert alert-danger alert-secondary\">\n      <b class=\"alert-contestation\">Attention</b>&nbsp;: les raisons de contestation ne seront pas retenues si elles ne sont pas assez argumentées. \n    </p>\n    <div\n      *ngFor=\"let rc of typeRaisonContestations; let idx = index\">\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          (ngModelChange)=\"rc.checked=$event; onRaisonContestationCheck()\"\n          [ngModel]=\"rc.checked\"\n          [required]=\"showRaisonsContesterDecisionSection && noneRCchecked\"\n          aria-describedby=\"errorMessageCheckboxRaisonContestation\"\n          id=\"checkbox-rc-{{rc.id}}\"\n          name=\"checkbox-rc-{{rc.id}}\"\n          type=\"checkbox\"\n          role=\"checkbox\"\n          value=\"{{ rc.id }}\"\n          tabindex=\"0\"\n          #checkboxRC/>\n        <label for=\"checkbox-rc-{{rc.id}}\" class=\"form-check-label\">\n            {{rc.description}}\n        </label>\n        <div class=\"explication\">\n          <p class=\"exp\">\n            Exemple : « {{rc.exemple}} »\n          </p>\n        </div>\n      </div>\n      <div *ngIf=\"rc.checked\" class=\"detail-raison-contestation\">\n        <h5>Veuillez détailler la situation <span class=\"danger-hint\">*</span></h5>\n        <textarea\n          class=\"form-control required focus-outline\"\n          id=\"raison-contestation-detail-{{rc.id}}\"\n          name=\"raison-contestation-detail-{{rc.id}}\"\n          maxlength=\"1000\"\n          [required]=\"showRaisonsContesterDecisionSection && rc.checked\"\n          [(ngModel)]=\"rc.detail\"\n          (change)=\"onRaisonContestationCheck()\"\n          aria-describedby=\"errorMessageRaisonContestationDetail\"\n          tabindex=\"0\"\n          #detailRC=\"ngModel\">\n        </textarea>\n        <div class=\"char-counter\">\n          {{rc.detail? rc.detail.length : 0}} / 1000 caractères\n        </div>\n        <div id=\"errorMessageRaisonContestationDetail\" class=\"error-msg\">\n          <div\n            *ngIf=\"(detailRC.touched && detailRC.hasError('required')) ||\n            (!litigeLieDecisionChampsObligatoiresFilled.raisonContestationDetail && rc.detail == '')\"\n            class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n            Pour poursuivre, veuillez détailler la situation.\n          </div>\n          <div\n            *ngIf=\"detailRC.hasError('invalid-whitespace')\"\n            class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n            Pour poursuivre, vous devez saisir au moins un caractère.\n          </div>\n        </div>\n      </div>\n\n      <!-- POUR LE CHOIX L'ADMINISTRATION A MAL INTERPRETE -->\n      <div class=\"piece-in-multi-choice\" *ngIf=\"rc.id == 6 && rc.checked && pieceComplementaireMalInterprete\">\n        <h5>Veuillez justifier votre déclaration avec tous documents utiles</h5>\n        <div\n          dragula=\"piecesComplementairesBagMI\"\n          [dragulaModel]=\"pieceComplementaireMalInterprete\"\n        >\n          <div\n            class=\"row no-gutters\"\n            *ngFor=\"\n            let pieceMI of pieceComplementaireMalInterprete;\n            let idx = index;\n            trackBy: trackByFileApiId\">\n              <div\n                class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n                tabindex=\"0\"\n                [id]=\"trackByFileApiId(idx, pieceMI)\"\n                role=\"button\"\n                aria-label=\"déplacer ce fichier\"\n                jhiA11yDragNDropDirective\n                [index]=\"idx\"\n                [piece]=\"pieceMI\"\n                [selectedItem]=\"selectedItemMI\"\n                (a11ySelect)=\"onSelectMI($event)\"\n                (a11yMoveup)=\"onMoveup($event, pieceComplementaireMalInterprete)\"\n                (a11yMovedown)=\"onMovedown($event, pieceComplementaireMalInterprete)\"\n                (a11yEscape)=\"onEscapeMI($event)\">\n                <i\n                  class=\"fa fa-arrows fa-2x\"\n                  aria-hidden=\"true\"\n                  title=\"déplacer ce fichier\"\n                ></i>\n              </div>\n              <div class=\"col-lg-11 col-12\">\n                <div class=\"d-lg-none text-center\">\n                  <button\n                    type=\"button\"\n                    (click)=\"moveUp(idx, pieceComplementaireMalInterprete)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-up\"\n                      aria-hidden=\"true\"\n                      title=\"déplacer ce fichier vers le haut\"\n                    ></i>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                  </button>\n                  <button\n                    type=\"button\"\n                    (click)=\"moveDown(idx, pieceComplementaireMalInterprete)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-down\"\n                      aria-hidden=\"true\"\n                      title=\"descendre ce fichier\"\n                    ></i>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                  </button>\n                </div>\n                <jhi-file-uploader\n                  inputName=\"piece-{{ pieceMI.fileModel.fileApiId }}\"\n                  [id]=\"'piece-complementaire-mal-interprete-' + idx + 1\"\n                  label=\"Pièce complémentaire n°{{ idx + 1 }}\"\n                  [file]=\"pieceMI.fileModel\"\n                  [url]=\"uploadUrl\"\n                  (fileChange)=\"onPieceComplementaireDelete(idx, $event, pieceComplementaireMalInterprete)\">\n                </jhi-file-uploader>\n                <div class=\"form-group required name\">\n                  <label\n                    [class.has-value]=\"renameInputMI.value\"\n                    class=\"nommer-piece-label\">Nommer la pièce n°{{ idx + 1 }}\n                  </label>\n                  <div class=\"input-group\">\n                    <input\n                      [attr.aria-label]=\"pieceMI.libelle\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      name=\"piece-{{pieceMI.fileModel.fileApiId}}-name\"\n                      [required]=\"rc.id == 6 && rc.checked && pieceMI\"\n                      jhiWhitespace\n                      aria-describedby=\"errorMessagePieceComplementaireMI\"\n                      [(ngModel)]=\"pieceMI.libelle\"\n                      (ngModelChange)=\"checkLengthForFileName($event, pieceMI)\"\n                      #renameInputMI=\"ngModel\"\n                    />\n                  </div>\n                </div>\n                <div\n                  *ngIf=\"showLengthWarningForFileName\"\n                  role=\"alert\"\n                  class=\"alert alert-warning alert-secondary\">\n                  <div\n                    jhiTranslate=\"entity.warning.maxlength\"\n                    translateValues=\"{actualLength: {{actualFileNameLength}}, max: {{maxFileNameWithoutExtensionLength}}}\">\n                  </div>\n                </div>\n                <div id=\"errorMessagePieceComplementaireMI\" class=\"error-msg\">\n                  <div\n                    *ngIf=\"(renameInputMI.touched ||\n                    !litigeLieDecisionChampsObligatoiresFilled.pieceMalInterpreteLibelle) && !renameInputMI.value\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez nommer cette pièce complémentaire\n                  </div>\n                  <div\n                    *ngIf=\"renameInputMI.value && renameInputMI.value.trim() === ''\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez utiliser au moins un caractère\n                  </div>\n                </div>\n              </div>\n          </div>\n        </div>\n        <jhi-file-uploader\n          inputName=\"piece-mi-adder\"\n          [id]=\"'piece-complementaire-mi-adder-' + pieceComplementaireMalInterprete.length + 1\"\n          label=\"Pièce complémentaire n°{{pieceComplementaireMalInterprete.length + 1}}\"\n          [required]=\"rc.id == 6 && rc.checked && pieceComplementaireMalInterprete.length === 0\"\n          (fileChange)=\"onPieceComplementaireMIAdd($event)\"\n          [url]=\"uploadUrl\"\n          *ngIf=\"pieceComplementaireMalInterprete?.length < maxNumberJointsComplementaryPieces - pieceComplementaireMalApprecie?.length - \n          depotRequeteState.acteAttaquesAFusioner?.length\"\n          #pieceMIAdder>\n        </jhi-file-uploader>\n      </div>\n      <!-- POUR LE CHOIX L'ADMINISTRATION A MAL APPRECIE -->\n      <div class=\"piece-in-multi-choice\" *ngIf=\"rc.id == 7 && rc.checked\">\n        <h5>Veuillez justifier votre déclaration avec tous documents utiles</h5>\n        <div class=\"explication\">\n          <p class=\"exp\">\n            Exemple : un plan avec l'itinéraire entre mon domicile, l'école et mon travail.\n          </p>\n        </div>\n        <div\n          dragula=\"piecesComplementairesBagMA\"\n          [dragulaModel]=\"pieceComplementaireMalApprecie\"\n          >\n          <div\n            class=\"row no-gutters\"\n            *ngFor=\"\n            let pieceMA of pieceComplementaireMalApprecie;\n            let i = index;\n            trackBy: trackByFileApiId\">\n              <div\n                class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n                tabindex=\"0\"\n                [id]=\"trackByFileApiId(i, pieceMA)\"\n                role=\"button\"\n                aria-label=\"déplacer ce fichier\"\n                jhiA11yDragNDropDirective\n                [index]=\"i\"\n                [piece]=\"pieceMA\"\n                [selectedItem]=\"selectedItemMA\"\n                (a11ySelect)=\"onSelectMA($event)\"\n                (a11yMoveup)=\"onMoveup($event, pieceComplementaireMalApprecie)\"\n                (a11yMovedown)=\"onMovedown($event, pieceComplementaireMalApprecie)\"\n                (a11yEscape)=\"onEscapeMA($event)\">\n                <i\n                  class=\"fa fa-arrows fa-2x\"\n                  aria-hidden=\"true\"\n                  title=\"déplacer ce fichier\"\n                ></i>\n              </div>\n              <div class=\"col-lg-11 col-12\">\n                <div class=\"d-lg-none text-center\">\n                  <button\n                    type=\"button\"\n                    (click)=\"moveUp(i, pieceComplementaireMalApprecie)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-up\"\n                      aria-hidden=\"true\"\n                      title=\"déplacer ce fichier vers le haut\"\n                    ></i>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                  </button>\n                  <button\n                    type=\"button\"\n                    (click)=\"moveDown(i, pieceComplementaireMalApprecie)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-down\"\n                      aria-hidden=\"true\"\n                      title=\"descendre ce fichier\"\n                    ></i>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                  </button>\n                </div>\n                <jhi-file-uploader\n                  inputName=\"piece-{{ pieceMA.fileModel.fileApiId }}\"\n                  [id]=\"'piece-complementaire-ma-' + i + 1\"\n                  label=\"Pièce complémentaire n°{{ i + 1 }}\"\n                  [file]=\"pieceMA.fileModel\"\n                  [url]=\"uploadUrl\"\n                  (fileChange)=\"onPieceComplementaireDelete(i, $event, pieceComplementaireMalApprecie)\">\n                </jhi-file-uploader>\n                <div class=\"form-group required name\">\n                  <label\n                    [class.has-value]=\"renameMAInput.value\"\n                    class=\"nommer-piece-label\">Nommer la pièce n°{{ i + 1 }}\n                  </label>\n                  <div class=\"input-group\">\n                    <input\n                      [attr.aria-label]=\"pieceMA.libelle\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      name=\"piece-{{pieceMA.fileModel.fileApiId}}-name\"\n                      [required]=\"rc.id == 7 && rc.checked && pieceMA\"\n                      jhiWhitespace\n                      aria-describedby=\"errorMessagePieceComplementaireMA\"\n                      [(ngModel)]=\"pieceMA.libelle\"\n                      (ngModelChange)=\"checkLengthForFileName($event, pieceMA)\"\n                      #renameMAInput=\"ngModel\"\n                    />\n                  </div>\n                </div>\n                <div\n                  *ngIf=\"showLengthWarningForFileName\"\n                  role=\"alert\"\n                  class=\"alert alert-warning alert-secondary\">\n                  <div\n                    jhiTranslate=\"entity.warning.maxlength\"\n                    translateValues=\"{actualLength: {{actualFileNameLength}}, max: {{maxFileNameWithoutExtensionLength}}}\">\n                  </div>\n                </div>\n                <div id=\"errorMessagePieceComplementaireMA\" class=\"error-msg\">\n                  <div\n                    *ngIf=\"(renameMAInput.touched ||\n                    !litigeLieDecisionChampsObligatoiresFilled.pieceMalApprecieLibelle) && !renameMAInput.value\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez nommer cette pièce complémentaire\n                  </div>\n                  <div\n                    *ngIf=\"renameMAInput.value && renameMAInput.value.trim() === ''\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez utiliser au moins un caractère\n                  </div>\n                </div>\n              </div>\n          </div>\n        </div>\n        <jhi-file-uploader\n          inputName=\"piece-ma-adder\"\n          [id]=\"'piece-complementaire-ma-adder-' + pieceComplementaireMalApprecie.length + 1\"\n          label=\"Pièce complémentaire n°{{pieceComplementaireMalApprecie.length + 1}}\"\n          [required]=\"rc.id == 7 && rc.checked && pieceComplementaireMalApprecie.length === 0\"\n          (fileChange)=\"onPieceComplementaireMAAdd($event)\"\n          [url]=\"uploadUrl\"\n          *ngIf=\"pieceComplementaireMalApprecie?.length < maxNumberJointsComplementaryPieces - pieceComplementaireMalInterprete?.length -\n          depotRequeteState.acteAttaquesAFusioner?.length\"\n          #pieceMAAdder>\n        </jhi-file-uploader>\n      </div>\n    </div>\n    <div id=\"errorMessageCheckboxRaisonContestation\" role=\"alert\"\n      *ngIf=\"!litigeLieDecisionChampsObligatoiresFilled.raisonContestations && !noRaisonContestationChecked()\"\n      class=\"alert alert-danger alert-secondary cs-alert\">\n      Pour poursuivre, veuillez cocher au moins une raison.\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- CONCLUSION LITIGE ADMIN -->\n<jhi-section class=\"col-12\" [state]=\"sections.conclusionLitigeAdmin\" *ngIf=\"showConclusionLitigeAdminSection\">\n  <ng-template #header>\n    <h2>Conclusion</h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"form-check\">\n        <input\n            type=\"checkbox\"\n            class=\"form-check-input\"\n            name=\"conclusion-litige-admin-checkbox\"\n            id=\"conclusion-litige-admin-checkbox\"\n            [(ngModel)]=\"contentieuxSocial.conclusionLitigeAdminCheckbox\"\n            (change)=\"onContentieuxSocialChange()\"\n            aria-describedby=\"errorMessageConclusionLitigeAdmin\"\n            [required]=\"showConclusionLitigeAdminSection\"\n            #conclusionLA=\"ngModel\">\n        <label class=\"form-check-label lb_clickable\" for=\"conclusion-litige-admin-checkbox\">\n          Je demande l'annulation de la décision prise par l'administration <span class=\"danger-hint\">*</span>\n        </label>\n      </div>\n      <div id=\"errorMessageConclusionLitigeAdmin\"\n          *ngIf=\"(conclusionLA.touched && conclusionLA.invalid) ||\n          (!litigeLieDecisionChampsObligatoiresFilled.conclusionLitigeAdminCheckbox && !contentieuxSocial.conclusionLitigeAdminCheckbox)\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez cocher cette case.\n      </div>\n      <div class=\"autre-conc-litige-admin\">\n        <h5>Autre :</h5>\n        <div class=\"explication\">\n          <p class=\"exp\">\n            Exemple : « Je demande au juge d'obliger l'administration à réexaminer ma situation. »\n          </p>\n        </div>\n        <textarea\n          id=\"conclusion-litige-admin-autre\"\n          class=\"form-control required focus-outline\"\n          [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n          type=\"text\"\n          maxlength=\"200\"\n          name=\"conclusion-litige-admin-autre\"\n          [(ngModel)]=\"contentieuxSocial.conclusionLitigeAdmin\"\n          (change)=\"onContentieuxSocialChange()\"\n        >\n        </textarea>\n        <div class=\"char-counter\">\n          {{contentieuxSocial.conclusionLitigeAdmin? contentieuxSocial.conclusionLitigeAdmin.length : 0}} / 200 caractères\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- ~~~~~~~~ FIN LITIGE LIE A UNE DECISION ADMIN ~~~~~~~~~~ -->\n<!-- ~~~~~~~~ RECLAMER UNE SOMME ~~~~~~~~ -->\n\n<!-- POURQUOI SOMME DUE -->\n<jhi-section class=\"col-12\" [state]=\"sections.sommeDueSection\" *ngIf=\"showSommeDueSection\">\n  <ng-template #header>\n    <h2>Démontrez pourquoi la somme est due <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p class=\"exp\">\n          Exemple : « J'ai réalisé des heures supplémentaires les 14 et 15 octobre 2023, je devrais percevoir\n          une rémunération pour le travail effectué ces jours. »\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"pourquoi-somme-due\"\n        name=\"pourquoi-somme-due\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.pourquoiSommeDue\"\n        (change)=\"onContentieuxSocialChange()\"\n        [required]=\"showSommeDueSection\"\n        jhiWhitespace\n        aria-describedby=\"errorMessagePourquoiSommeDue\"\n        tabindex=\"0\"\n        #sommeDue=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">\n        {{contentieuxSocial.pourquoiSommeDue? contentieuxSocial.pourquoiSommeDue.length : 0}} / 1000 caractères\n      </div>\n      <div id=\"errorMessagePourquoiSommeDue\" class=\"error-msg\">\n        <div\n          *ngIf=\"(sommeDue.touched && sommeDue.hasError('required')) || reclamerSommePourquoiSommeDueFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir pourquoi la somme est due.\n        </div>\n        <div\n          *ngIf=\"sommeDue.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n      <div class=\"piece-in-multi-choice\">\n        <h5>Joignez tous justificatifs utiles</h5>\n        <div class=\"explication\">\n          <p class=\"exp\">\n            Exemple : justificatif de travail pour les jours cités.\n          </p>\n        </div>\n        <div\n          dragula=\"piecesComplementairesBagSommeDue\"\n          [dragulaModel]=\"pieceComplementaireSommeDue\"\n        >\n          <div\n            class=\"row no-gutters\"\n            *ngFor=\"\n            let pieceSommeDue of pieceComplementaireSommeDue;\n            let idx = index;\n            trackBy: trackByFileApiId\">\n              <div\n                class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n                tabindex=\"0\"\n                [id]=\"trackByFileApiId(idx, pieceSommeDue)\"\n                role=\"button\"\n                aria-label=\"déplacer ce fichier\"\n                jhiA11yDragNDropDirective\n                [index]=\"idx\"\n                [piece]=\"pieceSommeDue\"\n                [selectedItem]=\"selectedItemSommeDue\"\n                (a11ySelect)=\"onSelectSommeDue($event)\"\n                (a11yMoveup)=\"onMoveup($event, pieceComplementaireSommeDue)\"\n                (a11yMovedown)=\"onMovedown($event, pieceComplementaireSommeDue)\"\n                (a11yEscape)=\"onEscapeSommeDue($event)\">\n                <i\n                  class=\"fa fa-arrows fa-2x\"\n                  aria-hidden=\"true\"\n                  title=\"déplacer ce fichier\"\n                ></i>\n              </div>\n              <div class=\"col-lg-11 col-12\">\n                <div class=\"d-lg-none text-center\">\n                  <button\n                    type=\"button\"\n                    (click)=\"moveUp(idx, pieceComplementaireSommeDue)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-up\"\n                      aria-hidden=\"true\"\n                      title=\"déplacer ce fichier vers le haut\"\n                    ></i>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                  </button>\n                  <button\n                    type=\"button\"\n                    (click)=\"moveDown(idx, pieceComplementaireSommeDue)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-down\"\n                      aria-hidden=\"true\"\n                      title=\"descendre ce fichier\"\n                    ></i>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                  </button>\n                </div>\n                <jhi-file-uploader\n                  inputName=\"piece-{{ pieceSommeDue.fileModel.fileApiId }}\"\n                  [id]=\"'piece-complementaire-somme-due-' + idx + 1\"\n                  label=\"Pièce complémentaire n°{{ idx + 1 }}\"\n                  [file]=\"pieceSommeDue.fileModel\"\n                  [url]=\"uploadUrl\"\n                  (fileChange)=\"onPieceComplementaireDelete(idx, $event, pieceComplementaireSommeDue)\">\n                </jhi-file-uploader>\n                <div class=\"form-group required name\">\n                  <label\n                    [class.has-value]=\"renameInputSommeDue.value\"\n                    class=\"nommer-piece-label\">Nommer la pièce n°{{ idx + 1 }}\n                  </label>\n                  <div class=\"input-group\">\n                    <input\n                      [attr.aria-label]=\"pieceSommeDue.libelle\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      name=\"piece-{{pieceSommeDue.fileModel.fileApiId}}-name\"\n                      [required]=\"showSommeDueSection && pieceSommeDue\"\n                      jhiWhitespace\n                      aria-describedby=\"errorMessagePieceComplementaireSommeDue\"\n                      [(ngModel)]=\"pieceSommeDue.libelle\"\n                      (ngModelChange)=\"checkLengthForFileName($event, pieceSommeDue)\"\n                      #renameInputSommeDue=\"ngModel\"\n                    />\n                  </div>\n                </div>\n                <div\n                  *ngIf=\"showLengthWarningForFileName\"\n                  role=\"alert\"\n                  class=\"alert alert-warning alert-secondary\">\n                  <div\n                    jhiTranslate=\"entity.warning.maxlength\"\n                    translateValues=\"{actualLength: {{actualFileNameLength}}, max: {{maxFileNameWithoutExtensionLength}}}\">\n                  </div>\n                </div>\n                <div id=\"errorMessagePieceComplementaireSommeDue\" class=\"error-msg\">\n                  <div\n                    *ngIf=\"(renameInputSommeDue.touched ||\n                    !this.reclamerUneSommeChampsObligatoiresFilled.pieceSommeDue) && !renameInputSommeDue.value\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez nommer cette pièce complémentaire\n                  </div>\n                  <div\n                    *ngIf=\"renameInputSommeDue.value && renameInputSommeDue.value.trim() === ''\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez utiliser au moins un caractère\n                  </div>\n                </div>\n              </div>\n          </div>\n        </div>\n        <jhi-file-uploader\n          inputName=\"piece-somme-due-adder\"\n          [id]=\"'piece-complementaire-somme-due-adder-' + pieceComplementaireSommeDue?.length + 1\"\n          label=\"Pièce complémentaire n°{{pieceComplementaireSommeDue?.length + 1}}\"\n          [required]=\"showSommeDueSection && pieceComplementaireSommeDue?.length === 0\"\n          (fileChange)=\"onPieceComplementaireSommeDueAdd($event)\"\n          [url]=\"uploadUrl\"\n          *ngIf=\"pieceComplementaireSommeDue?.length < maxNumberJointsComplementaryPieces - pieceComplementaireMontantDu?.length - \n          depotRequeteState.reclamationPrealablesAFusioner?.length\"\n          #pieceSommeDueAdder>\n        </jhi-file-uploader>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- MONTANT DU -->\n<jhi-section class=\"col-12\" [state]=\"sections.montantDuSection\" *ngIf=\"showMontantDuSection\">\n  <ng-template #header>\n    <h2>Indiquez le montant dû <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"input-group mb-3 montant-du-montant\" aria-describedby=\"errorMessageMontantDuMontant\">\n        <input\n        id=\"montant-du\"\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        type=\"number\"\n        name=\"montant-du\"\n        min=\"1\"\n        [(ngModel)]=\"contentieuxSocial.montantDuMontant\"\n        (change)=\"onContentieuxSocialChange()\"\n        aria-describedby=\"montant-currency-symble\"\n        [required]=\"showMontantDuSection\"\n        jhiWhitespace\n        tabindex=\"0\"\n        #montantDuMontant=\"ngModel\"\n        />\n        <span class=\"input-group-text\" id=\"montant-currency-symble\">€</span>\n      </div>\n      <div id=\"errorMessageMontantDuMontant\" class=\"error-msg\">\n        <div\n          *ngIf=\"(montantDuMontant.touched && montantDuMontant.hasError('required')) ||\n          reclamerSommeMontantDuMontantFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, veuillez saisir le montant dû.\n        </div>\n        <div\n          *ngIf=\"montantDuMontant.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un chiffre.\n        </div>\n      </div>\n      <div class=\"piece-in-multi-choice\">\n        <h5>Joignez tous justificatifs utiles</h5>\n        <div\n          dragula=\"piecesComplementairesBagMontantDu\"\n          [dragulaModel]=\"pieceComplementaireMontantDu\"\n        >\n          <div\n            class=\"row no-gutters\"\n            *ngFor=\"\n            let pieceMontantDu of pieceComplementaireMontantDu;\n            let idx = index;\n            trackBy: trackByFileApiId\">\n              <div\n                class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n                tabindex=\"0\"\n                [id]=\"trackByFileApiId(idx, pieceMontantDu)\"\n                role=\"button\"\n                aria-label=\"déplacer ce fichier\"\n                jhiA11yDragNDropDirective\n                [index]=\"idx\"\n                [piece]=\"pieceMontantDu\"\n                [selectedItem]=\"selectedItemMontantDu\"\n                (a11ySelect)=\"onSelectMontantDu($event)\"\n                (a11yMoveup)=\"onMoveup($event, pieceComplementaireMontantDu)\"\n                (a11yMovedown)=\"onMovedown($event, pieceComplementaireMontantDu)\"\n                (a11yEscape)=\"onEscapeMontantDu($event)\">\n                <i\n                  class=\"fa fa-arrows fa-2x\"\n                  aria-hidden=\"true\"\n                  title=\"déplacer ce fichier\"\n                ></i>\n              </div>\n              <div class=\"col-lg-11 col-12\">\n                <div class=\"d-lg-none text-center\">\n                  <button\n                    type=\"button\"\n                    (click)=\"moveUp(idx, pieceComplementaireMontantDu)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-up\"\n                      aria-hidden=\"true\"\n                      title=\"déplacer ce fichier vers le haut\"\n                    ></i>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                  </button>\n                  <button\n                    type=\"button\"\n                    (click)=\"moveDown(idx, pieceComplementaireMontantDu)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-down\"\n                      aria-hidden=\"true\"\n                      title=\"descendre ce fichier\"\n                    ></i>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                  </button>\n                </div>\n                <jhi-file-uploader\n                  inputName=\"piece-{{ pieceMontantDu.fileModel.fileApiId }}\"\n                  [id]=\"'piece-complementaire-montant-du-' + idx + 1\"\n                  label=\"Pièce complémentaire n°{{ idx + 1 }}\"\n                  [file]=\"pieceMontantDu.fileModel\"\n                  [url]=\"uploadUrl\"\n                  (fileChange)=\"onPieceComplementaireDelete(idx, $event, pieceComplementaireMontantDu)\">\n                </jhi-file-uploader>\n                <div class=\"form-group required name\">\n                  <label\n                    [class.has-value]=\"renameInputMontantDu.value\"\n                    class=\"nommer-piece-label\">Nommer la pièce n°{{ idx + 1 }}\n                  </label>\n                  <div class=\"input-group\">\n                    <input\n                      [attr.aria-label]=\"pieceMontantDu.libelle\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      name=\"piece-{{pieceMontantDu.fileModel.fileApiId}}-name\"\n                      [required]=\"showMontantDuSection && pieceMontantDu\"\n                      jhiWhitespace\n                      aria-describedby=\"errorMessagePieceComplementaireMontantDu\"\n                      [(ngModel)]=\"pieceMontantDu.libelle\"\n                      (ngModelChange)=\"checkLengthForFileName($event, pieceMontantDu)\"\n                      #renameInputMontantDu=\"ngModel\"\n                    />\n                  </div>\n                </div>\n                <div\n                  *ngIf=\"showLengthWarningForFileName\"\n                  role=\"alert\"\n                  class=\"alert alert-warning alert-secondary\">\n                  <div\n                    jhiTranslate=\"entity.warning.maxlength\"\n                    translateValues=\"{actualLength: {{actualFileNameLength}}, max: {{maxFileNameWithoutExtensionLength}}}\">\n                  </div>\n                </div>\n                <div id=\"errorMessagePieceComplementaireMontantDu\" class=\"error-msg\">\n                  <div\n                    *ngIf=\"(renameInputMontantDu.touched ||\n                    !this.reclamerUneSommeChampsObligatoiresFilled.pieceMontantDu) && !renameInputMontantDu.value\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez nommer cette pièce complémentaire\n                  </div>\n                  <div\n                    *ngIf=\"renameInputMontantDu.value && renameInputMontantDu.value.trim() === ''\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez utiliser au moins un caractère\n                  </div>\n                </div>\n              </div>\n          </div>\n        </div>\n        <jhi-file-uploader\n          inputName=\"piece-montant-du-adder\"\n          [id]=\"'piece-complementaire-montant-du-adder-' + pieceComplementaireMontantDu?.length + 1\"\n          label=\"Pièce complémentaire n°{{pieceComplementaireMontantDu?.length + 1}}\"\n          [required]=\"showMontantDuSection && pieceComplementaireMontantDu?.length === 0\"\n          (fileChange)=\"onPieceComplementaireMontantDuAdd($event)\"\n          [url]=\"uploadUrl\"\n          *ngIf=\"pieceComplementaireMontantDu?.length < maxNumberJointsComplementaryPieces -  pieceComplementaireSommeDue?.length -\n          depotRequeteState.reclamationPrealablesAFusioner?.length\"\n          #pieceMontantDuAdder>\n        </jhi-file-uploader>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- CONCLUSION LITIGE SOMME D'ARGENT : RECLAMER SOMME -->\n<jhi-section class=\"col-12\" [state]=\"sections.conclusionReclamerSommeSection\" *ngIf=\"showConclusionReclamerSommeSection\">\n  <ng-template #header>\n    <h2>Conclusion</h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"form-check\">\n        <input\n            type=\"checkbox\"\n            class=\"form-check-input\"\n            name=\"conclusion-reclamer-somme-condamner-admin-checkbox\"\n            id=\"conclusion-reclamer-somme-condamner-admin-checkbox\"\n            [(ngModel)]=\"contentieuxSocial.conclusionReclamerSommeCondamnerAdmin\"\n            (change)=\"onContentieuxSocialChange()\"\n            aria-describedby=\"errorMessageConclusionReclamerSommeCondamnerAdmin\"\n            [required]=\"showConclusionReclamerSommeSection\"\n            #conclusionRSCA=\"ngModel\">\n        <label class=\"form-check-label lb_clickable\" for=\"conclusion-reclamer-somme-condamner-admin-checkbox\">\n          Je demande au juge de condamner l'administration au paiement de la somme de : <span class=\"danger-hint\">*</span>\n        </label>\n      </div>\n      <div id=\"errorMessageConclusionReclamerSommeCondamnerAdmin\"\n          *ngIf=\"(conclusionRSCA.touched && conclusionRSCA.invalid) || reclamerSommeConclusionFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez cocher cette case.\n      </div>\n      <div class=\"input-group mb-3 montant-du-montant\">\n        <input\n        id=\"re-montant-du\"\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        type=\"number\"\n        name=\"re-montant-du\"\n        [value]=\"contentieuxSocial.montantDuMontant\"\n        disabled\n        aria-describedby=\"montant-currency-symble\"\n        tabindex=\"0\"\n        />\n        <span class=\"input-group-text\" id=\"montant-currency-symble\">€</span>\n      </div>\n      <div class=\"form-check\">\n        <input\n            type=\"checkbox\"\n            class=\"form-check-input\"\n            name=\"conclusion-reclamer-somme-majoree-checkbox\"\n            id=\"conclusion-reclamer-somme-majoree-checkbox\"\n            [(ngModel)]=\"contentieuxSocial.conclusionReclamerSommeMajoree\"\n            (change)=\"onContentieuxSocialChange()\"\n          >\n        <label class=\"form-check-label lb_clickable\" for=\"conclusion-reclamer-somme-majoree-checkbox\">\n          Je demande à ce que cette somme soit majorée des intérêts de droit.\n        </label>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- ~~~~~~~~~~ FIN RECLAMER UNE SOMME ~~~~~~~~~~ -->\n<!-- ~~~~~~~~~~~~~~ CONTESTER UNE SOMME ~~~~~~~~~~~~~~ -->\n<!-- FAIT CONDUIT AU LITIGE -->\n<jhi-section class=\"col-12\" [state]=\"sections.faitConduitLitigeSection\" *ngIf=\"showFaitConduitLitigeSection\">\n  <ng-template #header>\n    <h2>Présentez de façon précise les faits qui ont conduit au litige <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication col-12\">\n        <p>\n          Exemple :\n          « La commune de Grenoble a émis un titre de recette me demandant de payer l'accueil périscolaire pour le mercredi\n          et le vendredi après 18h alors qu'à ces heures-là mon enfant n'est pas gardé à l'école. J'ai demandé à la commune\n          d'annuler le titre de recette mais elle a refusé. »\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"fait-conduit-au-litige\"\n        name=\"fait-conduit-au-litige\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.faitConduitAuLitige\"\n        (change)=\"onContentieuxSocialChange()\"\n        [required]=\"showFaitConduitLitigeSection\"\n        jhiWhitespace\n        aria-describedby=\"errorMessageFaitConduitAuLitige\"\n        tabindex=\"0\"\n        #faitConduitAuLitige=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">\n        {{contentieuxSocial.faitConduitAuLitige? contentieuxSocial.faitConduitAuLitige.length : 0}} / 1000 caractères\n      </div>\n      <div id=\"errorMessageFaitConduitAuLitige\" class=\"error-msg\">\n        <div\n          *ngIf=\"(faitConduitAuLitige.touched && faitConduitAuLitige.hasError('required')) || contesterSommeFaitConduitAuLitigeFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir les faits qui ont conduit au litige.\n        </div>\n        <div\n          *ngIf=\"faitConduitAuLitige.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- TYPE ACTE EMIS -->\n<jhi-section class=\"col-12\" [state]=\"sections.typeActeEmisSection\" *ngIf=\"showTypeActeEmisSection\">\n  <ng-template #header>\n    <h2>Quel type d'acte l'administration a-t-elle émis ? <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div id=\"error-msg-type-acte-radio\" role=\"alert\"\n      *ngIf=\"!contesterUneSommeChampsObligatoiresFilled.typeActe && contentieuxSocial.typeActe == null\"\n      class=\"alert alert-danger alert-secondary cs-alert\">\n      Pour poursuivre, veuillez choisir une option.\n    </div>\n    <div *ngFor=\"let typeActe of typeActeEmisTexts; let idx = index\">\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          (ngModelChange)=\"onSetTypeActe($event)\"\n          [(ngModel)]=\"contentieuxSocial.typeActe\"\n          [required]=\"showTypeActeEmisSection\"\n          id=\"radio-{{typeActe.value}}\"\n          name=\"radio-{{typeActe.value}}\"\n          type=\"radio\"\n          role=\"radio\"\n          value=\"{{ typeActe.title }}\"\n          [checked]=\"(idx === 0)\"\n          aria-describedby=\"error-msg-type-acte-radio\"\n          tabindex=\"0\"\n          />\n        <label for=\"radio-{{typeActe.value}}\" class=\"form-check-label\">\n          <p>{{typeActe.title}}</p>\n          <div class=\"explication\">\n            <p class=\"exp\">\n              Exemples : {{ typeActe.description}}\n            </p>\n          </div>\n        </label>\n      </div>\n    </div>\n    <div class=\"piece-in-multi-choice\" *ngIf=\"contentieuxSocial.typeActe != null\">\n      <h5 *ngIf=\"contentieuxSocial.typeActe === 'Un avis d\\'imposition'\">\n        Déposez l'avis d'imposition émis par l'administration\n      </h5>\n      <h5 *ngIf=\"contentieuxSocial.typeActe !== 'Un avis d\\'imposition'\">\n        Déposez l'acte émis par l'administration\n      </h5>\n      <jhi-acte-attaque\n        name=\"acteAttaques\"\n        [(ngModel)]=\"depotRequeteState.acteAttaquesAFusioner\"\n        [adderLabel]=\"typeActeAdderLabel\"\n        [maxActeAttaquesForMerge]=\"maxActeAttaquesForMerge\"\n        [acteRequired]=\"showTypeActeEmisSection\"\n        [class.invalid]=\"isActeAttaquesMaxSizeExceeded\"\n        (change)=\"resetGeneratedActeAttaque()\"\n      >\n      </jhi-acte-attaque>\n      <div\n        role=\"alert\"\n        class=\"alert alert-danger\"\n        *ngIf=\"isActeAttaquesMaxSizeExceeded\"\n      >\n        La taille de l'ensemble des fichiers ci-dessus et formant\n        l'acte attaqué dépasse le maximum de\n        {{ maxFileSize | formatFileSize }}.\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- AVIS IMPOSITION IRREGULIER -->\n<jhi-section class=\"col-12\" [state]=\"sections.avisImpositionIrregulerSection\" *ngIf=\"showAvisImpositionIrregulerSection\">\n  <ng-template #header>\n    <h2>L'avis d'imposition émis est irrégulier car <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div\n      *ngFor=\"let ta of typeRaisonAvisDimpositionIrreguliers; let idx = index\">\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          (ngModelChange)=\"ta.checked=$event; onRaisonAvisDimpositionIrregulierCheck()\"\n          [ngModel]=\"ta.checked\"\n          [required]=\"showAvisImpositionIrregulerSection && noneRADIchecked\"\n          aria-describedby=\"error-msg-raison-avis-dimposition-irregulier-checkbox\"\n          id=\"checkbox-radi-{{ta.id}}\"\n          name=\"checkbox-radi-{{ta.id}}\"\n          type=\"checkbox\"\n          role=\"checkbox\"\n          value=\"{{ ta.id }}\"\n          tabindex=\"0\"\n          #checkboxRADI/>\n        <label for=\"checkbox-radi-{{ta.id}}\" class=\"form-check-label\">\n            {{ta.description}}\n        </label>\n        <div class=\"explication\" *ngIf=\"ta.exemple\">\n          <p class=\"exp\">\n            {{ta.exemple}}\n          </p>\n        </div>\n      </div>\n    </div>\n    <div id=\"error-msg-raison-avis-dimposition-irregulier-checkbox\" role=\"alert\"\n      *ngIf=\"!contesterUneSommeChampsObligatoiresFilled.raisonAvisDimpositionIrreguliers &&\n      !noRaisonAvisDimpositionIrregulierChecked()\"\n      class=\"alert alert-danger alert-secondary cs-alert\">\n      Pour poursuivre, vous devez cocher au moins une option.\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- RAISON PAS PAYER IMPOT -->\n<jhi-section class=\"col-12\" [state]=\"sections.raisonPasPayerImpotSection\" *ngIf=\"showRaisonPasPayerImpotSection\">\n  <ng-template #header>\n    <h2>Expliquez en quoi vous considérez que vous ne devriez pas payer cet impôt <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p>\n          Si vous avez choisi plusieurs raisons d'irrégularité de l'avis d'imposition,\n          vous devez expliquer et ajouter des pièces justificatives pour chacune de ces raisons.\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"raison-pas-payer-impot\"\n        name=\"raison-pas-payer-impot\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.raisonPasPayerImpot\"\n        (change)=\"onContentieuxSocialChange()\"\n        [required]=\"showRaisonPasPayerImpotSection\"\n        jhiWhitespace\n        aria-describedby=\"errorMessageRaisonPasPayerImpot\"\n        tabindex=\"0\"\n        #rppi=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">\n        {{contentieuxSocial.raisonPasPayerImpot? contentieuxSocial.raisonPasPayerImpot.length : 0}} / 1000 caractères\n      </div>\n      <div id=\"errorMessageRaisonPasPayerImpot\" class=\"error-msg\">\n        <div\n          *ngIf=\"(rppi.touched && rppi.hasError('required')) ||\n          contesterSommeRaisonPasPayerImpotFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez expliquer en quoi vous considérez que vous ne devriez pas payer cet impôt.\n        </div>\n        <div\n          *ngIf=\"rppi.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n      <div class=\"piece-in-multi-choice\">\n        <h5>Joignez tous justificatifs utiles</h5>\n        <div\n          dragula=\"piecesComplementairesBagAvisImpositionInfondeeEtAutre\"\n          [dragulaModel]=\"pieceComplmentaireAvisImpositionInfondeeEtAutre\"\n        >\n          <div\n            class=\"row no-gutters\"\n            *ngFor=\"\n            let pieceAIIA of pieceComplmentaireAvisImpositionInfondeeEtAutre;\n            let idx = index;\n            trackBy: trackByFileApiId\">\n              <div\n                class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n                tabindex=\"0\"\n                [id]=\"trackByFileApiId(idx, pieceAIIA)\"\n                role=\"button\"\n                aria-label=\"déplacer ce fichier\"\n                jhiA11yDragNDropDirective\n                [index]=\"idx\"\n                [piece]=\"pieceAIIA\"\n                [selectedItem]=\"selectedItemAIIA\"\n                (a11ySelect)=\"onSelectAIIA($event)\"\n                (a11yMoveup)=\"onMoveup($event, pieceComplmentaireAvisImpositionInfondeeEtAutre)\"\n                (a11yMovedown)=\"onMovedown($event, pieceComplmentaireAvisImpositionInfondeeEtAutre)\"\n                (a11yEscape)=\"onEscapeAIIA($event)\">\n                <i\n                  class=\"fa fa-arrows fa-2x\"\n                  aria-hidden=\"true\"\n                  title=\"déplacer ce fichier\"\n                ></i>\n              </div>\n              <div class=\"col-lg-11 col-12\">\n                <div class=\"d-lg-none text-center\">\n                  <button\n                    type=\"button\"\n                    (click)=\"moveUp(idx, pieceComplmentaireAvisImpositionInfondeeEtAutre)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-up\"\n                      aria-hidden=\"true\"\n                      title=\"déplacer ce fichier vers le haut\"\n                    ></i>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                  </button>\n                  <button\n                    type=\"button\"\n                    (click)=\"moveDown(idx, pieceComplmentaireAvisImpositionInfondeeEtAutre)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-down\"\n                      aria-hidden=\"true\"\n                      title=\"descendre ce fichier\"\n                    ></i>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                  </button>\n                </div>\n                <jhi-file-uploader\n                  inputName=\"piece-{{ pieceAIIA.fileModel.fileApiId }}\"\n                  [id]=\"'piece-complementaire-avis-imposition-infondee-et-autre' + idx + 1\"\n                  label=\"Pièce complémentaire n°{{ idx + 1 }}\"\n                  [file]=\"pieceAIIA.fileModel\"\n                  [url]=\"uploadUrl\"\n                  (fileChange)=\"onPieceComplementaireDelete(idx, $event, pieceComplmentaireAvisImpositionInfondeeEtAutre)\">\n                </jhi-file-uploader>\n                <div class=\"form-group required name\">\n                  <label\n                    [class.has-value]=\"renameInputAIIA.value\"\n                    class=\"nommer-piece-label\">Nommer la pièce n°{{ idx + 1 }}\n                  </label>\n                  <div class=\"input-group\">\n                    <input\n                      [attr.aria-label]=\"pieceAIIA.libelle\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      name=\"piece-{{pieceAIIA.fileModel.fileApiId}}-name\"\n                      [required]=\"showRaisonPasPayerImpotSection && pieceAIIA\"\n                      jhiWhitespace\n                      aria-describedby=\"errorMessagePieceComplementaireAIIA\"\n                      [(ngModel)]=\"pieceAIIA.libelle\"\n                      (ngModelChange)=\"checkLengthForFileName($event, pieceAIIA)\"\n                      #renameInputAIIA=\"ngModel\"\n                    />\n                  </div>\n                </div>\n                <div\n                  *ngIf=\"showLengthWarningForFileName\"\n                  role=\"alert\"\n                  class=\"alert alert-warning alert-secondary\">\n                  <div\n                    jhiTranslate=\"entity.warning.maxlength\"\n                    translateValues=\"{actualLength: {{actualFileNameLength}}, max: {{maxFileNameWithoutExtensionLength}}}\">\n                  </div>\n                </div>\n                <div id=\"errorMessagePieceComplementaireAIIA\" class=\"error-msg\">\n                  <div\n                    *ngIf=\"(renameInputAIIA.touched ||\n                    !contesterUneSommeChampsObligatoiresFilled.pieceAvisImpositionInfondeeEtAutreLibelle) && !renameInputAIIA.value\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez nommer cette pièce complémentaire\n                  </div>\n                  <div\n                    *ngIf=\"renameInputAIIA.value && renameInputAIIA.value.trim() === ''\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez utiliser au moins un caractère\n                  </div>\n                </div>\n              </div>\n          </div>\n        </div>\n        <jhi-file-uploader\n          inputName=\"piece-complementaire-avis-imposition-infondee-et-autre-adder\"\n          [id]=\"'piece-complementaire-avis-imposition-infondee-et-autre-adder-' +\n          pieceComplmentaireAvisImpositionInfondeeEtAutre.length + 1\"\n          label=\"Pièce complémentaire n°{{pieceComplmentaireAvisImpositionInfondeeEtAutre.length + 1}}\"\n          [required]=\"showRaisonPasPayerImpotSection && pieceComplmentaireAvisImpositionInfondeeEtAutre.length === 0\"\n          (fileChange)=\"onPieceComplementaireAIIAAdd($event)\"\n          [url]=\"uploadUrl\"\n          *ngIf=\"pieceComplmentaireAvisImpositionInfondeeEtAutre.length < maxNumberJointsComplementaryPieces - \n          depotRequeteState.acteAttaquesAFusioner?.length - depotRequeteState.reclamationPrealablesAFusioner?.length\"\n          #pieceAIIAAdder>\n        </jhi-file-uploader>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- CONCLUSION AVIS IMPOSITION -->\n<jhi-section class=\"col-12\" [state]=\"sections.conclusionAvisImpositionImpotSection\" *ngIf=\"showConclusionAvisImpositionImpotSection\">\n  <ng-template #header>\n    <h2>Conclusion <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"form-check\">\n        <input\n            type=\"checkbox\"\n            class=\"form-check-input\"\n            name=\"conclusion-reclamer-somme-condamner-admin-checkbox\"\n            id=\"conclusion-reclamer-somme-condamner-admin-checkbox\"\n            [(ngModel)]=\"contentieuxSocial.conclusionAvisImpositionImpot\"\n            (change)=\"onContentieuxSocialChange()\"\n            aria-describedby=\"errorMessageConclusionReclamerSommeCondamnerAdmin\"\n            [required]=\"showConclusionAvisImpositionImpotSection\"\n            #conclusionAII=\"ngModel\">\n        <label class=\"form-check-label lb_clickable\" for=\"conclusion-reclamer-somme-condamner-admin-checkbox\">\n          Je demande au juge de m'accorder le dégrèvement de la somme réclamée.\n        </label>\n      </div>\n      <div id=\"errorMessageConclusionReclamerSommeCondamnerAdmin\" role=\"alert\"\n          *ngIf=\"(conclusionAII.touched && conclusionAII.invalid) ||\n          contesterSommeConclusionAvisImpositionImpotFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\">\n          Pour poursuivre, vous devez cocher cette case.\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- TITRE EMIS IRREGULIER -->\n<jhi-section class=\"col-12\" [state]=\"sections.titreEmisIrregulerSection\" *ngIf=\"showTitreEmisIrregulerSection\">\n  <ng-template #header>\n    <h2>Le titre émis est irrégulier <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"explication col-12\">\n      <p>\n        Vous devez donner au minimum une raison d'invalidation du titre\n      </p>\n    </div>\n    <div\n      *ngFor=\"let rit of typeRaisonInvalidationTitres; let idx = index\">\n      <h4 class=\"raison-invalidation-titre-type\" *ngIf=\"idx === 0\">Sur la forme :</h4>\n      <h4 class=\"raison-invalidation-titre-type\" *ngIf=\"idx === 3\">Sur le fond :</h4>\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          (ngModelChange)=\"rit.checked=$event; onRaisonInvalidationTitreCheck()\"\n          [ngModel]=\"rit.checked\"\n          [required]=\"showTitreEmisIrregulerSection && noneRITchecked\"\n          aria-describedby=\"error-msg-raison-invalid-titres-checkbox\"\n          id=\"checkbox-rit-{{rit.id}}\"\n          name=\"checkbox-rit-{{rit.id}}\"\n          type=\"checkbox\"\n          role=\"checkbox\"\n          value=\"{{ rit.id }}\"\n          tabindex=\"0\"\n          #checkboxRIT/>\n        <label for=\"checkbox-rit-{{rit.id}}\" class=\"form-check-label\">\n            {{rit.description}}\n        </label>\n        <div class=\"explication\" *ngIf=\"rit.exemple\">\n          <p *ngIf=\"rit.information\"> {{rit.information}} </p>\n          <p class=\"exp\">\n            {{rit.exemple}}\n          </p>\n        </div>\n      </div>\n      <div *ngIf=\"rit.checked\" class=\"detail-raison-validation-titre\">\n        <h5>Veuillez détailler la situation <span class=\"danger-hint\">*</span></h5>\n        <textarea\n          class=\"form-control required focus-outline\"\n          id=\"raison-contestation-validation-titre-{{rit.id}}\"\n          name=\"raison-contestation-validation-titre-{{rit.id}}\"\n          maxlength=\"1000\"\n          [required]=\"showTitreEmisIrregulerSection && rit.checked\"\n          [(ngModel)]=\"rit.detail\"\n          (change)=\"onRaisonInvalidationTitreCheck()\"\n          aria-describedby=\"errorMessageRaisonValidationTitreDetail\"\n          tabindex=\"0\"\n          #detailRIT=\"ngModel\">\n        </textarea>\n        <div class=\"char-counter\">\n          {{rit.detail? rit.detail.length : 0}} / 1000 caractères\n        </div>\n        <div id=\"errorMessageRaisonValidationTitreDetail\" class=\"error-msg\">\n          <div\n            *ngIf=\"(detailRIT.touched && detailRIT.hasError('required')) ||\n            (!contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitreDetail && rit.detail == '')\"\n            class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n            Pour poursuivre, veuillez détailler la situation.\n          </div>\n          <div\n            *ngIf=\"detailRIT.hasError('invalid-whitespace')\"\n            class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n            Pour poursuivre, vous devez saisir au moins un caractère.\n          </div>\n        </div>\n      </div>\n    </div>\n    <div id=\"error-msg-raison-invalid-titres-checkbox\" role=\"alert\"\n      *ngIf=\"!contesterUneSommeChampsObligatoiresFilled.raisonInvalidationTitres && !noRaisonInvalidationTitreChecked()\"\n      class=\"alert alert-danger alert-secondary cs-alert\">\n      Pour poursuivre, veuillez sélectionner au moins une option.\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!--CONCLUSION TITRE EMIS IRREGULIER -->\n<jhi-section class=\"col-12\" [state]=\"sections.conclusionTitreEmisIrregulerSection\" *ngIf=\"showConclusionTitreEmisIrregulerSection\">\n  <ng-template #header>\n    <h2>Conclusion <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"form-check\">\n        <input\n            type=\"checkbox\"\n            class=\"form-check-input\"\n            name=\"conclusion-contester-somme-titre-emis-irregulier-checkbox\"\n            id=\"conclusion-contester-somme-titre-emis-irregulier-checkbox\"\n            [(ngModel)]=\"contentieuxSocial.conclusionContesterSommeTitreEmisIrregulierDes\"\n            (change)=\"onContentieuxSocialChange()\"\n            aria-describedby=\"errorMessageConclusionContesterSommeTitreEmisIrregulierDes\"\n            [required]=\"showConclusionTitreEmisIrregulerSection\"\n            #conclusionTEID=\"ngModel\">\n        <label class=\"form-check-label lb_clickable\" for=\"conclusion-contester-somme-titre-emis-irregulier-checkbox\">\n          Je demande au juge de prononcer la décharge de l'obligation de payer la somme de :\n        </label>\n      </div>\n      <div id=\"errorMessageConclusionContesterSommeTitreEmisIrregulierDes\"\n          *ngIf=\"(conclusionTEID.touched && conclusionTEID.invalid) ||\n          contesterSommeConclusionContesterSommeTitreEmisIrregulierDesFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez cocher cette case.\n      </div>\n      <div class=\"input-group mb-3 montant-du-montant\" aria-describedby=\"errorMessageMontantDuMontant\">\n        <input\n        id=\"conclusion-contester-somme-titre-emis-irregulier-montant\"\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        type=\"number\"\n        name=\"conclusion-contester-somme-titre-emis-irregulier-montant\"\n        min=\"1\"\n        [(ngModel)]=\"contentieuxSocial.conclusionContesterSommeTitreEmisIrregulierMontant\"\n        (change)=\"onContentieuxSocialChange()\"\n        aria-describedby=\"conclusion-titre-emis-irregulier-montant\"\n        [required]=\"showConclusionTitreEmisIrregulerSection\"\n        jhiWhitespace\n        tabindex=\"0\"\n        #conclusionTEIMontant=\"ngModel\"\n        />\n        <span class=\"input-group-text\" id=\"conclusion-titre-emis-irregulier-montant\">€</span>\n      </div>\n      <div id=\"errorMessageMontantDuMontant\" class=\"error-msg\">\n        <div\n          *ngIf=\"(conclusionTEIMontant.touched && conclusionTEIMontant.hasError('required')) ||\n          contesterSommeConclusionContesterSommeTitreEmisIrregulierMontantFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, veuillez saisir le montant dû.\n        </div>\n        <div\n          *ngIf=\"conclusionTEIMontant.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un chiffre.\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- ~~~~~~~~~~~~~ FIN CONTESTER UNE SOMME~~~~~~~~~~~~ -->\n<!-- ~~~~~~~~~~~~~~~~INDEMNISATION~~~~~~~~~~~~~~~~ -->\n<!-- FAIT CONDUIT SITUATION REPARATION -->\n<jhi-section class=\"col-12\" [state]=\"sections.faitConduitSituationReparationSection\" *ngIf=\"showFaitConduitSituationReparationSection\">\n  <ng-template #header>\n    <h2>Présentez de façon précise les faits qui ont conduit à la situation dont vous demandez réparation <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p class=\"exp\">\n          Exemple :\n          « Le 15 octobre 2023, je suis tombée dans la rue à cause d'un trou présent dans la chaussée et me suis cassée la jambe. En effet,\n          ce trou n'a pas été rebouché par l'administration et rien n'indiquait sa présence ou n'empêchait les passants de tomber dedans\n          (aucun panneau, aucune barrière, etc.) »\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"fait-conduit-situation-reparation\"\n        name=\"fait-conduit-situation-reparation\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.faitConduitSituationReparation\"\n        (change)=\"onContentieuxSocialChange()\"\n        [required]=\"showFaitConduitSituationReparationSection\"\n        jhiWhitespace\n        aria-describedby=\"errorMessagefaitConduitSituRepa\"\n        tabindex=\"0\"\n        #situRepa=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">\n        {{contentieuxSocial.faitConduitSituationReparation? contentieuxSocial.faitConduitSituationReparation.length : 0}} / 1000 caractères\n      </div>\n      <div id=\"errorMessagefaitConduitSituRepa\" class=\"error-msg\">\n        <div\n          *ngIf=\"(situRepa.touched && situRepa.hasError('required')) ||\n          indemnisationFaitConduitSituationReparationFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir les faits qui ont conduit à la situation dont vous demandez réparation.\n        </div>\n        <div\n          *ngIf=\"situRepa.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- TYPE PREJUDICE EVALUABLE EN ARGENT -->\n<jhi-section class=\"col-12\" [state]=\"sections.typePrejudiceEvaluableEnArgentSection\" *ngIf=\"showTypePrejudiceEvaluableEnArgentSection\">\n  <ng-template #header>\n    <h2>De quel(s) préjudice(s) évaluable(s) en argent avez-vous souffert ? <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <p class=\"alert alert-danger alert-secondary\">\n      <b class=\"alert-contestation\">Attention</b>&nbsp;: les préjudices sélectionnés ne seront pas retenus s'ils ne sont pas expliqués et justifiés à l'étape suivante. \n    </p>\n    <div\n      *ngFor=\"let prej of typePrejudiceEvaluableEnArgents; let idx = index\">\n      <div class=\"form-check\">\n        <input\n          class=\"form-check-input\"\n          (ngModelChange)=\"prej.checked=$event; onPrejudiceEvaluableEnArgentCheck()\"\n          [ngModel]=\"prej.checked\"\n          [required]=\"showTypePrejudiceEvaluableEnArgentSection && nonePEEAchecked\"\n          aria-describedby=\"error-msg-prejudice-checkbox\"\n          id=\"checkbox-prej-{{prej.id}}\"\n          name=\"checkbox-prej-{{prej.id}}\"\n          type=\"checkbox\"\n          role=\"checkbox\"\n          value=\"{{ prej.id }}\"\n          tabindex=\"0\"\n          #checkboxPEEA/>\n        <label for=\"checkbox-prej-{{prej.id}}\" class=\"form-check-label\">\n            {{prej.description}}\n        </label>\n        <div class=\"explication\">\n          <p class=\"exp\">\n            {{prej.exemple}}\n          </p>\n        </div>\n      </div>\n    </div>\n    <div id=\"error-msg-prejudice-checkbox\" role=\"alert\"\n      *ngIf=\"!indemnisationChampsObligatoiresFilled.prejudiceEvaluableEnArgents &&\n      !noPrejudiceEvaluableEnArgentChecked()\"\n      class=\"alert alert-danger alert-secondary cs-alert\">\n      Pour poursuivre, vous devez cocher au moins une option.\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- PRECISION PREJUDICE -->\n<jhi-section class=\"col-12\" [state]=\"sections.precisionPrejudiceSection\" *ngIf=\"showPrecisionPrejudiceSection\">\n  <ng-template #header>\n    <h2>Expliquez précisément votre préjudice et justifiez la somme demandée <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p>Le préjudice que vous avez subi doit être réel et avéré, il ne doit pas concerner un éventuel futur préjudice.</p>\n        <p>Vous devez expliquer chaque préjudice sélectionné à l’étape précédente.</p>\n        <p class=\"exp\">\n          Exemple :\n          « Ma jambe cassée à cause du trou présent dans la chaussée a entraîné des frais d'hôpitaux à ma charge\n          et m'empêche d'exercer mes fonctions de chauffeur de taxi pendant 3 mois et donc de percevoir une\n          rémunération. »\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"precision-prejudice\"\n        name=\"precision-prejudice\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.precisionPrejudice\"\n        (change)=\"onContentieuxSocialChange()\"\n        [required]=\"showPrecisionPrejudiceSection\"\n        jhiWhitespace\n        aria-describedby=\"errorMessagePrecisionPrejudice\"\n        tabindex=\"0\"\n        #precisionP=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">\n        {{contentieuxSocial.precisionPrejudice? contentieuxSocial.precisionPrejudice.length : 0}} / 1000 caractères\n      </div>\n      <div id=\"errorMessagePrecisionPrejudice\" class=\"error-msg\">\n        <div\n          *ngIf=\"(precisionP.touched && precisionP.hasError('required')) ||\n          indemnisationPrecisionPrejudiceFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez expliquer précisément votre préjudice et justifier la somme demandée.\n        </div>\n        <div\n          *ngIf=\"precisionP.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n      <div class=\"piece-in-multi-choice\">\n        <h5>Toutes déclarations doivent être justifiées par des pièces</h5>\n        <div class=\"explication\">\n          <p class=\"exp\">\n            Exemples : attestation de témoin, reconnaissance de dette, emprunt, actes d'huissiers, factures,\n            relevés bancaires, arrêts de travail, certificats médicaux, feuilles de paie, relevé de soins\n            de la CPAM, etc.\n          </p>\n        </div>\n        <div\n          dragula=\"piecesComplementairesBagPrecisionPrejudice\"\n          [dragulaModel]=\"pieceComplementairePrecisionPrejudice\"\n        >\n          <div\n            class=\"row no-gutters\"\n            *ngFor=\"\n            let piecePP of pieceComplementairePrecisionPrejudice;\n            let idx = index;\n            trackBy: trackByFileApiId\">\n              <div\n                class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n                tabindex=\"0\"\n                [id]=\"trackByFileApiId(idx, piecePP)\"\n                role=\"button\"\n                aria-label=\"déplacer ce fichier\"\n                jhiA11yDragNDropDirective\n                [index]=\"idx\"\n                [piece]=\"piecePP\"\n                [selectedItem]=\"selectedItemPrecisionPrejudice\"\n                (a11ySelect)=\"onSelectPrecisionPrejudice($event)\"\n                (a11yMoveup)=\"onMoveup($event, pieceComplementairePrecisionPrejudice)\"\n                (a11yMovedown)=\"onMovedown($event, pieceComplementairePrecisionPrejudice)\"\n                (a11yEscape)=\"onEscapePrecisionPrejudice($event)\">\n                <i\n                  class=\"fa fa-arrows fa-2x\"\n                  aria-hidden=\"true\"\n                  title=\"déplacer ce fichier\"\n                ></i>\n              </div>\n              <div class=\"col-lg-11 col-12\">\n                <div class=\"d-lg-none text-center\">\n                  <button\n                    type=\"button\"\n                    (click)=\"moveUp(idx, pieceComplementairePrecisionPrejudice)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-up\"\n                      aria-hidden=\"true\"\n                      title=\"déplacer ce fichier vers le haut\"\n                    ></i>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                  </button>\n                  <button\n                    type=\"button\"\n                    (click)=\"moveDown(idx, pieceComplementairePrecisionPrejudice)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-down\"\n                      aria-hidden=\"true\"\n                      title=\"descendre ce fichier\"\n                    ></i>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                  </button>\n                </div>\n                <jhi-file-uploader\n                  inputName=\"piece-{{ piecePP.fileModel.fileApiId }}\"\n                  [id]=\"'piece-complementaire-precision-prejudice-' + idx + 1\"\n                  label=\"Pièce complémentaire n°{{ idx + 1 }}\"\n                  [file]=\"piecePP.fileModel\"\n                  [url]=\"uploadUrl\"\n                  (fileChange)=\"onPieceComplementaireDelete(idx, $event, pieceComplementairePrecisionPrejudice)\">\n                </jhi-file-uploader>\n                <div class=\"form-group required name\">\n                  <label\n                    [class.has-value]=\"renameInputPrecisionPrejudice.value\"\n                    class=\"nommer-piece-label\">Nommer la pièce n°{{ idx + 1 }}\n                  </label>\n                  <div class=\"input-group\">\n                    <input\n                      [attr.aria-label]=\"piecePP.libelle\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      name=\"piece-{{piecePP.fileModel.fileApiId}}-name\"\n                      [required]=\"showPrecisionPrejudiceSection && piecePP\"\n                      jhiWhitespace\n                      aria-describedby=\"errorMessagePieceComplementairePrecisionPrejudice\"\n                      [(ngModel)]=\"piecePP.libelle\"\n                      (ngModelChange)=\"checkLengthForFileName($event, piecePP)\"\n                      #renameInputPrecisionPrejudice=\"ngModel\"\n                    />\n                  </div>\n                </div>\n                <div\n                  *ngIf=\"showLengthWarningForFileName\"\n                  role=\"alert\"\n                  class=\"alert alert-warning alert-secondary\">\n                  <div\n                    jhiTranslate=\"entity.warning.maxlength\"\n                    translateValues=\"{actualLength: {{actualFileNameLength}}, max: {{maxFileNameWithoutExtensionLength}}}\">\n                  </div>\n                </div>\n                <div id=\"errorMessagePieceComplementairePrecisionPrejudice\" class=\"error-msg\">\n                  <div\n                    *ngIf=\"(renameInputPrecisionPrejudice.touched ||\n                    !indemnisationChampsObligatoiresFilled.piecePrecisionPrejudiceLibelle) && !renameInputPrecisionPrejudice.value\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez nommer cette pièce complémentaire\n                  </div>\n                  <div\n                    *ngIf=\"renameInputPrecisionPrejudice.value && renameInputPrecisionPrejudice.value.trim() === ''\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez utiliser au moins un caractère\n                  </div>\n                </div>\n              </div>\n          </div>\n        </div>\n        <jhi-file-uploader\n          inputName=\"piece-precision-prejudice-adder\"\n          [id]=\"'piece-complementaire-precision-prejudice-adder-' + pieceComplementairePrecisionPrejudice?.length + 1\"\n          label=\"Pièce complémentaire n°{{pieceComplementairePrecisionPrejudice?.length + 1}}\"\n          [required]=\"showPrecisionPrejudiceSection && pieceComplementairePrecisionPrejudice?.length === 0\"\n          (fileChange)=\"onPieceComplementairePrecisionPrejudiceAdd($event)\"\n          [url]=\"uploadUrl\"\n          *ngIf=\"pieceComplementairePrecisionPrejudice?.length < maxNumberJointsComplementaryPieces - \n          depotRequeteState.reclamationPrealablesAFusioner?.length\"\n          #piecePrecisionPrejudiceAdder>\n        </jhi-file-uploader>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- ORIGINE PREJUDICE -->\n<jhi-section class=\"col-12\" [state]=\"sections.originePrejudiceSection\" *ngIf=\"showOriginePrejudiceSection\">\n  <ng-template #header>\n    <h2>Expliquez le lien entre la situation anormale ou la faute de l'administration subie et le préjudice dont vous avez souffert\n      <span class=\"danger-hint\">*</span>\n    </h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p>La faute peut résulter d'une action ou d'une inaction de l'administration.</p>\n        <p class=\"exp\">\n          Exemples :\n          « C'est uniquement parce que l'administration n'a pas réparé le trou présent sur la chaussée et ne\n          l'a pas indiqué que je suis tombée et me suis cassée la jambe. », « Je suis allée à l'hôpital et j'ai\n          attrapé une infection nosocomiale alors qu'à mon arrivée je n'avais rien. », etc.\n        </p>\n      </div>\n      <textarea\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        id=\"origine-prejudice\"\n        name=\"origine-prejudice\"\n        maxlength=\"1000\"\n        [(ngModel)]=\"contentieuxSocial.originePrejudice\"\n        (change)=\"onContentieuxSocialChange()\"\n        [required]=\"showOriginePrejudiceSection\"\n        jhiWhitespace\n        aria-describedby=\"errorMessageOriginePrejudice\"\n        tabindex=\"0\"\n        #oriP=\"ngModel\">\n      </textarea>\n      <div class=\"char-counter\">\n        {{contentieuxSocial.originePrejudice? contentieuxSocial.originePrejudice.length : 0}} / 1000 caractères\n      </div>\n      <div id=\"errorMessageOriginePrejudice\" class=\"error-msg\">\n        <div\n          *ngIf=\"(oriP.touched && oriP.hasError('required')) ||\n          indemnisationOriginePrejudiceFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez démontrer la faute de l'administration ou une situation anormale.\n        </div>\n        <div\n          *ngIf=\"oriP.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un caractère.\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- CONCLUSION INDEMNISATION -->\n<jhi-section class=\"col-12\" [state]=\"sections.conclusionIndemnisationSection\" *ngIf=\"showConclusionIndemnisationSection\">\n  <ng-template #header>\n    <h2>Conclusion\n    </h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"form-check\">\n        <input\n            type=\"checkbox\"\n            class=\"form-check-input\"\n            name=\"conclusion-indemnisation-condamner-admin-checkbox\"\n            id=\"conclusion-indemnisation-condamner-admin-checkbox\"\n            [(ngModel)]=\"contentieuxSocial.conclusionIndemnisationCondamnerAdmin\"\n            (change)=\"onContentieuxSocialChange()\"\n            aria-describedby=\"errorMessageConclusionIndemnisationCondamnerAdmin\"\n            [required]=\"showConclusionIndemnisationSection\"\n            #conclusionIndemCA=\"ngModel\">\n        <label class=\"form-check-label lb_clickable\" for=\"conclusion-reclamer-somme-condamner-admin-checkbox\">\n          Je demande au juge de condamner l'administration au paiement de la somme de : <span class=\"danger-hint\">*</span>\n        </label>\n      </div>\n      <div id=\"errorMessageConclusionIndemnisationCondamnerAdmin\"\n          *ngIf=\"(conclusionIndemCA.touched && conclusionIndemCA.invalid) ||\n          indemnisationConclusionIndemnisationCondamnerAdminFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez cocher cette case.\n      </div>\n      <div class=\"input-group mb-3 montant-du-montant\" aria-describedby=\"errorMessageConclusionIndemnisationMontant\">\n        <input\n        id=\"conclusion-indemnisation-montant\"\n        class=\"form-control required focus-outline\"\n        [ngClass]=\"{invalid: isInvalid, valid: isValid, required: isRequired}\"\n        type=\"number\"\n        name=\"conclusion-indemnisation-montant\"\n        [(ngModel)]=\"contentieuxSocial.conclusionIndemnisationMontant\"\n        [required]=\"showConclusionIndemnisationSection\"\n        aria-describedby=\"montant-currency-symble\"\n        tabindex=\"0\"\n        #conclusionIndemMontant=\"ngModel\"\n        />\n        <span class=\"input-group-text\" id=\"montant-currency-symble\">€</span>\n      </div>\n      <div id=\"errorMessageConclusionIndemnisationMontant\" class=\"error-msg\">\n        <div\n          *ngIf=\"(conclusionIndemMontant.touched && conclusionIndemMontant.hasError('required')) ||\n          indemnisationConclusionIndemnisationMontantFilled()\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, veuillez saisir le montant.\n        </div>\n        <div\n          *ngIf=\"conclusionIndemMontant.hasError('invalid-whitespace')\"\n          class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n          Pour poursuivre, vous devez saisir au moins un chiffre.\n        </div>\n      </div>\n      <div class=\"form-check\">\n        <input\n            type=\"checkbox\"\n            class=\"form-check-input\"\n            name=\"conclusion-indemnisation-majoree-checkbox\"\n            id=\"conclusion-indemnisation-majoree-checkbox\"\n            [(ngModel)]=\"contentieuxSocial.conclusionIndemnisationMajoree\"\n            (change)=\"onContentieuxSocialChange()\"\n          >\n        <label class=\"form-check-label lb_clickable\" for=\"conclusion-indemnisation-majoree-checkbox\">\n          Je demande à ce que cette somme soit majorée des intérêts de droit.\n        </label>\n      </div>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- ~~~~~~~~~~~FIN INDEMNISATION~~~~~~~~~~~~ -->\n\n<!-- DEPOT REQUETE REDIGEE -->\n<jhi-section class=\"col-12\" [state]=\"sections.depotRequeteRedigee\" *ngIf=\"showRequeteRedigeeSection\">\n  <ng-template #header>\n    <h2>Déposez votre requête rédigée</h2>\n  </ng-template>\n  <ng-template #content>\n    <div>\n      <jhi-file-uploader\n          inputName=\"requeteRedigee\"\n          [id]=\"'requeteRedigee'\"\n          label=\"Requête rédigée\"\n          [file]=\"depotRequeteState.requete?.fileModel\"\n          [required]=\"showRequeteRedigeeSection\"\n          [url]=\"uploadUrl\"\n          (fileChange)=\"onRequeteRedigeeChange($event)\"\n      ></jhi-file-uploader>\n    </div>\n  </ng-template>\n</jhi-section>\n\n<!-- REQUETE REDIGEE JUSTIFICATIFS-->\n<jhi-section class=\"col-12\" [state]=\"sections.requeteRedigeeJustificatifs\" *ngIf=\"showRequeteRedigeeJustificatifsSection\">\n  <ng-template #header>\n    <h2>Joignez tous justificatifs utiles</h2>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"cs-section\">\n      <div class=\"explication\">\n        <p>\n          Vous pouvez déposer ici tous documents qui appuient directement votre demande et qui permettent\n          d'éclairer le juge\n        </p>\n        <p class=\"exp\">\n          Exemples : relevé de pointage, itinéraire entre mon domicile et l'école de mon enfant,\n          justificatif de travail, attestation de témoin, reconnaissance de dettes, certificats médicaux, etc.\n        </p>\n      </div>\n      <div\n          dragula=\"piecesComplementairesBagRequeteRedigeeJustificatifs\"\n          [dragulaModel]=\"pieceComplementaireRequeteRedigeeJust\"\n        >\n          <div\n            class=\"row no-gutters\"\n            *ngFor=\"\n            let pieceRRJ of pieceComplementaireRequeteRedigeeJust;\n            let idx = index;\n            trackBy: trackByFileApiId\">\n              <div\n                class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n                tabindex=\"0\"\n                [id]=\"trackByFileApiId(idx, pieceRRJ)\"\n                role=\"button\"\n                aria-label=\"déplacer ce fichier\"\n                jhiA11yDragNDropDirective\n                [index]=\"idx\"\n                [piece]=\"pieceRRJ\"\n                [selectedItem]=\"selectedItemRRJ\"\n                (a11ySelect)=\"onSelectRequeteRedigeeJust($event)\"\n                (a11yMoveup)=\"onMoveup($event, pieceComplementaireRequeteRedigeeJust)\"\n                (a11yMovedown)=\"onMovedown($event, pieceComplementaireRequeteRedigeeJust)\"\n                (a11yEscape)=\"onEscapeRequeteRedigeeJust($event)\">\n                <i\n                  class=\"fa fa-arrows fa-2x\"\n                  aria-hidden=\"true\"\n                  title=\"déplacer ce fichier\"\n                ></i>\n              </div>\n              <div class=\"col-lg-11 col-12\">\n                <div class=\"d-lg-none text-center\">\n                  <button\n                    type=\"button\"\n                    (click)=\"moveUp(idx, pieceComplementaireRequeteRedigeeJust)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-up\"\n                      aria-hidden=\"true\"\n                      title=\"déplacer ce fichier vers le haut\"\n                    ></i>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                  </button>\n                  <button\n                    type=\"button\"\n                    (click)=\"moveDown(idx, pieceComplementaireRequeteRedigeeJust)\"\n                    class=\"btn btn-outline mx-3\">\n                    <i\n                      class=\"fa fa-arrow-down\"\n                      aria-hidden=\"true\"\n                      title=\"descendre ce fichier\"\n                    ></i>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                  </button>\n                </div>\n                <jhi-file-uploader\n                  inputName=\"piece-{{ pieceRRJ.fileModel.fileApiId }}\"\n                  [id]=\"'piece-complementaire-requete-redigee-just-' + idx + 1\"\n                  label=\"Pièce complémentaire n°{{ idx + 1 }}\"\n                  [file]=\"pieceRRJ.fileModel\"\n                  [url]=\"uploadUrl\"\n                  (fileChange)=\"onPieceComplementaireDelete(idx, $event, pieceComplementaireRequeteRedigeeJust)\">\n                </jhi-file-uploader>\n                <div class=\"form-group required name\">\n                  <label\n                    [class.has-value]=\"renameInputRRJ.value\"\n                    class=\"nommer-piece-label\">Nommer la pièce n°{{ idx + 1 }}\n                  </label>\n                  <div class=\"input-group\">\n                    <input\n                      [attr.aria-label]=\"pieceRRJ.libelle\"\n                      type=\"text\"\n                      class=\"form-control\"\n                      name=\"piece-{{pieceRRJ.fileModel.fileApiId}}-name\"\n                      [required]=\"showRequeteRedigeeJustificatifsSection && pieceRRJ\"\n                      jhiWhitespace\n                      aria-describedby=\"errorMessagePieceComplementaireRequeteRedigeeJust\"\n                      [(ngModel)]=\"pieceRRJ.libelle\"\n                      (ngModelChange)=\"checkLengthForFileName($event, pieceRRJ)\"\n                      #renameInputRRJ=\"ngModel\"\n                    />\n                  </div>\n                </div>\n                <div\n                  *ngIf=\"showLengthWarningForFileName\"\n                  role=\"alert\"\n                  class=\"alert alert-warning alert-secondary\">\n                  <div\n                    jhiTranslate=\"entity.warning.maxlength\"\n                    translateValues=\"{actualLength: {{actualFileNameLength}}, max: {{maxFileNameWithoutExtensionLength}}}\">\n                  </div>\n                </div>\n                <div id=\"errorMessagePieceComplementaireRequeteRedigeeJust\" class=\"error-msg\">\n                  <div\n                    *ngIf=\"(renameInputRRJ.touched ||\n                    !requeteRedigeePieceComplementaireLebelleFilled.requeteRedigeePCLibelle) && !renameInputRRJ.value\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez nommer cette pièce complémentaire\n                  </div>\n                  <div\n                    *ngIf=\"renameInputRRJ.value && renameInputRRJ.value.trim() === ''\"\n                    class=\"alert alert-danger alert-secondary cs-alert\" role=\"alert\">\n                    Pour passer à l'étape suivante, vous devez utiliser au moins un caractère\n                  </div>\n                </div>\n              </div>\n          </div>\n        </div>\n        <jhi-file-uploader\n          inputName=\"piece-requete-redigee-just-adder\"\n          [id]=\"'piece-complementaire-requete-redigee-just-adder-' + pieceComplementaireRequeteRedigeeJust.length + 1\"\n          label=\"Pièce complémentaire n°{{pieceComplementaireRequeteRedigeeJust.length + 1}}\"\n          (fileChange)=\"onPieceComplementaireRequeteRedigeeJustAdd($event)\"\n          [url]=\"uploadUrl\"\n          *ngIf=\"pieceComplementaireRequeteRedigeeJust.length < maxNumberJointsComplementaryPieces - \n          depotRequeteState.acteAttaquesAFusioner?.length - depotRequeteState.reclamationPrealablesAFusioner?.length\"\n          #pieceRequeteRedigeeJustAdder>\n        </jhi-file-uploader>\n    </div>\n  </ng-template>\n</jhi-section>\n\n\n<ng-template #litigeModal let-c=\"close\" let-d=\"dismiss\">\n  <div class=\"modal-content\"\n       aria-modal=\"true\"\n       role=\"alertdialog\"\n       aria-labelledby=\"alert_dialog_notif_label\"\n       aria-describedby=\"alert_dialog_notif_desc\"\n       jhiTrapFocus>\n      <div class=\"modal-header\">\n          <h4 class=\"modal-title\" id=\"alert_dialog_notif_label\">Quel type de litige vous concerne ?</h4>\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Quitter')\">\n              <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n              <span class=\"sr-only\">Fermer la fenêtre</span>\n          </button>\n      </div>\n      <div class=\"modal-body\">\n          <ul>\n            <li>\n              <span class=\"litige-modal-content\">Un litige lié à une décision prise par l'administration : </span>\n              si vous n'êtes pas satisfait(e) de la décision prise par l'administration, vous pouvez la contester devant le juge\n              <div class=\"explication\">\n                <p class=\"exp\">\n                  Exemples : contestation d'une décision d'affectation dans une école, contestation d'un refus de titre de séjour,\n                  contestation d'une évaluation professionnelle, etc.\n                </p>\n              </div>\n            </li>\n            <li>\n              <span class=\"litige-modal-content\">Un litige lié à une somme d'argent : </span>\n              vous n'êtes pas d'accord avec le montant que l'administration vous réclame ou vous estimez que l'administration vous doit\n              une somme d'argent\n              <div class=\"explication\">\n                <p class=\"exp\">\n                  Exemples : contestation d'un avis d'imposition, demande d'indemnisation pour faute d'un hôpital, contestation d'une\n                  facture d'un hôpital, contestation de frais de cantine, etc.\n                </p>\n              </div>\n\n            </li>\n          </ul>\n      </div>\n      <div class=\"modal-footer footer-centered btn-group\">\n          <jhi-button (onClick)=\"c('Confirmer')\" confirmation>\n              OK\n          </jhi-button>\n      </div>\n  </div>\n</ng-template>\n\n<ng-template #litigeExempteAvocatModal let-c=\"close\" let-d=\"dismiss\">\n  <div class=\"modal-content\"\n       aria-modal=\"true\"\n       role=\"alertdialog\"\n       aria-labelledby=\"alert_dialog_notif_label\"\n       aria-describedby=\"alert_dialog_notif_desc\"\n       jhiTrapFocus>\n      <div class=\"modal-header\">\n          <h4 class=\"modal-title\" id=\"alert_dialog_notif_label\">Précisions concernant les litiges exemptés d'avocat</h4>\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Quitter')\">\n              <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n              <span class=\"sr-only\">Fermer la fenêtre</span>\n          </button>\n      </div>\n      <div class=\"modal-body\">\n          <ul>\n            <li class=\"list-cs\">Une décision pour sanctionner les atteintes portées au domaine public\n              <div class=\"explication\">\n                <p class=\"exp\">\n                  Exemple : déversement de produits chimiques dans une rivière / un fleuve\n                </p>\n              </div>\n            </li>\n            <li class=\"list-cs\">Une décision d'ordre individuel concernant les fonctionnaires, agents publics, agents de l'État\n              <div class=\"explication\">\n                <p class=\"exp\">\n                  Exemples : décisions relatives aux rémunérations, aux heures supplémentaires, astreintes, etc.\n                </p>\n              </div>\n            </li>\n            <li class=\"list-cs\">Une demande d'exécution d'un jugement définitif : vous avez obtenu gain de cause auprès du juge mais\n              le délai d'appel est passé et l'administration n'a pas exécuté la décision\n            </li>\n          </ul>\n      </div>\n      <div class=\"modal-footer footer-centered btn-group\">\n          <jhi-button (onClick)=\"c('Confirmer')\" confirmation>\n              OK\n          </jhi-button>\n      </div>\n  </div>\n</ng-template>\n\n<ng-template #rapoModal let-c=\"close\" let-d=\"dismiss\">\n  <div class=\"modal-content\"\n       aria-modal=\"true\"\n       role=\"alertdialog\"\n       aria-labelledby=\"alert_dialog_notif_label\"\n       aria-describedby=\"alert_dialog_notif_desc\"\n       jhiTrapFocus>\n      <div class=\"modal-header\">\n          <h4 class=\"modal-title\" id=\"alert_dialog_notif_label\">Recours administratif préalable obligatoire (RAPO)</h4>\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Quitter')\">\n              <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n              <span class=\"sr-only\">Fermer la fenêtre</span>\n          </button>\n      </div>\n      <div class=\"modal-body\">\n          <p><b>Le Rapo est obligatoire pour les contentieux sociaux suivants :</b></p>\n          <ul>\n            <li>Une remise gracieuse (remise de dette)</li>\n            <li>Le revenu de solidarité active (RSA), la prime d'activité ou prime de Noël</li>\n            <li>L'aide personnalisée au logement (APL), l'allocation de logement familiale (ALF) ou sociale (ALS)</li>\n            <li>Une demande liée à la carte mobilité inclusion</li>\n            <li>L'orientation et la reconnaissance de la qualité du travailleur handicapé</li>\n            <li>Une demande liée à France Travail (anciennement Pôle Emploi)</li>\n            <li>Une aide médicale de l'État</li>\n          </ul>\n          <p>Le RAPO peut être effectué par écrit, par mail ou sur le site de l'administration concernée.\n            Vous retrouverez sur <b>la décision attaquée</b> les moyens d'envoi et les délais acceptés par l'administration.\n          </p>\n          <p>Dans ce recours vous devez expliquer les raisons de droit et de faits qui vous conduisent à contester la décision\n            et joindre une copie de la décision contestée ainsi que tous les documents que vous jugez utiles.\n          </p>\n          <p>Conservez une copie du recours, des pièces jointes, et les justificatifs de leur envoi et de leur bonne réception par l'administration.</p>\n      </div>\n  </div>\n</ng-template>\n"

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "<div dragula=\"reclamationPrealableBag\" [dragulaModel]=\"reclamationPrealables\">\n    <div class=\"row no-gutters\"\n        *ngFor=\"let piece of reclamationPrealables; let i = index; trackBy: trackByFileApiId\">\n        <div class=\"d-none d-lg-block col-lg-1 align-self-center text-center py-1\"\n             tabindex=\"0\" [id]=\"trackByFileApiId(i, piece)\" role=\"button\" aria-label=\"déplacer ce fichier\"\n             jhiA11yDragNDropDirective [index]=\"i\" [piece]=\"piece\" [selectedItem]=\"selectedItem\"\n             (a11ySelect)=\"onSelect($event)\" (a11yMoveup)=\"onMoveup($event)\"\n             (a11yMovedown)=\"onMovedown($event)\" (a11yEscape)=\"onEscape($event)\">\n            <span class=\"fa fa-arrows fa-2x\" aria-hidden=\"true\"></span>\n        </div>\n        <div class=\"col-lg-11 col-12\">\n            <div class=\"d-lg-none text-center \">\n                <button type=\"button\" (click)=\"moveUp(i)\" class=\"btn btn-outline mx-3\">\n                    <span class=\"fa fa-arrow-up\" aria-hidden=\"true\" title=\"déplacer ce fichier vers le haut\"></span>\n                    <span class=\"sr-only\">déplacer ce fichier vers le haut</span>\n                </button>\n                <button type=\"button\" (click)=\"moveDown(i)\" class=\"btn btn-outline mx-3\">\n                    <span class=\"fa fa-arrow-down\" aria-hidden=\"true\" title=\"descendre ce fichier\"></span>\n                    <span class=\"sr-only\">descendre ce fichier</span>\n                </button>\n            </div>\n            <jhi-file-uploader inputName=\"piece-{{piece.fileModel.fileApiId}}\" label=\"Réclamation préalable - document {{i + 1}}\"\n                [file]=\"piece.fileModel\"\n                [id]=\"'reclamation-prealable-piece-'+ i + 1\"\n                [url]=\"uploadUrl\"\n                (fileChange)=\"onReclamationPrealableDelete(i, $event)\">\n            </jhi-file-uploader>\n        </div>\n    </div>\n</div>\n<jhi-file-uploader inputName=\"reclamation-prealable-piece-adder\"\n    label=\"Réclamation préalable - document {{reclamationPrealables.length + 1}}\"\n    [id]=\"'reclamation-prealable-document-' + reclamationPrealables.length + 1\"\n    (fileChange)=\"onReclamationPrealableAdd($event)\"\n    [required]=\"required && reclamationPrealables.length === 0\"\n    [url]=\"uploadUrl\"\n    *ngIf=\"reclamationPrealables.length < maxReclamationPrealablesForMerge\" #reclamationPrealablesAdder>\n</jhi-file-uploader>\n"

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"juridictionAutoSaveSuccess\">\n    <jhi-alert></jhi-alert>\n</div>\n\n<div class=\"col-12\">\n    <p role=\"alert\" class=\"alert alert-warning\">\n        Formats acceptés : PDF, DOC, DOCX, ODT, RTF, GIF, JPG et PNG.<br />\n        Les documents qui ne sont pas en PDF sont automatiquement convertis dans\n        ce format.<br />\n        Taille maximale par fichier : {{ maxFileSize | formatFileSize }}.\n    </p>\n    <p class=\"obligatoire-hint\">Les champs marqués d'un astérisque <span class=\"danger-hint\">*</span> sont obligatoires</p>\n</div>\n\n<form class=\"col-12\" novalidate>\n    <!-- Type Requête -->\n    <jhi-urgence-requete-section\n        name=\"urgence-requete\"\n        class=\"urgence-requete\"\n        [depotRequeteState]=\"depotRequeteState\"\n        [showErrorMessageUrgenceRequete]=\"showErrorMessageUrgenceRequete\"\n        [(ngModel)]=\"depotRequeteState.urgenceRequete\"\n        [urgenceRequeteChampsObligatoireFilled]=\"urgenceRequeteChampsObligatoireFilled\"\n        (onConcernCSDALOChange)=\"updateState($event)\"\n        (onUrgenceRequeteChangeEvt)=\"updateURState($event)\"\n        required\n    >\n    </jhi-urgence-requete-section>\n\n    <!-- requête des contentieux sociaux --> <!-- *ngIf=\"displayContentieuxSocialSection()\" -->\n    <!-- required -->\n    <ng-container > \n        <jhi-contentieux-social-section\n            id=\"contentieux-social\"\n            name=\"contentieux-social\"\n            class=\"contentieux-social\"\n            [depotRequeteState]=\"depotRequeteState\"\n            [(ngModel)]=\"depotRequeteState.requeteCS\"\n            [sociauxDALOChampsObligatoiresFilled]=\"sociauxDALOChampsObligatoiresFilled\"\n            [litigeLieDecisionChampsObligatoiresFilled]=\"litigeLieDecisionChampsObligatoiresFilled\"\n            [reclamerUneSommeChampsObligatoiresFilled]=\"reclamerUneSommeChampsObligatoiresFilled\"\n            [contesterUneSommeChampsObligatoiresFilled]=\"contesterUneSommeChampsObligatoiresFilled\"\n            [indemnisationChampsObligatoiresFilled]=\"indemnisationChampsObligatoiresFilled\"\n            [requeteRedigeePieceComplementaireLebelleFilled]=\"requeteRedigeePieceComplementaireLebelleFilled\"\n            >\n        </jhi-contentieux-social-section>\n    </ng-container>\n</form>\n\n<!-- Alert -->\n<div *ngIf=\"saveDraftSuccess || saveDraftError\">\n    <jhi-alert></jhi-alert>\n</div>\n<div role=\"alert\" class=\"alert alert-warning alert-dismissible\" *ngIf=\"autoSaveError\">\n    <button type=\"button\" class=\"close\" aria-label=\"Fermer\" (click)=\"close()\">\n        <span aria-hidden=\"true\">&times;</span>\n    </button>\n    <span>Nous n'avons pas pu effectuer de sauvegarde automatique de votre requête. Vous pouvez tenter de \n        <a href=\"javascript:void(0);\" class=\"restart-request\" (click)=\"saveDraftAgain()\">sauvegarder à nouveau</a>\n        ou <a class=\"restart-request\" href=\"#/depot-requete/avertissement\">recommencer au début.</a></span>\n</div>\n\n<!-- Buttons -->\n<div class=\"col-12 btn-group\">\n    <jhi-previous-button\n        [label]=\"'Page précédente - Juridiction'\"\n        [clickHandler]=\"previous.bind(this)\"\n    ></jhi-previous-button>\n    <jhi-save-draft-requete-button\n        [isDisabled]=\"!depotRequeteState.urgenceRequete && !depotRequeteState.concernContentieuxSocial\"\n        [clickHandler]=\"saveDraft.bind(this)\"\n    ></jhi-save-draft-requete-button>\n    <jhi-next-button\n        [label]=\"'Page suivante - Justificatifs'\"\n        [clickHandler]=\"next.bind(this)\"\n    ></jhi-next-button>\n</div>\n"

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "<input\n    type=\"text\"\n    name=\"urgence-requete-hidden\"\n    [(ngModel)]=\"urgenceRequete\"\n    hidden\n/>\n<jhi-section class=\"col-12\" [state]=\"state\">\n  <ng-template #header>\n    <h2>Indiquez le type de procédure</h2>\n  </ng-template>\n  <ng-template #help>\n    <div class=\"explication col-12\">\n      <strong>Vous hésitez ?</strong>\n      <p class=\"mt-2\">Consultez\n        <a routerLink=\"/faq\" [queryParams]=\"{ category: urgenceRequeteFaqCategoryId }\" target=\"_blank\">\n        nos explications</a> concernant les types de procédures possibles.\n      </p>\n    </div>\n  </ng-template>\n  <ng-template #content>\n    <div class=\"form-group\" [ngClass]=\"{ invalid: isInvalid, valid: isValid, required: isRequired }\">\n      <label for=\"urgence-requete-id\" class=\"has-value\">Veuillez sélectionner un type de procédure</label>\n      <select\n          name=\"urgence-requete-id\"\n          class=\"custom-select focus-outline\"\n          id=\"urgence-requete-id\"\n          [(ngModel)]=\"urgenceRequeteId\"\n          (ngModelChange)=\"onUrgenceRequeteChange($event)\"\n          required\n          aria-describedby=\"errorMessageUrgenceRequete\"\n          #ur=\"ngModel\"\n      >\n        <option hidden [value]=\"undefined\">\n          Choisir un type de procédure\n        </option>\n        <option *ngFor=\"let urgenceRequete of filteredUrgencesRequete\" [value]=\"urgenceRequete.id\">\n          {{ urgenceRequete.libelle }}\n        </option>\n      </select>\n    </div>\n    <div role=\"alert\"\n      *ngIf=\"showErrorMessageUrgenceRequete && urgenceRequeteId == null\"\n      class=\"alert alert-danger alert-secondary\" id=\"errorMessageUrgenceRequete\">\n      Pour continuer, merci de sélectionner un type de procédure.\n    </div>\n    <div class=\"alert alert-danger alert-secondary\">\n      <p class=\"refere-alert-msg\">Attention, un référé concerne uniquement les situations d'urgence, vous mettant en difficulté de\n        <span class=\"refere-alert\">manière grave et immédiate</span>.\n      </p>\n    </div>\n  </ng-template>\n</jhi-section>\n<jhi-section class=\"col-12\" [state]=\"stateDalo\"\n  *ngIf=\"depotRequeteState.typeJuridiction?.code !== 'CE' && depotRequeteState.urgenceRequete?.codeUrgence === 0\">\n  <ng-template #header>\n    <h2>Votre requête concerne-t-elle un contentieux social ou un contentieux DALO ? <span class=\"danger-hint\">*</span></h2>\n  </ng-template>\n  <ng-template #content>\n    <p class=\"explication col-12 exp\">\n      Exemple : APL, RSA, listes des demandeurs d'emploi, etc. et le Droit au logement opposable. <button class=\"dalo-btn\" (click)=\"openWarningModal(typeDemandeModal)\">Plus d'exemples</button>\n    </p>\n    <div class=\"form-check\" [ngClass]=\"{ invalid: isInvalid, valid: isValid, required: isRequired }\">\n      <input\n        class=\"form-check-input\"\n        type=\"radio\"\n        name=\"contentieux-social-requete\"\n        id=\"csr-oui\"\n        aria-describedby=\"error-msg-concern-cs-dalo\"\n        [(ngModel)]=\"depotRequeteState.concernContentieuxSocial\"\n        [value]=\"true\"\n        (ngModelChange)=\"onConcernCSChange($event)\"\n        (click)=\"openWarningModal(warningModal)\"\n        required\n      />\n      <label class=\"form-check-label\" for=\"csr-oui\">Oui</label>\n    </div>\n    <div class=\"form-check\" [ngClass]=\"{ invalid: isInvalid, valid: isValid, required: isRequired }\">\n      <input\n        class=\"form-check-input\"\n        type=\"radio\"\n        name=\"contentieux-social-requete\"\n        id=\"csr-non\"\n        aria-describedby=\"error-msg-concern-cs-dalo\"\n        [(ngModel)]=\"depotRequeteState.concernContentieuxSocial\"\n        (ngModelChange)=\"onConcernCSChange($event)\"\n        [value]=\"false\"\n        required\n        />\n      <label class=\"form-check-label\" for=\"csr-non\">Non</label>\n    </div>\n    <div role=\"alert\" id=\"error-msg-concern-cs-dalo\"\n      *ngIf=\"!urgenceRequeteChampsObligatoireFilled.concernContentieuxSocial && depotRequeteState.concernContentieuxSocial == null\" \n      class=\"alert alert-danger alert-secondary cs-alert\">\n      Vous devez préciser si votre requête concerne-t-elle un contentieux social ou un contentieux DALO.\n    </div>\n  </ng-template>\n</jhi-section>\n\n<ng-template #warningModal let-c=\"close\" let-d=\"dismiss\">\n  <div class=\"modal-content\"\n       aria-modal=\"true\"\n       role=\"alertdialog\"\n       aria-labelledby=\"alert_dialog_notif_label\"\n       aria-describedby=\"alert_dialog_notif_desc\"\n       jhiTrapFocus>\n      <div class=\"modal-header\">\n          <h4 class=\"modal-title\" id=\"alert_dialog_notif_label\">Avertissement</h4>\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Quitter')\">\n              <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n              <span class=\"sr-only\">Fermer la fenêtre</span>\n          </button>\n      </div>\n      <div class=\"modal-body\">\n          <ul>\n            <li>Attention votre requête doit concerner APL, RSA, listes des demandeurs d’emploi, retour à l’emploi,…</li>\n            <li>\n              Avant de déposer votre demande, vous devez présenter un recours administratif préalable obligatoire (RAPO) notamment pour les contestations relatives au Revenu de Solidarité Active (RSA) ; à l’Aide Personnalisée au Logement (APL) ; aux décisions de suppression de l’aide de retour à l’emploi ; aux décisions d’inscription de la liste des demandeurs d’emplois.\n            </li>\n          </ul>\n      </div>\n      <div class=\"modal-footer footer-centered btn-group\">\n          <jhi-button (onClick)=\"c('Confirmer')\" confirmation>\n              OK\n          </jhi-button>\n      </div>\n  </div>\n</ng-template>\n\n<ng-template #typeDemandeModal let-c=\"close\" let-d=\"dismiss\">\n  <div class=\"modal-content\"\n       aria-modal=\"true\"\n       role=\"alertdialog\"\n       aria-labelledby=\"alert_dialog_notif_label\"\n       aria-describedby=\"alert_dialog_notif_desc\"\n       jhiTrapFocus>\n      <div class=\"modal-header\">\n          <h4 class=\"modal-title\" id=\"alert_dialog_notif_label\">Quelles sont les types de demandes concernées ?</h4>\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Quitter')\">\n              <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n              <span class=\"sr-only\">Fermer la fenêtre</span>\n          </button>\n      </div>\n      <div class=\"modal-body\">\n          <ol>\n            <li><span class=\"cas-cs\">Les cas contentieux sociaux :</span>\n              <ul class=\"cas-cs-sublist\">\n                <li class=\"list-cs\">Remise gracieuse,</li>\n                <li class=\"list-cs\">RSA - Revenu de solidarité active,</li>\n                <li class=\"list-cs\">APL - Aide personnalisée au logement et autres aides au logement,</li>\n                <li class=\"list-cs\">Carte mobilité inclusion,</li>\n                <li class=\"list-cs\">Orientation du travailleur handicapé,</li>\n                <li class=\"list-cs\">Reconnaissance de la qualité de travailleur handicapé,</li>\n                <li class=\"list-cs\">Indu et contrainte Pôle emploi,</li>\n                <li class=\"list-cs\">Radiation de la liste des demandeurs d'emploi,</li>\n                <li class=\"list-cs\">Autres décisions de Pôle emploi,</li>\n                <li class=\"list-cs\">Aide médicale de l'État,</li>\n                <li class=\"list-cs\">etc.</li>\n              </ul>\n            </li>\n            <li>\n              <span class=\"cas-cs\">Le droit au logement opposable - DALO</span>\n            </li>\n          </ol>\n      </div>\n      <div class=\"modal-footer footer-centered btn-group\">\n          <jhi-button (onClick)=\"c('Confirmer')\" confirmation>\n              OK\n          </jhi-button>\n      </div>\n  </div>\n</ng-template>\n"

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "<h3 class=\"faq-category-{{category.id}}\">{{ category.title }}</h3>\n<ng-container *ngFor=\"let item of category.items\">\n    <div class=\"item\">\n        <h4 class=\"faq-category-item-{{item.id}} faq-category-item-rank{{item.rank}}\" [innerHTML]=\"item.question | safeHtml\" id=\"item-{{item.id}}\"></h4>\n        <div [innerHTML]=\"item.answer | safeHtml\"></div> \n    </div>\n        \n    <div class=\"category-item-seperator\"></div>\n</ng-container>\n"

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "<h3 [innerHTML]=\"matchedItem.question | safeHtml\">\n</h3>\n<div class=\"content\">\n    <div [innerHTML]=\"matchedItem.answer | safeHtml\"></div>\n    <div class=\"btn btn-link active\" (click)=\"scrollToCategoryItem()\"> - Lire la suite</div>\n</div>\n<div class=\"highlight-item-seperator\"></div>\n"

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row search-header\">\n    <h1 class=\"col-6\">Recherche</h1>\n    <div class=\"form-group col-6\" role=\"search\">\n        <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n        <label *ngIf=\"!searchText\" for=\"rechercheFiltre\">Rechercher dans la foire aux questions</label>\n        <input id=\"rechercheFiltre\" class=\"form-control focus-outline\" name=\"searchInput\" type=\"text\" [(ngModel)]=\"searchText\" (ngModelChange)=\"getHighLightItems()\">\n        <i class=\"fa fa-remove pointer\" aria-hidden=\"true\" *ngIf=\"searchText\" (click)=\"resetSearch()\"></i>\n    </div>\n</div>\n<div class=\"search-seperator\"></div>\n<div *ngIf=\"searchText\">\n    <h2>Résultat de la recherche: <span *ngIf=\"matchedItems && matchedItems.length === 0\"> aucune information ne correspond à votre recherche</span></h2>\n    <div class=\"row col-12\" *ngIf=\"matchedItems && matchedItems.length > 0\">\n        <jhi-faq-highlight [matchedItem]=\"item\" *ngFor=\"let item of matchedItems\"></jhi-faq-highlight>\n    </div>\n</div>\n"

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "<h2 id=\"faq-summary\">Accès rapide aux thématiques</h2>\n<ul>\n  <li tabindex=\"0\"\n    *ngFor=\"let category of categories\"\n    (click)=\"scrollToCategory(category.id)\"\n    class=\"btn btn-link active\"\n    role=\"button\">\n    {{ category.title }}\n  </li>\n</ul>\n\n"

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n  <jhi-faq-search [categories]=\"faqCategories\"></jhi-faq-search>\n  <h1>Foire aux questions</h1>\n  <jhi-faq-summary [categories]=\"faqCategories\"></jhi-faq-summary>\n\n  <ng-container *ngFor=\"let category of faqCategories\">\n    <jhi-faq-category [category]=\"category\"></jhi-faq-category>\n    <div class=\"category-seperator\"></div>\n  </ng-container>\n    <a id=\"topLink\" class=\"btn btn-light fa fa-angle-up back-to-top\" href=\"#faq-summary\" title=\"Remonter en haut de la page\"\n       tabindex=\"0\" role=\"button\">\n      <span class=\"sr-only\">Remonter en haut de la page</span>\n    </a>\n</div>\n\n"

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "<jhi-trc-admin-config></jhi-trc-admin-config>\n<div class=\"container-fluid\">\n    <div class=\"offset-lg-1 col-lg-10 offset-xl-2 col-xl-8 col-md-12 welcome-block\">\n        <h1 class=\"mb-3 title\">Bienvenue sur Télérecours citoyens</h1>\n        <p>\n            Télérecours citoyens est un portail web qui permet aux particuliers et aux personnes morales de droit privé\n            <a id=\"personnes_morales_asterique\" (click)=\"scroll('personnes_morales_asterique_explication')\" aria-label=\"personnes morales de droit privé\">*</a>\n            (associations, sociétés…) de déposer une requête et d’échanger des documents et des informations avec le\n            Conseil d’État, les cours administratives d’appel et les tribunaux administratifs.\n        </p>\n        <!-- <p class=\"hors-pers-m\">*hors personnes morales de droit privé chargées de la gestion permanente d’un service\n            public.</p> -->\n        <div class=\"btn-group\">\n            <jhi-button class=\"mr-md-3\" icon=\"fa-envelope-o\" buttonLink=\"/rattachement\" outline-secondary>\n                Entrer un code reçu par courrier\n            </jhi-button>\n            <jhi-button icon=\"fa-file-text-o\" (onClick)=\"newRequete()\" iconLeft>\n                Déposer une nouvelle requête\n            </jhi-button>\n        </div>\n        <div *ngIf=\"isErrorDraftMessage\" role=\"alert\" class=\"alert text-danger border border-danger\">\n            <p>\n                <strong>Important</strong><br/>\n                Si vous souhaitez déposer une nouvelle requête, vous devez d’abord supprimer le brouillon de requête en\n                cours.\n            </p>\n        </div>\n        <div *ngIf=\"isDeletedDraftMessage\" role=\"alert\" class=\"alert text-success border border-success\">\n            <p>\n                Votre brouillon a bien été supprimé. Vous pouvez maintenant créer une nouvelle requête si vous le\n                souhaitez.\n            </p>\n        </div>\n\n        <div class=\"section-draft\" *ngIf=\"requete\">\n            <h4 class=\"mb-3\">Vous avez un brouillon en cours</h4>\n            <p>\n                Vous avez <strong>initié la création d'une requête</strong>\n                le {{requete.dateCreation | localDate:'dd MMMM yyyy'}} à\n                {{requete.dateCreation | localDate:'shortTime'}}.\n            </p>\n            <div class=\"container-draft col-12 mt-3\">\n                <div class=\"col-6 draft\">\n                    <p>Souhaitez-vous <strong>reprendre votre brouillon</strong> ?</p>\n                    <div class=\"btn-group\">\n                        <jhi-button icon=\"fa-pencil\"  iconLeft (onClick)=\"goToDraftRequete()\">\n                            Reprendre mon brouillon\n                        </jhi-button>\n                    </div>\n                </div>\n                <div class=\"col-1\">\n                    <div class=\"vertical-line\">\n                        <span>OU</span>\n                    </div>\n                </div>\n                <div class=\"col-5 draft\">\n                    <p>Souhaitez-vous <strong>supprimer votre brouillon</strong> ?</p>\n                    <div class=\"btn-group\">\n                        <jhi-button icon=\"fa-trash\" cancellation (onClick)=\"deleteDraftRequete()\">\n                            Supprimer mon brouillon\n                        </jhi-button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <jhi-mes-dossiers class=\"offset-lg-1 col-lg-10 offset-xl-2 col-xl-8 col-md-12 mes-dossiers\"></jhi-mes-dossiers>\n    <div class=\"offset-lg-1 col-lg-10 offset-xl-2 col-xl-8 col-md-12 hors-pers-m\">\n        <a id=\"personnes_morales_asterique_explication\" (click)=\"scroll('personnes_morales_asterique')\">\n        *hors personnes morales de droit privé chargées de la gestion permanente d’un service public.</a>\n    </div>\n</div>\n"

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports = "<div class=\"offset-md-6 col-md-6 offset-xl-8 col-xl-4 col-sm-12 filter-block\">\n    <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n            <label class=\"input-group-text\" for=\"statutFilter\">Filtre :</label>\n        </div>\n        <select class=\"custom-select filter-block-custom-select focus-outline\"  id=\"statutFilter\"  name=\"statutFilter\" [(ngModel)]=\"statutFilter\" (ngModelChange)=\"applyFilter($event)\">\n            <option [value]=\"'All'\">Tous les dossiers</option>\n            <option [value]=\"'En cours'\">Dossiers en cours</option>\n            <option [value]=\"'Terminé'\">Dossiers terminés</option>\n        </select>\n    </div>\n</div>\n"

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports = "<ng-container *ngIf=\"dataSource$.requetes.length !== 0 || isLoading\">\n    <div id=\"dossier-resume\" >\n        <h2  class=\"row justify-content-center text-center mt-3 title\"> {{ dataSource$.requetes.length > 1 || isLoading\n            ? \"Voir et agir sur mes dossiers\" : \"Voir et agir sur mon dossier\"}}\n        </h2>\n        <jhi-progress-spinner *ngIf=\"isLoading\">Chargement des dossiers en cours</jhi-progress-spinner>\n        <p class=\"row justify-content-center text-center\">\n            {{ isLoading ? \"Chargement des dossiers en cours\" : dataSource$.requetes.length === 1 ?\n                \"Vous pouvez consulter l'historique de votre dossier, \" +\n                \"les communications reçues, et dès son enregistrement effectué, y ajouter de nouvelles pièces. \" :\n                \"Vous pouvez consulter l'historique de vos dossiers, \" +\n                \"les communications reçues, et dès leur enregistrement effectué, y ajouter de nouvelles pièces. \"}}\n        </p>\n    </div>\n</ng-container>\n\n<!-- Display requetes -->\n<div *ngIf=\"!isLoading && !isError && dataSource$.requetes.length !== 0\">\n\n    <jhi-filter-block [statutFilter]=\"statutFilter\" (statusChanges)=\"applyFilter($event)\"></jhi-filter-block>\n\n    <jhi-mobile-sort-block class=\"sort-container\" [sortKey]=\"sortKey\" (sortKeyChanges)=\"adjustSort($event)\"></jhi-mobile-sort-block>\n\n    <cdk-table [dataSource]=\"dataSource$\" id=\"dossier-table\" aria-describedby=\"dossier-resume\" role=\"table\">\n\n        <ng-container cdkColumnDef=\"description\">\n            <cdk-header-cell *cdkHeaderCellDef (click)=\"adjustSort('description')\" class=\"cdk-header-cell-1\">\n                <jhi-sort-status [sortKey]=\"dataSource$.sortKey$.value\" [sortDirection]=\"dataSource$.sortDirection$.value\" [cellKey]=\"'description'\"></jhi-sort-status>\n                Dossier\n            </cdk-header-cell>\n            <cdk-cell *cdkCellDef=\"let dossier\" (click)=\"$event.stopPropagation()\" class=\"cdk-cell-1\">\n                <h4 class=\"header-cell-small\">Dossier</h4>\n                <jhi-numero-dossier [dossier]=\"dossier\"></jhi-numero-dossier>\n            </cdk-cell>\n        </ng-container>\n\n        <ng-container cdkColumnDef=\"juridiction\">\n            <cdk-header-cell *cdkHeaderCellDef (click)=\"adjustSort('juridiction')\" class=\"cdk-header-cell-2\">\n                <jhi-sort-status [sortKey]=\"dataSource$.sortKey$.value\" [sortDirection]=\"dataSource$.sortDirection$.value\" [cellKey]=\"'juridiction'\"></jhi-sort-status>\n                Juridiction\n            </cdk-header-cell>\n            <cdk-cell *cdkCellDef=\"let dossier\" class=\"cdk-cell-2\">\n                <h4 class=\"header-cell-small\">Juridiction</h4>\n                {{dossier.juridiction}}\n            </cdk-cell>\n        </ng-container>\n\n        <ng-container cdkColumnDef=\"statut\">\n            <cdk-header-cell *cdkHeaderCellDef (click)=\"adjustSort('statut')\" class=\"cdk-header-cell-3\">\n                <jhi-sort-status [sortKey]=\"dataSource$.sortKey$.value\" [sortDirection]=\"dataSource$.sortDirection$.value\" [cellKey]=\"'statut'\"></jhi-sort-status>\n                ÉTAT\n            </cdk-header-cell>\n            <cdk-cell *cdkCellDef=\"let dossier\" class=\"cdk-cell-3\">\n                <h4 class=\"header-cell-small\">ÉTAT</h4>\n                <div class=\"container\">\n                    <div class=\"status-text\">{{dossier.statut}}</div>\n                    <button type=\"button\"\n                        *ngIf=\"dossier.statut === 'En cours d\\'envoi'\"\n                        class=\"btn shadow-none en-cours-denvoi-btn\"\n                        ngbTooltip=\"Votre requête est en cours d'envoi. Si l'état En cours d'envoi persiste pendant plusieurs heures, veuillez contacter le support\"\n                        triggers=\"hover focusin\"\n                        aria-label=\"Votre requête est en cours d'envoi. Si l'état En cours d'envoi persiste pendant plusieurs heures, veuillez contacter le support\"\n                        #t=\"ngbTooltip\"\n\t\t                (focusout)=\"t.close()\"\n                        tabindex=\"0\">\n                        <i class=\"fa fa-exclamation-circle\">\n                            <jhi-abbreviate [text]=\"'aa'\"></jhi-abbreviate>\n                        </i>\n                    </button>\n                </div>\n            </cdk-cell>\n        </ng-container>\n\n        <ng-container cdkColumnDef=\"dateModification\">\n            <cdk-header-cell *cdkHeaderCellDef (click)=\"adjustSort('dateModification')\" class=\"date-maj cdk-header-cell-4\">\n                <jhi-sort-status [sortKey]=\"dataSource$.sortKey$.value\" [sortDirection]=\"dataSource$.sortDirection$.value\" [cellKey]=\"'dateModification'\"></jhi-sort-status>\n                    Date de l'état\n            </cdk-header-cell>\n            <cdk-cell *cdkCellDef=\"let dossier\" class=\"cdk-cell-4\">\n                <h4 class=\"header-cell-small\">Date de l'état</h4>\n                {{dossier.dateModification | localDate:'dd MMMM yyyy'}} à {{dossier.dateModification | localDate:'shortTime'}}\n            </cdk-cell>\n        </ng-container>\n        <ng-container cdkColumnDef=\"actions\">\n            <cdk-header-cell *cdkHeaderCellDef class=\"cdk-header-cell-5\">\n                Actions\n            </cdk-header-cell>\n            <cdk-cell *cdkCellDef=\"let dossier\" class=\"cdk-cell-5 actions\">\n                <button class=\"btn-circle\" (click)=\"openRequete(dossier)\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"Visualiser mon dossier\">\n                    <!-- <span class=\"fa fa-eye\" aria-hidden=\"true\"></span> -->\n                    <span class=\"fa\" [ngClass]=\"{'fa-eye': dossier.statut !== 'Dossier non accessible', 'fa-info': dossier.statut === 'Dossier non accessible'}\" aria-hidden=\"true\"></span>\n                    <span class=\"sr-only\">Visualiser mon dossier</span>\n                </button>\n                <button class=\"btn-circle\" (click)=\"addDocument(dossier)\" data-toggle=\"tooltip\" data-placement=\"right\"\n                    title=\"Ajouter une pièce\" *ngIf=\"displayAddDocumentBtn(dossier) && dossier.statut !== 'Dossier non accessible'\">\n                    <span class=\"fa fa-paperclip\" aria-hidden=\"true\"></span>\n                    <span class=\"sr-only\">Ajouter une pièce</span>\n                </button>\n            </cdk-cell>\n        </ng-container>\n        <cdk-header-row *cdkHeaderRowDef=\"displayedColumns\"></cdk-header-row>\n        <cdk-row *cdkRowDef=\"let dossier; columns: displayedColumns;\"\n                [ngClass]=\"{ 'inactive' : dossier.statut === 'Terminé' || dossier.statut === 'Refusé',  'active' : dossier.statut !== 'Terminé' && dossier.statut !== 'Refusé', 'linked': dossier.isLinked }\">\n        </cdk-row>\n    </cdk-table>\n</div>\n\n<a class=\"btn-avis\" target=\"_blank\"\n   href=\"https://voxusagers.numerique.gouv.fr/Demarches/1972?&view-mode=formulaire-avis&nd_mode=en-ligne-enti%C3%A8rement&nd_source=button&key=0d1ec655cdae6df5d2e5bd3196c251e8\"\n   rel=\"noopener noreferrer\">\n    <img src=\"https://voxusagers.numerique.gouv.fr/static/bouton-blanc.svg\" alt=\"Je donne mon avis\" title=\"Je donne mon avis sur cette démarche\" />\n</a>\n\n<div *ngIf=\"isError\" role=\"alert\" class=\"alert alert-danger\">Une erreur technique s'est produite, veuillez recommencer ultérieurement.</div>\n"

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "<div class=\"offset-md-6 col-md-6 offset-xl-8 col-xl-4 col-sm-12 sort-block\">\n    <div class=\"input-group\">\n        <div class=\"input-group-prepend\">\n            <label class=\"input-group-text\" for=\"sortSelect\">Tri :</label>\n        </div>\n        <select class=\"custom-select\" name=\"sortSelect\" [(ngModel)]=\"sortKey\" (ngModelChange)=\"adjustSort($event)\">\n            <option [value]=\"'description'\">Dossier</option>\n            <option [value]=\"'juridiction'\">Juridiction</option>\n            <option [value]=\"'statut'\">Statut</option>\n            <option [value]=\"'dateMaj'\">Date de l'état</option>\n        </select>\n    </div>\n</div>\n"

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "<ng-container>\n    <div  class=\"d-flex align-items-center\">\n        <span class=\"d-flex mr-3\" *ngIf=\"dossier.numeroRequete || dossier.numeroRequeteProvisoire\">{{ dossier.numeroRequete || dossier.numeroRequeteProvisoire + '*' }}</span>\n        <span class=\"d-flex mr-3\" *ngIf=\"!dossier.numeroRequete && !dossier.numeroRequeteProvisoire\"></span>\n    </div>\n    <div> {{dossier.titre}} </div>\n</ng-container>\n\n"

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container error-container\">\n    <section class=\"row my-4\">\n        <i class=\"icon fa fa-unlink\"></i>\n        <h2 class=\"col-12\">La page recherchée n'a pas été trouvée.</h2>\n        <div class=\"col-md-12 col-lg-6 mb-2\">\n            <button class=\"btn btn-dark btn-block btn-error\" routerLink=\"/\">\n                <i class=\"fa fa-home\" aria-hidden=\"true\"></i>\n                Retourner à l'accueil\n            </button>\n        </div>\n        <div class=\"col-md-12 col-lg-6 mb-2\">\n            <button class=\"btn btn-primary btn-block btn-error\" routerLink=\"/plan-site\">\n                <i class=\"fa fa-sitemap\" aria-hidden=\"true\"></i>\n                Découvrir le plan du site\n            </button>\n        </div>\n    </section>\n</div>\n"

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "<section>\n  <jhi-jumbotron>\n    <h1>Accessibilité</h1>\n  </jhi-jumbotron>\n</section>\n<section class=\"container accessibilite\">\n  <section class=\"declaration\">\n    <h1 class=\"title\">Déclaration d’accessibilité RGAA</h1>\n    <p>\n      Le Conseil d'État s’engage à rendre ses sites internet, intranet, extranet et ses progiciels accessibles\n      (et ses applications mobiles et mobilier urbain numérique) conformément à l’article 47 de la loi n°2005-102\n      du 11 février 2005.<br>\n      Cette déclaration d’accessibilité s’applique à <a class=\"accessibilite-link\" href=\"https://citoyens.telerecours.fr/\">https://citoyens.telerecours.fr/</a>.\n    </p>\n  </section>\n\n  <section>\n    <div class=\"accessibilite-seperator\"></div>\n    <h3 id=\"acces-rapide\" class=\"acces-rapide\">Accès rapide aux thématiques</h3>\n    <ul class=\"link-list\">\n      <li>\n        <a href=\"#etat-de-conformite\">État de conformité</a>\n      </li>\n      <li>\n        <a href=\"#resultats-des-tests\">Résultats des tests</a>\n      </li>\n      <li>\n        <a href=\"#criteres-non-conformes\">Critères non conformes</a>\n      </li>\n      <li>\n        <a href=\"#etablissement-de-cette-declaration\">Établissement de cette déclaration d’accessibilité</a>\n      </li>\n      <li>\n        <a href=\"#environnement-de-test\">Environnement de test</a>\n      </li>\n      <li>\n          <a href=\"#pages-font-lobjet-de-la-verification-conformite\">Pages du site ayant fait l'objet de la vérification de conformité</a>\n        </li>\n      <li>\n        <a href=\"#retour-d-information-et-contact\">Retour d’information et contact</a>\n      </li>\n      <li>\n        <a href=\"#voies-de-recours\">Voies de recours</a>\n      </li>\n    </ul>\n    <div class=\"accessibilite-seperator\"></div>\n  </section>\n\n  <section id=\"etat-de-conformite\">\n    <h4>État de conformité</h4>\n    <p>\n      Le site Télérecours citoyens est <strong>partiellement conforme</strong> au référentiel général d’amélioration\n      de l’accessibilité (RGAA), version 4 en raison des non-conformités énumérées ci-dessous.\n    </p>\n  </section>\n\n  <section id=\"resultats-des-tests\">\n    <h4>Résultats des tests</h4>\n    <p>L’audit de contrôle réalisé par la <strong>DINUM</strong> révèle que :</p>\n      <ul>\n        <li><strong>61%</strong> des 106 critères testés sont respectés.</li>\n        <li>Le taux moyen de conformité du site s'élève à 75,3%.</li>\n      </ul>\n  </section>\n\n  <section id=\"criteres-non-conformes\">\n    <h4>Critères non conformes</h4>\n    <h4>Sur l'ensemble du site</h4>\n    <ul>\n      <li>Sur mobile, le bouton permettant d'accéder au menu de navigation est inaccessible au clavier. De plus, son intitulé n'est pas explicite.</li>\n    </ul>\n\n    <h4>Accueil avec liste des dossiers (connecté)</h4>\n    <ul>\n      <li>Des options et boutons de la liste des dossiers ne sont pas accessibles au clavier;</li>\n      <li>Les changements de contexte sur la page ne sont pas restitués par les lecteurs d'écran.</li>\n    </ul>\n\n    <h4>Authentification (déconnecté)</h4>\n    <ul>\n      <li>Le bouton permettant de voir en clair le mot de passe n'est pas accessible au clavier et n'est pas explicite (icône et libellé);</li>\n      <li>Les champs obligatoires ne sont pas correctement indiqués, notamment par le lecteur d'écran;</li>\n      <li>Les messages d'erreur ne sont pas lus correctement avec un lecteur d'écran : la liaison entre le message d'erreur et\n        le champ de formulaire n'est pas faite. De plus, les messages d'erreur ne présentent pas de suggestion de correction.\n      </li>\n    </ul>\n\n    <h4>Création de compte</h4>\n    <ul>\n      <li>Le bouton permettant de voir en clair le mot de passe n'est pas accessible au clavier et n'est pas explicite (icône et libellé);</li>\n      <li>Les messages d'erreurs et les boutons d'action ne sont pas assez lisibles car les contrastes de couleur ne sont pas suffisants;</li>\n      <li>Les champs texte ne proposent pas tous l'auto-complétion des données liées à utilisateur;</li>\n      <li>Les titres de la page ne sont pas correctement hiérarchisés, ce qui peut compliquer la navigation titre par titre au lecteur d'écran;</li>\n      <li>Les messages d'erreur n'indiquent pas de suggestion de correction.</li>\n    </ul>\n\n    <h4>Mentions légales</h4>\n    <ul>\n      <li>Les listes d'éléments ne sont pas identifiées et par conséquent elles ne sont pas correctement retranscrites par le lecteur d'écran.</li>\n    </ul>\n\n    <h4>Aide / FAQ</h4>\n    <ul>\n      <li>Les listes d'éléments ne sont pas identifiées et par conséquent elles ne sont pas correctement retranscrites par le lecteur d'écran;</li>\n      <li>L'ordre de navigation au clavier n'est pas cohérent et logique.</li>\n    </ul>\n\n    <h4>Visualisation d'un dossier</h4>\n    <ul>\n      <li>La fonctionnalité « renommer le dossier », ainsi que la fonctionnalité de tri chronologique / anti-chronologique de l'historique ne sont\n          pas accessibles au clavier et au lecteur d'écran;\n      </li>\n      <li>La liste des pièces n'est pas accessible : le bouton de téléchargement peut être difficile à sélectionner et les noms des pièces ne sont pas explicites.</li>\n    </ul>\n\n    <h4>Dépôt de requête</h4>\n    <ul>\n      <li>Le libellé du bouton « modifier mes informations personnelles » n'est pas restitué au lecteur d'écran;</li>\n      <li>L'ordre de tabulation au clavier n'est pas cohérent, et le focus est mal placé à chaque nouvelle étape (le focus se place dans le pied de page).</li>\n    </ul>\n\n    <h4>Mon compte</h4>\n    <ul>\n      <li>Certains liens ne sont pas explicites et il est difficile de comprendre leur destination;</li>\n      <li>Les options auto-complétion des données de l'utilisateur ne sont pas correctement implémentées;</li>\n      <li>Les champs obligatoires ne sont pas clairement identifiés dès le début du formulaire;</li>\n      <li>Certains libellés de champs ne sont pas explicites et le formulaire peut être difficile à compléter;</li>\n      <li>La fonctionnalité pour voir en clair son mot de passe n'est pas explicite et n'est pas accessible au clavier.</li>\n    </ul>\n\n    <h4>Rattacher un dossier à mon compte</h4>\n    <ul>\n      <li>Le bouton précédent ne fonctionne pas au clavier;</li>\n      <li>Le libellé du champ texte du code n'est pas explicite et il n'y a pas d'exemple de code. Il peut être complexe de saisir le code correct.</li>\n    </ul>\n  </section>\n\n  <section id=\"etablissement-de-cette-declaration\">\n    <h4>Établissement de cette déclaration d’accessibilité</h4>\n    <p>Cette déclaration a été établie le 9 février 2022. Elle a été mise à jour le 14/12/2022. (suite à un audit de contrôle effectué par la DINUM).</p>\n  </section>\n\n  <section id=\"environnement-de-test\">\n    <h4>Environnement de test</h4>\n    <p>Les vérifications de restitution de contenus ont été réalisées sur la base de la combinaison fournie par la\n        base de référence du RGAA, avec les versions suivantes :\n    </p>\n    <div class=\"test-outils\">\n      <ul class=\"test-env\">\n        <li><h4>Technologies utilisées</h4></li>\n        <li>HTML, CSS, JavaScript</li>\n      </ul>\n\n      <ul class=\"test-env\">\n        <li><h4>Navigateurs web</h4></li>\n        <li>Safari Version 15.4, Chrome, Firefox</li>\n      </ul>\n\n      <ul class=\"test-env\">\n        <li><h4>Outils pour évaluer l’accessibilité</h4></li>\n        <li>HeadingsMap, Web Developer Chrome extension, Color Contrast Analyser, ArcToolkit, inspecteur de code</li>\n        <li>Lecteurs d'écran : Voice Over, NVDA</li>\n      </ul>\n    </div>\n  </section>\n\n  <section id=\"pages-font-lobjet-de-la-verification-conformite\">\n    <h4>Pages du site ayant fait l'objet de la vérification de conformité</h4>\n    <p>Lors de cet audit, 17 pages ont été auditées :</p>\n    <ul class=\"link-list\">\n      <li><a routerLink=\"/accueil\">Accueil avec liste des dossiers (connecté)</a></li>\n      <li><a routerLink=\"/\">Authentification (déconnecté)</a></li>\n      <li><a routerLink=\"/register/morale\">Création de compte (personne morale)</a></li>\n      <li><a routerLink=\"/reset/request\">Mot de passe oublié</a></li>\n      <li><a routerLink=\"/mentions-legales\">Mentions légales</a></li>\n      <li><a routerLink=\"/faq\">Aide / FAQ</a></li>\n      <li><a routerLink=\"/plan-site\">Plan du site (déconnecté)</a></li>\n      <li><span class=\"pseudo-link\">Visualisation d'un dossier</span></li>\n      <li><a routerLink=\"/depot-requete/avertissement\">Dépôt de requête - étape 1 Avertissement</a></li>\n      <li><a routerLink=\"/depot-requete/requerants\">Dépôt de requête - étape 2 Requérant</a></li>\n      <li><a routerLink=\"/depot-requete/juridiction\">Dépôt de requête - étape 3 Juridiction</a></li>\n      <li><a routerLink=\"/depot-requete/justificatifs\">Dépôt de requête - étape 4 Justificatifs</a></li>\n      <li><a routerLink=\"/depot-requete/recapitulatif\">Dépôt de requête - étape 5 Récapitulatif</a></li>\n      <li><a routerLink=\"/mon-profil\">Mon compte</a></li>\n      <li><a routerLink=\"/rattachement/rejoindre-dossier\">Rattacher un dossier à mon compte - étape 2 Saisie du Code</a></li>\n      <li><span class=\"pseudo-link\">Rattacher un dossier à mon compte - étape 3 Confirmation</span></li>\n      <li><span class=\"pseudo-link\">Accessibilité</span></li>\n    </ul>\n  </section>\n\n  <section id=\"retour-d-information-et-contact\">\n    <h4>Retour d’information et contact</h4>\n    <p>\n      Si vous n’arrivez pas à accéder à un contenu ou à un service, vous pouvez contacter le Conseil d'État, <a class=\"accessibilite-link\" href=\"https://citoyens.telerecours.fr/\">https://citoyens.telerecours.fr/</a>\n        pour être orienté vers une alternative accessible ou obtenir le contenu sous une autre forme.\n    </p>\n    <ul>\n      <li>Envoyer un courriel à l'adresse suivante : <a href=\"mailto:accessibilite-telerecours-citoyens@conseil-etat.fr\">accessibilite-telerecours-citoyens@conseil-etat.fr</a></li>\n      <li>Envoyer un courriel à l'adresse suivante : <br>\n        <address class=\"address\">\n          <ul class=\"address-list\">\n            <li>Conseil d'État</li>\n            <li>1, place du Palais-Royal 75100 Paris cedex</li>\n            <li>75100 Paris cedex 01</li>\n          </ul>\n        </address>\n      </li>\n    </ul>\n  </section>\n\n  <section id=\"voies-de-recours\">\n    <h4>Voies de recours</h4>\n    <p>\n      Si vous constatez un défaut d'accessibilité vous empêchant d'accéder à un contenu ou une fonctionnalité du site,\n      que vous nous le signalez et que vous ne parvenez pas à obtenir une réponse de notre part, vous êtes en droit de faire\n      vos doléances ou une demande de saisine au Défenseur des droits.\n    </p>\n    <p>Plusieurs moyens sont à votre disposition : </p>\n    <ul>\n      <li><a href=\"https://www.defenseurdesdroits.fr/fr/saisir/delegues\" target=\"_blank\">Contacter le délégué du Défenseur des droits dans votre région</a> <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></li>\n      <li><a href=\"https://formulaire.defenseurdesdroits.fr/code/afficher.php?ETAPE=accueil_2016\" target=\"_blank\">Écrire un message au Défenseur des droits</a> <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i></li>\n      <li>Envoyer un courrier par la Poste (gratuit, ne pas mettre de timbre) :\n        <address>\n          <ul class=\"address-list\">\n          <li>Défenseur des droits</li>\n          <li>Libre réponse 71120</li>\n          <li>75342 Paris CEDEX 07</li>\n        </ul>\n      </address>\n      </li>\n    </ul>\n  </section>\n</section>\n"

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "<jhi-jumbotron>\n    <h1>Conditions générales d'utilisation</h1>\n</jhi-jumbotron>\n\n<div class=\"container\">\n    <jhi-cgu [cguTypeEnum]=\"cguTypeEnum\"></jhi-cgu>\n</div>\n"

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "<div class=\"footer\">\n    <ng-container *ngIf=\"!joinedUserClub\">\n        <jhi-user-club></jhi-user-club>\n        <hr>\n    </ng-container>\n    <div class=\"copyright\">\n        <ul>\n            <li><span>© Conseil d’État</span></li>\n            <li><a routerLink=\"accessibilite\" target=\"_blank\">Accessibilité : partiellement conforme</a></li>\n            <li><a routerLink=\"conditions-generales\" target=\"_blank\">Conditions générales d'utilisation</a></li>\n            <li><a routerLink=\"mentions-legales\" target=\"_blank\">Mentions légales</a></li>\n            <li><a routerLink=\"plan-site\">Plan du site</a></li>\n            <li><a routerLink=\"changelog\" target=\"_blank\" (click)=\"trackCliquer()\">Mises à jour du site</a></li>\n            <li><a routerLink=\"donnees-personelles\" target=\"_blank\">Données personnelles</a></li>\n        </ul>\n    </div>\n</div>\n<ng-template ngbModalContainer></ng-template>\n"

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports = "<jhi-jumbotron>\n    <h1>Mises à jour du site</h1>\n</jhi-jumbotron>\n\n<div class=\"container\">\n    <jhi-changelog></jhi-changelog>\n</div>\n"

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "<jhi-jumbotron>\n    <h1>Mentions légales</h1>\n</jhi-jumbotron>\n\n<div class=\"container\">\n    <div class=\"row\">\n        <div class=\"row\">\n            <h3>Éditeur et hébergement</h3>\n            <p>L’application Télérecours citoyens est gérée et hébergée par la Direction des systèmes d’information du Conseil d’État\n            </p>\n            <p>Conseil d’État<br>\n                Secrétariat général / Direction des systèmes d’information<br>\n                1, place du Palais-Royal<br>\n                75100 Paris cedex 01</p>\n        </div>\n        <div class=\"row\">\n            <h3>Conception et développement</h3>\n            <p>Directeur des systèmes d’information : David Boucheny<br>\n                Directeur de projet : Emmanuel Quéré<br>\n                Développement : Conseil d’État</p>\n        </div>\n        <div class=\"row\">\n            <h3>Données personnelles</h3>\n            <p>L’application Télérecours citoyens constitue un traitement de données à caractère personnel, soumis à la loi « informatique et libertés » n°&nbsp;78-17 du 6 janvier\n                1978,\n                modifiée.</p>\n            <p>Le responsable de ce traitement est le Secrétaire général du Conseil d’État, M. Thierry-Xavier Girardot.</p>\n            <p>Cette application est conforme à l’autorisation du traitement automatisé d’informations nominatives concernant la gestion de l’ensemble des activités contentieuses\n                du\n                Conseil d’État, des cours administratives d’appel et des tribunaux administratifs résultant de la délibération n°2004-095 du 09 décembre 2004 (autorisation\n                n°1033829)\n                de la Commission Nationale Informatique et Libertés. Elle a fait l’objet d’un avis de la Commission Nationale Informatique et Libertés n° 2165666 en date du 19 avril 2018.</p>\n            <p>L’exercice des droits d’accès, d’opposition et de rectification des données à caractère personnel s’exerce auprès du délégué à la protection des données du Conseil\n                d’État et de la juridiction administrative 1, place du Palais-Royal 75100 Paris cedex 01.</p>\n        </div>\n        <div class=\"row\">\n            <h3>À propos des cookies</h3>\n            <p>Lors de la consultation du site <a href=\"https://citoyens.telerecours.fr/\">https://citoyens.telerecours.fr/</a>\n                des cookies sont déposés sur votre terminal.\n            </p>\n\n            <h4>Que recouvre le terme de « cookies » ou de « traceurs » ?</h4>\n\n            <p>Les traceurs sont déposés et lus par exemple lors de la consultation d'un site internet, de la lecture d'un courrier électronique,\n                de l'installation ou de l'utilisation d'un logiciel ou d'une application mobile et ce, quel que soit le type de terminal utilisé.\n            </p>\n\n            <p id=\"internal-cookies\">Sur le site de Télérecours citoyens, seuls des cookies internes nécessaires au fonctionnement du site sont déposés. Ces cookies\n                permettent au site de fonctionner de manière optimale.\n            </p>\n\n            <table aria-describedby=\"internal-cookies\">\n                <tr>\n                    <th>Nom du <br> cookie</th>\n                    <th>Finalité</th>\n                    <th>Durée de <br> conservation</th>\n                </tr>\n                <tr>\n                    <td>_pk_ses</td>\n                    <td>Permet le stockage temporaire de vos données de visite (si la mesure d'audience Piwik est active)</td>\n                    <td>30 minutes</td>\n                </tr>\n                <tr>\n                    <td>_pk_id</td>\n                    <td>Permet de stocker votre identifiant unique de visite (si la mesure d'audience Piwik est active)</td>\n                    <td>13 mois</td>\n                </tr>\n                <tr>\n                    <td>JSESSIONID</td>\n                    <td>Gestion de l’authentification</td>\n                    <td>Session</td>\n                </tr>\n                <tr>\n                    <td>remember-me</td>\n                    <td>Utilisé par la fonctionnalité « Rester connecté »</td>\n                    <td>1 mois</td>\n                </tr>\n            </table>\n\n            <p>Les cookies de mesure d’audience ont pour finalité l’optimisation des performances techniques du site et de son ergonomie.\n                Ils sont paramétrés afin de bénéficier de l’exemption du recueil du consentement.\n            </p>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = "<section>\n    <jhi-jumbotron>\n        <h1>Données personnelles</h1>\n    </jhi-jumbotron>\n</section>\n<section class=\"container personal-data\">\n\n    <section class=\"summary\">\n        <h1>Accès rapide aux thématiques</h1>\n        <ol>\n            <li><a (click)=\"scroll('personal-data-1')\">Traitements mis en œuvre par la justice administrative</a>\n                <ol type=\"a\">\n                    <li><a (click)=\"scroll('personal-data-1-a')\">Objet du traitement de la donnée</a>\n                        <ul>\n                            <li><a (click)=\"scroll('personal-data-1-a-1')\">Finalité principale 1</a>\n                                <ul>\n                                    <li><a (click)=\"scroll('personal-data-1-a-1-1')\">Sous finalités</a></li>\n                                </ul>\n                            <li><a (click)=\"scroll('personal-data-1-a-2')\">Finalité principale 2</a>\n                                <ul>\n                                    <li><a (click)=\"scroll('personal-data-1-a-2-1')\">Sous finalités</a></li>\n                                </ul>\n                        </ul>\n                    </li>\n                    <li><a (click)=\"scroll('personal-data-1-b')\">Données traitées</a>\n                        <ul>\n                            <li><a (click)=\"scroll('personal-data-1-b-1')\">Catégories de données traitées pour\n                                Télérecours\n                                citoyens</a></li>\n                            <li><a (click)=\"scroll('personal-data-1-b-2')\">Catégories de données traitées pour le club\n                                utilisateur</a></li>\n                            <li><a (click)=\"scroll('personal-data-1-b-3')\">Prise de décision automatisée</a></li>\n                            <li><a (click)=\"scroll('personal-data-1-b-4')\">Caractères obligatoires du recueil des\n                                données et\n                                conséquences en cas de non-fourniture\n                                des données</a>\n                            </li>\n                            <li><a (click)=\"scroll('personal-data-1-b-5')\">Destinataires des données</a></li>\n                            <li><a (click)=\"scroll('personal-data-1-b-6')\">Transfert des données hors union\n                                européenne</a></li>\n                            <li><a (click)=\"scroll('personal-data-1-b-7')\">Durée de conservation des données</a></li>\n                        </ul>\n                    </li>\n\n                    <li><a (click)=\"scroll('personal-data-1-c')\">Sécurité</a></li>\n\n                    <li><a (click)=\"scroll('personal-data-1-d')\">Vos droits sur les données vous concernant</a>\n                        <ul>\n                            <li><a (click)=\"scroll('personal-data-1-d-1')\">Contacter le délégué de la protection des\n                                données par\n                                voie postale</a></li>\n                            <li><a (click)=\"scroll('personal-data-1-d-2')\">Contacter le délégué de la protection des\n                                données par\n                                voie électronique</a></li>\n                            <li><a (click)=\"scroll('personal-data-1-d-3')\">Introduire une réclamation (plainte) auprès\n                                de la\n                                CNIL</a></li>\n                        </ul>\n                    </li>\n                </ol>\n            </li>\n            <li><a (click)=\"scroll('personal-data-2')\">Politique de protection des données RGPD et cookies</a>\n                <ul>\n                    <li><a (click)=\"scroll('personal-data-2-1')\">Qu’est-ce qu’un cookie ?</a></li>\n                    <li><a (click)=\"scroll('personal-data-2-2')\">Type de cookie déposé sur les services de\n                        Télérecours</a></li>\n                    <li><a (click)=\"scroll('personal-data-2-3')\">Cookies strictement nécessaires au site pour\n                        fonctionner</a></li>\n                    <li><a (click)=\"scroll('personal-data-2-4')\">Cookies de mesure d’audience</a></li>\n                </ul>\n            </li>\n        </ol>\n    </section>\n\n    <hr>\n    <p>Mise à jour le 20/01/2023 </p>\n\n    <section>\n        <h2 id=\"personal-data-1\">1. Traitements mis en œuvre par la justice administrative</h2>\n        <p>Le Conseil d’État s’engage à ce que les traitements de données personnelles effectués dans le cadre du\n            téléservice Télérecours soient conformes au règlement général sur la protection des données et à la loi\n            Informatique et Libertés.\n        </p>\n    </section>\n\n    <section>\n        <h3 id=\"personal-data-1-a\">a. Objet du traitement de la donnée</h3>\n        <h4 id=\"personal-data-1-a-1\">Finalité principale 1</h4>\n        <p>Télérecours citoyens est une application Internet destinée aux particuliers et aux personnes morales de\n            droit privé non chargées de la gestion d’un service public.\n        </p>\n        <p>Elle permet d’échanger avec les tribunaux administratifs, les cours administratives d’appel et le Conseil\n            d’État\n            de manière dématérialisée et en toute sécurité. Elle permet également de suivre l’état d’avancement de son\n            dossier.\n        </p>\n        <div>\n            Télérecours citoyens n’est pas obligatoire. Vous conservez la possibilité de déposer un recours :\n            <ul>\n                <li> En vous déplaçant directement à l’accueil de la juridiction,</li>\n                <li>Par voie postale, de préférence en recommandé avec accusé de réception.</li>\n            </ul>\n        </div>\n        <p> Dans l’exercice de leurs fonctions juridictionnelles, le Conseil d’Etat, les Cour administrative d’appel\n            et les Tribunaux administratifs collectent et traitent des données à caractère personnel aux fins de\n            garantir\n            la bonne conduite de la procédure administrative et, notamment, d’assurer la communication des actes de\n            procédure\n            aux parties à la procédure.\n        </p>\n        <p>Ces traitements visent également à permettre la diffusion d’une information utile concernant les procédures\n            juridictionnelles, pendantes ou clôturées, conforme au principe de publicité de la justice.\n        </p>\n    </section>\n\n    <section>\n        <h5 id=\"personal-data-1-a-1-1\">Sous finalités</h5>\n\n        <div class=\"mb-3\">\n            <strong>\n            1. Assure le suivi du déroulement de la procédure (création du dossier du requérant et gestion des\n            dépôts de pièces)</strong><br>\n            <span class=\"hint\">La base légale : Exécution d’une mission de service publique ou relevant de l’autorité du Conseil d’Etat et\n            obligations légales</span>\n        </div>\n\n        <div class=\"mb-3\">\n            <strong>2. Permet de créer un compte utilisateur et de rattacher un dossier à son compte\n                utilisateur</strong><br>\n            L’utilisateur a la possibilité de s’authentifier soit :\n            <ul>\n                <li>par le téléservice FranceConnect ,en application à l’arrêté du 24 juillet 2015 ;</li>\n                <li>par le formulaire de création de compte utilisateur.</li>\n            </ul>\n        </div>\n\n        <div class=\"mb-3\">\n            <strong>3. Améliore l’expérience de navigation dans nos services</strong><br>\n            <p>Dans le cadre de mise à disposition de services, le dépôt d’une requête de façon dématérialisée,\n                le suivi des échanges de pièces dans les dossiers et le suivi du déroulement d’une procédure\n                collectent des informations.</p>\n            La collecte de données statistiques est employée à des fins d’analyse et d’évaluation pour comprendre la\n            façon dont les services sont utilisés. Ce traitement permet :\n            <ul>\n                <li>la production de statistique d’audience et d’utilisation des services en ligne proposés par\n                    Télérecours ;\n                </li>\n                <li>le suivi statistique de l’activité et l’élaboration de données d’activité (évaluation de la\n                    satisfaction\n                    usagers, production de statistiques d’activité).\n                </li>\n            </ul>\n            <span class=\"hint\">La base légale : intérêt légitime</span>\n        </div>\n\n        <div class=\"mb-3\">\n            <strong>4. Gère le support technique avec les utilisateurs</strong><br>\n\n            <p>Dans le cadre de l’amélioration de l’expérience de navigation, l’historisation des demandes et réponses\n                apportées aux usagers est conservée pour avoir une trace de la demande afin de mieux résoudre\n                les problèmes récurrents.</p>\n            Ce traitement permet :\n            <ul>\n                <li>la réception des demandes notamment via le formulaire en ligne de saisine du support technique ;\n                </li>\n                <li>l’instruction et le suivi des demandes, en liaison avec les services concernés ;</li>\n                <li>la conservation d’un historique des demandes et des réponses apportées aux usagers.</li>\n            </ul>\n            <span class=\"hint\">La base légale : intérêt légitime</span>\n        </div>\n\n        <div>\n            <strong>5. Gère des exercices de droits par le bureau de la protection des données</strong><br>\n            <p>Dans le cadre de la collecte des données et la bonne application du Règlement de la protection des\n                données\n                personnelles, la réception des demandes notamment via le formulaire en liaison avec les services\n                concernés\n                sont traitées selon des protocoles sécurisés.<br>\n                <span class=\"hint\">La base légale : obligation légale</span>\n            </p>\n        </div>\n    </section>\n\n    <section>\n        <h4 id=\"personal-data-1-a-2\">Finalité principale 2</h4>\n        <p>Notre club utilisateur a pour but de réunir des personnes aux profils variés qui nous font part de leur\n            expérience sur notre service en ligne. L’objectif est d’améliorer Télérecours citoyens, grâce à une\n            collaboration étroite avec l’utilisateur. Vous serez alors libre de nous partager votre avis, vos besoins\n            et vos recommandations sur le téléservice.<br>\n            <span class=\"hint\">La base légale : le consentement</span>\n        </p>\n    </section>\n\n    <section>\n        <h5 id=\"personal-data-1-a-2-1\">Sous finalités</h5>\n\n        <p><strong>\n            1. Gère des demandes de souscription au club utilisateur par voie numérique (portail Télérecours)\n            ou orale (support utilisateur)</strong>\n        </p>\n\n        <div><strong>2. Traite des données sensibles pour la vérification et la mise en conformité avec le référentiel\n            français sur l’accessibilité (RGAA) du portail actuel et de la refonte</strong>\n            <div class=\"mb-4\">\n                <a href=\"https://accessibilite.numerique.gouv.fr/\" target=\"_blank\" rel=\"noopener noreferrer\">Consulter le référentiel\n                    général de l’accessibilité numérique <em class=\"fa fa-external-link\" title=\"Ouverture dans une nouvelle fenêtre\" aria-hidden=\"true\"></em>\n                    <span class=\"sr-only\">(ouverture dans une nouvelle fenêtre)</span>\n                </a>\n            </div>\n        </div>\n        <p><strong>3. Traite des résultats des ateliers, des manipulations des nouvelles interfaces et des entretiens\n            pour\n            prendre en compte leurs besoins en termes d’expérience d’utilisation du portail.</strong></p>\n\n        <p><strong>4. Identifie les membres du club utilisateur pour participer aux ateliers</strong></p>\n\n        <p><strong>5. Crée un questionnaire pour permettre d’identifier les membres du club utilisateur pour participer\n            au club utilisateur</strong></p>\n    </section>\n\n    <section>\n        <h3 id=\"personal-data-1-b\">b. Données traitées</h3>\n        <h4 id=\"personal-data-1-b-1\">Catégories de données traitées pour Télérecours citoyens</h4>\n        <div>\n            Les données à caractère personnel obligatoires enregistrées par l’application sont :\n            <ul>\n                <li>les noms, les prénoms des parties ;</li>\n                <li>l’adresse postale, l’adresse électronique des requérants ;</li>\n                <li>et ainsi que pour les personnes morales, leur forme, dénomination sociale et les noms et prénoms de\n                    leur représentant ;\n                </li>\n                <li>toute information que le justiciable souhaite communiquer à la juridiction dans le cadre de la\n                    procédure contentieuse ;\n                </li>\n                <li>le type de recours (requête normale, requête en référé, requête à délai contraint) ;</li>\n                <li>le type de contentieux ;</li>\n                <li>les données relatives à la navigation sur Télérecours (données techniques relatives à l’équipement\n                    et au navigateur utilisés par les usagers, cookies nécessaires au bon fonctionnement, traceurs) ;\n                </li>\n                <li>les données relatives à la gestion des contacts usagers sur le support technique\n                    (horodatage et objet de la demande, suivi, statistiques) ;\n                </li>\n                <li>les statistiques d’audiences de Télérecours et d’utilisation des services en ligne\n                    proposés par Télérecours (date et heures des requêtes, url des pages consultées, url de la page\n                    vue précédente à la page concernée, fichiers téléchargés, liens externes cliqués, temps\n                    d’ouverture de la page, temps de visite de la page, sessions enregistrées par un événement\n                    personnalisé comme le clic) ;\n                </li>\n            </ul>\n        </div>\n        <p>les données de connexion : identifiant, mot de passe, logs, adresses IP.</p>\n    </section>\n\n    <section>\n        <h4 id=\"personal-data-1-b-2\">Catégories de données traitées pour le club utilisateur (uniquement pour les\n            personnes ayant accepté\n            de participer au club utilisateur).</h4>\n        <div>\n            <ul>\n                <li>Identité (nom, prénom) ;</li>\n                <li>Coordonnées (ville, téléphone) ;</li>\n                <li>Métier, nom de l’employeur ;</li>\n                <li>Présence ou non d’un handicap, précision du type de handicap ;</li>\n                <li>Habitudes numériques ;</li>\n                <li>Date d’inscription au club utilisateur, de la demande, réponse apportée, date de réponse, historique\n                    des demandes de l’usager, statistiques ;\n                </li>\n                <li>Modalités d’échanges avec l’équipe Télérecours citoyens ;</li>\n                <li>Disponibilités des utilisateurs et préférences de contact.</li>\n            </ul>\n        </div>\n    </section>\n\n    <section>\n        <h4 id=\"personal-data-1-b-3\">Prise de décision automatisée</h4>\n        <p>Le traitement ne prévoit pas de prise de décision automatisée.</p>\n    </section>\n\n    <section>\n        <h4 id=\"personal-data-1-b-4\">Caractères obligatoires du recueil des données et conséquences en cas de\n            non-fourniture des données</h4>\n        <p>Les données collectées (notamment par les cookies nécessaires) à l’occasion de la navigation pour la mesure\n            de l’audience de Télérecours et de l’utilisation des services en ligne présentant un caractère\n            facultatif.</p>\n    </section>\n\n    <section>\n        <h4 id=\"personal-data-1-b-5\">Destinataires des données</h4>\n        <p><strong>Catégorie de destinataires</strong></p>\n        <div>En fonction de leurs besoins respectifs sont destinataires de tout ou partie des données :\n            <ul>\n                <li>les personnels de Télérecours chargés du traitement des demandes reçues via les formulaires de\n                    contact ;\n                </li>\n                <li>les personnels de Télérecours en charge de l’administration technique des sites web ;</li>\n                <li>les personnels responsables de la supervision de la sécurité des systèmes d’information de\n                    Télérecours ;\n                </li>\n                <li>le délégué à la protection des données de Télérecours uniquement lorsqu’il est sollicité pour\n                    l’exercice\n                    d’un droit « informatique et liberté » ;\n                </li>\n                <li>les personnels de Télérecours dont la contribution est sollicitée par le délégué à la protection des\n                    données ;\n                </li>\n                <li>l’équipe Télérecours citoyens en charge du Club utilisateur uniquement pour les personnes ayant\n                    accepté de participer au Club utilisateur ;\n                </li>\n                <li>leur hiérarchie (statistiques ; si besoin, données relatives à une requête particulière) ;</li>\n                <li>les personnels habilités de la justice administrative (magistrats, greffiers...) ;</li>\n                <li>les avocats et mandataires, le cas échéant.</li>\n            </ul>\n        </div>\n    </section>\n\n    <section>\n        <h4 id=\"personal-data-1-b-6\">Transfert des données hors union européenne</h4>\n        <p>Il n’y a pas de transfert de données en dehors de l’Union européenne.</p>\n    </section>\n\n    <section>\n        <h4 id=\"personal-data-1-b-7\">Durée de conservation des données</h4>\n        <p>Les données à caractère personnel à chaque affaire pour laquelle l’utilisation du téléservice a été acceptée\n            sont conservées pendant une durée de 5 ans après que cette affaire a fait l’objet d’une décision devenue\n            définitive.</p>\n        <p>La durée ainsi retenue doit permettre de tenir compte de la durée d’utilité administrative (DUA) notamment\n            prévue par l’instruction n° DAF/DPACL/RES/2019/019 et fixée à 5 ans.</p>\n        <p>Les données à caractère personnel du compte de l’utilisateur sont conservées pendant une durée d’un an après\n            la création de son compte, si aucune affaire n’y a été rattachée, ou après que toutes les affaires\n            pour lesquelles les téléprocédures ont été acceptées auront fait l’objet d’un effacement.</p>\n\n        <div>\n            <ul>\n                <li>Les données collectées via les formulaires en ligne ou les consultations sont conservées\n                    sur une durée maximale de 5 ans à compter de leur réception ;\n                </li>\n                <li>Les données collectées sur les affaires qui sont conservé 2 ans ;</li>\n                <li>Les données collectées sur les brouillons qui sont conservé 2 ans ;</li>\n                <li>Les données collectées sur les dossiers qui sont conservés 2 ans ;</li>\n                <li>Les données des journaux (logs) sont conservées 1 an ;</li>\n                <li>Les données collectées sur votre choix en matière de préférence de cookies qui sont conservées 6\n                    mois ;\n                </li>\n                <li>Les données liées au support technique qui sont conservées l’année civile de la demande ;</li>\n                <li>L’historique des demandes et des réponses apportées aux usagers sur les outils de support\n                    technique qui sont conservées 5 ans ;\n                </li>\n                <li>Les requêtes des usagers et les réponses apportées sont conservées 3 ans à compter de la date\n                    d’inscription au Club utilisateurs.\n                </li>\n            </ul>\n        </div>\n    </section>\n\n    <section>\n        <h3 id=\"personal-data-1-c\">c. Sécurité</h3>\n        <p>Les mesures de sécurité sont mises en œuvre conformément à la politique de sécurité des systèmes\n            d’information (PSSI) du Conseil d’Etat.</p>\n        <p>Dans le cadre de mise en conformité des outils, applications et les services, Télérecours met en œuvre des\n            mesures de sécurité garantissant la confidentialité, l’intégrité, la disponibilité et la résilience\n            constante\n            des systèmes de sécurité et des services.</p>\n        <p>La gestion du fonctionnement et de la sécurité des portails avec la journalisation applicative des événements\n            (Fournisseurs d’accès SSI, intérêt légitime, PSI de l’état).</p>\n        <p>L’administration technique en lien avec les prestataires (tierce maintenance applicative).</p>\n        <p>Le rétablissement des données et l’accès à celles-ci dans des délais appropriés en cas d’incident physique\n            ou technique.</p>\n    </section>\n\n    <section>\n        <h3 id=\"personal-data-1-d\">d. Droits sur les données vous concernant</h3>\n        <p>Vous disposez de droits en ce qui concerne l’utilisation des données personnelles. Vous pouvez exercer votre\n            droit d’accès, de rectification et de suppression auprès du délégué à la protection des données (DPO).</p>\n        <h4 id=\"personal-data-1-d-1\">Contacter le délégué de la protection des données par voie postale</h4>\n        <p>Envoyer un courrier simple à l’adresse suivante :</p>\n        <address>\n            Conseil d'État\n            A l'attention du délégué à la protection des données des services de Télérecours<br/>\n            1, place du Palais-Royal<br/>\n            75100 Paris cedex 01\n        </address>\n        <h4 id=\"personal-data-1-d-2\">Contacter le délégué de la protection des données par voie électronique</h4>\n        <p>Par courriel à <a href=\"mailto:donneespersonnelles@conseil-etat.fr\">\n            donneespersonnelles@conseil-etat.fr</a></p>\n        <h4 id=\"personal-data-1-d-3\">Introduire une réclamation (plainte) auprès de la CNIL</h4>\n        <p>Si vous estimez, après nous avoir contactés, que vos droits « informatique et libertés » ne sont pas\n            respectés, vous pouvez adresser une réclamation à la CNIL.</p>\n        <p>\n            Contacter la CNIL et adresser une réclamation (plainte) à la CNIL :<br>\n            <a href=\"https://www.cnil.fr/fr/plaintes\" target=\"_blank\" rel=\"noopener noreferrer\">Adresser une réclamation\n                (plainte) à la CNIL <em class=\"fa fa-external-link\" title=\"Ouverture dans une nouvelle fenêtre\" aria-hidden=\"true\"></em>\n                <span class=\"sr-only\">(ouverture dans une nouvelle fenêtre)</span>\n            </a>\n        </p>\n    </section>\n\n    <section>\n        <h2 id=\"personal-data-2\">2. à propos des cookies</h2>\n        <p>Nous utilisons un cookie sur les services de Télérecours pour mesurer l’audience et intégrer des services\n            permettant d’améliorer l’interactivité des services de Télérecours.\n        </p>\n    </section>\n\n    <section>\n        <h3 id=\"personal-data-2-1\">Qu’est-ce qu’un cookie ?</h3>\n        <p>Un cookie est un petit fichier stocké par un serveur dans le terminal (ordinateur, téléphone, etc…)\n            d’un utilisateur et associé à un domaine web (c’est à dire dans la majorité des cas à l’ensemble des pages\n            d’un même site web). Ce fichier est automatiquement renvoyé lors de contacts ultérieurs avec le même\n            domaine.\n        </p>\n    </section>\n\n    <section>\n        <h3 id=\"personal-data-2-2\">Type de cookie déposé sur les services de Télérecours</h3>\n        <p>Nous utilisons un cookie sur les services de Télérecours pour mesurer l’audience et intégrer des services\n            permettant d’améliorer l’interactivité des services de Télérecours.\n        </p>\n    </section>\n\n    <section>\n        <h3 id=\"personal-data-2-3\">Cookies strictement nécessaires au site pour fonctionner</h3>\n        <p>Notre cookie est un cookie « interne ». Il est déposé par le site consulté par l’internaute,\n            plus précisément sur le domaine du site. Nous pouvons demander que les cookies soient réglés sur votre\n            appareil.\n            Nous utilisons les cookies pour nous faire savoir quand vous visitez nos portails web, comment vous\n            interagissez\n            avec nous, pour enrichir votre expérience, et pour personnaliser votre relation avec nos portails web.\n        </p>\n    </section>\n\n    <section>\n        <h3 id=\"personal-data-2-4\">Cookies de mesure d’audience</h3>\n        <p id=\"list-cookies\">Découvrez la liste des cookies mis en place sur les services de Télérecours.\n        </p>\n        <table aria-describedby=\"list-cookies\">\n            <tr>\n                <th>NOM DU COOKIE</th>\n                <th>FINALITÉ</th>\n                <th>DURÉE DE CONVERSATION</th>\n            </tr>\n            <tr>\n                <td>Matomo</td>\n                <td>Permettre de mesuser l’audience sur les services de Télérecours</td>\n                <td>6 mois</td>\n            </tr>\n        </table>\n    </section>\n\n</section>\n"

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports = "<a class=\"nav-link\" routerLink=\"/{{routePath}}\">{{ routeTitle }}</a>"

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "<jhi-jumbotron>\n    <h1>Plan du site</h1>\n</jhi-jumbotron>\n<div class=\"container plan-container\">\n  <ng-container *ngFor=\"let route of routes\">\n    <div class=\"route-container\" *ngIf=\"!route.data.hide\">\n      <ul class=\"show-no-bullets\">\n        <li>\n          <jhi-plan-site-item\n            [routePath]=\"hasChildren(route) ? '/' : route.path\"\n            [routeTitle]=\"route.data.pageTitle\">\n        </jhi-plan-site-item>\n        </li>\n      </ul>\n      <ng-container  *ngFor=\"let child of route.children\">\n        <ul class=\"show-no-bullets\">\n          <li>\n            <jhi-plan-site-item\n              *ngIf=\"!child.data.hide\"\n              routePath=\"{{route.path}}/{{child.path}}\"\n              [routeTitle]=\"child.data.pageTitle\"\n              [isSubItem]=\"true\">\n            </jhi-plan-site-item>\n          </li>\n        </ul>\n      </ng-container>\n    </div>\n  </ng-container>\n</div>\n"

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "<jhi-page-ribbon></jhi-page-ribbon>\n<header role=\"banner\">\n    <div *ngIf=\"showNavigationButton\">\n        <a href=\"#main\" role=\"button\" aria-pressed=\"true\" tabindex=\"0\" class=\"btn skip\" id=\"main-button\" aria-label=\"Aller au contenu principal\">Aller au contenu principal</a>\n    </div>\n    <router-outlet name=\"navbar\"></router-outlet>\n</header>\n<main id=\"main\" class=\"container-main\" role=\"main\">\n    <router-outlet></router-outlet>\n    <router-outlet name=\"popup\"></router-outlet>\n</main>\n<jhi-inactivity-modal></jhi-inactivity-modal>\n<footer role=\"contentinfo\">\n    <jhi-footer></jhi-footer>\n</footer>\n"

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navbar navbar-dark navbar-expand-lg jh-navbar\" tabindex=\"-1\" role=\"navigation\">\n    <div class=\"jh-logo-container float-left\">\n        <a class=\"navbar-brand logo float-left\" id=\"logo-link\" title=\"Conseil d'État - Télérecours Citoyens - Accueil\" routerLink=\"/\">\n            <div class=\"logo-img\"></div>\n            <div class=\"verticalDivider mx-3\"></div>\n            <div class=\"navbar-title\"><h1>Télérecours citoyens</h1></div>\n        </a>\n        <button tabindex=\"0\" class=\"jh-navbar-toggler navbar-toggler hidden-xl-up float-right\" [attr.aria-expanded]=\"!isNavbarCollapsed\" aria-controls=\"navbarResponsive\"\n           aria-label=\"Menu de navigation principale\" (click)=\"toggleNavbar()\">\n            <i class=\"fa fa-bars\" aria-hidden=\"true\"></i>\n    </button>\n    </div>\n    <div class=\"navbar-collapse collapse\" id=\"navbarResponsive\" [ngbCollapse]=\"isNavbarCollapsed\">\n        <ul class=\"navbar-nav ml-auto\">\n            <ng-container *ngIf=\"isAuthenticated()\">\n                <li class=\"nav-item\" routerLinkActive=\"active\" #accueil=\"routerLinkActive\" [routerLinkActiveOptions]=\"{exact: true}\" >\n                    <a class=\"nav-link\" routerLink=\"accueil\" [attr.aria-current]=\"accueil.isActive ? 'page': undefined\" title=\"Accueil\" (click)=\"collapseNavbar()\">\n                        <span>Accueil</span>\n                    </a>\n                </li>\n            </ng-container>\n            <li class=\"nav-item\" routerLinkActive=\"active\" #faq=\"routerLinkActive\" [routerLinkActiveOptions]=\"{exact: true}\">\n                <a class=\"nav-link\"  routerLink=\"faq\" [attr.aria-current]=\"faq.isActive ? 'page': undefined\" title=\"Aide\" (click)=\"collapseNavbar(); trackCliquer()\">\n                    <span>Aide</span>\n                </a>\n            </li>\n            <ng-container *ngIf=\"isAuthenticated()\">\n                <li class=\"nav-item\" routerLinkActive=\"active\" #profil=\"routerLinkActive\" [routerLinkActiveOptions]=\"{exact: true}\" >\n                    <a class=\"nav-link\" routerLink=\"mon-profil\" [attr.aria-current]=\"profil.isActive ? 'page': undefined\" title=\"Mon compte\" (click)=\"collapseNavbar()\">\n                        <span>Mon Compte</span>\n                    </a>\n                </li>\n\n                <li class=\"nav-item\" >\n                    <a class=\"nav-link logout\" href=\"#\" title=\"Déconnexion de mon espace personnel\" (click)=\"logout()\">\n                        <span>Déconnexion</span>\n                    </a>\n                </li>\n            </ng-container>\n        </ul>\n    </div>\n</nav>\n"

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "<ng-template #modal let-modal>\n    <div aria-modal=\"true\"\n         role=\"alertdialog\"\n         aria-labelledby=\"dialog_session_expire_label\"\n         aria-describedby=\"dialog_session_expire_desc\"\n         jhiTrapFocus>\n        <div class=\"modal-header p-4\">\n            <h2 id=\"dialog_session_expire_label\">\n                Votre session va bientôt expirer\n            </h2>\n        </div>\n\n        <div *ngIf=\"!isSessionExtended\" class=\"modal-body p-4\">\n            <p id=\"dialog_session_expire_desc\">\n                Suite à une période d'inactivité, votre session va expirer dans\n                <b>\n                    {{ counter }}\n                    {{ counter === 1 ? 'seconde' : 'secondes' }}\n                </b>\n            </p>\n            <p>\n                Souhaitez-vous poursuivre votre session ?\n            </p>\n        </div>\n\n        <div *ngIf=\"!isSessionExtended\" class=\"modal-footer p-4\">\n            <div class=\"ml-3\"></div>\n            <jhi-button\n                (click)=\"onLogout()\"\n                cancellation>\n                Je me déconnecte\n                <ng-content></ng-content>\n            </jhi-button>\n            <jhi-button\n                (click)=\"onExtendSession()\"\n                confirmation>\n                Je prolonge ma session\n                <ng-content></ng-content>\n            </jhi-button>\n        </div>\n        <div *ngIf=\"isSessionExtended\" role=\"alert\" class=\"alert alert-warning alert-secondary m-4\">\n            Votre session de connexion a été prolongée de 30 minutes.\n        </div>\n    </div>\n</ng-template>\n"

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "<jhi-jumbotron>\n    <h1>Rattacher un dossier à mon compte</h1>\n</jhi-jumbotron>\n<div class=\"container\">\n    <jhi-breadcrumb [steps]=\"steps\"></jhi-breadcrumb>\n    <router-outlet></router-outlet>\n</div>\n"

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n    <h1 class=\"display-4 my-5 text-center\">Avertissement avant rattachement de dossier</h1>\n    <jhi-cgu [cguTypeEnum]=\"cguTypeEnum\" class=\"col-12\"></jhi-cgu>\n    <form novalidate>\n        <div class=\"col-lg-6 col-12 offset-lg-3 mb-2\">\n            <div class=\"form-check\">\n                <input\n                    type=\"checkbox\"\n                    class=\"form-check-input\"\n                    name=\"teleprocedureCheckbox\"\n                    id=\"teleprocedureCheckbox\"\n                    [(ngModel)]=\"_teleprocedures\"\n                    aria-describedby=\"errorMessage\"\n                    required>\n                <label class=\"form-check-label lb_clickable\" for=\"teleprocedureCheckbox\">J'accepte l'utilisation des téléprocédures pour cette requête.</label>\n            </div>\n\n            <div class=\"form-check\">\n                <input\n                    type=\"checkbox\"\n                    class=\"form-check-input\"\n                    name=\"cguCheckbox\"\n                    id=\"cguCheckbox\"\n                    [(ngModel)]=\"_cgu\"\n                    aria-describedby=\"errorMessage\"\n                    required>\n                <label class=\"form-check-label lb_clickable\" for=\"cguCheckbox\">J’ai lu et j’accepte les conditions générales d’utilisation.</label>\n            </div>\n        </div>\n        <div class=\"col-12\">\n            <div\n            class=\"alert alert-danger alert-secondary\"\n            *ngIf=\"form.invalid && isSubmitted\"\n            id=\"errorMessage\">\n                Vous devez accepter ces 2 éléments en cochant les cases pour passer à l'étape suivante.\n            </div>\n        </div>\n        <div class=\"btn pull-right\">\n            <jhi-next-button [label]=\"'Page suivante - Code'\" [clickHandler]=\"next.bind(this)\"></jhi-next-button>\n        </div>\n    </form>\n</div>\n"

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container justify-content-md-center\">\n    <div class=\"col-lg-8 offset-lg-2 col-sm-12 text-center my-2\">\n      <i class=\"fa fa-envelope-o fa-5x\" aria-hidden=\"true\"></i>\n    </div>\n    <div class=\"row\">\n      <h2 class=\"px-4\">Votre demande de rattachement est confirmée</h2>\n    </div>\n\n    <div class=\"row py-3\">\n      <p>Vous avez fait les démarches nécessaires pour avoir accès à ce dossier.</p>\n      <p>\n        La procédure de rattachement sera finalisée d'ici 24 heures au plus tard.\n        Vous recevrez un courriel d'avertissement dès l'opération finalisée,\n        et vous pourrez accéder à ce dossier depuis la page d'accueil.\n      </p>\n    </div>\n</div>\n<div class=\"row col-12 center-btn\">\n    <jhi-button icon=\"fa fa-home\" (onClick)=\"goToHome()\">\n        Retourner à l'accueil\n    </jhi-button>\n</div>\n"

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container\">\n    <form (ngSubmit)=\"valider()\" (keydown.enter)=\"$event.preventDefault()\" novalidate>\n\n        <div class=\"row p-3\">\n            <h2>Veuillez entrer le code Télérecours citoyens</h2>\n            <div class=\"explication col-12\">\n                <p>\n                    Vous avez reçu un courrier comportant un code confidentiel vous permettant d'accéder à un dossier vous concernant.<br/>\n                    Pour relier ce dossier à votre compte personnel, veuillez saisir avant la date indiquée le code dans l'espace ci-dessous.\n                </p>\n                <p>\n                    Exemples : C75&nbsp;-&nbsp;1800251&nbsp;-&nbsp;444525218 ou T75&nbsp;-&nbsp;1800004&nbsp;-&nbsp;766185224 ou CE&nbsp;360001&nbsp;508089709\n                </p>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-12 p-3\">\n                <div class=\"field-hint\">\n                    <span> * champ obligatoire</span>\n                </div>\n                <div class=\"form-group required focus-outline\" [class.invalid]=\"form.touched && form.invalid\">\n                    <label for=\"secretCode\" [ngClass]=\"'has-value'\">Mon code confidentiel</label>\n                    <div class=\"input-group\">\n                        <input\n                        type=\"text\"\n                        class=\"form-control\"\n                        id=\"secretCode\"\n                        name=\"secretCode\"\n                        autocomplete=\"off\"\n                        aria-describedby=\"errorMessageCode\"\n                        [(ngModel)]=\"secretCode\"\n                        placeholder=\"Veuillez saisir votre code confidentiel\"\n                        required>\n                    </div>\n                </div>\n                <jhi-messages [id]=\"'errorMessageCode'\">\n                    <jhi-message error=\"required\" controlKey=\"secretCode\">\n                        <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Code'}\"></div>\n                    </jhi-message>\n                    <jhi-message error=\"technical\" controlKey=\"secretCode\">\n                        <div>Une erreur technique s'est produite, veuillez recommencer dans quelques heures.</div>\n                    </jhi-message>\n                    <jhi-message error=\"syntax\" controlKey=\"secretCode\">\n                        <div>Le code que vous venez d'inscrire n'est pas valide. Vérifiez les caractères renseignés puis réessayez</div>\n                    </jhi-message>\n                    <jhi-message error=\"semantic\" controlKey=\"secretCode\">\n                        <div>\n                            <p>\n                                Le code {{ secretCode }} que vous venez de renseigner n'est pas valide.\n                                Avez-vous renseigné le même code que celui présent sur votre courrier ?\n                                Si c'est le cas, vous pouvez\n                                <a role=\"alert\" class=\"alert-link\" href=\"https://www.conseil-etat.fr/#carte-juridiction\" rel=\"noopener noreferrer\" target=\"_blank\">\n                                    contacter le greffe\n                                </a> pour plus d'information.\n                            </p>\n                        </div>\n                    </jhi-message>\n                    <jhi-message error=\"already-attached-fetchable\" controlKey=\"secretCode\">\n                        <div *ngIf=\"error\">\n                            Ce dossier a déjà été rattaché à votre compte. Vous pouvez y accéder depuis la page d'accueil ou en\n                            <a role=\"alert\" class=\"alert-link\" href=\"/#/historique/{{error.requeteId}}\">cliquant ici.</a>.\n                        </div>\n                    </jhi-message>\n                    <jhi-message error=\"already-attached-listable\" controlKey=\"secretCode\">\n                        <div>\n                            Ce dossier est déjà en cours de rattachement à votre compte. Vous pourrez y accéder prochainement depuis la page d'accueil.\n                        </div>\n                    </jhi-message>\n                    <jhi-message error=\"already-attached-unknown\" controlKey=\"secretCode\">\n                        <div>\n                            Ce code de rattachement a déjà été utilisé. Vérifiez les caractères renseignés puis réessayez.\n                        </div>\n                    </jhi-message>\n                    <jhi-message error=\"expired\" controlKey=\"secretCode\">\n                        <div>\n                            Ce code de rattachement a expiré, vous pouvez\n                            <a role=\"alert\" class=\"alert-link\"\n                               href=\"https://www.conseil-etat.fr/#carte-juridiction\" rel=\"noopener noreferrer\" target=\"_blank\">\n                                contacter le greffe\n                            </a> pour obtenir un nouveau code.\n                        </div>\n                    </jhi-message>\n                </jhi-messages>\n            </div>\n        </div>\n\n\t    <div class=\"col-12 btn-group\">\n            <jhi-previous-button [clickHandler]=\"previous.bind(this)\"></jhi-previous-button>\n            <jhi-button icon=\"fa-check-circle\" iconRight [isLoading]=\"isLoading\" [isDisabled]=\"isDisabled\" confirmation>\n                Rattacher le dossier\n            </jhi-button>\n        </div>\n   </form>\n</div>\n"

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "\n<jhi-jumbotron>\n    <jhi-requete-title class=\"col-12 size-42\"\n        [numeroRequete]=\"requeteSummary?.numeroRequete\"\n        [siteJuridictionLabel]=\"requeteSummary?.juridiction\"\n        [titre]=\"requeteSummary?.titre\"\n        *ngIf=\"requeteSummary\">\n    </jhi-requete-title>\n</jhi-jumbotron>\n<div class=\"container-fluid\" *ngIf=\"requeteSummary\">\n    <form class=\"container\" novalidate>\n        <h2 class=\"mb-4\">Ajout des documents complémentaires</h2>\n        <section>\n\n            <h3>Ajouter un courrier / mémoire</h3>\n\n            <div class=\"explication\">\n                <p>Vous pouvez présenter au juge vos demandes (\"conclusions\") et vos arguments de droit et de fait\n                    qui les justifient (\"moyens\").</p>\n                <p>Si vous avez déjà présenté précédemment ces conclusions et moyens,\n                    vous n’avez besoin de les mentionner à nouveau que\n                    si une demande de mémoire récapitulatif vous a été adressée.</p>\n            </div>\n\n            <jhi-file-uploader inputName=\"memoire\" label=\"Courrier / Mémoire\" (fileChange)=\"onMemoireChange($event)\" [url]=\"uploadUrl\">\n            </jhi-file-uploader>\n        </section>\n\n        <section>\n            <h3>Ajouter des pièces complémentaires</h3>\n\n            <div class=\"explication\">\n                <p>Vous pouvez déposer ici, à l’appui de votre requête, toutes les pièces en votre possession qui\n                    permettront d’éclairer le juge.</p>\n                <p>Vous pouvez les classer selon l’ordre qui vous semble le plus adapté pour une meilleure\n                    compréhension.</p>\n                <p>Pour que votre requête puisse être recevable, il vous faut déposer un fichier par pièce.</p>\n                <p>Les fichiers doivent être nommés en leur donnant un intitulé qui décrit leur contenu de manière\n                    suffisamment explicite, sous peine d’être écartés des débats.</p>\n            </div>\n\n            <div dragula=\"piecesComplementairesBag\" [dragulaModel]=\"pieceComplementaireArray\">\n                <div class=\"row no-gutters\" *ngFor=\"let piece of pieceComplementaireArray; let i = index; trackBy: trackByFileApiId\">\n                    <div class=\"col-1 handle\"\n                         tabindex=\"0\" [id]=\"trackByFileApiId(i, piece)\" role=\"button\" aria-label=\"déplacer ce fichier\"\n                         jhiA11yDragNDropDirective [index]=\"i\" [piece]=\"piece\" [selectedItem]=\"selectedItem\"\n                         (a11ySelect)=\"onSelect($event)\" (a11yMoveup)=\"onMoveup($event)\"\n                         (a11yMovedown)=\"onMovedown($event)\" (a11yEscape)=\"onEscape($event)\">\n                        <i class=\"fa fa-arrows fa-2x\" aria-hidden=\"true\"></i>\n                    </div>\n                    <div class=\"col-11\">\n                        <jhi-file-uploader inputName=\"piece-{{piece.fileModel.fileApiId}}\"\n                            label=\"Pièce complémentaire n°{{i + 1}}\" [file]=\"piece.fileModel\"\n                            (fileChange)=\"onPieceDelete(i, $event)\"\n                            [url]=\"uploadUrl\">\n                        </jhi-file-uploader>\n                        <div class=\"form-group required name\">\n                            <label [class.has-value]=\"renameInput.value\">Nommer la pièce n°{{i + 1 }}</label>\n                            <div class=\"input-group\">\n                                <input\n                                    [attr.aria-label]=\"piece.libelle\"\n                                type=\"text\"\n                                class=\"form-control\"\n                                name=\"piece-{{piece.fileModel.fileApiId}}-name\"\n                                required\n                                jhiWhitespace\n                                aria-describedby=\"errorMessagePieceComplementaire\"\n                                [ngModel]=\"piece.libelle\"\n                                (ngModelChange)=\"checkLengthForFileName($event)\"\n                                (blur)=\"onRenamePiece(piece, $event.target.value)\"\n                                #renameInput>\n                            </div>\n                        </div>\n                        <div *ngIf=\"showLengthWarningForFileName\" role=\"alert\" class=\"alert alert-warning alert-secondary\">\n                            <div jhiTranslate=\"entity.warning.maxlength\"\n                                translateValues=\"{actualLength: {{actualFileNameLength}}, max: {{maxFileNameWithoutExtensionLength}}}\"></div>\n                        </div>\n                        <jhi-messages [id]=\"'errorMessagePieceComplementaire'\">\n                            <jhi-message error=\"required\" controlKey=\"piece-{{piece.fileModel.fileApiId}}-name\">\n                                <span>Pour passer à l'étape suivante, vous devez nommer cette pièce complémentaire</span>\n                            </jhi-message>\n                            <jhi-message error=\"invalid-whitespace\" controlKey=\"piece-{{piece.fileModel.fileApiId}}-name\">\n                                <span>Pour passer à l'étape suivante, vous devez utiliser au moins un caractère</span>\n                            </jhi-message>\n                        </jhi-messages>\n                    </div>\n                </div>\n            </div>\n            <jhi-file-uploader inputName=\"piece-adder\"\n                label=\"Pièce complémentaire n°{{pieceComplementaireArray.length + 1}}\"\n                (fileChange)=\"onPieceAdd($event)\"\n                               [url]=\"uploadUrl\"\n                               *ngIf=\"pieceComplementaireArray.length < maxNumberJointsPieces\"\n                               #pieceAdder>\n            </jhi-file-uploader>\n        </section>\n\n        <section>\n            <h3>Ajouter des pièces complémentaires envoyées par voie postale</h3>\n\n            <div class=\"explication\">\n                <p>Vous souhaitez joindre des éléments qui ne peuvent faire l’objet d’une numérisation du fait de\n                    leur format (plans d’architecte, etc.) ?</p>\n                <p>Vous pouvez les transmettre sur support matériel, par voie postale ou en les déposant\n                    directement au greffe de la juridiction administrative que vous avez\n                    sélectionnée, en les nommant ci-dessous et en reportant le même nom sur celles-ci.</p>\n            </div>\n            <jhi-piece-postales [pieces]=\"piecePostaleArray\"></jhi-piece-postales>\n        </section>\n\n        <div class=\"col-lg-8 offset-lg-2\" *ngIf=\"!isPieceEmpty()\">\n            <div class=\"rename-check\">\n                <input type=\"checkbox\" id=\"conditionRenommage\"\n                    name=\"conditionRenommageCheckbox\" [(ngModel)]=\"conditionRenommage\"\n                    required\n                    aria-describedby=\"errorMessagePieceCheckbox\">\n                <label for=\"conditionRenommage\" class=\"lb_clickable\">J’ai bien nommé mes\n                    pièces complémentaires en leur donnant un intitulé qui décrit leur contenu\n                    de manière suffisamment explicite (Articles R 414-5 & R 611-8-5 du code de justice administrative).</label>\n            </div>\n\n            <jhi-messages [id]=\"'errorMessagePieceCheckbox'\">\n                <jhi-message [error]=\"'required'\" [controlKey]=\"'conditionRenommageCheckbox'\">\n                    <span>Pour passer à l'étape suivante, vous devez cocher la case relative au nommage de\n                        pièces complémentaires.</span>\n                </jhi-message>\n            </jhi-messages>\n        </div>\n\n        <div *ngIf=\"isEmptyError\" class=\"col-12 ng-invalid mt-3 mb-3\">\n            <div role=\"alert\" class=\"alert alert-danger\">Pour envoyer, vous devez télécharger un mémoire ou un courrier, une pièce complémentaire, ou nommer une\n                pièce complémentaire transmise par voie postale.</div>\n        </div>\n\n        <div *ngIf=\"isDeactivedPopup\" class=\"col-12 alert alert-danger\">Pour visualiser l'inventaire de vos pièces\n            complémentaires, merci d'autoriser les popups.</div>\n        <div *ngIf=\"isError\" class=\"col-12 alert alert-danger\">Une erreur technique s'est produite, veuillez recommencer ultérieurement.</div>\n\n        <section class=\"col-12\">\n            <div class=\"btn-group\">\n                <jhi-previous-button [label]=\"'Retour vers le dossier'\" [clickHandler]=\"previous.bind(this)\"></jhi-previous-button>\n                <div class=\"text-center center d-none d-md-block btn-link\" *ngIf=\"!isPieceEmpty()\">\n                    <a (click)=\"openInventaire()\">Consulter l'inventaire des pièces</a>\n                </div>\n                <jhi-button confirmation (onClick)=\"submitForm()\" [isDisabled]=\"isError || isLoading\"\n                        icon=\"fa-check-circle\"\n                        iconRight\n                        [isLoading]=\"isLoading\">\n                    Envoyer les documents complémentaires\n                </jhi-button>\n            </div>\n\n        </section>\n    </form>\n</div>\n"

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row\">\n    <div class=\"col-lg-4 col-sm-12 order-lg-2 sidebar\">\n        <div *ngIf=\"dossier?.syntheseDossier?.LIB_ETA\">\n            <h2>État du Dossier</h2>\n            <p>{{dossier?.syntheseDossier?.LIB_ETA}}</p>\n\n        </div>\n\n        <!-- BEGIN ajouter des courriers / pieces  -->\n        <div *ngIf=\"canAddPieces()\">\n            <div class=\"btn btn-primary\">\n                <a routerLink=\"./document\" routerLinkActive=\"active\" (click)=\"trackAjoutDoc()\">\n                    <span>Ajouter des documents complémentaires</span>\n                    <span class=\"fa fa-plus\" aria-hidden=\"true\"></span>\n                </a>\n            </div>\n        </div>\n        <hr>\n        <!-- END ajouter des courriers / pieces  -->\n        <div>\n            <h2>Nom du dossier</h2>\n            <p class=\"alias-container\">\n                <span  class=\"abbreviate-container\">\n                    <jhi-abbreviate [text]=\"dossier?.titre\"></jhi-abbreviate>\n                </span>\n                <button class=\"no-border\" (click)=\"openRequete(dossier?.titre)\" tabindex=\"0\" aria-label=\"Renommer votre dossier\">\n                    <span class=\"fa fa-pencil-square-o edit-button\" aria-hidden=\"true\"\n                        ngbTooltip=\"Renommer votre dossier\">\n                    </span>\n                    <span class=\"sr-only\">Renommer votre dossier</span>\n                </button>\n            </p>\n            <div *ngIf=\"dossier?.renamed\">\n                <jhi-alert></jhi-alert>\n            </div>\n        </div>\n\n        <div *ngIf=\"mandataires.length\">\n            <h2>Mandataire(s)</h2>\n            <p *ngFor=\"let mandataire of mandataires\">\n                <jhi-abbreviate [text]=\"mandataire?.nom\"></jhi-abbreviate>\n            </p>\n        </div>\n        <div *ngIf=\"requerants.length\">\n            <h2>Requérant(s)</h2>\n            <p *ngFor=\"let requerant of requerants\">\n                <jhi-abbreviate [text]=\"requerant?.nom\"></jhi-abbreviate><br>\n                <jhi-abbreviate *ngIf=\"requerant?.nomMandataire\" text=\"représenté(e) par {{requerant?.nomMandataire}}\"></jhi-abbreviate>\n            </p>\n        </div>\n        <div *ngIf=\"defendeurs.length\">\n            <h2>Défendeur(s)</h2>\n            <p *ngFor=\"let defendeur of defendeurs\">\n                <jhi-abbreviate [text]=\"defendeur?.nom\"></jhi-abbreviate><br>\n                <jhi-abbreviate *ngIf=\"defendeur?.nomMandataire\" text=\"représenté(e) par {{defendeur?.nomMandataire}}\"></jhi-abbreviate>\n            </p>\n        </div>\n        <div *ngIf=\"intervenantsReq.length\">\n            <h2>Intervenant(s) pour le requérant</h2>\n            <p *ngFor=\"let intervenantReq of intervenantsReq\">\n                <jhi-abbreviate [text]=\"intervenantReq.nom\"></jhi-abbreviate>\n            </p>\n        </div>\n        <div *ngIf=\"intervenantsDef.length\">\n            <h2>Intervenant(s) pour le défendeur</h2>\n            <p *ngFor=\"let intervenantDef of intervenantsDef\">\n                <jhi-abbreviate [text]=\"intervenantDef.nom\"></jhi-abbreviate>\n            </p>\n        </div>\n        <div *ngIf=\"observateurs.length\">\n            <h2>Observateur(s)</h2>\n            <p *ngFor=\"let observateur of observateurs\">\n                <jhi-abbreviate [text]=\"observateur.nom\"></jhi-abbreviate>\n            </p>\n        </div>\n\n        <div *ngIf=\"dossier?.dossierCorreles.length > 0\">\n            <h2>Dossiers corrélés</h2>\n            <ng-container *ngFor=\"let dossierCorrele of dossier.dossierCorreles\">\n                <p *ngIf=\"dossierCorrele.id !== dossier.id\">\n                    <a [routerLink]=\"['/historique', dossierCorrele.id ]\">{{dossierCorrele.numeroRequete}}</a>\n                </p>\n            </ng-container>\n        </div>\n    </div>\n\n\n    <div class=\"col-lg-8 col-sm-12 order-lg-1 main\">\n        <div *ngIf=\"dossier?.syntheseDossier?.ANALYSE\">\n            <h1>Analyse</h1>\n            <p>{{dossier?.syntheseDossier?.ANALYSE}}</p>\n        </div>\n        <div *ngIf=\"dossier?.sensConclusions?.length\">\n            <h1>Sens des conclusions</h1>\n            <p *ngFor=\"let sensConclusion of dossier?.sensConclusions\">\n                <ng-container *ngIf=\"sensConclusion.SENS_SYNTHETIQUE_CONC\">\n                    {{sensConclusion.SENS_SYNTHETIQUE_CONC}} :\n                </ng-container>\n                {{sensConclusion.SENS_CONCLUSION}}\n            </p>\n        </div>\n        <div *ngIf=\"dossier?.syntheseDossier?.DISPOSITIF\">\n            <h1>Dispositif</h1>\n            <p>\n                {{dossier?.syntheseDossier?.DISPOSITIF}}\n            </p>\n        </div>\n\n        <div *ngIf=\"dossier?.events != null\">\n            <h1>Historique\n                <button (click)=\"toggleOrder()\" class=\"pull-right inverser-lordre-chr mt-2\" tabindex=\"0\">Inverser l'ordre\n                    chronologique</button>\n            </h1>\n            <jhi-timeline [mesures]=\"dossier?.events\" [orderAsc]=\"orderAsc\" [parties]=\"dossier?.parties\"\n                [juridiction]=\"dossier?.siteJuridictionLabel\"></jhi-timeline>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "<jhi-adblocker-detector></jhi-adblocker-detector>\n<jhi-jumbotron>\n    <jhi-requete-title class=\"col-12 size-42\"\n        [numeroRequete]=\"dossier?.numeroRequete\"\n        [siteJuridictionLabel]=\"dossier?.siteJuridictionLabel\"\n        [affectation]=\"dossier?.syntheseDossier?.AFFECTATION\"\n        [titre]=\"dossier?.titre\"\n        *ngIf=\"dossier && !showDossierNonAccessible\">\n    </jhi-requete-title>\n    <h4 *ngIf=\"showDossierNonAccessible\">Vous n'avez plus accès au dossier {{dossier?.numeroRequete}} auprès {{siteJuridictionLabelMsg}}.</h4>\n</jhi-jumbotron>\n<div class=\"container-fluid\">\n    <jhi-dossier *ngIf=\"dossier && !showDossierNonAccessible\" [dossier]=\"dossier\"></jhi-dossier>\n    <div class=\"row\" *ngIf=\"displayLoading()\">Chargement du dossier en cours...</div>\n\n    <!-- Alert -->\n    <div *ngIf=\"hasError || showDossierNonAccessible\">\n        <jhi-alert></jhi-alert>\n    </div>\n\n</div>\n"

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row py-2\" [ngClass]=\"getClass()\">\n    <div class=\"col-12 col-md-2\">\n        <div class=\"date text-center\">\n            {{ mesure.dateEvt | localDate:'dd/MM/yyyy' }}\n            <span *ngIf=\"convertTime(mesure.dateEvt)\"> <br> à {{ mesure.dateEvt | localDate:'shortTime' }}</span>\n        </div>\n    </div>\n    <div class=\"d-none d-lg-block col-md-1 puce-container\">\n        <div class=\"puce center\"></div>\n    </div>\n    <div class=\"col-12 col-md-9\">\n        <div class=\"titre-timeline\">\n            <div *ngIf=\"de\">\n                <span class=\"expediteur\">DE :</span>\n                <span class=\"expediteur_nom\">\n                    <jhi-abbreviate [text]=\"de\"></jhi-abbreviate>\n                </span>\n            </div>\n            <div *ngIf=\"a\">\n                <span class=\"destinataire\">A :</span>\n                <span class=\"destinataire_nom\">\n                    <jhi-abbreviate [text]=\"a\"></jhi-abbreviate>\n                </span>\n            </div>\n            <div id=\"mesure\">{{mesure.mesureLibelle}}</div>\n            <div class=\"accuseLecture\" *ngIf=\"isCourrierLu\">\n                Lu <span *ngIf=\"mesure.dateReception\">le {{ mesure.dateReception | localDate:'dd/MM/yyyy' }}</span>\n                <span *ngIf=\"convertTime(mesure.dateReception)\"> à {{ mesure.dateReception | localDate:'shortTime' }}</span>\n            </div>\n        </div>\n\n        <div *ngIf=\"getFichier()\">\n            <hr>\n            <div class=\"fichier mt-2 pl-5\" *ngFor=\"let fichier of getFichier()\" role=\"list\">\n                <a (click)=\"downloadFile(mesure.id, mesure.type, fichier)\" role=\"listitem\">\n                    <span class=\"fichier-libelle\" tabindex=\"0\">{{fichier.libelle | extToPdf}}</span>\n                    <button class=\"pull-right mr-3 d-none d-md-inline no-border\" role=\"button\" aria-label=\"Télécharger\">\n                        <i class=\"fa fa-download\" aria-hidden=\"true\" title=\"télécharger\"></i>\n                        <span class=\"sr-only\">Télécharger</span>\n                    </button>\n                </a>\n            </div>\n        </div>\n\n    </div>\n</div>\n"

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "<div class=\"timeline\">\n    <div class=\"timelineElement\" *ngFor=\"let mesure of mesures\">\n        <jhi-timeline-element *ngIf=\"getCouleurMap().size > 0\"  [mesure]=\"mesure\" [couleurMap]=\"getCouleurMap()\" [juridiction]=\"juridiction\"></jhi-timeline-element>\n    </div>\n</div>\n"

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "<span #container placement=\"top\" [ngbTooltip]=\"isEllipsised && text\" class=\"tooltips\" triggers=\"hover click blur\">\n    {{text || \"(vide)\"}}\n</span>\n"

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "<ng-container class=\"modal-container\">\n    <div aria-modal=\"true\"\n         role=\"dialog\"\n         aria-labelledby=\"dialog_rename_label\"\n         aria-describedby=\"dialog_rename_desc\"\n         jhiTrapFocus>\n        <div class=\"modal-header\">\n            <h2 id=\"dialog_rename_label\">\n                Renommer votre dossier\n            </h2>\n            <button type=\"button\" class=\"modal-close\" aria-label=\"Fermer la fenêtre\" (click)=\"activeModal.dismiss('Cross click')\">\n                <span class=\"fa fa-times\" aria-hidden=\"true\" title=\"Fermer la fenêtre\"></span>\n                <span class=\"sr-only\">Fermer la fenêtre</span>\n            </button>\n        </div>\n        <div class=\"modal-body\">\n            <p id=\"dialog_rename_desc\">En renommant votre dossier, vous pourrez le reconnaître plus facilement. Vous êtes\n                la seule personne à pouvoir\n                voir ce nom</p>\n            <form>\n                <jhi-input [id]=\"'newTitle'\" name=\"newTitle\" label=\"Nom du dossier\" [(ngModel)]=\"newTitle\" (input)=\"onTitleChange($event)\" autocomplete=\"\">\n                </jhi-input>\n                <div *ngIf=\"titleLengthExceeded\" role=\"alert\" class=\"alert alert-warning\">\n                    <span jhiTranslate=\"entity.warning.maxlength\"\n                        translateValues=\"{actualLength: {{newTitle.length}}, max: {{maxTitleLength}}}\"></span>\n                </div>\n            </form>\n        </div>\n        <div class=\"modal-footer\">\n            <jhi-button cancellation (click)=\"activeModal.dismiss('Cross click')\">Annuler</jhi-button>\n            <jhi-button confirmation (click)=\"onSave()\" icon=\"fa-save\" iconRight>Enregistrer</jhi-button>\n        </div>\n    </div>\n</ng-container>\n"

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h1>Dossier : {{ numeroRequete }} </h1>\n</div>\n<h2 *ngIf=\"titre\" class=\"banner-subtitle\">{{titre}}</h2>\n\n<h4>\n    <span class=\"fa fa-map-marker\" aria-hidden=\"true\"></span>\n    Juridiction : {{ siteJuridictionLabel }}\n    <span *ngIf=\"affectation\"> - {{ affectation }}</span>\n</h4>\n"

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"adBlockerDetected\" class=\"container-fuild\">\n    <div class=\"exclamation-icon item\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i></div>\n    <div class=\"item\">\n        <h3 class=\"adblock-warning-title\">Le bloqueur de publicités a besoin d'être désactivé sur ce site</h3>\n        <p class=\"adblock-warning-text\">Afin de pouvoir visualiser les documents de votre requête, nous vous recommandons de désactiver ce bloqueur pour l'utilisation de ce site.</p>\n    </div>\n</div>\n"

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "<jhi-field class=\"col-12 col-lg-4 py-2 pr-lg-3\">\n  <jhi-input [id]=\"'adresse1'\" name=\"adresse1\" pattern=\".*\\S+.*\" [type]=\"'text'\" [autocomplete]=\"'street-address'\"\n              label=\"Adresse\" [(ngModel)]=\"address.adresse1\" required maxlength=\"32\" [ariaDescribedBy]=\"'errorMessageAdresse1'\">\n  </jhi-input>\n  <jhi-messages [id]=\"'errorMessageAdresse1'\">\n    <jhi-message error=\"required\" controlKey=\"adresse1\" *ngIf=\"isCreateAccountBtnClicked\">\n        <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Adresse'}\"></div>\n    </jhi-message>\n    <jhi-message error=\"pattern\" controlKey=\"adresse1\">\n        <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Adresse'}\"></div>\n    </jhi-message>\n    <jhi-message error=\"maxlength\" controlKey=\"adresse1\">\n        <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 32}\"></div>\n    </jhi-message>\n  </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-4 py-2 pr-lg-3\">\n  <jhi-input [id]=\"'adresse2'\" name=\"adresse2\" [type]=\"'text'\" [autocomplete]=\"'address-line1'\"\n              label=\"Complément d'adresse\" [(ngModel)]=\"address.adresse2\" maxlength=\"32\" [ariaDescribedBy]=\"'errorMessageAdresse2'\">\n  </jhi-input>\n    <jhi-messages [id]=\"'errorMessageAdresse2'\">\n        <jhi-message error=\"maxlength\" controlKey=\"adresse2\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 32}\"></div>\n        </jhi-message>\n    </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-4 py-2\">\n  <jhi-input [id]=\"'adresse3'\" name=\"adresse3\" [type]=\"'text'\" [autocomplete]=\"'address-line2'\"\n              label=\"Complément d'adresse - suite\" [(ngModel)]=\"address.adresse3\" maxlength=\"32\" [ariaDescribedBy]=\"'errorMessageAdresse3'\">\n  </jhi-input>\n    <jhi-messages [id]=\"'errorMessageAdresse3'\">\n        <jhi-message error=\"maxlength\" controlKey=\"adresse3\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 32}\"></div>\n        </jhi-message>\n    </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-4 py-2 pr-lg-3\">\n  <jhi-input [id]=\"'codePostal'\" [type]=\"'tel'\" name=\"codePostal\" [autocomplete]=\"'postal-code'\"\n              label=\"Code postal\" [(ngModel)]=\"address.codePostal\" required jhiOnlyNumber jhiPostcode [ariaDescribedBy]=\"'errorMessageCodePostal'\">\n  </jhi-input>\n\n  <jhi-messages [id]=\"'errorMessageCodePostal'\">\n    <jhi-message error=\"required\" controlKey=\"codePostal\" *ngIf=\"isCreateAccountBtnClicked\">\n        <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Code postal'}\"></div>\n    </jhi-message>\n    <jhi-message error=\"invalid-postcode\" controlKey=\"codePostal\">\n        <div>Le code postal doit comprendre minimum 5 chiffres et maximum 6 chiffres.</div>\n    </jhi-message>\n  </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-4 py-2 pr-lg-3\">\n  <jhi-input [id]=\"'ville'\" name=\"ville\" [type]=\"'text'\" [autocomplete]=\"'address-level2'\"\n              label=\"Ville\" [(ngModel)]=\"address.ville\" required jhiCapitalize jhiAlphaString maxlength=\"26\" [ariaDescribedBy]=\"'errorMessageVille'\">\n  </jhi-input>\n  <jhi-messages [id]=\"'errorMessageVille'\">\n      <jhi-message error=\"required\" controlKey=\"ville\" *ngIf=\"isCreateAccountBtnClicked\">\n          <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Ville'}\"></div>\n      </jhi-message>\n        <jhi-message error=\"maxlength\" controlKey=\"ville\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 26}\"></div>\n        </jhi-message>\n  </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-4 py-2\">\n  <jhi-select [id]=\"'pays'\" name=\"pays\" label=\"Pays\" hiddenOptionLabel=\"Choisir un pays\" [(ngModel)]=\"address.pays\" required>\n      <jhi-option *ngFor=\"let country of countries\" [value]=\"country.label\">{{ country.label }} </jhi-option>\n  </jhi-select>\n  <jhi-messages role=\"alert\">\n      <jhi-message error=\"required\" controlKey=\"pays\" *ngIf=\"isCreateAccountBtnClicked\">\n          <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Pays'}\"></div>\n      </jhi-message>\n  </jhi-messages>\n</jhi-field>\n"

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row timeline col-lg-12 d-none d-lg-block\">\n    <ol>\n        <li\n            class=\"col\"\n            *ngFor=\"let step of steps; let stepIndex = index\"\n            [ngClass]=\"{ 'active': step.isActive, 'validated': activeStepIndex > stepIndex }\">\n            <span class=\"text-center m-auto titre\" [attr.aria-current]=\"step.isActive ? 'step' : undefined\">{{ step.label }}</span>\n            <span class=\"ligne2\" [ngClass]=\"{'start': (stepIndex === 0), 'end': stepIndex === (steps.length - 1) }\"></span>\n        </li>\n    </ol>\n</div>\n"

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports = "<div class=\"captcha row\">\n\t<div class=\"explication\">\n\t\t<p>Veuillez recopier les caractères ci-dessous.</p>\n\t</div>\n\n\t<div class=\"col-12 col-md-8 px-0\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-9 col-md-4 px-0\">\n\t\t\t\t<img\n\t\t\t\t\t[src]=\"imageCaptchaUrl\" \n\t\t\t\t\talt=\"Captcha\"\n\t\t\t\t\t*ngIf=\"imageCaptchaUrl\"\n\t\t\t\t\tclass=\"mx-0 w-100\">\n\t\t\t</div>\n\t\t\t<button \n\t\t\t\tclass=\"btn btn-circle rounded-circle\"\n\t\t\t\t(click)=\"onAudioPlay()\"\n\t\t\t\t[attr.aria-label]=\"'Écouter le code'\"\n\t\t\t\tngbTooltip=\"Écouter le code\"\n\t\t\t\ttype=\"button\"\n\t\t\t\t>\n\t\t\t\t<i class=\"fa fa-volume-up\" aria-hidden=\"true\"></i>\n\t\t\t\t<span class=\"sr-only\">Écouter le code</span>\n\t\t\t</button>\n\t\t\t<button \n\t\t\t\tclass=\"btn btn-circle rounded-circle ml-2\"\n\t\t\t\t(click)=\"reload()\"\n\t\t\t\t[attr.aria-label]=\"'Changer le code'\"\n\t\t\t\tngbTooltip=\"Changer le code\"\n\t\t\t\ttype=\"button\"\n\t\t\t\t>\n\t\t\t\t<i class=\"fa fa-refresh\" aria-hidden=\"true\"></i>\n\t\t\t\t<span class=\"sr-only\">Changer le code</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\n    <div class=\"col-12 col-md-5 mt-3 px-0\">\n        <div class=\"form-group required mb-1\" [class.invalid]=\"isInvalid\">\n\t\t\t<label for=\"captcha-input\" [ngClass]=\"'has-value'\">Code de sécurité (CAPTCHA)</label>\n\t\t\t<input \n\t\t\t\ttype=\"text\" \n\t\t\t\tclass=\"form-control focus-outline\" \n\t\t\t\tid=\"captcha-input\" \n\t\t\t\tname=\"captcha-input\"\n\t\t\t\t[attr.aria-required]=\"true\"\n\t\t\t\t[attr.aria-invalid]=\"isInvalid\"\n\t\t\t\tautocomplete=\"one-time-code\"\n\t\t\t\t#captcha=\"ngModel\" \n\t\t\t\t[(ngModel)]=\"captchaTexte.texte\"\n\t\t\t\taria-describedby=\"passwordHelpBlock errorMessageCaptcha\">\n\t\t</div>\n\t\t<small id=\"passwordHelpBlock\" class=\"form-text text-muted mb-3\">\n\t\t\t5 caractères maximum\n\t\t</small>\n\t\t<span class=\"sr-only\" *ngIf=\"wasCaptchaReloaded\" role=\"status\">Le code de sécurité a été mis à jour</span>\n\t</div>\n\t\n\t<div class=\"col-12 col-md-5 px-0\">\n\t\t<jhi-messages role=\"alert\">\n\t\t\t<ng-content></ng-content>\n\t\t</jhi-messages>\n\t</div>\n</div>\n"

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "<div [innerHTML]=\"changelog | safeHtml\"></div>\n"

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports = "<div [innerHTML]=\"cguText | safeHtml\"></div>\n"

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports = "\n<jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n  <jhi-input [id]=\"'telPortable'\" [type]=\"'tel'\" name=\"telPortable\" [autocomplete]=\"'tel'\"\n      label=\"Téléphone portable\" hintLabel=\"Exemple : 0123456789 ou +34 123 456 789\" [(ngModel)]=\"contact.numeroPortable\" pattern=\"\\d{10,15}\" jhiOnlyNumber [ariaDescribedBy]=\"'errorMessageTel'\">\n  </jhi-input>\n  <jhi-messages [id]=\"'errorMessageTel'\">\n      <jhi-message error=\"pattern\" controlKey=\"telPortable\">\n          <div>Le numéro de téléphone portable renseigné n'est pas valide.</div>\n      </jhi-message>\n  </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-6 py-2\">\n  <jhi-input [id]=\"'telFixe'\" [type]=\"'tel'\" name=\"telFixe\" [autocomplete]=\"'tel'\"\n      label=\"Téléphone fixe\" [(ngModel)]=\"contact.numeroFixe\" pattern=\"\\d{10,15}\" jhiOnlyNumber [ariaDescribedBy]=\"'errorMessageTelFixe'\">\n  </jhi-input>\n  <jhi-messages [id]=\"'errorMessageTelFixe'\">\n      <jhi-message error=\"pattern\" controlKey=\"telFixe\">\n          <div>Le numéro de téléphone fixe renseigné n'est pas valide.</div>\n      </jhi-message>\n  </jhi-messages>\n</jhi-field>\n"

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "<ng-container>\n    <div class=\"modal-content\"\n         aria-modal=\"true\"\n         role=\"dialog\"\n         aria-labelledby=\"dialog_delete_draft_label\"\n         jhiTrapFocus>\n        <div class=\"modal-header\">\n            <h4 class=\"modal-title\" id=\"dialog_delete_draft_label\"><strong>Suppression de votre brouillon en cours</strong></h4>\n            <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\n                <span aria-hidden=\"true\" title=\"fermer la fenêtre\">&times;</span>\n                <span class=\"sr-only\">Fermer la fenêtre</span>\n            </button>\n        </div>\n        <div class=\"modal-body\">\n            <p>\n                Êtes-vous sûr(e) de vouloir supprimer votre brouillon en cours ?\n            </p>\n        </div>\n        <div class=\"modal-footer footer-centered\">\n            <div class=\"col-12 btn-group\">\n                <jhi-button cancellation (click)=\"activeModal.dismiss('Cross click')\" >\n                    Annuler\n                </jhi-button>\n\n                <jhi-button (onClick)=\"deleteMyDraftRequete()\" confirmation>\n                    Je supprime mon brouillon\n                </jhi-button>\n            </div>\n        </div>\n    </div>\n</ng-container>\n"

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "<div class=\"main-content\">\n    <div class=\"info-cards\">\n        <div class=\"info-card\" *ngIf=\"acteur.isMorale && acteur.nomEntreprise\">\n            <div class=\"card-icon fa fa-briefcase\" aria-hidden=\"true\"></div>\n            <div class=\"card-content name\">\n                {{ acteur.nomEntreprise }}\n                <ng-container *ngIf=\"acteur.sigleEntreprise\">({{ acteur.sigleEntreprise }})</ng-container>\n            </div>\n        </div>\n        <div class=\"info-card\">\n            <div class=\"card-icon fa fa-address-card\" aria-hidden=\"true\"></div>\n            <div class=\"card-content\">\n                <div class=\"name\">\n                    {{ acteur.civilite }} {{ acteur.firstName }} {{ acteur.lastName }}\n                </div>\n                <div *ngIf=\"type != FicheTypeEnum.addedList\">{{acteur.email}}</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"address-card\" *ngIf=\"type !== FicheTypeEnum.addedList || acteur.isAnonymous\">\n        <div class=\"card-icon fa fa-map\" aria-hidden=\"true\"></div>\n        <div class=\"card-content\">\n            <div *ngIf=\"type === FicheTypeEnum.default\" [innerHtml]=\"addr1Line\"></div>\n            <div [innerHtml]=\"addr2Line\"></div>\n            <div *ngIf=\"type === FicheTypeEnum.addedList && phoneLine\" [innerHTML]=\"phoneLine\"></div>\n        </div>\n    </div>\n    <div class=\"requerant-card\" *ngIf=\"type === FicheTypeEnum.addedList && !acteur.isAnonymous\"\n        [ngClass]=\"{'with-principal-button': !isPrincipal && !acteur.isAnonymous}\">\n        <div class=\"card-icon fa\" [ngClass]=\"isPrincipal ? 'fa-users' : 'fa-user'\" aria-hidden=\"true\"></div>\n        <div class=\"card-content\">\n            Requérant<ng-container *ngIf=\"isPrincipal\"> principal</ng-container>\n        </div>\n        <jhi-button *ngIf=\"!isPrincipal && !acteur.isAnonymous\" flat secondary icon=\"fa-users\"\n            (click)=\"onClickToPrincipalButton()\">\n            Passer requérant principal\n        </jhi-button>\n    </div>\n</div>\n<div class=\"button\" *ngIf=\"isOnClickUsed\">\n    <button type=\"button\" class=\"btn-circle\" (click)=\"onClickIcon()\" data-toggle=\"tooltip\" data-placement=\"right\" title=\"{{tooltip}}\" [attr.aria-label]=\"tooltip\">\n        <span class=\"fa\" aria-hidden=\"true\"></span>\n        <span *ngIf=\"type == FicheTypeEnum.resultList\" class=\"sr-only\">Ajouter ce requérant</span>\n        <span *ngIf=\"type == FicheTypeEnum.addedList\" class=\"sr-only\">Supprimer définitivement ce requérant</span>\n        <span *ngIf=\"type != (FicheTypeEnum.addedList || FicheTypeEnum.resultList)\" class=\"sr-only\">Modifier mes informations personnelles</span>\n    </button>\n</div>\n"

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports = "\n<!-- Input shown during file select and upload-->\n<div *ngIf=\"!file\" class=\"form-group\" ng2FileDrop [uploader]=\"uploader\"\n    (fileOver)=\"fileOver($event)\" [ngClass]=\"{\n        'fileOver': hasFileOver,\n        'invalid': isInvalid(),\n        'uploading': isUploading,\n        'required' : required\n    }\" >\n    <label for=\"{{id}}\">{{ label }}</label>\n    <div class=\"input-group focus-outline\" tabindex=\"0\" role=\"group\">\n        <!-- Real input type file : put before fake input for scroll to first error-->\n        <input type=\"file\" tabindex=\"-1\" class=\"form-control\" [ngClass]=\"{'ng-invalid': validationInput.invalid}\"\n            ng2FileSelect [uploader]=\"uploader\" id=\"{{id}}\"\n            [accept]=\"acceptMimeType\" [disabled]=\"isUploading\" [attr.aria-label]=\"inputName\" aria-describedby=\"errorMessage\" #fileInput>\n        <!-- Fake input for validation purpose -->\n        <input type=\"text\" tabindex=\"-1\" [name]=\"inputName\" [required]=\"required\" ngModel hidden #validationInput=\"ngModel\">\n        <button class=\"input-group-append add-btn\" (click)=\"fileInput.click()\" aria-label=\"Ajouter une pièce\">\n            <i class=\"fa fa-plus\" aria-hidden=\"true\" title=\"Ajouter une pièce\"></i>\n            <span class=\"sr-only\">Ajouter une pièce</span>\n        </button>\n    </div>\n</div>\n\n<!-- Fake input to display and handle uploaded file -->\n<div *ngIf=\"file\" class=\"form-group\">\n    <label class=\"has-value\" for=\"{{id}}-view\">{{ label }}</label>\n    <div class=\"input-group\" tabindex=\"0\" role=\"group\">\n        <input type=\"text\" [ngModel]=\"file.fileItem.name\" name=\"{{inputName}}-view\" class=\"form-control\" id=\"{{id}}-view\" readonly [attr.aria-label]=\"inputName + '-view'\">\n        <div tabindex=\"0\" class=\"input-group-append\" role=\"contentinfo\">\n            <span>{{ file.fileSize | formatFileSize }}</span>\n        </div>\n        <button class=\"input-group-append download-btn\" (click)=\"viewFile()\" aria-label=\"Télécharger\">\n            <i class=\"fa fa-download\" aria-hidden=\"true\" title=\"télécharger\"></i>\n            <span class=\"sr-only\">Télécharger</span>\n        </button>\n        <button class=\"input-group-append trash-btn\" (click)=\"deleteFile()\" [disabled]=\"disabled\" aria-label=\"Supprimer\">\n            <i class=\"fa fa-trash\" aria-hidden=\"true\" title=\"supprimer\"></i>\n            <span class=\"sr-only\">Supprimer</span>\n        </button>\n    </div>\n    <jhi-message *ngIf=\"errorTrFonctionnel\">\n        <span>Nous rencontrons actuellement un problème technique qui ne permet pas l'accès à ce document. \n              L'incident est en cours de résolution. Nous vous invitons à réessayer dans 24h.</span>\n    </jhi-message>\n</div>\n\n<!-- Errors -->\n<jhi-messages *ngIf=\"isInvalid()\" [id]=\"'errorMessage'\">\n    <jhi-message [error]=\"'required'\" [controlKey]=\"inputName\">\n        <div>Pour passer à l'étape suivante, vous devez télécharger le document \"{{ label }}\" </div>\n    </jhi-message>\n    <!-- <jhi-message error=\"format\" [controlKey]=\"inputName\">\n        <span>Le fichier <strong>{{fileName}}</strong> n'a pas pu être téléchargé car seuls les formats de\n            fichiers\n            suivants sont acceptés : Doc, Docx, Pdf, Jpg, Png, Odt, Rtf, Jpeg, Gif.</span>\n    </jhi-message>\n    <jhi-message error=\"taille\" [controlKey]=\"inputName\">\n        <span>Le fichier <strong>{{fileName}}</strong> ne peut être ajouté car sa taille est supérieure à {{maxFileSize | formatFileSize}}.\n            Réduisez\n            sa taille avant de le télécharger à nouveau.</span>\n    </jhi-message>\n    <jhi-message error=\"nomFichier\" [controlKey]=\"inputName\">\n        <span>Le nom du fichier contient des symboles/caractères spéciaux non conformes. Veuillez renommer votre fichier et recommencer.</span>\n    </jhi-message>\n    <jhi-message error=\"technique\" [controlKey]=\"inputName\">\n        <span>Une erreur technique est survenue. Nous allons la corriger le plus rapidement possible. Veuillez\n            réessayer à nouveau dans quelques minutes.</span>\n    </jhi-message> -->\n    <jhi-message error=\"inprogress\" [controlKey]=\"inputName\">\n        <span>Pour valider, vous devez attendre la fin du téléchargement du fichier.</span>\n    </jhi-message>\n</jhi-messages>\n<div role=\"alert\" class=\"alert alert-danger\" *ngIf=\"tailleError\">\n    <span>Le fichier <strong>{{fileName}}</strong> ne peut être ajouté car sa taille est supérieure à {{maxFileSize | formatFileSize}}.\n        Réduisez sa taille avant de le télécharger à nouveau.\n    </span>\n</div>\n<div role=\"alert\" class=\"alert alert-danger\" *ngIf=\"formatError\">\n    <span>Le fichier <strong>{{fileName}}</strong> n'a pas pu être téléchargé car seuls les formats de fichiers\n        suivants sont acceptés : Doc, Docx, Pdf, Jpg, Png, Odt, Rtf, Jpeg, Gif.\n    </span>\n</div>\n<div role=\"alert\" class=\"alert alert-danger\" *ngIf=\"nomFichierError\">\n    <span>Le nom du fichier contient des symboles/caractères spéciaux non conformes. Veuillez renommer votre fichier et recommencer.</span>\n</div>\n<div role=\"alert\" class=\"alert alert-danger\" *ngIf=\"techniqueError\">\n    <span>Une erreur technique est survenue. Nous allons la corriger le plus rapidement possible. Veuillez\n        réessayer à nouveau dans quelques minutes.\n    </span>\n</div>\n"

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "<button *ngIf=\"isOnClickUsed\" [ngClass]=\"{'isLoading': isLoading}\"\n    (click)=\"onClickButton($event)\"\n    type=\"button\" [disabled]=\"isDisabled\">\n    <ng-template [ngTemplateOutlet]=\"content\"></ng-template>\n</button>\n<button *ngIf=\"!isOnClickUsed\" [ngClass]=\"{'isLoading': isLoading}\"\ntype=\"submit\" [disabled]=\"isDisabled\">\n    <ng-template [ngTemplateOutlet]=\"content\"></ng-template>\n</button>\n\n<ng-template #content>\n    <i *ngIf=\"icon\" class=\"fa {{isLoading ? 'fa-spinner fa-spin' : icon}} icon\" [attr.aria-hidden]=\"true\"></i>\n    <span class=\"label\"><ng-content></ng-content></span>\n</ng-template>\n<div class=\"overlay\" *ngIf=\"isLoading\"></div>\n"

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "<jhi-button\n    icon=\"fa-arrow-circle-right\"\n    [isLoading]=\"isLoading\"\n    [isDisabled]=\"isLoading || isDisabled\"\n    iconRight\n    (onClick)=\"onClickButton()\">\n    {{ label ? label : 'Suivant' }}\n    <ng-content></ng-content>\n</jhi-button>\n"

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "<jhi-button cancellation\n    icon=\"fa-arrow-circle-left\"\n    [isLoading]=\"isLoading\"\n    [isDisabled]=\"isLoading || isDisabled\"\n    (onClick)=\"onClickButton($event)\">\n    {{ label ? label : 'Précédent' }}\n    <ng-content></ng-content>\n</jhi-button>\n"

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports = "<jhi-button saving\n    icon=\"fas fa-cloud\"\n    [isLoading]=\"isLoading\"\n    [isDisabled]=\"isLoading || isDisabled\"\n    iconLeft\n    (onClick)=\"onClickButton($event)\">\n    Enregistrer le brouillon\n    <ng-content></ng-content>\n</jhi-button>\n"

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-check\">\n  <label class=\"form-check-label lb_clickable\">\n    <input class=\"form-check-input\" [disabled]=\"disabled\" type=\"checkbox\" [(ngModel)]=\"value\">\n    <div class=\"label-text\">\n      <ng-content></ng-content>\n    </div>\n  </label>\n</div>"

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group focus-outline\"\n     [ngClass]=\"{ 'invalid': isInvalid, 'valid': isValid, 'required': isRequired }\" [class.mb-0]=\"hintLabel\">\n    <label [htmlFor]=\"id\" [ngClass]=\" hasValue() ? 'has-value':'no-value'\">{{ label }}</label>\n    <div class=\"input-group\">\n        <input\n            class=\"form-control\"\n            [id]=\"id\"\n            [type]=\"type\"\n            [(ngModel)]=\"value\"\n            [placeholder]=\"placeholder\"\n            [autocomplete]=\"autocomplete\"\n            [hidden]=\"hidden\"\n            [attr.aria-describedby]=\"hintLabel ? id + 'hintLabel ' + ariaDescribedBy : ariaDescribedBy\"\n            [attr.aria-invalid]=\"ariaDescribedBy ? true : undefined\">\n        <button *ngIf=\"isPassword\" class=\"input-group-addon input-group-addon-btn\"\n                [attr.aria-label]=\"type !== 'password' ? 'cacher le mot de passe' : 'afficher le mot de passe'\"\n                (click)=\"toggle($event)\">\n            <em [ngClass]=\"(type !== 'password')? 'fa fa-eye-slash blue2':'fa fa-eye'\"></em>\n            <em *ngIf=\"isPassword && type !== 'password'\" class=\"sr-only\">Cacher le mot de passe</em>\n            <em *ngIf=\"isPassword && type === 'password'\" class=\"sr-only\">Afficher le mot de passe</em>\n        </button>\n    </div>\n</div>\n<small class=\"form-text text-muted mb-3\" [id]=\"id + 'hintLabel'\" *ngIf=\"hintLabel\">{{ hintLabel }}</small>\n"

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\" [ngClass]=\"{ 'invalid': isInvalid, 'valid': isValid, 'required': isRequired }\">\n    <ng-container *ngFor=\"let option of options\">\n        <label class=\"form-radio-label\">\n            <input  class=\"form-control\" type=\"radio\" [(ngModel)]=\"option.value\" [disabled]=\"option.disabled\">\n            <span>{{ option.label }}</span>\n        </label>\n    </ng-container>\n<div>"

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-group\" [ngClass]=\"{ 'invalid': isInvalid, 'valid': isValid, 'required': isRequired }\">\n    <label [htmlFor]=\"id\" [ngClass]=\"'has-value'\"> {{ label }} </label>\n    <select [id]=\"id\" class=\"form-control custom-select focus-outline\" [(ngModel)]=\"value\">\n      <option [value]=\"undefined\" hidden>{{ hiddenOptionLabel || 'Veuillez sélectionner une valeur' }}</option>\n      <option *ngFor=\"let option of options\" [value]=\"option.value\"> {{ option.label }} </option>\n    </select>\n</div>\n"

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "<button class=\"btn\" aria-label=\"S'identifier avec FranceConnect\" (click)=\"openFranceConnectPopup()\">\n    <span class=\"sr-only\">S'identifier avec FranceConnect</span>\n</button>\n<p class=\"quote\">Accéder à tous les services en vous connectant avec votre compte ameli.fr, impots.gouv.fr ou\n    ind.laposte.fr, etc.\n    <a href=\"https://app.franceconnect.gouv.fr/en-savoir-plus\" rel=\"noopener noreferrer\" target=\"_blank\"> <span>En savoir plus</span></a>\n</p>\n"

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "<jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n    <jhi-nom-entreprise name=\"nomEntreprise\" [(ngModel)]=\"identite.nomEntreprise\" required></jhi-nom-entreprise>\n    <jhi-messages [id]=\"'errorMessageNomEntreprise'\" *ngIf=\"isCreateAccountBtnClicked\">\n        <jhi-message error=\"required\" controlKey=\"nomEntreprise\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Forme et dénomination sociale'}\"></div>\n        </jhi-message>\n    </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-6 py-2\">\n    <jhi-input [id]=\"'sigleEntreprise'\"  name=\"sigleEntreprise\" [type]=\"'text'\" label=\"Sigle\" [autocomplete]=\"'address-level2'\"\n    [(ngModel)]=\"identite.sigleEntreprise\" maxlength=\"20\" [ariaDescribedBy]=\"'errorMessageSingleEntreprise'\">\n    </jhi-input>\n    <jhi-messages [id]=\"'errorMessageSingleEntreprise'\">\n        <jhi-message error=\"maxlength\" controlKey=\"sigleEntreprise\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 20}\"></div>\n        </jhi-message>\n    </jhi-messages>\n</jhi-field>\n"

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "<jhi-input [id]=\"'nomEntreprise'\" name=\"nomEntreprise\" [type]=\"'text'\" [autocomplete]=\"'organization'\" label=\"Forme et dénomination sociale\"\n  [(ngModel)]=\"nomEntreprise\" jhiCapitalize [required]=\"isRequired\" [ariaDescribedBy]=\"'errorMessageNomEntreprise'\">\n</jhi-input>\n<div *ngIf=\"showLengthWarningForCompanyName\" role=\"alert\" class=\"alert alert-warning\">\n  <div  class=\"col-md-12\" jhiTranslate=\"entity.warning.maxlength\"\n    translateValues=\"{actualLength: {{actualNameCompanyLength}}, max: {{maxCompanyNameLength}}}\">\n  </div>\n</div>\n"

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "\n<jhi-select [id]=\"'civilite'\" name=\"civilite\" label=\"{{ isForMoraleIdentity ? 'Civilité du représentant' : 'Civilité' }}\" hiddenOptionLabel=\"Choisir une civilité\"\n  [(ngModel)]=\"value\" [disabled]=\"disabled\" [required]=\"isRequired\">\n  <jhi-option [value]=\"civility\" *ngFor=\"let civility of civilities\">{{civility}}</jhi-option>\n</jhi-select>\n"

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "<jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n    <jhi-civilite name=\"civilite\" [(ngModel)]=\"identite.civilite\" [isForMoraleIdentity]=\"isRepresentant\" [disabled]=\"isFCUser\" required>\n    </jhi-civilite>\n    <jhi-messages role=\"alert\">\n        <jhi-message error=\"required\" controlKey=\"civilite\" *ngIf=\"isCreateAccountBtnClicked\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Civilité'}\"></div>\n        </jhi-message>\n    </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-6 py-2\" *ngIf=\"!isRepresentant\">\n  <jhi-input [id]=\"'birthDate'\" type=\"date\" name=\"birthDate\" [autocomplete]=\"'bday'\"\n      label=\"Date de naissance\" [(ngModel)]=\"identite.birthDate\"\n      [disabled]=\"isFCUser\" jhiBirthDate [ariaDescribedBy]=\"'errorMessageDate'\">\n  </jhi-input>\n  <jhi-messages [id]=\"'errorMessageDate'\">\n      <jhi-message [error]=\"'invalid-birth-date'\" controlKey=\"birthDate\">\n          <div>La date de naissance n'est pas valide.</div>\n          </jhi-message>\n          <jhi-message [error]=\"'birth-date-gt-currentday'\" controlKey=\"birthDate\">\n              <div>Votre date de naissance ne peut pas être dans le futur.</div>\n          </jhi-message>\n  </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-6 py-2\" *ngIf=\"isRepresentant\">\n  <jhi-input [id]=\"'fonctionEntreprise'\" name=\"fonctionEntreprise\" [type]=\"'text'\" [autocomplete]=\"'organization'\"\n      label=\"Fonction\" [(ngModel)]=\"identite.fonctionEntreprise\" jhiCapitalize>\n  </jhi-input>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-6 py-2 pr-lg-3\">\n  <jhi-input [id]=\"'firstName'\" name=\"firstName\" [type]=\"'text'\" [autocomplete]=\"'given-name'\"\n        label=\"{{ isRepresentant ? 'Prénom du représentant' : 'Prénom' }}\"\n        [(ngModel)]=\"identite.firstName\"\n        pattern=\".*\\S+.*\" [disabled]=\"isFCUser\" required jhiCapitalize jhiAlphaString maxlength=\"32\" [ariaDescribedBy]=\"'errorMessageFirstName'\">\n  </jhi-input>\n  <jhi-messages [id]=\"'errorMessageFirstName'\">\n      <jhi-message error=\"required\" controlKey=\"firstName\" *ngIf=\"isCreateAccountBtnClicked && !isRepresentant\">\n          <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Prénom' }\"></div>\n      </jhi-message>\n      <jhi-message error=\"required\" controlKey=\"firstName\" *ngIf=\"isCreateAccountBtnClicked && isRepresentant\">\n          <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Prénom du représentant' }\"></div>\n      </jhi-message>\n        <jhi-message error=\"maxlength\" controlKey=\"firstName\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 32}\"></div>\n        </jhi-message>\n  </jhi-messages>\n</jhi-field>\n\n<jhi-field class=\"col-12 col-lg-6 py-2\">\n  <jhi-input [id]=\"'lastName'\" name=\"lastName\" [type]=\"'text'\" [autocomplete]=\"'family-name'\"\n        label=\"{{ isRepresentant ? 'Nom du représentant' : 'Nom' }}\"\n        [(ngModel)]=\"identite.lastName\"\n        pattern=\".*\\S+.*\" [disabled]=\"isFCUser\" required jhiCapitalize jhiAlphaString maxlength=\"32\" [ariaDescribedBy]=\"'errorMessageLastName'\">\n  </jhi-input>\n  <jhi-messages [id]=\"'errorMessageLastName'\">\n        <jhi-message error=\"required\" controlKey=\"lastName\" *ngIf=\"isCreateAccountBtnClicked && !isRepresentant\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Nom' }\"></div>\n        </jhi-message>\n        <jhi-message error=\"required\" controlKey=\"lastName\" *ngIf=\"isCreateAccountBtnClicked && isRepresentant\">\n            <div jhiTranslate=\"entity.validation.required\" translateValues=\"{champ: 'Nom du représentant' }\"></div>\n        </jhi-message>\n        <jhi-message error=\"maxlength\" controlKey=\"lastName\">\n            <div jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{max: 32}\"></div>\n        </jhi-message>\n  </jhi-messages>\n</jhi-field>\n"

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "<div class=\"jumbotron-container\">\n    <div class=\"jumbotron-content\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"jumbotron-image\"></div>\n</div>\n"

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "<ng-container *ngFor=\"let piece of pieces;  let i = index\">\n    <div class=\"form-group\">\n        <label [class.has-value]=\"piece.libelle\" for=\"piece-postale-{{i}}\">Pièce postale n°{{i + 1}}</label>\n        <div class=\"input-group focus-outline\" tabindex=\"0\">\n            <input type=\"text\" class=\"form-control\" name=\"piece-postale-{{i}}\" id=\"piece-postale-{{i}}\" [(ngModel)]=\"piece.libelle\" (blur)=\"deletePieceWithEmptyLibelle(i)\">\n            <div class=\"input-group-append\" (click)=\"onPiecePostaleDelete()\">\n                <i class=\"fa fa-trash align-self-center\" aria-hidden=\"true\"></i>\n            </div>\n        </div>\n    </div>\n</ng-container>\n\n<div class=\"form-group\">\n    <div class=\"input-group piece-postale-adder focus-outline\" tabindex=\"0\" role=\"group\">\n        <input type=\"text\" class=\"form-control\" name=\"piece-postale-adder\" [(ngModel)]=\"adderValue\" (blur)=\"onPiecePostaleAdd()\"\n            placeholder=\"Nommer la pièce complémentaire transmise par voie postale\" aria-label=\"Nommer la pièce complémentaire transmise par voie postale\">\n        <div class=\"input-group-append\" (click)=\"onPiecePostaleAdd()\">\n            <i class=\"fa fa-plus align-self-center\" aria-hidden=\"true\"></i>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "<div class=\"loading-block\">\n    <p><ng-content></ng-content></p>\n    <span class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></span>\n</div>\n"

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "<div class=\"section-header\">\n    <div class=\"section-index\" *ngIf=\"state.index\">{{ state.index }}</div>\n    <ng-container [ngTemplateOutlet]=\"headerRef\">\n    </ng-container>\n    <span *ngIf=\"state.isToggleable == null || state.isToggleable\" class=\"fa fa-question-circle help-icon\" aria-hidden=\"true\" title=\"Pour plus d'informations\" (click)=\"toggle()\"></span>\n    <button *ngIf=\"state.isToggleable == null || state.isToggleable\" type=\"button\" class=\"sr-only\" (click)=\"toggle()\">Pour plus d'informations</button>\n</div>\n<div class=\"section-help\" [@fade]=\"state.isHelpOpen ? 'fadeIn' : 'fadeOut'\">\n    <ng-container [ngTemplateOutlet]=\"helpRef\">\n\n    </ng-container>\n</div>\n<div class=\"section-body\">\n    <ng-container [ngTemplateOutlet]=\"contentRef\"></ng-container>\n</div>\n"

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"adminConfig?.activated\" class=\"container-fuild\">\n    <div class=\"exclamation-icon item\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i></div>\n    <p class=\"info\">{{adminConfig.info}}</p>\n</div>"

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports = "<ng-container class=\"modal-container\">\n    <div aria-modal=\"true\"\n         role=\"dialog\"\n         aria-labelledby=\"dialog_user_club_label\"\n         jhiTrapFocus>\n        <div class=\"modal-header\">\n            <h2 id=\"dialog_user_club_label\">\n                S’inscrire au club utilisateur de <strong>Télérecours citoyens</strong>\n            </h2>\n            <button type=\"button\" class=\"modal-close\" aria-label=\"Fermer la fenêtre\"\n                    (click)=\"activeModal.dismiss('Cross click')\">\n                <span class=\"fa fa-times\" aria-hidden=\"true\" title=\"fermer la fenêtre\"></span>\n                <span class=\"sr-only\">Fermer la fenêtre</span>\n            </button>\n        </div>\n\n        <div class=\"modal-body\">\n\n            <div *ngIf=\"!isSuccessMessageActive\">\n                <h3>En quoi consiste notre club utilisateur ?</h3>\n                <p> Notre club utilisateur a pour but de\n                    <strong>réunir des personnes aux profils variés</strong>\n                    qui nous font part de leur\n                    <strong>expérience</strong>\n                    sur notre service en ligne. L’objectif est d’améliorer Télérecours citoyens, grâce à une\n                    <strong>collaboration étroite avec l’utilisateur.</strong>\n                    Vous serez alors libre de nous partager\n                    <strong> votre avis, vos besoins et vos recommandations.</strong>\n                </p>\n                <p class=\"mb-0\">L’utilisateur peut être sollicité de plusieurs façons, en participant à :</p>\n                <ul>\n                    <li>des découvertes et manipulations des nouvelles interfaces ;</li>\n                    <li>des entretiens utilisateur ;</li>\n                    <li>des ateliers de reflexion.</li>\n                </ul>\n\n                <h3>Conditions d’inscription au club utilisateur</h3>\n                <p>\n                    En vous inscrivant, vous donnez votre accord pour être contacté(e) dans le cadre de l’amélioration du\n                    téléservice\n                    <strong>Télérecours citoyens. Faire partie du club utilisateur n‘aura aucun impact sur votre dossier. Vous\n                        serez libre à tout moment de quitter le club</strong>\n                    , sans raison précise.\n                </p>\n\n                <div class=\"form-check\">\n                    <input\n                        class=\"form-check-input\"\n                        type=\"checkbox\"\n                        value=\"juc-terms-accepted\"\n                        name=\"juc-terms-accepted\"\n                        id=\"juc-terms-accepted\"\n                        aria-describedby=\"errorMessage\"\n                        [(ngModel)]=\"isTermsChecked\"/>\n                    <label class=\"form-check-label\" for=\"juc-terms-accepted\">\n                        J’ai lu et j’accepte les\n                        <a href=\"/#/mentions-legales\" target=\"_blank\"\n                           title=\"Ouvrir les mentions légales de Télérecours citoyens dans un nouvel onglet\">\n                            mentions légales\n                        </a>\n                        , ainsi que les\n                        <a href=\"/#/donnees-personelles\" target=\"_blank\"\n                           title=\"Ouvrir les conditions d'utilisation de données personnelles de Télérecours citoyens dans un nouvel onglet\">\n                            conditions d’utilisation des données personnelles.\n                        </a>\n                    </label>\n                </div>\n                \n                <div  id=\"errorMessage\">\n                    <div *ngIf=\"!isTermsChecked && isSubmitted\" class=\"alert alert-danger alert-secondary\">\n                        Vous devez accepter les mentions légales et les conditions d'utilisation des données personnelles avant de pouvoir vous inscrire.\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"explication\" *ngIf=\"isSuccessMessageActive\">\n                <p>\n                    <em class=\"fa fa-info-circle\" data-close-modal></em>\n                    <strong>Votre demande a bien été prise en compte.</strong>\n                </p>\n                <p>\n                    Vous allez recevoir prochainement un courriel de confirmation.\n                    Si vous n’avez pas reçu de courriel, vérifiez vos courriers indésirables ou contactez-nous à l’adresse\n                    telerecours-citoyens-club@conseil-etat.fr.\n                </p>\n            </div>\n\n            <div class=\"alert alert-danger mt-3\" *ngIf=\"isErrorMessageActive\">\n                <p>\n                    <strong>Une erreur technique est survenue. </strong>\n                    Merci de réesayer dans quelques heures. Si le problème persiste, n'hésitez pas à <a\n                    href=\"https://support-telerecours.fr/\">contacter le support technique.</a>\n                </p>\n            </div>\n\n            <jhi-progress-spinner *ngIf=\"isLoadingMessageActive\">Chargement en cours</jhi-progress-spinner>\n\n        </div>\n\n        \n\n        <div class=\"modal-footer\" *ngIf=\"!isSuccessMessageActive\">\n            <jhi-button cancellation (click)=\"activeModal.dismiss('Cross click')\">Annuler</jhi-button>\n            <jhi-button confirmation (onClick)=\"onJoinUserClub()\">Je m'inscris</jhi-button>\n        </div>\n    </div>\n</ng-container>\n"

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid\">\n    <div class=\"offset-lg-1 col-lg-10 offset-xl-2 col-xl-8 col-md-12 block\">\n        <p>Vous souhaitez quitter le club utilisateur de Télérecours citoyen ?</p>\n\n        <p *ngIf=\"!isUserAlreadyJoined\">\n            En validant votre désinscription ci-dessous, vous ne ferez plus partie de notre club utilisateur et\n            vous ne recevrez plus de sollicitations de notre part\n        </p>\n\n        <p>Votre adresse de messagerie: <strong>{{email}}</strong></p>\n\n        <div *ngIf=\"joinedUserClub\" class=\"row col-12 center-btn\">\n            <jhi-button (onClick)=\"unsubscribeUser()\" confirmation>\n                Je me désinscris du club\n            </jhi-button>\n        </div>\n\n        <div *ngIf=\"isUserAlreadyJoined\">\n            <div role=\"alert\" class=\"alert alert-warning alert-secondary\">\n                Vous êtes déjà désinscrit(e) du club utilisateur de Télérecours citoyens.\n                Vous ne faites plus partie de notre club utilisateur et vous ne recevrez plus de sollicitations de\n                notre part.\n            </div>\n            <ng-container>S'il s'agit d'une erreur et/ou vous souhaitez de nouveau rejoindre le club,\n                vous pouvez toujours :\n            <ul>\n                <li>accéder depuis <a href=\"/#/accueil\">la page d'accueil</a> à la bannière du club utilisateur et vous réinscrire </li>\n                ou\n                <li>nous envoyer un courriel à l'adresse suivante :\n                    <a href=\"mailto:telerecours-citoyens-club@conseil-etat.fr\">telerecours-citoyens-club@conseil-etat.fr\n                    </a>\n                </li>\n            </ul>\n            </ng-container>\n        </div>\n\n        <div *ngIf=\"isSuccessMessage\" role=\"alert\" class=\"alert alert-success\" >\n            Votre demande de désinscription a été prise en compte, vous allez recevoir un mail de confirmation.\n        </div>\n\n        <div *ngIf=\"isErrorMessage\" role=\"alert\" class=\"alert alert-danger\">\n            Une erreur technique s'est produite, veuillez recommencer ultérieurement.\n        </div>\n\n    </div>\n</div>\n"

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "<section class=\"row py-4 bg-primary-blue text-light\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-10 col-md-7 mx-auto mt-lg-1\">\n                <div class=\"row pl-lg-6\">\n                    <div class=\"col-2 col-lg-1 px-0 mt-2 mt-xl-0 mr-0 mr-lg-2 mr-xl-0\">\n                        <div class=\" ml-sm-3 ml-md-0 h-100 text-center\">\n                            <em class=\"fa fa-users\" aria-hidden=\"true\"></em>\n                        </div>\n\n                    </div>\n                    <p class=\"col mb-0 px-0 p-join-user-club\">Envie de participer à l'amélioration de ce téléservice ?</p>\n                </div>\n            </div>\n            <div class=\"col-10 col-md-5 mx-auto mt-3 mt-md-0\">\n                <button class=\"btn btn-outline-light btn--join-user-club font-weight-bold\"\n                        (click)=\"openJucModal()\"\n                        tabindex=\"0\">\n                    Rejoignez notre club d'utilisateur\n                </button>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48), __webpack_require__(83)))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var si = typeof setImmediate === 'function', tick;
if (si) {
  tick = function (fn) { setImmediate(fn); };
} else {
  tick = function (fn) { setTimeout(fn, 0); };
}

module.exports = tick;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(864).setImmediate))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(862);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(655);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(656);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(657);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(658);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(659);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(660);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(661);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(662);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(663);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(664);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(665);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(666);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(667);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(668);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(669);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(670);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(671);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(672);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(673);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(674);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(675);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(676);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(677);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(678);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(679);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(680);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(681);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(682);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(683);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(684);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(685);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(686);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(687);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(688);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(689);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(690);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(691);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(692);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(693);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(694);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(695);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(696);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(697);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(698);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(699);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(700);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(701);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(702);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(703);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(704);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(705);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(706);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(707);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(708);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(709);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(710);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(711);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(712);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(713);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(714);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(715);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(716);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(717);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(718);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(719);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(720);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(721);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(722);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(723);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(724);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(725);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(726);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(727);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(728);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(729);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(730);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(731);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(732);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(733);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(734);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(735);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(736);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(737);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(738);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(739);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(740);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(741);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(742);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(743);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(744);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(745);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(746);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(747);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(748);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(749);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(750);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(751);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(752);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(753);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 964 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(203);

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(205);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(263);

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(9))(32);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_dynamic_1 = __webpack_require__(399);
var prod_config_1 = __webpack_require__(381);
var app_module_1 = __webpack_require__(380);
prod_config_1.ProdConfig();
if (false) {
    module['hot'].accept();
}
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.TelerecourspnrAppModule);


/***/ })
],[971]);


// WEBPACK FOOTER //
// 6251aa38d8007c9d804d.main.bundle.js